import styled$3, { css as css$1 } from "styled-components";
import { ThemeProvider as wt } from "styled-components";
import * as React from "react";
import React__default, { useState, useRef, useEffect, useLayoutEffect, createContext, forwardRef, useContext, createElement, Fragment as Fragment$1, Children, isValidElement, cloneElement } from "react";
import { createPortal } from "react-dom";
import { useWeb3React, Web3ReactProvider } from "@web3-react/core";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getAugmentedNamespace(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var i = function n() {
      if (this instanceof n) {
        var a = [null];
        a.push.apply(a, arguments);
        var o = Function.bind.apply(t, a);
        return new o();
      }
      return t.apply(this, arguments);
    };
    i.prototype = t.prototype;
  } else
    i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(i, n, a.get ? a : { enumerable: !0, get: function() {
      return e[n];
    } });
  }), i;
}
var jsxRuntimeExports = {}, jsxRuntime = { get exports() {
  return jsxRuntimeExports;
}, set exports(e) {
  jsxRuntimeExports = e;
} }, reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var d = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        u[m] = m;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = a() ? Object.assign : function(o, l) {
    for (var c, d = n(o), u, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var A in c)
        t.call(c, A) && (d[A] = c[A]);
      if (e) {
        u = e(c);
        for (var y = 0; y < u.length; y++)
          i.call(c, u[y]) && (d[u[y]] = c[u[y]]);
      }
    }
    return d;
  }, objectAssign;
}
/** @license React v17.0.2
* react-jsx-runtime.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1, requireObjectAssign();
  var e = React__default, t = 60103;
  if (reactJsxRuntime_production_min.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var i = Symbol.for;
    t = i("react.element"), reactJsxRuntime_production_min.Fragment = i("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, d, u) {
    var m, A = {}, y = null, D = null;
    u !== void 0 && (y = "" + u), d.key !== void 0 && (y = "" + d.key), d.ref !== void 0 && (D = d.ref);
    for (m in d)
      a.call(d, m) && !o.hasOwnProperty(m) && (A[m] = d[m]);
    if (c && c.defaultProps)
      for (m in d = c.defaultProps, d)
        A[m] === void 0 && (A[m] = d[m]);
    return { $$typeof: t, type: c, key: y, ref: D, props: A, _owner: n.current };
  }
  return reactJsxRuntime_production_min.jsx = l, reactJsxRuntime_production_min.jsxs = l, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/** @license React v17.0.2
* react-jsx-runtime.development.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = React__default, i = requireObjectAssign(), n = 60103, a = 60106;
      e.Fragment = 60107;
      var o = 60108, l = 60114, c = 60109, d = 60110, u = 60112, m = 60113, A = 60120, y = 60115, D = 60116, C = 60121, z = 60122, R = 60117, O = 60129, $ = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var k = Symbol.for;
        n = k("react.element"), a = k("react.portal"), e.Fragment = k("react.fragment"), o = k("react.strict_mode"), l = k("react.profiler"), c = k("react.provider"), d = k("react.context"), u = k("react.forward_ref"), m = k("react.suspense"), A = k("react.suspense_list"), y = k("react.memo"), D = k("react.lazy"), C = k("react.block"), z = k("react.server.block"), R = k("react.fundamental"), k("react.scope"), k("react.opaque.id"), O = k("react.debug_trace_mode"), k("react.offscreen"), $ = k("react.legacy_hidden");
      }
      var P = typeof Symbol == "function" && Symbol.iterator, L = "@@iterator";
      function F(q) {
        if (q === null || typeof q != "object")
          return null;
        var ce = P && q[P] || q[L];
        return typeof ce == "function" ? ce : null;
      }
      var B = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function G(q) {
        {
          for (var ce = arguments.length, de = new Array(ce > 1 ? ce - 1 : 0), me = 1; me < ce; me++)
            de[me - 1] = arguments[me];
          Z("error", q, de);
        }
      }
      function Z(q, ce, de) {
        {
          var me = B.ReactDebugCurrentFrame, De = me.getStackAddendum();
          De !== "" && (ce += "%s", de = de.concat([De]));
          var Ie = de.map(function(ye) {
            return "" + ye;
          });
          Ie.unshift("Warning: " + ce), Function.prototype.apply.call(console[q], console, Ie);
        }
      }
      var X = !1;
      function V(q) {
        return !!(typeof q == "string" || typeof q == "function" || q === e.Fragment || q === l || q === O || q === o || q === m || q === A || q === $ || X || typeof q == "object" && q !== null && (q.$$typeof === D || q.$$typeof === y || q.$$typeof === c || q.$$typeof === d || q.$$typeof === u || q.$$typeof === R || q.$$typeof === C || q[0] === z));
      }
      function E(q, ce, de) {
        var me = ce.displayName || ce.name || "";
        return q.displayName || (me !== "" ? de + "(" + me + ")" : de);
      }
      function T(q) {
        return q.displayName || "Context";
      }
      function g(q) {
        if (q == null)
          return null;
        if (typeof q.tag == "number" && G("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof q == "function")
          return q.displayName || q.name || null;
        if (typeof q == "string")
          return q;
        switch (q) {
          case e.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case l:
            return "Profiler";
          case o:
            return "StrictMode";
          case m:
            return "Suspense";
          case A:
            return "SuspenseList";
        }
        if (typeof q == "object")
          switch (q.$$typeof) {
            case d:
              var ce = q;
              return T(ce) + ".Consumer";
            case c:
              var de = q;
              return T(de._context) + ".Provider";
            case u:
              return E(q, q.render, "ForwardRef");
            case y:
              return g(q.type);
            case C:
              return g(q._render);
            case D: {
              var me = q, De = me._payload, Ie = me._init;
              try {
                return g(Ie(De));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var b = 0, x, S, I, N, p, M, j;
      function U() {
      }
      U.__reactDisabledLog = !0;
      function H() {
        {
          if (b === 0) {
            x = console.log, S = console.info, I = console.warn, N = console.error, p = console.group, M = console.groupCollapsed, j = console.groupEnd;
            var q = { configurable: !0, enumerable: !0, value: U, writable: !0 };
            Object.defineProperties(console, { info: q, log: q, warn: q, error: q, group: q, groupCollapsed: q, groupEnd: q });
          }
          b++;
        }
      }
      function J() {
        {
          if (b--, b === 0) {
            var q = { configurable: !0, enumerable: !0, writable: !0 };
            Object.defineProperties(console, { log: i({}, q, { value: x }), info: i({}, q, { value: S }), warn: i({}, q, { value: I }), error: i({}, q, { value: N }), group: i({}, q, { value: p }), groupCollapsed: i({}, q, { value: M }), groupEnd: i({}, q, { value: j }) });
          }
          b < 0 && G("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var te = B.ReactCurrentDispatcher, ae;
      function le(q, ce, de) {
        {
          if (ae === void 0)
            try {
              throw Error();
            } catch (De) {
              var me = De.stack.trim().match(/\n( *(at )?)/);
              ae = me && me[1] || "";
            }
          return `
` + ae + q;
        }
      }
      var ne = !1, ue;
      {
        var ge = typeof WeakMap == "function" ? WeakMap : Map;
        ue = new ge();
      }
      function re(q, ce) {
        if (!q || ne)
          return "";
        {
          var de = ue.get(q);
          if (de !== void 0)
            return de;
        }
        var me;
        ne = !0;
        var De = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Ie;
        Ie = te.current, te.current = null, H();
        try {
          if (ce) {
            var ye = function() {
              throw Error();
            };
            if (Object.defineProperty(ye.prototype, "props", { set: function() {
              throw Error();
            } }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(ye, []);
              } catch (et) {
                me = et;
              }
              Reflect.construct(q, [], ye);
            } else {
              try {
                ye.call();
              } catch (et) {
                me = et;
              }
              q.call(ye.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (et) {
              me = et;
            }
            q();
          }
        } catch (et) {
          if (et && me && typeof et.stack == "string") {
            for (var Ae = et.stack.split(`
`), Fe = me.stack.split(`
`), be = Ae.length - 1, ke = Fe.length - 1; be >= 1 && ke >= 0 && Ae[be] !== Fe[ke]; )
              ke--;
            for (; be >= 1 && ke >= 0; be--, ke--)
              if (Ae[be] !== Fe[ke]) {
                if (be !== 1 || ke !== 1)
                  do
                    if (be--, ke--, ke < 0 || Ae[be] !== Fe[ke]) {
                      var ze = `
` + Ae[be].replace(" at new ", " at ");
                      return typeof q == "function" && ue.set(q, ze), ze;
                    }
                  while (be >= 1 && ke >= 0);
                break;
              }
          }
        } finally {
          ne = !1, te.current = Ie, J(), Error.prepareStackTrace = De;
        }
        var Ge = q ? q.displayName || q.name : "", tt = Ge ? le(Ge) : "";
        return typeof q == "function" && ue.set(q, tt), tt;
      }
      function fe(q, ce, de) {
        return re(q, !1);
      }
      function oe(q) {
        var ce = q.prototype;
        return !!(ce && ce.isReactComponent);
      }
      function ve(q, ce, de) {
        if (q == null)
          return "";
        if (typeof q == "function")
          return re(q, oe(q));
        if (typeof q == "string")
          return le(q);
        switch (q) {
          case m:
            return le("Suspense");
          case A:
            return le("SuspenseList");
        }
        if (typeof q == "object")
          switch (q.$$typeof) {
            case u:
              return fe(q.render);
            case y:
              return ve(q.type, ce, de);
            case C:
              return fe(q._render);
            case D: {
              var me = q, De = me._payload, Ie = me._init;
              try {
                return ve(Ie(De), ce, de);
              } catch {
              }
            }
          }
        return "";
      }
      var Le = {}, Be = B.ReactDebugCurrentFrame;
      function we(q) {
        if (q) {
          var ce = q._owner, de = ve(q.type, q._source, ce ? ce.type : null);
          Be.setExtraStackFrame(de);
        } else
          Be.setExtraStackFrame(null);
      }
      function Ue(q, ce, de, me, De) {
        {
          var Ie = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var ye in q)
            if (Ie(q, ye)) {
              var Ae = void 0;
              try {
                if (typeof q[ye] != "function") {
                  var Fe = Error((me || "React class") + ": " + de + " type `" + ye + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof q[ye] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Fe.name = "Invariant Violation", Fe;
                }
                Ae = q[ye](ce, ye, me, de, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (be) {
                Ae = be;
              }
              Ae && !(Ae instanceof Error) && (we(De), G("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", me || "React class", de, ye, typeof Ae), we(null)), Ae instanceof Error && !(Ae.message in Le) && (Le[Ae.message] = !0, we(De), G("Failed %s type: %s", de, Ae.message), we(null));
            }
        }
      }
      var Oe = B.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ne = { key: !0, ref: !0, __self: !0, __source: !0 }, Ee, Se, Re;
      Re = {};
      function W(q) {
        if (Te.call(q, "ref")) {
          var ce = Object.getOwnPropertyDescriptor(q, "ref").get;
          if (ce && ce.isReactWarning)
            return !1;
        }
        return q.ref !== void 0;
      }
      function Y(q) {
        if (Te.call(q, "key")) {
          var ce = Object.getOwnPropertyDescriptor(q, "key").get;
          if (ce && ce.isReactWarning)
            return !1;
        }
        return q.key !== void 0;
      }
      function Q(q, ce) {
        if (typeof q.ref == "string" && Oe.current && ce && Oe.current.stateNode !== ce) {
          var de = g(Oe.current.type);
          Re[de] || (G('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', g(Oe.current.type), q.ref), Re[de] = !0);
        }
      }
      function ee(q, ce) {
        {
          var de = function() {
            Ee || (Ee = !0, G("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ce));
          };
          de.isReactWarning = !0, Object.defineProperty(q, "key", { get: de, configurable: !0 });
        }
      }
      function ie(q, ce) {
        {
          var de = function() {
            Se || (Se = !0, G("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ce));
          };
          de.isReactWarning = !0, Object.defineProperty(q, "ref", { get: de, configurable: !0 });
        }
      }
      var se = function(q, ce, de, me, De, Ie, ye) {
        var Ae = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: q,
          key: ce,
          ref: de,
          props: ye,
          // Record the component responsible for creating this element.
          _owner: Ie
        };
        return Ae._store = {}, Object.defineProperty(Ae._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(Ae, "_self", { configurable: !1, enumerable: !1, writable: !1, value: me }), Object.defineProperty(Ae, "_source", { configurable: !1, enumerable: !1, writable: !1, value: De }), Object.freeze && (Object.freeze(Ae.props), Object.freeze(Ae)), Ae;
      };
      function pe(q, ce, de, me, De) {
        {
          var Ie, ye = {}, Ae = null, Fe = null;
          de !== void 0 && (Ae = "" + de), Y(ce) && (Ae = "" + ce.key), W(ce) && (Fe = ce.ref, Q(ce, De));
          for (Ie in ce)
            Te.call(ce, Ie) && !Ne.hasOwnProperty(Ie) && (ye[Ie] = ce[Ie]);
          if (q && q.defaultProps) {
            var be = q.defaultProps;
            for (Ie in be)
              ye[Ie] === void 0 && (ye[Ie] = be[Ie]);
          }
          if (Ae || Fe) {
            var ke = typeof q == "function" ? q.displayName || q.name || "Unknown" : q;
            Ae && ee(ye, ke), Fe && ie(ye, ke);
          }
          return se(q, Ae, Fe, De, me, Oe.current, ye);
        }
      }
      var he = B.ReactCurrentOwner, Me = B.ReactDebugCurrentFrame;
      function _e(q) {
        if (q) {
          var ce = q._owner, de = ve(q.type, q._source, ce ? ce.type : null);
          Me.setExtraStackFrame(de);
        } else
          Me.setExtraStackFrame(null);
      }
      var xe;
      xe = !1;
      function Ye(q) {
        return typeof q == "object" && q !== null && q.$$typeof === n;
      }
      function Ve() {
        {
          if (he.current) {
            var q = g(he.current.type);
            if (q)
              return `

Check the render method of \`` + q + "`.";
          }
          return "";
        }
      }
      function Ce(q) {
        {
          if (q !== void 0) {
            var ce = q.fileName.replace(/^.*[\\\/]/, ""), de = q.lineNumber;
            return `

Check your code at ` + ce + ":" + de + ".";
          }
          return "";
        }
      }
      var Qe = {};
      function qe(q) {
        {
          var ce = Ve();
          if (!ce) {
            var de = typeof q == "string" ? q : q.displayName || q.name;
            de && (ce = `

Check the top-level render call using <` + de + ">.");
          }
          return ce;
        }
      }
      function Pe(q, ce) {
        {
          if (!q._store || q._store.validated || q.key != null)
            return;
          q._store.validated = !0;
          var de = qe(ce);
          if (Qe[de])
            return;
          Qe[de] = !0;
          var me = "";
          q && q._owner && q._owner !== he.current && (me = " It was passed a child from " + g(q._owner.type) + "."), _e(q), G('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', de, me), _e(null);
        }
      }
      function He(q, ce) {
        {
          if (typeof q != "object")
            return;
          if (Array.isArray(q))
            for (var de = 0; de < q.length; de++) {
              var me = q[de];
              Ye(me) && Pe(me, ce);
            }
          else if (Ye(q))
            q._store && (q._store.validated = !0);
          else if (q) {
            var De = F(q);
            if (typeof De == "function" && De !== q.entries)
              for (var Ie = De.call(q), ye; !(ye = Ie.next()).done; )
                Ye(ye.value) && Pe(ye.value, ce);
          }
        }
      }
      function Ze(q) {
        {
          var ce = q.type;
          if (ce == null || typeof ce == "string")
            return;
          var de;
          if (typeof ce == "function")
            de = ce.propTypes;
          else if (typeof ce == "object" && (ce.$$typeof === u || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          ce.$$typeof === y))
            de = ce.propTypes;
          else
            return;
          if (de) {
            var me = g(ce);
            Ue(de, q.props, "prop", me, q);
          } else if (ce.PropTypes !== void 0 && !xe) {
            xe = !0;
            var De = g(ce);
            G("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", De || "Unknown");
          }
          typeof ce.getDefaultProps == "function" && !ce.getDefaultProps.isReactClassApproved && G("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function je(q) {
        {
          for (var ce = Object.keys(q.props), de = 0; de < ce.length; de++) {
            var me = ce[de];
            if (me !== "children" && me !== "key") {
              _e(q), G("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", me), _e(null);
              break;
            }
          }
          q.ref !== null && (_e(q), G("Invalid attribute `ref` supplied to `React.Fragment`."), _e(null));
        }
      }
      function We(q, ce, de, me, De, Ie) {
        {
          var ye = V(q);
          if (!ye) {
            var Ae = "";
            (q === void 0 || typeof q == "object" && q !== null && Object.keys(q).length === 0) && (Ae += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Fe = Ce(De);
            Fe ? Ae += Fe : Ae += Ve();
            var be;
            q === null ? be = "null" : Array.isArray(q) ? be = "array" : q !== void 0 && q.$$typeof === n ? (be = "<" + (g(q.type) || "Unknown") + " />", Ae = " Did you accidentally export a JSX literal instead of a component?") : be = typeof q, G("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", be, Ae);
          }
          var ke = pe(q, ce, de, De, Ie);
          if (ke == null)
            return ke;
          if (ye) {
            var ze = ce.children;
            if (ze !== void 0)
              if (me)
                if (Array.isArray(ze)) {
                  for (var Ge = 0; Ge < ze.length; Ge++)
                    He(ze[Ge], q);
                  Object.freeze && Object.freeze(ze);
                } else
                  G("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                He(ze, q);
          }
          return q === e.Fragment ? je(ke) : Ze(ke), ke;
        }
      }
      function Je(q, ce, de) {
        return We(q, ce, de, !0);
      }
      function $e(q, ce, de) {
        return We(q, ce, de, !1);
      }
      var Xe = $e, Ke = Je;
      e.jsx = Xe, e.jsxs = Ke;
    }();
  }(reactJsxRuntime_development)), reactJsxRuntime_development;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = requireReactJsxRuntime_production_min() : e.exports = requireReactJsxRuntime_development();
})(jsxRuntime);
const Fragment = jsxRuntimeExports.Fragment, jsx = jsxRuntimeExports.jsx, jsxs = jsxRuntimeExports.jsxs, Ethereum = "data:image/svg+xml;base64,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", ThunderCore = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMTc4MDEgOS4zOTI5NUM0LjEzNTY3IDkuNDYwMDkgNC4xMTIxMSA5LjUzNzM4IDQuMTA5OCA5LjYxNjc1QzQuMTA3NDggOS42OTYxMiA0LjEyNjQ5IDkuNzc0NjYgNC4xNjQ4MyA5Ljg0NDE2QzQuMjAzMTggOS45MTM2NyA0LjI1OTQ2IDkuOTcxNTkgNC4zMjc4IDEwLjAxMTlDNC4zOTYxMyAxMC4wNTIyIDQuNDc0MDEgMTAuMDczMyA0LjU1MzMxIDEwLjA3MzJIOS42MTYxMkM5LjY1NDAyIDEwLjA3MyA5LjY5MTI3IDEwLjA4MjkgOS43MjM5OSAxMC4xMDIxQzkuNzU2NzEgMTAuMTIxMiA5Ljc4MzY5IDEwLjE0ODggOS44MDIxIDEwLjE4MkM5LjgyMDUyIDEwLjIxNTIgOS44Mjk2OSAxMC4yNTI3IDkuODI4NjYgMTAuMjkwNkM5LjgyNzY0IDEwLjMyODYgOS44MTY0NSAxMC4zNjU1IDkuNzk2MjYgMTAuMzk3Nkw0LjgyNzI4IDE4LjM1ODdDNC44MTQ3OCAxOC4zNzkxIDQuNzk4MzIgMTguMzk2OCA0Ljc3ODg3IDE4LjQxMDdDNC43NTk0MyAxOC40MjQ2IDQuNzM3MzkgMTguNDM0NSA0LjcxNDA3IDE4LjQzOThDNC42OTA3NCAxOC40NDUgNC42NjY2IDE4LjQ0NTUgNC42NDMwNyAxOC40NDEzQzQuNjE5NTQgMTguNDM3MSA0LjU5NzEgMTguNDI4MSA0LjU3NzA4IDE4LjQxNTFDMi43ODY3MyAxNy4yNTg1IDEuNDEyMjYgMTUuNTU5NCAwLjY1NDE2NCAxMy41NjU1Qy0wLjEwMzkyOCAxMS41NzE3IC0wLjIwNTk3MyA5LjM4NzQ1IDAuMzYyOTE1IDcuMzMxNDRDMC45MzE4MDMgNS4yNzU0MiAyLjE0MTg2IDMuNDU1MjIgMy44MTY1NiAyLjEzNjM2QzUuNDkxMjYgMC44MTc1MDYgNy41NDI5OCAwLjA2ODk5OTQgOS42NzI0MiAzLjUxMzY2ZS0wNUM5LjcwNDA3IC0wLjAwMDU5OTQ1NiA5LjczNTMxIDAuMDA3MzcyMjkgOS43NjI4MSAwLjAyMzEwMjNDOS43OTAzIDAuMDM4ODMyMyA5LjgxMzAyIDAuMDYxNzMyMSA5LjgyODU1IDAuMDg5MzY0OEM5Ljg0NDA4IDAuMTE2OTk3IDkuODUxODQgMC4xNDgzMjkgOS44NTEgMC4xODAwMjZDOS44NTAxNiAwLjIxMTcyMyA5Ljg0MDc2IDAuMjQyNiA5LjgyMzc5IDAuMjY5MzdMNC4xNzgwMSA5LjM5Mjk1Wk0xNS41OTU5IDEuNzFDMTUuNTc2MiAxLjY5NjI5IDE1LjU1MzkgMS42ODY3NyAxNS41MzA0IDEuNjgyMDVDMTUuNTA2OCAxLjY3NzMzIDE1LjQ4MjYgMS42Nzc0OSAxNS40NTkxIDEuNjgyNTVDMTUuNDM1NyAxLjY4NzYgMTUuNDEzNSAxLjY5NzQyIDE1LjM5NCAxLjcxMTQxQzE1LjM3NDUgMS43MjU0IDE1LjM1ODEgMS43NDMyNiAxNS4zNDU3IDEuNzYzODdMMTAuNDUzIDkuNjA4NDFDMTAuNDMzIDkuNjQwNTQgMTAuNDIxOSA5LjY3NzQ0IDEwLjQyMDkgOS43MTUzQzEwLjQxOTggOS43NTMxNiAxMC40Mjg5IDkuNzkwNjEgMTAuNDQ3MSA5LjgyMzhDMTAuNDY1MyA5Ljg1Njk4IDEwLjQ5MjEgOS44ODQ3IDEwLjUyNDYgOS45MDQwOUMxMC41NTcxIDkuOTIzNDggMTAuNTk0MSA5LjkzMzg1IDEwLjYzMTkgOS45MzQxMkgxNS42OTk4QzE1Ljc3ODkgOS45MzQxMSAxNS44NTY1IDkuOTU1MzIgMTUuOTI0NyA5Ljk5NTU0QzE1Ljk5MjggMTAuMDM1OCAxNi4wNDkgMTAuMDkzNSAxNi4wODczIDEwLjE2MjhDMTYuMTI1NiAxMC4yMzIxIDE2LjE0NDYgMTAuMzEwNCAxNi4xNDI1IDEwLjM4OTZDMTYuMTQwNCAxMC40Njg4IDE2LjExNzEgMTAuNTQ2IDE2LjA3NTEgMTAuNjEzMUwxMC4zNDY3IDE5Ljc4NTVDMTAuMzMyOCAxOS44MDcxIDEwLjMyNTEgMTkuODMyMiAxMC4zMjQ1IDE5Ljg1NzlDMTAuMzI0IDE5Ljg4MzYgMTAuMzMwNSAxOS45MDg5IDEwLjM0MzUgMTkuOTMxMUMxMC4zNTY1IDE5Ljk1MzMgMTAuMzc1MyAxOS45NzE1IDEwLjM5OCAxOS45ODM2QzEwLjQyMDYgMTkuOTk1NyAxMC40NDYyIDIwLjAwMTMgMTAuNDcxOCAxOS45OTk3QzEyLjU2OTQgMTkuOTAxNyAxNC41ODI5IDE5LjE0NDUgMTYuMjI2NCAxNy44MzU3QzE3Ljg3IDE2LjUyNjkgMTkuMDYwMSAxNC43MzI5IDE5LjYyNzggMTIuNzA4NEMyMC4xOTU1IDEwLjY4NCAyMC4xMTIgOC41MzE4NyAxOS4zODkyIDYuNTU3NkMxOC42NjY0IDQuNTgzMzQgMTcuMzQwOSAyLjg4NzIyIDE1LjYwMDkgMS43MUgxNS41OTU5WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzE0MjNfNDEyKSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzE0MjNfNDEyIiB4MT0iOC42MzI4MyIgeTE9IjQuMTI3NzUiIHgyPSIxMi4xNTM2IiB5Mj0iMTkuMjMzNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBvZmZzZXQ9IjAuMTgiIHN0b3AtY29sb3I9IiMwMEZGRDUiLz4KPHN0b3Agb2Zmc2V0PSIwLjIzIiBzdG9wLWNvbG9yPSIjMDBGOEQ1Ii8+CjxzdG9wIG9mZnNldD0iMC4zMSIgc3RvcC1jb2xvcj0iIzAwRTRENSIvPgo8c3RvcCBvZmZzZXQ9IjAuNCIgc3RvcC1jb2xvcj0iIzAwQzNENSIvPgo8c3RvcCBvZmZzZXQ9IjAuNTEiIHN0b3AtY29sb3I9IiMwMDk2RDUiLz4KPHN0b3Agb2Zmc2V0PSIwLjYyIiBzdG9wLWNvbG9yPSIjMDA1Q0Q1Ii8+CjxzdG9wIG9mZnNldD0iMC43NCIgc3RvcC1jb2xvcj0iIzAwMTZENSIvPgo8c3RvcCBvZmZzZXQ9IjAuNzgiIHN0b3AtY29sb3I9IiMwMDAwRDUiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K", Binance = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMTE3ODcgMTAuNDAzNkwxMi4wMDIyIDYuNTIwODlMMTUuODg4MSAxMC40MDY4TDE4LjE0NjkgOC4xNDYzM0wxMi4wMDIyIDJMNS44NTc0MiA4LjE0NDc1TDguMTE3ODcgMTAuNDAzNloiIGZpbGw9IiNGM0JBMkYiLz4KPHBhdGggZD0iTTIgMTIuMDAwNkw0LjI1ODg3IDkuNzQwMTFMNi41MTkzMSAxMi4wMDA2TDQuMjU4ODcgMTQuMjU5NEwyIDEyLjAwMDZaIiBmaWxsPSIjRjNCQTJGIi8+CjxwYXRoIGQ9Ik04LjExNzg3IDEzLjU5NjFMMTIuMDAyMiAxNy40ODA0TDE1Ljg4ODEgMTMuNTk0NUwxOC4xNDg1IDE1Ljg1MThMMTIuMDAzOCAyMS45OTgxTDUuODU3NDIgMTUuODU2NUw4LjExNzg3IDEzLjU5NjFaIiBmaWxsPSIjRjNCQTJGIi8+CjxwYXRoIGQ9Ik0xNy40ODA1IDEyLjAwMDZMMTkuNzM5MyA5Ljc0MDExTDIxLjk5OTggMTEuOTk5TDE5LjczOTMgMTQuMjYxTDE3LjQ4MDUgMTIuMDAwNloiIGZpbGw9IiNGM0JBMkYiLz4KPHBhdGggZD0iTTE0LjI5NCAxMS45OTkxTDEyLjAwMiA5LjcwNTQ0TDEwLjMwNzEgMTEuNDAwNEwxMC4xMTEyIDExLjU5NDdMOS43MDk5NiAxMS45OTU5TDEyLjAwMiAxNC4yODY0TDE0LjI5NCAxMi4wMDA2VjExLjk5OTFaIiBmaWxsPSIjRjNCQTJGIi8+Cjwvc3ZnPgo=", Polygon = "data:image/svg+xml;base64,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", unbinding = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAzNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDNIN0M2LjQ2OTU3IDMgNS45NjA4NiAzLjIxMDcxIDUuNTg1NzkgMy41ODU3OUM1LjIxMDcxIDMuOTYwODYgNSA0LjQ2OTU3IDUgNVYxOUM1IDE5LjUzMDQgNS4yMTA3MSAyMC4wMzkxIDUuNTg1NzkgMjAuNDE0MkM1Ljk2MDg2IDIwLjc4OTMgNi40Njk1NyAyMSA3IDIxSDE1TTE5IDEyTDE1IDhNMTkgMTJMMTUgMTZNMTkgMTJIOSIgc3Ryb2tlPSIjQjE0M0ZGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", zondiconsNetwork = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDE5QzcuNjEzMDUgMTkgNS4zMjM4NyAxOC4wNTE4IDMuNjM2MDQgMTYuMzY0QzEuOTQ4MjEgMTQuNjc2MSAxIDEyLjM4NjkgMSAxMEMxIDcuNjEzMDUgMS45NDgyMSA1LjMyMzg3IDMuNjM2MDQgMy42MzYwNEM1LjMyMzg3IDEuOTQ4MjEgNy42MTMwNSAxIDEwIDFDMTIuMzg2OSAxIDE0LjY3NjEgMS45NDgyMSAxNi4zNjQgMy42MzYwNEMxOC4wNTE4IDUuMzIzODcgMTkgNy42MTMwNSAxOSAxMEMxOSAxMi4zODY5IDE4LjA1MTggMTQuNjc2MSAxNi4zNjQgMTYuMzY0QzE0LjY3NjEgMTguMDUxOCAxMi4zODY5IDE5IDEwIDE5Wk0xNi45NzUgMTEuOEMxNy4yNzk0IDEwLjYxOTMgMTcuMjc5NCA5LjM4MDY5IDE2Ljk3NSA4LjJIMTMuNTM3QzEzLjYyMDQgOS4zOTg1NSAxMy42MjA0IDEwLjYwMTQgMTMuNTM3IDExLjhIMTYuOTc1Wk0xNi4yMzcgMTMuNkgxMy4zMzlDMTMuMTg4MyAxNC42ODQ4IDEyLjkwMSAxNS43NDYyIDEyLjQ4NCAxNi43NTlDMTQuMDY1IDE2LjE3NTggMTUuMzkyNiAxNS4wNTg0IDE2LjIzNyAxMy42Wk04LjI3MiAxMS44SDExLjcyOEMxMS44MjU3IDEwLjYwMiAxMS44MjU3IDkuMzk4MDEgMTEuNzI4IDguMkg4LjI3MkM4LjE3NDMyIDkuMzk4MDEgOC4xNzQzMiAxMC42MDIgOC4yNzIgMTEuOFpNOC40OTcgMTMuNkM4Ljg2NiAxNS43NiA5LjUxNCAxNy4yIDEwIDE3LjJDMTAuNDg2IDE3LjIgMTEuMTM0IDE1Ljc2IDExLjUwMyAxMy42SDguNDk3Wk0zLjAyNSAxMS44SDYuNDYzQzYuMzc5NTkgMTAuNjAxNCA2LjM3OTU5IDkuMzk4NTUgNi40NjMgOC4ySDMuMDI1QzIuNzIwNTUgOS4zODA2OSAyLjcyMDU1IDEwLjYxOTMgMy4wMjUgMTEuOFpNMy43NjMgMTMuNkM0LjYwNzQzIDE1LjA1ODQgNS45MzQ5NSAxNi4xNzU4IDcuNTE2IDE2Ljc1OUM3LjEzOCAxNS44OTUgNi44NSAxNC44MTUgNi42NjEgMTMuNkgzLjc2M1pNMTYuMjM3IDYuNEMxNS4zOTI2IDQuOTQxNjQgMTQuMDY1IDMuODI0MjMgMTIuNDg0IDMuMjQxQzEyLjg2MiA0LjEwNSAxMy4xNSA1LjE4NSAxMy4zMzkgNi40SDE2LjIzN1pNOC40OTcgNi40SDExLjUwM0MxMS4xMzQgNC4yNCAxMC40ODYgMi44IDEwIDIuOEM5LjUxNCAyLjggOC44NjYgNC4yNCA4LjQ5NyA2LjRaTTMuNzYzIDYuNEg2LjY2MUM2Ljg0MSA1LjE4NSA3LjEzOCA0LjEwNSA3LjUxNiAzLjI0MUM1LjkzNDk1IDMuODI0MjMgNC42MDc0MyA0Ljk0MTY0IDMuNzYzIDYuNFoiIGZpbGw9IiMxNjE2MUQiLz4KPC9zdmc+Cg==", zondiconsNetworkPurple = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE0MjNfMjMwMSkiPgo8cGF0aCBkPSJNMTAgMjBDNy4zNDc4NCAyMCA0LjgwNDMgMTguOTQ2NCAyLjkyODkzIDE3LjA3MTFDMS4wNTM1NyAxNS4xOTU3IDAgMTIuNjUyMiAwIDEwQzAgNy4zNDc4NCAxLjA1MzU3IDQuODA0MyAyLjkyODkzIDIuOTI4OTNDNC44MDQzIDEuMDUzNTcgNy4zNDc4NCAwIDEwIDBDMTIuNjUyMiAwIDE1LjE5NTcgMS4wNTM1NyAxNy4wNzExIDIuOTI4OTNDMTguOTQ2NCA0LjgwNDMgMjAgNy4zNDc4NCAyMCAxMEMyMCAxMi42NTIyIDE4Ljk0NjQgMTUuMTk1NyAxNy4wNzExIDE3LjA3MTFDMTUuMTk1NyAxOC45NDY0IDEyLjY1MjIgMjAgMTAgMjBaTTE3Ljc1IDEyQzE4LjA4ODMgMTAuNjg4MSAxOC4wODgzIDkuMzExODggMTcuNzUgOEgxMy45M0MxNC4wMjI3IDkuMzMxNzIgMTQuMDIyNyAxMC42NjgzIDEzLjkzIDEySDE3Ljc1Wk0xNi45MyAxNEgxMy43MUMxMy41NDI1IDE1LjIwNTQgMTMuMjIzMyAxNi4zODQ3IDEyLjc2IDE3LjUxQzE0LjUxNjcgMTYuODYyIDE1Ljk5MTcgMTUuNjIwNCAxNi45MyAxNFpNOC4wOCAxMkgxMS45MkMxMi4wMjg1IDEwLjY2ODkgMTIuMDI4NSA5LjMzMTEyIDExLjkyIDhIOC4wOEM3Ljk3MTQ2IDkuMzMxMTIgNy45NzE0NiAxMC42Njg5IDguMDggMTJaTTguMzMgMTRDOC43NCAxNi40IDkuNDYgMTggMTAgMThDMTAuNTQgMTggMTEuMjYgMTYuNCAxMS42NyAxNEg4LjMzWk0yLjI1IDEySDYuMDdDNS45NzczMyAxMC42NjgzIDUuOTc3MzMgOS4zMzE3MiA2LjA3IDhIMi4yNUMxLjkxMTczIDkuMzExODggMS45MTE3MyAxMC42ODgxIDIuMjUgMTJaTTMuMDcgMTRDNC4wMDgyNiAxNS42MjA0IDUuNDgzMjggMTYuODYyIDcuMjQgMTcuNTFDNi44MiAxNi41NSA2LjUgMTUuMzUgNi4yOSAxNEgzLjA3Wk0xNi45MyA2QzE1Ljk5MTcgNC4zNzk2IDE0LjUxNjcgMy4xMzgwNCAxMi43NiAyLjQ5QzEzLjE4IDMuNDUgMTMuNSA0LjY1IDEzLjcxIDZIMTYuOTNaTTguMzMgNkgxMS42N0MxMS4yNiAzLjYgMTAuNTQgMiAxMCAyQzkuNDYgMiA4Ljc0IDMuNiA4LjMzIDZaTTMuMDcgNkg2LjI5QzYuNDkgNC42NSA2LjgyIDMuNDUgNy4yNCAyLjQ5QzUuNDgzMjggMy4xMzgwNCA0LjAwODI2IDQuMzc5NiAzLjA3IDZaIiBmaWxsPSIjQjE0M0ZGIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTQyM18yMzAxIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", checkMark = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjk2OTcgNC45Njk5OUMxMS4xMTA1IDQuODM1ODggMTEuMjk4IDQuNzYxNzMgMTEuNDkyNSA0Ljc2MzIxQzExLjY4NyA0Ljc2NDY4IDExLjg3MzMgNC44NDE2NSAxMi4wMTIxIDQuOTc3ODdDMTIuMTUwOSA1LjExNDEgMTIuMjMxNCA1LjI5ODkzIDEyLjIzNjYgNS40OTMzNkMxMi4yNDE3IDUuNjg3NzkgMTIuMTcxMSA1Ljg3NjYxIDEyLjAzOTcgNi4wMTk5OUw4LjA0OTY3IDExLjAxQzcuOTgxMDYgMTEuMDgzOSA3Ljg5ODI1IDExLjE0MzIgNy44MDYyIDExLjE4NDRDNy43MTQxNSAxMS4yMjU1IDcuNjE0NzQgMTEuMjQ3NyA3LjUxMzkyIDExLjI0OTZDNy40MTMxIDExLjI1MTQgNy4zMTI5NCAxMS4yMzI5IDcuMjE5NDMgMTEuMTk1MkM3LjEyNTkxIDExLjE1NzUgNy4wNDA5NyAxMS4xMDEzIDYuOTY5NjcgMTEuMDNMNC4zMjM2NyA4LjM4Mzk5QzQuMjQ5OTggOC4zMTUzMiA0LjE5MDg4IDguMjMyNTIgNC4xNDk4OSA4LjE0MDUyQzQuMTA4OSA4LjA0ODUzIDQuMDg2ODUgNy45NDkyMSA0LjA4NTA4IDcuODQ4NTFDNC4wODMzIDcuNzQ3ODEgNC4xMDE4MyA3LjY0Nzc4IDQuMTM5NTUgNy41NTQzOUM0LjE3NzI3IDcuNDYxIDQuMjMzNDEgNy4zNzYxNyA0LjMwNDYzIDcuMzA0OTVDNC4zNzU4NSA3LjIzMzczIDQuNDYwNjggNy4xNzc1OCA0LjU1NDA3IDcuMTM5ODZDNC42NDc0NiA3LjEwMjE0IDQuNzQ3NDkgNy4wODM2MiA0Ljg0ODE5IDcuMDg1MzlDNC45NDg4OSA3LjA4NzE3IDUuMDQ4MjEgNy4xMDkyMSA1LjE0MDIxIDcuMTUwMjFDNS4yMzIyMSA3LjE5MTIgNS4zMTUwMSA3LjI1MDMgNS4zODM2NyA3LjMyMzk5TDcuNDc3NjcgOS40MTY5OUwxMC45NTA3IDQuOTkxOTlDMTAuOTU2OSA0Ljk4NDI5IDEwLjk2MzYgNC45NzY5NCAxMC45NzA3IDQuOTY5OTlIMTAuOTY5N1oiIGZpbGw9IiNCMTQzRkYiLz4KPC9zdmc+Cg==", close = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkzN180NzczKSI+CjxwYXRoIGQ9Ik0xOSA2LjQxTDE3LjU5IDVMMTIgMTAuNTlMNi40MSA1TDUgNi40MUwxMC41OSAxMkw1IDE3LjU5TDYuNDEgMTlMMTIgMTMuNDFMMTcuNTkgMTlMMTkgMTcuNTlMMTMuNDEgMTJMMTkgNi40MVoiIGZpbGw9IiNCMTQzRkYiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MzdfNDc3MyI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", campaignEnd = "data:image/svg+xml;base64,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", refresh = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDIxQzkuNDg3NSAyMSA3LjM1OTM3IDIwLjEyODEgNS42MTU2MiAxOC4zODQ0QzMuODcxODcgMTYuNjQwNiAzIDE0LjUxMjUgMyAxMkMzIDkuNDg3NSAzLjg3MTg3IDcuMzU5MzcgNS42MTU2MiA1LjYxNTYyQzcuMzU5MzcgMy44NzE4NyA5LjQ4NzUgMyAxMiAzQzEzLjI5MzcgMyAxNC41MzEyIDMuMjY3MzcgMTUuNzEyNSAzLjgwMjEyQzE2Ljg5MzggNC4zMzYxMiAxNy45MDYyIDUuMSAxOC43NSA2LjA5Mzc1VjQuMTI1QzE4Ljc1IDMuODA2MjUgMTguODU4IDMuNTM4ODggMTkuMDc0IDMuMzIyODhDMTkuMjg5MiAzLjEwNzYzIDE5LjU1NjIgMyAxOS44NzUgM0MyMC4xOTM4IDMgMjAuNDYwOCAzLjEwNzYzIDIwLjY3NiAzLjMyMjg4QzIwLjg5MiAzLjUzODg4IDIxIDMuODA2MjUgMjEgNC4xMjVWOS43NUMyMSAxMC4wNjg3IDIwLjg5MiAxMC4zMzU4IDIwLjY3NiAxMC41NTFDMjAuNDYwOCAxMC43NjcgMjAuMTkzOCAxMC44NzUgMTkuODc1IDEwLjg3NUgxNC4yNUMxMy45MzEyIDEwLjg3NSAxMy42NjQzIDEwLjc2NyAxMy40NDkgMTAuNTUxQzEzLjIzMyAxMC4zMzU4IDEzLjEyNSAxMC4wNjg3IDEzLjEyNSA5Ljc1QzEzLjEyNSA5LjQzMTI1IDEzLjIzMyA5LjE2Mzg3IDEzLjQ0OSA4Ljk0Nzg3QzEzLjY2NDMgOC43MzI2MiAxMy45MzEyIDguNjI1IDE0LjI1IDguNjI1SDE3Ljg1QzE3LjI1IDcuNTc1IDE2LjQyOTkgNi43NSAxNS4zODk2IDYuMTVDMTQuMzQ4NiA1LjU1IDEzLjIxODggNS4yNSAxMiA1LjI1QzEwLjEyNSA1LjI1IDguNTMxMjUgNS45MDYyNSA3LjIxODc1IDcuMjE4NzVDNS45MDYyNSA4LjUzMTI1IDUuMjUgMTAuMTI1IDUuMjUgMTJDNS4yNSAxMy44NzUgNS45MDYyNSAxNS40Njg4IDcuMjE4NzUgMTYuNzgxMkM4LjUzMTI1IDE4LjA5MzggMTAuMTI1IDE4Ljc1IDEyIDE4Ljc1QzEzLjI5MzcgMTguNzUgMTQuNDg5MiAxOC40MDc2IDE1LjU4NjUgMTcuNzIyOUMxNi42ODMgMTcuMDM4OSAxNy41MDMxIDE2LjEyNSAxOC4wNDY5IDE0Ljk4MTJDMTguMTQwNiAxNC43NzUgMTguMjk1NSAxNC42MDE3IDE4LjUxMTUgMTQuNDYxNUMxOC43MjY4IDE0LjMyMDUgMTguOTQ2OSAxNC4yNSAxOS4xNzE5IDE0LjI1QzE5LjYwMzEgMTQuMjUgMTkuOTI2OCAxNC40IDIwLjE0MjggMTQuN0MyMC4zNTggMTUgMjAuMzgxMiAxNS4zMzc1IDIwLjIxMjUgMTUuNzEyNUMxOS41IDE3LjMwNjMgMTguNDAzMSAxOC41ODU3IDE2LjkyMTkgMTkuNTUxQzE1LjQ0MDYgMjAuNTE3IDEzLjggMjEgMTIgMjFaIiBmaWxsPSIjQjE0M0ZGIi8+Cjwvc3ZnPgo=", downArrow = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgOS40TDcuNCA4TDEyIDEyLjZMMTYuNiA4TDE4IDkuNEwxMiAxNS40TDYgOS40WiIgZmlsbD0iI0IxNDNGRiIvPgo8L3N2Zz4K", gridiconsNotice = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODEiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MSA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQwLjUgMEMxOC40MDggMCAwLjUgMTcuOTA4IDAuNSA0MEMwLjUgNjIuMDkyIDE4LjQwOCA4MCA0MC41IDgwQzYyLjU5MiA4MCA4MC41IDYyLjA5MiA4MC41IDQwQzgwLjUgMTcuOTA4IDYyLjU5MiAwIDQwLjUgMFpNNDQuNSA2MEgzNi41VjUySDQ0LjVWNjBaTTQ0LjUgNDRIMzYuNUwzNC41IDIwSDQ2LjVMNDQuNSA0NFoiIGZpbGw9IiNGRjJDODIiLz4KPC9zdmc+Cg==", arrowLeft = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjcwNSA3LjQxTDE0LjI5NSA2TDguMjk1MDQgMTJMMTQuMjk1IDE4TDE1LjcwNSAxNi41OUwxMS4xMjUgMTJMMTUuNzA1IDcuNDFaIiBmaWxsPSIjMTYxNjFEIi8+Cjwvc3ZnPgo=", arrowRight = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNzA1MDQgNkw4LjI5NTA0IDcuNDFMMTIuODc1IDEyTDguMjk1MDQgMTYuNTlMOS43MDUwNCAxOEwxNS43MDUgMTJMOS43MDUwNCA2WiIgZmlsbD0iIzE2MTYxRCIvPgo8L3N2Zz4K", IconImage = "data:image/svg+xml;base64,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", powerByRedreamerBlack = "data:image/svg+xml;base64,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", powerByRedreamerWhite = "data:image/svg+xml;base64,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", EthereumIcon = Ethereum, ThunderCoreIcon = ThunderCore, BinanceIcon = Binance, PolygonIcon = Polygon, unbindingIcon = unbinding, zondiconsNetworkIcon = zondiconsNetwork, zondiconsNetworkPurpleIcon = zondiconsNetworkPurple, checkMarkIcon = checkMark, closeIcon = close, campaignEndIcon = campaignEnd, refreshIcon = refresh, downArrowIcon = downArrow, gridiconsNoticeIcon = gridiconsNotice, arrowLeftIcon = arrowLeft, arrowRightIcon = arrowRight, LogoImage = IconImage, powerByRedreamerBlackIcon = powerByRedreamerBlack, powerByRedreamerWhiteIcon = powerByRedreamerWhite, vw = { xs: 600, sm: 960, md: 1264, lg: 1904 }, breakpoints = [
  "1px",
  // xs
  `${vw.xs + 1}px`,
  // sm
  `${vw.sm + 1}px`,
  // md
  `${vw.md + 1}px`,
  // lg
  `${vw.lg + 1}px`
  // xl
];
[breakpoints.xs, breakpoints.sm, breakpoints.md, breakpoints.lg, breakpoints.xl] = breakpoints;
breakpoints.mobile = vw.xs;
const metrics = { widthXS: vw.xs, widthSM: vw.sm, widthMD: vw.md, widthLG: vw.lg }, { widthXS, widthSM, widthMD, widthLG } = metrics, v$1 = { xs: { min: `(min-width: ${widthXS}px)`, max: `(max-width: ${widthXS}px)` }, sm: { min: `(min-width: ${widthXS + 1}px)`, max: `(max-width: ${widthSM}px)` }, md: { min: `(min-width: ${widthSM + 1}px)`, max: `(max-width: ${widthMD}px)` }, lg: { min: `(min-width: ${widthMD + 1}px)`, max: `(max-width: ${widthLG}px)` }, xl: { min: `(min-width: ${widthLG + 1}px)` } }, XS_QUERY = v$1.xs.max, SM_AND_UP_QUERY = v$1.sm.min, MD_AND_DOWN_QUERY = v$1.md.max, Row = styled$3.div`
  display: flex;
  align-items: ${(e) => {
  let { align: t } = e;
  return t || "center";
}};
  flex-direction: ${(e) => {
  let { direction: t } = e;
  return t || "row";
}};
  justify-content: ${(e) => {
  let { justify: t } = e;
  return t;
}};
  flex-wrap: ${(e) => {
  let { wrap: t } = e;
  return t;
}};
  cursor: ${(e) => {
  let { useCursor: t } = e;
  return t ? "pointer" : "";
}};
`, StyledIconImg = styled$3.img`
  width: ${(e) => {
  let { width: t, mobileWidth: i } = e;
  return i || t;
}};
  margin-right: ${(e) => {
  let { marginRight: t, mobileMarginRight: i } = e;
  return i || t;
}};
  margin-left: ${(e) => {
  let { marginLeft: t, mobileMarginLeft: i } = e;
  return i || t;
}};
  margin-bottom: ${(e) => {
  let { marginBottom: t } = e;
  return t;
}};
  cursor: ${(e) => {
  let { pointer: t } = e;
  return t ? "pointer" : "";
}};
`, StyledDesktopRender = styled$3.div`
  display: none;

  @media ${SM_AND_UP_QUERY} {
    display: block;
  }
`, StyledMobileRender = styled$3.div`
  display: block;
  width: 100%;

  @media ${SM_AND_UP_QUERY} {
    display: none;
  }
`, fontStyle = (e, t) => css$1`
  font-size: ${e};
  font-weight: ${t || "normal"};
`, fontEllipsis = (e) => css$1`
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${e};
  -webkit-box-orient: vertical;
`, size = (e, t) => css$1`
  width: ${e};
  height: ${t};
`, StyledMaskIcon = styled$3.div`
  mask-repeat: no-repeat;
  mask-position: center;
  ${(e) => {
  let { width: t } = e;
  return size(t, t);
}};
  margin-right: ${(e) => {
  let { mr: t } = e;
  return t;
}};
  mask-image: ${(e) => {
  let { src: t } = e;
  return `url(${t})`;
}};
  background: ${(e) => {
  let { theme: t, notChangeColor: i } = e;
  return i ? "" : t.colors.brightDream;
}};
  cursor: ${(e) => {
  let { pointer: t } = e;
  return t ? "pointer" : "";
}};
`;
styled$3.div`
  width: 130px;
  padding: 8px 0;
  border: 1px solid ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  background: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 1;
  color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brainGrey;
}};

  & > div {
    font-size: 14px;
    padding: 6px 0 6px 16px;
    text-align: left;
    cursor: pointer;

    :hover {
      background: rgba(177, 67, 255, 0.05);
      color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
      font-weight: 500;
    }
  }

  & > div:last-child {
    color: ${(e) => {
  let { hasDelete: t, theme: i } = e;
  return t ? i.colors.rose : i.colors.brainGrey;
}};

    :hover {
      color: ${(e) => {
  let { hasDelete: t, theme: i } = e;
  return t ? i.colors.rose : i.colors.brightDream;
}};
      background: ${(e) => {
  let { hasDelete: t } = e;
  return t ? "rgba(255, 44, 130, 0.05)" : "rgba(177, 67, 255, 0.05)";
}};
    }
  }
`;
const StyledContainer$5 = styled$3.div`
  width: 100%;
  cursor: pointer;
`, StyledContent$3 = styled$3.div`
  padding: 8px;
  height: 64px;
  background: white;

  @media ${SM_AND_UP_QUERY} {
    padding: 24px;
    height: 129px;
  }
`, StyledDateMobile = styled$3.div`
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
  ${fontStyle("10px")};

  @media ${SM_AND_UP_QUERY} {
    margin-bottom: 16px;
    ${fontStyle("14px")};
    display: none;
  }
`, StyledDateDesktop = styled$3(StyledDateMobile)`
  display: none;

  @media ${SM_AND_UP_QUERY} {
    display: block;
  }
`, StyledTitle$1 = styled$3.div`
  color: #16161d;
  ${fontEllipsis(2)};
  ${fontStyle("12px", "700")};

  @media ${SM_AND_UP_QUERY} {
    ${fontStyle("20px", "700")};
  }
`, StyledImageContainer = styled$3.div`
  width: 100%;
  height: ${(e) => {
  let { height: t } = e;
  return t + 1;
}}px;
  position: relative;
  object-fit: contain;
  background: #16161d;
`, StyledCampaignEndIcon = styled$3.img`
  width: 113px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`, CampaignCard = (e) => {
  let { name: t = "", imageUrl: i = "", startTime: n = "", endTime: a = "", loading: o, defaultImg: l, isCampaignEnd: c = !1, onClick: d } = e;
  const [u, m] = useState(0), A = useRef(null), y = () => {
    o || typeof d == "function" && d();
  };
  return useEffect(() => {
    if (A.current) {
      const { width: D } = A.current.getBoundingClientRect();
      m(D);
    }
  }, [A.current]), /* @__PURE__ */ jsxs(StyledContainer$5, { role: "presentation", onClick: y, children: [/* @__PURE__ */ jsxs(StyledImageContainer, { height: u, children: [/* @__PURE__ */ jsx("img", { ref: A, height: u, alt: "cover", src: i || l || "", style: { width: "100%", objectFit: "contain" } }), c && /* @__PURE__ */ jsx(StyledCampaignEndIcon, { src: campaignEndIcon, alt: "campaign_end" })] }), /* @__PURE__ */ jsxs(StyledContent$3, { children: [/* @__PURE__ */ jsx(StyledDateMobile, { children: `~${n}` }), /* @__PURE__ */ jsx(StyledDateDesktop, { children: `${n} ~ ${a}` }), /* @__PURE__ */ jsx(StyledTitle$1, { children: t })] })] });
};
function isNil(e) {
  return e == null;
}
var isNil_1 = isNil, ModalMode = /* @__PURE__ */ ((e) => (e[e.NORMAL = 1] = "NORMAL", e[e.QR_CODE = 2] = "QR_CODE", e))(ModalMode || {});
const StyledBackDrop = styled$3.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #333;
  opacity: ${(e) => {
  let { hasBackDrop: t } = e;
  return t ? 0.75 : 0;
}};
  z-index: 10;
  transition: opacity 0.3s;
`, StyledContainer$4 = styled$3.div`
  position: fixed;
  width: ${(e) => {
  let { width: t } = e;
  return isNil_1(t) ? "100%" : String(t).includes("%") ? t : `${t}px`;
}};
  height: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "100%";
    default:
      return "";
  }
}};
  max-height: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "100%";
    default:
      return "90%";
  }
}};
  max-width: 100%;
  min-width: 300px;
  left: 50%;
  top: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.NORMAL:
      return "50%";
    case ModalMode.QR_CODE:
      return "60%";
    default:
      return "50%";
  }
}};
  bottom: auto;
  right: auto;
  padding: 15px;
  transform: translate(-50%, -50%);
  background-color: ${(e) => {
  let { backgroundColor: t } = e;
  return t;
}};
  box-shadow: 0 0 10px rgba(100, 100, 100, 0.7);
  overflow-x: auto;
  overflow-y: auto;
  z-index: 15;
  border-radius: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "20px 20px 0 0";
    default:
      return "";
  }
}};

  @media ${XS_QUERY} {
    width: ${(e) => {
  let { width: t } = e;
  return t || "90%";
}};
  }

  @media ${SM_AND_UP_QUERY} {
    width: ${(e) => {
  let { width: t } = e;
  return isNil_1(t) ? "500px" : String(t).includes("%") ? t : `${t}px`;
}};
    height: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "489px";
    default:
      return "";
  }
}};
    max-height: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "";
    default:
      return "90%";
  }
}};
    max-width: 100%;
    min-width: 300px;
    left: 50%;
    top: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "50%";
    default:
      return "50%";
  }
}};
    border-radius: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "0";
    default:
      return "";
  }
}};
    border: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return `solid 5px ${(i) => {
        let { theme: n } = i;
        return n.colors.brightDream;
      }}`;
    default:
      return "";
  }
}};
  }
`, StyledCloseButton = styled$3.div`
  padding: 12px 15px;
  position: absolute;
  top: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "13px";
    default:
      return "8px";
  }
}};
  right: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "15px";
    default:
      return "8px";
  }
}};
  color: ${(e) => {
  let { closeColor: t } = e;
  return t;
}};
  cursor: pointer;

  @media ${SM_AND_UP_QUERY} {
    font-size: 32px;
    top: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "48px";
    default:
      return "8px";
  }
}};
    right: ${(e) => {
  let { mode: t } = e;
  switch (t) {
    case ModalMode.QR_CODE:
      return "33px";
    default:
      return "8px";
  }
}};
  }
`;
let modalNode;
typeof window < "u" && (modalNode = document.createElement("div"), modalNode.classList.add("modal-container"), document.body.appendChild(modalNode));
const Modal = (e) => {
  let { hasBackDrop: t = !0, backgroundColor: i = "#fff", closeColor: n = "#000", opened: a = !1, onClose: o = () => {
  }, width: l, children: c, mode: d, disabledCloseButton: u, ...m } = e;
  return useEffect(() => {
    function A(y) {
      y.code === "Escape" && o();
    }
    return document.addEventListener("keydown", A), () => document.removeEventListener("keydown", A);
  }, []), a && modalNode && createPortal(/* @__PURE__ */ jsxs("div", { ...m, children: [/* @__PURE__ */ jsx(StyledBackDrop, { hasBackDrop: t, onClick: o }), /* @__PURE__ */ jsxs(StyledContainer$4, { width: l, backgroundColor: i, mode: d, children: [!u && /* @__PURE__ */ jsx(StyledCloseButton, { closeColor: n, onClick: o, mode: d, children: "✕" }), c] })] }), modalNode);
};
function _objectWithoutPropertiesLoose$1(e, t) {
  if (e == null)
    return {};
  var i = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(t.indexOf(a) >= 0) && (i[a] = e[a]);
  return i;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, _extends.apply(this, arguments);
}
var propTypesExports = {}, propTypes = { get exports() {
  return propTypesExports;
}, set exports(e) {
  propTypesExports = e;
} }, reactIsExports$2 = {}, reactIs$3 = { get exports() {
  return reactIsExports$2;
}, set exports(e) {
  reactIsExports$2 = e;
} }, reactIs_production_min$2 = {};
/** @license React v16.13.1
* react-is.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2)
    return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, z = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function k(L) {
    if (typeof L == "object" && L !== null) {
      var F = L.$$typeof;
      switch (F) {
        case t:
          switch (L = L.type, L) {
            case d:
            case u:
            case n:
            case o:
            case a:
            case A:
              return L;
            default:
              switch (L = L && L.$$typeof, L) {
                case c:
                case m:
                case C:
                case D:
                case l:
                  return L;
                default:
                  return F;
              }
          }
        case i:
          return F;
      }
    }
  }
  function P(L) {
    return k(L) === u;
  }
  return reactIs_production_min$2.AsyncMode = d, reactIs_production_min$2.ConcurrentMode = u, reactIs_production_min$2.ContextConsumer = c, reactIs_production_min$2.ContextProvider = l, reactIs_production_min$2.Element = t, reactIs_production_min$2.ForwardRef = m, reactIs_production_min$2.Fragment = n, reactIs_production_min$2.Lazy = C, reactIs_production_min$2.Memo = D, reactIs_production_min$2.Portal = i, reactIs_production_min$2.Profiler = o, reactIs_production_min$2.StrictMode = a, reactIs_production_min$2.Suspense = A, reactIs_production_min$2.isAsyncMode = function(L) {
    return P(L) || k(L) === d;
  }, reactIs_production_min$2.isConcurrentMode = P, reactIs_production_min$2.isContextConsumer = function(L) {
    return k(L) === c;
  }, reactIs_production_min$2.isContextProvider = function(L) {
    return k(L) === l;
  }, reactIs_production_min$2.isElement = function(L) {
    return typeof L == "object" && L !== null && L.$$typeof === t;
  }, reactIs_production_min$2.isForwardRef = function(L) {
    return k(L) === m;
  }, reactIs_production_min$2.isFragment = function(L) {
    return k(L) === n;
  }, reactIs_production_min$2.isLazy = function(L) {
    return k(L) === C;
  }, reactIs_production_min$2.isMemo = function(L) {
    return k(L) === D;
  }, reactIs_production_min$2.isPortal = function(L) {
    return k(L) === i;
  }, reactIs_production_min$2.isProfiler = function(L) {
    return k(L) === o;
  }, reactIs_production_min$2.isStrictMode = function(L) {
    return k(L) === a;
  }, reactIs_production_min$2.isSuspense = function(L) {
    return k(L) === A;
  }, reactIs_production_min$2.isValidElementType = function(L) {
    return typeof L == "string" || typeof L == "function" || L === n || L === u || L === o || L === a || L === A || L === y || typeof L == "object" && L !== null && (L.$$typeof === C || L.$$typeof === D || L.$$typeof === l || L.$$typeof === c || L.$$typeof === m || L.$$typeof === R || L.$$typeof === O || L.$$typeof === $ || L.$$typeof === z);
  }, reactIs_production_min$2.typeOf = k, reactIs_production_min$2;
}
var reactIs_development$2 = {};
/** @license React v16.13.1
* react-is.development.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  return hasRequiredReactIs_development$2 || (hasRequiredReactIs_development$2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, z = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function k(re) {
      return typeof re == "string" || typeof re == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      re === n || re === u || re === o || re === a || re === A || re === y || typeof re == "object" && re !== null && (re.$$typeof === C || re.$$typeof === D || re.$$typeof === l || re.$$typeof === c || re.$$typeof === m || re.$$typeof === R || re.$$typeof === O || re.$$typeof === $ || re.$$typeof === z);
    }
    function P(re) {
      if (typeof re == "object" && re !== null) {
        var fe = re.$$typeof;
        switch (fe) {
          case t:
            var oe = re.type;
            switch (oe) {
              case d:
              case u:
              case n:
              case o:
              case a:
              case A:
                return oe;
              default:
                var ve = oe && oe.$$typeof;
                switch (ve) {
                  case c:
                  case m:
                  case C:
                  case D:
                  case l:
                    return ve;
                  default:
                    return fe;
                }
            }
          case i:
            return fe;
        }
      }
    }
    var L = d, F = u, B = c, G = l, Z = t, X = m, V = n, E = C, T = D, g = i, b = o, x = a, S = A, I = !1;
    function N(re) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), p(re) || P(re) === d;
    }
    function p(re) {
      return P(re) === u;
    }
    function M(re) {
      return P(re) === c;
    }
    function j(re) {
      return P(re) === l;
    }
    function U(re) {
      return typeof re == "object" && re !== null && re.$$typeof === t;
    }
    function H(re) {
      return P(re) === m;
    }
    function J(re) {
      return P(re) === n;
    }
    function te(re) {
      return P(re) === C;
    }
    function ae(re) {
      return P(re) === D;
    }
    function le(re) {
      return P(re) === i;
    }
    function ne(re) {
      return P(re) === o;
    }
    function ue(re) {
      return P(re) === a;
    }
    function ge(re) {
      return P(re) === A;
    }
    reactIs_development$2.AsyncMode = L, reactIs_development$2.ConcurrentMode = F, reactIs_development$2.ContextConsumer = B, reactIs_development$2.ContextProvider = G, reactIs_development$2.Element = Z, reactIs_development$2.ForwardRef = X, reactIs_development$2.Fragment = V, reactIs_development$2.Lazy = E, reactIs_development$2.Memo = T, reactIs_development$2.Portal = g, reactIs_development$2.Profiler = b, reactIs_development$2.StrictMode = x, reactIs_development$2.Suspense = S, reactIs_development$2.isAsyncMode = N, reactIs_development$2.isConcurrentMode = p, reactIs_development$2.isContextConsumer = M, reactIs_development$2.isContextProvider = j, reactIs_development$2.isElement = U, reactIs_development$2.isForwardRef = H, reactIs_development$2.isFragment = J, reactIs_development$2.isLazy = te, reactIs_development$2.isMemo = ae, reactIs_development$2.isPortal = le, reactIs_development$2.isProfiler = ne, reactIs_development$2.isStrictMode = ue, reactIs_development$2.isSuspense = ge, reactIs_development$2.isValidElementType = k, reactIs_development$2.typeOf = P;
  }()), reactIs_development$2;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = requireReactIs_production_min$2() : e.exports = requireReactIs_development$2();
  }(reactIs$3)), reactIsExports$2;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = e, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = requireReactPropTypesSecret(), i = {}, n = requireHas();
    e = function(o) {
      var l = "Warning: " + o;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function a(o, l, c, d, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var m in o)
        if (n(o, m)) {
          var A;
          try {
            if (typeof o[m] != "function") {
              var y = Error((d || "React class") + ": " + c + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw y.name = "Invariant Violation", y;
            }
            A = o[m](l, m, d, c, null, t);
          } catch (C) {
            A = C;
          }
          if (A && !(A instanceof Error) && e((d || "React class") + ": type specification of " + c + " `" + m + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof A + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), A instanceof Error && !(A.message in i)) {
            i[A.message] = !0;
            var D = u ? u() : "";
            e("Failed " + c + " type: " + A.message + (D ?? ""));
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (i = {});
  }, checkPropTypes_1 = a, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var e = requireReactIs(), t = requireObjectAssign(), i = requireReactPropTypesSecret(), n = requireHas(), a = requireCheckPropTypes(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(c) {
    var d = "Warning: " + c;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return factoryWithTypeCheckers = function(c, d) {
    var u = typeof Symbol == "function" && Symbol.iterator, m = "@@iterator";
    function A(p) {
      var M = p && (u && p[u] || p[m]);
      if (typeof M == "function")
        return M;
    }
    var y = "<<anonymous>>", D = { array: O("array"), bigint: O("bigint"), bool: O("boolean"), func: O("function"), number: O("number"), object: O("object"), string: O("string"), symbol: O("symbol"), any: $(), arrayOf: k, element: P(), elementType: L(), instanceOf: F, node: X(), objectOf: G, oneOf: B, oneOfType: Z, shape: E, exact: T };
    function C(p, M) {
      return p === M ? p !== 0 || 1 / p === 1 / M : p !== p && M !== M;
    }
    function z(p, M) {
      this.message = p, this.data = M && typeof M == "object" ? M : {}, this.stack = "";
    }
    z.prototype = Error.prototype;
    function R(p) {
      if (process.env.NODE_ENV !== "production")
        var M = {}, j = 0;
      function U(J, te, ae, le, ne, ue, ge) {
        if (le = le || y, ue = ue || ae, ge !== i) {
          if (d) {
            var re = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw re.name = "Invariant Violation", re;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var fe = le + ":" + ae;
            !M[fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            j < 3 && (o("You are manually calling a React.PropTypes validation function for the `" + ue + "` prop on `" + le + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), M[fe] = !0, j++);
          }
        }
        return te[ae] == null ? J ? te[ae] === null ? new z("The " + ne + " `" + ue + "` is marked as required " + ("in `" + le + "`, but its value is `null`.")) : new z("The " + ne + " `" + ue + "` is marked as required in " + ("`" + le + "`, but its value is `undefined`.")) : null : p(te, ae, le, ne, ue);
      }
      var H = U.bind(null, !1);
      return H.isRequired = U.bind(null, !0), H;
    }
    function O(p) {
      function M(j, U, H, J, te, ae) {
        var le = j[U], ne = x(le);
        if (ne !== p) {
          var ue = S(le);
          return new z("Invalid " + J + " `" + te + "` of type " + ("`" + ue + "` supplied to `" + H + "`, expected ") + ("`" + p + "`."), { expectedType: p });
        }
        return null;
      }
      return R(M);
    }
    function $() {
      return R(l);
    }
    function k(p) {
      function M(j, U, H, J, te) {
        if (typeof p != "function")
          return new z("Property `" + te + "` of component `" + H + "` has invalid PropType notation inside arrayOf.");
        var ae = j[U];
        if (!Array.isArray(ae)) {
          var le = x(ae);
          return new z("Invalid " + J + " `" + te + "` of type " + ("`" + le + "` supplied to `" + H + "`, expected an array."));
        }
        for (var ne = 0; ne < ae.length; ne++) {
          var ue = p(ae, ne, H, J, te + "[" + ne + "]", i);
          if (ue instanceof Error)
            return ue;
        }
        return null;
      }
      return R(M);
    }
    function P() {
      function p(M, j, U, H, J) {
        var te = M[j];
        if (!c(te)) {
          var ae = x(te);
          return new z("Invalid " + H + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + U + "`, expected a single ReactElement."));
        }
        return null;
      }
      return R(p);
    }
    function L() {
      function p(M, j, U, H, J) {
        var te = M[j];
        if (!e.isValidElementType(te)) {
          var ae = x(te);
          return new z("Invalid " + H + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + U + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return R(p);
    }
    function F(p) {
      function M(j, U, H, J, te) {
        if (!(j[U] instanceof p)) {
          var ae = p.name || y, le = N(j[U]);
          return new z("Invalid " + J + " `" + te + "` of type " + ("`" + le + "` supplied to `" + H + "`, expected ") + ("instance of `" + ae + "`."));
        }
        return null;
      }
      return R(M);
    }
    function B(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : o("Invalid argument supplied to oneOf, expected an array.")), l;
      function M(j, U, H, J, te) {
        for (var ae = j[U], le = 0; le < p.length; le++)
          if (C(ae, p[le]))
            return null;
        var ne = JSON.stringify(p, function(ge, re) {
          var fe = S(re);
          return fe === "symbol" ? String(re) : re;
        });
        return new z("Invalid " + J + " `" + te + "` of value `" + String(ae) + "` " + ("supplied to `" + H + "`, expected one of " + ne + "."));
      }
      return R(M);
    }
    function G(p) {
      function M(j, U, H, J, te) {
        if (typeof p != "function")
          return new z("Property `" + te + "` of component `" + H + "` has invalid PropType notation inside objectOf.");
        var ae = j[U], le = x(ae);
        if (le !== "object")
          return new z("Invalid " + J + " `" + te + "` of type " + ("`" + le + "` supplied to `" + H + "`, expected an object."));
        for (var ne in ae)
          if (n(ae, ne)) {
            var ue = p(ae, ne, H, J, te + "." + ne, i);
            if (ue instanceof Error)
              return ue;
          }
        return null;
      }
      return R(M);
    }
    function Z(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var M = 0; M < p.length; M++) {
        var j = p[M];
        if (typeof j != "function")
          return o("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + I(j) + " at index " + M + "."), l;
      }
      function U(H, J, te, ae, le) {
        for (var ne = [], ue = 0; ue < p.length; ue++) {
          var ge = p[ue], re = ge(H, J, te, ae, le, i);
          if (re == null)
            return null;
          re.data && n(re.data, "expectedType") && ne.push(re.data.expectedType);
        }
        var fe = ne.length > 0 ? ", expected one of type [" + ne.join(", ") + "]" : "";
        return new z("Invalid " + ae + " `" + le + "` supplied to " + ("`" + te + "`" + fe + "."));
      }
      return R(U);
    }
    function X() {
      function p(M, j, U, H, J) {
        return g(M[j]) ? null : new z("Invalid " + H + " `" + J + "` supplied to " + ("`" + U + "`, expected a ReactNode."));
      }
      return R(p);
    }
    function V(p, M, j, U, H) {
      return new z((p || "React class") + ": " + M + " type `" + j + "." + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + H + "`.");
    }
    function E(p) {
      function M(j, U, H, J, te) {
        var ae = j[U], le = x(ae);
        if (le !== "object")
          return new z("Invalid " + J + " `" + te + "` of type `" + le + "` " + ("supplied to `" + H + "`, expected `object`."));
        for (var ne in p) {
          var ue = p[ne];
          if (typeof ue != "function")
            return V(H, J, te, ne, S(ue));
          var ge = ue(ae, ne, H, J, te + "." + ne, i);
          if (ge)
            return ge;
        }
        return null;
      }
      return R(M);
    }
    function T(p) {
      function M(j, U, H, J, te) {
        var ae = j[U], le = x(ae);
        if (le !== "object")
          return new z("Invalid " + J + " `" + te + "` of type `" + le + "` " + ("supplied to `" + H + "`, expected `object`."));
        var ne = t({}, j[U], p);
        for (var ue in ne) {
          var ge = p[ue];
          if (n(p, ue) && typeof ge != "function")
            return V(H, J, te, ue, S(ge));
          if (!ge)
            return new z("Invalid " + J + " `" + te + "` key `" + ue + "` supplied to `" + H + "`.\nBad object: " + JSON.stringify(j[U], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(p), null, "  "));
          var re = ge(ae, ue, H, J, te + "." + ue, i);
          if (re)
            return re;
        }
        return null;
      }
      return R(M);
    }
    function g(p) {
      switch (typeof p) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !p;
        case "object":
          if (Array.isArray(p))
            return p.every(g);
          if (p === null || c(p))
            return !0;
          var M = A(p);
          if (M) {
            var j = M.call(p), U;
            if (M !== p.entries) {
              for (; !(U = j.next()).done; )
                if (!g(U.value))
                  return !1;
            } else
              for (; !(U = j.next()).done; ) {
                var H = U.value;
                if (H && !g(H[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function b(p, M) {
      return p === "symbol" ? !0 : M ? M["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && M instanceof Symbol : !1;
    }
    function x(p) {
      var M = typeof p;
      return Array.isArray(p) ? "array" : p instanceof RegExp ? "object" : b(M, p) ? "symbol" : M;
    }
    function S(p) {
      if (typeof p > "u" || p === null)
        return "" + p;
      var M = x(p);
      if (M === "object") {
        if (p instanceof Date)
          return "date";
        if (p instanceof RegExp)
          return "regexp";
      }
      return M;
    }
    function I(p) {
      var M = S(p);
      switch (M) {
        case "array":
        case "object":
          return "an " + M;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + M;
        default:
          return M;
      }
    }
    function N(p) {
      return !p.constructor || !p.constructor.name ? y : p.constructor.name;
    }
    return D.checkPropTypes = a, D.resetWarningCache = a.resetWarningCache, D.PropTypes = D, D;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var e = requireReactPropTypesSecret();
  function t() {
  }
  function i() {
  }
  return i.resetWarningCache = t, factoryWithThrowingShims = function() {
    function n(l, c, d, u, m, A) {
      if (A !== e) {
        var y = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw y.name = "Invariant Violation", y;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var o = { array: n, bigint: n, bool: n, func: n, number: n, object: n, string: n, symbol: n, any: n, arrayOf: a, element: n, elementType: n, instanceOf: a, node: n, objectOf: a, oneOf: a, oneOfType: a, shape: a, exact: a, checkPropTypes: i, resetWarningCache: t };
    return o.PropTypes = o, o;
  }, factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
function r$2(e) {
  var t, i, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (i = r$2(e[t])) && (n && (n += " "), n += i);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, i = 0, n = ""; i < arguments.length; )
    (e = arguments[i++]) && (t = r$2(e)) && (n && (n += " "), n += t);
  return n;
}
function chainPropTypes(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function() {
    return e(...arguments) || t(...arguments);
  };
}
function isPlainObject(e) {
  return e !== null && typeof e == "object" && e.constructor === Object;
}
function deepClone(e) {
  if (!isPlainObject(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((i) => {
    t[i] = deepClone(e[i]);
  }), t;
}
function deepmerge(e, t) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { clone: !0 };
  const n = i.clone ? _extends({}, e) : e;
  return isPlainObject(e) && isPlainObject(t) && Object.keys(t).forEach((a) => {
    a !== "__proto__" && (isPlainObject(t[a]) && a in e && isPlainObject(e[a]) ? n[a] = deepmerge(e[a], t[a], i) : i.clone ? n[a] = isPlainObject(t[a]) ? deepClone(t[a]) : t[a] : n[a] = t[a]);
  }), n;
}
function isClassComponent(e) {
  const { prototype: t = {} } = e;
  return !!t.isReactComponent;
}
function elementTypeAcceptingRef(e, t, i, n, a) {
  const o = e[t], l = a || t;
  if (o == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  return typeof o == "function" && !isClassComponent(o) && (c = "Did you accidentally provide a plain function component instead?"), c !== void 0 ? new Error(`Invalid ${n} \`${l}\` supplied to \`${i}\`. Expected an element type that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(propTypesExports.elementType, elementTypeAcceptingRef);
function formatMuiErrorMessage(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let i = 1; i < arguments.length; i += 1)
    t += "&args[]=" + encodeURIComponent(arguments[i]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
var reactIsExports$1 = {}, reactIs$2 = { get exports() {
  return reactIsExports$1;
}, set exports(e) {
  reactIsExports$1 = e;
} }, reactIs_production_min$1 = {};
/**
* @license React
* react-is.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1)
    return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), A = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), C;
  C = Symbol.for("react.module.reference");
  function z(R) {
    if (typeof R == "object" && R !== null) {
      var O = R.$$typeof;
      switch (O) {
        case e:
          switch (R = R.type, R) {
            case i:
            case a:
            case n:
            case u:
            case m:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case c:
                case l:
                case d:
                case y:
                case A:
                case o:
                  return R;
                default:
                  return O;
              }
          }
        case t:
          return O;
      }
    }
  }
  return reactIs_production_min$1.ContextConsumer = l, reactIs_production_min$1.ContextProvider = o, reactIs_production_min$1.Element = e, reactIs_production_min$1.ForwardRef = d, reactIs_production_min$1.Fragment = i, reactIs_production_min$1.Lazy = y, reactIs_production_min$1.Memo = A, reactIs_production_min$1.Portal = t, reactIs_production_min$1.Profiler = a, reactIs_production_min$1.StrictMode = n, reactIs_production_min$1.Suspense = u, reactIs_production_min$1.SuspenseList = m, reactIs_production_min$1.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min$1.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min$1.isContextConsumer = function(R) {
    return z(R) === l;
  }, reactIs_production_min$1.isContextProvider = function(R) {
    return z(R) === o;
  }, reactIs_production_min$1.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === e;
  }, reactIs_production_min$1.isForwardRef = function(R) {
    return z(R) === d;
  }, reactIs_production_min$1.isFragment = function(R) {
    return z(R) === i;
  }, reactIs_production_min$1.isLazy = function(R) {
    return z(R) === y;
  }, reactIs_production_min$1.isMemo = function(R) {
    return z(R) === A;
  }, reactIs_production_min$1.isPortal = function(R) {
    return z(R) === t;
  }, reactIs_production_min$1.isProfiler = function(R) {
    return z(R) === a;
  }, reactIs_production_min$1.isStrictMode = function(R) {
    return z(R) === n;
  }, reactIs_production_min$1.isSuspense = function(R) {
    return z(R) === u;
  }, reactIs_production_min$1.isSuspenseList = function(R) {
    return z(R) === m;
  }, reactIs_production_min$1.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === i || R === a || R === n || R === u || R === m || R === D || typeof R == "object" && R !== null && (R.$$typeof === y || R.$$typeof === A || R.$$typeof === o || R.$$typeof === l || R.$$typeof === d || R.$$typeof === C || R.getModuleId !== void 0);
  }, reactIs_production_min$1.typeOf = z, reactIs_production_min$1;
}
var reactIs_development$1 = {};
/**
* @license React
* react-is.development.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), A = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), C = !1, z = !1, R = !1, O = !1, $ = !1, k;
    k = Symbol.for("react.module.reference");
    function P(oe) {
      return !!(typeof oe == "string" || typeof oe == "function" || oe === i || oe === a || $ || oe === n || oe === u || oe === m || O || oe === D || C || z || R || typeof oe == "object" && oe !== null && (oe.$$typeof === y || oe.$$typeof === A || oe.$$typeof === o || oe.$$typeof === l || oe.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      oe.$$typeof === k || oe.getModuleId !== void 0));
    }
    function L(oe) {
      if (typeof oe == "object" && oe !== null) {
        var ve = oe.$$typeof;
        switch (ve) {
          case e:
            var Le = oe.type;
            switch (Le) {
              case i:
              case a:
              case n:
              case u:
              case m:
                return Le;
              default:
                var Be = Le && Le.$$typeof;
                switch (Be) {
                  case c:
                  case l:
                  case d:
                  case y:
                  case A:
                  case o:
                    return Be;
                  default:
                    return ve;
                }
            }
          case t:
            return ve;
        }
      }
    }
    var F = l, B = o, G = e, Z = d, X = i, V = y, E = A, T = t, g = a, b = n, x = u, S = m, I = !1, N = !1;
    function p(oe) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function M(oe) {
      return N || (N = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(oe) {
      return L(oe) === l;
    }
    function U(oe) {
      return L(oe) === o;
    }
    function H(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === e;
    }
    function J(oe) {
      return L(oe) === d;
    }
    function te(oe) {
      return L(oe) === i;
    }
    function ae(oe) {
      return L(oe) === y;
    }
    function le(oe) {
      return L(oe) === A;
    }
    function ne(oe) {
      return L(oe) === t;
    }
    function ue(oe) {
      return L(oe) === a;
    }
    function ge(oe) {
      return L(oe) === n;
    }
    function re(oe) {
      return L(oe) === u;
    }
    function fe(oe) {
      return L(oe) === m;
    }
    reactIs_development$1.ContextConsumer = F, reactIs_development$1.ContextProvider = B, reactIs_development$1.Element = G, reactIs_development$1.ForwardRef = Z, reactIs_development$1.Fragment = X, reactIs_development$1.Lazy = V, reactIs_development$1.Memo = E, reactIs_development$1.Portal = T, reactIs_development$1.Profiler = g, reactIs_development$1.StrictMode = b, reactIs_development$1.Suspense = x, reactIs_development$1.SuspenseList = S, reactIs_development$1.isAsyncMode = p, reactIs_development$1.isConcurrentMode = M, reactIs_development$1.isContextConsumer = j, reactIs_development$1.isContextProvider = U, reactIs_development$1.isElement = H, reactIs_development$1.isForwardRef = J, reactIs_development$1.isFragment = te, reactIs_development$1.isLazy = ae, reactIs_development$1.isMemo = le, reactIs_development$1.isPortal = ne, reactIs_development$1.isProfiler = ue, reactIs_development$1.isStrictMode = ge, reactIs_development$1.isSuspense = re, reactIs_development$1.isSuspenseList = fe, reactIs_development$1.isValidElementType = P, reactIs_development$1.typeOf = L;
  }()), reactIs_development$1;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = requireReactIs_production_min$1() : e.exports = requireReactIs_development$1();
})(reactIs$2);
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(e) {
  const t = `${e}`.match(fnNameMatchRegex);
  return t && t[1] || "";
}
function getFunctionComponentName(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return e.displayName || e.name || getFunctionName(e) || t;
}
function getWrappedName(e, t, i) {
  const n = getFunctionComponentName(t);
  return e.displayName || (n !== "" ? `${i}(${n})` : i);
}
function getDisplayName(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return getFunctionComponentName(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case reactIsExports$1.ForwardRef:
          return getWrappedName(e, e.render, "ForwardRef");
        case reactIsExports$1.Memo:
          return getWrappedName(e, e.type, "memo");
        default:
          return;
      }
  }
}
const refType = propTypesExports.oneOfType([propTypesExports.func, propTypesExports.object]), refType$1 = refType;
function capitalize(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function setRef(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const useEnhancedEffect = typeof window < "u" ? React.useLayoutEffect : React.useEffect, useEnhancedEffect$1 = useEnhancedEffect;
function useEventCallback(e) {
  const t = React.useRef(e);
  return useEnhancedEffect$1(() => {
    t.current = e;
  }), React.useCallback(function() {
    return (
      // @ts-expect-error hide `this`
      // tslint:disable-next-line:ban-comma-operator
      (0, t.current)(...arguments)
    );
  }, []);
}
function useForkRef() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return React.useMemo(() => t.every((n) => n == null) ? null : (n) => {
    t.forEach((a) => {
      setRef(a, n);
    });
  }, t);
}
let hadKeyboardEvent = !0, hadFocusVisibleRecently = !1, hadFocusVisibleRecentlyTimeout;
const inputTypesWhitelist = { text: !0, search: !0, url: !0, tel: !0, email: !0, password: !0, number: !0, date: !0, month: !0, week: !0, time: !0, datetime: !0, "datetime-local": !0 };
function focusTriggersKeyboardModality(e) {
  const { type: t, tagName: i } = e;
  return !!(i === "INPUT" && inputTypesWhitelist[t] && !e.readOnly || i === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function handleKeyDown(e) {
  e.metaKey || e.altKey || e.ctrlKey || (hadKeyboardEvent = !0);
}
function handlePointerDown() {
  hadKeyboardEvent = !1;
}
function handleVisibilityChange() {
  this.visibilityState === "hidden" && hadFocusVisibleRecently && (hadKeyboardEvent = !0);
}
function prepare(e) {
  e.addEventListener("keydown", handleKeyDown, !0), e.addEventListener("mousedown", handlePointerDown, !0), e.addEventListener("pointerdown", handlePointerDown, !0), e.addEventListener("touchstart", handlePointerDown, !0), e.addEventListener("visibilitychange", handleVisibilityChange, !0);
}
function isFocusVisible(e) {
  const { target: t } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(t);
}
function useIsFocusVisible() {
  const e = React.useCallback((a) => {
    a != null && prepare(a.ownerDocument);
  }, []), t = React.useRef(!1);
  function i() {
    return t.current ? (hadFocusVisibleRecently = !0, window.clearTimeout(hadFocusVisibleRecentlyTimeout), hadFocusVisibleRecentlyTimeout = window.setTimeout(() => {
      hadFocusVisibleRecently = !1;
    }, 100), t.current = !1, !0) : !1;
  }
  function n(a) {
    return isFocusVisible(a) ? (t.current = !0, !0) : !1;
  }
  return { isFocusVisibleRef: t, onFocus: n, onBlur: i, ref: e };
}
function resolveProps(e, t) {
  const i = _extends({}, t);
  return Object.keys(e).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      i[n] = _extends({}, e[n], i[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const a = e[n] || {}, o = t[n];
      i[n] = {}, !o || !Object.keys(o) ? i[n] = a : !a || !Object.keys(a) ? i[n] = o : (i[n] = _extends({}, o), Object.keys(a).forEach((l) => {
        i[n][l] = resolveProps(a[l], o[l]);
      }));
    } else
      i[n] === void 0 && (i[n] = e[n]);
  }), i;
}
function composeClasses(e, t) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
  const n = {};
  return Object.keys(e).forEach(
    // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (a) => {
      n[a] = e[a].reduce((o, l) => {
        if (l) {
          const c = t(l);
          c !== "" && o.push(c), i && i[l] && o.push(i[l]);
        }
        return o;
      }, []).join(" ");
    }
  ), n;
}
const defaultGenerator = (e) => e, createClassNameGenerator = () => {
  let e = defaultGenerator;
  return { configure(t) {
    e = t;
  }, generate(t) {
    return e(t);
  }, reset() {
    e = defaultGenerator;
  } };
}, ClassNameGenerator = createClassNameGenerator(), ClassNameGenerator$1 = ClassNameGenerator, globalStateClassesMapping = { active: "active", checked: "checked", completed: "completed", disabled: "disabled", readOnly: "readOnly", error: "error", expanded: "expanded", focused: "focused", focusVisible: "focusVisible", required: "required", selected: "selected" };
function generateUtilityClass(e, t) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Mui";
  const n = globalStateClassesMapping[t];
  return n ? `${i}-${n}` : `${ClassNameGenerator$1.generate(e)}-${t}`;
}
function generateUtilityClasses(e, t) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Mui";
  const n = {};
  return t.forEach((a) => {
    n[a] = generateUtilityClass(e, a, i);
  }), n;
}
function memoize$3(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(i) {
    return t[i] === void 0 && (t[i] = e(i)), t[i];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$3(
  function(e) {
    return reactPropsRegex.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function sheetForTag(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function createStyleElement(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var StyleSheet = /* @__PURE__ */ function() {
  function e(i) {
    var n = this;
    this._insertTag = function(a) {
      var o;
      n.tags.length === 0 ? n.insertionPoint ? o = n.insertionPoint.nextSibling : n.prepend ? o = n.container.firstChild : o = n.before : o = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, o), n.tags.push(a);
    }, this.isSpeedy = i.speedy === void 0 ? process.env.NODE_ENV === "production" : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var a = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var o = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      o && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !o;
    }
    if (this.isSpeedy) {
      var l = sheetForTag(a);
      try {
        l.insertRule(n, l.cssRules.length);
      } catch (c) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', c);
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT$1 = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", abs = Math.abs, from = String.fromCharCode, assign = Object.assign;
function hash$3(e, t) {
  return charat(e, 0) ^ 45 ? (((t << 2 ^ charat(e, 0)) << 2 ^ charat(e, 1)) << 2 ^ charat(e, 2)) << 2 ^ charat(e, 3) : 0;
}
function trim(e) {
  return e.trim();
}
function match(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function replace(e, t, i) {
  return e.replace(t, i);
}
function indexof(e, t) {
  return e.indexOf(t);
}
function charat(e, t) {
  return e.charCodeAt(t) | 0;
}
function substr(e, t, i) {
  return e.slice(t, i);
}
function strlen(e) {
  return e.length;
}
function sizeof(e) {
  return e.length;
}
function append(e, t) {
  return t.push(e), e;
}
function combine(e, t) {
  return e.map(t).join("");
}
var line = 1, column = 1, length = 0, position = 0, character = 0, characters = "";
function node(e, t, i, n, a, o, l) {
  return { value: e, root: t, parent: i, type: n, props: a, children: o, line, column, length: l, return: "" };
}
function copy(e, t) {
  return assign(node("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(e, t) {
  return substr(characters, e, t);
}
function token(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(e) {
  return line = column = 1, length = strlen(characters = e), position = 0, [];
}
function dealloc(e) {
  return characters = "", e;
}
function delimit(e) {
  return trim(slice(position - 1, delimiter(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function whitespace(e) {
  for (; (character = peek()) && character < 33; )
    next();
  return token(e) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(e, t) {
  for (; --t && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(e, caret() + (t < 6 && peek() == 32 && next() == 32));
}
function delimiter(e) {
  for (; next(); )
    switch (character) {
      case e:
        return position;
      case 34:
      case 39:
        e !== 34 && e !== 39 && delimiter(character);
        break;
      case 40:
        e === 41 && delimiter(e);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(e, t) {
  for (; next() && e + character !== 47 + 10; )
    if (e + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(t, position - 1) + "*" + from(e === 47 ? e : next());
}
function identifier(e) {
  for (; !token(peek()); )
    next();
  return slice(e, position);
}
function compile(e) {
  return dealloc(parse("", null, null, null, [""], e = alloc(e), 0, [0], e));
}
function parse(e, t, i, n, a, o, l, c, d) {
  for (var u = 0, m = 0, A = l, y = 0, D = 0, C = 0, z = 1, R = 1, O = 1, $ = 0, k = "", P = a, L = o, F = n, B = k; R; )
    switch (C = $, $ = next()) {
      case 40:
        if (C != 108 && charat(B, A - 1) == 58) {
          indexof(B += replace(delimit($), "&", "&\f"), "&\f") != -1 && (O = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        B += delimit($);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        B += whitespace(C);
        break;
      case 92:
        B += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), t, i), d);
            break;
          default:
            B += "/";
        }
        break;
      case 123 * z:
        c[u++] = strlen(B) * O;
      case 125 * z:
      case 59:
      case 0:
        switch ($) {
          case 0:
          case 125:
            R = 0;
          case 59 + m:
            D > 0 && strlen(B) - A && append(D > 32 ? declaration(B + ";", n, i, A - 1) : declaration(replace(B, " ", "") + ";", n, i, A - 2), d);
            break;
          case 59:
            B += ";";
          default:
            if (append(F = ruleset(B, t, i, u, m, a, c, k, P = [], L = [], A), o), $ === 123)
              if (m === 0)
                parse(B, t, F, F, P, o, A, c, L);
              else
                switch (y === 99 && charat(B, 3) === 110 ? 100 : y) {
                  case 100:
                  case 109:
                  case 115:
                    parse(e, F, F, n && append(ruleset(e, F, F, 0, 0, a, c, k, a, P = [], A), L), a, L, A, c, n ? P : L);
                    break;
                  default:
                    parse(B, F, F, F, [""], L, 0, c, L);
                }
        }
        u = m = D = 0, z = O = 1, k = B = "", A = l;
        break;
      case 58:
        A = 1 + strlen(B), D = C;
      default:
        if (z < 1) {
          if ($ == 123)
            --z;
          else if ($ == 125 && z++ == 0 && prev() == 125)
            continue;
        }
        switch (B += from($), $ * z) {
          case 38:
            O = m > 0 ? 1 : (B += "\f", -1);
            break;
          case 44:
            c[u++] = (strlen(B) - 1) * O, O = 1;
            break;
          case 64:
            peek() === 45 && (B += delimit(next())), y = peek(), m = A = strlen(k = B += identifier(caret())), $++;
            break;
          case 45:
            C === 45 && strlen(B) == 2 && (z = 0);
        }
    }
  return o;
}
function ruleset(e, t, i, n, a, o, l, c, d, u, m) {
  for (var A = a - 1, y = a === 0 ? o : [""], D = sizeof(y), C = 0, z = 0, R = 0; C < n; ++C)
    for (var O = 0, $ = substr(e, A + 1, A = abs(z = l[C])), k = e; O < D; ++O)
      (k = trim(z > 0 ? y[O] + " " + $ : replace($, /&\f/g, y[O]))) && (d[R++] = k);
  return node(e, t, i, a === 0 ? RULESET : c, d, u, m);
}
function comment(e, t, i) {
  return node(e, t, i, COMMENT$1, from(char()), substr(e, 2, -2), 0);
}
function declaration(e, t, i, n) {
  return node(e, t, i, DECLARATION, substr(e, 0, n), substr(e, n + 1, -1), n);
}
function serialize(e, t) {
  for (var i = "", n = sizeof(e), a = 0; a < n; a++)
    i += t(e[a], a, e, t) || "";
  return i;
}
function stringify(e, t, i, n) {
  switch (e.type) {
    case IMPORT:
    case DECLARATION:
      return e.return = e.return || e.value;
    case COMMENT$1:
      return "";
    case KEYFRAMES:
      return e.return = e.value + "{" + serialize(e.children, n) + "}";
    case RULESET:
      e.value = e.props.join(",");
  }
  return strlen(i = serialize(e.children, n)) ? e.return = e.value + "{" + i + "}" : "";
}
function middleware(e) {
  var t = sizeof(e);
  return function(i, n, a, o) {
    for (var l = "", c = 0; c < t; c++)
      l += e[c](i, n, a, o) || "";
    return l;
  };
}
function rulesheet(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var identifierWithPointTracking = function(t, i, n) {
  for (var a = 0, o = 0; a = o, o = peek(), a === 38 && o === 12 && (i[n] = 1), !token(o); )
    next();
  return slice(t, position);
}, toRules = function(t, i) {
  var n = -1, a = 44;
  do
    switch (token(a)) {
      case 0:
        a === 38 && peek() === 12 && (i[n] = 1), t[n] += identifierWithPointTracking(position - 1, i, n);
        break;
      case 2:
        t[n] += delimit(a);
        break;
      case 4:
        if (a === 44) {
          t[++n] = peek() === 58 ? "&\f" : "", i[n] = t[n].length;
          break;
        }
      default:
        t[n] += from(a);
    }
  while (a = next());
  return t;
}, getRules = function(t, i) {
  return dealloc(toRules(alloc(t), i));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var i = t.value, n = t.parent, a = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(t.props.length === 1 && i.charCodeAt(0) !== 58 && !fixedElements.get(n)) && !a) {
      fixedElements.set(t, !0);
      for (var o = [], l = getRules(i, o), c = n.props, d = 0, u = 0; d < l.length; d++)
        for (var m = 0; m < c.length; m++, u++)
          t.props[u] = o[d] ? l[d].replace(/&\f/g, c[m]) : c[m] + " " + l[d];
    }
  }
}, removeLabel = function(t) {
  if (t.type === "decl") {
    var i = t.value;
    // charcode for l
    i.charCodeAt(0) === 108 && // charcode for b
    i.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", isIgnoringComment = function(t) {
  return t.type === "comm" && t.children.indexOf(ignoreFlag) > -1;
}, createUnsafeSelectorsAlarm = function(t) {
  return function(i, n, a) {
    if (!(i.type !== "rule" || t.compat)) {
      var o = i.value.match(/(:first|:nth|:nth-last)-child/g);
      if (o) {
        for (var l = !!i.parent, c = l ? i.parent.children : (
          // global rule at the root level
          a
        ), d = c.length - 1; d >= 0; d--) {
          var u = c[d];
          if (u.line < i.line)
            break;
          if (u.column < i.column) {
            if (isIgnoringComment(u))
              return;
            break;
          }
        }
        o.forEach(function(m) {
          console.error('The pseudo class "' + m + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + m.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, isImportRule = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, isPrependedWithRegularRules = function(t, i) {
  for (var n = t - 1; n >= 0; n--)
    if (!isImportRule(i[n]))
      return !0;
  return !1;
}, nullifyElement = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, incorrectImportAlarm = function(t, i, n) {
  isImportRule(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), nullifyElement(t)) : isPrependedWithRegularRules(i, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), nullifyElement(t)));
};
function prefix(e, t) {
  switch (hash$3(e, t)) {
    case 5103:
      return WEBKIT + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + e + MOZ + e + MS + e + e;
    case 6828:
    case 4268:
      return WEBKIT + e + MS + e + e;
    case 6165:
      return WEBKIT + e + MS + "flex-" + e + e;
    case 5187:
      return WEBKIT + e + replace(e, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + e;
    case 5443:
      return WEBKIT + e + MS + "flex-item-" + replace(e, /flex-|-self/, "") + e;
    case 4675:
      return WEBKIT + e + MS + "flex-line-pack" + replace(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return WEBKIT + e + MS + replace(e, "shrink", "negative") + e;
    case 5292:
      return WEBKIT + e + MS + replace(e, "basis", "preferred-size") + e;
    case 6060:
      return WEBKIT + "box-" + replace(e, "-grow", "") + WEBKIT + e + MS + replace(e, "grow", "positive") + e;
    case 4554:
      return WEBKIT + replace(e, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + e;
    case 6187:
      return replace(replace(replace(e, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return replace(e, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(e, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(e, /(.+)-inline(.+)/, WEBKIT + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(e) - 1 - t > 6)
        switch (charat(e, t + 1)) {
          case 109:
            if (charat(e, t + 4) !== 45)
              break;
          case 102:
            return replace(e, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~indexof(e, "stretch") ? prefix(replace(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (charat(e, t + 1) !== 115)
        break;
    case 6444:
      switch (charat(e, strlen(e) - 3 - (~indexof(e, "!important") && 10))) {
        case 107:
          return replace(e, ":", ":" + WEBKIT) + e;
        case 101:
          return replace(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(e, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (charat(e, t + 11)) {
        case 114:
          return WEBKIT + e + MS + replace(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return WEBKIT + e + MS + replace(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return WEBKIT + e + MS + replace(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return WEBKIT + e + MS + e + e;
  }
  return e;
}
var prefixer = function(t, i, n, a) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case DECLARATION:
        t.return = prefix(t.value, t.length);
        break;
      case KEYFRAMES:
        return serialize([copy(t, { value: replace(t.value, "@", "@" + WEBKIT) })], a);
      case RULESET:
        if (t.length)
          return combine(t.props, function(o) {
            switch (match(o, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return serialize([copy(t, { props: [replace(o, /:(read-\w+)/, ":" + MOZ + "$1")] })], a);
              case "::placeholder":
                return serialize([copy(t, { props: [replace(o, /:(plac\w+)/, ":" + WEBKIT + "input-$1")] }), copy(t, { props: [replace(o, /:(plac\w+)/, ":" + MOZ + "$1")] }), copy(t, { props: [replace(o, /:(plac\w+)/, MS + "input-$1")] })], a);
            }
            return "";
          });
    }
}, defaultStylisPlugins = [prefixer], createCache = function(t) {
  var i = t.key;
  if (process.env.NODE_ENV !== "production" && !i)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (i === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(z) {
      var R = z.getAttribute("data-emotion");
      R.indexOf(" ") !== -1 && (document.head.appendChild(z), z.setAttribute("data-s", ""));
    });
  }
  var a = t.stylisPlugins || defaultStylisPlugins;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(i))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + i + '" was passed');
  var o = {}, l, c = [];
  l = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + i + ' "]'),
    function(z) {
      for (var R = z.getAttribute("data-emotion").split(" "), O = 1; O < R.length; O++)
        o[R[O]] = !0;
      c.push(z);
    }
  );
  var d, u = [compat, removeLabel];
  process.env.NODE_ENV !== "production" && u.push(createUnsafeSelectorsAlarm({ get compat() {
    return C.compat;
  } }), incorrectImportAlarm);
  {
    var m, A = [stringify, process.env.NODE_ENV !== "production" ? function(z) {
      z.root || (z.return ? m.insert(z.return) : z.value && z.type !== COMMENT$1 && m.insert(z.value + "{}"));
    } : rulesheet(function(z) {
      m.insert(z);
    })], y = middleware(u.concat(a, A)), D = function(R) {
      return serialize(compile(R), y);
    };
    d = function(R, O, $, k) {
      m = $, process.env.NODE_ENV !== "production" && O.map !== void 0 && (m = { insert: function(L) {
        $.insert(L + O.map);
      } }), D(R ? R + "{" + O.styles + "}" : O.styles), k && (C.inserted[O.name] = !0);
    };
  }
  var C = { key: i, sheet: new StyleSheet({ key: i, container: l, nonce: t.nonce, speedy: t.speedy, prepend: t.prepend, insertionPoint: t.insertionPoint }), nonce: t.nonce, inserted: o, registered: {}, insert: d };
  return C.sheet.hydrate(c), C;
}, reactIsExports = {}, reactIs$1 = { get exports() {
  return reactIsExports;
}, set exports(e) {
  reactIsExports = e;
} }, reactIs_production_min = {};
/** @license React v16.13.1
* react-is.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, z = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function k(L) {
    if (typeof L == "object" && L !== null) {
      var F = L.$$typeof;
      switch (F) {
        case t:
          switch (L = L.type, L) {
            case d:
            case u:
            case n:
            case o:
            case a:
            case A:
              return L;
            default:
              switch (L = L && L.$$typeof, L) {
                case c:
                case m:
                case C:
                case D:
                case l:
                  return L;
                default:
                  return F;
              }
          }
        case i:
          return F;
      }
    }
  }
  function P(L) {
    return k(L) === u;
  }
  return reactIs_production_min.AsyncMode = d, reactIs_production_min.ConcurrentMode = u, reactIs_production_min.ContextConsumer = c, reactIs_production_min.ContextProvider = l, reactIs_production_min.Element = t, reactIs_production_min.ForwardRef = m, reactIs_production_min.Fragment = n, reactIs_production_min.Lazy = C, reactIs_production_min.Memo = D, reactIs_production_min.Portal = i, reactIs_production_min.Profiler = o, reactIs_production_min.StrictMode = a, reactIs_production_min.Suspense = A, reactIs_production_min.isAsyncMode = function(L) {
    return P(L) || k(L) === d;
  }, reactIs_production_min.isConcurrentMode = P, reactIs_production_min.isContextConsumer = function(L) {
    return k(L) === c;
  }, reactIs_production_min.isContextProvider = function(L) {
    return k(L) === l;
  }, reactIs_production_min.isElement = function(L) {
    return typeof L == "object" && L !== null && L.$$typeof === t;
  }, reactIs_production_min.isForwardRef = function(L) {
    return k(L) === m;
  }, reactIs_production_min.isFragment = function(L) {
    return k(L) === n;
  }, reactIs_production_min.isLazy = function(L) {
    return k(L) === C;
  }, reactIs_production_min.isMemo = function(L) {
    return k(L) === D;
  }, reactIs_production_min.isPortal = function(L) {
    return k(L) === i;
  }, reactIs_production_min.isProfiler = function(L) {
    return k(L) === o;
  }, reactIs_production_min.isStrictMode = function(L) {
    return k(L) === a;
  }, reactIs_production_min.isSuspense = function(L) {
    return k(L) === A;
  }, reactIs_production_min.isValidElementType = function(L) {
    return typeof L == "string" || typeof L == "function" || L === n || L === u || L === o || L === a || L === A || L === y || typeof L == "object" && L !== null && (L.$$typeof === C || L.$$typeof === D || L.$$typeof === l || L.$$typeof === c || L.$$typeof === m || L.$$typeof === R || L.$$typeof === O || L.$$typeof === $ || L.$$typeof === z);
  }, reactIs_production_min.typeOf = k, reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
* react-is.development.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, z = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function k(re) {
      return typeof re == "string" || typeof re == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      re === n || re === u || re === o || re === a || re === A || re === y || typeof re == "object" && re !== null && (re.$$typeof === C || re.$$typeof === D || re.$$typeof === l || re.$$typeof === c || re.$$typeof === m || re.$$typeof === R || re.$$typeof === O || re.$$typeof === $ || re.$$typeof === z);
    }
    function P(re) {
      if (typeof re == "object" && re !== null) {
        var fe = re.$$typeof;
        switch (fe) {
          case t:
            var oe = re.type;
            switch (oe) {
              case d:
              case u:
              case n:
              case o:
              case a:
              case A:
                return oe;
              default:
                var ve = oe && oe.$$typeof;
                switch (ve) {
                  case c:
                  case m:
                  case C:
                  case D:
                  case l:
                    return ve;
                  default:
                    return fe;
                }
            }
          case i:
            return fe;
        }
      }
    }
    var L = d, F = u, B = c, G = l, Z = t, X = m, V = n, E = C, T = D, g = i, b = o, x = a, S = A, I = !1;
    function N(re) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), p(re) || P(re) === d;
    }
    function p(re) {
      return P(re) === u;
    }
    function M(re) {
      return P(re) === c;
    }
    function j(re) {
      return P(re) === l;
    }
    function U(re) {
      return typeof re == "object" && re !== null && re.$$typeof === t;
    }
    function H(re) {
      return P(re) === m;
    }
    function J(re) {
      return P(re) === n;
    }
    function te(re) {
      return P(re) === C;
    }
    function ae(re) {
      return P(re) === D;
    }
    function le(re) {
      return P(re) === i;
    }
    function ne(re) {
      return P(re) === o;
    }
    function ue(re) {
      return P(re) === a;
    }
    function ge(re) {
      return P(re) === A;
    }
    reactIs_development.AsyncMode = L, reactIs_development.ConcurrentMode = F, reactIs_development.ContextConsumer = B, reactIs_development.ContextProvider = G, reactIs_development.Element = Z, reactIs_development.ForwardRef = X, reactIs_development.Fragment = V, reactIs_development.Lazy = E, reactIs_development.Memo = T, reactIs_development.Portal = g, reactIs_development.Profiler = b, reactIs_development.StrictMode = x, reactIs_development.Suspense = S, reactIs_development.isAsyncMode = N, reactIs_development.isConcurrentMode = p, reactIs_development.isContextConsumer = M, reactIs_development.isContextProvider = j, reactIs_development.isElement = U, reactIs_development.isForwardRef = H, reactIs_development.isFragment = J, reactIs_development.isLazy = te, reactIs_development.isMemo = ae, reactIs_development.isPortal = le, reactIs_development.isProfiler = ne, reactIs_development.isStrictMode = ue, reactIs_development.isSuspense = ge, reactIs_development.isValidElementType = k, reactIs_development.typeOf = P;
  }()), reactIs_development;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = requireReactIs_production_min() : e.exports = requireReactIs_development();
})(reactIs$1);
var reactIs = reactIsExports, FORWARD_REF_STATICS = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, MEMO_STATICS = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser$1 = !0;
function getRegisteredStyles(e, t, i) {
  var n = "";
  return i.split(" ").forEach(function(a) {
    e[a] !== void 0 ? t.push(e[a] + ";") : n += a + " ";
  }), n;
}
var registerStyles = function(t, i, n) {
  var a = t.key + "-" + i.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === !1) && t.registered[a] === void 0 && (t.registered[a] = i.styles);
}, insertStyles = function(t, i, n) {
  registerStyles(t, i, n);
  var a = t.key + "-" + i.name;
  if (t.inserted[i.name] === void 0) {
    var o = i;
    do
      t.insert(i === o ? "." + a : "", o, t.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function murmur2(e) {
  for (var t = 0, i, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    i = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, i = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16), i ^= /* k >>> r: */
    i >>> 24, t = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(t) {
  return t.charCodeAt(1) === 45;
}, isProcessableValue = function(t) {
  return t != null && typeof t != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$3(function(e) {
  return isCustomProperty(e) ? e : e.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(t, i) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof i == "string")
        return i.replace(animationRegex, function(n, a, o) {
          return cursor = { name: a, styles: o, next: cursor }, a;
        });
  }
  return unitlessKeys[t] !== 1 && !isCustomProperty(t) && typeof i == "number" && i !== 0 ? i + "px" : i;
};
if (process.env.NODE_ENV !== "production") {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, contentValues = ["normal", "none", "initial", "inherit", "unset"], oldProcessStyleValue = processStyleValue, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, hyphenatedCache = {};
  processStyleValue = function(t, i) {
    if (t === "content" && (typeof i != "string" || contentValues.indexOf(i) === -1 && !contentValuePattern.test(i) && (i.charAt(0) !== i.charAt(i.length - 1) || i.charAt(0) !== '"' && i.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + i + "\"'`");
    var n = oldProcessStyleValue(t, i);
    return n !== "" && !isCustomProperty(t) && t.indexOf("-") !== -1 && hyphenatedCache[t] === void 0 && (hyphenatedCache[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(msPattern, "ms-").replace(hyphenPattern, function(a, o) {
      return o.toUpperCase();
    }) + "?")), n;
  };
}
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(e, t, i) {
  if (i == null)
    return "";
  if (i.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && i.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(noComponentSelectorMessage);
    return i;
  }
  switch (typeof i) {
    case "boolean":
      return "";
    case "object": {
      if (i.anim === 1)
        return cursor = { name: i.name, styles: i.styles, next: cursor }, i.name;
      if (i.styles !== void 0) {
        var n = i.next;
        if (n !== void 0)
          for (; n !== void 0; )
            cursor = { name: n.name, styles: n.styles, next: cursor }, n = n.next;
        var a = i.styles + ";";
        return process.env.NODE_ENV !== "production" && i.map !== void 0 && (a += i.map), a;
      }
      return createStringFromObject(e, t, i);
    }
    case "function": {
      if (e !== void 0) {
        var o = cursor, l = i(e);
        return cursor = o, handleInterpolation(e, t, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var c = [], d = i.replace(animationRegex, function(m, A, y) {
          var D = "animation" + c.length;
          return c.push("const " + D + " = keyframes`" + y.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + D + "}";
        });
        c.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(c, ["`" + d + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + d + "`"));
      }
      break;
  }
  if (t == null)
    return i;
  var u = t[i];
  return u !== void 0 ? u : i;
}
function createStringFromObject(e, t, i) {
  var n = "";
  if (Array.isArray(i))
    for (var a = 0; a < i.length; a++)
      n += handleInterpolation(e, t, i[a]) + ";";
  else
    for (var o in i) {
      var l = i[o];
      if (typeof l != "object")
        t != null && t[l] !== void 0 ? n += o + "{" + t[l] + "}" : isProcessableValue(l) && (n += processStyleName(o) + ":" + processStyleValue(o, l) + ";");
      else {
        if (o === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(noComponentSelectorMessage);
        if (Array.isArray(l) && typeof l[0] == "string" && (t == null || t[l[0]] === void 0))
          for (var c = 0; c < l.length; c++)
            isProcessableValue(l[c]) && (n += processStyleName(o) + ":" + processStyleValue(o, l[c]) + ";");
        else {
          var d = handleInterpolation(e, t, l);
          switch (o) {
            case "animation":
            case "animationName": {
              n += processStyleName(o) + ":" + d + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && o === "undefined" && console.error(UNDEFINED_AS_OBJECT_KEY_ERROR), n += o + "{" + d + "}";
          }
        }
      }
    }
  return n;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g, sourceMapPattern;
process.env.NODE_ENV !== "production" && (sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var cursor, serializeStyles = function(t, i, n) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var a = !0, o = "";
  cursor = void 0;
  var l = t[0];
  l == null || l.raw === void 0 ? (a = !1, o += handleInterpolation(n, i, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1), o += l[0]);
  for (var c = 1; c < t.length; c++)
    o += handleInterpolation(n, i, t[c]), a && (process.env.NODE_ENV !== "production" && l[c] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1), o += l[c]);
  var d;
  process.env.NODE_ENV !== "production" && (o = o.replace(sourceMapPattern, function(y) {
    return d = y, "";
  })), labelPattern.lastIndex = 0;
  for (var u = "", m; (m = labelPattern.exec(o)) !== null; )
    u += "-" + // $FlowFixMe we know it's not null
    m[1];
  var A = murmur2(o) + u;
  return process.env.NODE_ENV !== "production" ? { name: A, styles: o, map: d, next: cursor, toString: function() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  } } : { name: A, styles: o, next: cursor };
}, syncFallback = function(t) {
  return t();
}, useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || useLayoutEffect, hasOwnProperty$9 = {}.hasOwnProperty, EmotionCacheContext = /* @__PURE__ */ createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({ key: "css" }) : null
);
process.env.NODE_ENV !== "production" && (EmotionCacheContext.displayName = "EmotionCacheContext");
EmotionCacheContext.Provider;
var withEmotionCache = function(t) {
  return /* @__PURE__ */ forwardRef(function(i, n) {
    var a = useContext(EmotionCacheContext);
    return t(i, a, n);
  });
}, ThemeContext = /* @__PURE__ */ createContext({});
process.env.NODE_ENV !== "production" && (ThemeContext.displayName = "EmotionThemeContext");
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Insertion$2 = function(t) {
  var i = t.cache, n = t.serialized, a = t.isStringTag;
  return registerStyles(i, n, a), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(i, n, a);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(e, t, i) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var a = e[typePropName], o = [n], l = "";
  typeof e.className == "string" ? l = getRegisteredStyles(t.registered, o, e.className) : e.className != null && (l = e.className + " ");
  var c = serializeStyles(o, void 0, useContext(ThemeContext));
  if (process.env.NODE_ENV !== "production" && c.name.indexOf("-") === -1) {
    var d = e[labelPropName];
    d && (c = serializeStyles([c, "label:" + d + ";"]));
  }
  l += t.key + "-" + c.name;
  var u = {};
  for (var m in e)
    hasOwnProperty$9.call(e, m) && m !== "css" && m !== typePropName && (process.env.NODE_ENV === "production" || m !== labelPropName) && (u[m] = e[m]);
  return u.ref = i, u.className = l, /* @__PURE__ */ createElement(Fragment$1, null, /* @__PURE__ */ createElement(Insertion$2, { cache: t, serialized: c, isStringTag: typeof a == "string" }), /* @__PURE__ */ createElement(a, u));
});
process.env.NODE_ENV !== "production" && (Emotion.displayName = "EmotionCssPropInternal");
var pkg = { name: "@emotion/react", version: "11.10.6", main: "dist/emotion-react.cjs.js", module: "dist/emotion-react.esm.js", browser: { "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js" }, exports: { ".": { module: { worker: "./dist/emotion-react.worker.esm.js", browser: "./dist/emotion-react.browser.esm.js", default: "./dist/emotion-react.esm.js" }, default: "./dist/emotion-react.cjs.js" }, "./jsx-runtime": { module: { worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js", browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js", default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js" }, default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js" }, "./_isolated-hnrs": { module: { worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js", browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js", default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js" }, default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js" }, "./jsx-dev-runtime": { module: { worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js", browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js", default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js" }, default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js" }, "./package.json": "./package.json", "./types/css-prop": "./types/css-prop.d.ts", "./macro": "./macro.js" }, types: "types/index.d.ts", files: ["src", "dist", "jsx-runtime", "jsx-dev-runtime", "_isolated-hnrs", "types/*.d.ts", "macro.js", "macro.d.ts", "macro.js.flow"], sideEffects: !1, author: "Emotion Contributors", license: "MIT", scripts: { "test:typescript": "dtslint types" }, dependencies: { "@babel/runtime": "^7.18.3", "@emotion/babel-plugin": "^11.10.6", "@emotion/cache": "^11.10.5", "@emotion/serialize": "^1.1.1", "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0", "@emotion/utils": "^1.2.0", "@emotion/weak-memoize": "^0.3.0", "hoist-non-react-statics": "^3.3.1" }, peerDependencies: { react: ">=16.8.0" }, peerDependenciesMeta: { "@types/react": { optional: !0 } }, devDependencies: { "@definitelytyped/dtslint": "0.0.112", "@emotion/css": "11.10.6", "@emotion/css-prettifier": "1.1.1", "@emotion/server": "11.10.0", "@emotion/styled": "11.10.6", "html-tag-names": "^1.1.2", react: "16.14.0", "svg-tag-names": "^1.1.1", typescript: "^4.5.5" }, repository: "https://github.com/emotion-js/emotion/tree/main/packages/react", publishConfig: { access: "public" }, "umd:main": "dist/emotion-react.umd.min.js", preconstruct: { entrypoints: ["./index.js", "./jsx-runtime.js", "./jsx-dev-runtime.js", "./_isolated-hnrs.js"], umdName: "emotionReact", exports: { envConditions: ["browser", "worker"], extra: { "./types/css-prop": "./types/css-prop.d.ts", "./macro": "./macro.js" } } } }, warnedAboutCssPropForGlobal = !1, Global = /* @__PURE__ */ withEmotionCache(function(e, t) {
  process.env.NODE_ENV !== "production" && !warnedAboutCssPropForGlobal && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), warnedAboutCssPropForGlobal = !0);
  var i = e.styles, n = serializeStyles([i], void 0, useContext(ThemeContext)), a = useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var o = t.key + "-global", l = new t.sheet.constructor({ key: o, nonce: t.sheet.nonce, container: t.sheet.container, speedy: t.sheet.isSpeedy }), c = !1, d = document.querySelector('style[data-emotion="' + o + " " + n.name + '"]');
    return t.sheet.tags.length && (l.before = t.sheet.tags[0]), d !== null && (c = !0, d.setAttribute("data-emotion", o), l.hydrate([d])), a.current = [l, c], function() {
      l.flush();
    };
  }, [t]), useInsertionEffectWithLayoutFallback(function() {
    var o = a.current, l = o[0], c = o[1];
    if (c) {
      o[1] = !1;
      return;
    }
    if (n.next !== void 0 && insertStyles(t, n.next, !0), l.tags.length) {
      var d = l.tags[l.tags.length - 1].nextElementSibling;
      l.before = d, l.flush();
    }
    t.insert("", n, l, !1);
  }, [t, n.name]), null;
});
process.env.NODE_ENV !== "production" && (Global.displayName = "EmotionGlobal");
function css() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return serializeStyles(t);
}
var keyframes = function() {
  var t = css.apply(void 0, arguments), i = "animation-" + t.name;
  return { name: i, styles: "@keyframes " + i + "{" + t.styles + "}", anim: 1, toString: function() {
    return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
  } };
}, classnames = function e(t) {
  for (var i = t.length, n = 0, a = ""; n < i; n++) {
    var o = t[n];
    if (o != null) {
      var l = void 0;
      switch (typeof o) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(o))
            l = e(o);
          else {
            process.env.NODE_ENV !== "production" && o.styles !== void 0 && o.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), l = "";
            for (var c in o)
              o[c] && c && (l && (l += " "), l += c);
          }
          break;
        }
        default:
          l = o;
      }
      l && (a && (a += " "), a += l);
    }
  }
  return a;
};
function merge$1(e, t, i) {
  var n = [], a = getRegisteredStyles(e, n, i);
  return n.length < 2 ? i : a + t(n);
}
var Insertion$1 = function(t) {
  var i = t.cache, n = t.serializedArr;
  return useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var a = 0; a < n.length; a++)
      insertStyles(i, n[a], !1);
  }), null;
}, ClassNames = /* @__PURE__ */ withEmotionCache(function(e, t) {
  var i = !1, n = [], a = function() {
    if (i && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var u = arguments.length, m = new Array(u), A = 0; A < u; A++)
      m[A] = arguments[A];
    var y = serializeStyles(m, t.registered);
    return n.push(y), registerStyles(t, y, !1), t.key + "-" + y.name;
  }, o = function() {
    if (i && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var u = arguments.length, m = new Array(u), A = 0; A < u; A++)
      m[A] = arguments[A];
    return merge$1(t.registered, a, classnames(m));
  }, l = { css: a, cx: o, theme: useContext(ThemeContext) }, c = e.children(l);
  return i = !0, /* @__PURE__ */ createElement(Fragment$1, null, /* @__PURE__ */ createElement(Insertion$1, { cache: t, serializedArr: n }), c);
});
process.env.NODE_ENV !== "production" && (ClassNames.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var isBrowser = !0, isTestEnv = typeof jest < "u" || typeof vi < "u";
  if (isBrowser && !isTestEnv) {
    var globalContext = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : isBrowser ? window : global
    ), globalKey = "__EMOTION_REACT_" + pkg.version.split(".")[0] + "__";
    globalContext[globalKey] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), globalContext[globalKey] = !0;
  }
}
var testOmitPropsOnStringTag = isPropValid, testOmitPropsOnComponent = function(t) {
  return t !== "theme";
}, getDefaultShouldForwardProp = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function(t, i, n) {
  var a;
  if (i) {
    var o = i.shouldForwardProp;
    a = t.__emotion_forwardProp && o ? function(l) {
      return t.__emotion_forwardProp(l) && o(l);
    } : o;
  }
  return typeof a != "function" && n && (a = t.__emotion_forwardProp), a;
}, ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Insertion = function(t) {
  var i = t.cache, n = t.serialized, a = t.isStringTag;
  return registerStyles(i, n, a), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(i, n, a);
  }), null;
}, createStyled$1 = function e(t, i) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var n = t.__emotion_real === t, a = n && t.__emotion_base || t, o, l;
  i !== void 0 && (o = i.label, l = i.target);
  var c = composeShouldForwardProps(t, i, n), d = c || getDefaultShouldForwardProp(a), u = !d("as");
  return function() {
    var m = arguments, A = n && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (o !== void 0 && A.push("label:" + o + ";"), m[0] == null || m[0].raw === void 0)
      A.push.apply(A, m);
    else {
      process.env.NODE_ENV !== "production" && m[0][0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), A.push(m[0][0]);
      for (var y = m.length, D = 1; D < y; D++)
        process.env.NODE_ENV !== "production" && m[0][D] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), A.push(m[D], m[0][D]);
    }
    var C = withEmotionCache(function(z, R, O) {
      var $ = u && z.as || a, k = "", P = [], L = z;
      if (z.theme == null) {
        L = {};
        for (var F in z)
          L[F] = z[F];
        L.theme = useContext(ThemeContext);
      }
      typeof z.className == "string" ? k = getRegisteredStyles(R.registered, P, z.className) : z.className != null && (k = z.className + " ");
      var B = serializeStyles(A.concat(P), R.registered, L);
      k += R.key + "-" + B.name, l !== void 0 && (k += " " + l);
      var G = u && c === void 0 ? getDefaultShouldForwardProp($) : d, Z = {};
      for (var X in z)
        u && X === "as" || // $FlowFixMe
        G(X) && (Z[X] = z[X]);
      return Z.className = k, Z.ref = O, /* @__PURE__ */ createElement(Fragment$1, null, /* @__PURE__ */ createElement(Insertion, { cache: R, serialized: B, isStringTag: typeof $ == "string" }), /* @__PURE__ */ createElement($, Z));
    });
    return C.displayName = o !== void 0 ? o : "Styled(" + (typeof a == "string" ? a : a.displayName || a.name || "Component") + ")", C.defaultProps = t.defaultProps, C.__emotion_real = C, C.__emotion_base = a, C.__emotion_styles = A, C.__emotion_forwardProp = c, Object.defineProperty(C, "toString", { value: function() {
      return l === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + l;
    } }), C.withComponent = function(z, R) {
      return e(z, _extends({}, i, R, { shouldForwardProp: composeShouldForwardProps(C, R, !0) })).apply(void 0, A);
    }, C;
  };
};
const createStyled$2 = createStyled$1;
var tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], newStyled = createStyled$2.bind();
tags.forEach(function(e) {
  newStyled[e] = newStyled(e);
});
const emStyled = newStyled;
/**
* @mui/styled-engine v5.12.0
*
* @license MIT
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
function styled$2(e, t) {
  const i = emStyled(e, t);
  return process.env.NODE_ENV !== "production" ? function() {
    const n = typeof e == "string" ? `"${e}"` : "component";
    for (var a = arguments.length, o = new Array(a), l = 0; l < a; l++)
      o[l] = arguments[l];
    return o.length === 0 ? console.error([`MUI: Seems like you called \`styled(${n})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : o.some((c) => c === void 0) && console.error(`MUI: the styled(${n})(...args) API requires all its args to be defined.`), i(...o);
  } : i;
}
const internal_processStyles = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, _excluded$c = ["values", "unit", "step"], sortBreakpointsValues = (e) => {
  const t = Object.keys(e).map((i) => ({ key: i, val: e[i] })) || [];
  return t.sort((i, n) => i.val - n.val), t.reduce((i, n) => _extends({}, i, { [n.key]: n.val }), {});
};
function createBreakpoints(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: i = "px",
    step: n = 5
  } = e, a = _objectWithoutPropertiesLoose$1(e, _excluded$c), o = sortBreakpointsValues(t), l = Object.keys(o);
  function c(y) {
    return `@media (min-width:${typeof t[y] == "number" ? t[y] : y}${i})`;
  }
  function d(y) {
    return `@media (max-width:${(typeof t[y] == "number" ? t[y] : y) - n / 100}${i})`;
  }
  function u(y, D) {
    const C = l.indexOf(D);
    return `@media (min-width:${typeof t[y] == "number" ? t[y] : y}${i}) and (max-width:${(C !== -1 && typeof t[l[C]] == "number" ? t[l[C]] : D) - n / 100}${i})`;
  }
  function m(y) {
    return l.indexOf(y) + 1 < l.length ? u(y, l[l.indexOf(y) + 1]) : c(y);
  }
  function A(y) {
    const D = l.indexOf(y);
    return D === 0 ? c(l[1]) : D === l.length - 1 ? d(l[D]) : u(y, l[l.indexOf(y) + 1]).replace("@media", "@media not all and");
  }
  return _extends({ keys: l, values: o, up: c, down: d, between: u, only: m, not: A, unit: i }, a);
}
const shape = { borderRadius: 4 }, shape$1 = shape, responsivePropType = process.env.NODE_ENV !== "production" ? propTypesExports.oneOfType([propTypesExports.number, propTypesExports.string, propTypesExports.object, propTypesExports.array]) : {}, responsivePropType$1 = responsivePropType;
function merge(e, t) {
  return t ? deepmerge(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${values$1[e]}px)`
};
function handleBreakpoints(e, t, i) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const o = n.breakpoints || defaultBreakpoints;
    return t.reduce((l, c, d) => (l[o.up(o.keys[d])] = i(t[d]), l), {});
  }
  if (typeof t == "object") {
    const o = n.breakpoints || defaultBreakpoints;
    return Object.keys(t).reduce((l, c) => {
      if (Object.keys(o.values || values$1).indexOf(c) !== -1) {
        const d = o.up(c);
        l[d] = i(t[c], c);
      } else {
        const d = c;
        l[d] = t[d];
      }
      return l;
    }, {});
  }
  return i(t);
}
function createEmptyBreakpointObject() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, a) => {
    const o = e.up(a);
    return n[o] = {}, n;
  }, {})) || {};
}
function removeUnusedBreakpoints(e, t) {
  return e.reduce((i, n) => {
    const a = i[n];
    return (!a || Object.keys(a).length === 0) && delete i[n], i;
  }, t);
}
function getPath(e, t) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && i) {
    const n = `vars.${t}`.split(".").reduce((a, o) => a && a[o] ? a[o] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, a) => n && n[a] != null ? n[a] : null, e);
}
function getStyleValue(e, t, i) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : i, a;
  return typeof e == "function" ? a = e(i) : Array.isArray(e) ? a = e[i] || n : a = getPath(e, i) || n, t && (a = t(a, n, e)), a;
}
function style$1(e) {
  const { prop: t, cssProperty: i = e.prop, themeKey: n, transform: a } = e, o = (l) => {
    if (l[t] == null)
      return null;
    const c = l[t], d = l.theme, u = getPath(d, n) || {};
    return handleBreakpoints(l, c, (A) => {
      let y = getStyleValue(u, a, A);
      return A === y && typeof A == "string" && (y = getStyleValue(u, a, `${t}${A === "default" ? "" : capitalize(A)}`, A)), i === !1 ? y : { [i]: y };
    });
  };
  return o.propTypes = process.env.NODE_ENV !== "production" ? { [t]: responsivePropType$1 } : {}, o.filterProps = [t], o;
}
function memoize$2(e) {
  const t = {};
  return (i) => (t[i] === void 0 && (t[i] = e(i)), t[i]);
}
const properties = { m: "margin", p: "padding" }, directions = { t: "Top", r: "Right", b: "Bottom", l: "Left", x: ["Left", "Right"], y: ["Top", "Bottom"] }, aliases = { marginX: "mx", marginY: "my", paddingX: "px", paddingY: "py" }, getCssProperties = memoize$2((e) => {
  if (e.length > 2)
    if (aliases[e])
      e = aliases[e];
    else
      return [e];
  const [t, i] = e.split(""), n = properties[t], a = directions[i] || "";
  return Array.isArray(a) ? a.map((o) => n + o) : [n + a];
}), marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(e, t, i, n) {
  var a;
  const o = (a = getPath(e, t, !1)) != null ? a : i;
  return typeof o == "number" ? (l) => typeof l == "string" ? l : (process.env.NODE_ENV !== "production" && typeof l != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${l}.`), o * l) : Array.isArray(o) ? (l) => typeof l == "string" ? l : (process.env.NODE_ENV !== "production" && (Number.isInteger(l) ? l > o.length - 1 && console.error([`MUI: The value provided (${l}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${l} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), o[l]) : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function createUnarySpacing(e) {
  return createUnaryUnit(e, "spacing", 8, "spacing");
}
function getValue$2(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const i = Math.abs(t), n = e(i);
  return t >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function getStyleFromPropValue(e, t) {
  return (i) => e.reduce((n, a) => (n[a] = getValue$2(t, i), n), {});
}
function resolveCssProperty(e, t, i, n) {
  if (t.indexOf(i) === -1)
    return null;
  const a = getCssProperties(i), o = getStyleFromPropValue(a, n), l = e[i];
  return handleBreakpoints(e, l, o);
}
function style(e, t) {
  const i = createUnarySpacing(e.theme);
  return Object.keys(e).map((n) => resolveCssProperty(e, t, n, i)).reduce(merge, {});
}
function margin(e) {
  return style(e, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((e, t) => (e[t] = responsivePropType$1, e), {}) : {};
margin.filterProps = marginKeys;
function padding(e) {
  return style(e, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((e, t) => (e[t] = responsivePropType$1, e), {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" && spacingKeys.reduce((e, t) => (e[t] = responsivePropType$1, e), {});
function createSpacing() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (e.mui)
    return e;
  const t = createUnarySpacing({ spacing: e }), i = function() {
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return process.env.NODE_ENV !== "production" && (a.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${a.length}`)), (a.length === 0 ? [1] : a).map((c) => {
      const d = t(c);
      return typeof d == "number" ? `${d}px` : d;
    }).join(" ");
  };
  return i.mui = !0, i;
}
function compose() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  const n = t.reduce((o, l) => (l.filterProps.forEach((c) => {
    o[c] = l;
  }), o), {}), a = (o) => Object.keys(o).reduce((l, c) => n[c] ? merge(l, n[c](o)) : l, {});
  return a.propTypes = process.env.NODE_ENV !== "production" ? t.reduce((o, l) => Object.assign(o, l.propTypes), {}) : {}, a.filterProps = t.reduce((o, l) => o.concat(l.filterProps), []), a;
}
function borderTransform(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
const border = style$1({ prop: "border", themeKey: "borders", transform: borderTransform }), borderTop = style$1({ prop: "borderTop", themeKey: "borders", transform: borderTransform }), borderRight = style$1({ prop: "borderRight", themeKey: "borders", transform: borderTransform }), borderBottom = style$1({ prop: "borderBottom", themeKey: "borders", transform: borderTransform }), borderLeft = style$1({ prop: "borderLeft", themeKey: "borders", transform: borderTransform }), borderColor = style$1({ prop: "borderColor", themeKey: "palette" }), borderTopColor = style$1({ prop: "borderTopColor", themeKey: "palette" }), borderRightColor = style$1({ prop: "borderRightColor", themeKey: "palette" }), borderBottomColor = style$1({ prop: "borderBottomColor", themeKey: "palette" }), borderLeftColor = style$1({ prop: "borderLeftColor", themeKey: "palette" }), borderRadius = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = createUnaryUnit(e.theme, "shape.borderRadius", 4, "borderRadius"), i = (n) => ({ borderRadius: getValue$2(t, n) });
    return handleBreakpoints(e, e.borderRadius, i);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? { borderRadius: responsivePropType$1 } : {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
const gap = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = createUnaryUnit(e.theme, "spacing", 8, "gap"), i = (n) => ({ gap: getValue$2(t, n) });
    return handleBreakpoints(e, e.gap, i);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? { gap: responsivePropType$1 } : {};
gap.filterProps = ["gap"];
const columnGap = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = createUnaryUnit(e.theme, "spacing", 8, "columnGap"), i = (n) => ({ columnGap: getValue$2(t, n) });
    return handleBreakpoints(e, e.columnGap, i);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? { columnGap: responsivePropType$1 } : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = createUnaryUnit(e.theme, "spacing", 8, "rowGap"), i = (n) => ({ rowGap: getValue$2(t, n) });
    return handleBreakpoints(e, e.rowGap, i);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? { rowGap: responsivePropType$1 } : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({ prop: "gridColumn" }), gridRow = style$1({ prop: "gridRow" }), gridAutoFlow = style$1({ prop: "gridAutoFlow" }), gridAutoColumns = style$1({ prop: "gridAutoColumns" }), gridAutoRows = style$1({ prop: "gridAutoRows" }), gridTemplateColumns = style$1({ prop: "gridTemplateColumns" }), gridTemplateRows = style$1({ prop: "gridTemplateRows" }), gridTemplateAreas = style$1({ prop: "gridTemplateAreas" }), gridArea = style$1({ prop: "gridArea" });
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(e, t) {
  return t === "grey" ? t : e;
}
const color = style$1({ prop: "color", themeKey: "palette", transform: paletteTransform }), bgcolor = style$1({ prop: "bgcolor", cssProperty: "backgroundColor", themeKey: "palette", transform: paletteTransform }), backgroundColor = style$1({ prop: "backgroundColor", themeKey: "palette", transform: paletteTransform });
compose(color, bgcolor, backgroundColor);
function sizingTransform(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const width = style$1({ prop: "width", transform: sizingTransform }), maxWidth = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (i) => {
      var n, a, o;
      return { maxWidth: ((n = e.theme) == null || (a = n.breakpoints) == null || (o = a.values) == null ? void 0 : o[i]) || values$1[i] || sizingTransform(i) };
    };
    return handleBreakpoints(e, e.maxWidth, t);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({ prop: "minWidth", transform: sizingTransform }), height = style$1({ prop: "height", transform: sizingTransform }), maxHeight = style$1({ prop: "maxHeight", transform: sizingTransform }), minHeight = style$1({ prop: "minHeight", transform: sizingTransform });
style$1({ prop: "size", cssProperty: "width", transform: sizingTransform });
style$1({ prop: "size", cssProperty: "height", transform: sizingTransform });
const boxSizing = style$1({ prop: "boxSizing" });
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: { themeKey: "borders", transform: borderTransform },
  borderTop: { themeKey: "borders", transform: borderTransform },
  borderRight: { themeKey: "borders", transform: borderTransform },
  borderBottom: { themeKey: "borders", transform: borderTransform },
  borderLeft: { themeKey: "borders", transform: borderTransform },
  borderColor: { themeKey: "palette" },
  borderTopColor: { themeKey: "palette" },
  borderRightColor: { themeKey: "palette" },
  borderBottomColor: { themeKey: "palette" },
  borderLeftColor: { themeKey: "palette" },
  borderRadius: { themeKey: "shape.borderRadius", style: borderRadius },
  // palette
  color: { themeKey: "palette", transform: paletteTransform },
  bgcolor: { themeKey: "palette", cssProperty: "backgroundColor", transform: paletteTransform },
  backgroundColor: { themeKey: "palette", transform: paletteTransform },
  // spacing
  p: { style: padding },
  pt: { style: padding },
  pr: { style: padding },
  pb: { style: padding },
  pl: { style: padding },
  px: { style: padding },
  py: { style: padding },
  padding: { style: padding },
  paddingTop: { style: padding },
  paddingRight: { style: padding },
  paddingBottom: { style: padding },
  paddingLeft: { style: padding },
  paddingX: { style: padding },
  paddingY: { style: padding },
  paddingInline: { style: padding },
  paddingInlineStart: { style: padding },
  paddingInlineEnd: { style: padding },
  paddingBlock: { style: padding },
  paddingBlockStart: { style: padding },
  paddingBlockEnd: { style: padding },
  m: { style: margin },
  mt: { style: margin },
  mr: { style: margin },
  mb: { style: margin },
  ml: { style: margin },
  mx: { style: margin },
  my: { style: margin },
  margin: { style: margin },
  marginTop: { style: margin },
  marginRight: { style: margin },
  marginBottom: { style: margin },
  marginLeft: { style: margin },
  marginX: { style: margin },
  marginY: { style: margin },
  marginInline: { style: margin },
  marginInlineStart: { style: margin },
  marginInlineEnd: { style: margin },
  marginBlock: { style: margin },
  marginBlockStart: { style: margin },
  marginBlockEnd: { style: margin },
  // display
  displayPrint: { cssProperty: !1, transform: (e) => ({ "@media print": { display: e } }) },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: { style: gap },
  rowGap: { style: rowGap },
  columnGap: { style: columnGap },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: { themeKey: "zIndex" },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: { themeKey: "shadows" },
  // sizing
  width: { transform: sizingTransform },
  maxWidth: { style: maxWidth },
  minWidth: { transform: sizingTransform },
  height: { transform: sizingTransform },
  maxHeight: { transform: sizingTransform },
  minHeight: { transform: sizingTransform },
  boxSizing: {},
  // typography
  fontFamily: { themeKey: "typography" },
  fontSize: { themeKey: "typography" },
  fontStyle: { themeKey: "typography" },
  fontWeight: { themeKey: "typography" },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: { cssProperty: !1, themeKey: "typography" }
}, defaultSxConfig$1 = defaultSxConfig;
function objectsHaveSameKeys() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  const n = t.reduce((o, l) => o.concat(Object.keys(l)), []), a = new Set(n);
  return t.every((o) => a.size === Object.keys(o).length);
}
function callIfFn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function unstable_createStyleFunctionSx() {
  function e(i, n, a, o) {
    const l = { [i]: n, theme: a }, c = o[i];
    if (!c)
      return { [i]: n };
    const { cssProperty: d = i, themeKey: u, transform: m, style: A } = c;
    if (n == null)
      return null;
    if (u === "typography" && n === "inherit")
      return { [i]: n };
    const y = getPath(a, u) || {};
    return A ? A(l) : handleBreakpoints(l, n, (C) => {
      let z = getStyleValue(y, m, C);
      return C === z && typeof C == "string" && (z = getStyleValue(y, m, `${i}${C === "default" ? "" : capitalize(C)}`, C)), d === !1 ? z : { [d]: z };
    });
  }
  function t(i) {
    var n;
    const { sx: a, theme: o = {} } = i || {};
    if (!a)
      return null;
    const l = (n = o.unstable_sxConfig) != null ? n : defaultSxConfig$1;
    function c(d) {
      let u = d;
      if (typeof d == "function")
        u = d(o);
      else if (typeof d != "object")
        return d;
      if (!u)
        return null;
      const m = createEmptyBreakpointObject(o.breakpoints), A = Object.keys(m);
      let y = m;
      return Object.keys(u).forEach((D) => {
        const C = callIfFn(u[D], o);
        if (C != null)
          if (typeof C == "object")
            if (l[D])
              y = merge(y, e(D, C, o, l));
            else {
              const z = handleBreakpoints({ theme: o }, C, (R) => ({ [D]: R }));
              objectsHaveSameKeys(z, C) ? y[D] = t({ sx: C, theme: o }) : y = merge(y, z);
            }
          else
            y = merge(y, e(D, C, o, l));
      }), removeUnusedBreakpoints(A, y);
    }
    return Array.isArray(a) ? a.map(c) : c(a);
  }
  return t;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
const styleFunctionSx$1 = styleFunctionSx, _excluded$b = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const { breakpoints: t = {}, palette: i = {}, spacing: n, shape: a = {} } = e, o = _objectWithoutPropertiesLoose$1(e, _excluded$b), l = createBreakpoints(t), c = createSpacing(n);
  let d = deepmerge({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends({ mode: "light" }, i),
    spacing: c,
    shape: _extends({}, shape$1, a)
  }, o);
  for (var u = arguments.length, m = new Array(u > 1 ? u - 1 : 0), A = 1; A < u; A++)
    m[A - 1] = arguments[A];
  return d = m.reduce((y, D) => deepmerge(y, D), d), d.unstable_sxConfig = _extends({}, defaultSxConfig$1, o == null ? void 0 : o.unstable_sxConfig), d.unstable_sx = function(D) {
    return styleFunctionSx$1({ sx: D, theme: this });
  }, d;
}
function isObjectEmpty(e) {
  return Object.keys(e).length === 0;
}
function useTheme$1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
  const t = React.useContext(ThemeContext);
  return !t || isObjectEmpty(t) ? e : t;
}
const systemDefaultTheme$1 = createTheme$1();
function useTheme() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : systemDefaultTheme$1;
  return useTheme$1(e);
}
const _excluded$a = ["variant"];
function isEmpty$1(e) {
  return e.length === 0;
}
function propsToClassKey(e) {
  const { variant: t } = e, i = _objectWithoutPropertiesLoose$1(e, _excluded$a);
  let n = t || "";
  return Object.keys(i).sort().forEach((a) => {
    a === "color" ? n += isEmpty$1(n) ? e[a] : capitalize(e[a]) : n += `${isEmpty$1(n) ? a : capitalize(a)}${capitalize(e[a].toString())}`;
  }), n;
}
const _excluded$9 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function isEmpty(e) {
  return Object.keys(e).length === 0;
}
function isStringTag(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
const getStyleOverrides = (e, t) => t.components && t.components[e] && t.components[e].styleOverrides ? t.components[e].styleOverrides : null, getVariantStyles = (e, t) => {
  let i = [];
  t && t.components && t.components[e] && t.components[e].variants && (i = t.components[e].variants);
  const n = {};
  return i.forEach((a) => {
    const o = propsToClassKey(a.props);
    n[o] = a.style;
  }), n;
}, variantsResolver = (e, t, i, n) => {
  var a, o;
  const { ownerState: l = {} } = e, c = [], d = i == null || (a = i.components) == null || (o = a[n]) == null ? void 0 : o.variants;
  return d && d.forEach((u) => {
    let m = !0;
    Object.keys(u.props).forEach((A) => {
      l[A] !== u.props[A] && e[A] !== u.props[A] && (m = !1);
    }), m && c.push(t[propsToClassKey(u.props)]);
  }), c;
};
function shouldForwardProp(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const systemDefaultTheme = createTheme$1(), lowercaseFirstLetter = (e) => e.charAt(0).toLowerCase() + e.slice(1);
function resolveTheme(e) {
  let { defaultTheme: t, theme: i, themeId: n } = e;
  return isEmpty(i) ? t : i[n] || i;
}
function createStyled() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const { themeId: t, defaultTheme: i = systemDefaultTheme, rootShouldForwardProp: n = shouldForwardProp, slotShouldForwardProp: a = shouldForwardProp } = e, o = (l) => styleFunctionSx$1(_extends({}, l, { theme: resolveTheme(_extends({}, l, { defaultTheme: i, themeId: t })) }));
  return o.__mui_systemSx = !0, function(l) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    internal_processStyles(l, (P) => P.filter((L) => !(L != null && L.__mui_systemSx)));
    const { name: d, slot: u, skipVariantsResolver: m, skipSx: A, overridesResolver: y } = c, D = _objectWithoutPropertiesLoose$1(c, _excluded$9), C = m !== void 0 ? m : u && u !== "Root" || !1, z = A || !1;
    let R;
    process.env.NODE_ENV !== "production" && d && (R = `${d}-${lowercaseFirstLetter(u || "Root")}`);
    let O = shouldForwardProp;
    u === "Root" ? O = n : u ? O = a : isStringTag(l) && (O = void 0);
    const $ = styled$2(l, _extends({ shouldForwardProp: O, label: R }, D)), k = function(P) {
      for (var L = arguments.length, F = new Array(L > 1 ? L - 1 : 0), B = 1; B < L; B++)
        F[B - 1] = arguments[B];
      const G = F ? F.map((E) => typeof E == "function" && E.__emotion_real !== E ? (T) => E(_extends({}, T, { theme: resolveTheme(_extends({}, T, { defaultTheme: i, themeId: t })) })) : E) : [];
      let Z = P;
      d && y && G.push((E) => {
        const T = resolveTheme(_extends({}, E, { defaultTheme: i, themeId: t })), g = getStyleOverrides(d, T);
        if (g) {
          const b = {};
          return Object.entries(g).forEach((x) => {
            let [S, I] = x;
            b[S] = typeof I == "function" ? I(_extends({}, E, { theme: T })) : I;
          }), y(E, b);
        }
        return null;
      }), d && !C && G.push((E) => {
        const T = resolveTheme(_extends({}, E, { defaultTheme: i, themeId: t }));
        return variantsResolver(E, getVariantStyles(d, T), T, d);
      }), z || G.push(o);
      const X = G.length - F.length;
      if (Array.isArray(P) && X > 0) {
        const E = new Array(X).fill("");
        Z = [...P, ...E], Z.raw = [...P.raw, ...E];
      } else
        typeof P == "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        P.__emotion_real !== P && (Z = (E) => P(_extends({}, E, { theme: resolveTheme(_extends({}, E, { defaultTheme: i, themeId: t })) })));
      const V = $(Z, ...G);
      if (process.env.NODE_ENV !== "production") {
        let E;
        d && (E = `${d}${u || ""}`), E === void 0 && (E = `Styled(${getDisplayName(l)})`), V.displayName = E;
      }
      return V;
    };
    return $.withConfig && (k.withConfig = $.withConfig), k;
  };
}
function getThemeProps(e) {
  const { theme: t, name: i, props: n } = e;
  return !t || !t.components || !t.components[i] || !t.components[i].defaultProps ? n : resolveProps(t.components[i].defaultProps, n);
}
function useThemeProps$1(e) {
  let { props: t, name: i, defaultTheme: n, themeId: a } = e, o = useTheme(n);
  return a && (o = o[a] || o), getThemeProps({ theme: o, name: i, props: t });
}
function clamp(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return process.env.NODE_ENV !== "production" && (e < t || e > i) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${i}].`), Math.min(Math.max(t, e), i);
}
function hexToRgb(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let i = e.match(t);
  return i && i[0].length === 1 && (i = i.map((n) => n + n)), i ? `rgb${i.length === 4 ? "a" : ""}(${i.map((n, a) => a < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function decomposeColor(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return decomposeColor(hexToRgb(e));
  const t = e.indexOf("("), i = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(i) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage(9, e));
  let n = e.substring(t + 1, e.length - 1), a;
  if (i === "color") {
    if (n = n.split(" "), a = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(a) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${a}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage(10, a));
  } else
    n = n.split(",");
  return n = n.map((o) => parseFloat(o)), { type: i, values: n, colorSpace: a };
}
function recomposeColor(e) {
  const { type: t, colorSpace: i } = e;
  let { values: n } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((a, o) => o < 3 ? parseInt(a, 10) : a) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${i} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function hslToRgb(e) {
  e = decomposeColor(e);
  const { values: t } = e, i = t[0], n = t[1] / 100, a = t[2] / 100, o = n * Math.min(a, 1 - a), l = function(u) {
    let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (u + i / 30) % 12;
    return a - o * Math.max(Math.min(m - 3, 9 - m, 1), -1);
  };
  let c = "rgb";
  const d = [Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255)];
  return e.type === "hsla" && (c += "a", d.push(t[3])), recomposeColor({ type: c, values: d });
}
function getLuminance(e) {
  e = decomposeColor(e);
  let t = e.type === "hsl" || e.type === "hsla" ? decomposeColor(hslToRgb(e)).values : e.values;
  return t = t.map((i) => (e.type !== "color" && (i /= 255), i <= 0.03928 ? i / 12.92 : ((i + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function getContrastRatio(e, t) {
  const i = getLuminance(e), n = getLuminance(t);
  return (Math.max(i, n) + 0.05) / (Math.min(i, n) + 0.05);
}
function alpha(e, t) {
  return e = decomposeColor(e), t = clamp(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, recomposeColor(e);
}
function darken(e, t) {
  if (e = decomposeColor(e), t = clamp(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] *= 1 - t;
  return recomposeColor(e);
}
function lighten(e, t) {
  if (e = decomposeColor(e), t = clamp(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (255 - e.values[i]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (1 - e.values[i]) * t;
  return recomposeColor(e);
}
function createMixins(e, t) {
  return _extends({ toolbar: { minHeight: 56, [e.up("xs")]: { "@media (orientation: landscape)": { minHeight: 48 } }, [e.up("sm")]: { minHeight: 64 } } }, t);
}
const common$7 = { black: "#000", white: "#fff" }, common$8 = common$7, grey = { 50: "#fafafa", 100: "#f5f5f5", 200: "#eeeeee", 300: "#e0e0e0", 400: "#bdbdbd", 500: "#9e9e9e", 600: "#757575", 700: "#616161", 800: "#424242", 900: "#212121", A100: "#f5f5f5", A200: "#eeeeee", A400: "#bdbdbd", A700: "#616161" }, grey$1 = grey, purple = { 50: "#f3e5f5", 100: "#e1bee7", 200: "#ce93d8", 300: "#ba68c8", 400: "#ab47bc", 500: "#9c27b0", 600: "#8e24aa", 700: "#7b1fa2", 800: "#6a1b9a", 900: "#4a148c", A100: "#ea80fc", A200: "#e040fb", A400: "#d500f9", A700: "#aa00ff" }, purple$1 = purple, red = { 50: "#ffebee", 100: "#ffcdd2", 200: "#ef9a9a", 300: "#e57373", 400: "#ef5350", 500: "#f44336", 600: "#e53935", 700: "#d32f2f", 800: "#c62828", 900: "#b71c1c", A100: "#ff8a80", A200: "#ff5252", A400: "#ff1744", A700: "#d50000" }, red$1 = red, orange = { 50: "#fff3e0", 100: "#ffe0b2", 200: "#ffcc80", 300: "#ffb74d", 400: "#ffa726", 500: "#ff9800", 600: "#fb8c00", 700: "#f57c00", 800: "#ef6c00", 900: "#e65100", A100: "#ffd180", A200: "#ffab40", A400: "#ff9100", A700: "#ff6d00" }, orange$1 = orange, blue = { 50: "#e3f2fd", 100: "#bbdefb", 200: "#90caf9", 300: "#64b5f6", 400: "#42a5f5", 500: "#2196f3", 600: "#1e88e5", 700: "#1976d2", 800: "#1565c0", 900: "#0d47a1", A100: "#82b1ff", A200: "#448aff", A400: "#2979ff", A700: "#2962ff" }, blue$1 = blue, lightBlue = { 50: "#e1f5fe", 100: "#b3e5fc", 200: "#81d4fa", 300: "#4fc3f7", 400: "#29b6f6", 500: "#03a9f4", 600: "#039be5", 700: "#0288d1", 800: "#0277bd", 900: "#01579b", A100: "#80d8ff", A200: "#40c4ff", A400: "#00b0ff", A700: "#0091ea" }, lightBlue$1 = lightBlue, green = { 50: "#e8f5e9", 100: "#c8e6c9", 200: "#a5d6a7", 300: "#81c784", 400: "#66bb6a", 500: "#4caf50", 600: "#43a047", 700: "#388e3c", 800: "#2e7d32", 900: "#1b5e20", A100: "#b9f6ca", A200: "#69f0ae", A400: "#00e676", A700: "#00c853" }, green$1 = green, _excluded$8 = ["mode", "contrastThreshold", "tonalOffset"], light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: { paper: common$8.white, default: common$8.white },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, dark = { text: { primary: common$8.white, secondary: "rgba(255, 255, 255, 0.7)", disabled: "rgba(255, 255, 255, 0.5)", icon: "rgba(255, 255, 255, 0.5)" }, divider: "rgba(255, 255, 255, 0.12)", background: { paper: "#121212", default: "#121212" }, action: { active: common$8.white, hover: "rgba(255, 255, 255, 0.08)", hoverOpacity: 0.08, selected: "rgba(255, 255, 255, 0.16)", selectedOpacity: 0.16, disabled: "rgba(255, 255, 255, 0.3)", disabledBackground: "rgba(255, 255, 255, 0.12)", disabledOpacity: 0.38, focus: "rgba(255, 255, 255, 0.12)", focusOpacity: 0.12, activatedOpacity: 0.24 } };
function addLightOrDark(e, t, i, n) {
  const a = n.light || n, o = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(i) ? e[t] = e[i] : t === "light" ? e.light = lighten(e.main, a) : t === "dark" && (e.dark = darken(e.main, o)));
}
function getDefaultPrimary() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light") === "dark" ? { main: blue$1[200], light: blue$1[50], dark: blue$1[400] } : { main: blue$1[700], light: blue$1[400], dark: blue$1[800] };
}
function getDefaultSecondary() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light") === "dark" ? { main: purple$1[200], light: purple$1[50], dark: purple$1[400] } : { main: purple$1[500], light: purple$1[300], dark: purple$1[700] };
}
function getDefaultError() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light") === "dark" ? { main: red$1[500], light: red$1[300], dark: red$1[700] } : { main: red$1[700], light: red$1[400], dark: red$1[800] };
}
function getDefaultInfo() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light") === "dark" ? { main: lightBlue$1[400], light: lightBlue$1[300], dark: lightBlue$1[700] } : { main: lightBlue$1[700], light: lightBlue$1[500], dark: lightBlue$1[900] };
}
function getDefaultSuccess() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light") === "dark" ? { main: green$1[400], light: green$1[300], dark: green$1[700] } : { main: green$1[800], light: green$1[500], dark: green$1[900] };
}
function getDefaultWarning() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light") === "dark" ? { main: orange$1[400], light: orange$1[300], dark: orange$1[700] } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function createPalette(e) {
  const { mode: t = "light", contrastThreshold: i = 3, tonalOffset: n = 0.2 } = e, a = _objectWithoutPropertiesLoose$1(e, _excluded$8), o = e.primary || getDefaultPrimary(t), l = e.secondary || getDefaultSecondary(t), c = e.error || getDefaultError(t), d = e.info || getDefaultInfo(t), u = e.success || getDefaultSuccess(t), m = e.warning || getDefaultWarning(t);
  function A(z) {
    const R = getContrastRatio(z, dark.text.primary) >= i ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const O = getContrastRatio(z, R);
      O < 3 && console.error([`MUI: The contrast ratio of ${O}:1 for ${R} on ${z}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return R;
  }
  const y = (z) => {
    let { color: R, name: O, mainShade: $ = 500, lightShade: k = 300, darkShade: P = 700 } = z;
    if (R = _extends({}, R), !R.main && R[$] && (R.main = R[$]), !R.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${O ? ` (${O})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${$}\` property.` : formatMuiErrorMessage(11, O ? ` (${O})` : "", $));
    if (typeof R.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${O ? ` (${O})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(R.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage(12, O ? ` (${O})` : "", JSON.stringify(R.main)));
    return addLightOrDark(R, "light", k, n), addLightOrDark(R, "dark", P, n), R.contrastText || (R.contrastText = A(R.main)), R;
  }, D = { dark, light };
  return process.env.NODE_ENV !== "production" && (D[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), deepmerge(_extends({
    // A collection of common colors.
    common: _extends({}, common$8),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: y({ color: o, name: "primary" }),
    // The colors used to represent secondary interface elements for a user.
    secondary: y({ color: l, name: "secondary", mainShade: "A400", lightShade: "A200", darkShade: "A700" }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: y({ color: c, name: "error" }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: y({ color: m, name: "warning" }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: y({ color: d, name: "info" }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: y({ color: u, name: "success" }),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: i,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: A,
    // Generate a rich color object.
    augmentColor: y,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, D[t]), a);
}
const _excluded$7 = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round(e) {
  return Math.round(e * 1e5) / 1e5;
}
const caseAllCaps = { textTransform: "uppercase" }, defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(e, t) {
  const i = typeof t == "function" ? t(e) : t, {
    fontFamily: n = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize: a = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: l = 400,
    fontWeightMedium: c = 500,
    fontWeightBold: d = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: u = 16,
    // Apply the CSS properties to all the variants.
    allVariants: m,
    pxToRem: A
  } = i, y = _objectWithoutPropertiesLoose$1(i, _excluded$7);
  process.env.NODE_ENV !== "production" && (typeof a != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof u != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const D = a / 14, C = A || ((O) => `${O / u * D}rem`), z = (O, $, k, P, L) => _extends({
    fontFamily: n,
    fontWeight: O,
    fontSize: C($),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: k
  }, n === defaultFontFamily ? { letterSpacing: `${round(P / $)}em` } : {}, L, m), R = { h1: z(o, 96, 1.167, -1.5), h2: z(o, 60, 1.2, -0.5), h3: z(l, 48, 1.167, 0), h4: z(l, 34, 1.235, 0.25), h5: z(l, 24, 1.334, 0), h6: z(c, 20, 1.6, 0.15), subtitle1: z(l, 16, 1.75, 0.15), subtitle2: z(c, 14, 1.57, 0.1), body1: z(l, 16, 1.5, 0.15), body2: z(l, 14, 1.43, 0.15), button: z(c, 14, 1.75, 0.4, caseAllCaps), caption: z(l, 12, 1.66, 0.4), overline: z(l, 12, 2.66, 1, caseAllCaps), inherit: { fontFamily: "inherit", fontWeight: "inherit", fontSize: "inherit", lineHeight: "inherit", letterSpacing: "inherit" } };
  return deepmerge(_extends({ htmlFontSize: u, pxToRem: C, fontFamily: n, fontSize: a, fontWeightLight: o, fontWeightRegular: l, fontWeightMedium: c, fontWeightBold: d }, R), y, {
    clone: !1
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2, shadowKeyPenumbraOpacity = 0.14, shadowAmbientShadowOpacity = 0.12;
function createShadow() {
  return [`${arguments.length <= 0 ? void 0 : arguments[0]}px ${arguments.length <= 1 ? void 0 : arguments[1]}px ${arguments.length <= 2 ? void 0 : arguments[2]}px ${arguments.length <= 3 ? void 0 : arguments[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${arguments.length <= 4 ? void 0 : arguments[4]}px ${arguments.length <= 5 ? void 0 : arguments[5]}px ${arguments.length <= 6 ? void 0 : arguments[6]}px ${arguments.length <= 7 ? void 0 : arguments[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${arguments.length <= 8 ? void 0 : arguments[8]}px ${arguments.length <= 9 ? void 0 : arguments[9]}px ${arguments.length <= 10 ? void 0 : arguments[10]}px ${arguments.length <= 11 ? void 0 : arguments[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], shadows$1 = shadows, _excluded$6 = ["duration", "easing", "delay"], easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(e) {
  return `${Math.round(e)}ms`;
}
function getAutoHeightDuration(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function createTransitions(e) {
  const t = _extends({}, easing, e.easing), i = _extends({}, duration, e.duration);
  return _extends({ getAutoHeightDuration, create: function() {
    let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"], o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { duration: l = i.standard, easing: c = t.easeInOut, delay: d = 0 } = o, u = _objectWithoutPropertiesLoose$1(o, _excluded$6);
    if (process.env.NODE_ENV !== "production") {
      const m = (y) => typeof y == "string", A = (y) => !isNaN(parseFloat(y));
      !m(a) && !Array.isArray(a) && console.error('MUI: Argument "props" must be a string or Array.'), !A(l) && !m(l) && console.error(`MUI: Argument "duration" must be a number or a string but found ${l}.`), m(c) || console.error('MUI: Argument "easing" must be a string.'), !A(d) && !m(d) && console.error('MUI: Argument "delay" must be a number or a string.'), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
    }
    return (Array.isArray(a) ? a : [a]).map((m) => `${m} ${typeof l == "string" ? l : formatMs(l)} ${c} ${typeof d == "string" ? d : formatMs(d)}`).join(",");
  } }, e, { easing: t, duration: i });
}
const zIndex = { mobileStepper: 1e3, fab: 1050, speedDial: 1050, appBar: 1100, drawer: 1200, modal: 1300, snackbar: 1400, tooltip: 1500 }, zIndex$1 = zIndex, _excluded$5 = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const { mixins: t = {}, palette: i = {}, transitions: n = {}, typography: a = {} } = e, o = _objectWithoutPropertiesLoose$1(e, _excluded$5);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : formatMuiErrorMessage(18));
  const l = createPalette(i), c = createTheme$1(e);
  let d = deepmerge(c, {
    mixins: createMixins(c.breakpoints, t),
    palette: l,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(l, a),
    transitions: createTransitions(n),
    zIndex: _extends({}, zIndex$1)
  });
  d = deepmerge(d, o);
  for (var u = arguments.length, m = new Array(u > 1 ? u - 1 : 0), A = 1; A < u; A++)
    m[A - 1] = arguments[A];
  if (d = m.reduce((y, D) => deepmerge(y, D), d), process.env.NODE_ENV !== "production") {
    const y = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], D = (C, z) => {
      let R;
      for (R in C) {
        const O = C[R];
        if (y.indexOf(R) !== -1 && Object.keys(O).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const $ = generateUtilityClass("", R);
            console.error([`MUI: The \`${z}\` component increases the CSS specificity of the \`${R}\` internal state.`, "You can not override it like this: ", JSON.stringify(C, null, 2), "", `Instead, you need to use the '&.${$}' syntax:`, JSON.stringify({ root: { [`&.${$}`]: O } }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          C[R] = {};
        }
      }
    };
    Object.keys(d.components).forEach((C) => {
      const z = d.components[C].styleOverrides;
      z && C.indexOf("Mui") === 0 && D(z, C);
    });
  }
  return d.unstable_sxConfig = _extends({}, defaultSxConfig$1, o == null ? void 0 : o.unstable_sxConfig), d.unstable_sx = function(D) {
    return styleFunctionSx$1({ sx: D, theme: this });
  }, d;
}
const defaultTheme = createTheme(), defaultTheme$1 = defaultTheme, THEME_ID = "$$material", rootShouldForwardProp = (e) => shouldForwardProp(e) && e !== "classes", styled = createStyled({ themeId: THEME_ID, defaultTheme: defaultTheme$1, rootShouldForwardProp }), styled$1 = styled;
function useThemeProps(e) {
  let { props: t, name: i } = e;
  return useThemeProps$1({ props: t, name: i, defaultTheme: defaultTheme$1, themeId: THEME_ID });
}
function _setPrototypeOf(e, t) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, _setPrototypeOf(e, t);
}
function _inheritsLoose(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, _setPrototypeOf(e, t);
}
const TransitionGroupContext = React__default.createContext(null);
function _assertThisInitialized(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function getChildMapping(e, t) {
  var i = function(o) {
    return t && isValidElement(o) ? t(o) : o;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && Children.map(e, function(a) {
    return a;
  }).forEach(function(a) {
    n[a.key] = i(a);
  }), n;
}
function mergeChildMappings(e, t) {
  e = e || {}, t = t || {};
  function i(m) {
    return m in t ? t[m] : e[m];
  }
  var n = /* @__PURE__ */ Object.create(null), a = [];
  for (var o in e)
    o in t ? a.length && (n[o] = a, a = []) : a.push(o);
  var l, c = {};
  for (var d in t) {
    if (n[d])
      for (l = 0; l < n[d].length; l++) {
        var u = n[d][l];
        c[n[d][l]] = i(u);
      }
    c[d] = i(d);
  }
  for (l = 0; l < a.length; l++)
    c[a[l]] = i(a[l]);
  return c;
}
function getProp(e, t, i) {
  return i[t] != null ? i[t] : e.props[t];
}
function getInitialChildMapping(e, t) {
  return getChildMapping(e.children, function(i) {
    return cloneElement(i, { onExited: t.bind(null, i), in: !0, appear: getProp(i, "appear", e), enter: getProp(i, "enter", e), exit: getProp(i, "exit", e) });
  });
}
function getNextChildMapping(e, t, i) {
  var n = getChildMapping(e.children), a = mergeChildMappings(t, n);
  return Object.keys(a).forEach(function(o) {
    var l = a[o];
    if (isValidElement(l)) {
      var c = o in t, d = o in n, u = t[o], m = isValidElement(u) && !u.props.in;
      d && (!c || m) ? a[o] = cloneElement(l, { onExited: i.bind(null, l), in: !0, exit: getProp(l, "exit", e), enter: getProp(l, "enter", e) }) : !d && c && !m ? a[o] = cloneElement(l, { in: !1 }) : d && c && isValidElement(u) && (a[o] = cloneElement(l, { onExited: i.bind(null, l), in: u.props.in, exit: getProp(l, "exit", e), enter: getProp(l, "enter", e) }));
    }
  }), a;
}
var values = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, defaultProps = { component: "div", childFactory: function(t) {
  return t;
} }, TransitionGroup = /* @__PURE__ */ function(e) {
  _inheritsLoose(t, e);
  function t(n, a) {
    var o;
    o = e.call(this, n, a) || this;
    var l = o.handleExited.bind(_assertThisInitialized(o));
    return o.state = { contextValue: { isMounting: !0 }, handleExited: l, firstRender: !0 }, o;
  }
  var i = t.prototype;
  return i.componentDidMount = function() {
    this.mounted = !0, this.setState({ contextValue: { isMounting: !1 } });
  }, i.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(a, o) {
    var l = o.children, c = o.handleExited, d = o.firstRender;
    return { children: d ? getInitialChildMapping(a, c) : getNextChildMapping(a, l, c), firstRender: !1 };
  }, i.handleExited = function(a, o) {
    var l = getChildMapping(this.props.children);
    a.key in l || (a.props.onExited && a.props.onExited(o), this.mounted && this.setState(function(c) {
      var d = _extends({}, c.children);
      return delete d[a.key], { children: d };
    }));
  }, i.render = function() {
    var a = this.props, o = a.component, l = a.childFactory, c = _objectWithoutPropertiesLoose$1(a, ["component", "childFactory"]), d = this.state.contextValue, u = values(this.state.children).map(l);
    return delete c.appear, delete c.enter, delete c.exit, o === null ? /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, { value: d }, u) : /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, { value: d }, /* @__PURE__ */ React__default.createElement(o, c, u));
  }, t;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
  * `<TransitionGroup>` renders a `<div>` by default. You can change this
  * behavior by providing a `component` prop.
  * If you use React v16+ and would like to avoid a wrapping `<div>` element
  * you can pass in `component={null}`. This is useful if the wrapping div
  * borks your css styles.
  */
  component: propTypesExports.any,
  /**
  * A set of `<Transition>` components, that are toggled `in` and out as they
  * leave. the `<TransitionGroup>` will inject specific transition props, so
  * remember to spread them through if you are wrapping the `<Transition>` as
  * with our `<Fade>` example.
  *
  * While this component is meant for multiple `Transition` or `CSSTransition`
  * children, sometimes you may want to have a single transition child with
  * content that you want to be transitioned out and in when you change it
  * (e.g. routes, images etc.) In that case you can change the `key` prop of
  * the transition child as you change its content, this will cause
  * `TransitionGroup` to transition the child out and back in.
  */
  children: propTypesExports.node,
  /**
  * A convenience prop that enables or disables appear animations
  * for all children. Note that specifying this will override any defaults set
  * on individual children Transitions.
  */
  appear: propTypesExports.bool,
  /**
  * A convenience prop that enables or disables enter animations
  * for all children. Note that specifying this will override any defaults set
  * on individual children Transitions.
  */
  enter: propTypesExports.bool,
  /**
  * A convenience prop that enables or disables exit animations
  * for all children. Note that specifying this will override any defaults set
  * on individual children Transitions.
  */
  exit: propTypesExports.bool,
  /**
  * You may need to apply reactive updates to a child as it is exiting.
  * This is generally done by using `cloneElement` however in the case of an exiting
  * child the element has already been removed and not accessible to the consumer.
  *
  * If you do need to update a child as it leaves you can provide a `childFactory`
  * to wrap every child, even the ones that are leaving.
  *
  * @type Function(child: ReactElement) -> ReactElement
  */
  childFactory: propTypesExports.func
} : {};
TransitionGroup.defaultProps = defaultProps;
const TransitionGroup$1 = TransitionGroup;
function Ripple(e) {
  const { className: t, classes: i, pulsate: n = !1, rippleX: a, rippleY: o, rippleSize: l, in: c, onExited: d, timeout: u } = e, [m, A] = React.useState(!1), y = clsx(t, i.ripple, i.rippleVisible, n && i.ripplePulsate), D = { width: l, height: l, top: -(l / 2) + o, left: -(l / 2) + a }, C = clsx(i.child, m && i.childLeaving, n && i.childPulsate);
  return !c && !m && A(!0), React.useEffect(() => {
    if (!c && d != null) {
      const z = setTimeout(d, u);
      return () => {
        clearTimeout(z);
      };
    }
  }, [d, c, u]), /* @__PURE__ */ jsx("span", { className: y, style: D, children: /* @__PURE__ */ jsx("span", { className: C }) });
}
process.env.NODE_ENV !== "production" && (Ripple.propTypes = {
  /**
  * Override or extend the styles applied to the component.
  * See [CSS API](#css) below for more details.
  */
  classes: propTypesExports.object.isRequired,
  className: propTypesExports.string,
  /**
  * @ignore - injected from TransitionGroup
  */
  in: propTypesExports.bool,
  /**
  * @ignore - injected from TransitionGroup
  */
  onExited: propTypesExports.func,
  /**
  * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
  */
  pulsate: propTypesExports.bool,
  /**
  * Diameter of the ripple.
  */
  rippleSize: propTypesExports.number,
  /**
  * Horizontal position of the ripple center.
  */
  rippleX: propTypesExports.number,
  /**
  * Vertical position of the ripple center.
  */
  rippleY: propTypesExports.number,
  /**
  * exit delay
  */
  timeout: propTypesExports.number.isRequired
});
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), touchRippleClasses$1 = touchRippleClasses, _excluded$4 = ["center", "classes", "className"];
let _ = (e) => e, _t, _t2, _t3, _t4;
const DURATION = 550, DELAY_RIPPLE = 80, enterKeyframe = keyframes(_t || (_t = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), exitKeyframe = keyframes(_t2 || (_t2 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), pulsateKeyframe = keyframes(_t3 || (_t3 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), TouchRippleRoot = styled$1("span", { name: "MuiTouchRipple", slot: "Root" })({ overflow: "hidden", pointerEvents: "none", position: "absolute", zIndex: 0, top: 0, right: 0, bottom: 0, left: 0, borderRadius: "inherit" }), TouchRippleRipple = styled$1(Ripple, { name: "MuiTouchRipple", slot: "Ripple" })(_t4 || (_t4 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses$1.rippleVisible, enterKeyframe, DURATION, (e) => {
  let { theme: t } = e;
  return t.transitions.easing.easeInOut;
}, touchRippleClasses$1.ripplePulsate, (e) => {
  let { theme: t } = e;
  return t.transitions.duration.shorter;
}, touchRippleClasses$1.child, touchRippleClasses$1.childLeaving, exitKeyframe, DURATION, (e) => {
  let { theme: t } = e;
  return t.transitions.easing.easeInOut;
}, touchRippleClasses$1.childPulsate, pulsateKeyframe, (e) => {
  let { theme: t } = e;
  return t.transitions.easing.easeInOut;
}), TouchRipple = /* @__PURE__ */ React.forwardRef(function(t, i) {
  const n = useThemeProps({ props: t, name: "MuiTouchRipple" }), { center: a = !1, classes: o = {}, className: l } = n, c = _objectWithoutPropertiesLoose$1(n, _excluded$4), [d, u] = React.useState([]), m = React.useRef(0), A = React.useRef(null);
  React.useEffect(() => {
    A.current && (A.current(), A.current = null);
  }, [d]);
  const y = React.useRef(!1), D = React.useRef(null), C = React.useRef(null), z = React.useRef(null);
  React.useEffect(() => () => {
    clearTimeout(D.current);
  }, []);
  const R = React.useCallback((P) => {
    const { pulsate: L, rippleX: F, rippleY: B, rippleSize: G, cb: Z } = P;
    u((X) => [...X, /* @__PURE__ */ jsx(TouchRippleRipple, { classes: { ripple: clsx(o.ripple, touchRippleClasses$1.ripple), rippleVisible: clsx(o.rippleVisible, touchRippleClasses$1.rippleVisible), ripplePulsate: clsx(o.ripplePulsate, touchRippleClasses$1.ripplePulsate), child: clsx(o.child, touchRippleClasses$1.child), childLeaving: clsx(o.childLeaving, touchRippleClasses$1.childLeaving), childPulsate: clsx(o.childPulsate, touchRippleClasses$1.childPulsate) }, timeout: DURATION, pulsate: L, rippleX: F, rippleY: B, rippleSize: G }, m.current)]), m.current += 1, A.current = Z;
  }, [o]), O = React.useCallback(function() {
    let P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : () => {
    };
    const {
      pulsate: B = !1,
      center: G = a || L.pulsate,
      fakeElement: Z = !1
      // For test purposes
    } = L;
    if ((P == null ? void 0 : P.type) === "mousedown" && y.current) {
      y.current = !1;
      return;
    }
    (P == null ? void 0 : P.type) === "touchstart" && (y.current = !0);
    const X = Z ? null : z.current, V = X ? X.getBoundingClientRect() : { width: 0, height: 0, left: 0, top: 0 };
    let E, T, g;
    if (G || P === void 0 || P.clientX === 0 && P.clientY === 0 || !P.clientX && !P.touches)
      E = Math.round(V.width / 2), T = Math.round(V.height / 2);
    else {
      const { clientX: b, clientY: x } = P.touches && P.touches.length > 0 ? P.touches[0] : P;
      E = Math.round(b - V.left), T = Math.round(x - V.top);
    }
    if (G)
      g = Math.sqrt((2 * V.width ** 2 + V.height ** 2) / 3), g % 2 === 0 && (g += 1);
    else {
      const b = Math.max(Math.abs((X ? X.clientWidth : 0) - E), E) * 2 + 2, x = Math.max(Math.abs((X ? X.clientHeight : 0) - T), T) * 2 + 2;
      g = Math.sqrt(b ** 2 + x ** 2);
    }
    P != null && P.touches ? C.current === null && (C.current = () => {
      R({ pulsate: B, rippleX: E, rippleY: T, rippleSize: g, cb: F });
    }, D.current = setTimeout(() => {
      C.current && (C.current(), C.current = null);
    }, DELAY_RIPPLE)) : R({ pulsate: B, rippleX: E, rippleY: T, rippleSize: g, cb: F });
  }, [a, R]), $ = React.useCallback(() => {
    O({}, { pulsate: !0 });
  }, [O]), k = React.useCallback((P, L) => {
    if (clearTimeout(D.current), (P == null ? void 0 : P.type) === "touchend" && C.current) {
      C.current(), C.current = null, D.current = setTimeout(() => {
        k(P, L);
      });
      return;
    }
    C.current = null, u((F) => F.length > 0 ? F.slice(1) : F), A.current = L;
  }, []);
  return React.useImperativeHandle(i, () => ({ pulsate: $, start: O, stop: k }), [$, O, k]), /* @__PURE__ */ jsx(TouchRippleRoot, _extends({ className: clsx(touchRippleClasses$1.root, o.root, l), ref: z }, c, { children: /* @__PURE__ */ jsx(TransitionGroup$1, { component: null, exit: !0, children: d }) }));
});
process.env.NODE_ENV !== "production" && (TouchRipple.propTypes = {
  /**
  * If `true`, the ripple starts at the center of the component
  * rather than at the point of interaction.
  */
  center: propTypesExports.bool,
  /**
  * Override or extend the styles applied to the component.
  * See [CSS API](#css) below for more details.
  */
  classes: propTypesExports.object,
  /**
  * @ignore
  */
  className: propTypesExports.string
});
const TouchRipple$1 = TouchRipple;
function getButtonBaseUtilityClass(e) {
  return generateUtilityClass("MuiButtonBase", e);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]), buttonBaseClasses$1 = buttonBaseClasses, _excluded$3 = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], useUtilityClasses$1 = (e) => {
  const { disabled: t, focusVisible: i, focusVisibleClassName: n, classes: a } = e, l = composeClasses({ root: ["root", t && "disabled", i && "focusVisible"] }, getButtonBaseUtilityClass, a);
  return i && n && (l.root += ` ${n}`), l;
}, ButtonBaseRoot = styled$1("button", { name: "MuiButtonBase", slot: "Root", overridesResolver: (e, t) => t.root })({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses$1.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": { colorAdjust: "exact" }
}), ButtonBase = /* @__PURE__ */ React.forwardRef(function(t, i) {
  const n = useThemeProps({ props: t, name: "MuiButtonBase" }), { action: a, centerRipple: o = !1, children: l, className: c, component: d = "button", disabled: u = !1, disableRipple: m = !1, disableTouchRipple: A = !1, focusRipple: y = !1, LinkComponent: D = "a", onBlur: C, onClick: z, onContextMenu: R, onDragLeave: O, onFocus: $, onFocusVisible: k, onKeyDown: P, onKeyUp: L, onMouseDown: F, onMouseLeave: B, onMouseUp: G, onTouchEnd: Z, onTouchMove: X, onTouchStart: V, tabIndex: E = 0, TouchRippleProps: T, touchRippleRef: g, type: b } = n, x = _objectWithoutPropertiesLoose$1(n, _excluded$3), S = React.useRef(null), I = React.useRef(null), N = useForkRef(I, g), { isFocusVisibleRef: p, onFocus: M, onBlur: j, ref: U } = useIsFocusVisible(), [H, J] = React.useState(!1);
  u && H && J(!1), React.useImperativeHandle(a, () => ({ focusVisible: () => {
    J(!0), S.current.focus();
  } }), []);
  const [te, ae] = React.useState(!1);
  React.useEffect(() => {
    ae(!0);
  }, []);
  const le = te && !m && !u;
  React.useEffect(() => {
    H && y && !m && te && I.current.pulsate();
  }, [m, y, H, te]);
  function ne(ee, ie) {
    let se = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : A;
    return useEventCallback((pe) => (ie && ie(pe), !se && I.current && I.current[ee](pe), !0));
  }
  const ue = ne("start", F), ge = ne("stop", R), re = ne("stop", O), fe = ne("stop", G), oe = ne("stop", (ee) => {
    H && ee.preventDefault(), B && B(ee);
  }), ve = ne("start", V), Le = ne("stop", Z), Be = ne("stop", X), we = ne("stop", (ee) => {
    j(ee), p.current === !1 && J(!1), C && C(ee);
  }, !1), Ue = useEventCallback((ee) => {
    S.current || (S.current = ee.currentTarget), M(ee), p.current === !0 && (J(!0), k && k(ee)), $ && $(ee);
  }), Oe = () => {
    const ee = S.current;
    return d && d !== "button" && !(ee.tagName === "A" && ee.href);
  }, Te = React.useRef(!1), Ne = useEventCallback((ee) => {
    y && !Te.current && H && I.current && ee.key === " " && (Te.current = !0, I.current.stop(ee, () => {
      I.current.start(ee);
    })), ee.target === ee.currentTarget && Oe() && ee.key === " " && ee.preventDefault(), P && P(ee), ee.target === ee.currentTarget && Oe() && ee.key === "Enter" && !u && (ee.preventDefault(), z && z(ee));
  }), Ee = useEventCallback((ee) => {
    y && ee.key === " " && I.current && H && !ee.defaultPrevented && (Te.current = !1, I.current.stop(ee, () => {
      I.current.pulsate(ee);
    })), L && L(ee), z && ee.target === ee.currentTarget && Oe() && ee.key === " " && !ee.defaultPrevented && z(ee);
  });
  let Se = d;
  Se === "button" && (x.href || x.to) && (Se = D);
  const Re = {};
  Se === "button" ? (Re.type = b === void 0 ? "button" : b, Re.disabled = u) : (!x.href && !x.to && (Re.role = "button"), u && (Re["aria-disabled"] = u));
  const W = useForkRef(i, U, S);
  process.env.NODE_ENV !== "production" && React.useEffect(() => {
    le && !I.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [le]);
  const Y = _extends({}, n, { centerRipple: o, component: d, disabled: u, disableRipple: m, disableTouchRipple: A, focusRipple: y, tabIndex: E, focusVisible: H }), Q = useUtilityClasses$1(Y);
  return /* @__PURE__ */ jsxs(ButtonBaseRoot, _extends({ as: Se, className: clsx(Q.root, c), ownerState: Y, onBlur: we, onClick: z, onContextMenu: ge, onFocus: Ue, onKeyDown: Ne, onKeyUp: Ee, onMouseDown: ue, onMouseLeave: oe, onMouseUp: fe, onDragLeave: re, onTouchEnd: Le, onTouchMove: Be, onTouchStart: ve, ref: W, tabIndex: u ? -1 : E, type: b }, Re, x, { children: [l, le ? (
    /* TouchRipple is only needed client-side, x2 boost on the server. */
    /* @__PURE__ */ jsx(TouchRipple$1, _extends({ ref: N, center: o }, T))
  ) : null] }));
});
process.env.NODE_ENV !== "production" && (ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
     * A ref for imperative actions.
     * It currently only supports `focusVisible()` action.
     */
  action: refType$1,
  /**
  * If `true`, the ripples are centered.
  * They won't start at the cursor interaction position.
  * @default false
  */
  centerRipple: propTypesExports.bool,
  /**
  * The content of the component.
  */
  children: propTypesExports.node,
  /**
  * Override or extend the styles applied to the component.
  */
  classes: propTypesExports.object,
  /**
  * @ignore
  */
  className: propTypesExports.string,
  /**
  * The component used for the root node.
  * Either a string to use a HTML element or a component.
  */
  component: elementTypeAcceptingRef$1,
  /**
  * If `true`, the component is disabled.
  * @default false
  */
  disabled: propTypesExports.bool,
  /**
  * If `true`, the ripple effect is disabled.
  *
  * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
  * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
  * @default false
  */
  disableRipple: propTypesExports.bool,
  /**
  * If `true`, the touch ripple effect is disabled.
  * @default false
  */
  disableTouchRipple: propTypesExports.bool,
  /**
  * If `true`, the base button will have a keyboard focus ripple.
  * @default false
  */
  focusRipple: propTypesExports.bool,
  /**
  * This prop can help identify which element has keyboard focus.
  * The class name will be applied when the element gains the focus through keyboard interaction.
  * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
  * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
  * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
  * if needed.
  */
  focusVisibleClassName: propTypesExports.string,
  /**
  * @ignore
  */
  href: propTypesExports.any,
  /**
  * The component used to render a link when the `href` prop is provided.
  * @default 'a'
  */
  LinkComponent: propTypesExports.elementType,
  /**
  * @ignore
  */
  onBlur: propTypesExports.func,
  /**
  * @ignore
  */
  onClick: propTypesExports.func,
  /**
  * @ignore
  */
  onContextMenu: propTypesExports.func,
  /**
  * @ignore
  */
  onDragLeave: propTypesExports.func,
  /**
  * @ignore
  */
  onFocus: propTypesExports.func,
  /**
  * Callback fired when the component is focused with a keyboard.
  * We trigger a `onFocus` callback too.
  */
  onFocusVisible: propTypesExports.func,
  /**
  * @ignore
  */
  onKeyDown: propTypesExports.func,
  /**
  * @ignore
  */
  onKeyUp: propTypesExports.func,
  /**
  * @ignore
  */
  onMouseDown: propTypesExports.func,
  /**
  * @ignore
  */
  onMouseLeave: propTypesExports.func,
  /**
  * @ignore
  */
  onMouseUp: propTypesExports.func,
  /**
  * @ignore
  */
  onTouchEnd: propTypesExports.func,
  /**
  * @ignore
  */
  onTouchMove: propTypesExports.func,
  /**
  * @ignore
  */
  onTouchStart: propTypesExports.func,
  /**
  * The system prop that allows defining system overrides as well as additional CSS styles.
  */
  sx: propTypesExports.oneOfType([propTypesExports.arrayOf(propTypesExports.oneOfType([propTypesExports.func, propTypesExports.object, propTypesExports.bool])), propTypesExports.func, propTypesExports.object]),
  /**
  * @default 0
  */
  tabIndex: propTypesExports.number,
  /**
  * Props applied to the `TouchRipple` element.
  */
  TouchRippleProps: propTypesExports.object,
  /**
  * A ref that points to the `TouchRipple` element.
  */
  touchRippleRef: propTypesExports.oneOfType([propTypesExports.func, propTypesExports.shape({ current: propTypesExports.shape({ pulsate: propTypesExports.func.isRequired, start: propTypesExports.func.isRequired, stop: propTypesExports.func.isRequired }) })]),
  /**
  * @ignore
  */
  type: propTypesExports.oneOfType([propTypesExports.oneOf(["button", "reset", "submit"]), propTypesExports.string])
});
const ButtonBase$1 = ButtonBase;
function getButtonUtilityClass(e) {
  return generateUtilityClass("MuiButton", e);
}
const buttonClasses = generateUtilityClasses("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), buttonClasses$1 = buttonClasses, ButtonGroupContext = /* @__PURE__ */ React.createContext({});
process.env.NODE_ENV !== "production" && (ButtonGroupContext.displayName = "ButtonGroupContext");
const ButtonGroupContext$1 = ButtonGroupContext, _excluded$2 = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], useUtilityClasses = (e) => {
  const { color: t, disableElevation: i, fullWidth: n, size: a, variant: o, classes: l } = e, c = { root: ["root", o, `${o}${capitalize(t)}`, `size${capitalize(a)}`, `${o}Size${capitalize(a)}`, t === "inherit" && "colorInherit", i && "disableElevation", n && "fullWidth"], label: ["label"], startIcon: ["startIcon", `iconSize${capitalize(a)}`], endIcon: ["endIcon", `iconSize${capitalize(a)}`] }, d = composeClasses(c, getButtonUtilityClass, l);
  return _extends({}, l, d);
}, commonIconStyles = (e) => _extends({}, e.size === "small" && { "& > *:nth-of-type(1)": { fontSize: 18 } }, e.size === "medium" && { "& > *:nth-of-type(1)": { fontSize: 20 } }, e.size === "large" && { "& > *:nth-of-type(1)": { fontSize: 22 } }), ButtonRoot = styled$1(ButtonBase$1, { shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes", name: "MuiButton", slot: "Root", overridesResolver: (e, t) => {
  const { ownerState: i } = e;
  return [t.root, t[i.variant], t[`${i.variant}${capitalize(i.color)}`], t[`size${capitalize(i.size)}`], t[`${i.variant}Size${capitalize(i.size)}`], i.color === "inherit" && t.colorInherit, i.disableElevation && t.disableElevation, i.fullWidth && t.fullWidth];
} })((e) => {
  let { theme: t, ownerState: i } = e;
  var n, a;
  return _extends({}, t.typography.button, { minWidth: 64, padding: "6px 16px", borderRadius: (t.vars || t).shape.borderRadius, transition: t.transitions.create(["background-color", "box-shadow", "border-color", "color"], { duration: t.transitions.duration.short }), "&:hover": _extends({
    textDecoration: "none",
    backgroundColor: t.vars ? `rgba(${t.vars.palette.text.primaryChannel} / ${t.vars.palette.action.hoverOpacity})` : alpha(t.palette.text.primary, t.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": { backgroundColor: "transparent" }
  }, i.variant === "text" && i.color !== "inherit" && {
    backgroundColor: t.vars ? `rgba(${t.vars.palette[i.color].mainChannel} / ${t.vars.palette.action.hoverOpacity})` : alpha(t.palette[i.color].main, t.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": { backgroundColor: "transparent" }
  }, i.variant === "outlined" && i.color !== "inherit" && {
    border: `1px solid ${(t.vars || t).palette[i.color].main}`,
    backgroundColor: t.vars ? `rgba(${t.vars.palette[i.color].mainChannel} / ${t.vars.palette.action.hoverOpacity})` : alpha(t.palette[i.color].main, t.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": { backgroundColor: "transparent" }
  }, i.variant === "contained" && {
    backgroundColor: (t.vars || t).palette.grey.A100,
    boxShadow: (t.vars || t).shadows[4],
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": { boxShadow: (t.vars || t).shadows[2], backgroundColor: (t.vars || t).palette.grey[300] }
  }, i.variant === "contained" && i.color !== "inherit" && {
    backgroundColor: (t.vars || t).palette[i.color].dark,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": { backgroundColor: (t.vars || t).palette[i.color].main }
  }), "&:active": _extends({}, i.variant === "contained" && { boxShadow: (t.vars || t).shadows[8] }), [`&.${buttonClasses$1.focusVisible}`]: _extends({}, i.variant === "contained" && { boxShadow: (t.vars || t).shadows[6] }), [`&.${buttonClasses$1.disabled}`]: _extends({ color: (t.vars || t).palette.action.disabled }, i.variant === "outlined" && { border: `1px solid ${(t.vars || t).palette.action.disabledBackground}` }, i.variant === "contained" && { color: (t.vars || t).palette.action.disabled, boxShadow: (t.vars || t).shadows[0], backgroundColor: (t.vars || t).palette.action.disabledBackground }) }, i.variant === "text" && { padding: "6px 8px" }, i.variant === "text" && i.color !== "inherit" && { color: (t.vars || t).palette[i.color].main }, i.variant === "outlined" && { padding: "5px 15px", border: "1px solid currentColor" }, i.variant === "outlined" && i.color !== "inherit" && { color: (t.vars || t).palette[i.color].main, border: t.vars ? `1px solid rgba(${t.vars.palette[i.color].mainChannel} / 0.5)` : `1px solid ${alpha(t.palette[i.color].main, 0.5)}` }, i.variant === "contained" && { color: t.vars ? (
    // this is safe because grey does not change between default light/dark mode
    t.vars.palette.text.primary
  ) : (n = (a = t.palette).getContrastText) == null ? void 0 : n.call(a, t.palette.grey[300]), backgroundColor: (t.vars || t).palette.grey[300], boxShadow: (t.vars || t).shadows[2] }, i.variant === "contained" && i.color !== "inherit" && { color: (t.vars || t).palette[i.color].contrastText, backgroundColor: (t.vars || t).palette[i.color].main }, i.color === "inherit" && { color: "inherit", borderColor: "currentColor" }, i.size === "small" && i.variant === "text" && { padding: "4px 5px", fontSize: t.typography.pxToRem(13) }, i.size === "large" && i.variant === "text" && { padding: "8px 11px", fontSize: t.typography.pxToRem(15) }, i.size === "small" && i.variant === "outlined" && { padding: "3px 9px", fontSize: t.typography.pxToRem(13) }, i.size === "large" && i.variant === "outlined" && { padding: "7px 21px", fontSize: t.typography.pxToRem(15) }, i.size === "small" && i.variant === "contained" && { padding: "4px 10px", fontSize: t.typography.pxToRem(13) }, i.size === "large" && i.variant === "contained" && { padding: "8px 22px", fontSize: t.typography.pxToRem(15) }, i.fullWidth && { width: "100%" });
}, (e) => {
  let { ownerState: t } = e;
  return t.disableElevation && { boxShadow: "none", "&:hover": { boxShadow: "none" }, [`&.${buttonClasses$1.focusVisible}`]: { boxShadow: "none" }, "&:active": { boxShadow: "none" }, [`&.${buttonClasses$1.disabled}`]: { boxShadow: "none" } };
}), ButtonStartIcon = styled$1("span", { name: "MuiButton", slot: "StartIcon", overridesResolver: (e, t) => {
  const { ownerState: i } = e;
  return [t.startIcon, t[`iconSize${capitalize(i.size)}`]];
} })((e) => {
  let { ownerState: t } = e;
  return _extends({ display: "inherit", marginRight: 8, marginLeft: -4 }, t.size === "small" && { marginLeft: -2 }, commonIconStyles(t));
}), ButtonEndIcon = styled$1("span", { name: "MuiButton", slot: "EndIcon", overridesResolver: (e, t) => {
  const { ownerState: i } = e;
  return [t.endIcon, t[`iconSize${capitalize(i.size)}`]];
} })((e) => {
  let { ownerState: t } = e;
  return _extends({ display: "inherit", marginRight: -4, marginLeft: 8 }, t.size === "small" && { marginRight: -2 }, commonIconStyles(t));
}), Button$1 = /* @__PURE__ */ React.forwardRef(function(t, i) {
  const n = React.useContext(ButtonGroupContext$1), a = resolveProps(n, t), o = useThemeProps({ props: a, name: "MuiButton" }), { children: l, color: c = "primary", component: d = "button", className: u, disabled: m = !1, disableElevation: A = !1, disableFocusRipple: y = !1, endIcon: D, focusVisibleClassName: C, fullWidth: z = !1, size: R = "medium", startIcon: O, type: $, variant: k = "text" } = o, P = _objectWithoutPropertiesLoose$1(o, _excluded$2), L = _extends({}, o, { color: c, component: d, disabled: m, disableElevation: A, disableFocusRipple: y, fullWidth: z, size: R, type: $, variant: k }), F = useUtilityClasses(L), B = O && /* @__PURE__ */ jsx(ButtonStartIcon, { className: F.startIcon, ownerState: L, children: O }), G = D && /* @__PURE__ */ jsx(ButtonEndIcon, { className: F.endIcon, ownerState: L, children: D });
  return /* @__PURE__ */ jsxs(ButtonRoot, _extends({ ownerState: L, className: clsx(n.className, F.root, u), component: d, disabled: m, focusRipple: !y, focusVisibleClassName: clsx(F.focusVisible, C), ref: i, type: $ }, P, { classes: F, children: [B, l, G] }));
});
process.env.NODE_ENV !== "production" && (Button$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
     * The content of the component.
     */
  children: propTypesExports.node,
  /**
  * Override or extend the styles applied to the component.
  */
  classes: propTypesExports.object,
  /**
  * @ignore
  */
  className: propTypesExports.string,
  /**
  * The color of the component.
  * It supports both default and custom theme colors, which can be added as shown in the
  * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
  * @default 'primary'
  */
  color: propTypesExports.oneOfType([propTypesExports.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), propTypesExports.string]),
  /**
  * The component used for the root node.
  * Either a string to use a HTML element or a component.
  */
  component: propTypesExports.elementType,
  /**
  * If `true`, the component is disabled.
  * @default false
  */
  disabled: propTypesExports.bool,
  /**
  * If `true`, no elevation is used.
  * @default false
  */
  disableElevation: propTypesExports.bool,
  /**
  * If `true`, the  keyboard focus ripple is disabled.
  * @default false
  */
  disableFocusRipple: propTypesExports.bool,
  /**
  * If `true`, the ripple effect is disabled.
  *
  * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
  * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
  * @default false
  */
  disableRipple: propTypesExports.bool,
  /**
  * Element placed after the children.
  */
  endIcon: propTypesExports.node,
  /**
  * @ignore
  */
  focusVisibleClassName: propTypesExports.string,
  /**
  * If `true`, the button will take up the full width of its container.
  * @default false
  */
  fullWidth: propTypesExports.bool,
  /**
  * The URL to link to when the button is clicked.
  * If defined, an `a` element will be used as the root node.
  */
  href: propTypesExports.string,
  /**
  * The size of the component.
  * `small` is equivalent to the dense button styling.
  * @default 'medium'
  */
  size: propTypesExports.oneOfType([propTypesExports.oneOf(["small", "medium", "large"]), propTypesExports.string]),
  /**
  * Element placed before the children.
  */
  startIcon: propTypesExports.node,
  /**
  * The system prop that allows defining system overrides as well as additional CSS styles.
  */
  sx: propTypesExports.oneOfType([propTypesExports.arrayOf(propTypesExports.oneOfType([propTypesExports.func, propTypesExports.object, propTypesExports.bool])), propTypesExports.func, propTypesExports.object]),
  /**
  * @ignore
  */
  type: propTypesExports.oneOfType([propTypesExports.oneOf(["button", "reset", "submit"]), propTypesExports.string]),
  /**
  * The variant to use.
  * @default 'text'
  */
  variant: propTypesExports.oneOfType([propTypesExports.oneOf(["contained", "outlined", "text"]), propTypesExports.string])
});
const MButton = Button$1, CustomMuiButton$1 = styled$3(MButton)`
  &&& {
    width: ${(e) => {
  let { width: t } = e;
  return t || "100%";
}};
    height: ${(e) => {
  let { height: t } = e;
  return t || "52px";
}};
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
    border: 1px solid ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
    border-radius: 4px;
    color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
    ${fontStyle("16px", "700")}
    text-transform: none;
    box-shadow: 0px 1px 1px -2px rgba(0, 0, 0, 0.2);
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.12));

    :hover: {
      background: ${(e) => {
  let { theme: t } = e;
  return t.colors.hoverRefreshBtn;
}},
    },
  }`, RefreshButton = (e) => {
  let { width: t, height: i, iconWidth: n, onRefresh: a } = e;
  return /* @__PURE__ */ jsxs(CustomMuiButton$1, { width: t, height: i, onClick: a, children: [/* @__PURE__ */ jsx(StyledMaskIcon, { src: refreshIcon, width: n || "24px", mr: "12px" }), "Refresh"] });
};
function baseTimes$1(e, t) {
  for (var i = -1, n = Array(e); ++i < e; )
    n[i] = t(i);
  return n;
}
var _baseTimes = baseTimes$1, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$8 = freeGlobal || freeSelf || Function("return this")(), _root = root$8, root$7 = _root, Symbol$5 = root$7.Symbol, _Symbol = Symbol$5, Symbol$4 = _Symbol, objectProto$b = Object.prototype, hasOwnProperty$8 = objectProto$b.hasOwnProperty, nativeObjectToString$1 = objectProto$b.toString, symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$1(e) {
  var t = hasOwnProperty$8.call(e, symToStringTag$1), i = e[symToStringTag$1];
  try {
    e[symToStringTag$1] = void 0;
    var n = !0;
  } catch {
  }
  var a = nativeObjectToString$1.call(e);
  return n && (t ? e[symToStringTag$1] = i : delete e[symToStringTag$1]), a;
}
var _getRawTag = getRawTag$1, objectProto$a = Object.prototype, nativeObjectToString = objectProto$a.toString;
function objectToString$1(e) {
  return nativeObjectToString.call(e);
}
var _objectToString = objectToString$1, Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$5(e) {
  return e == null ? e === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(e) ? getRawTag(e) : objectToString(e);
}
var _baseGetTag = baseGetTag$5;
function isObjectLike$5(e) {
  return e != null && typeof e == "object";
}
var isObjectLike_1 = isObjectLike$5, baseGetTag$4 = _baseGetTag, isObjectLike$4 = isObjectLike_1, argsTag$2 = "[object Arguments]";
function baseIsArguments$1(e) {
  return isObjectLike$4(e) && baseGetTag$4(e) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1, baseIsArguments = _baseIsArguments, isObjectLike$3 = isObjectLike_1, objectProto$9 = Object.prototype, hasOwnProperty$7 = objectProto$9.hasOwnProperty, propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable, isArguments$2 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(e) {
  return isObjectLike$3(e) && hasOwnProperty$7.call(e, "callee") && !propertyIsEnumerable$1.call(e, "callee");
}, isArguments_1 = isArguments$2, isArray$9 = Array.isArray, isArray_1 = isArray$9, isBufferExports = {}, isBuffer$2 = { get exports() {
  return isBufferExports;
}, set exports(e) {
  isBufferExports = e;
} };
function stubFalse() {
  return !1;
}
var stubFalse_1 = stubFalse;
(function(e, t) {
  var i = _root, n = stubFalse_1, a = t && !t.nodeType && t, o = a && !0 && e && !e.nodeType && e, l = o && o.exports === a, c = l ? i.Buffer : void 0, d = c ? c.isBuffer : void 0, u = d || n;
  e.exports = u;
})(isBuffer$2, isBufferExports);
var MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$2(e, t) {
  var i = typeof e;
  return t = t ?? MAX_SAFE_INTEGER$1, !!t && (i == "number" || i != "symbol" && reIsUint.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var _isIndex = isIndex$2, MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3, baseGetTag$3 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$2 = isObjectLike_1, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag$1 = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray$1(e) {
  return isObjectLike$2(e) && isLength$2(e.length) && !!typedArrayTags[baseGetTag$3(e)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$1(e) {
  return function(t) {
    return e(t);
  };
}
var _baseUnary = baseUnary$1, _nodeUtilExports = {}, _nodeUtil = { get exports() {
  return _nodeUtilExports;
}, set exports(e) {
  _nodeUtilExports = e;
} };
(function(e, t) {
  var i = _freeGlobal, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, o = a && a.exports === n, l = o && i.process, c = function() {
    try {
      var d = a && a.require && a.require("util").types;
      return d || l && l.binding && l.binding("util");
    } catch {
    }
  }();
  e.exports = c;
})(_nodeUtil, _nodeUtilExports);
var baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, isTypedArray_1 = isTypedArray$2, baseTimes = _baseTimes, isArguments$1 = isArguments_1, isArray$8 = isArray_1, isBuffer$1 = isBufferExports, isIndex$1 = _isIndex, isTypedArray$1 = isTypedArray_1, objectProto$8 = Object.prototype, hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function arrayLikeKeys$1(e, t) {
  var i = isArray$8(e), n = !i && isArguments$1(e), a = !i && !n && isBuffer$1(e), o = !i && !n && !a && isTypedArray$1(e), l = i || n || a || o, c = l ? baseTimes(e.length, String) : [], d = c.length;
  for (var u in e)
    (t || hasOwnProperty$6.call(e, u)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    isIndex$1(u, d))) && c.push(u);
  return c;
}
var _arrayLikeKeys = arrayLikeKeys$1, objectProto$7 = Object.prototype;
function isPrototype$1(e) {
  var t = e && e.constructor, i = typeof t == "function" && t.prototype || objectProto$7;
  return e === i;
}
var _isPrototype = isPrototype$1;
function overArg$1(e, t) {
  return function(i) {
    return e(t(i));
  };
}
var _overArg = overArg$1, overArg = _overArg, nativeKeys$1 = overArg(Object.keys, Object), _nativeKeys = nativeKeys$1, isPrototype = _isPrototype, nativeKeys = _nativeKeys, objectProto$6 = Object.prototype, hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function baseKeys$1(e) {
  if (!isPrototype(e))
    return nativeKeys(e);
  var t = [];
  for (var i in Object(e))
    hasOwnProperty$5.call(e, i) && i != "constructor" && t.push(i);
  return t;
}
var _baseKeys = baseKeys$1;
function isObject$3(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var isObject_1 = isObject$3, baseGetTag$2 = _baseGetTag, isObject$2 = isObject_1, asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(e) {
  if (!isObject$2(e))
    return !1;
  var t = baseGetTag$2(e);
  return t == funcTag || t == genTag || t == asyncTag || t == proxyTag;
}
var isFunction_1 = isFunction$2, isFunction$1 = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$2(e) {
  return e != null && isLength$1(e.length) && !isFunction$1(e);
}
var isArrayLike_1 = isArrayLike$2, arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$1 = isArrayLike_1;
function keys$3(e) {
  return isArrayLike$1(e) ? arrayLikeKeys(e) : baseKeys(e);
}
var keys_1 = keys$3, Mode = /* @__PURE__ */ ((e) => (e[e.NORMAL = 0] = "NORMAL", e[e.DARK = 1] = "DARK", e))(Mode || {}), TradeMark = /* @__PURE__ */ ((e) => (e[e.BLACK = 0] = "BLACK", e[e.WHITE = 1] = "WHITE", e))(TradeMark || {});
const StyledPosition = styled$3(Row)`
  width: 100%;
  position: relative;
  height: 0;
  margin-top: 50px;

  @media ${MD_AND_DOWN_QUERY} {
    height: 146px;
  }
`, StyledContainer$3 = styled$3.div`
  width: 100%;
  position: absolute;
  top: 0;
  background-color: ${(e) => {
  let { theme: t, mode: i } = e;
  return i === Mode.DARK ? t.colors.black : t.colors.white;
}};
  padding-bottom: 40px;

  @media ${MD_AND_DOWN_QUERY} {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 32px 0 40px;
  }
`, StyledContent$2 = styled$3(Row)`
  flex-direction: row;

  @media ${MD_AND_DOWN_QUERY} {
    flex-direction: column;
  }
`, StyledSocialMeidaRow = styled$3.div`
  display: flex;
  align-items: center;

  & > a:last-child > div {
    margin-right: 0;
  }
`, StyledImage$2 = styled$3.img`
  width: ${(e) => {
  let { width: t } = e;
  return t;
}}px;
  margin-right: 32px;

  @media ${MD_AND_DOWN_QUERY} {
    width: ${(e) => {
  let { mobileWidth: t } = e;
  return t;
}}px;
    margin-bottom: 28px;
    margin-right: 0;
  }
`, StyledIcon = styled$3.div`
  width: 32px;
  height: 32px;
  mask-image: ${(e) => {
  let { src: t } = e;
  return `url(${t})`;
}};
  margin-right: 12px;
  background: ${(e) => {
  let { theme: t, mode: i, socialIconColor: n } = e;
  return n || (i === Mode.DARK ? t.colors.white : t.colors.black);
}};

  &:hover {
    background: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
  }
`, StyledFooterTextContainer = styled$3.div`
  & > div:not(:last-child) {
    margin-bottom: 6px;
  }
`, StyledFooterText = styled$3.div`
  font-size: 12px;
  margin-right: 24px;
  color: ${(e) => {
  let { mode: t, theme: i } = e;
  return t === Mode.DARK ? i.colors.white : "rgba(0, 0, 0, 0.6)";
}};

  @media ${MD_AND_DOWN_QUERY} {
    margin-right: 0;
    margin-bottom: 16px;
    font-size: 10px;
  }
`, StyledDivide = styled$3.div`
  width: 100%;
  height: 1px;
  background-color: #d9d9d9;
  margin: 32px 0;
`, StyledBottomRow = styled$3.div`
  padding: 0 124px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  img {
    margin-right: 0;
  }

  @media ${MD_AND_DOWN_QUERY} {
    flex-direction: column;
    padding: 0;

    img {
      margin-bottom: 0;
    }
  }
`, StyledTopContainer = styled$3(Row)`
  padding: 32px 124px 0px;

  @media ${MD_AND_DOWN_QUERY} {
    padding-top: 0;
    flex-direction: column;
  }
`, date = /* @__PURE__ */ new Date(), year = date.getFullYear(), applySocialMedias = (e) => keys_1(e.footer).filter((t) => e.footer[t].isShow), Footer = (e) => {
  var l, c, d;
  let { customConfig: t, mode: i = Mode.NORMAL, forSales: n, socialIconColor: a, tradeMarkType: o = TradeMark.BLACK } = e;
  return /* @__PURE__ */ jsx(StyledPosition, { children: /* @__PURE__ */ jsxs(StyledContainer$3, { mode: i, children: [/* @__PURE__ */ jsxs(StyledTopContainer, { justify: "space-between", children: [/* @__PURE__ */ jsxs(StyledContent$2, { justify: "center", children: [/* @__PURE__ */ jsx("a", { rel: "noreferrer", href: t.footer.logo.link, target: "_blank", children: /* @__PURE__ */ jsx(StyledImage$2, { src: t.footer.logo.imgSrc, width: ((l = t.footer.logo) == null ? void 0 : l.width) || 100, mobileWidth: ((c = t.footer.logo) == null ? void 0 : c.mobileWidth) || 80 }) }), ((d = t.footer) == null ? void 0 : d.apiDocs) && /* @__PURE__ */ jsxs(StyledFooterTextContainer, { children: [/* @__PURE__ */ jsxs(StyledFooterText, { children: ["You can design for yourself using the 🔗", /* @__PURE__ */ jsx("a", { href: t.footer.apiDocs.link, target: "_blank", rel: "noreferrer", children: "API document" })] }), /* @__PURE__ */ jsx(StyledFooterText, { children: `Copyright © ${year}  RE:DREAMER Lab. All rights reserved.` })] })] }), /* @__PURE__ */ jsx(StyledSocialMeidaRow, { children: applySocialMedias(t).map((u) => {
    const m = t.footer[u];
    return /* @__PURE__ */ jsx("a", { rel: "noreferrer", href: m.link, target: "_blank", children: /* @__PURE__ */ jsx(StyledIcon, { src: m.imgSrc, mode: i, socialIconColor: a }) }, u);
  }) })] }), n && /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(StyledDivide, {}), /* @__PURE__ */ jsxs(StyledBottomRow, { children: [/* @__PURE__ */ jsx(StyledFooterText, { mode: i, children: `Copyright © ${year}  RE:DREAMER Lab. All rights reserved.` }), /* @__PURE__ */ jsx("a", { rel: "noreferrer", href: "https://www.redreamer.io/", target: "_blank", children: /* @__PURE__ */ jsx(StyledImage$2, { src: o === TradeMark.BLACK ? powerByRedreamerBlackIcon : powerByRedreamerWhiteIcon, width: 121 }) })] })] })] }) });
}, StyledHeader = styled$3.header`
  padding-top: ${(e) => {
  let { isTestnet: t } = e;
  return t ? "100px" : "60px";
}};
`, StyledNav = styled$3.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
  color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
  z-index: 5;
  border-bottom: 1px solid ${(e) => {
  let { theme: t } = e;
  return t.colors.gray;
}};
`, StyledContainer$2 = styled$3.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  font-size: 24px;
  padding: 0 20px 0 18px;

  @media ${SM_AND_UP_QUERY} {
    padding: 0 20px;
    max-width: 1228px;
    width: 100%;
    margin: 0 auto;
  }
`, StyledImage$1 = styled$3.img`
  height: 32px;
  cursor: pointer;
`, StyledNoticeBanner = styled$3(Row)`
  padding: 10px 0;
  width: 100%;
  background: ${(e) => {
  let { theme: t } = e;
  return t.colors.black;
}};
`, StyledNoticeText = styled$3.div`
  ${fontStyle("12px", "700")};
  color: ${(e) => {
  let { theme: t } = e;
  return t.colors.hope;
}};
`, StyledContainer$1 = styled$3.div`
  height: 24px;
  width: 24px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media ${SM_AND_UP_QUERY} {
    display: none;
  }
`, StyledContent$1 = styled$3.div`
  width: 18px;
  height: 2px;
  margin-bottom: 3px;
  background: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
`, Hamburger = (e) => {
  let { isOpen: t, onClick: i } = e;
  return /* @__PURE__ */ jsx(StyledContainer$1, { onClick: i, children: t ? /* @__PURE__ */ jsx(StyledMaskIcon, { src: closeIcon, width: "24px" }) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(StyledContent$1, {}), /* @__PURE__ */ jsx(StyledContent$1, {}), /* @__PURE__ */ jsx(StyledContent$1, {})] }) });
}, StyledWrapper$3 = styled$3.div`
  background: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
  height: ${(e) => {
  let { isTestnet: t } = e;
  return t ? "calc(100vh - 101px)" : "calc(100vh - 60px)";
}};
  display: ${(e) => {
  let { isShow: t } = e;
  return t ? "block" : "none";
}};
  position: fixed;
  top: ${(e) => {
  let { isTestnet: t } = e;
  return t ? "101px" : "60px";
}};
  left: 0;
  z-index: 15;
  width: 100%;

  @media ${SM_AND_UP_QUERY} {
    height: auto;
    position: absolute;
    top: calc(100% + 28px);
    left: -30px;
    border: 1px solid ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    width: 274px;
    padding-bottom: 13px;
  }
`, StyledList = styled$3(Row)`
  justify-content: center;
  flex-direction: column;
`, StyledNetwork = styled$3(Row)`
  padding: 15px 0;
  width: 260px;
  position: relative;

  @media ${SM_AND_UP_QUERY} {
    width: 224px;
    padding: 8px 0 8px 9px;
  }
`, StyledNetworkName = styled$3.div`
  ${fontStyle("16px")}
  font-weight: ${(e) => {
  let { isActive: t } = e;
  return t ? "700" : "normal";
}};
  color: ${(e) => {
  let { isActive: t, theme: i } = e;
  return t ? i.colors.brightDream : i.colors.black;
}};

  @media ${SM_AND_UP_QUERY} {
    ${fontStyle("12px")}
    font-weight: ${(e) => {
  let { isActive: t } = e;
  return t ? "700" : "normal";
}};
  }
`, StyledTitle = styled$3.div`
  ${fontStyle("16px", "700")}
  color: ${(e) => {
  let { theme: t } = e;
  return t.colors.black;
}};

  @media ${SM_AND_UP_QUERY} {
    ${fontStyle("12px", "700")}
  }
`, StyledTitleWrapper = styled$3(Row)`
  width: 100%;
  padding: 31px 0 25px 29px;

  @media ${SM_AND_UP_QUERY} {
    display: ${(e) => {
  let { hideElement: t } = e;
  return t ? "none" : "flex";
}};
    padding: 20px 0 6px 23px;
  }
`, StyledCheckMark = styled$3(StyledMaskIcon)`
  position: absolute;
  left: -20px;

  @media ${SM_AND_UP_QUERY} {
    left: -17px;
  }
`, StyledNetworkHover = styled$3(Row)`
  justify-content: center;
  width: 100%;
  cursor: pointer;

  &:hover {
    background: ${(e) => {
  let { theme: t } = e;
  return `${t.colors.brightDream}0c`;
}};
  }

  @media ${SM_AND_UP_QUERY} {
    padding-left: 32px;
  }
`, StyledWalletAddressWrapper = styled$3(Row)`
  @media ${SM_AND_UP_QUERY} {
    width: auto;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`, StyledWalletAddress = styled$3.div`
  ${fontStyle("16px", "500")};
  color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};

  @media ${SM_AND_UP_QUERY} {
    ${fontStyle("14px", "500")};
  }
`, NavbarContext = createContext({ isMainnet: !1, currentChainType: "", switchNetworks: [], walletAddress: "", hideNetwork: !1, onResetAuth: () => {
}, onLogoClick: () => {
}, onSwitchChainRedirect: () => {
}, onLogError: () => {
}, children: React__default.createElement("div") }), Provider$1 = (e) => {
  const t = { ...e };
  return /* @__PURE__ */ jsx(NavbarContext.Provider, { value: t, children: e.children });
}, useNavbarContext = () => useContext(NavbarContext), NavbarProvider = Provider$1;
function noop() {
}
var noop_1 = noop, dist$1 = {}, dist = {}, eosjsApi = {}, pako = {}, deflate$4 = {}, deflate$3 = {}, trees = {};
const Z_FIXED$1 = 4, Z_BINARY = 0, Z_TEXT = 1, Z_UNKNOWN$1 = 2;
function zero$1(e) {
  let t = e.length;
  for (; --t >= 0; )
    e[t] = 0;
}
const STORED_BLOCK = 0, STATIC_TREES = 1, DYN_TREES = 2, MIN_MATCH$1 = 3, MAX_MATCH$1 = 258, LENGTH_CODES$1 = 29, LITERALS$1 = 256, L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1, D_CODES$1 = 30, BL_CODES$1 = 19, HEAP_SIZE$1 = 2 * L_CODES$1 + 1, MAX_BITS$1 = 15, Buf_size = 16, MAX_BL_BITS = 7, END_BLOCK = 256, REP_3_6 = 16, REPZ_3_10 = 17, REPZ_11_138 = 18, extra_lbits = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), extra_dbits = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), extra_blbits = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), DIST_CODE_LEN = 512, static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
const static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
const _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
const _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
const base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
const base_dist = new Array(D_CODES$1);
zero$1(base_dist);
function StaticTreeDesc(e, t, i, n, a) {
  this.static_tree = e, this.extra_bits = t, this.extra_base = i, this.elems = n, this.max_length = a, this.has_stree = e && e.length;
}
let static_l_desc, static_d_desc, static_bl_desc;
function TreeDesc(e, t) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
}
const d_code = (e) => e < 256 ? _dist_code[e] : _dist_code[256 + (e >>> 7)], put_short = (e, t) => {
  e.pending_buf[e.pending++] = t & 255, e.pending_buf[e.pending++] = t >>> 8 & 255;
}, send_bits = (e, t, i) => {
  e.bi_valid > Buf_size - i ? (e.bi_buf |= t << e.bi_valid & 65535, put_short(e, e.bi_buf), e.bi_buf = t >> Buf_size - e.bi_valid, e.bi_valid += i - Buf_size) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += i);
}, send_code = (e, t, i) => {
  send_bits(
    e,
    i[t * 2],
    i[t * 2 + 1]
    /*.Len*/
  );
}, bi_reverse = (e, t) => {
  let i = 0;
  do
    i |= e & 1, e >>>= 1, i <<= 1;
  while (--t > 0);
  return i >>> 1;
}, bi_flush = (e) => {
  e.bi_valid === 16 ? (put_short(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}, gen_bitlen = (e, t) => {
  const i = t.dyn_tree, n = t.max_code, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, l = t.stat_desc.extra_bits, c = t.stat_desc.extra_base, d = t.stat_desc.max_length;
  let u, m, A, y, D, C, z = 0;
  for (y = 0; y <= MAX_BITS$1; y++)
    e.bl_count[y] = 0;
  for (i[e.heap[e.heap_max] * 2 + 1] = 0, u = e.heap_max + 1; u < HEAP_SIZE$1; u++)
    m = e.heap[u], y = i[i[m * 2 + 1] * 2 + 1] + 1, y > d && (y = d, z++), i[m * 2 + 1] = y, !(m > n) && (e.bl_count[y]++, D = 0, m >= c && (D = l[m - c]), C = i[m * 2], e.opt_len += C * (y + D), o && (e.static_len += C * (a[m * 2 + 1] + D)));
  if (z !== 0) {
    do {
      for (y = d - 1; e.bl_count[y] === 0; )
        y--;
      e.bl_count[y]--, e.bl_count[y + 1] += 2, e.bl_count[d]--, z -= 2;
    } while (z > 0);
    for (y = d; y !== 0; y--)
      for (m = e.bl_count[y]; m !== 0; )
        A = e.heap[--u], !(A > n) && (i[A * 2 + 1] !== y && (e.opt_len += (y - i[A * 2 + 1]) * i[A * 2], i[A * 2 + 1] = y), m--);
  }
}, gen_codes = (e, t, i) => {
  const n = new Array(MAX_BITS$1 + 1);
  let a = 0, o, l;
  for (o = 1; o <= MAX_BITS$1; o++)
    n[o] = a = a + i[o - 1] << 1;
  for (l = 0; l <= t; l++) {
    let c = e[l * 2 + 1];
    c !== 0 && (e[l * 2] = bi_reverse(n[c]++, c));
  }
}, tr_static_init = () => {
  let e, t, i, n, a;
  const o = new Array(MAX_BITS$1 + 1);
  for (i = 0, n = 0; n < LENGTH_CODES$1 - 1; n++)
    for (base_length[n] = i, e = 0; e < 1 << extra_lbits[n]; e++)
      _length_code[i++] = n;
  for (_length_code[i - 1] = n, a = 0, n = 0; n < 16; n++)
    for (base_dist[n] = a, e = 0; e < 1 << extra_dbits[n]; e++)
      _dist_code[a++] = n;
  for (a >>= 7; n < D_CODES$1; n++)
    for (base_dist[n] = a << 7, e = 0; e < 1 << extra_dbits[n] - 7; e++)
      _dist_code[256 + a++] = n;
  for (t = 0; t <= MAX_BITS$1; t++)
    o[t] = 0;
  for (e = 0; e <= 143; )
    static_ltree[e * 2 + 1] = 8, e++, o[8]++;
  for (; e <= 255; )
    static_ltree[e * 2 + 1] = 9, e++, o[9]++;
  for (; e <= 279; )
    static_ltree[e * 2 + 1] = 7, e++, o[7]++;
  for (; e <= 287; )
    static_ltree[e * 2 + 1] = 8, e++, o[8]++;
  for (gen_codes(static_ltree, L_CODES$1 + 1, o), e = 0; e < D_CODES$1; e++)
    static_dtree[e * 2 + 1] = 5, static_dtree[e * 2] = bi_reverse(e, 5);
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1), static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1), static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
}, init_block = (e) => {
  let t;
  for (t = 0; t < L_CODES$1; t++)
    e.dyn_ltree[t * 2] = 0;
  for (t = 0; t < D_CODES$1; t++)
    e.dyn_dtree[t * 2] = 0;
  for (t = 0; t < BL_CODES$1; t++)
    e.bl_tree[t * 2] = 0;
  e.dyn_ltree[END_BLOCK * 2] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
}, bi_windup = (e) => {
  e.bi_valid > 8 ? put_short(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}, copy_block = (e, t, i, n) => {
  bi_windup(e), n && (put_short(e, i), put_short(e, ~i)), e.pending_buf.set(e.window.subarray(t, t + i), e.pending), e.pending += i;
}, smaller = (e, t, i, n) => {
  const a = t * 2, o = i * 2;
  return e[a] < e[o] || e[a] === e[o] && n[t] <= n[i];
}, pqdownheap = (e, t, i) => {
  const n = e.heap[i];
  let a = i << 1;
  for (; a <= e.heap_len && (a < e.heap_len && smaller(t, e.heap[a + 1], e.heap[a], e.depth) && a++, !smaller(t, n, e.heap[a], e.depth)); )
    e.heap[i] = e.heap[a], i = a, a <<= 1;
  e.heap[i] = n;
}, compress_block = (e, t, i) => {
  let n, a, o = 0, l, c;
  if (e.last_lit !== 0)
    do
      n = e.pending_buf[e.d_buf + o * 2] << 8 | e.pending_buf[e.d_buf + o * 2 + 1], a = e.pending_buf[e.l_buf + o], o++, n === 0 ? send_code(e, a, t) : (l = _length_code[a], send_code(e, l + LITERALS$1 + 1, t), c = extra_lbits[l], c !== 0 && (a -= base_length[l], send_bits(e, a, c)), n--, l = d_code(n), send_code(e, l, i), c = extra_dbits[l], c !== 0 && (n -= base_dist[l], send_bits(e, n, c)));
    while (o < e.last_lit);
  send_code(e, END_BLOCK, t);
}, build_tree = (e, t) => {
  const i = t.dyn_tree, n = t.stat_desc.static_tree, a = t.stat_desc.has_stree, o = t.stat_desc.elems;
  let l, c, d = -1, u;
  for (e.heap_len = 0, e.heap_max = HEAP_SIZE$1, l = 0; l < o; l++)
    i[l * 2] !== 0 ? (e.heap[++e.heap_len] = d = l, e.depth[l] = 0) : i[l * 2 + 1] = 0;
  for (; e.heap_len < 2; )
    u = e.heap[++e.heap_len] = d < 2 ? ++d : 0, i[u * 2] = 1, e.depth[u] = 0, e.opt_len--, a && (e.static_len -= n[u * 2 + 1]);
  for (t.max_code = d, l = e.heap_len >> 1; l >= 1; l--)
    pqdownheap(e, i, l);
  u = o;
  do
    l = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[
      1
      /*SMALLEST*/
    ] = e.heap[e.heap_len--], pqdownheap(
      e,
      i,
      1
      /*SMALLEST*/
    ), c = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[--e.heap_max] = l, e.heap[--e.heap_max] = c, i[u * 2] = i[l * 2] + i[c * 2], e.depth[u] = (e.depth[l] >= e.depth[c] ? e.depth[l] : e.depth[c]) + 1, i[l * 2 + 1] = i[c * 2 + 1] = u, e.heap[
      1
      /*SMALLEST*/
    ] = u++, pqdownheap(
      e,
      i,
      1
      /*SMALLEST*/
    );
  while (e.heap_len >= 2);
  e.heap[--e.heap_max] = e.heap[
    1
    /*SMALLEST*/
  ], gen_bitlen(e, t), gen_codes(i, d, e.bl_count);
}, scan_tree = (e, t, i) => {
  let n, a = -1, o, l = t[0 * 2 + 1], c = 0, d = 7, u = 4;
  for (l === 0 && (d = 138, u = 3), t[(i + 1) * 2 + 1] = 65535, n = 0; n <= i; n++)
    o = l, l = t[(n + 1) * 2 + 1], !(++c < d && o === l) && (c < u ? e.bl_tree[o * 2] += c : o !== 0 ? (o !== a && e.bl_tree[o * 2]++, e.bl_tree[REP_3_6 * 2]++) : c <= 10 ? e.bl_tree[REPZ_3_10 * 2]++ : e.bl_tree[REPZ_11_138 * 2]++, c = 0, a = o, l === 0 ? (d = 138, u = 3) : o === l ? (d = 6, u = 3) : (d = 7, u = 4));
}, send_tree = (e, t, i) => {
  let n, a = -1, o, l = t[0 * 2 + 1], c = 0, d = 7, u = 4;
  for (l === 0 && (d = 138, u = 3), n = 0; n <= i; n++)
    if (o = l, l = t[(n + 1) * 2 + 1], !(++c < d && o === l)) {
      if (c < u)
        do
          send_code(e, o, e.bl_tree);
        while (--c !== 0);
      else
        o !== 0 ? (o !== a && (send_code(e, o, e.bl_tree), c--), send_code(e, REP_3_6, e.bl_tree), send_bits(e, c - 3, 2)) : c <= 10 ? (send_code(e, REPZ_3_10, e.bl_tree), send_bits(e, c - 3, 3)) : (send_code(e, REPZ_11_138, e.bl_tree), send_bits(e, c - 11, 7));
      c = 0, a = o, l === 0 ? (d = 138, u = 3) : o === l ? (d = 6, u = 3) : (d = 7, u = 4);
    }
}, build_bl_tree = (e) => {
  let t;
  for (scan_tree(e, e.dyn_ltree, e.l_desc.max_code), scan_tree(e, e.dyn_dtree, e.d_desc.max_code), build_tree(e, e.bl_desc), t = BL_CODES$1 - 1; t >= 3 && e.bl_tree[bl_order[t] * 2 + 1] === 0; t--)
    ;
  return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
}, send_all_trees = (e, t, i, n) => {
  let a;
  for (send_bits(e, t - 257, 5), send_bits(e, i - 1, 5), send_bits(e, n - 4, 4), a = 0; a < n; a++)
    send_bits(e, e.bl_tree[bl_order[a] * 2 + 1], 3);
  send_tree(e, e.dyn_ltree, t - 1), send_tree(e, e.dyn_dtree, i - 1);
}, detect_data_type = (e) => {
  let t = 4093624447, i;
  for (i = 0; i <= 31; i++, t >>>= 1)
    if (t & 1 && e.dyn_ltree[i * 2] !== 0)
      return Z_BINARY;
  if (e.dyn_ltree[9 * 2] !== 0 || e.dyn_ltree[10 * 2] !== 0 || e.dyn_ltree[13 * 2] !== 0)
    return Z_TEXT;
  for (i = 32; i < LITERALS$1; i++)
    if (e.dyn_ltree[i * 2] !== 0)
      return Z_TEXT;
  return Z_BINARY;
};
let static_init_done = !1;
const _tr_init$1 = (e) => {
  static_init_done || (tr_static_init(), static_init_done = !0), e.l_desc = new TreeDesc(e.dyn_ltree, static_l_desc), e.d_desc = new TreeDesc(e.dyn_dtree, static_d_desc), e.bl_desc = new TreeDesc(e.bl_tree, static_bl_desc), e.bi_buf = 0, e.bi_valid = 0, init_block(e);
}, _tr_stored_block$1 = (e, t, i, n) => {
  send_bits(e, (STORED_BLOCK << 1) + (n ? 1 : 0), 3), copy_block(e, t, i, !0);
}, _tr_align$1 = (e) => {
  send_bits(e, STATIC_TREES << 1, 3), send_code(e, END_BLOCK, static_ltree), bi_flush(e);
}, _tr_flush_block$1 = (e, t, i, n) => {
  let a, o, l = 0;
  e.level > 0 ? (e.strm.data_type === Z_UNKNOWN$1 && (e.strm.data_type = detect_data_type(e)), build_tree(e, e.l_desc), build_tree(e, e.d_desc), l = build_bl_tree(e), a = e.opt_len + 3 + 7 >>> 3, o = e.static_len + 3 + 7 >>> 3, o <= a && (a = o)) : a = o = i + 5, i + 4 <= a && t !== -1 ? _tr_stored_block$1(e, t, i, n) : e.strategy === Z_FIXED$1 || o === a ? (send_bits(e, (STATIC_TREES << 1) + (n ? 1 : 0), 3), compress_block(e, static_ltree, static_dtree)) : (send_bits(e, (DYN_TREES << 1) + (n ? 1 : 0), 3), send_all_trees(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, l + 1), compress_block(e, e.dyn_ltree, e.dyn_dtree)), init_block(e), n && bi_windup(e);
}, _tr_tally$1 = (e, t, i) => (e.pending_buf[e.d_buf + e.last_lit * 2] = t >>> 8 & 255, e.pending_buf[e.d_buf + e.last_lit * 2 + 1] = t & 255, e.pending_buf[e.l_buf + e.last_lit] = i & 255, e.last_lit++, t === 0 ? e.dyn_ltree[i * 2]++ : (e.matches++, t--, e.dyn_ltree[(_length_code[i] + LITERALS$1 + 1) * 2]++, e.dyn_dtree[d_code(t) * 2]++), e.last_lit === e.lit_bufsize - 1);
trees._tr_init = _tr_init$1;
trees._tr_stored_block = _tr_stored_block$1;
trees._tr_flush_block = _tr_flush_block$1;
trees._tr_tally = _tr_tally$1;
trees._tr_align = _tr_align$1;
const adler32$2 = (e, t, i, n) => {
  let a = e & 65535 | 0, o = e >>> 16 & 65535 | 0, l = 0;
  for (; i !== 0; ) {
    l = i > 2e3 ? 2e3 : i, i -= l;
    do
      a = a + t[n++] | 0, o = o + a | 0;
    while (--l);
    a %= 65521, o %= 65521;
  }
  return a | o << 16 | 0;
};
var adler32_1 = adler32$2;
const makeTable = () => {
  let e, t = [];
  for (var i = 0; i < 256; i++) {
    e = i;
    for (var n = 0; n < 8; n++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    t[i] = e;
  }
  return t;
}, crcTable = new Uint32Array(makeTable()), crc32$2 = (e, t, i, n) => {
  const a = crcTable, o = n + i;
  e ^= -1;
  for (let l = n; l < o; l++)
    e = e >>> 8 ^ a[(e ^ t[l]) & 255];
  return e ^ -1;
};
var crc32_1 = crc32$2, messages = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, constants$1 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees, adler32$1 = adler32_1, crc32$1 = crc32_1, msg$2 = messages, { Z_NO_FLUSH: Z_NO_FLUSH$2, Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$3, Z_BLOCK: Z_BLOCK$1, Z_OK: Z_OK$3, Z_STREAM_END: Z_STREAM_END$3, Z_STREAM_ERROR: Z_STREAM_ERROR$2, Z_DATA_ERROR: Z_DATA_ERROR$2, Z_BUF_ERROR: Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1, Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1, Z_UNKNOWN, Z_DEFLATED: Z_DEFLATED$2 } = constants$1, MAX_MEM_LEVEL = 9, MAX_WBITS$1 = 15, DEF_MEM_LEVEL = 8, LENGTH_CODES = 29, LITERALS = 256, L_CODES = LITERALS + 1 + LENGTH_CODES, D_CODES = 30, BL_CODES = 19, HEAP_SIZE = 2 * L_CODES + 1, MAX_BITS = 15, MIN_MATCH = 3, MAX_MATCH = 258, MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1, PRESET_DICT = 32, INIT_STATE = 42, EXTRA_STATE = 69, NAME_STATE = 73, COMMENT_STATE = 91, HCRC_STATE = 103, BUSY_STATE = 113, FINISH_STATE = 666, BS_NEED_MORE = 1, BS_BLOCK_DONE = 2, BS_FINISH_STARTED = 3, BS_FINISH_DONE = 4, OS_CODE = 3, err = (e, t) => (e.msg = msg$2[t], t), rank = (e) => (e << 1) - (e > 4 ? 9 : 0), zero = (e) => {
  let t = e.length;
  for (; --t >= 0; )
    e[t] = 0;
};
let HASH_ZLIB = (e, t, i) => (t << e.hash_shift ^ i) & e.hash_mask, HASH = HASH_ZLIB;
const flush_pending = (e) => {
  const t = e.state;
  let i = t.pending;
  i > e.avail_out && (i = e.avail_out), i !== 0 && (e.output.set(t.pending_buf.subarray(t.pending_out, t.pending_out + i), e.next_out), e.next_out += i, t.pending_out += i, e.total_out += i, e.avail_out -= i, t.pending -= i, t.pending === 0 && (t.pending_out = 0));
}, flush_block_only = (e, t) => {
  _tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, flush_pending(e.strm);
}, put_byte = (e, t) => {
  e.pending_buf[e.pending++] = t;
}, putShortMSB = (e, t) => {
  e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = t & 255;
}, read_buf = (e, t, i, n) => {
  let a = e.avail_in;
  return a > n && (a = n), a === 0 ? 0 : (e.avail_in -= a, t.set(e.input.subarray(e.next_in, e.next_in + a), i), e.state.wrap === 1 ? e.adler = adler32$1(e.adler, t, a, i) : e.state.wrap === 2 && (e.adler = crc32$1(e.adler, t, a, i)), e.next_in += a, e.total_in += a, a);
}, longest_match = (e, t) => {
  let i = e.max_chain_length, n = e.strstart, a, o, l = e.prev_length, c = e.nice_match;
  const d = e.strstart > e.w_size - MIN_LOOKAHEAD ? e.strstart - (e.w_size - MIN_LOOKAHEAD) : 0, u = e.window, m = e.w_mask, A = e.prev, y = e.strstart + MAX_MATCH;
  let D = u[n + l - 1], C = u[n + l];
  e.prev_length >= e.good_match && (i >>= 2), c > e.lookahead && (c = e.lookahead);
  do
    if (a = t, !(u[a + l] !== C || u[a + l - 1] !== D || u[a] !== u[n] || u[++a] !== u[n + 1])) {
      n += 2, a++;
      do
        ;
      while (u[++n] === u[++a] && u[++n] === u[++a] && u[++n] === u[++a] && u[++n] === u[++a] && u[++n] === u[++a] && u[++n] === u[++a] && u[++n] === u[++a] && u[++n] === u[++a] && n < y);
      if (o = MAX_MATCH - (y - n), n = y - MAX_MATCH, o > l) {
        if (e.match_start = t, l = o, o >= c)
          break;
        D = u[n + l - 1], C = u[n + l];
      }
    }
  while ((t = A[t & m]) > d && --i !== 0);
  return l <= e.lookahead ? l : e.lookahead;
}, fill_window = (e) => {
  const t = e.w_size;
  let i, n, a, o, l;
  do {
    if (o = e.window_size - e.lookahead - e.strstart, e.strstart >= t + (t - MIN_LOOKAHEAD)) {
      e.window.set(e.window.subarray(t, t + t), 0), e.match_start -= t, e.strstart -= t, e.block_start -= t, n = e.hash_size, i = n;
      do
        a = e.head[--i], e.head[i] = a >= t ? a - t : 0;
      while (--n);
      n = t, i = n;
      do
        a = e.prev[--i], e.prev[i] = a >= t ? a - t : 0;
      while (--n);
      o += t;
    }
    if (e.strm.avail_in === 0)
      break;
    if (n = read_buf(e.strm, e.window, e.strstart + e.lookahead, o), e.lookahead += n, e.lookahead + e.insert >= MIN_MATCH)
      for (l = e.strstart - e.insert, e.ins_h = e.window[l], e.ins_h = HASH(e, e.ins_h, e.window[l + 1]); e.insert && (e.ins_h = HASH(e, e.ins_h, e.window[l + MIN_MATCH - 1]), e.prev[l & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = l, l++, e.insert--, !(e.lookahead + e.insert < MIN_MATCH)); )
        ;
  } while (e.lookahead < MIN_LOOKAHEAD && e.strm.avail_in !== 0);
}, deflate_stored = (e, t) => {
  let i = 65535;
  for (i > e.pending_buf_size - 5 && (i = e.pending_buf_size - 5); ; ) {
    if (e.lookahead <= 1) {
      if (fill_window(e), e.lookahead === 0 && t === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    e.strstart += e.lookahead, e.lookahead = 0;
    const n = e.block_start + i;
    if ((e.strstart === 0 || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, flush_block_only(e, !1), e.strm.avail_out === 0) || e.strstart - e.block_start >= e.w_size - MIN_LOOKAHEAD && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = 0, t === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : (e.strstart > e.block_start && (flush_block_only(e, !1), e.strm.avail_out === 0), BS_NEED_MORE);
}, deflate_fast = (e, t) => {
  let i, n;
  for (; ; ) {
    if (e.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(e), e.lookahead < MIN_LOOKAHEAD && t === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    if (i = 0, e.lookahead >= MIN_MATCH && (e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), i !== 0 && e.strstart - i <= e.w_size - MIN_LOOKAHEAD && (e.match_length = longest_match(e, i)), e.match_length >= MIN_MATCH)
      if (n = _tr_tally(e, e.strstart - e.match_start, e.match_length - MIN_MATCH), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= MIN_MATCH) {
        e.match_length--;
        do
          e.strstart++, e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
        while (--e.match_length !== 0);
        e.strstart++;
      } else
        e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + 1]);
    else
      n = _tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
    if (n && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = e.strstart < MIN_MATCH - 1 ? e.strstart : MIN_MATCH - 1, t === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.last_lit && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_slow = (e, t) => {
  let i, n, a;
  for (; ; ) {
    if (e.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(e), e.lookahead < MIN_LOOKAHEAD && t === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    if (i = 0, e.lookahead >= MIN_MATCH && (e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = MIN_MATCH - 1, i !== 0 && e.prev_length < e.max_lazy_match && e.strstart - i <= e.w_size - MIN_LOOKAHEAD && (e.match_length = longest_match(e, i), e.match_length <= 5 && (e.strategy === Z_FILTERED || e.match_length === MIN_MATCH && e.strstart - e.match_start > 4096) && (e.match_length = MIN_MATCH - 1)), e.prev_length >= MIN_MATCH && e.match_length <= e.prev_length) {
      a = e.strstart + e.lookahead - MIN_MATCH, n = _tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - MIN_MATCH), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
      do
        ++e.strstart <= a && (e.ins_h = HASH(e, e.ins_h, e.window[e.strstart + MIN_MATCH - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
      while (--e.prev_length !== 0);
      if (e.match_available = 0, e.match_length = MIN_MATCH - 1, e.strstart++, n && (flush_block_only(e, !1), e.strm.avail_out === 0))
        return BS_NEED_MORE;
    } else if (e.match_available) {
      if (n = _tr_tally(e, 0, e.window[e.strstart - 1]), n && flush_block_only(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0)
        return BS_NEED_MORE;
    } else
      e.match_available = 1, e.strstart++, e.lookahead--;
  }
  return e.match_available && (n = _tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < MIN_MATCH - 1 ? e.strstart : MIN_MATCH - 1, t === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.last_lit && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_rle = (e, t) => {
  let i, n, a, o;
  const l = e.window;
  for (; ; ) {
    if (e.lookahead <= MAX_MATCH) {
      if (fill_window(e), e.lookahead <= MAX_MATCH && t === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      if (e.lookahead === 0)
        break;
    }
    if (e.match_length = 0, e.lookahead >= MIN_MATCH && e.strstart > 0 && (a = e.strstart - 1, n = l[a], n === l[++a] && n === l[++a] && n === l[++a])) {
      o = e.strstart + MAX_MATCH;
      do
        ;
      while (n === l[++a] && n === l[++a] && n === l[++a] && n === l[++a] && n === l[++a] && n === l[++a] && n === l[++a] && n === l[++a] && a < o);
      e.match_length = MAX_MATCH - (o - a), e.match_length > e.lookahead && (e.match_length = e.lookahead);
    }
    if (e.match_length >= MIN_MATCH ? (i = _tr_tally(e, 1, e.match_length - MIN_MATCH), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (i = _tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), i && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = 0, t === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.last_lit && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}, deflate_huff = (e, t) => {
  let i;
  for (; ; ) {
    if (e.lookahead === 0 && (fill_window(e), e.lookahead === 0)) {
      if (t === Z_NO_FLUSH$2)
        return BS_NEED_MORE;
      break;
    }
    if (e.match_length = 0, i = _tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, i && (flush_block_only(e, !1), e.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return e.insert = 0, t === Z_FINISH$3 ? (flush_block_only(e, !0), e.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : e.last_lit && (flush_block_only(e, !1), e.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
};
function Config(e, t, i, n, a) {
  this.good_length = e, this.max_lazy = t, this.nice_length = i, this.max_chain = n, this.func = a;
}
const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),
  /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),
  /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),
  /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),
  /* 3 */
  new Config(4, 4, 16, 16, deflate_slow),
  /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),
  /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),
  /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),
  /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),
  /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)
  /* 9 max compression */
], lm_init = (e) => {
  e.window_size = 2 * e.w_size, zero(e.head), e.max_lazy_match = configuration_table[e.level].max_lazy, e.good_match = configuration_table[e.level].good_length, e.nice_match = configuration_table[e.level].nice_length, e.max_chain_length = configuration_table[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = MIN_MATCH - 1, e.match_available = 0, e.ins_h = 0;
};
function DeflateState() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Z_DEFLATED$2, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2), this.dyn_dtree = new Uint16Array((2 * D_CODES + 1) * 2), this.bl_tree = new Uint16Array((2 * BL_CODES + 1) * 2), zero(this.dyn_ltree), zero(this.dyn_dtree), zero(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(MAX_BITS + 1), this.heap = new Uint16Array(2 * L_CODES + 1), zero(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * L_CODES + 1), zero(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const deflateResetKeep = (e) => {
  if (!e || !e.state)
    return err(e, Z_STREAM_ERROR$2);
  e.total_in = e.total_out = 0, e.data_type = Z_UNKNOWN;
  const t = e.state;
  return t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? INIT_STATE : BUSY_STATE, e.adler = t.wrap === 2 ? 0 : 1, t.last_flush = Z_NO_FLUSH$2, _tr_init(t), Z_OK$3;
}, deflateReset = (e) => {
  const t = deflateResetKeep(e);
  return t === Z_OK$3 && lm_init(e.state), t;
}, deflateSetHeader = (e, t) => !e || !e.state || e.state.wrap !== 2 ? Z_STREAM_ERROR$2 : (e.state.gzhead = t, Z_OK$3), deflateInit2 = (e, t, i, n, a, o) => {
  if (!e)
    return Z_STREAM_ERROR$2;
  let l = 1;
  if (t === Z_DEFAULT_COMPRESSION$1 && (t = 6), n < 0 ? (l = 0, n = -n) : n > 15 && (l = 2, n -= 16), a < 1 || a > MAX_MEM_LEVEL || i !== Z_DEFLATED$2 || n < 8 || n > 15 || t < 0 || t > 9 || o < 0 || o > Z_FIXED)
    return err(e, Z_STREAM_ERROR$2);
  n === 8 && (n = 9);
  const c = new DeflateState();
  return e.state = c, c.strm = e, c.wrap = l, c.gzhead = null, c.w_bits = n, c.w_size = 1 << c.w_bits, c.w_mask = c.w_size - 1, c.hash_bits = a + 7, c.hash_size = 1 << c.hash_bits, c.hash_mask = c.hash_size - 1, c.hash_shift = ~~((c.hash_bits + MIN_MATCH - 1) / MIN_MATCH), c.window = new Uint8Array(c.w_size * 2), c.head = new Uint16Array(c.hash_size), c.prev = new Uint16Array(c.w_size), c.lit_bufsize = 1 << a + 6, c.pending_buf_size = c.lit_bufsize * 4, c.pending_buf = new Uint8Array(c.pending_buf_size), c.d_buf = 1 * c.lit_bufsize, c.l_buf = (1 + 2) * c.lit_bufsize, c.level = t, c.strategy = o, c.method = i, deflateReset(e);
}, deflateInit = (e, t) => deflateInit2(e, t, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1), deflate$2 = (e, t) => {
  let i, n;
  if (!e || !e.state || t > Z_BLOCK$1 || t < 0)
    return e ? err(e, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
  const a = e.state;
  if (!e.output || !e.input && e.avail_in !== 0 || a.status === FINISH_STATE && t !== Z_FINISH$3)
    return err(e, e.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
  a.strm = e;
  const o = a.last_flush;
  if (a.last_flush = t, a.status === INIT_STATE)
    if (a.wrap === 2)
      e.adler = 0, put_byte(a, 31), put_byte(a, 139), put_byte(a, 8), a.gzhead ? (put_byte(a, (a.gzhead.text ? 1 : 0) + (a.gzhead.hcrc ? 2 : 0) + (a.gzhead.extra ? 4 : 0) + (a.gzhead.name ? 8 : 0) + (a.gzhead.comment ? 16 : 0)), put_byte(a, a.gzhead.time & 255), put_byte(a, a.gzhead.time >> 8 & 255), put_byte(a, a.gzhead.time >> 16 & 255), put_byte(a, a.gzhead.time >> 24 & 255), put_byte(a, a.level === 9 ? 2 : a.strategy >= Z_HUFFMAN_ONLY || a.level < 2 ? 4 : 0), put_byte(a, a.gzhead.os & 255), a.gzhead.extra && a.gzhead.extra.length && (put_byte(a, a.gzhead.extra.length & 255), put_byte(a, a.gzhead.extra.length >> 8 & 255)), a.gzhead.hcrc && (e.adler = crc32$1(e.adler, a.pending_buf, a.pending, 0)), a.gzindex = 0, a.status = EXTRA_STATE) : (put_byte(a, 0), put_byte(a, 0), put_byte(a, 0), put_byte(a, 0), put_byte(a, 0), put_byte(a, a.level === 9 ? 2 : a.strategy >= Z_HUFFMAN_ONLY || a.level < 2 ? 4 : 0), put_byte(a, OS_CODE), a.status = BUSY_STATE);
    else {
      let l = Z_DEFLATED$2 + (a.w_bits - 8 << 4) << 8, c = -1;
      a.strategy >= Z_HUFFMAN_ONLY || a.level < 2 ? c = 0 : a.level < 6 ? c = 1 : a.level === 6 ? c = 2 : c = 3, l |= c << 6, a.strstart !== 0 && (l |= PRESET_DICT), l += 31 - l % 31, a.status = BUSY_STATE, putShortMSB(a, l), a.strstart !== 0 && (putShortMSB(a, e.adler >>> 16), putShortMSB(a, e.adler & 65535)), e.adler = 1;
    }
  if (a.status === EXTRA_STATE)
    if (a.gzhead.extra) {
      for (i = a.pending; a.gzindex < (a.gzhead.extra.length & 65535) && !(a.pending === a.pending_buf_size && (a.gzhead.hcrc && a.pending > i && (e.adler = crc32$1(e.adler, a.pending_buf, a.pending - i, i)), flush_pending(e), i = a.pending, a.pending === a.pending_buf_size)); )
        put_byte(a, a.gzhead.extra[a.gzindex] & 255), a.gzindex++;
      a.gzhead.hcrc && a.pending > i && (e.adler = crc32$1(e.adler, a.pending_buf, a.pending - i, i)), a.gzindex === a.gzhead.extra.length && (a.gzindex = 0, a.status = NAME_STATE);
    } else
      a.status = NAME_STATE;
  if (a.status === NAME_STATE)
    if (a.gzhead.name) {
      i = a.pending;
      do {
        if (a.pending === a.pending_buf_size && (a.gzhead.hcrc && a.pending > i && (e.adler = crc32$1(e.adler, a.pending_buf, a.pending - i, i)), flush_pending(e), i = a.pending, a.pending === a.pending_buf_size)) {
          n = 1;
          break;
        }
        a.gzindex < a.gzhead.name.length ? n = a.gzhead.name.charCodeAt(a.gzindex++) & 255 : n = 0, put_byte(a, n);
      } while (n !== 0);
      a.gzhead.hcrc && a.pending > i && (e.adler = crc32$1(e.adler, a.pending_buf, a.pending - i, i)), n === 0 && (a.gzindex = 0, a.status = COMMENT_STATE);
    } else
      a.status = COMMENT_STATE;
  if (a.status === COMMENT_STATE)
    if (a.gzhead.comment) {
      i = a.pending;
      do {
        if (a.pending === a.pending_buf_size && (a.gzhead.hcrc && a.pending > i && (e.adler = crc32$1(e.adler, a.pending_buf, a.pending - i, i)), flush_pending(e), i = a.pending, a.pending === a.pending_buf_size)) {
          n = 1;
          break;
        }
        a.gzindex < a.gzhead.comment.length ? n = a.gzhead.comment.charCodeAt(a.gzindex++) & 255 : n = 0, put_byte(a, n);
      } while (n !== 0);
      a.gzhead.hcrc && a.pending > i && (e.adler = crc32$1(e.adler, a.pending_buf, a.pending - i, i)), n === 0 && (a.status = HCRC_STATE);
    } else
      a.status = HCRC_STATE;
  if (a.status === HCRC_STATE && (a.gzhead.hcrc ? (a.pending + 2 > a.pending_buf_size && flush_pending(e), a.pending + 2 <= a.pending_buf_size && (put_byte(a, e.adler & 255), put_byte(a, e.adler >> 8 & 255), e.adler = 0, a.status = BUSY_STATE)) : a.status = BUSY_STATE), a.pending !== 0) {
    if (flush_pending(e), e.avail_out === 0)
      return a.last_flush = -1, Z_OK$3;
  } else if (e.avail_in === 0 && rank(t) <= rank(o) && t !== Z_FINISH$3)
    return err(e, Z_BUF_ERROR$1);
  if (a.status === FINISH_STATE && e.avail_in !== 0)
    return err(e, Z_BUF_ERROR$1);
  if (e.avail_in !== 0 || a.lookahead !== 0 || t !== Z_NO_FLUSH$2 && a.status !== FINISH_STATE) {
    let l = a.strategy === Z_HUFFMAN_ONLY ? deflate_huff(a, t) : a.strategy === Z_RLE ? deflate_rle(a, t) : configuration_table[a.level].func(a, t);
    if ((l === BS_FINISH_STARTED || l === BS_FINISH_DONE) && (a.status = FINISH_STATE), l === BS_NEED_MORE || l === BS_FINISH_STARTED)
      return e.avail_out === 0 && (a.last_flush = -1), Z_OK$3;
    if (l === BS_BLOCK_DONE && (t === Z_PARTIAL_FLUSH ? _tr_align(a) : t !== Z_BLOCK$1 && (_tr_stored_block(a, 0, 0, !1), t === Z_FULL_FLUSH$1 && (zero(a.head), a.lookahead === 0 && (a.strstart = 0, a.block_start = 0, a.insert = 0))), flush_pending(e), e.avail_out === 0))
      return a.last_flush = -1, Z_OK$3;
  }
  return t !== Z_FINISH$3 ? Z_OK$3 : a.wrap <= 0 ? Z_STREAM_END$3 : (a.wrap === 2 ? (put_byte(a, e.adler & 255), put_byte(a, e.adler >> 8 & 255), put_byte(a, e.adler >> 16 & 255), put_byte(a, e.adler >> 24 & 255), put_byte(a, e.total_in & 255), put_byte(a, e.total_in >> 8 & 255), put_byte(a, e.total_in >> 16 & 255), put_byte(a, e.total_in >> 24 & 255)) : (putShortMSB(a, e.adler >>> 16), putShortMSB(a, e.adler & 65535)), flush_pending(e), a.wrap > 0 && (a.wrap = -a.wrap), a.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3);
}, deflateEnd = (e) => {
  if (!e || !e.state)
    return Z_STREAM_ERROR$2;
  const t = e.state.status;
  return t !== INIT_STATE && t !== EXTRA_STATE && t !== NAME_STATE && t !== COMMENT_STATE && t !== HCRC_STATE && t !== BUSY_STATE && t !== FINISH_STATE ? err(e, Z_STREAM_ERROR$2) : (e.state = null, t === BUSY_STATE ? err(e, Z_DATA_ERROR$2) : Z_OK$3);
}, deflateSetDictionary = (e, t) => {
  let i = t.length;
  if (!e || !e.state)
    return Z_STREAM_ERROR$2;
  const n = e.state, a = n.wrap;
  if (a === 2 || a === 1 && n.status !== INIT_STATE || n.lookahead)
    return Z_STREAM_ERROR$2;
  if (a === 1 && (e.adler = adler32$1(e.adler, t, i, 0)), n.wrap = 0, i >= n.w_size) {
    a === 0 && (zero(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0);
    let d = new Uint8Array(n.w_size);
    d.set(t.subarray(i - n.w_size, i), 0), t = d, i = n.w_size;
  }
  const o = e.avail_in, l = e.next_in, c = e.input;
  for (e.avail_in = i, e.next_in = 0, e.input = t, fill_window(n); n.lookahead >= MIN_MATCH; ) {
    let d = n.strstart, u = n.lookahead - (MIN_MATCH - 1);
    do
      n.ins_h = HASH(n, n.ins_h, n.window[d + MIN_MATCH - 1]), n.prev[d & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = d, d++;
    while (--u);
    n.strstart = d, n.lookahead = MIN_MATCH - 1, fill_window(n);
  }
  return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = MIN_MATCH - 1, n.match_available = 0, e.next_in = l, e.input = c, e.avail_in = o, n.wrap = a, Z_OK$3;
};
deflate$3.deflateInit = deflateInit;
deflate$3.deflateInit2 = deflateInit2;
deflate$3.deflateReset = deflateReset;
deflate$3.deflateResetKeep = deflateResetKeep;
deflate$3.deflateSetHeader = deflateSetHeader;
deflate$3.deflate = deflate$2;
deflate$3.deflateEnd = deflateEnd;
deflate$3.deflateSetDictionary = deflateSetDictionary;
deflate$3.deflateInfo = "pako deflate (from Nodeca project)";
var common$6 = {};
const _has = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
common$6.assign = function(e) {
  const t = Array.prototype.slice.call(arguments, 1);
  for (; t.length; ) {
    const i = t.shift();
    if (i) {
      if (typeof i != "object")
        throw new TypeError(i + "must be non-object");
      for (const n in i)
        _has(i, n) && (e[n] = i[n]);
    }
  }
  return e;
};
common$6.flattenChunks = (e) => {
  let t = 0;
  for (let n = 0, a = e.length; n < a; n++)
    t += e[n].length;
  const i = new Uint8Array(t);
  for (let n = 0, a = 0, o = e.length; n < o; n++) {
    let l = e[n];
    i.set(l, a), a += l.length;
  }
  return i;
};
var strings$2 = {};
let STR_APPLY_UIA_OK = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  STR_APPLY_UIA_OK = !1;
}
const _utf8len = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  _utf8len[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
_utf8len[254] = _utf8len[254] = 1;
strings$2.string2buf = (e) => {
  let t, i, n, a, o, l = e.length, c = 0;
  for (a = 0; a < l; a++)
    i = e.charCodeAt(a), (i & 64512) === 55296 && a + 1 < l && (n = e.charCodeAt(a + 1), (n & 64512) === 56320 && (i = 65536 + (i - 55296 << 10) + (n - 56320), a++)), c += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4;
  for (t = new Uint8Array(c), o = 0, a = 0; o < c; a++)
    i = e.charCodeAt(a), (i & 64512) === 55296 && a + 1 < l && (n = e.charCodeAt(a + 1), (n & 64512) === 56320 && (i = 65536 + (i - 55296 << 10) + (n - 56320), a++)), i < 128 ? t[o++] = i : i < 2048 ? (t[o++] = 192 | i >>> 6, t[o++] = 128 | i & 63) : i < 65536 ? (t[o++] = 224 | i >>> 12, t[o++] = 128 | i >>> 6 & 63, t[o++] = 128 | i & 63) : (t[o++] = 240 | i >>> 18, t[o++] = 128 | i >>> 12 & 63, t[o++] = 128 | i >>> 6 & 63, t[o++] = 128 | i & 63);
  return t;
};
const buf2binstring = (e, t) => {
  if (t < 65534 && e.subarray && STR_APPLY_UIA_OK)
    return String.fromCharCode.apply(null, e.length === t ? e : e.subarray(0, t));
  let i = "";
  for (let n = 0; n < t; n++)
    i += String.fromCharCode(e[n]);
  return i;
};
strings$2.buf2string = (e, t) => {
  let i, n;
  const a = t || e.length, o = new Array(a * 2);
  for (n = 0, i = 0; i < a; ) {
    let l = e[i++];
    if (l < 128) {
      o[n++] = l;
      continue;
    }
    let c = _utf8len[l];
    if (c > 4) {
      o[n++] = 65533, i += c - 1;
      continue;
    }
    for (l &= c === 2 ? 31 : c === 3 ? 15 : 7; c > 1 && i < a; )
      l = l << 6 | e[i++] & 63, c--;
    if (c > 1) {
      o[n++] = 65533;
      continue;
    }
    l < 65536 ? o[n++] = l : (l -= 65536, o[n++] = 55296 | l >> 10 & 1023, o[n++] = 56320 | l & 1023);
  }
  return buf2binstring(o, n);
};
strings$2.utf8border = (e, t) => {
  t = t || e.length, t > e.length && (t = e.length);
  let i = t - 1;
  for (; i >= 0 && (e[i] & 192) === 128; )
    i--;
  return i < 0 || i === 0 ? t : i + _utf8len[e[i]] > t ? i : t;
};
function ZStream$2() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var zstream = ZStream$2;
const zlib_deflate = deflate$3, utils$o = common$6, strings$1 = strings$2, msg$1 = messages, ZStream$1 = zstream, toString$3 = Object.prototype.toString, { Z_NO_FLUSH: Z_NO_FLUSH$1, Z_SYNC_FLUSH, Z_FULL_FLUSH, Z_FINISH: Z_FINISH$2, Z_OK: Z_OK$2, Z_STREAM_END: Z_STREAM_END$2, Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY, Z_DEFLATED: Z_DEFLATED$1 } = constants$1;
function Deflate$1(e) {
  this.options = utils$o.assign({ level: Z_DEFAULT_COMPRESSION, method: Z_DEFLATED$1, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: Z_DEFAULT_STRATEGY }, e || {});
  let t = this.options;
  t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ZStream$1(), this.strm.avail_out = 0;
  let i = zlib_deflate.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
  if (i !== Z_OK$2)
    throw new Error(msg$1[i]);
  if (t.header && zlib_deflate.deflateSetHeader(this.strm, t.header), t.dictionary) {
    let n;
    if (typeof t.dictionary == "string" ? n = strings$1.string2buf(t.dictionary) : toString$3.call(t.dictionary) === "[object ArrayBuffer]" ? n = new Uint8Array(t.dictionary) : n = t.dictionary, i = zlib_deflate.deflateSetDictionary(this.strm, n), i !== Z_OK$2)
      throw new Error(msg$1[i]);
    this._dict_set = !0;
  }
}
Deflate$1.prototype.push = function(e, t) {
  const i = this.strm, n = this.options.chunkSize;
  let a, o;
  if (this.ended)
    return !1;
  for (t === ~~t ? o = t : o = t === !0 ? Z_FINISH$2 : Z_NO_FLUSH$1, typeof e == "string" ? i.input = strings$1.string2buf(e) : toString$3.call(e) === "[object ArrayBuffer]" ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length; ; ) {
    if (i.avail_out === 0 && (i.output = new Uint8Array(n), i.next_out = 0, i.avail_out = n), (o === Z_SYNC_FLUSH || o === Z_FULL_FLUSH) && i.avail_out <= 6) {
      this.onData(i.output.subarray(0, i.next_out)), i.avail_out = 0;
      continue;
    }
    if (a = zlib_deflate.deflate(i, o), a === Z_STREAM_END$2)
      return i.next_out > 0 && this.onData(i.output.subarray(0, i.next_out)), a = zlib_deflate.deflateEnd(this.strm), this.onEnd(a), this.ended = !0, a === Z_OK$2;
    if (i.avail_out === 0) {
      this.onData(i.output);
      continue;
    }
    if (o > 0 && i.next_out > 0) {
      this.onData(i.output.subarray(0, i.next_out)), i.avail_out = 0;
      continue;
    }
    if (i.avail_in === 0)
      break;
  }
  return !0;
};
Deflate$1.prototype.onData = function(e) {
  this.chunks.push(e);
};
Deflate$1.prototype.onEnd = function(e) {
  e === Z_OK$2 && (this.result = utils$o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function deflate$1(e, t) {
  const i = new Deflate$1(t);
  if (i.push(e, !0), i.err)
    throw i.msg || msg$1[i.err];
  return i.result;
}
function deflateRaw$1(e, t) {
  return t = t || {}, t.raw = !0, deflate$1(e, t);
}
function gzip$1(e, t) {
  return t = t || {}, t.gzip = !0, deflate$1(e, t);
}
deflate$4.Deflate = Deflate$1;
deflate$4.deflate = deflate$1;
deflate$4.deflateRaw = deflateRaw$1;
deflate$4.gzip = gzip$1;
deflate$4.constants = constants$1;
var inflate$4 = {}, inflate$3 = {};
const BAD$1 = 30, TYPE$1 = 12;
var inffast = function(t, i) {
  let n, a, o, l, c, d, u, m, A, y, D, C, z, R, O, $, k, P, L, F, B, G, Z, X;
  const V = t.state;
  n = t.next_in, Z = t.input, a = n + (t.avail_in - 5), o = t.next_out, X = t.output, l = o - (i - t.avail_out), c = o + (t.avail_out - 257), d = V.dmax, u = V.wsize, m = V.whave, A = V.wnext, y = V.window, D = V.hold, C = V.bits, z = V.lencode, R = V.distcode, O = (1 << V.lenbits) - 1, $ = (1 << V.distbits) - 1;
  e:
    do {
      C < 15 && (D += Z[n++] << C, C += 8, D += Z[n++] << C, C += 8), k = z[D & O];
      t:
        for (; ; ) {
          if (P = k >>> 24, D >>>= P, C -= P, P = k >>> 16 & 255, P === 0)
            X[o++] = k & 65535;
          else if (P & 16) {
            L = k & 65535, P &= 15, P && (C < P && (D += Z[n++] << C, C += 8), L += D & (1 << P) - 1, D >>>= P, C -= P), C < 15 && (D += Z[n++] << C, C += 8, D += Z[n++] << C, C += 8), k = R[D & $];
            r:
              for (; ; ) {
                if (P = k >>> 24, D >>>= P, C -= P, P = k >>> 16 & 255, P & 16) {
                  if (F = k & 65535, P &= 15, C < P && (D += Z[n++] << C, C += 8, C < P && (D += Z[n++] << C, C += 8)), F += D & (1 << P) - 1, F > d) {
                    t.msg = "invalid distance too far back", V.mode = BAD$1;
                    break e;
                  }
                  if (D >>>= P, C -= P, P = o - l, F > P) {
                    if (P = F - P, P > m && V.sane) {
                      t.msg = "invalid distance too far back", V.mode = BAD$1;
                      break e;
                    }
                    if (B = 0, G = y, A === 0) {
                      if (B += u - P, P < L) {
                        L -= P;
                        do
                          X[o++] = y[B++];
                        while (--P);
                        B = o - F, G = X;
                      }
                    } else if (A < P) {
                      if (B += u + A - P, P -= A, P < L) {
                        L -= P;
                        do
                          X[o++] = y[B++];
                        while (--P);
                        if (B = 0, A < L) {
                          P = A, L -= P;
                          do
                            X[o++] = y[B++];
                          while (--P);
                          B = o - F, G = X;
                        }
                      }
                    } else if (B += A - P, P < L) {
                      L -= P;
                      do
                        X[o++] = y[B++];
                      while (--P);
                      B = o - F, G = X;
                    }
                    for (; L > 2; )
                      X[o++] = G[B++], X[o++] = G[B++], X[o++] = G[B++], L -= 3;
                    L && (X[o++] = G[B++], L > 1 && (X[o++] = G[B++]));
                  } else {
                    B = o - F;
                    do
                      X[o++] = X[B++], X[o++] = X[B++], X[o++] = X[B++], L -= 3;
                    while (L > 2);
                    L && (X[o++] = X[B++], L > 1 && (X[o++] = X[B++]));
                  }
                } else if (P & 64) {
                  t.msg = "invalid distance code", V.mode = BAD$1;
                  break e;
                } else {
                  k = R[(k & 65535) + (D & (1 << P) - 1)];
                  continue r;
                }
                break;
              }
          } else if (P & 64)
            if (P & 32) {
              V.mode = TYPE$1;
              break e;
            } else {
              t.msg = "invalid literal/length code", V.mode = BAD$1;
              break e;
            }
          else {
            k = z[(k & 65535) + (D & (1 << P) - 1)];
            continue t;
          }
          break;
        }
    } while (n < a && o < c);
  L = C >> 3, n -= L, C -= L << 3, D &= (1 << C) - 1, t.next_in = n, t.next_out = o, t.avail_in = n < a ? 5 + (a - n) : 5 - (n - a), t.avail_out = o < c ? 257 + (c - o) : 257 - (o - c), V.hold = D, V.bits = C;
};
const MAXBITS = 15, ENOUGH_LENS$1 = 852, ENOUGH_DISTS$1 = 592, CODES$1 = 0, LENS$1 = 1, DISTS$1 = 2, lbase = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), lext = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), dbase = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), dext = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), inflate_table$1 = (e, t, i, n, a, o, l, c) => {
  const d = c.bits;
  let u = 0, m = 0, A = 0, y = 0, D = 0, C = 0, z = 0, R = 0, O = 0, $ = 0, k, P, L, F, B, G = null, Z = 0, X;
  const V = new Uint16Array(MAXBITS + 1), E = new Uint16Array(MAXBITS + 1);
  let T = null, g = 0, b, x, S;
  for (u = 0; u <= MAXBITS; u++)
    V[u] = 0;
  for (m = 0; m < n; m++)
    V[t[i + m]]++;
  for (D = d, y = MAXBITS; y >= 1 && V[y] === 0; y--)
    ;
  if (D > y && (D = y), y === 0)
    return a[o++] = 1 << 24 | 64 << 16 | 0, a[o++] = 1 << 24 | 64 << 16 | 0, c.bits = 1, 0;
  for (A = 1; A < y && V[A] === 0; A++)
    ;
  for (D < A && (D = A), R = 1, u = 1; u <= MAXBITS; u++)
    if (R <<= 1, R -= V[u], R < 0)
      return -1;
  if (R > 0 && (e === CODES$1 || y !== 1))
    return -1;
  for (E[1] = 0, u = 1; u < MAXBITS; u++)
    E[u + 1] = E[u] + V[u];
  for (m = 0; m < n; m++)
    t[i + m] !== 0 && (l[E[t[i + m]]++] = m);
  if (e === CODES$1 ? (G = T = l, X = 19) : e === LENS$1 ? (G = lbase, Z -= 257, T = lext, g -= 257, X = 256) : (G = dbase, T = dext, X = -1), $ = 0, m = 0, u = A, B = o, C = D, z = 0, L = -1, O = 1 << D, F = O - 1, e === LENS$1 && O > ENOUGH_LENS$1 || e === DISTS$1 && O > ENOUGH_DISTS$1)
    return 1;
  for (; ; ) {
    b = u - z, l[m] < X ? (x = 0, S = l[m]) : l[m] > X ? (x = T[g + l[m]], S = G[Z + l[m]]) : (x = 32 + 64, S = 0), k = 1 << u - z, P = 1 << C, A = P;
    do
      P -= k, a[B + ($ >> z) + P] = b << 24 | x << 16 | S | 0;
    while (P !== 0);
    for (k = 1 << u - 1; $ & k; )
      k >>= 1;
    if (k !== 0 ? ($ &= k - 1, $ += k) : $ = 0, m++, --V[u] === 0) {
      if (u === y)
        break;
      u = t[i + l[m]];
    }
    if (u > D && ($ & F) !== L) {
      for (z === 0 && (z = D), B += A, C = u - z, R = 1 << C; C + z < y && (R -= V[C + z], !(R <= 0)); )
        C++, R <<= 1;
      if (O += 1 << C, e === LENS$1 && O > ENOUGH_LENS$1 || e === DISTS$1 && O > ENOUGH_DISTS$1)
        return 1;
      L = $ & F, a[L] = D << 24 | C << 16 | B - o | 0;
    }
  }
  return $ !== 0 && (a[B + $] = u - z << 24 | 64 << 16 | 0), c.bits = D, 0;
};
var inftrees = inflate_table$1;
const adler32 = adler32_1, crc32 = crc32_1, inflate_fast = inffast, inflate_table = inftrees, CODES = 0, LENS = 1, DISTS = 2, { Z_FINISH: Z_FINISH$1, Z_BLOCK, Z_TREES, Z_OK: Z_OK$1, Z_STREAM_END: Z_STREAM_END$1, Z_NEED_DICT: Z_NEED_DICT$1, Z_STREAM_ERROR: Z_STREAM_ERROR$1, Z_DATA_ERROR: Z_DATA_ERROR$1, Z_MEM_ERROR: Z_MEM_ERROR$1, Z_BUF_ERROR, Z_DEFLATED } = constants$1, HEAD = 1, FLAGS = 2, TIME = 3, OS = 4, EXLEN = 5, EXTRA = 6, NAME = 7, COMMENT = 8, HCRC = 9, DICTID = 10, DICT = 11, TYPE = 12, TYPEDO = 13, STORED = 14, COPY_ = 15, COPY = 16, TABLE = 17, LENLENS = 18, CODELENS = 19, LEN_ = 20, LEN = 21, LENEXT = 22, DIST = 23, DISTEXT = 24, MATCH = 25, LIT = 26, CHECK = 27, LENGTH = 28, DONE = 29, BAD = 30, MEM = 31, SYNC = 32, ENOUGH_LENS = 852, ENOUGH_DISTS = 592, MAX_WBITS = 15, DEF_WBITS = MAX_WBITS, zswap32 = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function InflateState() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const inflateResetKeep = (e) => {
  if (!e || !e.state)
    return Z_STREAM_ERROR$1;
  const t = e.state;
  return e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = t.wrap & 1), t.mode = HEAD, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(ENOUGH_LENS), t.distcode = t.distdyn = new Int32Array(ENOUGH_DISTS), t.sane = 1, t.back = -1, Z_OK$1;
}, inflateReset = (e) => {
  if (!e || !e.state)
    return Z_STREAM_ERROR$1;
  const t = e.state;
  return t.wsize = 0, t.whave = 0, t.wnext = 0, inflateResetKeep(e);
}, inflateReset2 = (e, t) => {
  let i;
  if (!e || !e.state)
    return Z_STREAM_ERROR$1;
  const n = e.state;
  return t < 0 ? (i = 0, t = -t) : (i = (t >> 4) + 1, t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? Z_STREAM_ERROR$1 : (n.window !== null && n.wbits !== t && (n.window = null), n.wrap = i, n.wbits = t, inflateReset(e));
}, inflateInit2 = (e, t) => {
  if (!e)
    return Z_STREAM_ERROR$1;
  const i = new InflateState();
  e.state = i, i.window = null;
  const n = inflateReset2(e, t);
  return n !== Z_OK$1 && (e.state = null), n;
}, inflateInit = (e) => inflateInit2(e, DEF_WBITS);
let virgin = !0, lenfix, distfix;
const fixedtables = (e) => {
  if (virgin) {
    lenfix = new Int32Array(512), distfix = new Int32Array(32);
    let t = 0;
    for (; t < 144; )
      e.lens[t++] = 8;
    for (; t < 256; )
      e.lens[t++] = 9;
    for (; t < 280; )
      e.lens[t++] = 7;
    for (; t < 288; )
      e.lens[t++] = 8;
    for (inflate_table(LENS, e.lens, 0, 288, lenfix, 0, e.work, { bits: 9 }), t = 0; t < 32; )
      e.lens[t++] = 5;
    inflate_table(DISTS, e.lens, 0, 32, distfix, 0, e.work, { bits: 5 }), virgin = !1;
  }
  e.lencode = lenfix, e.lenbits = 9, e.distcode = distfix, e.distbits = 5;
}, updatewindow = (e, t, i, n) => {
  let a;
  const o = e.state;
  return o.window === null && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new Uint8Array(o.wsize)), n >= o.wsize ? (o.window.set(t.subarray(i - o.wsize, i), 0), o.wnext = 0, o.whave = o.wsize) : (a = o.wsize - o.wnext, a > n && (a = n), o.window.set(t.subarray(i - n, i - n + a), o.wnext), n -= a, n ? (o.window.set(t.subarray(i - n, i), 0), o.wnext = n, o.whave = o.wsize) : (o.wnext += a, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += a))), 0;
}, inflate$2 = (e, t) => {
  let i, n, a, o, l, c, d, u, m, A, y, D, C, z, R = 0, O, $, k, P, L, F, B, G;
  const Z = new Uint8Array(4);
  let X, V;
  const E = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (!e || !e.state || !e.output || !e.input && e.avail_in !== 0)
    return Z_STREAM_ERROR$1;
  i = e.state, i.mode === TYPE && (i.mode = TYPEDO), l = e.next_out, a = e.output, d = e.avail_out, o = e.next_in, n = e.input, c = e.avail_in, u = i.hold, m = i.bits, A = c, y = d, G = Z_OK$1;
  e:
    for (; ; )
      switch (i.mode) {
        case HEAD:
          if (i.wrap === 0) {
            i.mode = TYPEDO;
            break;
          }
          for (; m < 16; ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          if (i.wrap & 2 && u === 35615) {
            i.check = 0, Z[0] = u & 255, Z[1] = u >>> 8 & 255, i.check = crc32(i.check, Z, 2, 0), u = 0, m = 0, i.mode = FLAGS;
            break;
          }
          if (i.flags = 0, i.head && (i.head.done = !1), !(i.wrap & 1) || /* check if zlib header allowed */
          (((u & 255) << 8) + (u >> 8)) % 31) {
            e.msg = "incorrect header check", i.mode = BAD;
            break;
          }
          if ((u & 15) !== Z_DEFLATED) {
            e.msg = "unknown compression method", i.mode = BAD;
            break;
          }
          if (u >>>= 4, m -= 4, B = (u & 15) + 8, i.wbits === 0)
            i.wbits = B;
          else if (B > i.wbits) {
            e.msg = "invalid window size", i.mode = BAD;
            break;
          }
          i.dmax = 1 << i.wbits, e.adler = i.check = 1, i.mode = u & 512 ? DICTID : TYPE, u = 0, m = 0;
          break;
        case FLAGS:
          for (; m < 16; ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          if (i.flags = u, (i.flags & 255) !== Z_DEFLATED) {
            e.msg = "unknown compression method", i.mode = BAD;
            break;
          }
          if (i.flags & 57344) {
            e.msg = "unknown header flags set", i.mode = BAD;
            break;
          }
          i.head && (i.head.text = u >> 8 & 1), i.flags & 512 && (Z[0] = u & 255, Z[1] = u >>> 8 & 255, i.check = crc32(i.check, Z, 2, 0)), u = 0, m = 0, i.mode = TIME;
        case TIME:
          for (; m < 32; ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          i.head && (i.head.time = u), i.flags & 512 && (Z[0] = u & 255, Z[1] = u >>> 8 & 255, Z[2] = u >>> 16 & 255, Z[3] = u >>> 24 & 255, i.check = crc32(i.check, Z, 4, 0)), u = 0, m = 0, i.mode = OS;
        case OS:
          for (; m < 16; ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          i.head && (i.head.xflags = u & 255, i.head.os = u >> 8), i.flags & 512 && (Z[0] = u & 255, Z[1] = u >>> 8 & 255, i.check = crc32(i.check, Z, 2, 0)), u = 0, m = 0, i.mode = EXLEN;
        case EXLEN:
          if (i.flags & 1024) {
            for (; m < 16; ) {
              if (c === 0)
                break e;
              c--, u += n[o++] << m, m += 8;
            }
            i.length = u, i.head && (i.head.extra_len = u), i.flags & 512 && (Z[0] = u & 255, Z[1] = u >>> 8 & 255, i.check = crc32(i.check, Z, 2, 0)), u = 0, m = 0;
          } else
            i.head && (i.head.extra = null);
          i.mode = EXTRA;
        case EXTRA:
          if (i.flags & 1024 && (D = i.length, D > c && (D = c), D && (i.head && (B = i.head.extra_len - i.length, i.head.extra || (i.head.extra = new Uint8Array(i.head.extra_len)), i.head.extra.set(
            n.subarray(
              o,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              o + D
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            B
          )), i.flags & 512 && (i.check = crc32(i.check, n, D, o)), c -= D, o += D, i.length -= D), i.length))
            break e;
          i.length = 0, i.mode = NAME;
        case NAME:
          if (i.flags & 2048) {
            if (c === 0)
              break e;
            D = 0;
            do
              B = n[o + D++], i.head && B && i.length < 65536 && (i.head.name += String.fromCharCode(B));
            while (B && D < c);
            if (i.flags & 512 && (i.check = crc32(i.check, n, D, o)), c -= D, o += D, B)
              break e;
          } else
            i.head && (i.head.name = null);
          i.length = 0, i.mode = COMMENT;
        case COMMENT:
          if (i.flags & 4096) {
            if (c === 0)
              break e;
            D = 0;
            do
              B = n[o + D++], i.head && B && i.length < 65536 && (i.head.comment += String.fromCharCode(B));
            while (B && D < c);
            if (i.flags & 512 && (i.check = crc32(i.check, n, D, o)), c -= D, o += D, B)
              break e;
          } else
            i.head && (i.head.comment = null);
          i.mode = HCRC;
        case HCRC:
          if (i.flags & 512) {
            for (; m < 16; ) {
              if (c === 0)
                break e;
              c--, u += n[o++] << m, m += 8;
            }
            if (u !== (i.check & 65535)) {
              e.msg = "header crc mismatch", i.mode = BAD;
              break;
            }
            u = 0, m = 0;
          }
          i.head && (i.head.hcrc = i.flags >> 9 & 1, i.head.done = !0), e.adler = i.check = 0, i.mode = TYPE;
          break;
        case DICTID:
          for (; m < 32; ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          e.adler = i.check = zswap32(u), u = 0, m = 0, i.mode = DICT;
        case DICT:
          if (i.havedict === 0)
            return e.next_out = l, e.avail_out = d, e.next_in = o, e.avail_in = c, i.hold = u, i.bits = m, Z_NEED_DICT$1;
          e.adler = i.check = 1, i.mode = TYPE;
        case TYPE:
          if (t === Z_BLOCK || t === Z_TREES)
            break e;
        case TYPEDO:
          if (i.last) {
            u >>>= m & 7, m -= m & 7, i.mode = CHECK;
            break;
          }
          for (; m < 3; ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          switch (i.last = u & 1, u >>>= 1, m -= 1, u & 3) {
            case 0:
              i.mode = STORED;
              break;
            case 1:
              if (fixedtables(i), i.mode = LEN_, t === Z_TREES) {
                u >>>= 2, m -= 2;
                break e;
              }
              break;
            case 2:
              i.mode = TABLE;
              break;
            case 3:
              e.msg = "invalid block type", i.mode = BAD;
          }
          u >>>= 2, m -= 2;
          break;
        case STORED:
          for (u >>>= m & 7, m -= m & 7; m < 32; ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          if ((u & 65535) !== (u >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", i.mode = BAD;
            break;
          }
          if (i.length = u & 65535, u = 0, m = 0, i.mode = COPY_, t === Z_TREES)
            break e;
        case COPY_:
          i.mode = COPY;
        case COPY:
          if (D = i.length, D) {
            if (D > c && (D = c), D > d && (D = d), D === 0)
              break e;
            a.set(n.subarray(o, o + D), l), c -= D, o += D, d -= D, l += D, i.length -= D;
            break;
          }
          i.mode = TYPE;
          break;
        case TABLE:
          for (; m < 14; ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          if (i.nlen = (u & 31) + 257, u >>>= 5, m -= 5, i.ndist = (u & 31) + 1, u >>>= 5, m -= 5, i.ncode = (u & 15) + 4, u >>>= 4, m -= 4, i.nlen > 286 || i.ndist > 30) {
            e.msg = "too many length or distance symbols", i.mode = BAD;
            break;
          }
          i.have = 0, i.mode = LENLENS;
        case LENLENS:
          for (; i.have < i.ncode; ) {
            for (; m < 3; ) {
              if (c === 0)
                break e;
              c--, u += n[o++] << m, m += 8;
            }
            i.lens[E[i.have++]] = u & 7, u >>>= 3, m -= 3;
          }
          for (; i.have < 19; )
            i.lens[E[i.have++]] = 0;
          if (i.lencode = i.lendyn, i.lenbits = 7, X = { bits: i.lenbits }, G = inflate_table(CODES, i.lens, 0, 19, i.lencode, 0, i.work, X), i.lenbits = X.bits, G) {
            e.msg = "invalid code lengths set", i.mode = BAD;
            break;
          }
          i.have = 0, i.mode = CODELENS;
        case CODELENS:
          for (; i.have < i.nlen + i.ndist; ) {
            for (; R = i.lencode[u & (1 << i.lenbits) - 1], O = R >>> 24, $ = R >>> 16 & 255, k = R & 65535, !(O <= m); ) {
              if (c === 0)
                break e;
              c--, u += n[o++] << m, m += 8;
            }
            if (k < 16)
              u >>>= O, m -= O, i.lens[i.have++] = k;
            else {
              if (k === 16) {
                for (V = O + 2; m < V; ) {
                  if (c === 0)
                    break e;
                  c--, u += n[o++] << m, m += 8;
                }
                if (u >>>= O, m -= O, i.have === 0) {
                  e.msg = "invalid bit length repeat", i.mode = BAD;
                  break;
                }
                B = i.lens[i.have - 1], D = 3 + (u & 3), u >>>= 2, m -= 2;
              } else if (k === 17) {
                for (V = O + 3; m < V; ) {
                  if (c === 0)
                    break e;
                  c--, u += n[o++] << m, m += 8;
                }
                u >>>= O, m -= O, B = 0, D = 3 + (u & 7), u >>>= 3, m -= 3;
              } else {
                for (V = O + 7; m < V; ) {
                  if (c === 0)
                    break e;
                  c--, u += n[o++] << m, m += 8;
                }
                u >>>= O, m -= O, B = 0, D = 11 + (u & 127), u >>>= 7, m -= 7;
              }
              if (i.have + D > i.nlen + i.ndist) {
                e.msg = "invalid bit length repeat", i.mode = BAD;
                break;
              }
              for (; D--; )
                i.lens[i.have++] = B;
            }
          }
          if (i.mode === BAD)
            break;
          if (i.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", i.mode = BAD;
            break;
          }
          if (i.lenbits = 9, X = { bits: i.lenbits }, G = inflate_table(LENS, i.lens, 0, i.nlen, i.lencode, 0, i.work, X), i.lenbits = X.bits, G) {
            e.msg = "invalid literal/lengths set", i.mode = BAD;
            break;
          }
          if (i.distbits = 6, i.distcode = i.distdyn, X = { bits: i.distbits }, G = inflate_table(DISTS, i.lens, i.nlen, i.ndist, i.distcode, 0, i.work, X), i.distbits = X.bits, G) {
            e.msg = "invalid distances set", i.mode = BAD;
            break;
          }
          if (i.mode = LEN_, t === Z_TREES)
            break e;
        case LEN_:
          i.mode = LEN;
        case LEN:
          if (c >= 6 && d >= 258) {
            e.next_out = l, e.avail_out = d, e.next_in = o, e.avail_in = c, i.hold = u, i.bits = m, inflate_fast(e, y), l = e.next_out, a = e.output, d = e.avail_out, o = e.next_in, n = e.input, c = e.avail_in, u = i.hold, m = i.bits, i.mode === TYPE && (i.back = -1);
            break;
          }
          for (i.back = 0; R = i.lencode[u & (1 << i.lenbits) - 1], O = R >>> 24, $ = R >>> 16 & 255, k = R & 65535, !(O <= m); ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          if ($ && !($ & 240)) {
            for (P = O, L = $, F = k; R = i.lencode[F + ((u & (1 << P + L) - 1) >> P)], O = R >>> 24, $ = R >>> 16 & 255, k = R & 65535, !(P + O <= m); ) {
              if (c === 0)
                break e;
              c--, u += n[o++] << m, m += 8;
            }
            u >>>= P, m -= P, i.back += P;
          }
          if (u >>>= O, m -= O, i.back += O, i.length = k, $ === 0) {
            i.mode = LIT;
            break;
          }
          if ($ & 32) {
            i.back = -1, i.mode = TYPE;
            break;
          }
          if ($ & 64) {
            e.msg = "invalid literal/length code", i.mode = BAD;
            break;
          }
          i.extra = $ & 15, i.mode = LENEXT;
        case LENEXT:
          if (i.extra) {
            for (V = i.extra; m < V; ) {
              if (c === 0)
                break e;
              c--, u += n[o++] << m, m += 8;
            }
            i.length += u & (1 << i.extra) - 1, u >>>= i.extra, m -= i.extra, i.back += i.extra;
          }
          i.was = i.length, i.mode = DIST;
        case DIST:
          for (; R = i.distcode[u & (1 << i.distbits) - 1], O = R >>> 24, $ = R >>> 16 & 255, k = R & 65535, !(O <= m); ) {
            if (c === 0)
              break e;
            c--, u += n[o++] << m, m += 8;
          }
          if (!($ & 240)) {
            for (P = O, L = $, F = k; R = i.distcode[F + ((u & (1 << P + L) - 1) >> P)], O = R >>> 24, $ = R >>> 16 & 255, k = R & 65535, !(P + O <= m); ) {
              if (c === 0)
                break e;
              c--, u += n[o++] << m, m += 8;
            }
            u >>>= P, m -= P, i.back += P;
          }
          if (u >>>= O, m -= O, i.back += O, $ & 64) {
            e.msg = "invalid distance code", i.mode = BAD;
            break;
          }
          i.offset = k, i.extra = $ & 15, i.mode = DISTEXT;
        case DISTEXT:
          if (i.extra) {
            for (V = i.extra; m < V; ) {
              if (c === 0)
                break e;
              c--, u += n[o++] << m, m += 8;
            }
            i.offset += u & (1 << i.extra) - 1, u >>>= i.extra, m -= i.extra, i.back += i.extra;
          }
          if (i.offset > i.dmax) {
            e.msg = "invalid distance too far back", i.mode = BAD;
            break;
          }
          i.mode = MATCH;
        case MATCH:
          if (d === 0)
            break e;
          if (D = y - d, i.offset > D) {
            if (D = i.offset - D, D > i.whave && i.sane) {
              e.msg = "invalid distance too far back", i.mode = BAD;
              break;
            }
            D > i.wnext ? (D -= i.wnext, C = i.wsize - D) : C = i.wnext - D, D > i.length && (D = i.length), z = i.window;
          } else
            z = a, C = l - i.offset, D = i.length;
          D > d && (D = d), d -= D, i.length -= D;
          do
            a[l++] = z[C++];
          while (--D);
          i.length === 0 && (i.mode = LEN);
          break;
        case LIT:
          if (d === 0)
            break e;
          a[l++] = i.length, d--, i.mode = LEN;
          break;
        case CHECK:
          if (i.wrap) {
            for (; m < 32; ) {
              if (c === 0)
                break e;
              c--, u |= n[o++] << m, m += 8;
            }
            if (y -= d, e.total_out += y, i.total += y, y && (e.adler = i.check = /*UPDATE(state.check, put - _out, _out);*/
            i.flags ? crc32(i.check, a, y, l - y) : adler32(i.check, a, y, l - y)), y = d, (i.flags ? u : zswap32(u)) !== i.check) {
              e.msg = "incorrect data check", i.mode = BAD;
              break;
            }
            u = 0, m = 0;
          }
          i.mode = LENGTH;
        case LENGTH:
          if (i.wrap && i.flags) {
            for (; m < 32; ) {
              if (c === 0)
                break e;
              c--, u += n[o++] << m, m += 8;
            }
            if (u !== (i.total & 4294967295)) {
              e.msg = "incorrect length check", i.mode = BAD;
              break;
            }
            u = 0, m = 0;
          }
          i.mode = DONE;
        case DONE:
          G = Z_STREAM_END$1;
          break e;
        case BAD:
          G = Z_DATA_ERROR$1;
          break e;
        case MEM:
          return Z_MEM_ERROR$1;
        case SYNC:
        default:
          return Z_STREAM_ERROR$1;
      }
  return e.next_out = l, e.avail_out = d, e.next_in = o, e.avail_in = c, i.hold = u, i.bits = m, (i.wsize || y !== e.avail_out && i.mode < BAD && (i.mode < CHECK || t !== Z_FINISH$1)) && updatewindow(e, e.output, e.next_out, y - e.avail_out), A -= e.avail_in, y -= e.avail_out, e.total_in += A, e.total_out += y, i.total += y, i.wrap && y && (e.adler = i.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
  i.flags ? crc32(i.check, a, y, e.next_out - y) : adler32(i.check, a, y, e.next_out - y)), e.data_type = i.bits + (i.last ? 64 : 0) + (i.mode === TYPE ? 128 : 0) + (i.mode === LEN_ || i.mode === COPY_ ? 256 : 0), (A === 0 && y === 0 || t === Z_FINISH$1) && G === Z_OK$1 && (G = Z_BUF_ERROR), G;
}, inflateEnd = (e) => {
  if (!e || !e.state)
    return Z_STREAM_ERROR$1;
  let t = e.state;
  return t.window && (t.window = null), e.state = null, Z_OK$1;
}, inflateGetHeader = (e, t) => {
  if (!e || !e.state)
    return Z_STREAM_ERROR$1;
  const i = e.state;
  return i.wrap & 2 ? (i.head = t, t.done = !1, Z_OK$1) : Z_STREAM_ERROR$1;
}, inflateSetDictionary = (e, t) => {
  const i = t.length;
  let n, a, o;
  return !e || !e.state || (n = e.state, n.wrap !== 0 && n.mode !== DICT) ? Z_STREAM_ERROR$1 : n.mode === DICT && (a = 1, a = adler32(a, t, i, 0), a !== n.check) ? Z_DATA_ERROR$1 : (o = updatewindow(e, t, i, i), o ? (n.mode = MEM, Z_MEM_ERROR$1) : (n.havedict = 1, Z_OK$1));
};
inflate$3.inflateReset = inflateReset;
inflate$3.inflateReset2 = inflateReset2;
inflate$3.inflateResetKeep = inflateResetKeep;
inflate$3.inflateInit = inflateInit;
inflate$3.inflateInit2 = inflateInit2;
inflate$3.inflate = inflate$2;
inflate$3.inflateEnd = inflateEnd;
inflate$3.inflateGetHeader = inflateGetHeader;
inflate$3.inflateSetDictionary = inflateSetDictionary;
inflate$3.inflateInfo = "pako inflate (from Nodeca project)";
function GZheader$1() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var gzheader = GZheader$1;
const zlib_inflate = inflate$3, utils$n = common$6, strings = strings$2, msg = messages, ZStream = zstream, GZheader = gzheader, toString$2 = Object.prototype.toString, { Z_NO_FLUSH, Z_FINISH, Z_OK, Z_STREAM_END, Z_NEED_DICT, Z_STREAM_ERROR, Z_DATA_ERROR, Z_MEM_ERROR } = constants$1;
function Inflate$1(e) {
  this.options = utils$n.assign({ chunkSize: 1024 * 64, windowBits: 15, to: "" }, e || {});
  const t = this.options;
  t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, t.windowBits === 0 && (t.windowBits = -15)), t.windowBits >= 0 && t.windowBits < 16 && !(e && e.windowBits) && (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && (t.windowBits & 15 || (t.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ZStream(), this.strm.avail_out = 0;
  let i = zlib_inflate.inflateInit2(this.strm, t.windowBits);
  if (i !== Z_OK)
    throw new Error(msg[i]);
  if (this.header = new GZheader(), zlib_inflate.inflateGetHeader(this.strm, this.header), t.dictionary && (typeof t.dictionary == "string" ? t.dictionary = strings.string2buf(t.dictionary) : toString$2.call(t.dictionary) === "[object ArrayBuffer]" && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (i = zlib_inflate.inflateSetDictionary(this.strm, t.dictionary), i !== Z_OK)))
    throw new Error(msg[i]);
}
Inflate$1.prototype.push = function(e, t) {
  const i = this.strm, n = this.options.chunkSize, a = this.options.dictionary;
  let o, l, c;
  if (this.ended)
    return !1;
  for (t === ~~t ? l = t : l = t === !0 ? Z_FINISH : Z_NO_FLUSH, toString$2.call(e) === "[object ArrayBuffer]" ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length; ; ) {
    for (i.avail_out === 0 && (i.output = new Uint8Array(n), i.next_out = 0, i.avail_out = n), o = zlib_inflate.inflate(i, l), o === Z_NEED_DICT && a && (o = zlib_inflate.inflateSetDictionary(i, a), o === Z_OK ? o = zlib_inflate.inflate(i, l) : o === Z_DATA_ERROR && (o = Z_NEED_DICT)); i.avail_in > 0 && o === Z_STREAM_END && i.state.wrap > 0 && e[i.next_in] !== 0; )
      zlib_inflate.inflateReset(i), o = zlib_inflate.inflate(i, l);
    switch (o) {
      case Z_STREAM_ERROR:
      case Z_DATA_ERROR:
      case Z_NEED_DICT:
      case Z_MEM_ERROR:
        return this.onEnd(o), this.ended = !0, !1;
    }
    if (c = i.avail_out, i.next_out && (i.avail_out === 0 || o === Z_STREAM_END))
      if (this.options.to === "string") {
        let d = strings.utf8border(i.output, i.next_out), u = i.next_out - d, m = strings.buf2string(i.output, d);
        i.next_out = u, i.avail_out = n - u, u && i.output.set(i.output.subarray(d, d + u), 0), this.onData(m);
      } else
        this.onData(i.output.length === i.next_out ? i.output : i.output.subarray(0, i.next_out));
    if (!(o === Z_OK && c === 0)) {
      if (o === Z_STREAM_END)
        return o = zlib_inflate.inflateEnd(this.strm), this.onEnd(o), this.ended = !0, !0;
      if (i.avail_in === 0)
        break;
    }
  }
  return !0;
};
Inflate$1.prototype.onData = function(e) {
  this.chunks.push(e);
};
Inflate$1.prototype.onEnd = function(e) {
  e === Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = utils$n.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function inflate$1(e, t) {
  const i = new Inflate$1(t);
  if (i.push(e), i.err)
    throw i.msg || msg[i.err];
  return i.result;
}
function inflateRaw$1(e, t) {
  return t = t || {}, t.raw = !0, inflate$1(e, t);
}
inflate$4.Inflate = Inflate$1;
inflate$4.inflate = inflate$1;
inflate$4.inflateRaw = inflateRaw$1;
inflate$4.ungzip = inflate$1;
inflate$4.constants = constants$1;
const { Deflate, deflate, deflateRaw, gzip } = deflate$4, { Inflate, inflate, inflateRaw, ungzip } = inflate$4, constants = constants$1;
pako.Deflate = Deflate;
pako.deflate = deflate;
pako.deflateRaw = deflateRaw;
pako.gzip = gzip;
pako.Inflate = Inflate;
pako.inflate = inflate;
pako.inflateRaw = inflateRaw;
pako.ungzip = ungzip;
pako.constants = constants;
var eosjsSerialize = {}, eosjsNumeric = {}, hash$2 = {}, utils$m = {}, minimalisticAssert = assert$f;
function assert$f(e, t) {
  if (!e)
    throw new Error(t || "Assertion failed");
}
assert$f.equal = function(t, i, n) {
  if (t != i)
    throw new Error(n || "Assertion failed: " + t + " != " + i);
};
var inherits_browserExports = {}, inherits_browser = { get exports() {
  return inherits_browserExports;
}, set exports(e) {
  inherits_browserExports = e;
} };
typeof Object.create == "function" ? inherits_browser.exports = function(t, i) {
  i && (t.super_ = i, t.prototype = Object.create(i.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }));
} : inherits_browser.exports = function(t, i) {
  if (i) {
    t.super_ = i;
    var n = function() {
    };
    n.prototype = i.prototype, t.prototype = new n(), t.prototype.constructor = t;
  }
};
var assert$e = minimalisticAssert, inherits$3 = inherits_browserExports;
utils$m.inherits = inherits$3;
function isSurrogatePair(e, t) {
  return (e.charCodeAt(t) & 64512) !== 55296 || t < 0 || t + 1 >= e.length ? !1 : (e.charCodeAt(t + 1) & 64512) === 56320;
}
function toArray(e, t) {
  if (Array.isArray(e))
    return e.slice();
  if (!e)
    return [];
  var i = [];
  if (typeof e == "string")
    if (t) {
      if (t === "hex")
        for (e = e.replace(/[^a-z0-9]+/ig, ""), e.length % 2 !== 0 && (e = "0" + e), a = 0; a < e.length; a += 2)
          i.push(parseInt(e[a] + e[a + 1], 16));
    } else
      for (var n = 0, a = 0; a < e.length; a++) {
        var o = e.charCodeAt(a);
        o < 128 ? i[n++] = o : o < 2048 ? (i[n++] = o >> 6 | 192, i[n++] = o & 63 | 128) : isSurrogatePair(e, a) ? (o = 65536 + ((o & 1023) << 10) + (e.charCodeAt(++a) & 1023), i[n++] = o >> 18 | 240, i[n++] = o >> 12 & 63 | 128, i[n++] = o >> 6 & 63 | 128, i[n++] = o & 63 | 128) : (i[n++] = o >> 12 | 224, i[n++] = o >> 6 & 63 | 128, i[n++] = o & 63 | 128);
      }
  else
    for (a = 0; a < e.length; a++)
      i[a] = e[a] | 0;
  return i;
}
utils$m.toArray = toArray;
function toHex(e) {
  for (var t = "", i = 0; i < e.length; i++)
    t += zero2(e[i].toString(16));
  return t;
}
utils$m.toHex = toHex;
function htonl(e) {
  var t = e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (e & 255) << 24;
  return t >>> 0;
}
utils$m.htonl = htonl;
function toHex32(e, t) {
  for (var i = "", n = 0; n < e.length; n++) {
    var a = e[n];
    t === "little" && (a = htonl(a)), i += zero8(a.toString(16));
  }
  return i;
}
utils$m.toHex32 = toHex32;
function zero2(e) {
  return e.length === 1 ? "0" + e : e;
}
utils$m.zero2 = zero2;
function zero8(e) {
  return e.length === 7 ? "0" + e : e.length === 6 ? "00" + e : e.length === 5 ? "000" + e : e.length === 4 ? "0000" + e : e.length === 3 ? "00000" + e : e.length === 2 ? "000000" + e : e.length === 1 ? "0000000" + e : e;
}
utils$m.zero8 = zero8;
function join32(e, t, i, n) {
  var a = i - t;
  assert$e(a % 4 === 0);
  for (var o = new Array(a / 4), l = 0, c = t; l < o.length; l++, c += 4) {
    var d;
    n === "big" ? d = e[c] << 24 | e[c + 1] << 16 | e[c + 2] << 8 | e[c + 3] : d = e[c + 3] << 24 | e[c + 2] << 16 | e[c + 1] << 8 | e[c], o[l] = d >>> 0;
  }
  return o;
}
utils$m.join32 = join32;
function split32(e, t) {
  for (var i = new Array(e.length * 4), n = 0, a = 0; n < e.length; n++, a += 4) {
    var o = e[n];
    t === "big" ? (i[a] = o >>> 24, i[a + 1] = o >>> 16 & 255, i[a + 2] = o >>> 8 & 255, i[a + 3] = o & 255) : (i[a + 3] = o >>> 24, i[a + 2] = o >>> 16 & 255, i[a + 1] = o >>> 8 & 255, i[a] = o & 255);
  }
  return i;
}
utils$m.split32 = split32;
function rotr32$1(e, t) {
  return e >>> t | e << 32 - t;
}
utils$m.rotr32 = rotr32$1;
function rotl32$2(e, t) {
  return e << t | e >>> 32 - t;
}
utils$m.rotl32 = rotl32$2;
function sum32$3(e, t) {
  return e + t >>> 0;
}
utils$m.sum32 = sum32$3;
function sum32_3$1(e, t, i) {
  return e + t + i >>> 0;
}
utils$m.sum32_3 = sum32_3$1;
function sum32_4$2(e, t, i, n) {
  return e + t + i + n >>> 0;
}
utils$m.sum32_4 = sum32_4$2;
function sum32_5$2(e, t, i, n, a) {
  return e + t + i + n + a >>> 0;
}
utils$m.sum32_5 = sum32_5$2;
function sum64$1(e, t, i, n) {
  var a = e[t], o = e[t + 1], l = n + o >>> 0, c = (l < n ? 1 : 0) + i + a;
  e[t] = c >>> 0, e[t + 1] = l;
}
utils$m.sum64 = sum64$1;
function sum64_hi$1(e, t, i, n) {
  var a = t + n >>> 0, o = (a < t ? 1 : 0) + e + i;
  return o >>> 0;
}
utils$m.sum64_hi = sum64_hi$1;
function sum64_lo$1(e, t, i, n) {
  var a = t + n;
  return a >>> 0;
}
utils$m.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(e, t, i, n, a, o, l, c) {
  var d = 0, u = t;
  u = u + n >>> 0, d += u < t ? 1 : 0, u = u + o >>> 0, d += u < o ? 1 : 0, u = u + c >>> 0, d += u < c ? 1 : 0;
  var m = e + i + a + l + d;
  return m >>> 0;
}
utils$m.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(e, t, i, n, a, o, l, c) {
  var d = t + n + o + c;
  return d >>> 0;
}
utils$m.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(e, t, i, n, a, o, l, c, d, u) {
  var m = 0, A = t;
  A = A + n >>> 0, m += A < t ? 1 : 0, A = A + o >>> 0, m += A < o ? 1 : 0, A = A + c >>> 0, m += A < c ? 1 : 0, A = A + u >>> 0, m += A < u ? 1 : 0;
  var y = e + i + a + l + d + m;
  return y >>> 0;
}
utils$m.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(e, t, i, n, a, o, l, c, d, u) {
  var m = t + n + o + c + u;
  return m >>> 0;
}
utils$m.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(e, t, i) {
  var n = t << 32 - i | e >>> i;
  return n >>> 0;
}
utils$m.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(e, t, i) {
  var n = e << 32 - i | t >>> i;
  return n >>> 0;
}
utils$m.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(e, t, i) {
  return e >>> i;
}
utils$m.shr64_hi = shr64_hi$1;
function shr64_lo$1(e, t, i) {
  var n = e << 32 - i | t >>> i;
  return n >>> 0;
}
utils$m.shr64_lo = shr64_lo$1;
var common$5 = {}, utils$l = utils$m, assert$d = minimalisticAssert;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$5.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function(t, i) {
  if (t = utils$l.toArray(t, i), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
    t = this.pending;
    var n = t.length % this._delta8;
    this.pending = t.slice(t.length - n, t.length), this.pending.length === 0 && (this.pending = null), t = utils$l.join32(t, 0, t.length - n, this.endian);
    for (var a = 0; a < t.length; a += this._delta32)
      this._update(t, a, a + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function(t) {
  return this.update(this._pad()), assert$d(this.pending === null), this._digest(t);
};
BlockHash$4.prototype._pad = function() {
  var t = this.pendingTotal, i = this._delta8, n = i - (t + this.padLength) % i, a = new Array(n + this.padLength);
  a[0] = 128;
  for (var o = 1; o < n; o++)
    a[o] = 0;
  if (t <<= 3, this.endian === "big") {
    for (var l = 8; l < this.padLength; l++)
      a[o++] = 0;
    a[o++] = 0, a[o++] = 0, a[o++] = 0, a[o++] = 0, a[o++] = t >>> 24 & 255, a[o++] = t >>> 16 & 255, a[o++] = t >>> 8 & 255, a[o++] = t & 255;
  } else
    for (a[o++] = t & 255, a[o++] = t >>> 8 & 255, a[o++] = t >>> 16 & 255, a[o++] = t >>> 24 & 255, a[o++] = 0, a[o++] = 0, a[o++] = 0, a[o++] = 0, l = 8; l < this.padLength; l++)
      a[o++] = 0;
  return a;
};
var sha = {}, common$4 = {}, utils$k = utils$m, rotr32 = utils$k.rotr32;
function ft_1$1(e, t, i, n) {
  if (e === 0)
    return ch32$1(t, i, n);
  if (e === 1 || e === 3)
    return p32(t, i, n);
  if (e === 2)
    return maj32$1(t, i, n);
}
common$4.ft_1 = ft_1$1;
function ch32$1(e, t, i) {
  return e & t ^ ~e & i;
}
common$4.ch32 = ch32$1;
function maj32$1(e, t, i) {
  return e & t ^ e & i ^ t & i;
}
common$4.maj32 = maj32$1;
function p32(e, t, i) {
  return e ^ t ^ i;
}
common$4.p32 = p32;
function s0_256$1(e) {
  return rotr32(e, 2) ^ rotr32(e, 13) ^ rotr32(e, 22);
}
common$4.s0_256 = s0_256$1;
function s1_256$1(e) {
  return rotr32(e, 6) ^ rotr32(e, 11) ^ rotr32(e, 25);
}
common$4.s1_256 = s1_256$1;
function g0_256$1(e) {
  return rotr32(e, 7) ^ rotr32(e, 18) ^ e >>> 3;
}
common$4.g0_256 = g0_256$1;
function g1_256$1(e) {
  return rotr32(e, 17) ^ rotr32(e, 19) ^ e >>> 10;
}
common$4.g1_256 = g1_256$1;
var utils$j = utils$m, common$3 = common$5, shaCommon$1 = common$4, rotl32$1 = utils$j.rotl32, sum32$2 = utils$j.sum32, sum32_5$1 = utils$j.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$3.BlockHash, sha1_K = [1518500249, 1859775393, 2400959708, 3395469782];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
}
utils$j.inherits(SHA1, BlockHash$3);
var _1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function(t, i) {
  for (var n = this.W, a = 0; a < 16; a++)
    n[a] = t[i + a];
  for (; a < n.length; a++)
    n[a] = rotl32$1(n[a - 3] ^ n[a - 8] ^ n[a - 14] ^ n[a - 16], 1);
  var o = this.h[0], l = this.h[1], c = this.h[2], d = this.h[3], u = this.h[4];
  for (a = 0; a < n.length; a++) {
    var m = ~~(a / 20), A = sum32_5$1(rotl32$1(o, 5), ft_1(m, l, c, d), u, n[a], sha1_K[m]);
    u = d, d = c, c = rotl32$1(l, 30), l = o, o = A;
  }
  this.h[0] = sum32$2(this.h[0], o), this.h[1] = sum32$2(this.h[1], l), this.h[2] = sum32$2(this.h[2], c), this.h[3] = sum32$2(this.h[3], d), this.h[4] = sum32$2(this.h[4], u);
};
SHA1.prototype._digest = function(t) {
  return t === "hex" ? utils$j.toHex32(this.h, "big") : utils$j.split32(this.h, "big");
};
var utils$i = utils$m, common$2 = common$5, shaCommon = common$4, assert$c = minimalisticAssert, sum32$1 = utils$i.sum32, sum32_4$1 = utils$i.sum32_4, sum32_5 = utils$i.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$2.BlockHash, sha256_K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
function SHA256$1() {
  if (!(this instanceof SHA256$1))
    return new SHA256$1();
  BlockHash$2.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = sha256_K, this.W = new Array(64);
}
utils$i.inherits(SHA256$1, BlockHash$2);
var _256 = SHA256$1;
SHA256$1.blockSize = 512;
SHA256$1.outSize = 256;
SHA256$1.hmacStrength = 192;
SHA256$1.padLength = 64;
SHA256$1.prototype._update = function(t, i) {
  for (var n = this.W, a = 0; a < 16; a++)
    n[a] = t[i + a];
  for (; a < n.length; a++)
    n[a] = sum32_4$1(g1_256(n[a - 2]), n[a - 7], g0_256(n[a - 15]), n[a - 16]);
  var o = this.h[0], l = this.h[1], c = this.h[2], d = this.h[3], u = this.h[4], m = this.h[5], A = this.h[6], y = this.h[7];
  for (assert$c(this.k.length === n.length), a = 0; a < n.length; a++) {
    var D = sum32_5(y, s1_256(u), ch32(u, m, A), this.k[a], n[a]), C = sum32$1(s0_256(o), maj32(o, l, c));
    y = A, A = m, m = u, u = sum32$1(d, D), d = c, c = l, l = o, o = sum32$1(D, C);
  }
  this.h[0] = sum32$1(this.h[0], o), this.h[1] = sum32$1(this.h[1], l), this.h[2] = sum32$1(this.h[2], c), this.h[3] = sum32$1(this.h[3], d), this.h[4] = sum32$1(this.h[4], u), this.h[5] = sum32$1(this.h[5], m), this.h[6] = sum32$1(this.h[6], A), this.h[7] = sum32$1(this.h[7], y);
};
SHA256$1.prototype._digest = function(t) {
  return t === "hex" ? utils$i.toHex32(this.h, "big") : utils$i.split32(this.h, "big");
};
var utils$h = utils$m, SHA256 = _256;
function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();
  SHA256.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
}
utils$h.inherits(SHA224, SHA256);
var _224 = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function(t) {
  return t === "hex" ? utils$h.toHex32(this.h.slice(0, 7), "big") : utils$h.split32(this.h.slice(0, 7), "big");
};
var utils$g = utils$m, common$1 = common$5, assert$b = minimalisticAssert, rotr64_hi = utils$g.rotr64_hi, rotr64_lo = utils$g.rotr64_lo, shr64_hi = utils$g.shr64_hi, shr64_lo = utils$g.shr64_lo, sum64 = utils$g.sum64, sum64_hi = utils$g.sum64_hi, sum64_lo = utils$g.sum64_lo, sum64_4_hi = utils$g.sum64_4_hi, sum64_4_lo = utils$g.sum64_4_lo, sum64_5_hi = utils$g.sum64_5_hi, sum64_5_lo = utils$g.sum64_5_lo, BlockHash$1 = common$1.BlockHash, sha512_K = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];
function SHA512$1() {
  if (!(this instanceof SHA512$1))
    return new SHA512$1();
  BlockHash$1.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = sha512_K, this.W = new Array(160);
}
utils$g.inherits(SHA512$1, BlockHash$1);
var _512 = SHA512$1;
SHA512$1.blockSize = 1024;
SHA512$1.outSize = 512;
SHA512$1.hmacStrength = 192;
SHA512$1.padLength = 128;
SHA512$1.prototype._prepareBlock = function(t, i) {
  for (var n = this.W, a = 0; a < 32; a++)
    n[a] = t[i + a];
  for (; a < n.length; a += 2) {
    var o = g1_512_hi(n[a - 4], n[a - 3]), l = g1_512_lo(n[a - 4], n[a - 3]), c = n[a - 14], d = n[a - 13], u = g0_512_hi(n[a - 30], n[a - 29]), m = g0_512_lo(n[a - 30], n[a - 29]), A = n[a - 32], y = n[a - 31];
    n[a] = sum64_4_hi(o, l, c, d, u, m, A, y), n[a + 1] = sum64_4_lo(o, l, c, d, u, m, A, y);
  }
};
SHA512$1.prototype._update = function(t, i) {
  this._prepareBlock(t, i);
  var n = this.W, a = this.h[0], o = this.h[1], l = this.h[2], c = this.h[3], d = this.h[4], u = this.h[5], m = this.h[6], A = this.h[7], y = this.h[8], D = this.h[9], C = this.h[10], z = this.h[11], R = this.h[12], O = this.h[13], $ = this.h[14], k = this.h[15];
  assert$b(this.k.length === n.length);
  for (var P = 0; P < n.length; P += 2) {
    var L = $, F = k, B = s1_512_hi(y, D), G = s1_512_lo(y, D), Z = ch64_hi(y, D, C, z, R), X = ch64_lo(y, D, C, z, R, O), V = this.k[P], E = this.k[P + 1], T = n[P], g = n[P + 1], b = sum64_5_hi(L, F, B, G, Z, X, V, E, T, g), x = sum64_5_lo(L, F, B, G, Z, X, V, E, T, g);
    L = s0_512_hi(a, o), F = s0_512_lo(a, o), B = maj64_hi(a, o, l, c, d), G = maj64_lo(a, o, l, c, d, u);
    var S = sum64_hi(L, F, B, G), I = sum64_lo(L, F, B, G);
    $ = R, k = O, R = C, O = z, C = y, z = D, y = sum64_hi(m, A, b, x), D = sum64_lo(A, A, b, x), m = d, A = u, d = l, u = c, l = a, c = o, a = sum64_hi(b, x, S, I), o = sum64_lo(b, x, S, I);
  }
  sum64(this.h, 0, a, o), sum64(this.h, 2, l, c), sum64(this.h, 4, d, u), sum64(this.h, 6, m, A), sum64(this.h, 8, y, D), sum64(this.h, 10, C, z), sum64(this.h, 12, R, O), sum64(this.h, 14, $, k);
};
SHA512$1.prototype._digest = function(t) {
  return t === "hex" ? utils$g.toHex32(this.h, "big") : utils$g.split32(this.h, "big");
};
function ch64_hi(e, t, i, n, a) {
  var o = e & i ^ ~e & a;
  return o < 0 && (o += 4294967296), o;
}
function ch64_lo(e, t, i, n, a, o) {
  var l = t & n ^ ~t & o;
  return l < 0 && (l += 4294967296), l;
}
function maj64_hi(e, t, i, n, a) {
  var o = e & i ^ e & a ^ i & a;
  return o < 0 && (o += 4294967296), o;
}
function maj64_lo(e, t, i, n, a, o) {
  var l = t & n ^ t & o ^ n & o;
  return l < 0 && (l += 4294967296), l;
}
function s0_512_hi(e, t) {
  var i = rotr64_hi(e, t, 28), n = rotr64_hi(t, e, 2), a = rotr64_hi(t, e, 7), o = i ^ n ^ a;
  return o < 0 && (o += 4294967296), o;
}
function s0_512_lo(e, t) {
  var i = rotr64_lo(e, t, 28), n = rotr64_lo(t, e, 2), a = rotr64_lo(t, e, 7), o = i ^ n ^ a;
  return o < 0 && (o += 4294967296), o;
}
function s1_512_hi(e, t) {
  var i = rotr64_hi(e, t, 14), n = rotr64_hi(e, t, 18), a = rotr64_hi(t, e, 9), o = i ^ n ^ a;
  return o < 0 && (o += 4294967296), o;
}
function s1_512_lo(e, t) {
  var i = rotr64_lo(e, t, 14), n = rotr64_lo(e, t, 18), a = rotr64_lo(t, e, 9), o = i ^ n ^ a;
  return o < 0 && (o += 4294967296), o;
}
function g0_512_hi(e, t) {
  var i = rotr64_hi(e, t, 1), n = rotr64_hi(e, t, 8), a = shr64_hi(e, t, 7), o = i ^ n ^ a;
  return o < 0 && (o += 4294967296), o;
}
function g0_512_lo(e, t) {
  var i = rotr64_lo(e, t, 1), n = rotr64_lo(e, t, 8), a = shr64_lo(e, t, 7), o = i ^ n ^ a;
  return o < 0 && (o += 4294967296), o;
}
function g1_512_hi(e, t) {
  var i = rotr64_hi(e, t, 19), n = rotr64_hi(t, e, 29), a = shr64_hi(e, t, 6), o = i ^ n ^ a;
  return o < 0 && (o += 4294967296), o;
}
function g1_512_lo(e, t) {
  var i = rotr64_lo(e, t, 19), n = rotr64_lo(t, e, 29), a = shr64_lo(e, t, 6), o = i ^ n ^ a;
  return o < 0 && (o += 4294967296), o;
}
var utils$f = utils$m, SHA512 = _512;
function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();
  SHA512.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
}
utils$f.inherits(SHA384, SHA512);
var _384 = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function(t) {
  return t === "hex" ? utils$f.toHex32(this.h.slice(0, 12), "big") : utils$f.split32(this.h.slice(0, 12), "big");
};
sha.sha1 = _1;
sha.sha224 = _224;
sha.sha256 = _256;
sha.sha384 = _384;
sha.sha512 = _512;
var ripemd$1 = {}, utils$e = utils$m, common = common$5, rotl32 = utils$e.rotl32, sum32 = utils$e.sum32, sum32_3 = utils$e.sum32_3, sum32_4 = utils$e.sum32_4, BlockHash = common.BlockHash;
function RIPEMD160$1() {
  if (!(this instanceof RIPEMD160$1))
    return new RIPEMD160$1();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$e.inherits(RIPEMD160$1, BlockHash);
ripemd$1.ripemd160 = RIPEMD160$1;
RIPEMD160$1.blockSize = 512;
RIPEMD160$1.outSize = 160;
RIPEMD160$1.hmacStrength = 192;
RIPEMD160$1.padLength = 64;
RIPEMD160$1.prototype._update = function(t, i) {
  for (var n = this.h[0], a = this.h[1], o = this.h[2], l = this.h[3], c = this.h[4], d = n, u = a, m = o, A = l, y = c, D = 0; D < 80; D++) {
    var C = sum32(rotl32(sum32_4(n, f(D, a, o, l), t[r$1[D] + i], K(D)), s[D]), c);
    n = c, c = l, l = rotl32(o, 10), o = a, a = C, C = sum32(rotl32(sum32_4(d, f(79 - D, u, m, A), t[rh[D] + i], Kh(D)), sh[D]), y), d = y, y = A, A = rotl32(m, 10), m = u, u = C;
  }
  C = sum32_3(this.h[1], o, A), this.h[1] = sum32_3(this.h[2], l, y), this.h[2] = sum32_3(this.h[3], c, d), this.h[3] = sum32_3(this.h[4], n, u), this.h[4] = sum32_3(this.h[0], a, m), this.h[0] = C;
};
RIPEMD160$1.prototype._digest = function(t) {
  return t === "hex" ? utils$e.toHex32(this.h, "little") : utils$e.split32(this.h, "little");
};
function f(e, t, i, n) {
  return e <= 15 ? t ^ i ^ n : e <= 31 ? t & i | ~t & n : e <= 47 ? (t | ~i) ^ n : e <= 63 ? t & n | i & ~n : t ^ (i | ~n);
}
function K(e) {
  return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
}
function Kh(e) {
  return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
}
var r$1 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13], rh = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11], s = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6], sh = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11], utils$d = utils$m, assert$a = minimalisticAssert;
function Hmac(e, t, i) {
  if (!(this instanceof Hmac))
    return new Hmac(e, t, i);
  this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(utils$d.toArray(t, i));
}
var hmac = Hmac;
Hmac.prototype._init = function(t) {
  t.length > this.blockSize && (t = new this.Hash().update(t).digest()), assert$a(t.length <= this.blockSize);
  for (var i = t.length; i < this.blockSize; i++)
    t.push(0);
  for (i = 0; i < t.length; i++)
    t[i] ^= 54;
  for (this.inner = new this.Hash().update(t), i = 0; i < t.length; i++)
    t[i] ^= 106;
  this.outer = new this.Hash().update(t);
};
Hmac.prototype.update = function(t, i) {
  return this.inner.update(t, i), this;
};
Hmac.prototype.digest = function(t) {
  return this.outer.update(this.inner.digest()), this.outer.digest(t);
};
(function(e) {
  var t = e;
  t.utils = utils$m, t.common = common$5, t.sha = sha, t.ripemd = ripemd$1, t.hmac = hmac, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
})(hash$2);
var _slicedToArray$1 = function() {
  function e(t, i) {
    var n = [], a = !0, o = !1, l = void 0;
    try {
      for (var c = t[Symbol.iterator](), d; !(a = (d = c.next()).done) && (n.push(d.value), !(i && n.length === i)); a = !0)
        ;
    } catch (u) {
      o = !0, l = u;
    } finally {
      try {
        !a && c.return && c.return();
      } finally {
        if (o)
          throw l;
      }
    }
    return n;
  }
  return function(t, i) {
    if (Array.isArray(t))
      return t;
    if (Symbol.iterator in Object(t))
      return e(t, i);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(), _createClass = function() {
  function e(t, i) {
    for (var n = 0; n < i.length; n++) {
      var a = i[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, i, n) {
    return i && e(t.prototype, i), n && e(t, n), t;
  };
}();
function _classCallCheck(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var RIPEMD160 = function() {
  function e() {
    _classCallCheck(this, e);
  }
  return _createClass(e, null, [{ key: "get_n_pad_bytes", value: function(i) {
    return 64 - (i + 8 & 63);
  } }, { key: "pad", value: function(i) {
    var n = i.byteLength, a = e.get_n_pad_bytes(n), o = function(D, C) {
      return [Math.floor(D / C), D % C];
    }, l = o(
      n,
      536870912
      /* (2 ** 29) */
    ).map(function(y, D) {
      return D ? y * 8 : y;
    }), c = _slicedToArray$1(l, 2), d = c[0], u = c[1], m = new Uint8Array(n + a + 8);
    m.set(new Uint8Array(i), 0);
    var A = new DataView(m.buffer);
    return A.setUint8(n, 128), A.setUint32(
      n + a,
      u,
      !0
      // Little-endian
    ), A.setUint32(
      n + a + 4,
      d,
      !0
      // Little-endian
    ), m.buffer;
  } }, { key: "f", value: function(i, n, a, o) {
    if (0 <= i && i <= 15)
      return n ^ a ^ o;
    if (16 <= i && i <= 31)
      return n & a | ~n & o;
    if (32 <= i && i <= 47)
      return (n | ~a) ^ o;
    if (48 <= i && i <= 63)
      return n & o | a & ~o;
    if (64 <= i && i <= 79)
      return n ^ (a | ~o);
  } }, { key: "K", value: function(i) {
    if (0 <= i && i <= 15)
      return 0;
    if (16 <= i && i <= 31)
      return 1518500249;
    if (32 <= i && i <= 47)
      return 1859775393;
    if (48 <= i && i <= 63)
      return 2400959708;
    if (64 <= i && i <= 79)
      return 2840853838;
  } }, { key: "KP", value: function(i) {
    if (0 <= i && i <= 15)
      return 1352829926;
    if (16 <= i && i <= 31)
      return 1548603684;
    if (32 <= i && i <= 47)
      return 1836072691;
    if (48 <= i && i <= 63)
      return 2053994217;
    if (64 <= i && i <= 79)
      return 0;
  } }, { key: "add_modulo32", value: function() {
    return Array.from(arguments).reduce(function(i, n) {
      return i + n;
    }, 0) | 0;
  } }, { key: "rol32", value: function(i, n) {
    return i << n | i >>> 32 - n;
  } }, { key: "hash", value: function(i) {
    for (var n = e.pad(i), a = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13], o = [
      // r'
      5,
      14,
      7,
      0,
      9,
      2,
      11,
      4,
      13,
      6,
      15,
      8,
      1,
      10,
      3,
      12,
      6,
      11,
      3,
      7,
      0,
      13,
      5,
      10,
      14,
      15,
      8,
      12,
      4,
      9,
      1,
      2,
      15,
      5,
      1,
      3,
      7,
      14,
      6,
      9,
      11,
      8,
      12,
      2,
      10,
      0,
      4,
      13,
      8,
      6,
      4,
      1,
      3,
      11,
      15,
      0,
      5,
      12,
      2,
      13,
      9,
      7,
      10,
      14,
      12,
      15,
      10,
      4,
      1,
      5,
      8,
      7,
      6,
      2,
      13,
      14,
      0,
      3,
      9,
      11
    ], l = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6], c = [
      // s'
      8,
      9,
      9,
      11,
      13,
      15,
      15,
      5,
      7,
      7,
      8,
      11,
      14,
      14,
      12,
      6,
      9,
      13,
      15,
      7,
      12,
      8,
      9,
      11,
      7,
      7,
      12,
      7,
      6,
      15,
      13,
      11,
      9,
      7,
      15,
      11,
      8,
      6,
      6,
      14,
      12,
      13,
      5,
      14,
      13,
      13,
      7,
      5,
      15,
      5,
      8,
      11,
      14,
      14,
      6,
      14,
      6,
      9,
      12,
      9,
      12,
      5,
      15,
      8,
      8,
      5,
      12,
      9,
      12,
      5,
      14,
      6,
      8,
      13,
      6,
      5,
      15,
      13,
      11,
      11
    ], d = 4, u = 64, m = n.byteLength / u, A = new Array(m).fill(void 0).map(function(T, g) {
      return function(b) {
        return new DataView(n, g * u, u).getUint32(
          b * d,
          !0
          // Little-endian
        );
      };
    }), y = [
      1732584193,
      // h_0
      4023233417,
      // h_1
      2562383102,
      // h_2
      271733878,
      // h_3
      3285377520
      // h_4
    ], D = 0; D < m; ++D) {
      for (var C = y[0], z = y[1], R = y[2], O = y[3], $ = y[4], k = C, P = z, L = R, F = O, B = $, G = 0; G < 80; ++G) {
        var Z = e.add_modulo32(e.rol32(e.add_modulo32(C, e.f(G, z, R, O), A[D](a[G]), e.K(G)), l[G]), $);
        C = $, $ = O, O = e.rol32(R, 10), R = z, z = Z, Z = e.add_modulo32(e.rol32(e.add_modulo32(k, e.f(79 - G, P, L, F), A[D](o[G]), e.KP(G)), c[G]), B), k = B, B = F, F = e.rol32(L, 10), L = P, P = Z;
      }
      var X = e.add_modulo32(y[1], R, F);
      y[1] = e.add_modulo32(y[2], O, B), y[2] = e.add_modulo32(y[3], $, k), y[3] = e.add_modulo32(y[4], C, P), y[4] = e.add_modulo32(y[0], z, L), y[0] = X;
    }
    var V = new ArrayBuffer(20), E = new DataView(V);
    return y.forEach(function(T, g) {
      return E.setUint32(g * 4, T, !0);
    }), V;
  } }]), e;
}(), ripemd = { RIPEMD160 };
(function(e) {
  var t = commonjsGlobal && commonjsGlobal.__read || function(p, M) {
    var j = typeof Symbol == "function" && p[Symbol.iterator];
    if (!j)
      return p;
    var U = j.call(p), H, J = [], te;
    try {
      for (; (M === void 0 || M-- > 0) && !(H = U.next()).done; )
        J.push(H.value);
    } catch (ae) {
      te = { error: ae };
    } finally {
      try {
        H && !H.done && (j = U.return) && j.call(U);
      } finally {
        if (te)
          throw te.error;
      }
    }
    return J;
  }, i = commonjsGlobal && commonjsGlobal.__spreadArray || function(p, M) {
    for (var j = 0, U = M.length, H = p.length; j < U; j++, H++)
      p[H] = M[j];
    return p;
  }, n = commonjsGlobal && commonjsGlobal.__values || function(p) {
    var M = typeof Symbol == "function" && Symbol.iterator, j = M && p[M], U = 0;
    if (j)
      return j.call(p);
    if (p && typeof p.length == "number")
      return { next: function() {
        return p && U >= p.length && (p = void 0), { value: p && p[U++], done: !p };
      } };
    throw new TypeError(M ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.signatureToString = e.stringToSignature = e.privateKeyToString = e.privateKeyToLegacyString = e.stringToPrivateKey = e.convertLegacyPublicKeys = e.convertLegacyPublicKey = e.publicKeyToString = e.publicKeyToLegacyString = e.stringToPublicKey = e.signatureDataSize = e.privateKeyDataSize = e.publicKeyDataSize = e.KeyType = e.base64ToBinary = e.binaryToBase58 = e.base58ToBinary = e.signedBinaryToDecimal = e.binaryToDecimal = e.signedDecimalToBinary = e.decimalToBinary = e.negate = e.isNegative = void 0;
  var a = hash$2, o = ripemd.RIPEMD160.hash, l = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", d = function() {
    for (var p = Array(256).fill(-1), M = 0; M < l.length; ++M)
      p[l.charCodeAt(M)] = M;
    return p;
  }, u = d(), m = function() {
    for (var p = Array(256).fill(-1), M = 0; M < c.length; ++M)
      p[c.charCodeAt(M)] = M;
    return p["=".charCodeAt(0)] = 0, p;
  }, A = m(), y = function(p) {
    return (p[p.length - 1] & 128) !== 0;
  };
  e.isNegative = y;
  var D = function(p) {
    for (var M = 1, j = 0; j < p.length; ++j) {
      var U = (~p[j] & 255) + M;
      p[j] = U, M = U >> 8;
    }
  };
  e.negate = D;
  var C = function(p, M) {
    for (var j = new Uint8Array(p), U = 0; U < M.length; ++U) {
      var H = M.charCodeAt(U);
      if (H < "0".charCodeAt(0) || H > "9".charCodeAt(0))
        throw new Error("invalid number");
      for (var J = H - "0".charCodeAt(0), te = 0; te < p; ++te) {
        var ae = j[te] * 10 + J;
        j[te] = ae, J = ae >> 8;
      }
      if (J)
        throw new Error("number is out of range");
    }
    return j;
  };
  e.decimalToBinary = C;
  var z = function(p, M) {
    var j = M[0] === "-";
    j && (M = M.substr(1));
    var U = e.decimalToBinary(p, M);
    if (j) {
      if (e.negate(U), !e.isNegative(U))
        throw new Error("number is out of range");
    } else if (e.isNegative(U))
      throw new Error("number is out of range");
    return U;
  };
  e.signedDecimalToBinary = z;
  var R = function(p, M) {
    M === void 0 && (M = 1);
    for (var j = Array(M).fill("0".charCodeAt(0)), U = p.length - 1; U >= 0; --U) {
      for (var H = p[U], J = 0; J < j.length; ++J) {
        var te = (j[J] - "0".charCodeAt(0) << 8) + H;
        j[J] = "0".charCodeAt(0) + te % 10, H = te / 10 | 0;
      }
      for (; H; )
        j.push("0".charCodeAt(0) + H % 10), H = H / 10 | 0;
    }
    return j.reverse(), String.fromCharCode.apply(String, i([], t(j)));
  };
  e.binaryToDecimal = R;
  var O = function(p, M) {
    if (M === void 0 && (M = 1), e.isNegative(p)) {
      var j = p.slice();
      return e.negate(j), "-" + e.binaryToDecimal(j, M);
    }
    return e.binaryToDecimal(p, M);
  };
  e.signedBinaryToDecimal = O;
  var $ = function(p) {
    for (var M, j, U = [], H = 0; H < p.length; ++H) {
      var J = u[p.charCodeAt(H)];
      if (J < 0)
        throw new Error("invalid base-58 value");
      for (var te = 0; te < U.length; ++te) {
        var ae = U[te] * 58 + J;
        U[te] = ae & 255, J = ae >> 8;
      }
      J && U.push(J);
    }
    try {
      for (var le = n(p), ne = le.next(); !ne.done; ne = le.next()) {
        var ue = ne.value;
        if (ue === "1")
          U.push(0);
        else
          break;
      }
    } catch (ge) {
      M = { error: ge };
    } finally {
      try {
        ne && !ne.done && (j = le.return) && j.call(le);
      } finally {
        if (M)
          throw M.error;
      }
    }
    return U.reverse(), new Uint8Array(U);
  }, k = function(p, M) {
    if (!p)
      return $(M);
    for (var j = new Uint8Array(p), U = 0; U < M.length; ++U) {
      var H = u[M.charCodeAt(U)];
      if (H < 0)
        throw new Error("invalid base-58 value");
      for (var J = 0; J < p; ++J) {
        var te = j[J] * 58 + H;
        j[J] = te, H = te >> 8;
      }
      if (H)
        throw new Error("base-58 value is out of range");
    }
    return j.reverse(), j;
  };
  e.base58ToBinary = k;
  var P = function(p, M) {
    var j, U, H, J, te = [];
    try {
      for (var ae = n(p), le = ae.next(); !le.done; le = ae.next()) {
        for (var ne = le.value, ue = ne, ge = 0; ge < te.length; ++ge) {
          var re = (u[te[ge]] << 8) + ue;
          te[ge] = l.charCodeAt(re % 58), ue = re / 58 | 0;
        }
        for (; ue; )
          te.push(l.charCodeAt(ue % 58)), ue = ue / 58 | 0;
      }
    } catch (ve) {
      j = { error: ve };
    } finally {
      try {
        le && !le.done && (U = ae.return) && U.call(ae);
      } finally {
        if (j)
          throw j.error;
      }
    }
    try {
      for (var fe = n(p), oe = fe.next(); !oe.done; oe = fe.next()) {
        var ne = oe.value;
        if (ne)
          break;
        te.push("1".charCodeAt(0));
      }
    } catch (ve) {
      H = { error: ve };
    } finally {
      try {
        oe && !oe.done && (J = fe.return) && J.call(fe);
      } finally {
        if (H)
          throw H.error;
      }
    }
    return te.reverse(), String.fromCharCode.apply(String, i([], t(te)));
  };
  e.binaryToBase58 = P;
  var L = function(p) {
    var M = p.length;
    if ((M & 3) === 1 && p[M - 1] === "=" && (M -= 1), M & 3)
      throw new Error("base-64 value is not padded correctly");
    var j = M >> 2, U = j * 3;
    M > 0 && p[M - 1] === "=" && (p[M - 2] === "=" ? U -= 2 : U -= 1);
    for (var H = new Uint8Array(U), J = 0; J < j; ++J) {
      var te = A[p.charCodeAt(J * 4 + 0)], ae = A[p.charCodeAt(J * 4 + 1)], le = A[p.charCodeAt(J * 4 + 2)], ne = A[p.charCodeAt(J * 4 + 3)];
      H[J * 3 + 0] = te << 2 | ae >> 4, J * 3 + 1 < U && (H[J * 3 + 1] = (ae & 15) << 4 | le >> 2), J * 3 + 2 < U && (H[J * 3 + 2] = (le & 3) << 6 | ne);
    }
    return H;
  };
  e.base64ToBinary = L;
  var F;
  (function(p) {
    p[p.k1 = 0] = "k1", p[p.r1 = 1] = "r1", p[p.wa = 2] = "wa";
  })(F = e.KeyType || (e.KeyType = {})), e.publicKeyDataSize = 33, e.privateKeyDataSize = 32, e.signatureDataSize = 65;
  var B = function(p, M) {
    for (var j = new Uint8Array(p.length + M.length), U = 0; U < p.length; ++U)
      j[U] = p[U];
    for (var U = 0; U < M.length; ++U)
      j[p.length + U] = M.charCodeAt(U);
    return o(j);
  }, G = function(p, M, j, U) {
    var H = e.base58ToBinary(j ? j + 4 : 0, p), J = { type: M, data: new Uint8Array(H.buffer, 0, H.length - 4) }, te = new Uint8Array(B(J.data, U));
    if (te[0] !== H[H.length - 4] || te[1] !== H[H.length - 3] || te[2] !== H[H.length - 2] || te[3] !== H[H.length - 1])
      throw new Error("checksum doesn't match");
    return J;
  }, Z = function(p, M, j) {
    for (var U = new Uint8Array(B(p.data, M)), H = new Uint8Array(p.data.length + 4), J = 0; J < p.data.length; ++J)
      H[J] = p.data[J];
    for (var J = 0; J < 4; ++J)
      H[J + p.data.length] = U[J];
    return j + e.binaryToBase58(H);
  }, X = function(p) {
    if (typeof p != "string")
      throw new Error("expected string containing public key");
    if (p.substr(0, 3) === "EOS") {
      for (var M = e.base58ToBinary(e.publicKeyDataSize + 4, p.substr(3)), j = { type: F.k1, data: new Uint8Array(e.publicKeyDataSize) }, U = 0; U < e.publicKeyDataSize; ++U)
        j.data[U] = M[U];
      var H = new Uint8Array(o(j.data));
      if (H[0] !== M[e.publicKeyDataSize] || H[1] !== M[34] || H[2] !== M[35] || H[3] !== M[36])
        throw new Error("checksum doesn't match");
      return j;
    } else {
      if (p.substr(0, 7) === "PUB_K1_")
        return G(p.substr(7), F.k1, e.publicKeyDataSize, "K1");
      if (p.substr(0, 7) === "PUB_R1_")
        return G(p.substr(7), F.r1, e.publicKeyDataSize, "R1");
      if (p.substr(0, 7) === "PUB_WA_")
        return G(p.substr(7), F.wa, 0, "WA");
      throw new Error("unrecognized public key format");
    }
  };
  e.stringToPublicKey = X;
  var V = function(p) {
    if (p.type === F.k1 && p.data.length === e.publicKeyDataSize)
      return Z(p, "", "EOS");
    throw p.type === F.r1 || p.type === F.wa ? new Error("Key format not supported in legacy conversion") : new Error("unrecognized public key format");
  };
  e.publicKeyToLegacyString = V;
  var E = function(p) {
    if (p.type === F.k1 && p.data.length === e.publicKeyDataSize)
      return Z(p, "K1", "PUB_K1_");
    if (p.type === F.r1 && p.data.length === e.publicKeyDataSize)
      return Z(p, "R1", "PUB_R1_");
    if (p.type === F.wa)
      return Z(p, "WA", "PUB_WA_");
    throw new Error("unrecognized public key format");
  };
  e.publicKeyToString = E;
  var T = function(p) {
    return p.substr(0, 3) === "EOS" ? e.publicKeyToString(e.stringToPublicKey(p)) : p;
  };
  e.convertLegacyPublicKey = T;
  var g = function(p) {
    return p.map(e.convertLegacyPublicKey);
  };
  e.convertLegacyPublicKeys = g;
  var b = function(p) {
    if (typeof p != "string")
      throw new Error("expected string containing private key");
    if (p.substr(0, 7) === "PVT_R1_")
      return G(p.substr(7), F.r1, e.privateKeyDataSize, "R1");
    if (p.substr(0, 7) === "PVT_K1_")
      return G(p.substr(7), F.k1, e.privateKeyDataSize, "K1");
    var M = e.base58ToBinary(e.privateKeyDataSize + 5, p), j = { type: F.k1, data: new Uint8Array(e.privateKeyDataSize) };
    if (M[0] !== 128)
      throw new Error("unrecognized private key type");
    for (var U = 0; U < e.privateKeyDataSize; ++U)
      j.data[U] = M[U + 1];
    return j;
  };
  e.stringToPrivateKey = b;
  var x = function(p) {
    if (p.type === F.k1 && p.data.length === e.privateKeyDataSize) {
      var M = [];
      M.push(128), p.data.forEach(function(J) {
        return M.push(J);
      });
      for (var j = new Uint8Array(a.sha256().update(a.sha256().update(M).digest()).digest()), U = new Uint8Array(e.privateKeyDataSize + 5), H = 0; H < M.length; H++)
        U[H] = M[H];
      for (var H = 0; H < 4; H++)
        U[H + M.length] = j[H];
      return e.binaryToBase58(U);
    } else
      throw p.type === F.r1 || p.type === F.wa ? new Error("Key format not supported in legacy conversion") : new Error("unrecognized public key format");
  };
  e.privateKeyToLegacyString = x;
  var S = function(p) {
    if (p.type === F.r1)
      return Z(p, "R1", "PVT_R1_");
    if (p.type === F.k1)
      return Z(p, "K1", "PVT_K1_");
    throw new Error("unrecognized private key format");
  };
  e.privateKeyToString = S;
  var I = function(p) {
    if (typeof p != "string")
      throw new Error("expected string containing signature");
    if (p.substr(0, 7) === "SIG_K1_")
      return G(p.substr(7), F.k1, e.signatureDataSize, "K1");
    if (p.substr(0, 7) === "SIG_R1_")
      return G(p.substr(7), F.r1, e.signatureDataSize, "R1");
    if (p.substr(0, 7) === "SIG_WA_")
      return G(p.substr(7), F.wa, 0, "WA");
    throw new Error("unrecognized signature format");
  };
  e.stringToSignature = I;
  var N = function(p) {
    if (p.type === F.k1)
      return Z(p, "K1", "SIG_K1_");
    if (p.type === F.r1)
      return Z(p, "R1", "SIG_R1_");
    if (p.type === F.wa)
      return Z(p, "WA", "SIG_WA_");
    throw new Error("unrecognized signature format");
  };
  e.signatureToString = N;
})(eosjsNumeric);
(function(e) {
  var t = commonjsGlobal && commonjsGlobal.__assign || function() {
    return t = Object.assign || function(W) {
      for (var Y, Q = 1, ee = arguments.length; Q < ee; Q++) {
        Y = arguments[Q];
        for (var ie in Y)
          Object.prototype.hasOwnProperty.call(Y, ie) && (W[ie] = Y[ie]);
      }
      return W;
    }, t.apply(this, arguments);
  }, i = commonjsGlobal && commonjsGlobal.__read || function(W, Y) {
    var Q = typeof Symbol == "function" && W[Symbol.iterator];
    if (!Q)
      return W;
    var ee = Q.call(W), ie, se = [], pe;
    try {
      for (; (Y === void 0 || Y-- > 0) && !(ie = ee.next()).done; )
        se.push(ie.value);
    } catch (he) {
      pe = { error: he };
    } finally {
      try {
        ie && !ie.done && (Q = ee.return) && Q.call(ee);
      } finally {
        if (pe)
          throw pe.error;
      }
    }
    return se;
  }, n = commonjsGlobal && commonjsGlobal.__spreadArray || function(W, Y) {
    for (var Q = 0, ee = Y.length, ie = W.length; Q < ee; Q++, ie++)
      W[ie] = Y[Q];
    return W;
  }, a = commonjsGlobal && commonjsGlobal.__values || function(W) {
    var Y = typeof Symbol == "function" && Symbol.iterator, Q = Y && W[Y], ee = 0;
    if (Q)
      return Q.call(W);
    if (W && typeof W.length == "number")
      return { next: function() {
        return W && ee >= W.length && (W = void 0), { value: W && W[ee++], done: !W };
      } };
    throw new TypeError(Y ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.serializeQuery = e.deserializeAnyArray = e.serializeAnyArray = e.deserializeAnyObject = e.serializeAnyObject = e.deserializeAnyvarShort = e.deserializeAnyvar = e.serializeAnyvar = e.deserializeAction = e.deserializeActionData = e.serializeAction = e.serializeActionData = e.transactionHeader = e.getTypesFromAbi = e.getType = e.createTransactionTypes = e.createTransactionExtensionTypes = e.createAbiTypes = e.createInitialTypes = e.hexToUint8Array = e.arrayToHex = e.symbolToString = e.stringToSymbol = e.blockTimestampToDate = e.dateToBlockTimestamp = e.timePointSecToDate = e.dateToTimePointSec = e.timePointToDate = e.dateToTimePoint = e.supportedAbiVersion = e.SerialBuffer = e.SerializerState = void 0;
  var o = eosjsNumeric, l = (
    /** @class */
    function() {
      function W(Y) {
        Y === void 0 && (Y = {}), this.skippedBinaryExtension = !1, this.options = Y;
      }
      return W;
    }()
  );
  e.SerializerState = l;
  var c = (
    /** @class */
    function() {
      function W(Y) {
        var Q = Y === void 0 ? {} : Y, ee = Q.textEncoder, ie = Q.textDecoder, se = Q.array;
        this.readPos = 0, this.array = se || new Uint8Array(1024), this.length = se ? se.length : 0, this.textEncoder = ee || new TextEncoder(), this.textDecoder = ie || new TextDecoder("utf-8", { fatal: !0 });
      }
      return W.prototype.reserve = function(Y) {
        if (!(this.length + Y <= this.array.length)) {
          for (var Q = this.array.length; this.length + Y > Q; )
            Q = Math.ceil(Q * 1.5);
          var ee = new Uint8Array(Q);
          ee.set(this.array), this.array = ee;
        }
      }, W.prototype.haveReadData = function() {
        return this.readPos < this.length;
      }, W.prototype.restartRead = function() {
        this.readPos = 0;
      }, W.prototype.asUint8Array = function() {
        return new Uint8Array(this.array.buffer, this.array.byteOffset, this.length);
      }, W.prototype.pushArray = function(Y) {
        this.reserve(Y.length), this.array.set(Y, this.length), this.length += Y.length;
      }, W.prototype.push = function() {
        for (var Y = [], Q = 0; Q < arguments.length; Q++)
          Y[Q] = arguments[Q];
        this.pushArray(Y);
      }, W.prototype.get = function() {
        if (this.readPos < this.length)
          return this.array[this.readPos++];
        throw new Error("Read past end of buffer");
      }, W.prototype.pushUint8ArrayChecked = function(Y, Q) {
        if (Y.length !== Q)
          throw new Error("Binary data has incorrect size");
        this.pushArray(Y);
      }, W.prototype.getUint8Array = function(Y) {
        if (this.readPos + Y > this.length)
          throw new Error("Read past end of buffer");
        var Q = new Uint8Array(this.array.buffer, this.array.byteOffset + this.readPos, Y);
        return this.readPos += Y, Q;
      }, W.prototype.skip = function(Y) {
        if (this.readPos + Y > this.length)
          throw new Error("Read past end of buffer");
        this.readPos += Y;
      }, W.prototype.pushUint16 = function(Y) {
        this.push(Y >> 0 & 255, Y >> 8 & 255);
      }, W.prototype.getUint16 = function() {
        var Y = 0;
        return Y |= this.get() << 0, Y |= this.get() << 8, Y;
      }, W.prototype.pushUint32 = function(Y) {
        this.push(Y >> 0 & 255, Y >> 8 & 255, Y >> 16 & 255, Y >> 24 & 255);
      }, W.prototype.getUint32 = function() {
        var Y = 0;
        return Y |= this.get() << 0, Y |= this.get() << 8, Y |= this.get() << 16, Y |= this.get() << 24, Y >>> 0;
      }, W.prototype.pushNumberAsUint64 = function(Y) {
        this.pushUint32(Y >>> 0), this.pushUint32(Math.floor(Y / 4294967296) >>> 0);
      }, W.prototype.getUint64AsNumber = function() {
        var Y = this.getUint32(), Q = this.getUint32();
        return (Q >>> 0) * 4294967296 + (Y >>> 0);
      }, W.prototype.pushVaruint32 = function(Y) {
        for (; ; )
          if (Y >>> 7)
            this.push(128 | Y & 127), Y = Y >>> 7;
          else {
            this.push(Y);
            break;
          }
      }, W.prototype.getVaruint32 = function() {
        for (var Y = 0, Q = 0; ; ) {
          var ee = this.get();
          if (Y |= (ee & 127) << Q, Q += 7, !(ee & 128))
            break;
        }
        return Y >>> 0;
      }, W.prototype.pushVarint32 = function(Y) {
        this.pushVaruint32(Y << 1 ^ Y >> 31);
      }, W.prototype.getVarint32 = function() {
        var Y = this.getVaruint32();
        return Y & 1 ? ~Y >> 1 | 2147483648 : Y >>> 1;
      }, W.prototype.pushFloat32 = function(Y) {
        this.pushArray(new Uint8Array(new Float32Array([Y]).buffer));
      }, W.prototype.getFloat32 = function() {
        return new Float32Array(this.getUint8Array(4).slice().buffer)[0];
      }, W.prototype.pushFloat64 = function(Y) {
        this.pushArray(new Uint8Array(new Float64Array([Y]).buffer));
      }, W.prototype.getFloat64 = function() {
        return new Float64Array(this.getUint8Array(8).slice().buffer)[0];
      }, W.prototype.pushName = function(Y) {
        if (typeof Y != "string")
          throw new Error("Expected string containing name");
        var Q = new RegExp(/^[.1-5a-z]{0,12}[.1-5a-j]?$/);
        if (!Q.test(Y))
          throw new Error("Name should be less than 13 characters, or less than 14 if last character is between 1-5 or a-j, and only contain the following symbols .12345abcdefghijklmnopqrstuvwxyz");
        for (var ee = function(_e) {
          return _e >= "a".charCodeAt(0) && _e <= "z".charCodeAt(0) ? _e - "a".charCodeAt(0) + 6 : _e >= "1".charCodeAt(0) && _e <= "5".charCodeAt(0) ? _e - "1".charCodeAt(0) + 1 : 0;
        }, ie = new Uint8Array(8), se = 63, pe = 0; pe < Y.length; ++pe) {
          var he = ee(Y.charCodeAt(pe));
          se < 5 && (he = he << 1);
          for (var Me = 4; Me >= 0; --Me)
            se >= 0 && (ie[Math.floor(se / 8)] |= (he >> Me & 1) << se % 8, --se);
        }
        this.pushArray(ie);
      }, W.prototype.getName = function() {
        for (var Y = this.getUint8Array(8), Q = "", ee = 63; ee >= 0; ) {
          for (var ie = 0, se = 0; se < 5; ++se)
            ee >= 0 && (ie = ie << 1 | Y[Math.floor(ee / 8)] >> ee % 8 & 1, --ee);
          ie >= 6 ? Q += String.fromCharCode(ie + "a".charCodeAt(0) - 6) : ie >= 1 ? Q += String.fromCharCode(ie + "1".charCodeAt(0) - 1) : Q += ".";
        }
        for (; Q.endsWith("."); )
          Q = Q.substr(0, Q.length - 1);
        return Q;
      }, W.prototype.pushBytes = function(Y) {
        this.pushVaruint32(Y.length), this.pushArray(Y);
      }, W.prototype.getBytes = function() {
        return this.getUint8Array(this.getVaruint32());
      }, W.prototype.pushString = function(Y) {
        this.pushBytes(this.textEncoder.encode(Y));
      }, W.prototype.getString = function() {
        return this.textDecoder.decode(this.getBytes());
      }, W.prototype.pushSymbolCode = function(Y) {
        if (typeof Y != "string")
          throw new Error("Expected string containing symbol_code");
        var Q = [];
        for (Q.push.apply(Q, n([], i(this.textEncoder.encode(Y)))); Q.length < 8; )
          Q.push(0);
        this.pushArray(Q.slice(0, 8));
      }, W.prototype.getSymbolCode = function() {
        var Y = this.getUint8Array(8), Q;
        for (Q = 0; Q < Y.length && Y[Q]; ++Q)
          ;
        var ee = this.textDecoder.decode(new Uint8Array(Y.buffer, Y.byteOffset, Q));
        return ee;
      }, W.prototype.pushSymbol = function(Y) {
        var Q = Y.name, ee = Y.precision;
        if (!/^[A-Z]{1,7}$/.test(Q))
          throw new Error("Expected symbol to be A-Z and between one and seven characters");
        var ie = [ee & 255];
        for (ie.push.apply(ie, n([], i(this.textEncoder.encode(Q)))); ie.length < 8; )
          ie.push(0);
        this.pushArray(ie.slice(0, 8));
      }, W.prototype.getSymbol = function() {
        var Y = this.get(), Q = this.getUint8Array(7), ee;
        for (ee = 0; ee < Q.length && Q[ee]; ++ee)
          ;
        var ie = this.textDecoder.decode(new Uint8Array(Q.buffer, Q.byteOffset, ee));
        return { name: ie, precision: Y };
      }, W.prototype.pushAsset = function(Y) {
        if (typeof Y != "string")
          throw new Error("Expected string containing asset");
        Y = Y.trim();
        var Q = 0, ee = "", ie = 0;
        Y[Q] === "-" && (ee += "-", ++Q);
        for (var se = !1; Q < Y.length && Y.charCodeAt(Q) >= "0".charCodeAt(0) && Y.charCodeAt(Q) <= "9".charCodeAt(0); )
          se = !0, ee += Y[Q], ++Q;
        if (!se)
          throw new Error("Asset must begin with a number");
        if (Y[Q] === ".")
          for (++Q; Q < Y.length && Y.charCodeAt(Q) >= "0".charCodeAt(0) && Y.charCodeAt(Q) <= "9".charCodeAt(0); )
            ee += Y[Q], ++ie, ++Q;
        var pe = Y.substr(Q).trim();
        this.pushArray(o.signedDecimalToBinary(8, ee)), this.pushSymbol({ name: pe, precision: ie });
      }, W.prototype.getAsset = function() {
        var Y = this.getUint8Array(8), Q = this.getSymbol(), ee = Q.name, ie = Q.precision, se = o.signedBinaryToDecimal(Y, ie + 1);
        return ie && (se = se.substr(0, se.length - ie) + "." + se.substr(se.length - ie)), se + " " + ee;
      }, W.prototype.pushPublicKey = function(Y) {
        var Q = o.stringToPublicKey(Y);
        this.push(Q.type), this.pushArray(Q.data);
      }, W.prototype.getPublicKey = function() {
        var Y = this.get(), Q;
        if (Y === o.KeyType.wa) {
          var ee = this.readPos;
          this.skip(34), this.skip(this.getVaruint32()), Q = new Uint8Array(this.array.buffer, this.array.byteOffset + ee, this.readPos - ee);
        } else
          Q = this.getUint8Array(o.publicKeyDataSize);
        return o.publicKeyToString({ type: Y, data: Q });
      }, W.prototype.pushPrivateKey = function(Y) {
        var Q = o.stringToPrivateKey(Y);
        this.push(Q.type), this.pushArray(Q.data);
      }, W.prototype.getPrivateKey = function() {
        var Y = this.get(), Q = this.getUint8Array(o.privateKeyDataSize);
        return o.privateKeyToString({ type: Y, data: Q });
      }, W.prototype.pushSignature = function(Y) {
        var Q = o.stringToSignature(Y);
        this.push(Q.type), this.pushArray(Q.data);
      }, W.prototype.getSignature = function() {
        var Y = this.get(), Q;
        if (Y === o.KeyType.wa) {
          var ee = this.readPos;
          this.skip(65), this.skip(this.getVaruint32()), this.skip(this.getVaruint32()), Q = new Uint8Array(this.array.buffer, this.array.byteOffset + ee, this.readPos - ee);
        } else
          Q = this.getUint8Array(o.signatureDataSize);
        return o.signatureToString({ type: Y, data: Q });
      }, W;
    }()
  );
  e.SerialBuffer = c;
  var d = function(W) {
    return W.startsWith("eosio::abi/1.");
  };
  e.supportedAbiVersion = d;
  var u = function(W) {
    var Y = Date.parse(W);
    if (Number.isNaN(Y))
      throw new Error("Invalid time format");
    return Y;
  }, m = function(W) {
    return Math.round(u(W + "Z") * 1e3);
  };
  e.dateToTimePoint = m;
  var A = function(W) {
    var Y = new Date(W / 1e3).toISOString();
    return Y.substr(0, Y.length - 1);
  };
  e.timePointToDate = A;
  var y = function(W) {
    return Math.round(u(W + "Z") / 1e3);
  };
  e.dateToTimePointSec = y;
  var D = function(W) {
    var Y = new Date(W * 1e3).toISOString();
    return Y.substr(0, Y.length - 1);
  };
  e.timePointSecToDate = D;
  var C = function(W) {
    return Math.round((u(W + "Z") - 9466848e5) / 500);
  };
  e.dateToBlockTimestamp = C;
  var z = function(W) {
    var Y = new Date(W * 500 + 9466848e5).toISOString();
    return Y.substr(0, Y.length - 1);
  };
  e.blockTimestampToDate = z;
  var R = function(W) {
    if (typeof W != "string")
      throw new Error("Expected string containing symbol");
    var Y = W.match(/^([0-9]+),([A-Z]+)$/);
    if (!Y)
      throw new Error("Invalid symbol");
    return { name: Y[2], precision: +Y[1] };
  };
  e.stringToSymbol = R;
  var O = function(W) {
    var Y = W.name, Q = W.precision;
    return Q + "," + Y;
  };
  e.symbolToString = O;
  var $ = function(W) {
    var Y, Q, ee = "";
    try {
      for (var ie = a(W), se = ie.next(); !se.done; se = ie.next()) {
        var pe = se.value;
        ee += ("00" + pe.toString(16)).slice(-2);
      }
    } catch (he) {
      Y = { error: he };
    } finally {
      try {
        se && !se.done && (Q = ie.return) && Q.call(ie);
      } finally {
        if (Y)
          throw Y.error;
      }
    }
    return ee.toUpperCase();
  };
  e.arrayToHex = $;
  var k = function(W) {
    if (typeof W != "string")
      throw new Error("Expected string containing hex digits");
    if (W.length % 2)
      throw new Error("Odd number of hex digits");
    for (var Y = W.length / 2, Q = new Uint8Array(Y), ee = 0; ee < Y; ++ee) {
      var ie = parseInt(W.substr(ee * 2, 2), 16);
      if (Number.isNaN(ie))
        throw new Error("Expected hex string");
      Q[ee] = ie;
    }
    return Q;
  };
  e.hexToUint8Array = k;
  function P(W, Y) {
    throw new Error("Don't know how to serialize " + this.name);
  }
  function L(W) {
    throw new Error("Don't know how to deserialize " + this.name);
  }
  function F(W, Y, Q, ee) {
    var ie, se;
    if (Q === void 0 && (Q = new l()), ee === void 0 && (ee = !0), typeof Y != "object")
      throw new Error("expected object containing data: " + JSON.stringify(Y));
    this.base && this.base.serialize(W, Y, Q, ee);
    try {
      for (var pe = a(this.fields), he = pe.next(); !he.done; he = pe.next()) {
        var Me = he.value;
        if (Me.name in Y) {
          if (Q.skippedBinaryExtension)
            throw new Error("unexpected " + this.name + "." + Me.name);
          Me.type.serialize(W, Y[Me.name], Q, ee && Me === this.fields[this.fields.length - 1]);
        } else if (ee && Me.type.extensionOf)
          Q.skippedBinaryExtension = !0;
        else
          throw new Error("missing " + this.name + "." + Me.name + " (type=" + Me.type.name + ")");
      }
    } catch (_e) {
      ie = { error: _e };
    } finally {
      try {
        he && !he.done && (se = pe.return) && se.call(pe);
      } finally {
        if (ie)
          throw ie.error;
      }
    }
  }
  function B(W, Y, Q) {
    var ee, ie;
    Y === void 0 && (Y = new l()), Q === void 0 && (Q = !0);
    var se;
    this.base ? se = this.base.deserialize(W, Y, Q) : se = {};
    try {
      for (var pe = a(this.fields), he = pe.next(); !he.done; he = pe.next()) {
        var Me = he.value;
        Q && Me.type.extensionOf && !W.haveReadData() ? Y.skippedBinaryExtension = !0 : se[Me.name] = Me.type.deserialize(W, Y, Q);
      }
    } catch (_e) {
      ee = { error: _e };
    } finally {
      try {
        he && !he.done && (ie = pe.return) && ie.call(pe);
      } finally {
        if (ee)
          throw ee.error;
      }
    }
    return se;
  }
  function G(W, Y, Q, ee) {
    if (!Array.isArray(Y) || Y.length !== 2 || typeof Y[0] != "string")
      throw new Error('expected variant: ["type", value]');
    var ie = this.fields.findIndex(function(se) {
      return se.name === Y[0];
    });
    if (ie < 0)
      throw new Error('type "' + Y[0] + '" is not valid for variant');
    W.pushVaruint32(ie), this.fields[ie].type.serialize(W, Y[1], Q, ee);
  }
  function Z(W, Y, Q) {
    var ee = W.getVaruint32();
    if (ee >= this.fields.length)
      throw new Error("type index " + ee + " is not valid for variant");
    var ie = this.fields[ee];
    return [ie.name, ie.type.deserialize(W, Y, Q)];
  }
  function X(W, Y, Q, ee) {
    var ie, se;
    W.pushVaruint32(Y.length);
    try {
      for (var pe = a(Y), he = pe.next(); !he.done; he = pe.next()) {
        var Me = he.value;
        this.arrayOf.serialize(W, Me, Q, !1);
      }
    } catch (_e) {
      ie = { error: _e };
    } finally {
      try {
        he && !he.done && (se = pe.return) && se.call(pe);
      } finally {
        if (ie)
          throw ie.error;
      }
    }
  }
  function V(W, Y, Q) {
    for (var ee = W.getVaruint32(), ie = [], se = 0; se < ee; ++se)
      ie.push(this.arrayOf.deserialize(W, Y, !1));
    return ie;
  }
  function E(W, Y, Q, ee) {
    Y == null ? W.push(0) : (W.push(1), this.optionalOf.serialize(W, Y, Q, ee));
  }
  function T(W, Y, Q) {
    return W.get() ? this.optionalOf.deserialize(W, Y, Q) : null;
  }
  function g(W, Y, Q, ee) {
    this.extensionOf.serialize(W, Y, Q, ee);
  }
  function b(W, Y, Q) {
    return this.extensionOf.deserialize(W, Y, Q);
  }
  function x(W, Y, Q, ee) {
    var ie, se, pe = Object.entries(Y);
    W.pushVaruint32(pe.length);
    try {
      for (var he = a(pe), Me = he.next(); !Me.done; Me = he.next()) {
        var _e = i(Me.value, 2), xe = _e[0], Ye = _e[1], Ve = this.fields[0].type, Ce = this.fields[1].type;
        Ve.serialize(W, xe, Q, ee), Ce.serialize(W, Ye, Q, ee);
      }
    } catch (Qe) {
      ie = { error: Qe };
    } finally {
      try {
        Me && !Me.done && (se = he.return) && se.call(he);
      } finally {
        if (ie)
          throw ie.error;
      }
    }
  }
  function S(W, Y, Q) {
    for (var ee = W.getVaruint32(), ie = {}, se = 0; se < ee; ++se) {
      var pe = this.fields[0].type, he = this.fields[1].type, Me = pe.deserialize(W, Y, Q);
      ie[Me] = he.deserialize(W, Y, Q);
    }
    return ie;
  }
  function I(W, Y, Q, ee) {
    var ie = this;
    W.pushVaruint32(Y.length), Y.forEach(function(se) {
      ie.fields[0].type.serialize(W, se[0], Q, ee), ie.fields[1].type.serialize(W, se[1], Q, ee);
    });
  }
  function N(W, Y, Q) {
    for (var ee = [], ie = W.getVaruint32(), se = 0; se < ie; ++se)
      ee.push(this.fields[0].type.deserialize(W, Y, Q)), ee.push(this.fields[1].type.deserialize(W, Y, Q));
    return ee;
  }
  var p = function(W) {
    return t({ name: "<missing name>", aliasOfName: "", arrayOf: null, optionalOf: null, extensionOf: null, baseName: "", base: null, fields: [], serialize: P, deserialize: L }, W);
  }, M = function(W, Y) {
    if (Number.isNaN(+W) || Number.isNaN(+Y) || typeof W != "number" && typeof W != "string")
      throw new Error("Expected number");
    if (+W != +Y)
      throw new Error("Number is out of range");
    return +W;
  }, j = function() {
    var W = new Map(Object.entries({ bool: p({ name: "bool", serialize: function(Y, Q) {
      if (!(typeof Q == "boolean" || typeof Q == "number" && (Q === 1 || Q === 0)))
        throw new Error("Expected boolean or number equal to 1 or 0");
      Y.push(Q ? 1 : 0);
    }, deserialize: function(Y) {
      return !!Y.get();
    } }), uint8: p({ name: "uint8", serialize: function(Y, Q) {
      Y.push(M(Q, Q & 255));
    }, deserialize: function(Y) {
      return Y.get();
    } }), int8: p({ name: "int8", serialize: function(Y, Q) {
      Y.push(M(Q, Q << 24 >> 24));
    }, deserialize: function(Y) {
      return Y.get() << 24 >> 24;
    } }), uint16: p({ name: "uint16", serialize: function(Y, Q) {
      Y.pushUint16(M(Q, Q & 65535));
    }, deserialize: function(Y) {
      return Y.getUint16();
    } }), int16: p({ name: "int16", serialize: function(Y, Q) {
      Y.pushUint16(M(Q, Q << 16 >> 16));
    }, deserialize: function(Y) {
      return Y.getUint16() << 16 >> 16;
    } }), uint32: p({ name: "uint32", serialize: function(Y, Q) {
      Y.pushUint32(M(Q, Q >>> 0));
    }, deserialize: function(Y) {
      return Y.getUint32();
    } }), uint64: p({ name: "uint64", serialize: function(Y, Q) {
      Y.pushArray(o.decimalToBinary(8, "" + Q));
    }, deserialize: function(Y) {
      return o.binaryToDecimal(Y.getUint8Array(8));
    } }), int64: p({ name: "int64", serialize: function(Y, Q) {
      Y.pushArray(o.signedDecimalToBinary(8, "" + Q));
    }, deserialize: function(Y) {
      return o.signedBinaryToDecimal(Y.getUint8Array(8));
    } }), int32: p({ name: "int32", serialize: function(Y, Q) {
      Y.pushUint32(M(Q, Q | 0));
    }, deserialize: function(Y) {
      return Y.getUint32() | 0;
    } }), varuint32: p({ name: "varuint32", serialize: function(Y, Q) {
      Y.pushVaruint32(M(Q, Q >>> 0));
    }, deserialize: function(Y) {
      return Y.getVaruint32();
    } }), varint32: p({ name: "varint32", serialize: function(Y, Q) {
      Y.pushVarint32(M(Q, Q | 0));
    }, deserialize: function(Y) {
      return Y.getVarint32();
    } }), uint128: p({ name: "uint128", serialize: function(Y, Q) {
      Y.pushArray(o.decimalToBinary(16, "" + Q));
    }, deserialize: function(Y) {
      return o.binaryToDecimal(Y.getUint8Array(16));
    } }), int128: p({ name: "int128", serialize: function(Y, Q) {
      Y.pushArray(o.signedDecimalToBinary(16, "" + Q));
    }, deserialize: function(Y) {
      return o.signedBinaryToDecimal(Y.getUint8Array(16));
    } }), float32: p({ name: "float32", serialize: function(Y, Q) {
      Y.pushFloat32(Q);
    }, deserialize: function(Y) {
      return Y.getFloat32();
    } }), float64: p({ name: "float64", serialize: function(Y, Q) {
      Y.pushFloat64(Q);
    }, deserialize: function(Y) {
      return Y.getFloat64();
    } }), float128: p({ name: "float128", serialize: function(Y, Q) {
      Y.pushUint8ArrayChecked(e.hexToUint8Array(Q), 16);
    }, deserialize: function(Y) {
      return e.arrayToHex(Y.getUint8Array(16));
    } }), bytes: p({ name: "bytes", serialize: function(Y, Q) {
      Q instanceof Uint8Array || Array.isArray(Q) ? Y.pushBytes(Q) : Y.pushBytes(e.hexToUint8Array(Q));
    }, deserialize: function(Y, Q) {
      return Q && Q.options.bytesAsUint8Array ? Y.getBytes() : e.arrayToHex(Y.getBytes());
    } }), string: p({ name: "string", serialize: function(Y, Q) {
      Y.pushString(Q);
    }, deserialize: function(Y) {
      return Y.getString();
    } }), name: p({ name: "name", serialize: function(Y, Q) {
      Y.pushName(Q);
    }, deserialize: function(Y) {
      return Y.getName();
    } }), time_point: p({ name: "time_point", serialize: function(Y, Q) {
      Y.pushNumberAsUint64(e.dateToTimePoint(Q));
    }, deserialize: function(Y) {
      return e.timePointToDate(Y.getUint64AsNumber());
    } }), time_point_sec: p({ name: "time_point_sec", serialize: function(Y, Q) {
      Y.pushUint32(e.dateToTimePointSec(Q));
    }, deserialize: function(Y) {
      return e.timePointSecToDate(Y.getUint32());
    } }), block_timestamp_type: p({ name: "block_timestamp_type", serialize: function(Y, Q) {
      Y.pushUint32(e.dateToBlockTimestamp(Q));
    }, deserialize: function(Y) {
      return e.blockTimestampToDate(Y.getUint32());
    } }), symbol_code: p({ name: "symbol_code", serialize: function(Y, Q) {
      Y.pushSymbolCode(Q);
    }, deserialize: function(Y) {
      return Y.getSymbolCode();
    } }), symbol: p({ name: "symbol", serialize: function(Y, Q) {
      Y.pushSymbol(e.stringToSymbol(Q));
    }, deserialize: function(Y) {
      return e.symbolToString(Y.getSymbol());
    } }), asset: p({ name: "asset", serialize: function(Y, Q) {
      Y.pushAsset(Q);
    }, deserialize: function(Y) {
      return Y.getAsset();
    } }), checksum160: p({ name: "checksum160", serialize: function(Y, Q) {
      Y.pushUint8ArrayChecked(e.hexToUint8Array(Q), 20);
    }, deserialize: function(Y) {
      return e.arrayToHex(Y.getUint8Array(20));
    } }), checksum256: p({ name: "checksum256", serialize: function(Y, Q) {
      Y.pushUint8ArrayChecked(e.hexToUint8Array(Q), 32);
    }, deserialize: function(Y) {
      return e.arrayToHex(Y.getUint8Array(32));
    } }), checksum512: p({ name: "checksum512", serialize: function(Y, Q) {
      Y.pushUint8ArrayChecked(e.hexToUint8Array(Q), 64);
    }, deserialize: function(Y) {
      return e.arrayToHex(Y.getUint8Array(64));
    } }), public_key: p({ name: "public_key", serialize: function(Y, Q) {
      Y.pushPublicKey(Q);
    }, deserialize: function(Y) {
      return Y.getPublicKey();
    } }), private_key: p({ name: "private_key", serialize: function(Y, Q) {
      Y.pushPrivateKey(Q);
    }, deserialize: function(Y) {
      return Y.getPrivateKey();
    } }), signature: p({ name: "signature", serialize: function(Y, Q) {
      Y.pushSignature(Q);
    }, deserialize: function(Y) {
      return Y.getSignature();
    } }) }));
    return W.set("extended_asset", p({ name: "extended_asset", baseName: "", fields: [{ name: "quantity", typeName: "asset", type: W.get("asset") }, { name: "contract", typeName: "name", type: W.get("name") }], serialize: F, deserialize: B })), W;
  };
  e.createInitialTypes = j;
  var U = function() {
    var W = e.createInitialTypes();
    return W.set("extensions_entry", p({ name: "extensions_entry", baseName: "", fields: [{ name: "tag", typeName: "uint16", type: null }, { name: "value", typeName: "bytes", type: null }], serialize: F, deserialize: B })), W.set("type_def", p({ name: "type_def", baseName: "", fields: [{ name: "new_type_name", typeName: "string", type: null }, { name: "type", typeName: "string", type: null }], serialize: F, deserialize: B })), W.set("field_def", p({ name: "field_def", baseName: "", fields: [{ name: "name", typeName: "string", type: null }, { name: "type", typeName: "string", type: null }], serialize: F, deserialize: B })), W.set("struct_def", p({ name: "struct_def", baseName: "", fields: [{ name: "name", typeName: "string", type: null }, { name: "base", typeName: "string", type: null }, { name: "fields", typeName: "field_def[]", type: null }], serialize: F, deserialize: B })), W.set("action_def", p({ name: "action_def", baseName: "", fields: [{ name: "name", typeName: "name", type: null }, { name: "type", typeName: "string", type: null }, { name: "ricardian_contract", typeName: "string", type: null }], serialize: F, deserialize: B })), W.set("table_def", p({ name: "table_def", baseName: "", fields: [{ name: "name", typeName: "name", type: null }, { name: "index_type", typeName: "string", type: null }, { name: "key_names", typeName: "string[]", type: null }, { name: "key_types", typeName: "string[]", type: null }, { name: "type", typeName: "string", type: null }], serialize: F, deserialize: B })), W.set("clause_pair", p({ name: "clause_pair", baseName: "", fields: [{ name: "id", typeName: "string", type: null }, { name: "body", typeName: "string", type: null }], serialize: F, deserialize: B })), W.set("error_message", p({ name: "error_message", baseName: "", fields: [{ name: "error_code", typeName: "uint64", type: null }, { name: "error_msg", typeName: "string", type: null }], serialize: F, deserialize: B })), W.set("variant_def", p({ name: "variant_def", baseName: "", fields: [{ name: "name", typeName: "string", type: null }, { name: "types", typeName: "string[]", type: null }], serialize: F, deserialize: B })), W.set("action_result", p({ name: "action_result", baseName: "", fields: [{ name: "name", typeName: "name", type: null }, { name: "result_type", typeName: "string", type: null }], serialize: F, deserialize: B })), W.set("primary_key_index_def", p({ name: "primary_key_index_def", baseName: "", fields: [{ name: "name", typeName: "name", type: null }, { name: "type", typeName: "string", type: null }], serialize: F, deserialize: B })), W.set("secondary_index_def", p({ name: "secondary_index_def", baseName: "", fields: [{ name: "type", typeName: "string", type: null }], serialize: F, deserialize: B })), W.set("secondary_indices", p({ name: "secondary_indices", baseName: "", fields: [{ name: "name", typeName: "name", type: null }, { name: "secondary_index_def", typeName: "secondary_index_def", type: null }], serialize: x, deserialize: S })), W.set("kv_table_entry_def", p({ name: "kv_table_entry_def", baseName: "", fields: [{ name: "type", typeName: "string", type: null }, { name: "primary_index", typeName: "primary_key_index_def", type: null }, { name: "secondary_indices", typeName: "secondary_indices", type: null }], serialize: F, deserialize: B })), W.set("kv_table", p({ name: "kv_table", baseName: "", fields: [{ name: "name", typeName: "name", type: null }, { name: "kv_table_entry_def", typeName: "kv_table_entry_def", type: null }], serialize: x, deserialize: S })), W.set("abi_def", p({ name: "abi_def", baseName: "", fields: [{ name: "version", typeName: "string", type: null }, { name: "types", typeName: "type_def[]", type: null }, { name: "structs", typeName: "struct_def[]", type: null }, { name: "actions", typeName: "action_def[]", type: null }, { name: "tables", typeName: "table_def[]", type: null }, { name: "ricardian_clauses", typeName: "clause_pair[]", type: null }, { name: "error_messages", typeName: "error_message[]", type: null }, { name: "abi_extensions", typeName: "extensions_entry[]", type: null }, { name: "variants", typeName: "variant_def[]$", type: null }, { name: "action_results", typeName: "action_result[]$", type: null }, { name: "kv_tables", typeName: "kv_table$", type: null }], serialize: F, deserialize: B })), W;
  };
  e.createAbiTypes = U;
  var H = function() {
    var W = e.createInitialTypes();
    return W.set("resource_payer", p({ name: "resource_payer", baseName: "", fields: [{ name: "payer", typeName: "name", type: null }, { name: "max_net_bytes", typeName: "uint64", type: null }, { name: "max_cpu_us", typeName: "uint64", type: null }, { name: "max_memory_bytes", typeName: "uint64", type: null }], serialize: F, deserialize: B })), W;
  };
  e.createTransactionExtensionTypes = H;
  var J = function() {
    var W = e.createInitialTypes();
    return W.set("permission_level", p({ name: "permission_level", baseName: "", fields: [{ name: "actor", typeName: "name", type: null }, { name: "permission", typeName: "name", type: null }], serialize: F, deserialize: B })), W.set("action", p({ name: "action", baseName: "", fields: [{ name: "account", typeName: "name", type: null }, { name: "name", typeName: "name", type: null }, { name: "authorization", typeName: "permission_level[]", type: null }, { name: "data", typeName: "bytes", type: null }], serialize: F, deserialize: B })), W.set("extension", p({ name: "extension", baseName: "", fields: [{ name: "type", typeName: "uint16", type: null }, { name: "data", typeName: "bytes", type: null }], serialize: I, deserialize: N })), W.set("transaction_header", p({ name: "transaction_header", baseName: "", fields: [{ name: "expiration", typeName: "time_point_sec", type: null }, { name: "ref_block_num", typeName: "uint16", type: null }, { name: "ref_block_prefix", typeName: "uint32", type: null }, { name: "max_net_usage_words", typeName: "varuint32", type: null }, { name: "max_cpu_usage_ms", typeName: "uint8", type: null }, { name: "delay_sec", typeName: "varuint32", type: null }], serialize: F, deserialize: B })), W.set("transaction", p({ name: "transaction", baseName: "transaction_header", fields: [{ name: "context_free_actions", typeName: "action[]", type: null }, { name: "actions", typeName: "action[]", type: null }, { name: "transaction_extensions", typeName: "extension", type: null }], serialize: F, deserialize: B })), W;
  };
  e.createTransactionTypes = J;
  var te = function(W, Y) {
    var Q = W.get(Y);
    if (Q && Q.aliasOfName)
      return e.getType(W, Q.aliasOfName);
    if (Q)
      return Q;
    if (Y.endsWith("[]"))
      return p({ name: Y, arrayOf: e.getType(W, Y.substr(0, Y.length - 2)), serialize: X, deserialize: V });
    if (Y.endsWith("?"))
      return p({ name: Y, optionalOf: e.getType(W, Y.substr(0, Y.length - 1)), serialize: E, deserialize: T });
    if (Y.endsWith("$"))
      return p({ name: Y, extensionOf: e.getType(W, Y.substr(0, Y.length - 1)), serialize: g, deserialize: b });
    throw new Error("Unknown type: " + Y);
  };
  e.getType = te;
  var ae = function(W, Y) {
    var Q, ee, ie, se, pe, he, Me, _e, xe, Ye, Ve = new Map(W);
    if (Y && Y.types)
      try {
        for (var Ce = a(Y.types), Qe = Ce.next(); !Qe.done; Qe = Ce.next()) {
          var qe = Qe.value, Pe = qe.new_type_name, He = qe.type;
          Ve.set(Pe, p({ name: Pe, aliasOfName: He }));
        }
      } catch (ze) {
        Q = { error: ze };
      } finally {
        try {
          Qe && !Qe.done && (ee = Ce.return) && ee.call(Ce);
        } finally {
          if (Q)
            throw Q.error;
        }
      }
    if (Y && Y.structs)
      try {
        for (var Ze = a(Y.structs), je = Ze.next(); !je.done; je = Ze.next()) {
          var We = je.value, Je = We.name, $e = We.base, Xe = We.fields;
          Ve.set(Je, p({ name: Je, baseName: $e, fields: Xe.map(function(ze) {
            var Ge = ze.name, tt = ze.type;
            return { name: Ge, typeName: tt, type: null };
          }), serialize: F, deserialize: B }));
        }
      } catch (ze) {
        ie = { error: ze };
      } finally {
        try {
          je && !je.done && (se = Ze.return) && se.call(Ze);
        } finally {
          if (ie)
            throw ie.error;
        }
      }
    if (Y && Y.variants)
      try {
        for (var Ke = a(Y.variants), q = Ke.next(); !q.done; q = Ke.next()) {
          var ce = q.value, de = ce.name, me = ce.types;
          Ve.set(de, p({ name: de, fields: me.map(function(ze) {
            return { name: ze, typeName: ze, type: null };
          }), serialize: G, deserialize: Z }));
        }
      } catch (ze) {
        pe = { error: ze };
      } finally {
        try {
          q && !q.done && (he = Ke.return) && he.call(Ke);
        } finally {
          if (pe)
            throw pe.error;
        }
      }
    try {
      for (var De = a(Ve), Ie = De.next(); !Ie.done; Ie = De.next()) {
        var ye = i(Ie.value, 2), Ae = ye[0], He = ye[1];
        He.baseName && (He.base = e.getType(Ve, He.baseName));
        try {
          for (var Fe = (xe = void 0, a(He.fields)), be = Fe.next(); !be.done; be = Fe.next()) {
            var ke = be.value;
            ke.type = e.getType(Ve, ke.typeName);
          }
        } catch (Ge) {
          xe = { error: Ge };
        } finally {
          try {
            be && !be.done && (Ye = Fe.return) && Ye.call(Fe);
          } finally {
            if (xe)
              throw xe.error;
          }
        }
      }
    } catch (ze) {
      Me = { error: ze };
    } finally {
      try {
        Ie && !Ie.done && (_e = De.return) && _e.call(De);
      } finally {
        if (Me)
          throw Me.error;
      }
    }
    return Ve;
  };
  e.getTypesFromAbi = ae;
  var le = function(W) {
    return W.substr(6, 2) + W.substr(4, 2) + W.substr(2, 2) + W.substr(0, 2);
  }, ne = function(W, Y) {
    var Q = W.header ? W.header.timestamp : W.timestamp, ee = parseInt(le(W.id.substr(16, 8)), 16);
    return { expiration: e.timePointSecToDate(e.dateToTimePointSec(Q) + Y), ref_block_num: W.block_num & 65535, ref_block_prefix: ee };
  };
  e.transactionHeader = ne;
  var ue = function(W, Y, Q, ee, ie, se) {
    var pe = W.actions.get(Q);
    if (!pe)
      throw new Error("Unknown action " + Q + " in contract " + Y);
    var he = new c({ textEncoder: ie, textDecoder: se });
    return pe.serialize(he, ee), e.arrayToHex(he.asUint8Array());
  };
  e.serializeActionData = ue;
  var ge = function(W, Y, Q, ee, ie, se, pe) {
    return { account: Y, name: Q, authorization: ee, data: e.serializeActionData(W, Y, Q, ie, se, pe) };
  };
  e.serializeAction = ge;
  var re = function(W, Y, Q, ee, ie, se) {
    var pe = W.actions.get(Q);
    if (typeof ee == "string" && (ee = e.hexToUint8Array(ee)), !pe)
      throw new Error("Unknown action " + Q + " in contract " + Y);
    var he = new c({ textDecoder: se, textEncoder: ie });
    return he.pushArray(ee), pe.deserialize(he);
  };
  e.deserializeActionData = re;
  var fe = function(W, Y, Q, ee, ie, se, pe) {
    return { account: Y, name: Q, authorization: ee, data: e.deserializeActionData(W, Y, Q, ie, se, pe) };
  };
  e.deserializeAction = fe;
  var oe = function(W, Y) {
    var Q, ee, ie, se, pe, he, Me, _e, xe;
    Y === null ? (Q = i([Ee.null_t, Y], 2), _e = Q[0], xe = Q[1]) : typeof Y == "string" ? (ee = i([Ee.string, Y], 2), _e = ee[0], xe = ee[1]) : typeof Y == "number" ? (ie = i([Ee.int32, Y], 2), _e = ie[0], xe = ie[1]) : Y instanceof Uint8Array ? (se = i([Ee.bytes, Y], 2), _e = se[0], xe = se[1]) : Array.isArray(Y) ? (pe = i([Ee.any_array, Y], 2), _e = pe[0], xe = pe[1]) : Object.keys(Y).length === 2 && Y.hasOwnProperty("type") && Y.hasOwnProperty("value") ? (he = i([Ee[Y.type], Y.value], 2), _e = he[0], xe = he[1]) : (Me = i([Ee.any_object, Y], 2), _e = Me[0], xe = Me[1]), W.pushVaruint32(_e.index), _e.type.serialize(W, xe);
  };
  e.serializeAnyvar = oe;
  var ve = function(W, Y) {
    var Q = W.getVaruint32();
    if (Q >= Se.length)
      throw new Error("Tried to deserialize unknown anyvar type");
    var ee = Se[Q], ie = ee.type.deserialize(W, Y);
    return Y && Y.options.useShortForm || ee.useShortForm ? ie : { type: ee.type.name, value: ie };
  };
  e.deserializeAnyvar = ve;
  var Le = function(W) {
    return e.deserializeAnyvar(W, new l({ useShortForm: !0 }));
  };
  e.deserializeAnyvarShort = Le;
  var Be = function(W, Y) {
    var Q, ee, ie = Object.entries(Y);
    W.pushVaruint32(ie.length);
    try {
      for (var se = a(ie), pe = se.next(); !pe.done; pe = se.next()) {
        var he = i(pe.value, 2), Me = he[0], _e = he[1];
        W.pushString(Me), e.serializeAnyvar(W, _e);
      }
    } catch (xe) {
      Q = { error: xe };
    } finally {
      try {
        pe && !pe.done && (ee = se.return) && ee.call(se);
      } finally {
        if (Q)
          throw Q.error;
      }
    }
  };
  e.serializeAnyObject = Be;
  var we = function(W, Y) {
    for (var Q = W.getVaruint32(), ee = {}, ie = 0; ie < Q; ++ie) {
      var se = W.getString();
      if (se in ee) {
        for (var pe = 1; se + "_" + pe in ee; )
          ++pe;
        se = se + "_" + pe;
      }
      ee[se] = e.deserializeAnyvar(W, Y);
    }
    return ee;
  };
  e.deserializeAnyObject = we;
  var Ue = function(W, Y) {
    var Q, ee;
    W.pushVaruint32(Y.length);
    try {
      for (var ie = a(Y), se = ie.next(); !se.done; se = ie.next()) {
        var pe = se.value;
        e.serializeAnyvar(W, pe);
      }
    } catch (he) {
      Q = { error: he };
    } finally {
      try {
        se && !se.done && (ee = ie.return) && ee.call(ie);
      } finally {
        if (Q)
          throw Q.error;
      }
    }
  };
  e.serializeAnyArray = Ue;
  var Oe = function(W, Y) {
    for (var Q = W.getVaruint32(), ee = [], ie = 0; ie < Q; ++ie)
      ee.push(e.deserializeAnyvar(W, Y));
    return ee;
  };
  e.deserializeAnyArray = Oe;
  var Te = function() {
    var W = e.createInitialTypes();
    return W.set("null_t", p({ name: "null_t", serialize: function(Y, Q) {
    }, deserialize: function(Y, Q) {
    } })), W.set("any_object", p({ name: "any_object", serialize: e.serializeAnyObject, deserialize: e.deserializeAnyObject })), W.set("any_array", p({ name: "any_array", serialize: e.serializeAnyArray, deserialize: e.deserializeAnyArray })), W;
  }, Ne = Te(), Ee = { null_t: { index: 0, useShortForm: !0, type: Ne.get("null_t") }, int64: { index: 1, useShortForm: !1, type: Ne.get("int64") }, uint64: { index: 2, useShortForm: !1, type: Ne.get("uint64") }, int32: { index: 3, useShortForm: !0, type: Ne.get("int32") }, uint32: { index: 4, useShortForm: !1, type: Ne.get("uint32") }, int16: { index: 5, useShortForm: !1, type: Ne.get("int16") }, uint16: { index: 6, useShortForm: !1, type: Ne.get("uint16") }, int8: { index: 7, useShortForm: !1, type: Ne.get("int8") }, uint8: { index: 8, useShortForm: !1, type: Ne.get("uint8") }, time_point: { index: 9, useShortForm: !1, type: Ne.get("time_point") }, checksum256: { index: 10, useShortForm: !1, type: Ne.get("checksum256") }, float64: { index: 11, useShortForm: !1, type: Ne.get("float64") }, string: { index: 12, useShortForm: !0, type: Ne.get("string") }, any_object: { index: 13, useShortForm: !0, type: Ne.get("any_object") }, any_array: { index: 14, useShortForm: !0, type: Ne.get("any_array") }, bytes: { index: 15, useShortForm: !1, type: Ne.get("bytes") }, symbol: { index: 16, useShortForm: !1, type: Ne.get("symbol") }, symbol_code: { index: 17, useShortForm: !1, type: Ne.get("symbol_code") }, asset: { index: 18, useShortForm: !1, type: Ne.get("asset") } }, Se = [Ee.null_t, Ee.int64, Ee.uint64, Ee.int32, Ee.uint32, Ee.int16, Ee.uint16, Ee.int8, Ee.uint8, Ee.time_point, Ee.checksum256, Ee.float64, Ee.string, Ee.any_object, Ee.any_array, Ee.bytes, Ee.symbol, Ee.symbol_code, Ee.asset], Re = function(W, Y) {
    var Q, ee, ie, se, pe, he, Me, _e;
    if (typeof Y == "string" ? he = Y : Array.isArray(Y) && Y.length === 2 ? (Q = i(Y, 2), he = Q[0], _e = Q[1]) : Array.isArray(Y) && Y.length === 3 ? (ee = i(Y, 3), he = ee[0], Me = ee[1], _e = ee[2]) : (ie = i([Y.method, Y.arg, Y.filter], 3), he = ie[0], Me = ie[1], _e = ie[2]), W.pushString(he), Me === void 0 ? W.push(0) : (W.push(1), e.serializeAnyvar(W, Me)), _e === void 0)
      W.push(0);
    else {
      W.pushVaruint32(_e.length);
      try {
        for (var xe = a(_e), Ye = xe.next(); !Ye.done; Ye = xe.next()) {
          var Ve = Ye.value;
          e.serializeQuery(W, Ve);
        }
      } catch (Ce) {
        se = { error: Ce };
      } finally {
        try {
          Ye && !Ye.done && (pe = xe.return) && pe.call(xe);
        } finally {
          if (se)
            throw se.error;
        }
      }
    }
  };
  e.serializeQuery = Re;
})(eosjsSerialize);
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign = Object.assign || function(e) {
    for (var t, i = 1, n = arguments.length; i < n; i++) {
      t = arguments[i];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, __assign.apply(this, arguments);
}, __awaiter$4 = commonjsGlobal && commonjsGlobal.__awaiter || function(e, t, i, n) {
  function a(o) {
    return o instanceof i ? o : new i(function(l) {
      l(o);
    });
  }
  return new (i || (i = Promise))(function(o, l) {
    function c(m) {
      try {
        u(n.next(m));
      } catch (A) {
        l(A);
      }
    }
    function d(m) {
      try {
        u(n.throw(m));
      } catch (A) {
        l(A);
      }
    }
    function u(m) {
      m.done ? o(m.value) : a(m.value).then(c, d);
    }
    u((n = n.apply(e, t || [])).next());
  });
}, __generator$1 = commonjsGlobal && commonjsGlobal.__generator || function(e, t) {
  var i = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, a, o, l;
  return l = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function c(u) {
    return function(m) {
      return d([u, m]);
    };
  }
  function d(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; i; )
      try {
        if (n = 1, a && (o = u[0] & 2 ? a.return : u[0] ? a.throw || ((o = a.return) && o.call(a), 0) : a.next) && !(o = o.call(a, u[1])).done)
          return o;
        switch (a = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
          case 0:
          case 1:
            o = u;
            break;
          case 4:
            return i.label++, { value: u[1], done: !1 };
          case 5:
            i.label++, a = u[1], u = [0];
            continue;
          case 7:
            u = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (o = i.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              i = 0;
              continue;
            }
            if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
              i.label = u[1];
              break;
            }
            if (u[0] === 6 && i.label < o[1]) {
              i.label = o[1], o = u;
              break;
            }
            if (o && i.label < o[2]) {
              i.label = o[2], i.ops.push(u);
              break;
            }
            o[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        u = t.call(e, i);
      } catch (m) {
        u = [6, m], a = 0;
      } finally {
        n = o = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, __read = commonjsGlobal && commonjsGlobal.__read || function(e, t) {
  var i = typeof Symbol == "function" && e[Symbol.iterator];
  if (!i)
    return e;
  var n = i.call(e), a, o = [], l;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; )
      o.push(a.value);
  } catch (c) {
    l = { error: c };
  } finally {
    try {
      a && !a.done && (i = n.return) && i.call(n);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return o;
}, __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function(e, t) {
  for (var i = 0, n = t.length, a = e.length; i < n; i++, a++)
    e[a] = t[i];
  return e;
}, __values$1 = commonjsGlobal && commonjsGlobal.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, i = t && e[t], n = 0;
  if (i)
    return i.call(e);
  if (e && typeof e.length == "number")
    return { next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(eosjsApi, "__esModule", { value: !0 });
eosjsApi.ActionBuilder = eosjsApi.TransactionBuilder = eosjsApi.Api = void 0;
var pako_1 = pako, ser = eosjsSerialize, Api = (
  /** @class */
  function() {
    function e(t) {
      this.contracts = /* @__PURE__ */ new Map(), this.cachedAbis = /* @__PURE__ */ new Map(), this.transactionExtensions = [{ id: 1, type: "resource_payer", keys: ["payer", "max_net_bytes", "max_cpu_us", "max_memory_bytes"] }], this.rpc = t.rpc, this.authorityProvider = t.authorityProvider || t.rpc, this.abiProvider = t.abiProvider || t.rpc, this.signatureProvider = t.signatureProvider, this.chainId = t.chainId, this.textEncoder = t.textEncoder, this.textDecoder = t.textDecoder, this.abiTypes = ser.getTypesFromAbi(ser.createAbiTypes()), this.transactionTypes = ser.getTypesFromAbi(ser.createTransactionTypes());
    }
    return e.prototype.rawAbiToJson = function(t) {
      var i = new ser.SerialBuffer({ textEncoder: this.textEncoder, textDecoder: this.textDecoder, array: t });
      if (!ser.supportedAbiVersion(i.getString()))
        throw new Error("Unsupported abi version");
      return i.restartRead(), this.abiTypes.get("abi_def").deserialize(i);
    }, e.prototype.jsonToRawAbi = function(t) {
      var i = new ser.SerialBuffer({ textEncoder: this.textEncoder, textDecoder: this.textDecoder });
      if (this.abiTypes.get("abi_def").serialize(i, t), !ser.supportedAbiVersion(i.getString()))
        throw new Error("Unsupported abi version");
      return i.asUint8Array();
    }, e.prototype.getCachedAbi = function(t, i) {
      return i === void 0 && (i = !1), __awaiter$4(this, void 0, void 0, function() {
        var n, a, o, l;
        return __generator$1(this, function(c) {
          switch (c.label) {
            case 0:
              if (!i && this.cachedAbis.get(t))
                return [2, this.cachedAbis.get(t)];
              c.label = 1;
            case 1:
              return c.trys.push([1, 3, , 4]), [4, this.abiProvider.getRawAbi(t)];
            case 2:
              return a = c.sent().abi, o = this.rawAbiToJson(a), n = { rawAbi: a, abi: o }, [3, 4];
            case 3:
              throw l = c.sent(), l.message = "fetching abi for " + t + ": " + l.message, l;
            case 4:
              if (!n)
                throw new Error("Missing abi for " + t);
              return this.cachedAbis.set(t, n), [2, n];
          }
        });
      });
    }, e.prototype.getAbi = function(t, i) {
      return i === void 0 && (i = !1), __awaiter$4(this, void 0, void 0, function() {
        return __generator$1(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.getCachedAbi(t, i)];
            case 1:
              return [2, n.sent().abi];
          }
        });
      });
    }, e.prototype.getTransactionAbis = function(t, i) {
      return i === void 0 && (i = !1), __awaiter$4(this, void 0, void 0, function() {
        var n, a, o, l, c = this;
        return __generator$1(this, function(d) {
          return n = (t.context_free_actions || []).concat(t.actions), a = n.map(function(u) {
            return u.account;
          }), o = new Set(a), l = __spreadArray([], __read(o)).map(function(u) {
            return __awaiter$4(c, void 0, void 0, function() {
              var m;
              return __generator$1(this, function(A) {
                switch (A.label) {
                  case 0:
                    return m = { accountName: u }, [4, this.getCachedAbi(u, i)];
                  case 1:
                    return [2, (m.abi = A.sent().rawAbi, m)];
                }
              });
            });
          }), [2, Promise.all(l)];
        });
      });
    }, e.prototype.getContract = function(t, i) {
      return i === void 0 && (i = !1), __awaiter$4(this, void 0, void 0, function() {
        var n, a, o, l, c, d, u, m, A, y, D;
        return __generator$1(this, function(C) {
          switch (C.label) {
            case 0:
              return !i && this.contracts.get(t) ? [2, this.contracts.get(t)] : [4, this.getAbi(t, i)];
            case 1:
              n = C.sent(), a = ser.getTypesFromAbi(ser.createInitialTypes(), n), o = /* @__PURE__ */ new Map();
              try {
                for (l = __values$1(n.actions), c = l.next(); !c.done; c = l.next())
                  d = c.value, u = d.name, m = d.type, o.set(u, ser.getType(a, m));
              } catch (z) {
                y = { error: z };
              } finally {
                try {
                  c && !c.done && (D = l.return) && D.call(l);
                } finally {
                  if (y)
                    throw y.error;
                }
              }
              return A = { types: a, actions: o }, this.contracts.set(t, A), [2, A];
          }
        });
      });
    }, e.prototype.serialize = function(t, i, n) {
      this.transactionTypes.get(i).serialize(t, n);
    }, e.prototype.deserialize = function(t, i) {
      return this.transactionTypes.get(i).deserialize(t);
    }, e.prototype.serializeTransaction = function(t) {
      var i = new ser.SerialBuffer({ textEncoder: this.textEncoder, textDecoder: this.textDecoder });
      return this.serialize(i, "transaction", __assign({ max_net_usage_words: 0, max_cpu_usage_ms: 0, delay_sec: 0, context_free_actions: [], actions: [], transaction_extensions: [] }, t)), i.asUint8Array();
    }, e.prototype.serializeContextFreeData = function(t) {
      var i, n;
      if (!t || !t.length)
        return null;
      var a = new ser.SerialBuffer({ textEncoder: this.textEncoder, textDecoder: this.textDecoder });
      a.pushVaruint32(t.length);
      try {
        for (var o = __values$1(t), l = o.next(); !l.done; l = o.next()) {
          var c = l.value;
          a.pushBytes(c);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          l && !l.done && (n = o.return) && n.call(o);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return a.asUint8Array();
    }, e.prototype.deserializeTransaction = function(t) {
      var i = new ser.SerialBuffer({ textEncoder: this.textEncoder, textDecoder: this.textDecoder });
      return i.pushArray(t), this.deserialize(i, "transaction");
    }, e.prototype.serializeTransactionExtensions = function(t) {
      var i = [];
      if (t.resource_payer) {
        var n = new ser.SerialBuffer({ textEncoder: this.textEncoder, textDecoder: this.textDecoder }), a = ser.getTypesFromAbi(ser.createTransactionExtensionTypes());
        a.get("resource_payer").serialize(n, t.resource_payer), i = __spreadArray(__spreadArray([], __read(i)), [[1, ser.arrayToHex(n.asUint8Array())]]);
      }
      return i;
    }, e.prototype.deserializeTransactionExtensions = function(t) {
      var i = this, n = {};
      return t.forEach(function(a) {
        var o = i.transactionExtensions.find(function(u) {
          return u.id === a[0];
        });
        if (o === void 0)
          throw new Error("Transaction Extension could not be determined: " + a);
        var l = ser.getTypesFromAbi(ser.createTransactionExtensionTypes()), c = new ser.SerialBuffer({ textEncoder: i.textEncoder, textDecoder: i.textDecoder });
        c.pushArray(ser.hexToUint8Array(a[1]));
        var d = l.get(o.type).deserialize(c);
        a[0] === 1 && (d.max_net_bytes = Number(d.max_net_bytes), d.max_cpu_us = Number(d.max_cpu_us), d.max_memory_bytes = Number(d.max_memory_bytes), n.resource_payer = d);
      }), n;
    }, e.prototype.deleteTransactionExtensionObjects = function(t) {
      return delete t.resource_payer, t;
    }, e.prototype.serializeActions = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var i = this;
        return __generator$1(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, Promise.all(t.map(function(a) {
                return __awaiter$4(i, void 0, void 0, function() {
                  var o, l, c, d, u;
                  return __generator$1(this, function(m) {
                    switch (m.label) {
                      case 0:
                        return o = a.account, l = a.name, c = a.authorization, d = a.data, [4, this.getContract(o)];
                      case 1:
                        return u = m.sent(), typeof d != "object" ? [2, a] : [2, ser.serializeAction(u, o, l, c, d, this.textEncoder, this.textDecoder)];
                    }
                  });
                });
              }))];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, e.prototype.deserializeActions = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var i = this;
        return __generator$1(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, Promise.all(t.map(function(a) {
                var o = a.account, l = a.name, c = a.authorization, d = a.data;
                return __awaiter$4(i, void 0, void 0, function() {
                  var u;
                  return __generator$1(this, function(m) {
                    switch (m.label) {
                      case 0:
                        return [4, this.getContract(o)];
                      case 1:
                        return u = m.sent(), [2, ser.deserializeAction(u, o, l, c, d, this.textEncoder, this.textDecoder)];
                    }
                  });
                });
              }))];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, e.prototype.deserializeTransactionWithActions = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var i, n, a;
        return __generator$1(this, function(o) {
          switch (o.label) {
            case 0:
              return typeof t == "string" && (t = ser.hexToUint8Array(t)), i = this.deserializeTransaction(t), [4, this.deserializeActions(i.context_free_actions)];
            case 1:
              return n = o.sent(), [4, this.deserializeActions(i.actions)];
            case 2:
              return a = o.sent(), [2, __assign(__assign({}, i), { context_free_actions: n, actions: a })];
          }
        });
      });
    }, e.prototype.deflateSerializedArray = function(t) {
      return pako_1.deflate(t, { level: 9 });
    }, e.prototype.inflateSerializedArray = function(t) {
      return pako_1.inflate(t);
    }, e.prototype.transact = function(t, i) {
      var n = i === void 0 ? {} : i, a = n.broadcast, o = a === void 0 ? !0 : a, l = n.sign, c = l === void 0 ? !0 : l, d = n.readOnlyTrx, u = n.returnFailureTraces, m = n.requiredKeys, A = n.compression, y = n.blocksBehind, D = n.useLastIrreversible, C = n.expireSeconds;
      return __awaiter$4(this, void 0, void 0, function() {
        var z, R, O, $, k, P, L, F;
        return __generator$1(this, function(B) {
          switch (B.label) {
            case 0:
              if (typeof y == "number" && D)
                throw new Error("Use either blocksBehind or useLastIrreversible");
              return this.chainId ? [3, 2] : [4, this.rpc.get_info()];
            case 1:
              z = B.sent(), this.chainId = z.chain_id, B.label = 2;
            case 2:
              return (typeof y == "number" || D) && C ? [4, this.generateTapos(z, t, y, D, C)] : [3, 4];
            case 3:
              t = B.sent(), B.label = 4;
            case 4:
              if (!this.hasRequiredTaposFields(t))
                throw new Error("Required configuration or TAPOS fields are not present");
              return [4, this.getTransactionAbis(t)];
            case 5:
              return R = B.sent(), O = [__assign({}, t)], F = {}, [4, this.serializeTransactionExtensions(t)];
            case 6:
              return F.transaction_extensions = B.sent(), [4, this.serializeActions(t.context_free_actions || [])];
            case 7:
              return F.context_free_actions = B.sent(), [4, this.serializeActions(t.actions)];
            case 8:
              return t = __assign.apply(void 0, O.concat([(F.actions = B.sent(), F)])), t = this.deleteTransactionExtensionObjects(t), $ = this.serializeTransaction(t), k = this.serializeContextFreeData(t.context_free_data), P = { serializedTransaction: $, serializedContextFreeData: k, signatures: [] }, c ? m ? [3, 11] : [4, this.signatureProvider.getAvailableKeys()] : [3, 13];
            case 9:
              return L = B.sent(), [4, this.authorityProvider.getRequiredKeys({ transaction: t, availableKeys: L })];
            case 10:
              m = B.sent(), B.label = 11;
            case 11:
              return [4, this.signatureProvider.sign({ chainId: this.chainId, requiredKeys: m, serializedTransaction: $, serializedContextFreeData: k, abis: R })];
            case 12:
              P = B.sent(), B.label = 13;
            case 13:
              return o ? A ? [2, this.pushCompressedSignedTransaction(P, d, u)] : [2, this.pushSignedTransaction(P, d, u)] : [2, P];
          }
        });
      });
    }, e.prototype.query = function(t, i, n, a) {
      var o = a.sign, l = a.requiredKeys, c = a.authorization, d = c === void 0 ? [] : c;
      return __awaiter$4(this, void 0, void 0, function() {
        var u, m, A, y, D, C, z, R, O, $, k;
        return __generator$1(this, function(P) {
          switch (P.label) {
            case 0:
              return [4, this.rpc.get_info()];
            case 1:
              return u = P.sent(), [4, this.tryRefBlockFromGetInfo(u)];
            case 2:
              return m = P.sent(), A = new ser.SerialBuffer({ textEncoder: this.textEncoder, textDecoder: this.textDecoder }), ser.serializeQuery(A, n), y = __assign(__assign({}, ser.transactionHeader(m, 60 * 30)), { context_free_actions: [], actions: [{ account: t, name: "queryit", authorization: d, data: ser.arrayToHex(A.asUint8Array()) }] }), D = this.serializeTransaction(y), C = [], o ? [4, this.getTransactionAbis(y)] : [3, 8];
            case 3:
              return z = P.sent(), l ? [3, 6] : [4, this.signatureProvider.getAvailableKeys()];
            case 4:
              return R = P.sent(), [4, this.authorityProvider.getRequiredKeys({ transaction: y, availableKeys: R })];
            case 5:
              l = P.sent(), P.label = 6;
            case 6:
              return [4, this.signatureProvider.sign({ chainId: this.chainId, requiredKeys: l, serializedTransaction: D, serializedContextFreeData: null, abis: z })];
            case 7:
              O = P.sent(), C = O.signatures, P.label = 8;
            case 8:
              return [4, this.rpc.send_transaction({ signatures: C, compression: 0, serializedTransaction: D })];
            case 9:
              return $ = P.sent(), k = new ser.SerialBuffer({ textEncoder: this.textEncoder, textDecoder: this.textDecoder, array: ser.hexToUint8Array($.processed.action_traces[0][1].return_value) }), i ? [2, ser.deserializeAnyvarShort(k)] : [2, ser.deserializeAnyvar(k)];
          }
        });
      });
    }, e.prototype.pushSignedTransaction = function(t, i, n) {
      var a = t.signatures, o = t.serializedTransaction, l = t.serializedContextFreeData;
      return i === void 0 && (i = !1), n === void 0 && (n = !1), __awaiter$4(this, void 0, void 0, function() {
        return __generator$1(this, function(c) {
          return i ? [2, this.rpc.push_ro_transaction({ signatures: a, serializedTransaction: o, serializedContextFreeData: l }, n)] : [2, this.rpc.push_transaction({ signatures: a, serializedTransaction: o, serializedContextFreeData: l })];
        });
      });
    }, e.prototype.pushCompressedSignedTransaction = function(t, i, n) {
      var a = t.signatures, o = t.serializedTransaction, l = t.serializedContextFreeData;
      return i === void 0 && (i = !1), n === void 0 && (n = !1), __awaiter$4(this, void 0, void 0, function() {
        var c, d;
        return __generator$1(this, function(u) {
          return c = this.deflateSerializedArray(o), d = this.deflateSerializedArray(l || new Uint8Array(0)), i ? [2, this.rpc.push_ro_transaction({ signatures: a, compression: 1, serializedTransaction: c, serializedContextFreeData: d }, n)] : [2, this.rpc.push_transaction({ signatures: a, compression: 1, serializedTransaction: c, serializedContextFreeData: d })];
        });
      });
    }, e.prototype.generateTapos = function(t, i, n, a, o) {
      return __awaiter$4(this, void 0, void 0, function() {
        var l, c, d, u;
        return __generator$1(this, function(m) {
          switch (m.label) {
            case 0:
              return t ? [3, 2] : [4, this.rpc.get_info()];
            case 1:
              t = m.sent(), m.label = 2;
            case 2:
              return a ? [4, this.tryRefBlockFromGetInfo(t)] : [3, 4];
            case 3:
              return l = m.sent(), [2, __assign(__assign({}, ser.transactionHeader(l, o)), i)];
            case 4:
              return c = t.head_block_num - n, c <= t.last_irreversible_block_num ? [4, this.tryGetBlockInfo(c)] : [3, 6];
            case 5:
              return u = m.sent(), [3, 8];
            case 6:
              return [4, this.tryGetBlockHeaderState(c)];
            case 7:
              u = m.sent(), m.label = 8;
            case 8:
              return d = u, [2, __assign(__assign({}, ser.transactionHeader(d, o)), i)];
          }
        });
      });
    }, e.prototype.hasRequiredTaposFields = function(t) {
      var i = t.expiration, n = t.ref_block_num, a = t.ref_block_prefix;
      return !!(i && typeof n == "number" && typeof a == "number");
    }, e.prototype.tryGetBlockHeaderState = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        return __generator$1(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 4]), [4, this.rpc.get_block_header_state(t)];
            case 1:
              return [2, i.sent()];
            case 2:
              return i.sent(), [4, this.tryGetBlockInfo(t)];
            case 3:
              return [2, i.sent()];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.tryGetBlockInfo = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        return __generator$1(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 4]), [4, this.rpc.get_block_info(t)];
            case 1:
              return [2, i.sent()];
            case 2:
              return i.sent(), [4, this.rpc.get_block(t)];
            case 3:
              return [2, i.sent()];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.tryRefBlockFromGetInfo = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var i;
        return __generator$1(this, function(n) {
          switch (n.label) {
            case 0:
              return t.hasOwnProperty("last_irreversible_block_id") && t.hasOwnProperty("last_irreversible_block_num") && t.hasOwnProperty("last_irreversible_block_time") ? [2, { block_num: t.last_irreversible_block_num, id: t.last_irreversible_block_id, timestamp: t.last_irreversible_block_time }] : [3, 1];
            case 1:
              return [4, this.tryGetBlockInfo(t.last_irreversible_block_num)];
            case 2:
              return i = n.sent(), [2, { block_num: i.block_num, id: i.id, timestamp: i.timestamp }];
          }
        });
      });
    }, e.prototype.with = function(t) {
      return new ActionBuilder(this, t);
    }, e.prototype.buildTransaction = function(t) {
      var i = new TransactionBuilder(this);
      return t ? t(i) : i;
    }, e;
  }()
);
eosjsApi.Api = Api;
var TransactionBuilder = (
  /** @class */
  function() {
    function e(t) {
      this.actions = [], this.contextFreeGroups = [], this.api = t;
    }
    return e.prototype.with = function(t) {
      var i = new ActionBuilder(this.api, t);
      return this.actions.push(i), i;
    }, e.prototype.associateContextFree = function(t) {
      return this.contextFreeGroups.push(t), this;
    }, e.prototype.send = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var i, n, a, o = this;
        return __generator$1(this, function(l) {
          switch (l.label) {
            case 0:
              return i = [], n = [], a = this.actions.map(function(c) {
                return c.serializedData;
              }), [4, Promise.all(this.contextFreeGroups.map(function(c) {
                return __awaiter$4(o, void 0, void 0, function() {
                  var d, u, m, A;
                  return __generator$1(this, function(y) {
                    return d = c({ cfd: i.length, cfa: n.length }), u = d.action, m = d.contextFreeAction, A = d.contextFreeData, u && a.push(u), m && n.push(m), A && i.push(A), [
                      2
                      /*return*/
                    ];
                  });
                });
              }))];
            case 1:
              return l.sent(), this.contextFreeGroups = [], this.actions = [], [4, this.api.transact({ context_free_data: i, context_free_actions: n, actions: a }, t)];
            case 2:
              return [2, l.sent()];
          }
        });
      });
    }, e;
  }()
);
eosjsApi.TransactionBuilder = TransactionBuilder;
var ActionBuilder = (
  /** @class */
  function() {
    function e(t, i) {
      this.api = t, this.accountName = i;
    }
    return e.prototype.as = function(t) {
      t === void 0 && (t = []);
      var i = [];
      return t && typeof t == "string" ? i = [{ actor: t, permission: "active" }] : i = t, new ActionSerializer(this, this.api, this.accountName, i);
    }, e;
  }()
);
eosjsApi.ActionBuilder = ActionBuilder;
var ActionSerializer = (
  /** @class */
  function() {
    function e(t, i, n, a) {
      var o, l, c = this, d = i.cachedAbis.get(n);
      if (!d)
        throw new Error("ABI must be cached before using ActionBuilder, run api.getAbi()");
      var u = ser.getTypesFromAbi(ser.createInitialTypes(), d.abi), m = /* @__PURE__ */ new Map();
      try {
        for (var A = __values$1(d.abi.actions), y = A.next(); !y.done; y = A.next()) {
          var D = y.value, C = D.name, z = D.type;
          m.set(C, ser.getType(u, z));
        }
      } catch (R) {
        o = { error: R };
      } finally {
        try {
          y && !y.done && (l = A.return) && l.call(A);
        } finally {
          if (o)
            throw o.error;
        }
      }
      m.forEach(function(R, O) {
        var $;
        Object.assign(c, ($ = {}, $[O] = function() {
          for (var k = [], P = 0; P < arguments.length; P++)
            k[P] = arguments[P];
          var L = {};
          k.forEach(function(B, G) {
            var Z = R.fields[G];
            L[Z.name] = B;
          });
          var F = ser.serializeAction({ types: u, actions: m }, n, O, a, L, i.textEncoder, i.textDecoder);
          return t.serializedData = F, F;
        }, $));
      });
    }
    return e;
  }()
), eosjsApiInterfaces = {};
Object.defineProperty(eosjsApiInterfaces, "__esModule", { value: !0 });
var eosjsJsonrpc = {}, eosjsRpcerror = {}, __extends = commonjsGlobal && commonjsGlobal.__extends || function() {
  var e = function(t, i) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var o in a)
        Object.prototype.hasOwnProperty.call(a, o) && (n[o] = a[o]);
    }, e(t, i);
  };
  return function(t, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    e(t, i);
    function n() {
      this.constructor = t;
    }
    t.prototype = i === null ? Object.create(i) : (n.prototype = i.prototype, new n());
  };
}();
Object.defineProperty(eosjsRpcerror, "__esModule", { value: !0 });
eosjsRpcerror.RpcError = void 0;
var RpcError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(i) {
      var n = this;
      return i.error && i.error.details && i.error.details.length && i.error.details[0].message ? (n = e.call(this, i.error.details[0].message) || this, n.details = i.error.details) : i.processed && i.processed.except && i.processed.except.message ? (n = e.call(this, i.processed.except.message) || this, n.details = i.processed.except) : i.result && i.result.except && i.result.except.message ? (n = e.call(this, i.result.except.message) || this, n.details = i.result.except) : n = e.call(this, i.message) || this, Object.setPrototypeOf(n, t.prototype), n.json = i, n;
    }
    return t;
  }(Error)
);
eosjsRpcerror.RpcError = RpcError;
var __awaiter$3 = commonjsGlobal && commonjsGlobal.__awaiter || function(e, t, i, n) {
  function a(o) {
    return o instanceof i ? o : new i(function(l) {
      l(o);
    });
  }
  return new (i || (i = Promise))(function(o, l) {
    function c(m) {
      try {
        u(n.next(m));
      } catch (A) {
        l(A);
      }
    }
    function d(m) {
      try {
        u(n.throw(m));
      } catch (A) {
        l(A);
      }
    }
    function u(m) {
      m.done ? o(m.value) : a(m.value).then(c, d);
    }
    u((n = n.apply(e, t || [])).next());
  });
}, __generator = commonjsGlobal && commonjsGlobal.__generator || function(e, t) {
  var i = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, a, o, l;
  return l = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function c(u) {
    return function(m) {
      return d([u, m]);
    };
  }
  function d(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; i; )
      try {
        if (n = 1, a && (o = u[0] & 2 ? a.return : u[0] ? a.throw || ((o = a.return) && o.call(a), 0) : a.next) && !(o = o.call(a, u[1])).done)
          return o;
        switch (a = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
          case 0:
          case 1:
            o = u;
            break;
          case 4:
            return i.label++, { value: u[1], done: !1 };
          case 5:
            i.label++, a = u[1], u = [0];
            continue;
          case 7:
            u = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (o = i.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              i = 0;
              continue;
            }
            if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
              i.label = u[1];
              break;
            }
            if (u[0] === 6 && i.label < o[1]) {
              i.label = o[1], o = u;
              break;
            }
            if (o && i.label < o[2]) {
              i.label = o[2], i.ops.push(u);
              break;
            }
            o[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        u = t.call(e, i);
      } catch (m) {
        u = [6, m], a = 0;
      } finally {
        n = o = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, __values = commonjsGlobal && commonjsGlobal.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, i = t && e[t], n = 0;
  if (i)
    return i.call(e);
  if (e && typeof e.length == "number")
    return { next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(eosjsJsonrpc, "__esModule", { value: !0 });
eosjsJsonrpc.JsonRpc = void 0;
var eosjs_numeric_1$1 = eosjsNumeric, eosjs_rpcerror_1 = eosjsRpcerror, arrayToHex = function(e) {
  var t, i, n = "";
  try {
    for (var a = __values(e), o = a.next(); !o.done; o = a.next()) {
      var l = o.value;
      n += ("00" + l.toString(16)).slice(-2);
    }
  } catch (c) {
    t = { error: c };
  } finally {
    try {
      o && !o.done && (i = a.return) && i.call(a);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return n;
}, JsonRpc = (
  /** @class */
  function() {
    function e(t, i) {
      i === void 0 && (i = {}), this.endpoint = t.replace(/\/$/, ""), i.fetch ? this.fetchBuiltin = i.fetch : this.fetchBuiltin = commonjsGlobal.fetch;
    }
    return e.prototype.fetch = function(t, i) {
      return __awaiter$3(this, void 0, void 0, function() {
        var n, a, o, l;
        return __generator(this, function(c) {
          switch (c.label) {
            case 0:
              return c.trys.push([0, 3, , 4]), o = this.fetchBuiltin, [4, o(this.endpoint + t, { body: JSON.stringify(i), method: "POST" })];
            case 1:
              return n = c.sent(), [4, n.json()];
            case 2:
              if (a = c.sent(), a.processed && a.processed.except)
                throw new eosjs_rpcerror_1.RpcError(a);
              if (a.result && a.result.except)
                throw new eosjs_rpcerror_1.RpcError(a);
              return [3, 4];
            case 3:
              throw l = c.sent(), l.isFetchError = !0, l;
            case 4:
              if (!n.ok)
                throw new eosjs_rpcerror_1.RpcError(a);
              return [2, a];
          }
        });
      });
    }, e.prototype.abi_bin_to_json = function(t, i, n) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.fetch("/v1/chain/abi_bin_to_json", { code: t, action: i, binargs: n })];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.abi_json_to_bin = function(t, i, n) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.fetch("/v1/chain/abi_json_to_bin", { code: t, action: i, args: n })];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.get_abi = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_abi", { account_name: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.get_account = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_account", { account_name: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.get_accounts_by_authorizers = function(t, i) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_accounts_by_authorizers", { accounts: t, keys: i })];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, e.prototype.get_activated_protocol_features = function(t) {
      var i = t.limit, n = i === void 0 ? 10 : i, a = t.search_by_block_num, o = a === void 0 ? !1 : a, l = t.reverse, c = l === void 0 ? !1 : l, d = t.lower_bound, u = d === void 0 ? null : d, m = t.upper_bound, A = m === void 0 ? null : m;
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(y) {
          switch (y.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_activated_protocol_features", { lower_bound: u, upper_bound: A, limit: n, search_by_block_num: o, reverse: c })];
            case 1:
              return [2, y.sent()];
          }
        });
      });
    }, e.prototype.get_block_header_state = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_block_header_state", { block_num_or_id: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.get_block_info = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_block_info", { block_num: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.get_block = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_block", { block_num_or_id: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.get_code = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_code", { account_name: t, code_as_wasm: !0 })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.get_code_hash = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_code_hash", { account_name: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.get_currency_balance = function(t, i, n) {
      return n === void 0 && (n = null), __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_currency_balance", { code: t, account: i, symbol: n })];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.get_currency_stats = function(t, i) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_currency_stats", { code: t, symbol: i })];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, e.prototype.get_info = function() {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_info", {})];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.get_producer_schedule = function() {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_producer_schedule", {})];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.get_producers = function(t, i, n) {
      return t === void 0 && (t = !0), i === void 0 && (i = ""), n === void 0 && (n = 50), __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_producers", { json: t, lower_bound: i, limit: n })];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.get_raw_code_and_abi = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_raw_code_and_abi", { account_name: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.getRawAbi = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        var i, n;
        return __generator(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.get_raw_abi(t)];
            case 1:
              return i = a.sent(), n = eosjs_numeric_1$1.base64ToBinary(i.abi), [2, { accountName: i.account_name, abi: n }];
          }
        });
      });
    }, e.prototype.get_raw_abi = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_raw_abi", { account_name: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.get_scheduled_transactions = function(t, i, n) {
      return t === void 0 && (t = !0), i === void 0 && (i = ""), n === void 0 && (n = 50), __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_scheduled_transactions", { json: t, lower_bound: i, limit: n })];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.get_table_rows = function(t) {
      var i = t.json, n = i === void 0 ? !0 : i, a = t.code, o = t.scope, l = t.table, c = t.lower_bound, d = c === void 0 ? "" : c, u = t.upper_bound, m = u === void 0 ? "" : u, A = t.index_position, y = A === void 0 ? 1 : A, D = t.key_type, C = D === void 0 ? "" : D, z = t.limit, R = z === void 0 ? 10 : z, O = t.reverse, $ = O === void 0 ? !1 : O, k = t.show_payer, P = k === void 0 ? !1 : k;
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(L) {
          switch (L.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_table_rows", { json: n, code: a, scope: o, table: l, lower_bound: d, upper_bound: m, index_position: y, key_type: C, limit: R, reverse: $, show_payer: P })];
            case 1:
              return [2, L.sent()];
          }
        });
      });
    }, e.prototype.get_kv_table_rows = function(t) {
      var i = t.json, n = i === void 0 ? !0 : i, a = t.code, o = t.table, l = t.index_name, c = t.encode_type, d = c === void 0 ? "bytes" : c, u = t.index_value, m = t.lower_bound, A = t.upper_bound, y = t.limit, D = y === void 0 ? 10 : y, C = t.reverse, z = C === void 0 ? !1 : C, R = t.show_payer, O = R === void 0 ? !1 : R;
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function($) {
          switch ($.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_kv_table_rows", { json: n, code: a, table: o, index_name: l, encode_type: d, index_value: u, lower_bound: m, upper_bound: A, limit: D, reverse: z, show_payer: O })];
            case 1:
              return [2, $.sent()];
          }
        });
      });
    }, e.prototype.get_table_by_scope = function(t) {
      var i = t.code, n = t.table, a = t.lower_bound, o = a === void 0 ? "" : a, l = t.upper_bound, c = l === void 0 ? "" : l, d = t.limit, u = d === void 0 ? 10 : d;
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(m) {
          switch (m.label) {
            case 0:
              return [4, this.fetch("/v1/chain/get_table_by_scope", { code: i, table: n, lower_bound: o, upper_bound: c, limit: u })];
            case 1:
              return [2, m.sent()];
          }
        });
      });
    }, e.prototype.getRequiredKeys = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        var i;
        return __generator(this, function(n) {
          switch (n.label) {
            case 0:
              return i = eosjs_numeric_1$1.convertLegacyPublicKeys, [4, this.fetch("/v1/chain/get_required_keys", { transaction: t.transaction, available_keys: t.availableKeys })];
            case 1:
              return [2, i.apply(void 0, [n.sent().required_keys])];
          }
        });
      });
    }, e.prototype.push_transaction = function(t) {
      var i = t.signatures, n = t.compression, a = n === void 0 ? 0 : n, o = t.serializedTransaction, l = t.serializedContextFreeData;
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, this.fetch("/v1/chain/push_transaction", { signatures: i, compression: a, packed_context_free_data: arrayToHex(l || new Uint8Array(0)), packed_trx: arrayToHex(o) })];
            case 1:
              return [2, c.sent()];
          }
        });
      });
    }, e.prototype.push_ro_transaction = function(t, i) {
      var n = t.signatures, a = t.compression, o = a === void 0 ? 0 : a, l = t.serializedTransaction;
      return i === void 0 && (i = !1), __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, this.fetch("/v1/chain/push_ro_transaction", { transaction: { signatures: n, compression: o, packed_context_free_data: arrayToHex(new Uint8Array(0)), packed_trx: arrayToHex(l) }, return_failure_traces: i })];
            case 1:
              return [2, c.sent()];
          }
        });
      });
    }, e.prototype.push_transactions = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        var i;
        return __generator(this, function(n) {
          switch (n.label) {
            case 0:
              return i = t.map(function(a) {
                var o = a.signatures, l = a.compression, c = l === void 0 ? 0 : l, d = a.serializedTransaction, u = a.serializedContextFreeData;
                return { signatures: o, compression: c, packed_context_free_data: arrayToHex(u || new Uint8Array(0)), packed_trx: arrayToHex(d) };
              }), [4, this.fetch("/v1/chain/push_transactions", i)];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, e.prototype.send_transaction = function(t) {
      var i = t.signatures, n = t.compression, a = n === void 0 ? 0 : n, o = t.serializedTransaction, l = t.serializedContextFreeData;
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, this.fetch("/v1/chain/send_transaction", { signatures: i, compression: a, packed_context_free_data: arrayToHex(l || new Uint8Array(0)), packed_trx: arrayToHex(o) })];
            case 1:
              return [2, c.sent()];
          }
        });
      });
    }, e.prototype.db_size_get = function() {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this.fetch("/v1/db_size/get", {})];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.trace_get_block = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/trace_api/get_block", { block_num: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.history_get_actions = function(t, i, n) {
      return i === void 0 && (i = null), n === void 0 && (n = null), __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.fetch("/v1/history/get_actions", { account_name: t, pos: i, offset: n })];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.history_get_transaction = function(t, i) {
      return i === void 0 && (i = null), __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.fetch("/v1/history/get_transaction", { id: t, block_num_hint: i })];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, e.prototype.history_get_key_accounts = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/history/get_key_accounts", { public_key: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e.prototype.history_get_controlled_accounts = function(t) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.fetch("/v1/history/get_controlled_accounts", { controlling_account: t })];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, e;
  }()
);
eosjsJsonrpc.JsonRpc = JsonRpc;
var eosjsRpcInterfaces = {};
Object.defineProperty(eosjsRpcInterfaces, "__esModule", { value: !0 });
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Serialize = e.RpcError = e.RpcInterfaces = e.Numeric = e.JsonRpc = e.ApiInterfaces = e.Api = void 0;
  var t = eosjsApi;
  Object.defineProperty(e, "Api", { enumerable: !0, get: function() {
    return t.Api;
  } });
  var i = eosjsApiInterfaces;
  e.ApiInterfaces = i;
  var n = eosjsJsonrpc;
  Object.defineProperty(e, "JsonRpc", { enumerable: !0, get: function() {
    return n.JsonRpc;
  } });
  var a = eosjsNumeric;
  e.Numeric = a;
  var o = eosjsRpcInterfaces;
  e.RpcInterfaces = o;
  var l = eosjsRpcerror;
  Object.defineProperty(e, "RpcError", { enumerable: !0, get: function() {
    return l.RpcError;
  } });
  var c = eosjsSerialize;
  e.Serialize = c;
})(dist);
var eosjsEccMigration = {}, eosjsJssig = {}, elliptic = {};
const name = "elliptic", version = "6.5.4", description = "EC cryptography", main = "lib/elliptic.js", files = ["lib"], scripts = { lint: "eslint lib test", "lint:fix": "npm run lint -- --fix", unit: "istanbul test _mocha --reporter=spec test/index.js", test: "npm run lint && npm run unit", version: "grunt dist && git add dist/" }, repository = { type: "git", url: "git@github.com:indutny/elliptic" }, keywords = ["EC", "Elliptic", "curve", "Cryptography"], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = { url: "https://github.com/indutny/elliptic/issues" }, homepage = "https://github.com/indutny/elliptic", devDependencies = { brfs: "^2.0.2", coveralls: "^3.1.0", eslint: "^7.6.0", grunt: "^1.2.1", "grunt-browserify": "^5.3.0", "grunt-cli": "^1.3.2", "grunt-contrib-connect": "^3.0.0", "grunt-contrib-copy": "^1.0.0", "grunt-contrib-uglify": "^5.0.0", "grunt-mocha-istanbul": "^5.0.2", "grunt-saucelabs": "^9.0.1", istanbul: "^0.4.5", mocha: "^8.0.1" }, dependencies = { "bn.js": "^4.11.9", brorand: "^1.1.0", "hash.js": "^1.0.0", "hmac-drbg": "^1.0.1", inherits: "^2.0.4", "minimalistic-assert": "^1.0.1", "minimalistic-crypto-utils": "^1.0.1" }, require$$0$1 = { name, version, description, main, files, scripts, repository, keywords, author, license, bugs, homepage, devDependencies, dependencies };
var utils$c = {}, bnExports$1 = {}, bn$1 = { get exports() {
  return bnExports$1;
}, set exports(e) {
  bnExports$1 = e;
} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({ __proto__: null, default: __viteBrowserExternal }, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
(function(e) {
  (function(t, i) {
    function n(V, E) {
      if (!V)
        throw new Error(E || "Assertion failed");
    }
    function a(V, E) {
      V.super_ = E;
      var T = function() {
      };
      T.prototype = E.prototype, V.prototype = new T(), V.prototype.constructor = V;
    }
    function o(V, E, T) {
      if (o.isBN(V))
        return V;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, V !== null && ((E === "le" || E === "be") && (T = E, E = 10), this._init(V || 0, E || 10, T || "be"));
    }
    typeof t == "object" ? t.exports = o : i.BN = o, o.BN = o, o.wordSize = 26;
    var l;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = require$$0.Buffer;
    } catch {
    }
    o.isBN = function(E) {
      return E instanceof o ? !0 : E !== null && typeof E == "object" && E.constructor.wordSize === o.wordSize && Array.isArray(E.words);
    }, o.max = function(E, T) {
      return E.cmp(T) > 0 ? E : T;
    }, o.min = function(E, T) {
      return E.cmp(T) < 0 ? E : T;
    }, o.prototype._init = function(E, T, g) {
      if (typeof E == "number")
        return this._initNumber(E, T, g);
      if (typeof E == "object")
        return this._initArray(E, T, g);
      T === "hex" && (T = 16), n(T === (T | 0) && T >= 2 && T <= 36), E = E.toString().replace(/\s+/g, "");
      var b = 0;
      E[0] === "-" && (b++, this.negative = 1), b < E.length && (T === 16 ? this._parseHex(E, b, g) : (this._parseBase(E, T, b), g === "le" && this._initArray(this.toArray(), T, g)));
    }, o.prototype._initNumber = function(E, T, g) {
      E < 0 && (this.negative = 1, E = -E), E < 67108864 ? (this.words = [E & 67108863], this.length = 1) : E < 4503599627370496 ? (this.words = [E & 67108863, E / 67108864 & 67108863], this.length = 2) : (n(E < 9007199254740992), this.words = [E & 67108863, E / 67108864 & 67108863, 1], this.length = 3), g === "le" && this._initArray(this.toArray(), T, g);
    }, o.prototype._initArray = function(E, T, g) {
      if (n(typeof E.length == "number"), E.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(E.length / 3), this.words = new Array(this.length);
      for (var b = 0; b < this.length; b++)
        this.words[b] = 0;
      var x, S, I = 0;
      if (g === "be")
        for (b = E.length - 1, x = 0; b >= 0; b -= 3)
          S = E[b] | E[b - 1] << 8 | E[b - 2] << 16, this.words[x] |= S << I & 67108863, this.words[x + 1] = S >>> 26 - I & 67108863, I += 24, I >= 26 && (I -= 26, x++);
      else if (g === "le")
        for (b = 0, x = 0; b < E.length; b += 3)
          S = E[b] | E[b + 1] << 8 | E[b + 2] << 16, this.words[x] |= S << I & 67108863, this.words[x + 1] = S >>> 26 - I & 67108863, I += 24, I >= 26 && (I -= 26, x++);
      return this.strip();
    };
    function c(V, E) {
      var T = V.charCodeAt(E);
      return T >= 65 && T <= 70 ? T - 55 : T >= 97 && T <= 102 ? T - 87 : T - 48 & 15;
    }
    function d(V, E, T) {
      var g = c(V, T);
      return T - 1 >= E && (g |= c(V, T - 1) << 4), g;
    }
    o.prototype._parseHex = function(E, T, g) {
      this.length = Math.ceil((E.length - T) / 6), this.words = new Array(this.length);
      for (var b = 0; b < this.length; b++)
        this.words[b] = 0;
      var x = 0, S = 0, I;
      if (g === "be")
        for (b = E.length - 1; b >= T; b -= 2)
          I = d(E, T, b) << x, this.words[S] |= I & 67108863, x >= 18 ? (x -= 18, S += 1, this.words[S] |= I >>> 26) : x += 8;
      else {
        var N = E.length - T;
        for (b = N % 2 === 0 ? T + 1 : T; b < E.length; b += 2)
          I = d(E, T, b) << x, this.words[S] |= I & 67108863, x >= 18 ? (x -= 18, S += 1, this.words[S] |= I >>> 26) : x += 8;
      }
      this.strip();
    };
    function u(V, E, T, g) {
      for (var b = 0, x = Math.min(V.length, T), S = E; S < x; S++) {
        var I = V.charCodeAt(S) - 48;
        b *= g, I >= 49 ? b += I - 49 + 10 : I >= 17 ? b += I - 17 + 10 : b += I;
      }
      return b;
    }
    o.prototype._parseBase = function(E, T, g) {
      this.words = [0], this.length = 1;
      for (var b = 0, x = 1; x <= 67108863; x *= T)
        b++;
      b--, x = x / T | 0;
      for (var S = E.length - g, I = S % b, N = Math.min(S, S - I) + g, p = 0, M = g; M < N; M += b)
        p = u(E, M, M + b, T), this.imuln(x), this.words[0] + p < 67108864 ? this.words[0] += p : this._iaddn(p);
      if (I !== 0) {
        var j = 1;
        for (p = u(E, M, E.length, T), M = 0; M < I; M++)
          j *= T;
        this.imuln(j), this.words[0] + p < 67108864 ? this.words[0] += p : this._iaddn(p);
      }
      this.strip();
    }, o.prototype.copy = function(E) {
      E.words = new Array(this.length);
      for (var T = 0; T < this.length; T++)
        E.words[T] = this.words[T];
      E.length = this.length, E.negative = this.negative, E.red = this.red;
    }, o.prototype.clone = function() {
      var E = new o(null);
      return this.copy(E), E;
    }, o.prototype._expand = function(E) {
      for (; this.length < E; )
        this.words[this.length++] = 0;
      return this;
    }, o.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, o.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, o.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var m = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"], A = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5], y = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
    o.prototype.toString = function(E, T) {
      E = E || 10, T = T | 0 || 1;
      var g;
      if (E === 16 || E === "hex") {
        g = "";
        for (var b = 0, x = 0, S = 0; S < this.length; S++) {
          var I = this.words[S], N = ((I << b | x) & 16777215).toString(16);
          x = I >>> 24 - b & 16777215, x !== 0 || S !== this.length - 1 ? g = m[6 - N.length] + N + g : g = N + g, b += 2, b >= 26 && (b -= 26, S--);
        }
        for (x !== 0 && (g = x.toString(16) + g); g.length % T !== 0; )
          g = "0" + g;
        return this.negative !== 0 && (g = "-" + g), g;
      }
      if (E === (E | 0) && E >= 2 && E <= 36) {
        var p = A[E], M = y[E];
        g = "";
        var j = this.clone();
        for (j.negative = 0; !j.isZero(); ) {
          var U = j.modn(M).toString(E);
          j = j.idivn(M), j.isZero() ? g = U + g : g = m[p - U.length] + U + g;
        }
        for (this.isZero() && (g = "0" + g); g.length % T !== 0; )
          g = "0" + g;
        return this.negative !== 0 && (g = "-" + g), g;
      }
      n(!1, "Base should be between 2 and 36");
    }, o.prototype.toNumber = function() {
      var E = this.words[0];
      return this.length === 2 ? E += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? E += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -E : E;
    }, o.prototype.toJSON = function() {
      return this.toString(16);
    }, o.prototype.toBuffer = function(E, T) {
      return n(typeof l < "u"), this.toArrayLike(l, E, T);
    }, o.prototype.toArray = function(E, T) {
      return this.toArrayLike(Array, E, T);
    }, o.prototype.toArrayLike = function(E, T, g) {
      var b = this.byteLength(), x = g || Math.max(1, b);
      n(b <= x, "byte array longer than desired length"), n(x > 0, "Requested array length <= 0"), this.strip();
      var S = T === "le", I = new E(x), N, p, M = this.clone();
      if (S) {
        for (p = 0; !M.isZero(); p++)
          N = M.andln(255), M.iushrn(8), I[p] = N;
        for (; p < x; p++)
          I[p] = 0;
      } else {
        for (p = 0; p < x - b; p++)
          I[p] = 0;
        for (p = 0; !M.isZero(); p++)
          N = M.andln(255), M.iushrn(8), I[x - p - 1] = N;
      }
      return I;
    }, Math.clz32 ? o.prototype._countBits = function(E) {
      return 32 - Math.clz32(E);
    } : o.prototype._countBits = function(E) {
      var T = E, g = 0;
      return T >= 4096 && (g += 13, T >>>= 13), T >= 64 && (g += 7, T >>>= 7), T >= 8 && (g += 4, T >>>= 4), T >= 2 && (g += 2, T >>>= 2), g + T;
    }, o.prototype._zeroBits = function(E) {
      if (E === 0)
        return 26;
      var T = E, g = 0;
      return T & 8191 || (g += 13, T >>>= 13), T & 127 || (g += 7, T >>>= 7), T & 15 || (g += 4, T >>>= 4), T & 3 || (g += 2, T >>>= 2), T & 1 || g++, g;
    }, o.prototype.bitLength = function() {
      var E = this.words[this.length - 1], T = this._countBits(E);
      return (this.length - 1) * 26 + T;
    };
    function D(V) {
      for (var E = new Array(V.bitLength()), T = 0; T < E.length; T++) {
        var g = T / 26 | 0, b = T % 26;
        E[T] = (V.words[g] & 1 << b) >>> b;
      }
      return E;
    }
    o.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var E = 0, T = 0; T < this.length; T++) {
        var g = this._zeroBits(this.words[T]);
        if (E += g, g !== 26)
          break;
      }
      return E;
    }, o.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, o.prototype.toTwos = function(E) {
      return this.negative !== 0 ? this.abs().inotn(E).iaddn(1) : this.clone();
    }, o.prototype.fromTwos = function(E) {
      return this.testn(E - 1) ? this.notn(E).iaddn(1).ineg() : this.clone();
    }, o.prototype.isNeg = function() {
      return this.negative !== 0;
    }, o.prototype.neg = function() {
      return this.clone().ineg();
    }, o.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, o.prototype.iuor = function(E) {
      for (; this.length < E.length; )
        this.words[this.length++] = 0;
      for (var T = 0; T < E.length; T++)
        this.words[T] = this.words[T] | E.words[T];
      return this.strip();
    }, o.prototype.ior = function(E) {
      return n((this.negative | E.negative) === 0), this.iuor(E);
    }, o.prototype.or = function(E) {
      return this.length > E.length ? this.clone().ior(E) : E.clone().ior(this);
    }, o.prototype.uor = function(E) {
      return this.length > E.length ? this.clone().iuor(E) : E.clone().iuor(this);
    }, o.prototype.iuand = function(E) {
      var T;
      this.length > E.length ? T = E : T = this;
      for (var g = 0; g < T.length; g++)
        this.words[g] = this.words[g] & E.words[g];
      return this.length = T.length, this.strip();
    }, o.prototype.iand = function(E) {
      return n((this.negative | E.negative) === 0), this.iuand(E);
    }, o.prototype.and = function(E) {
      return this.length > E.length ? this.clone().iand(E) : E.clone().iand(this);
    }, o.prototype.uand = function(E) {
      return this.length > E.length ? this.clone().iuand(E) : E.clone().iuand(this);
    }, o.prototype.iuxor = function(E) {
      var T, g;
      this.length > E.length ? (T = this, g = E) : (T = E, g = this);
      for (var b = 0; b < g.length; b++)
        this.words[b] = T.words[b] ^ g.words[b];
      if (this !== T)
        for (; b < T.length; b++)
          this.words[b] = T.words[b];
      return this.length = T.length, this.strip();
    }, o.prototype.ixor = function(E) {
      return n((this.negative | E.negative) === 0), this.iuxor(E);
    }, o.prototype.xor = function(E) {
      return this.length > E.length ? this.clone().ixor(E) : E.clone().ixor(this);
    }, o.prototype.uxor = function(E) {
      return this.length > E.length ? this.clone().iuxor(E) : E.clone().iuxor(this);
    }, o.prototype.inotn = function(E) {
      n(typeof E == "number" && E >= 0);
      var T = Math.ceil(E / 26) | 0, g = E % 26;
      this._expand(T), g > 0 && T--;
      for (var b = 0; b < T; b++)
        this.words[b] = ~this.words[b] & 67108863;
      return g > 0 && (this.words[b] = ~this.words[b] & 67108863 >> 26 - g), this.strip();
    }, o.prototype.notn = function(E) {
      return this.clone().inotn(E);
    }, o.prototype.setn = function(E, T) {
      n(typeof E == "number" && E >= 0);
      var g = E / 26 | 0, b = E % 26;
      return this._expand(g + 1), T ? this.words[g] = this.words[g] | 1 << b : this.words[g] = this.words[g] & ~(1 << b), this.strip();
    }, o.prototype.iadd = function(E) {
      var T;
      if (this.negative !== 0 && E.negative === 0)
        return this.negative = 0, T = this.isub(E), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && E.negative !== 0)
        return E.negative = 0, T = this.isub(E), E.negative = 1, T._normSign();
      var g, b;
      this.length > E.length ? (g = this, b = E) : (g = E, b = this);
      for (var x = 0, S = 0; S < b.length; S++)
        T = (g.words[S] | 0) + (b.words[S] | 0) + x, this.words[S] = T & 67108863, x = T >>> 26;
      for (; x !== 0 && S < g.length; S++)
        T = (g.words[S] | 0) + x, this.words[S] = T & 67108863, x = T >>> 26;
      if (this.length = g.length, x !== 0)
        this.words[this.length] = x, this.length++;
      else if (g !== this)
        for (; S < g.length; S++)
          this.words[S] = g.words[S];
      return this;
    }, o.prototype.add = function(E) {
      var T;
      return E.negative !== 0 && this.negative === 0 ? (E.negative = 0, T = this.sub(E), E.negative ^= 1, T) : E.negative === 0 && this.negative !== 0 ? (this.negative = 0, T = E.sub(this), this.negative = 1, T) : this.length > E.length ? this.clone().iadd(E) : E.clone().iadd(this);
    }, o.prototype.isub = function(E) {
      if (E.negative !== 0) {
        E.negative = 0;
        var T = this.iadd(E);
        return E.negative = 1, T._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(E), this.negative = 1, this._normSign();
      var g = this.cmp(E);
      if (g === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var b, x;
      g > 0 ? (b = this, x = E) : (b = E, x = this);
      for (var S = 0, I = 0; I < x.length; I++)
        T = (b.words[I] | 0) - (x.words[I] | 0) + S, S = T >> 26, this.words[I] = T & 67108863;
      for (; S !== 0 && I < b.length; I++)
        T = (b.words[I] | 0) + S, S = T >> 26, this.words[I] = T & 67108863;
      if (S === 0 && I < b.length && b !== this)
        for (; I < b.length; I++)
          this.words[I] = b.words[I];
      return this.length = Math.max(this.length, I), b !== this && (this.negative = 1), this.strip();
    }, o.prototype.sub = function(E) {
      return this.clone().isub(E);
    };
    function C(V, E, T) {
      T.negative = E.negative ^ V.negative;
      var g = V.length + E.length | 0;
      T.length = g, g = g - 1 | 0;
      var b = V.words[0] | 0, x = E.words[0] | 0, S = b * x, I = S & 67108863, N = S / 67108864 | 0;
      T.words[0] = I;
      for (var p = 1; p < g; p++) {
        for (var M = N >>> 26, j = N & 67108863, U = Math.min(p, E.length - 1), H = Math.max(0, p - V.length + 1); H <= U; H++) {
          var J = p - H | 0;
          b = V.words[J] | 0, x = E.words[H] | 0, S = b * x + j, M += S / 67108864 | 0, j = S & 67108863;
        }
        T.words[p] = j | 0, N = M | 0;
      }
      return N !== 0 ? T.words[p] = N | 0 : T.length--, T.strip();
    }
    var z = function(E, T, g) {
      var b = E.words, x = T.words, S = g.words, I = 0, N, p, M, j = b[0] | 0, U = j & 8191, H = j >>> 13, J = b[1] | 0, te = J & 8191, ae = J >>> 13, le = b[2] | 0, ne = le & 8191, ue = le >>> 13, ge = b[3] | 0, re = ge & 8191, fe = ge >>> 13, oe = b[4] | 0, ve = oe & 8191, Le = oe >>> 13, Be = b[5] | 0, we = Be & 8191, Ue = Be >>> 13, Oe = b[6] | 0, Te = Oe & 8191, Ne = Oe >>> 13, Ee = b[7] | 0, Se = Ee & 8191, Re = Ee >>> 13, W = b[8] | 0, Y = W & 8191, Q = W >>> 13, ee = b[9] | 0, ie = ee & 8191, se = ee >>> 13, pe = x[0] | 0, he = pe & 8191, Me = pe >>> 13, _e = x[1] | 0, xe = _e & 8191, Ye = _e >>> 13, Ve = x[2] | 0, Ce = Ve & 8191, Qe = Ve >>> 13, qe = x[3] | 0, Pe = qe & 8191, He = qe >>> 13, Ze = x[4] | 0, je = Ze & 8191, We = Ze >>> 13, Je = x[5] | 0, $e = Je & 8191, Xe = Je >>> 13, Ke = x[6] | 0, q = Ke & 8191, ce = Ke >>> 13, de = x[7] | 0, me = de & 8191, De = de >>> 13, Ie = x[8] | 0, ye = Ie & 8191, Ae = Ie >>> 13, Fe = x[9] | 0, be = Fe & 8191, ke = Fe >>> 13;
      g.negative = E.negative ^ T.negative, g.length = 19, N = Math.imul(U, he), p = Math.imul(U, Me), p = p + Math.imul(H, he) | 0, M = Math.imul(H, Me);
      var ze = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (ze >>> 26) | 0, ze &= 67108863, N = Math.imul(te, he), p = Math.imul(te, Me), p = p + Math.imul(ae, he) | 0, M = Math.imul(ae, Me), N = N + Math.imul(U, xe) | 0, p = p + Math.imul(U, Ye) | 0, p = p + Math.imul(H, xe) | 0, M = M + Math.imul(H, Ye) | 0;
      var Ge = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (Ge >>> 26) | 0, Ge &= 67108863, N = Math.imul(ne, he), p = Math.imul(ne, Me), p = p + Math.imul(ue, he) | 0, M = Math.imul(ue, Me), N = N + Math.imul(te, xe) | 0, p = p + Math.imul(te, Ye) | 0, p = p + Math.imul(ae, xe) | 0, M = M + Math.imul(ae, Ye) | 0, N = N + Math.imul(U, Ce) | 0, p = p + Math.imul(U, Qe) | 0, p = p + Math.imul(H, Ce) | 0, M = M + Math.imul(H, Qe) | 0;
      var tt = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (tt >>> 26) | 0, tt &= 67108863, N = Math.imul(re, he), p = Math.imul(re, Me), p = p + Math.imul(fe, he) | 0, M = Math.imul(fe, Me), N = N + Math.imul(ne, xe) | 0, p = p + Math.imul(ne, Ye) | 0, p = p + Math.imul(ue, xe) | 0, M = M + Math.imul(ue, Ye) | 0, N = N + Math.imul(te, Ce) | 0, p = p + Math.imul(te, Qe) | 0, p = p + Math.imul(ae, Ce) | 0, M = M + Math.imul(ae, Qe) | 0, N = N + Math.imul(U, Pe) | 0, p = p + Math.imul(U, He) | 0, p = p + Math.imul(H, Pe) | 0, M = M + Math.imul(H, He) | 0;
      var et = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (et >>> 26) | 0, et &= 67108863, N = Math.imul(ve, he), p = Math.imul(ve, Me), p = p + Math.imul(Le, he) | 0, M = Math.imul(Le, Me), N = N + Math.imul(re, xe) | 0, p = p + Math.imul(re, Ye) | 0, p = p + Math.imul(fe, xe) | 0, M = M + Math.imul(fe, Ye) | 0, N = N + Math.imul(ne, Ce) | 0, p = p + Math.imul(ne, Qe) | 0, p = p + Math.imul(ue, Ce) | 0, M = M + Math.imul(ue, Qe) | 0, N = N + Math.imul(te, Pe) | 0, p = p + Math.imul(te, He) | 0, p = p + Math.imul(ae, Pe) | 0, M = M + Math.imul(ae, He) | 0, N = N + Math.imul(U, je) | 0, p = p + Math.imul(U, We) | 0, p = p + Math.imul(H, je) | 0, M = M + Math.imul(H, We) | 0;
      var rt = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (rt >>> 26) | 0, rt &= 67108863, N = Math.imul(we, he), p = Math.imul(we, Me), p = p + Math.imul(Ue, he) | 0, M = Math.imul(Ue, Me), N = N + Math.imul(ve, xe) | 0, p = p + Math.imul(ve, Ye) | 0, p = p + Math.imul(Le, xe) | 0, M = M + Math.imul(Le, Ye) | 0, N = N + Math.imul(re, Ce) | 0, p = p + Math.imul(re, Qe) | 0, p = p + Math.imul(fe, Ce) | 0, M = M + Math.imul(fe, Qe) | 0, N = N + Math.imul(ne, Pe) | 0, p = p + Math.imul(ne, He) | 0, p = p + Math.imul(ue, Pe) | 0, M = M + Math.imul(ue, He) | 0, N = N + Math.imul(te, je) | 0, p = p + Math.imul(te, We) | 0, p = p + Math.imul(ae, je) | 0, M = M + Math.imul(ae, We) | 0, N = N + Math.imul(U, $e) | 0, p = p + Math.imul(U, Xe) | 0, p = p + Math.imul(H, $e) | 0, M = M + Math.imul(H, Xe) | 0;
      var it = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (it >>> 26) | 0, it &= 67108863, N = Math.imul(Te, he), p = Math.imul(Te, Me), p = p + Math.imul(Ne, he) | 0, M = Math.imul(Ne, Me), N = N + Math.imul(we, xe) | 0, p = p + Math.imul(we, Ye) | 0, p = p + Math.imul(Ue, xe) | 0, M = M + Math.imul(Ue, Ye) | 0, N = N + Math.imul(ve, Ce) | 0, p = p + Math.imul(ve, Qe) | 0, p = p + Math.imul(Le, Ce) | 0, M = M + Math.imul(Le, Qe) | 0, N = N + Math.imul(re, Pe) | 0, p = p + Math.imul(re, He) | 0, p = p + Math.imul(fe, Pe) | 0, M = M + Math.imul(fe, He) | 0, N = N + Math.imul(ne, je) | 0, p = p + Math.imul(ne, We) | 0, p = p + Math.imul(ue, je) | 0, M = M + Math.imul(ue, We) | 0, N = N + Math.imul(te, $e) | 0, p = p + Math.imul(te, Xe) | 0, p = p + Math.imul(ae, $e) | 0, M = M + Math.imul(ae, Xe) | 0, N = N + Math.imul(U, q) | 0, p = p + Math.imul(U, ce) | 0, p = p + Math.imul(H, q) | 0, M = M + Math.imul(H, ce) | 0;
      var nt = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, N = Math.imul(Se, he), p = Math.imul(Se, Me), p = p + Math.imul(Re, he) | 0, M = Math.imul(Re, Me), N = N + Math.imul(Te, xe) | 0, p = p + Math.imul(Te, Ye) | 0, p = p + Math.imul(Ne, xe) | 0, M = M + Math.imul(Ne, Ye) | 0, N = N + Math.imul(we, Ce) | 0, p = p + Math.imul(we, Qe) | 0, p = p + Math.imul(Ue, Ce) | 0, M = M + Math.imul(Ue, Qe) | 0, N = N + Math.imul(ve, Pe) | 0, p = p + Math.imul(ve, He) | 0, p = p + Math.imul(Le, Pe) | 0, M = M + Math.imul(Le, He) | 0, N = N + Math.imul(re, je) | 0, p = p + Math.imul(re, We) | 0, p = p + Math.imul(fe, je) | 0, M = M + Math.imul(fe, We) | 0, N = N + Math.imul(ne, $e) | 0, p = p + Math.imul(ne, Xe) | 0, p = p + Math.imul(ue, $e) | 0, M = M + Math.imul(ue, Xe) | 0, N = N + Math.imul(te, q) | 0, p = p + Math.imul(te, ce) | 0, p = p + Math.imul(ae, q) | 0, M = M + Math.imul(ae, ce) | 0, N = N + Math.imul(U, me) | 0, p = p + Math.imul(U, De) | 0, p = p + Math.imul(H, me) | 0, M = M + Math.imul(H, De) | 0;
      var at = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, N = Math.imul(Y, he), p = Math.imul(Y, Me), p = p + Math.imul(Q, he) | 0, M = Math.imul(Q, Me), N = N + Math.imul(Se, xe) | 0, p = p + Math.imul(Se, Ye) | 0, p = p + Math.imul(Re, xe) | 0, M = M + Math.imul(Re, Ye) | 0, N = N + Math.imul(Te, Ce) | 0, p = p + Math.imul(Te, Qe) | 0, p = p + Math.imul(Ne, Ce) | 0, M = M + Math.imul(Ne, Qe) | 0, N = N + Math.imul(we, Pe) | 0, p = p + Math.imul(we, He) | 0, p = p + Math.imul(Ue, Pe) | 0, M = M + Math.imul(Ue, He) | 0, N = N + Math.imul(ve, je) | 0, p = p + Math.imul(ve, We) | 0, p = p + Math.imul(Le, je) | 0, M = M + Math.imul(Le, We) | 0, N = N + Math.imul(re, $e) | 0, p = p + Math.imul(re, Xe) | 0, p = p + Math.imul(fe, $e) | 0, M = M + Math.imul(fe, Xe) | 0, N = N + Math.imul(ne, q) | 0, p = p + Math.imul(ne, ce) | 0, p = p + Math.imul(ue, q) | 0, M = M + Math.imul(ue, ce) | 0, N = N + Math.imul(te, me) | 0, p = p + Math.imul(te, De) | 0, p = p + Math.imul(ae, me) | 0, M = M + Math.imul(ae, De) | 0, N = N + Math.imul(U, ye) | 0, p = p + Math.imul(U, Ae) | 0, p = p + Math.imul(H, ye) | 0, M = M + Math.imul(H, Ae) | 0;
      var st = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (st >>> 26) | 0, st &= 67108863, N = Math.imul(ie, he), p = Math.imul(ie, Me), p = p + Math.imul(se, he) | 0, M = Math.imul(se, Me), N = N + Math.imul(Y, xe) | 0, p = p + Math.imul(Y, Ye) | 0, p = p + Math.imul(Q, xe) | 0, M = M + Math.imul(Q, Ye) | 0, N = N + Math.imul(Se, Ce) | 0, p = p + Math.imul(Se, Qe) | 0, p = p + Math.imul(Re, Ce) | 0, M = M + Math.imul(Re, Qe) | 0, N = N + Math.imul(Te, Pe) | 0, p = p + Math.imul(Te, He) | 0, p = p + Math.imul(Ne, Pe) | 0, M = M + Math.imul(Ne, He) | 0, N = N + Math.imul(we, je) | 0, p = p + Math.imul(we, We) | 0, p = p + Math.imul(Ue, je) | 0, M = M + Math.imul(Ue, We) | 0, N = N + Math.imul(ve, $e) | 0, p = p + Math.imul(ve, Xe) | 0, p = p + Math.imul(Le, $e) | 0, M = M + Math.imul(Le, Xe) | 0, N = N + Math.imul(re, q) | 0, p = p + Math.imul(re, ce) | 0, p = p + Math.imul(fe, q) | 0, M = M + Math.imul(fe, ce) | 0, N = N + Math.imul(ne, me) | 0, p = p + Math.imul(ne, De) | 0, p = p + Math.imul(ue, me) | 0, M = M + Math.imul(ue, De) | 0, N = N + Math.imul(te, ye) | 0, p = p + Math.imul(te, Ae) | 0, p = p + Math.imul(ae, ye) | 0, M = M + Math.imul(ae, Ae) | 0, N = N + Math.imul(U, be) | 0, p = p + Math.imul(U, ke) | 0, p = p + Math.imul(H, be) | 0, M = M + Math.imul(H, ke) | 0;
      var ot = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (ot >>> 26) | 0, ot &= 67108863, N = Math.imul(ie, xe), p = Math.imul(ie, Ye), p = p + Math.imul(se, xe) | 0, M = Math.imul(se, Ye), N = N + Math.imul(Y, Ce) | 0, p = p + Math.imul(Y, Qe) | 0, p = p + Math.imul(Q, Ce) | 0, M = M + Math.imul(Q, Qe) | 0, N = N + Math.imul(Se, Pe) | 0, p = p + Math.imul(Se, He) | 0, p = p + Math.imul(Re, Pe) | 0, M = M + Math.imul(Re, He) | 0, N = N + Math.imul(Te, je) | 0, p = p + Math.imul(Te, We) | 0, p = p + Math.imul(Ne, je) | 0, M = M + Math.imul(Ne, We) | 0, N = N + Math.imul(we, $e) | 0, p = p + Math.imul(we, Xe) | 0, p = p + Math.imul(Ue, $e) | 0, M = M + Math.imul(Ue, Xe) | 0, N = N + Math.imul(ve, q) | 0, p = p + Math.imul(ve, ce) | 0, p = p + Math.imul(Le, q) | 0, M = M + Math.imul(Le, ce) | 0, N = N + Math.imul(re, me) | 0, p = p + Math.imul(re, De) | 0, p = p + Math.imul(fe, me) | 0, M = M + Math.imul(fe, De) | 0, N = N + Math.imul(ne, ye) | 0, p = p + Math.imul(ne, Ae) | 0, p = p + Math.imul(ue, ye) | 0, M = M + Math.imul(ue, Ae) | 0, N = N + Math.imul(te, be) | 0, p = p + Math.imul(te, ke) | 0, p = p + Math.imul(ae, be) | 0, M = M + Math.imul(ae, ke) | 0;
      var lt = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, N = Math.imul(ie, Ce), p = Math.imul(ie, Qe), p = p + Math.imul(se, Ce) | 0, M = Math.imul(se, Qe), N = N + Math.imul(Y, Pe) | 0, p = p + Math.imul(Y, He) | 0, p = p + Math.imul(Q, Pe) | 0, M = M + Math.imul(Q, He) | 0, N = N + Math.imul(Se, je) | 0, p = p + Math.imul(Se, We) | 0, p = p + Math.imul(Re, je) | 0, M = M + Math.imul(Re, We) | 0, N = N + Math.imul(Te, $e) | 0, p = p + Math.imul(Te, Xe) | 0, p = p + Math.imul(Ne, $e) | 0, M = M + Math.imul(Ne, Xe) | 0, N = N + Math.imul(we, q) | 0, p = p + Math.imul(we, ce) | 0, p = p + Math.imul(Ue, q) | 0, M = M + Math.imul(Ue, ce) | 0, N = N + Math.imul(ve, me) | 0, p = p + Math.imul(ve, De) | 0, p = p + Math.imul(Le, me) | 0, M = M + Math.imul(Le, De) | 0, N = N + Math.imul(re, ye) | 0, p = p + Math.imul(re, Ae) | 0, p = p + Math.imul(fe, ye) | 0, M = M + Math.imul(fe, Ae) | 0, N = N + Math.imul(ne, be) | 0, p = p + Math.imul(ne, ke) | 0, p = p + Math.imul(ue, be) | 0, M = M + Math.imul(ue, ke) | 0;
      var ft = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, N = Math.imul(ie, Pe), p = Math.imul(ie, He), p = p + Math.imul(se, Pe) | 0, M = Math.imul(se, He), N = N + Math.imul(Y, je) | 0, p = p + Math.imul(Y, We) | 0, p = p + Math.imul(Q, je) | 0, M = M + Math.imul(Q, We) | 0, N = N + Math.imul(Se, $e) | 0, p = p + Math.imul(Se, Xe) | 0, p = p + Math.imul(Re, $e) | 0, M = M + Math.imul(Re, Xe) | 0, N = N + Math.imul(Te, q) | 0, p = p + Math.imul(Te, ce) | 0, p = p + Math.imul(Ne, q) | 0, M = M + Math.imul(Ne, ce) | 0, N = N + Math.imul(we, me) | 0, p = p + Math.imul(we, De) | 0, p = p + Math.imul(Ue, me) | 0, M = M + Math.imul(Ue, De) | 0, N = N + Math.imul(ve, ye) | 0, p = p + Math.imul(ve, Ae) | 0, p = p + Math.imul(Le, ye) | 0, M = M + Math.imul(Le, Ae) | 0, N = N + Math.imul(re, be) | 0, p = p + Math.imul(re, ke) | 0, p = p + Math.imul(fe, be) | 0, M = M + Math.imul(fe, ke) | 0;
      var ct = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, N = Math.imul(ie, je), p = Math.imul(ie, We), p = p + Math.imul(se, je) | 0, M = Math.imul(se, We), N = N + Math.imul(Y, $e) | 0, p = p + Math.imul(Y, Xe) | 0, p = p + Math.imul(Q, $e) | 0, M = M + Math.imul(Q, Xe) | 0, N = N + Math.imul(Se, q) | 0, p = p + Math.imul(Se, ce) | 0, p = p + Math.imul(Re, q) | 0, M = M + Math.imul(Re, ce) | 0, N = N + Math.imul(Te, me) | 0, p = p + Math.imul(Te, De) | 0, p = p + Math.imul(Ne, me) | 0, M = M + Math.imul(Ne, De) | 0, N = N + Math.imul(we, ye) | 0, p = p + Math.imul(we, Ae) | 0, p = p + Math.imul(Ue, ye) | 0, M = M + Math.imul(Ue, Ae) | 0, N = N + Math.imul(ve, be) | 0, p = p + Math.imul(ve, ke) | 0, p = p + Math.imul(Le, be) | 0, M = M + Math.imul(Le, ke) | 0;
      var ut = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (ut >>> 26) | 0, ut &= 67108863, N = Math.imul(ie, $e), p = Math.imul(ie, Xe), p = p + Math.imul(se, $e) | 0, M = Math.imul(se, Xe), N = N + Math.imul(Y, q) | 0, p = p + Math.imul(Y, ce) | 0, p = p + Math.imul(Q, q) | 0, M = M + Math.imul(Q, ce) | 0, N = N + Math.imul(Se, me) | 0, p = p + Math.imul(Se, De) | 0, p = p + Math.imul(Re, me) | 0, M = M + Math.imul(Re, De) | 0, N = N + Math.imul(Te, ye) | 0, p = p + Math.imul(Te, Ae) | 0, p = p + Math.imul(Ne, ye) | 0, M = M + Math.imul(Ne, Ae) | 0, N = N + Math.imul(we, be) | 0, p = p + Math.imul(we, ke) | 0, p = p + Math.imul(Ue, be) | 0, M = M + Math.imul(Ue, ke) | 0;
      var ht = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, N = Math.imul(ie, q), p = Math.imul(ie, ce), p = p + Math.imul(se, q) | 0, M = Math.imul(se, ce), N = N + Math.imul(Y, me) | 0, p = p + Math.imul(Y, De) | 0, p = p + Math.imul(Q, me) | 0, M = M + Math.imul(Q, De) | 0, N = N + Math.imul(Se, ye) | 0, p = p + Math.imul(Se, Ae) | 0, p = p + Math.imul(Re, ye) | 0, M = M + Math.imul(Re, Ae) | 0, N = N + Math.imul(Te, be) | 0, p = p + Math.imul(Te, ke) | 0, p = p + Math.imul(Ne, be) | 0, M = M + Math.imul(Ne, ke) | 0;
      var dt = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, N = Math.imul(ie, me), p = Math.imul(ie, De), p = p + Math.imul(se, me) | 0, M = Math.imul(se, De), N = N + Math.imul(Y, ye) | 0, p = p + Math.imul(Y, Ae) | 0, p = p + Math.imul(Q, ye) | 0, M = M + Math.imul(Q, Ae) | 0, N = N + Math.imul(Se, be) | 0, p = p + Math.imul(Se, ke) | 0, p = p + Math.imul(Re, be) | 0, M = M + Math.imul(Re, ke) | 0;
      var pt = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, N = Math.imul(ie, ye), p = Math.imul(ie, Ae), p = p + Math.imul(se, ye) | 0, M = Math.imul(se, Ae), N = N + Math.imul(Y, be) | 0, p = p + Math.imul(Y, ke) | 0, p = p + Math.imul(Q, be) | 0, M = M + Math.imul(Q, ke) | 0;
      var mt = (I + N | 0) + ((p & 8191) << 13) | 0;
      I = (M + (p >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, N = Math.imul(ie, be), p = Math.imul(ie, ke), p = p + Math.imul(se, be) | 0, M = Math.imul(se, ke);
      var gt = (I + N | 0) + ((p & 8191) << 13) | 0;
      return I = (M + (p >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, S[0] = ze, S[1] = Ge, S[2] = tt, S[3] = et, S[4] = rt, S[5] = it, S[6] = nt, S[7] = at, S[8] = st, S[9] = ot, S[10] = lt, S[11] = ft, S[12] = ct, S[13] = ut, S[14] = ht, S[15] = dt, S[16] = pt, S[17] = mt, S[18] = gt, I !== 0 && (S[19] = I, g.length++), g;
    };
    Math.imul || (z = C);
    function R(V, E, T) {
      T.negative = E.negative ^ V.negative, T.length = V.length + E.length;
      for (var g = 0, b = 0, x = 0; x < T.length - 1; x++) {
        var S = b;
        b = 0;
        for (var I = g & 67108863, N = Math.min(x, E.length - 1), p = Math.max(0, x - V.length + 1); p <= N; p++) {
          var M = x - p, j = V.words[M] | 0, U = E.words[p] | 0, H = j * U, J = H & 67108863;
          S = S + (H / 67108864 | 0) | 0, J = J + I | 0, I = J & 67108863, S = S + (J >>> 26) | 0, b += S >>> 26, S &= 67108863;
        }
        T.words[x] = I, g = S, S = b;
      }
      return g !== 0 ? T.words[x] = g : T.length--, T.strip();
    }
    function O(V, E, T) {
      var g = new $();
      return g.mulp(V, E, T);
    }
    o.prototype.mulTo = function(E, T) {
      var g, b = this.length + E.length;
      return this.length === 10 && E.length === 10 ? g = z(this, E, T) : b < 63 ? g = C(this, E, T) : b < 1024 ? g = R(this, E, T) : g = O(this, E, T), g;
    };
    function $(V, E) {
      this.x = V, this.y = E;
    }
    $.prototype.makeRBT = function(E) {
      for (var T = new Array(E), g = o.prototype._countBits(E) - 1, b = 0; b < E; b++)
        T[b] = this.revBin(b, g, E);
      return T;
    }, $.prototype.revBin = function(E, T, g) {
      if (E === 0 || E === g - 1)
        return E;
      for (var b = 0, x = 0; x < T; x++)
        b |= (E & 1) << T - x - 1, E >>= 1;
      return b;
    }, $.prototype.permute = function(E, T, g, b, x, S) {
      for (var I = 0; I < S; I++)
        b[I] = T[E[I]], x[I] = g[E[I]];
    }, $.prototype.transform = function(E, T, g, b, x, S) {
      this.permute(S, E, T, g, b, x);
      for (var I = 1; I < x; I <<= 1)
        for (var N = I << 1, p = Math.cos(2 * Math.PI / N), M = Math.sin(2 * Math.PI / N), j = 0; j < x; j += N)
          for (var U = p, H = M, J = 0; J < I; J++) {
            var te = g[j + J], ae = b[j + J], le = g[j + J + I], ne = b[j + J + I], ue = U * le - H * ne;
            ne = U * ne + H * le, le = ue, g[j + J] = te + le, b[j + J] = ae + ne, g[j + J + I] = te - le, b[j + J + I] = ae - ne, J !== N && (ue = p * U - M * H, H = p * H + M * U, U = ue);
          }
    }, $.prototype.guessLen13b = function(E, T) {
      var g = Math.max(T, E) | 1, b = g & 1, x = 0;
      for (g = g / 2 | 0; g; g = g >>> 1)
        x++;
      return 1 << x + 1 + b;
    }, $.prototype.conjugate = function(E, T, g) {
      if (!(g <= 1))
        for (var b = 0; b < g / 2; b++) {
          var x = E[b];
          E[b] = E[g - b - 1], E[g - b - 1] = x, x = T[b], T[b] = -T[g - b - 1], T[g - b - 1] = -x;
        }
    }, $.prototype.normalize13b = function(E, T) {
      for (var g = 0, b = 0; b < T / 2; b++) {
        var x = Math.round(E[2 * b + 1] / T) * 8192 + Math.round(E[2 * b] / T) + g;
        E[b] = x & 67108863, x < 67108864 ? g = 0 : g = x / 67108864 | 0;
      }
      return E;
    }, $.prototype.convert13b = function(E, T, g, b) {
      for (var x = 0, S = 0; S < T; S++)
        x = x + (E[S] | 0), g[2 * S] = x & 8191, x = x >>> 13, g[2 * S + 1] = x & 8191, x = x >>> 13;
      for (S = 2 * T; S < b; ++S)
        g[S] = 0;
      n(x === 0), n((x & -8192) === 0);
    }, $.prototype.stub = function(E) {
      for (var T = new Array(E), g = 0; g < E; g++)
        T[g] = 0;
      return T;
    }, $.prototype.mulp = function(E, T, g) {
      var b = 2 * this.guessLen13b(E.length, T.length), x = this.makeRBT(b), S = this.stub(b), I = new Array(b), N = new Array(b), p = new Array(b), M = new Array(b), j = new Array(b), U = new Array(b), H = g.words;
      H.length = b, this.convert13b(E.words, E.length, I, b), this.convert13b(T.words, T.length, M, b), this.transform(I, S, N, p, b, x), this.transform(M, S, j, U, b, x);
      for (var J = 0; J < b; J++) {
        var te = N[J] * j[J] - p[J] * U[J];
        p[J] = N[J] * U[J] + p[J] * j[J], N[J] = te;
      }
      return this.conjugate(N, p, b), this.transform(N, p, H, S, b, x), this.conjugate(H, S, b), this.normalize13b(H, b), g.negative = E.negative ^ T.negative, g.length = E.length + T.length, g.strip();
    }, o.prototype.mul = function(E) {
      var T = new o(null);
      return T.words = new Array(this.length + E.length), this.mulTo(E, T);
    }, o.prototype.mulf = function(E) {
      var T = new o(null);
      return T.words = new Array(this.length + E.length), O(this, E, T);
    }, o.prototype.imul = function(E) {
      return this.clone().mulTo(E, this);
    }, o.prototype.imuln = function(E) {
      n(typeof E == "number"), n(E < 67108864);
      for (var T = 0, g = 0; g < this.length; g++) {
        var b = (this.words[g] | 0) * E, x = (b & 67108863) + (T & 67108863);
        T >>= 26, T += b / 67108864 | 0, T += x >>> 26, this.words[g] = x & 67108863;
      }
      return T !== 0 && (this.words[g] = T, this.length++), this;
    }, o.prototype.muln = function(E) {
      return this.clone().imuln(E);
    }, o.prototype.sqr = function() {
      return this.mul(this);
    }, o.prototype.isqr = function() {
      return this.imul(this.clone());
    }, o.prototype.pow = function(E) {
      var T = D(E);
      if (T.length === 0)
        return new o(1);
      for (var g = this, b = 0; b < T.length && T[b] === 0; b++, g = g.sqr())
        ;
      if (++b < T.length)
        for (var x = g.sqr(); b < T.length; b++, x = x.sqr())
          T[b] !== 0 && (g = g.mul(x));
      return g;
    }, o.prototype.iushln = function(E) {
      n(typeof E == "number" && E >= 0);
      var T = E % 26, g = (E - T) / 26, b = 67108863 >>> 26 - T << 26 - T, x;
      if (T !== 0) {
        var S = 0;
        for (x = 0; x < this.length; x++) {
          var I = this.words[x] & b, N = (this.words[x] | 0) - I << T;
          this.words[x] = N | S, S = I >>> 26 - T;
        }
        S && (this.words[x] = S, this.length++);
      }
      if (g !== 0) {
        for (x = this.length - 1; x >= 0; x--)
          this.words[x + g] = this.words[x];
        for (x = 0; x < g; x++)
          this.words[x] = 0;
        this.length += g;
      }
      return this.strip();
    }, o.prototype.ishln = function(E) {
      return n(this.negative === 0), this.iushln(E);
    }, o.prototype.iushrn = function(E, T, g) {
      n(typeof E == "number" && E >= 0);
      var b;
      T ? b = (T - T % 26) / 26 : b = 0;
      var x = E % 26, S = Math.min((E - x) / 26, this.length), I = 67108863 ^ 67108863 >>> x << x, N = g;
      if (b -= S, b = Math.max(0, b), N) {
        for (var p = 0; p < S; p++)
          N.words[p] = this.words[p];
        N.length = S;
      }
      if (S !== 0)
        if (this.length > S)
          for (this.length -= S, p = 0; p < this.length; p++)
            this.words[p] = this.words[p + S];
        else
          this.words[0] = 0, this.length = 1;
      var M = 0;
      for (p = this.length - 1; p >= 0 && (M !== 0 || p >= b); p--) {
        var j = this.words[p] | 0;
        this.words[p] = M << 26 - x | j >>> x, M = j & I;
      }
      return N && M !== 0 && (N.words[N.length++] = M), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, o.prototype.ishrn = function(E, T, g) {
      return n(this.negative === 0), this.iushrn(E, T, g);
    }, o.prototype.shln = function(E) {
      return this.clone().ishln(E);
    }, o.prototype.ushln = function(E) {
      return this.clone().iushln(E);
    }, o.prototype.shrn = function(E) {
      return this.clone().ishrn(E);
    }, o.prototype.ushrn = function(E) {
      return this.clone().iushrn(E);
    }, o.prototype.testn = function(E) {
      n(typeof E == "number" && E >= 0);
      var T = E % 26, g = (E - T) / 26, b = 1 << T;
      if (this.length <= g)
        return !1;
      var x = this.words[g];
      return !!(x & b);
    }, o.prototype.imaskn = function(E) {
      n(typeof E == "number" && E >= 0);
      var T = E % 26, g = (E - T) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= g)
        return this;
      if (T !== 0 && g++, this.length = Math.min(g, this.length), T !== 0) {
        var b = 67108863 ^ 67108863 >>> T << T;
        this.words[this.length - 1] &= b;
      }
      return this.strip();
    }, o.prototype.maskn = function(E) {
      return this.clone().imaskn(E);
    }, o.prototype.iaddn = function(E) {
      return n(typeof E == "number"), n(E < 67108864), E < 0 ? this.isubn(-E) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < E ? (this.words[0] = E - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(E), this.negative = 1, this) : this._iaddn(E);
    }, o.prototype._iaddn = function(E) {
      this.words[0] += E;
      for (var T = 0; T < this.length && this.words[T] >= 67108864; T++)
        this.words[T] -= 67108864, T === this.length - 1 ? this.words[T + 1] = 1 : this.words[T + 1]++;
      return this.length = Math.max(this.length, T + 1), this;
    }, o.prototype.isubn = function(E) {
      if (n(typeof E == "number"), n(E < 67108864), E < 0)
        return this.iaddn(-E);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(E), this.negative = 1, this;
      if (this.words[0] -= E, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var T = 0; T < this.length && this.words[T] < 0; T++)
          this.words[T] += 67108864, this.words[T + 1] -= 1;
      return this.strip();
    }, o.prototype.addn = function(E) {
      return this.clone().iaddn(E);
    }, o.prototype.subn = function(E) {
      return this.clone().isubn(E);
    }, o.prototype.iabs = function() {
      return this.negative = 0, this;
    }, o.prototype.abs = function() {
      return this.clone().iabs();
    }, o.prototype._ishlnsubmul = function(E, T, g) {
      var b = E.length + g, x;
      this._expand(b);
      var S, I = 0;
      for (x = 0; x < E.length; x++) {
        S = (this.words[x + g] | 0) + I;
        var N = (E.words[x] | 0) * T;
        S -= N & 67108863, I = (S >> 26) - (N / 67108864 | 0), this.words[x + g] = S & 67108863;
      }
      for (; x < this.length - g; x++)
        S = (this.words[x + g] | 0) + I, I = S >> 26, this.words[x + g] = S & 67108863;
      if (I === 0)
        return this.strip();
      for (n(I === -1), I = 0, x = 0; x < this.length; x++)
        S = -(this.words[x] | 0) + I, I = S >> 26, this.words[x] = S & 67108863;
      return this.negative = 1, this.strip();
    }, o.prototype._wordDiv = function(E, T) {
      var g = this.length - E.length, b = this.clone(), x = E, S = x.words[x.length - 1] | 0, I = this._countBits(S);
      g = 26 - I, g !== 0 && (x = x.ushln(g), b.iushln(g), S = x.words[x.length - 1] | 0);
      var N = b.length - x.length, p;
      if (T !== "mod") {
        p = new o(null), p.length = N + 1, p.words = new Array(p.length);
        for (var M = 0; M < p.length; M++)
          p.words[M] = 0;
      }
      var j = b.clone()._ishlnsubmul(x, 1, N);
      j.negative === 0 && (b = j, p && (p.words[N] = 1));
      for (var U = N - 1; U >= 0; U--) {
        var H = (b.words[x.length + U] | 0) * 67108864 + (b.words[x.length + U - 1] | 0);
        for (H = Math.min(H / S | 0, 67108863), b._ishlnsubmul(x, H, U); b.negative !== 0; )
          H--, b.negative = 0, b._ishlnsubmul(x, 1, U), b.isZero() || (b.negative ^= 1);
        p && (p.words[U] = H);
      }
      return p && p.strip(), b.strip(), T !== "div" && g !== 0 && b.iushrn(g), { div: p || null, mod: b };
    }, o.prototype.divmod = function(E, T, g) {
      if (n(!E.isZero()), this.isZero())
        return { div: new o(0), mod: new o(0) };
      var b, x, S;
      return this.negative !== 0 && E.negative === 0 ? (S = this.neg().divmod(E, T), T !== "mod" && (b = S.div.neg()), T !== "div" && (x = S.mod.neg(), g && x.negative !== 0 && x.iadd(E)), { div: b, mod: x }) : this.negative === 0 && E.negative !== 0 ? (S = this.divmod(E.neg(), T), T !== "mod" && (b = S.div.neg()), { div: b, mod: S.mod }) : this.negative & E.negative ? (S = this.neg().divmod(E.neg(), T), T !== "div" && (x = S.mod.neg(), g && x.negative !== 0 && x.isub(E)), { div: S.div, mod: x }) : E.length > this.length || this.cmp(E) < 0 ? { div: new o(0), mod: this } : E.length === 1 ? T === "div" ? { div: this.divn(E.words[0]), mod: null } : T === "mod" ? { div: null, mod: new o(this.modn(E.words[0])) } : { div: this.divn(E.words[0]), mod: new o(this.modn(E.words[0])) } : this._wordDiv(E, T);
    }, o.prototype.div = function(E) {
      return this.divmod(E, "div", !1).div;
    }, o.prototype.mod = function(E) {
      return this.divmod(E, "mod", !1).mod;
    }, o.prototype.umod = function(E) {
      return this.divmod(E, "mod", !0).mod;
    }, o.prototype.divRound = function(E) {
      var T = this.divmod(E);
      if (T.mod.isZero())
        return T.div;
      var g = T.div.negative !== 0 ? T.mod.isub(E) : T.mod, b = E.ushrn(1), x = E.andln(1), S = g.cmp(b);
      return S < 0 || x === 1 && S === 0 ? T.div : T.div.negative !== 0 ? T.div.isubn(1) : T.div.iaddn(1);
    }, o.prototype.modn = function(E) {
      n(E <= 67108863);
      for (var T = (1 << 26) % E, g = 0, b = this.length - 1; b >= 0; b--)
        g = (T * g + (this.words[b] | 0)) % E;
      return g;
    }, o.prototype.idivn = function(E) {
      n(E <= 67108863);
      for (var T = 0, g = this.length - 1; g >= 0; g--) {
        var b = (this.words[g] | 0) + T * 67108864;
        this.words[g] = b / E | 0, T = b % E;
      }
      return this.strip();
    }, o.prototype.divn = function(E) {
      return this.clone().idivn(E);
    }, o.prototype.egcd = function(E) {
      n(E.negative === 0), n(!E.isZero());
      var T = this, g = E.clone();
      T.negative !== 0 ? T = T.umod(E) : T = T.clone();
      for (var b = new o(1), x = new o(0), S = new o(0), I = new o(1), N = 0; T.isEven() && g.isEven(); )
        T.iushrn(1), g.iushrn(1), ++N;
      for (var p = g.clone(), M = T.clone(); !T.isZero(); ) {
        for (var j = 0, U = 1; !(T.words[0] & U) && j < 26; ++j, U <<= 1)
          ;
        if (j > 0)
          for (T.iushrn(j); j-- > 0; )
            (b.isOdd() || x.isOdd()) && (b.iadd(p), x.isub(M)), b.iushrn(1), x.iushrn(1);
        for (var H = 0, J = 1; !(g.words[0] & J) && H < 26; ++H, J <<= 1)
          ;
        if (H > 0)
          for (g.iushrn(H); H-- > 0; )
            (S.isOdd() || I.isOdd()) && (S.iadd(p), I.isub(M)), S.iushrn(1), I.iushrn(1);
        T.cmp(g) >= 0 ? (T.isub(g), b.isub(S), x.isub(I)) : (g.isub(T), S.isub(b), I.isub(x));
      }
      return { a: S, b: I, gcd: g.iushln(N) };
    }, o.prototype._invmp = function(E) {
      n(E.negative === 0), n(!E.isZero());
      var T = this, g = E.clone();
      T.negative !== 0 ? T = T.umod(E) : T = T.clone();
      for (var b = new o(1), x = new o(0), S = g.clone(); T.cmpn(1) > 0 && g.cmpn(1) > 0; ) {
        for (var I = 0, N = 1; !(T.words[0] & N) && I < 26; ++I, N <<= 1)
          ;
        if (I > 0)
          for (T.iushrn(I); I-- > 0; )
            b.isOdd() && b.iadd(S), b.iushrn(1);
        for (var p = 0, M = 1; !(g.words[0] & M) && p < 26; ++p, M <<= 1)
          ;
        if (p > 0)
          for (g.iushrn(p); p-- > 0; )
            x.isOdd() && x.iadd(S), x.iushrn(1);
        T.cmp(g) >= 0 ? (T.isub(g), b.isub(x)) : (g.isub(T), x.isub(b));
      }
      var j;
      return T.cmpn(1) === 0 ? j = b : j = x, j.cmpn(0) < 0 && j.iadd(E), j;
    }, o.prototype.gcd = function(E) {
      if (this.isZero())
        return E.abs();
      if (E.isZero())
        return this.abs();
      var T = this.clone(), g = E.clone();
      T.negative = 0, g.negative = 0;
      for (var b = 0; T.isEven() && g.isEven(); b++)
        T.iushrn(1), g.iushrn(1);
      do {
        for (; T.isEven(); )
          T.iushrn(1);
        for (; g.isEven(); )
          g.iushrn(1);
        var x = T.cmp(g);
        if (x < 0) {
          var S = T;
          T = g, g = S;
        } else if (x === 0 || g.cmpn(1) === 0)
          break;
        T.isub(g);
      } while (!0);
      return g.iushln(b);
    }, o.prototype.invm = function(E) {
      return this.egcd(E).a.umod(E);
    }, o.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, o.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, o.prototype.andln = function(E) {
      return this.words[0] & E;
    }, o.prototype.bincn = function(E) {
      n(typeof E == "number");
      var T = E % 26, g = (E - T) / 26, b = 1 << T;
      if (this.length <= g)
        return this._expand(g + 1), this.words[g] |= b, this;
      for (var x = b, S = g; x !== 0 && S < this.length; S++) {
        var I = this.words[S] | 0;
        I += x, x = I >>> 26, I &= 67108863, this.words[S] = I;
      }
      return x !== 0 && (this.words[S] = x, this.length++), this;
    }, o.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, o.prototype.cmpn = function(E) {
      var T = E < 0;
      if (this.negative !== 0 && !T)
        return -1;
      if (this.negative === 0 && T)
        return 1;
      this.strip();
      var g;
      if (this.length > 1)
        g = 1;
      else {
        T && (E = -E), n(E <= 67108863, "Number is too big");
        var b = this.words[0] | 0;
        g = b === E ? 0 : b < E ? -1 : 1;
      }
      return this.negative !== 0 ? -g | 0 : g;
    }, o.prototype.cmp = function(E) {
      if (this.negative !== 0 && E.negative === 0)
        return -1;
      if (this.negative === 0 && E.negative !== 0)
        return 1;
      var T = this.ucmp(E);
      return this.negative !== 0 ? -T | 0 : T;
    }, o.prototype.ucmp = function(E) {
      if (this.length > E.length)
        return 1;
      if (this.length < E.length)
        return -1;
      for (var T = 0, g = this.length - 1; g >= 0; g--) {
        var b = this.words[g] | 0, x = E.words[g] | 0;
        if (b !== x) {
          b < x ? T = -1 : b > x && (T = 1);
          break;
        }
      }
      return T;
    }, o.prototype.gtn = function(E) {
      return this.cmpn(E) === 1;
    }, o.prototype.gt = function(E) {
      return this.cmp(E) === 1;
    }, o.prototype.gten = function(E) {
      return this.cmpn(E) >= 0;
    }, o.prototype.gte = function(E) {
      return this.cmp(E) >= 0;
    }, o.prototype.ltn = function(E) {
      return this.cmpn(E) === -1;
    }, o.prototype.lt = function(E) {
      return this.cmp(E) === -1;
    }, o.prototype.lten = function(E) {
      return this.cmpn(E) <= 0;
    }, o.prototype.lte = function(E) {
      return this.cmp(E) <= 0;
    }, o.prototype.eqn = function(E) {
      return this.cmpn(E) === 0;
    }, o.prototype.eq = function(E) {
      return this.cmp(E) === 0;
    }, o.red = function(E) {
      return new Z(E);
    }, o.prototype.toRed = function(E) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), E.convertTo(this)._forceRed(E);
    }, o.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, o.prototype._forceRed = function(E) {
      return this.red = E, this;
    }, o.prototype.forceRed = function(E) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(E);
    }, o.prototype.redAdd = function(E) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, E);
    }, o.prototype.redIAdd = function(E) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, E);
    }, o.prototype.redSub = function(E) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, E);
    }, o.prototype.redISub = function(E) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, E);
    }, o.prototype.redShl = function(E) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, E);
    }, o.prototype.redMul = function(E) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, E), this.red.mul(this, E);
    }, o.prototype.redIMul = function(E) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, E), this.red.imul(this, E);
    }, o.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, o.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, o.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, o.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, o.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, o.prototype.redPow = function(E) {
      return n(this.red && !E.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, E);
    };
    var k = { k256: null, p224: null, p192: null, p25519: null };
    function P(V, E) {
      this.name = V, this.p = new o(E, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    P.prototype._tmp = function() {
      var E = new o(null);
      return E.words = new Array(Math.ceil(this.n / 13)), E;
    }, P.prototype.ireduce = function(E) {
      var T = E, g;
      do
        this.split(T, this.tmp), T = this.imulK(T), T = T.iadd(this.tmp), g = T.bitLength();
      while (g > this.n);
      var b = g < this.n ? -1 : T.ucmp(this.p);
      return b === 0 ? (T.words[0] = 0, T.length = 1) : b > 0 ? T.isub(this.p) : T.strip !== void 0 ? T.strip() : T._strip(), T;
    }, P.prototype.split = function(E, T) {
      E.iushrn(this.n, 0, T);
    }, P.prototype.imulK = function(E) {
      return E.imul(this.k);
    };
    function L() {
      P.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    a(L, P), L.prototype.split = function(E, T) {
      for (var g = 4194303, b = Math.min(E.length, 9), x = 0; x < b; x++)
        T.words[x] = E.words[x];
      if (T.length = b, E.length <= 9) {
        E.words[0] = 0, E.length = 1;
        return;
      }
      var S = E.words[9];
      for (T.words[T.length++] = S & g, x = 10; x < E.length; x++) {
        var I = E.words[x] | 0;
        E.words[x - 10] = (I & g) << 4 | S >>> 22, S = I;
      }
      S >>>= 22, E.words[x - 10] = S, S === 0 && E.length > 10 ? E.length -= 10 : E.length -= 9;
    }, L.prototype.imulK = function(E) {
      E.words[E.length] = 0, E.words[E.length + 1] = 0, E.length += 2;
      for (var T = 0, g = 0; g < E.length; g++) {
        var b = E.words[g] | 0;
        T += b * 977, E.words[g] = T & 67108863, T = b * 64 + (T / 67108864 | 0);
      }
      return E.words[E.length - 1] === 0 && (E.length--, E.words[E.length - 1] === 0 && E.length--), E;
    };
    function F() {
      P.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    a(F, P);
    function B() {
      P.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    a(B, P);
    function G() {
      P.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    a(G, P), G.prototype.imulK = function(E) {
      for (var T = 0, g = 0; g < E.length; g++) {
        var b = (E.words[g] | 0) * 19 + T, x = b & 67108863;
        b >>>= 26, E.words[g] = x, T = b;
      }
      return T !== 0 && (E.words[E.length++] = T), E;
    }, o._prime = function(E) {
      if (k[E])
        return k[E];
      var T;
      if (E === "k256")
        T = new L();
      else if (E === "p224")
        T = new F();
      else if (E === "p192")
        T = new B();
      else if (E === "p25519")
        T = new G();
      else
        throw new Error("Unknown prime " + E);
      return k[E] = T, T;
    };
    function Z(V) {
      if (typeof V == "string") {
        var E = o._prime(V);
        this.m = E.p, this.prime = E;
      } else
        n(V.gtn(1), "modulus must be greater than 1"), this.m = V, this.prime = null;
    }
    Z.prototype._verify1 = function(E) {
      n(E.negative === 0, "red works only with positives"), n(E.red, "red works only with red numbers");
    }, Z.prototype._verify2 = function(E, T) {
      n((E.negative | T.negative) === 0, "red works only with positives"), n(E.red && E.red === T.red, "red works only with red numbers");
    }, Z.prototype.imod = function(E) {
      return this.prime ? this.prime.ireduce(E)._forceRed(this) : E.umod(this.m)._forceRed(this);
    }, Z.prototype.neg = function(E) {
      return E.isZero() ? E.clone() : this.m.sub(E)._forceRed(this);
    }, Z.prototype.add = function(E, T) {
      this._verify2(E, T);
      var g = E.add(T);
      return g.cmp(this.m) >= 0 && g.isub(this.m), g._forceRed(this);
    }, Z.prototype.iadd = function(E, T) {
      this._verify2(E, T);
      var g = E.iadd(T);
      return g.cmp(this.m) >= 0 && g.isub(this.m), g;
    }, Z.prototype.sub = function(E, T) {
      this._verify2(E, T);
      var g = E.sub(T);
      return g.cmpn(0) < 0 && g.iadd(this.m), g._forceRed(this);
    }, Z.prototype.isub = function(E, T) {
      this._verify2(E, T);
      var g = E.isub(T);
      return g.cmpn(0) < 0 && g.iadd(this.m), g;
    }, Z.prototype.shl = function(E, T) {
      return this._verify1(E), this.imod(E.ushln(T));
    }, Z.prototype.imul = function(E, T) {
      return this._verify2(E, T), this.imod(E.imul(T));
    }, Z.prototype.mul = function(E, T) {
      return this._verify2(E, T), this.imod(E.mul(T));
    }, Z.prototype.isqr = function(E) {
      return this.imul(E, E.clone());
    }, Z.prototype.sqr = function(E) {
      return this.mul(E, E);
    }, Z.prototype.sqrt = function(E) {
      if (E.isZero())
        return E.clone();
      var T = this.m.andln(3);
      if (n(T % 2 === 1), T === 3) {
        var g = this.m.add(new o(1)).iushrn(2);
        return this.pow(E, g);
      }
      for (var b = this.m.subn(1), x = 0; !b.isZero() && b.andln(1) === 0; )
        x++, b.iushrn(1);
      n(!b.isZero());
      var S = new o(1).toRed(this), I = S.redNeg(), N = this.m.subn(1).iushrn(1), p = this.m.bitLength();
      for (p = new o(2 * p * p).toRed(this); this.pow(p, N).cmp(I) !== 0; )
        p.redIAdd(I);
      for (var M = this.pow(p, b), j = this.pow(E, b.addn(1).iushrn(1)), U = this.pow(E, b), H = x; U.cmp(S) !== 0; ) {
        for (var J = U, te = 0; J.cmp(S) !== 0; te++)
          J = J.redSqr();
        n(te < H);
        var ae = this.pow(M, new o(1).iushln(H - te - 1));
        j = j.redMul(ae), M = ae.redSqr(), U = U.redMul(M), H = te;
      }
      return j;
    }, Z.prototype.invm = function(E) {
      var T = E._invmp(this.m);
      return T.negative !== 0 ? (T.negative = 0, this.imod(T).redNeg()) : this.imod(T);
    }, Z.prototype.pow = function(E, T) {
      if (T.isZero())
        return new o(1).toRed(this);
      if (T.cmpn(1) === 0)
        return E.clone();
      var g = 4, b = new Array(1 << g);
      b[0] = new o(1).toRed(this), b[1] = E;
      for (var x = 2; x < b.length; x++)
        b[x] = this.mul(b[x - 1], E);
      var S = b[0], I = 0, N = 0, p = T.bitLength() % 26;
      for (p === 0 && (p = 26), x = T.length - 1; x >= 0; x--) {
        for (var M = T.words[x], j = p - 1; j >= 0; j--) {
          var U = M >> j & 1;
          if (S !== b[0] && (S = this.sqr(S)), U === 0 && I === 0) {
            N = 0;
            continue;
          }
          I <<= 1, I |= U, N++, !(N !== g && (x !== 0 || j !== 0)) && (S = this.mul(S, b[I]), N = 0, I = 0);
        }
        p = 26;
      }
      return S;
    }, Z.prototype.convertTo = function(E) {
      var T = E.umod(this.m);
      return T === E ? T.clone() : T;
    }, Z.prototype.convertFrom = function(E) {
      var T = E.clone();
      return T.red = null, T;
    }, o.mont = function(E) {
      return new X(E);
    };
    function X(V) {
      Z.call(this, V), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    a(X, Z), X.prototype.convertTo = function(E) {
      return this.imod(E.ushln(this.shift));
    }, X.prototype.convertFrom = function(E) {
      var T = this.imod(E.mul(this.rinv));
      return T.red = null, T;
    }, X.prototype.imul = function(E, T) {
      if (E.isZero() || T.isZero())
        return E.words[0] = 0, E.length = 1, E;
      var g = E.imul(T), b = g.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), x = g.isub(b).iushrn(this.shift), S = x;
      return x.cmp(this.m) >= 0 ? S = x.isub(this.m) : x.cmpn(0) < 0 && (S = x.iadd(this.m)), S._forceRed(this);
    }, X.prototype.mul = function(E, T) {
      if (E.isZero() || T.isZero())
        return new o(0)._forceRed(this);
      var g = E.mul(T), b = g.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), x = g.isub(b).iushrn(this.shift), S = x;
      return x.cmp(this.m) >= 0 ? S = x.isub(this.m) : x.cmpn(0) < 0 && (S = x.iadd(this.m)), S._forceRed(this);
    }, X.prototype.invm = function(E) {
      var T = this.imod(E._invmp(this.m).mul(this.r2));
      return T._forceRed(this);
    };
  })(e, commonjsGlobal);
})(bn$1);
var utils$b = {};
(function(e) {
  var t = e;
  function i(o, l) {
    if (Array.isArray(o))
      return o.slice();
    if (!o)
      return [];
    var c = [];
    if (typeof o != "string") {
      for (var d = 0; d < o.length; d++)
        c[d] = o[d] | 0;
      return c;
    }
    if (l === "hex") {
      o = o.replace(/[^a-z0-9]+/ig, ""), o.length % 2 !== 0 && (o = "0" + o);
      for (var d = 0; d < o.length; d += 2)
        c.push(parseInt(o[d] + o[d + 1], 16));
    } else
      for (var d = 0; d < o.length; d++) {
        var u = o.charCodeAt(d), m = u >> 8, A = u & 255;
        m ? c.push(m, A) : c.push(A);
      }
    return c;
  }
  t.toArray = i;
  function n(o) {
    return o.length === 1 ? "0" + o : o;
  }
  t.zero2 = n;
  function a(o) {
    for (var l = "", c = 0; c < o.length; c++)
      l += n(o[c].toString(16));
    return l;
  }
  t.toHex = a, t.encode = function(l, c) {
    return c === "hex" ? a(l) : l;
  };
})(utils$b);
(function(e) {
  var t = e, i = bnExports$1, n = minimalisticAssert, a = utils$b;
  t.assert = n, t.toArray = a.toArray, t.zero2 = a.zero2, t.toHex = a.toHex, t.encode = a.encode;
  function o(m, A, y) {
    var D = new Array(Math.max(m.bitLength(), y) + 1);
    D.fill(0);
    for (var C = 1 << A + 1, z = m.clone(), R = 0; R < D.length; R++) {
      var O, $ = z.andln(C - 1);
      z.isOdd() ? ($ > (C >> 1) - 1 ? O = (C >> 1) - $ : O = $, z.isubn(O)) : O = 0, D[R] = O, z.iushrn(1);
    }
    return D;
  }
  t.getNAF = o;
  function l(m, A) {
    var y = [[], []];
    m = m.clone(), A = A.clone();
    for (var D = 0, C = 0, z; m.cmpn(-D) > 0 || A.cmpn(-C) > 0; ) {
      var R = m.andln(3) + D & 3, O = A.andln(3) + C & 3;
      R === 3 && (R = -1), O === 3 && (O = -1);
      var $;
      R & 1 ? (z = m.andln(7) + D & 7, (z === 3 || z === 5) && O === 2 ? $ = -R : $ = R) : $ = 0, y[0].push($);
      var k;
      O & 1 ? (z = A.andln(7) + C & 7, (z === 3 || z === 5) && R === 2 ? k = -O : k = O) : k = 0, y[1].push(k), 2 * D === $ + 1 && (D = 1 - D), 2 * C === k + 1 && (C = 1 - C), m.iushrn(1), A.iushrn(1);
    }
    return y;
  }
  t.getJSF = l;
  function c(m, A, y) {
    var D = "_" + A;
    m.prototype[A] = function() {
      return this[D] !== void 0 ? this[D] : this[D] = y.call(this);
    };
  }
  t.cachedProperty = c;
  function d(m) {
    return typeof m == "string" ? t.toArray(m, "hex") : m;
  }
  t.parseBytes = d;
  function u(m) {
    return new i(m, "hex", "le");
  }
  t.intFromLE = u;
})(utils$c);
var brorandExports = {}, brorand = { get exports() {
  return brorandExports;
}, set exports(e) {
  brorandExports = e;
} }, r;
brorand.exports = function(t) {
  return r || (r = new Rand(null)), r.generate(t);
};
function Rand(e) {
  this.rand = e;
}
brorandExports.Rand = Rand;
Rand.prototype.generate = function(t) {
  return this._rand(t);
};
Rand.prototype._rand = function(t) {
  if (this.rand.getBytes)
    return this.rand.getBytes(t);
  for (var i = new Uint8Array(t), n = 0; n < i.length; n++)
    i[n] = this.rand.getByte();
  return i;
};
if (typeof self == "object")
  self.crypto && self.crypto.getRandomValues ? Rand.prototype._rand = function(t) {
    var i = new Uint8Array(t);
    return self.crypto.getRandomValues(i), i;
  } : self.msCrypto && self.msCrypto.getRandomValues ? Rand.prototype._rand = function(t) {
    var i = new Uint8Array(t);
    return self.msCrypto.getRandomValues(i), i;
  } : typeof window == "object" && (Rand.prototype._rand = function() {
    throw new Error("Not implemented yet");
  });
else
  try {
    var crypto = require$$0;
    if (typeof crypto.randomBytes != "function")
      throw new Error("Not supported");
    Rand.prototype._rand = function(t) {
      return crypto.randomBytes(t);
    };
  } catch {
  }
var curve = {}, BN$7 = bnExports$1, utils$a = utils$c, getNAF = utils$a.getNAF, getJSF = utils$a.getJSF, assert$9 = utils$a.assert;
function BaseCurve(e, t) {
  this.type = e, this.p = new BN$7(t.p, 16), this.red = t.prime ? BN$7.red(t.prime) : BN$7.mont(this.p), this.zero = new BN$7(0).toRed(this.red), this.one = new BN$7(1).toRed(this.red), this.two = new BN$7(2).toRed(this.red), this.n = t.n && new BN$7(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var i = this.n && this.p.div(this.n);
  !i || i.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base = BaseCurve;
BaseCurve.prototype.point = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function(t, i) {
  assert$9(t.precomputed);
  var n = t._getDoubles(), a = getNAF(i, 1, this._bitLength), o = (1 << n.step + 1) - (n.step % 2 === 0 ? 2 : 1);
  o /= 3;
  var l = [], c, d;
  for (c = 0; c < a.length; c += n.step) {
    d = 0;
    for (var u = c + n.step - 1; u >= c; u--)
      d = (d << 1) + a[u];
    l.push(d);
  }
  for (var m = this.jpoint(null, null, null), A = this.jpoint(null, null, null), y = o; y > 0; y--) {
    for (c = 0; c < l.length; c++)
      d = l[c], d === y ? A = A.mixedAdd(n.points[c]) : d === -y && (A = A.mixedAdd(n.points[c].neg()));
    m = m.add(A);
  }
  return m.toP();
};
BaseCurve.prototype._wnafMul = function(t, i) {
  var n = 4, a = t._getNAFPoints(n);
  n = a.wnd;
  for (var o = a.points, l = getNAF(i, n, this._bitLength), c = this.jpoint(null, null, null), d = l.length - 1; d >= 0; d--) {
    for (var u = 0; d >= 0 && l[d] === 0; d--)
      u++;
    if (d >= 0 && u++, c = c.dblp(u), d < 0)
      break;
    var m = l[d];
    assert$9(m !== 0), t.type === "affine" ? m > 0 ? c = c.mixedAdd(o[m - 1 >> 1]) : c = c.mixedAdd(o[-m - 1 >> 1].neg()) : m > 0 ? c = c.add(o[m - 1 >> 1]) : c = c.add(o[-m - 1 >> 1].neg());
  }
  return t.type === "affine" ? c.toP() : c;
};
BaseCurve.prototype._wnafMulAdd = function(t, i, n, a, o) {
  var l = this._wnafT1, c = this._wnafT2, d = this._wnafT3, u = 0, m, A, y;
  for (m = 0; m < a; m++) {
    y = i[m];
    var D = y._getNAFPoints(t);
    l[m] = D.wnd, c[m] = D.points;
  }
  for (m = a - 1; m >= 1; m -= 2) {
    var C = m - 1, z = m;
    if (l[C] !== 1 || l[z] !== 1) {
      d[C] = getNAF(n[C], l[C], this._bitLength), d[z] = getNAF(n[z], l[z], this._bitLength), u = Math.max(d[C].length, u), u = Math.max(d[z].length, u);
      continue;
    }
    var R = [
      i[C],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      i[z]
      /* 7 */
    ];
    i[C].y.cmp(i[z].y) === 0 ? (R[1] = i[C].add(i[z]), R[2] = i[C].toJ().mixedAdd(i[z].neg())) : i[C].y.cmp(i[z].y.redNeg()) === 0 ? (R[1] = i[C].toJ().mixedAdd(i[z]), R[2] = i[C].add(i[z].neg())) : (R[1] = i[C].toJ().mixedAdd(i[z]), R[2] = i[C].toJ().mixedAdd(i[z].neg()));
    var O = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], $ = getJSF(n[C], n[z]);
    for (u = Math.max($[0].length, u), d[C] = new Array(u), d[z] = new Array(u), A = 0; A < u; A++) {
      var k = $[0][A] | 0, P = $[1][A] | 0;
      d[C][A] = O[(k + 1) * 3 + (P + 1)], d[z][A] = 0, c[C] = R;
    }
  }
  var L = this.jpoint(null, null, null), F = this._wnafT4;
  for (m = u; m >= 0; m--) {
    for (var B = 0; m >= 0; ) {
      var G = !0;
      for (A = 0; A < a; A++)
        F[A] = d[A][m] | 0, F[A] !== 0 && (G = !1);
      if (!G)
        break;
      B++, m--;
    }
    if (m >= 0 && B++, L = L.dblp(B), m < 0)
      break;
    for (A = 0; A < a; A++) {
      var Z = F[A];
      Z !== 0 && (Z > 0 ? y = c[A][Z - 1 >> 1] : Z < 0 && (y = c[A][-Z - 1 >> 1].neg()), y.type === "affine" ? L = L.mixedAdd(y) : L = L.add(y));
    }
  }
  for (m = 0; m < a; m++)
    c[m] = null;
  return o ? L : L.toP();
};
function BasePoint(e, t) {
  this.curve = e, this.type = t, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function(t, i) {
  t = utils$a.toArray(t, i);
  var n = this.p.byteLength();
  if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 === 2 * n) {
    t[0] === 6 ? assert$9(t[t.length - 1] % 2 === 0) : t[0] === 7 && assert$9(t[t.length - 1] % 2 === 1);
    var a = this.point(t.slice(1, 1 + n), t.slice(1 + n, 1 + 2 * n));
    return a;
  } else if ((t[0] === 2 || t[0] === 3) && t.length - 1 === n)
    return this.pointFromX(t.slice(1, 1 + n), t[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function(t) {
  return this.encode(t, !0);
};
BasePoint.prototype._encode = function(t) {
  var i = this.curve.p.byteLength(), n = this.getX().toArray("be", i);
  return t ? [this.getY().isEven() ? 2 : 3].concat(n) : [4].concat(n, this.getY().toArray("be", i));
};
BasePoint.prototype.encode = function(t, i) {
  return utils$a.encode(this._encode(i), t);
};
BasePoint.prototype.precompute = function(t) {
  if (this.precomputed)
    return this;
  var i = { doubles: null, naf: null, beta: null };
  return i.naf = this._getNAFPoints(8), i.doubles = this._getDoubles(4, t), i.beta = this._getBeta(), this.precomputed = i, this;
};
BasePoint.prototype._hasDoubles = function(t) {
  if (!this.precomputed)
    return !1;
  var i = this.precomputed.doubles;
  return i ? i.points.length >= Math.ceil((t.bitLength() + 1) / i.step) : !1;
};
BasePoint.prototype._getDoubles = function(t, i) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var n = [this], a = this, o = 0; o < i; o += t) {
    for (var l = 0; l < t; l++)
      a = a.dbl();
    n.push(a);
  }
  return { step: t, points: n };
};
BasePoint.prototype._getNAFPoints = function(t) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var i = [this], n = (1 << t) - 1, a = n === 1 ? null : this.dbl(), o = 1; o < n; o++)
    i[o] = i[o - 1].add(a);
  return { wnd: t, points: i };
};
BasePoint.prototype._getBeta = function() {
  return null;
};
BasePoint.prototype.dblp = function(t) {
  for (var i = this, n = 0; n < t; n++)
    i = i.dbl();
  return i;
};
var utils$9 = utils$c, BN$6 = bnExports$1, inherits$2 = inherits_browserExports, Base$2 = base, assert$8 = utils$9.assert;
function ShortCurve(e) {
  Base$2.call(this, "short", e), this.a = new BN$6(e.a, 16).toRed(this.red), this.b = new BN$6(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$2(ShortCurve, Base$2);
var short = ShortCurve;
ShortCurve.prototype._getEndomorphism = function(t) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var i, n;
    if (t.beta)
      i = new BN$6(t.beta, 16).toRed(this.red);
    else {
      var a = this._getEndoRoots(this.p);
      i = a[0].cmp(a[1]) < 0 ? a[0] : a[1], i = i.toRed(this.red);
    }
    if (t.lambda)
      n = new BN$6(t.lambda, 16);
    else {
      var o = this._getEndoRoots(this.n);
      this.g.mul(o[0]).x.cmp(this.g.x.redMul(i)) === 0 ? n = o[0] : (n = o[1], assert$8(this.g.mul(n).x.cmp(this.g.x.redMul(i)) === 0));
    }
    var l;
    return t.basis ? l = t.basis.map(function(c) {
      return { a: new BN$6(c.a, 16), b: new BN$6(c.b, 16) };
    }) : l = this._getEndoBasis(n), { beta: i, lambda: n, basis: l };
  }
};
ShortCurve.prototype._getEndoRoots = function(t) {
  var i = t === this.p ? this.red : BN$6.mont(t), n = new BN$6(2).toRed(i).redInvm(), a = n.redNeg(), o = new BN$6(3).toRed(i).redNeg().redSqrt().redMul(n), l = a.redAdd(o).fromRed(), c = a.redSub(o).fromRed();
  return [l, c];
};
ShortCurve.prototype._getEndoBasis = function(t) {
  for (var i = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), n = t, a = this.n.clone(), o = new BN$6(1), l = new BN$6(0), c = new BN$6(0), d = new BN$6(1), u, m, A, y, D, C, z, R = 0, O, $; n.cmpn(0) !== 0; ) {
    var k = a.div(n);
    O = a.sub(k.mul(n)), $ = c.sub(k.mul(o));
    var P = d.sub(k.mul(l));
    if (!A && O.cmp(i) < 0)
      u = z.neg(), m = o, A = O.neg(), y = $;
    else if (A && ++R === 2)
      break;
    z = O, a = n, n = O, c = o, o = $, d = l, l = P;
  }
  D = O.neg(), C = $;
  var L = A.sqr().add(y.sqr()), F = D.sqr().add(C.sqr());
  return F.cmp(L) >= 0 && (D = u, C = m), A.negative && (A = A.neg(), y = y.neg()), D.negative && (D = D.neg(), C = C.neg()), [{ a: A, b: y }, { a: D, b: C }];
};
ShortCurve.prototype._endoSplit = function(t) {
  var i = this.endo.basis, n = i[0], a = i[1], o = a.b.mul(t).divRound(this.n), l = n.b.neg().mul(t).divRound(this.n), c = o.mul(n.a), d = l.mul(a.a), u = o.mul(n.b), m = l.mul(a.b), A = t.sub(c).sub(d), y = u.add(m).neg();
  return { k1: A, k2: y };
};
ShortCurve.prototype.pointFromX = function(t, i) {
  t = new BN$6(t, 16), t.red || (t = t.toRed(this.red));
  var n = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b), a = n.redSqrt();
  if (a.redSqr().redSub(n).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var o = a.fromRed().isOdd();
  return (i && !o || !i && o) && (a = a.redNeg()), this.point(t, a);
};
ShortCurve.prototype.validate = function(t) {
  if (t.inf)
    return !0;
  var i = t.x, n = t.y, a = this.a.redMul(i), o = i.redSqr().redMul(i).redIAdd(a).redIAdd(this.b);
  return n.redSqr().redISub(o).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function(t, i, n) {
  for (var a = this._endoWnafT1, o = this._endoWnafT2, l = 0; l < t.length; l++) {
    var c = this._endoSplit(i[l]), d = t[l], u = d._getBeta();
    c.k1.negative && (c.k1.ineg(), d = d.neg(!0)), c.k2.negative && (c.k2.ineg(), u = u.neg(!0)), a[l * 2] = d, a[l * 2 + 1] = u, o[l * 2] = c.k1, o[l * 2 + 1] = c.k2;
  }
  for (var m = this._wnafMulAdd(1, a, o, l * 2, n), A = 0; A < l * 2; A++)
    a[A] = null, o[A] = null;
  return m;
};
function Point$2(e, t, i, n) {
  Base$2.BasePoint.call(this, e, "affine"), t === null && i === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$6(t, 16), this.y = new BN$6(i, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$2(Point$2, Base$2.BasePoint);
ShortCurve.prototype.point = function(t, i, n) {
  return new Point$2(this, t, i, n);
};
ShortCurve.prototype.pointFromJSON = function(t, i) {
  return Point$2.fromJSON(this, t, i);
};
Point$2.prototype._getBeta = function() {
  if (this.curve.endo) {
    var t = this.precomputed;
    if (t && t.beta)
      return t.beta;
    var i = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (t) {
      var n = this.curve, a = function(o) {
        return n.point(o.x.redMul(n.endo.beta), o.y);
      };
      t.beta = i, i.precomputed = { beta: null, naf: t.naf && { wnd: t.naf.wnd, points: t.naf.points.map(a) }, doubles: t.doubles && { step: t.doubles.step, points: t.doubles.points.map(a) } };
    }
    return i;
  }
};
Point$2.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && { doubles: this.precomputed.doubles && { step: this.precomputed.doubles.step, points: this.precomputed.doubles.points.slice(1) }, naf: this.precomputed.naf && { wnd: this.precomputed.naf.wnd, points: this.precomputed.naf.points.slice(1) } }] : [this.x, this.y];
};
Point$2.fromJSON = function(t, i, n) {
  typeof i == "string" && (i = JSON.parse(i));
  var a = t.point(i[0], i[1], n);
  if (!i[2])
    return a;
  function o(c) {
    return t.point(c[0], c[1], n);
  }
  var l = i[2];
  return a.precomputed = { beta: null, doubles: l.doubles && { step: l.doubles.step, points: [a].concat(l.doubles.points.map(o)) }, naf: l.naf && { wnd: l.naf.wnd, points: [a].concat(l.naf.points.map(o)) } }, a;
};
Point$2.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$2.prototype.isInfinity = function() {
  return this.inf;
};
Point$2.prototype.add = function(t) {
  if (this.inf)
    return t;
  if (t.inf)
    return this;
  if (this.eq(t))
    return this.dbl();
  if (this.neg().eq(t))
    return this.curve.point(null, null);
  if (this.x.cmp(t.x) === 0)
    return this.curve.point(null, null);
  var i = this.y.redSub(t.y);
  i.cmpn(0) !== 0 && (i = i.redMul(this.x.redSub(t.x).redInvm()));
  var n = i.redSqr().redISub(this.x).redISub(t.x), a = i.redMul(this.x.redSub(n)).redISub(this.y);
  return this.curve.point(n, a);
};
Point$2.prototype.dbl = function() {
  if (this.inf)
    return this;
  var t = this.y.redAdd(this.y);
  if (t.cmpn(0) === 0)
    return this.curve.point(null, null);
  var i = this.curve.a, n = this.x.redSqr(), a = t.redInvm(), o = n.redAdd(n).redIAdd(n).redIAdd(i).redMul(a), l = o.redSqr().redISub(this.x.redAdd(this.x)), c = o.redMul(this.x.redSub(l)).redISub(this.y);
  return this.curve.point(l, c);
};
Point$2.prototype.getX = function() {
  return this.x.fromRed();
};
Point$2.prototype.getY = function() {
  return this.y.fromRed();
};
Point$2.prototype.mul = function(t) {
  return t = new BN$6(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [t]) : this.curve._wnafMul(this, t);
};
Point$2.prototype.mulAdd = function(t, i, n) {
  var a = [this, i], o = [t, n];
  return this.curve.endo ? this.curve._endoWnafMulAdd(a, o) : this.curve._wnafMulAdd(1, a, o, 2);
};
Point$2.prototype.jmulAdd = function(t, i, n) {
  var a = [this, i], o = [t, n];
  return this.curve.endo ? this.curve._endoWnafMulAdd(a, o, !0) : this.curve._wnafMulAdd(1, a, o, 2, !0);
};
Point$2.prototype.eq = function(t) {
  return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
};
Point$2.prototype.neg = function(t) {
  if (this.inf)
    return this;
  var i = this.curve.point(this.x, this.y.redNeg());
  if (t && this.precomputed) {
    var n = this.precomputed, a = function(o) {
      return o.neg();
    };
    i.precomputed = { naf: n.naf && { wnd: n.naf.wnd, points: n.naf.points.map(a) }, doubles: n.doubles && { step: n.doubles.step, points: n.doubles.points.map(a) } };
  }
  return i;
};
Point$2.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var t = this.curve.jpoint(this.x, this.y, this.curve.one);
  return t;
};
function JPoint(e, t, i, n) {
  Base$2.BasePoint.call(this, e, "jacobian"), t === null && i === null && n === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$6(0)) : (this.x = new BN$6(t, 16), this.y = new BN$6(i, 16), this.z = new BN$6(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$2(JPoint, Base$2.BasePoint);
ShortCurve.prototype.jpoint = function(t, i, n) {
  return new JPoint(this, t, i, n);
};
JPoint.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var t = this.z.redInvm(), i = t.redSqr(), n = this.x.redMul(i), a = this.y.redMul(i).redMul(t);
  return this.curve.point(n, a);
};
JPoint.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function(t) {
  if (this.isInfinity())
    return t;
  if (t.isInfinity())
    return this;
  var i = t.z.redSqr(), n = this.z.redSqr(), a = this.x.redMul(i), o = t.x.redMul(n), l = this.y.redMul(i.redMul(t.z)), c = t.y.redMul(n.redMul(this.z)), d = a.redSub(o), u = l.redSub(c);
  if (d.cmpn(0) === 0)
    return u.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var m = d.redSqr(), A = m.redMul(d), y = a.redMul(m), D = u.redSqr().redIAdd(A).redISub(y).redISub(y), C = u.redMul(y.redISub(D)).redISub(l.redMul(A)), z = this.z.redMul(t.z).redMul(d);
  return this.curve.jpoint(D, C, z);
};
JPoint.prototype.mixedAdd = function(t) {
  if (this.isInfinity())
    return t.toJ();
  if (t.isInfinity())
    return this;
  var i = this.z.redSqr(), n = this.x, a = t.x.redMul(i), o = this.y, l = t.y.redMul(i).redMul(this.z), c = n.redSub(a), d = o.redSub(l);
  if (c.cmpn(0) === 0)
    return d.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var u = c.redSqr(), m = u.redMul(c), A = n.redMul(u), y = d.redSqr().redIAdd(m).redISub(A).redISub(A), D = d.redMul(A.redISub(y)).redISub(o.redMul(m)), C = this.z.redMul(c);
  return this.curve.jpoint(y, D, C);
};
JPoint.prototype.dblp = function(t) {
  if (t === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!t)
    return this.dbl();
  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var n = this;
    for (i = 0; i < t; i++)
      n = n.dbl();
    return n;
  }
  var a = this.curve.a, o = this.curve.tinv, l = this.x, c = this.y, d = this.z, u = d.redSqr().redSqr(), m = c.redAdd(c);
  for (i = 0; i < t; i++) {
    var A = l.redSqr(), y = m.redSqr(), D = y.redSqr(), C = A.redAdd(A).redIAdd(A).redIAdd(a.redMul(u)), z = l.redMul(y), R = C.redSqr().redISub(z.redAdd(z)), O = z.redISub(R), $ = C.redMul(O);
    $ = $.redIAdd($).redISub(D);
    var k = m.redMul(d);
    i + 1 < t && (u = u.redMul(D)), l = R, d = k, m = $;
  }
  return this.curve.jpoint(l, m.redMul(o), d);
};
JPoint.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function() {
  var t, i, n;
  if (this.zOne) {
    var a = this.x.redSqr(), o = this.y.redSqr(), l = o.redSqr(), c = this.x.redAdd(o).redSqr().redISub(a).redISub(l);
    c = c.redIAdd(c);
    var d = a.redAdd(a).redIAdd(a), u = d.redSqr().redISub(c).redISub(c), m = l.redIAdd(l);
    m = m.redIAdd(m), m = m.redIAdd(m), t = u, i = d.redMul(c.redISub(u)).redISub(m), n = this.y.redAdd(this.y);
  } else {
    var A = this.x.redSqr(), y = this.y.redSqr(), D = y.redSqr(), C = this.x.redAdd(y).redSqr().redISub(A).redISub(D);
    C = C.redIAdd(C);
    var z = A.redAdd(A).redIAdd(A), R = z.redSqr(), O = D.redIAdd(D);
    O = O.redIAdd(O), O = O.redIAdd(O), t = R.redISub(C).redISub(C), i = z.redMul(C.redISub(t)).redISub(O), n = this.y.redMul(this.z), n = n.redIAdd(n);
  }
  return this.curve.jpoint(t, i, n);
};
JPoint.prototype._threeDbl = function() {
  var t, i, n;
  if (this.zOne) {
    var a = this.x.redSqr(), o = this.y.redSqr(), l = o.redSqr(), c = this.x.redAdd(o).redSqr().redISub(a).redISub(l);
    c = c.redIAdd(c);
    var d = a.redAdd(a).redIAdd(a).redIAdd(this.curve.a), u = d.redSqr().redISub(c).redISub(c);
    t = u;
    var m = l.redIAdd(l);
    m = m.redIAdd(m), m = m.redIAdd(m), i = d.redMul(c.redISub(u)).redISub(m), n = this.y.redAdd(this.y);
  } else {
    var A = this.z.redSqr(), y = this.y.redSqr(), D = this.x.redMul(y), C = this.x.redSub(A).redMul(this.x.redAdd(A));
    C = C.redAdd(C).redIAdd(C);
    var z = D.redIAdd(D);
    z = z.redIAdd(z);
    var R = z.redAdd(z);
    t = C.redSqr().redISub(R), n = this.y.redAdd(this.z).redSqr().redISub(y).redISub(A);
    var O = y.redSqr();
    O = O.redIAdd(O), O = O.redIAdd(O), O = O.redIAdd(O), i = C.redMul(z.redISub(t)).redISub(O);
  }
  return this.curve.jpoint(t, i, n);
};
JPoint.prototype._dbl = function() {
  var t = this.curve.a, i = this.x, n = this.y, a = this.z, o = a.redSqr().redSqr(), l = i.redSqr(), c = n.redSqr(), d = l.redAdd(l).redIAdd(l).redIAdd(t.redMul(o)), u = i.redAdd(i);
  u = u.redIAdd(u);
  var m = u.redMul(c), A = d.redSqr().redISub(m.redAdd(m)), y = m.redISub(A), D = c.redSqr();
  D = D.redIAdd(D), D = D.redIAdd(D), D = D.redIAdd(D);
  var C = d.redMul(y).redISub(D), z = n.redAdd(n).redMul(a);
  return this.curve.jpoint(A, C, z);
};
JPoint.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var t = this.x.redSqr(), i = this.y.redSqr(), n = this.z.redSqr(), a = i.redSqr(), o = t.redAdd(t).redIAdd(t), l = o.redSqr(), c = this.x.redAdd(i).redSqr().redISub(t).redISub(a);
  c = c.redIAdd(c), c = c.redAdd(c).redIAdd(c), c = c.redISub(l);
  var d = c.redSqr(), u = a.redIAdd(a);
  u = u.redIAdd(u), u = u.redIAdd(u), u = u.redIAdd(u);
  var m = o.redIAdd(c).redSqr().redISub(l).redISub(d).redISub(u), A = i.redMul(m);
  A = A.redIAdd(A), A = A.redIAdd(A);
  var y = this.x.redMul(d).redISub(A);
  y = y.redIAdd(y), y = y.redIAdd(y);
  var D = this.y.redMul(m.redMul(u.redISub(m)).redISub(c.redMul(d)));
  D = D.redIAdd(D), D = D.redIAdd(D), D = D.redIAdd(D);
  var C = this.z.redAdd(c).redSqr().redISub(n).redISub(d);
  return this.curve.jpoint(y, D, C);
};
JPoint.prototype.mul = function(t, i) {
  return t = new BN$6(t, i), this.curve._wnafMul(this, t);
};
JPoint.prototype.eq = function(t) {
  if (t.type === "affine")
    return this.eq(t.toJ());
  if (this === t)
    return !0;
  var i = this.z.redSqr(), n = t.z.redSqr();
  if (this.x.redMul(n).redISub(t.x.redMul(i)).cmpn(0) !== 0)
    return !1;
  var a = i.redMul(this.z), o = n.redMul(t.z);
  return this.y.redMul(o).redISub(t.y.redMul(a)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function(t) {
  var i = this.z.redSqr(), n = t.toRed(this.curve.red).redMul(i);
  if (this.x.cmp(n) === 0)
    return !0;
  for (var a = t.clone(), o = this.curve.redN.redMul(i); ; ) {
    if (a.iadd(this.curve.n), a.cmp(this.curve.p) >= 0)
      return !1;
    if (n.redIAdd(o), this.x.cmp(n) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var BN$5 = bnExports$1, inherits$1 = inherits_browserExports, Base$1 = base, utils$8 = utils$c;
function MontCurve(e) {
  Base$1.call(this, "mont", e), this.a = new BN$5(e.a, 16).toRed(this.red), this.b = new BN$5(e.b, 16).toRed(this.red), this.i4 = new BN$5(4).toRed(this.red).redInvm(), this.two = new BN$5(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$1(MontCurve, Base$1);
var mont = MontCurve;
MontCurve.prototype.validate = function(t) {
  var i = t.normalize().x, n = i.redSqr(), a = n.redMul(i).redAdd(n.redMul(this.a)).redAdd(i), o = a.redSqrt();
  return o.redSqr().cmp(a) === 0;
};
function Point$1(e, t, i) {
  Base$1.BasePoint.call(this, e, "projective"), t === null && i === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$5(t, 16), this.z = new BN$5(i, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$1(Point$1, Base$1.BasePoint);
MontCurve.prototype.decodePoint = function(t, i) {
  return this.point(utils$8.toArray(t, i), 1);
};
MontCurve.prototype.point = function(t, i) {
  return new Point$1(this, t, i);
};
MontCurve.prototype.pointFromJSON = function(t) {
  return Point$1.fromJSON(this, t);
};
Point$1.prototype.precompute = function() {
};
Point$1.prototype._encode = function() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$1.fromJSON = function(t, i) {
  return new Point$1(t, i[0], i[1] || t.one);
};
Point$1.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$1.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
Point$1.prototype.dbl = function() {
  var t = this.x.redAdd(this.z), i = t.redSqr(), n = this.x.redSub(this.z), a = n.redSqr(), o = i.redSub(a), l = i.redMul(a), c = o.redMul(a.redAdd(this.curve.a24.redMul(o)));
  return this.curve.point(l, c);
};
Point$1.prototype.add = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.diffAdd = function(t, i) {
  var n = this.x.redAdd(this.z), a = this.x.redSub(this.z), o = t.x.redAdd(t.z), l = t.x.redSub(t.z), c = l.redMul(n), d = o.redMul(a), u = i.z.redMul(c.redAdd(d).redSqr()), m = i.x.redMul(c.redISub(d).redSqr());
  return this.curve.point(u, m);
};
Point$1.prototype.mul = function(t) {
  for (var i = t.clone(), n = this, a = this.curve.point(null, null), o = this, l = []; i.cmpn(0) !== 0; i.iushrn(1))
    l.push(i.andln(1));
  for (var c = l.length - 1; c >= 0; c--)
    l[c] === 0 ? (n = n.diffAdd(a, o), a = a.dbl()) : (a = n.diffAdd(a, o), n = n.dbl());
  return a;
};
Point$1.prototype.mulAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.jumlAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.eq = function(t) {
  return this.getX().cmp(t.getX()) === 0;
};
Point$1.prototype.normalize = function() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$1.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
var utils$7 = utils$c, BN$4 = bnExports$1, inherits = inherits_browserExports, Base = base, assert$7 = utils$7.assert;
function EdwardsCurve(e) {
  this.twisted = (e.a | 0) !== 1, this.mOneA = this.twisted && (e.a | 0) === -1, this.extended = this.mOneA, Base.call(this, "edwards", e), this.a = new BN$4(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$4(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$4(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$7(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (e.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function(t) {
  return this.mOneA ? t.redNeg() : this.a.redMul(t);
};
EdwardsCurve.prototype._mulC = function(t) {
  return this.oneC ? t : this.c.redMul(t);
};
EdwardsCurve.prototype.jpoint = function(t, i, n, a) {
  return this.point(t, i, n, a);
};
EdwardsCurve.prototype.pointFromX = function(t, i) {
  t = new BN$4(t, 16), t.red || (t = t.toRed(this.red));
  var n = t.redSqr(), a = this.c2.redSub(this.a.redMul(n)), o = this.one.redSub(this.c2.redMul(this.d).redMul(n)), l = a.redMul(o.redInvm()), c = l.redSqrt();
  if (c.redSqr().redSub(l).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var d = c.fromRed().isOdd();
  return (i && !d || !i && d) && (c = c.redNeg()), this.point(t, c);
};
EdwardsCurve.prototype.pointFromY = function(t, i) {
  t = new BN$4(t, 16), t.red || (t = t.toRed(this.red));
  var n = t.redSqr(), a = n.redSub(this.c2), o = n.redMul(this.d).redMul(this.c2).redSub(this.a), l = a.redMul(o.redInvm());
  if (l.cmp(this.zero) === 0) {
    if (i)
      throw new Error("invalid point");
    return this.point(this.zero, t);
  }
  var c = l.redSqrt();
  if (c.redSqr().redSub(l).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return c.fromRed().isOdd() !== i && (c = c.redNeg()), this.point(c, t);
};
EdwardsCurve.prototype.validate = function(t) {
  if (t.isInfinity())
    return !0;
  t.normalize();
  var i = t.x.redSqr(), n = t.y.redSqr(), a = i.redMul(this.a).redAdd(n), o = this.c2.redMul(this.one.redAdd(this.d.redMul(i).redMul(n)));
  return a.cmp(o) === 0;
};
function Point(e, t, i, n, a) {
  Base.BasePoint.call(this, e, "projective"), t === null && i === null && n === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$4(t, 16), this.y = new BN$4(i, 16), this.z = n ? new BN$4(n, 16) : this.curve.one, this.t = a && new BN$4(a, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function(t) {
  return Point.fromJSON(this, t);
};
EdwardsCurve.prototype.point = function(t, i, n, a) {
  return new Point(this, t, i, n, a);
};
Point.fromJSON = function(t, i) {
  return new Point(t, i[0], i[1], i[2]);
};
Point.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function() {
  var t = this.x.redSqr(), i = this.y.redSqr(), n = this.z.redSqr();
  n = n.redIAdd(n);
  var a = this.curve._mulA(t), o = this.x.redAdd(this.y).redSqr().redISub(t).redISub(i), l = a.redAdd(i), c = l.redSub(n), d = a.redSub(i), u = o.redMul(c), m = l.redMul(d), A = o.redMul(d), y = c.redMul(l);
  return this.curve.point(u, m, y, A);
};
Point.prototype._projDbl = function() {
  var t = this.x.redAdd(this.y).redSqr(), i = this.x.redSqr(), n = this.y.redSqr(), a, o, l, c, d, u;
  if (this.curve.twisted) {
    c = this.curve._mulA(i);
    var m = c.redAdd(n);
    this.zOne ? (a = t.redSub(i).redSub(n).redMul(m.redSub(this.curve.two)), o = m.redMul(c.redSub(n)), l = m.redSqr().redSub(m).redSub(m)) : (d = this.z.redSqr(), u = m.redSub(d).redISub(d), a = t.redSub(i).redISub(n).redMul(u), o = m.redMul(c.redSub(n)), l = m.redMul(u));
  } else
    c = i.redAdd(n), d = this.curve._mulC(this.z).redSqr(), u = c.redSub(d).redSub(d), a = this.curve._mulC(t.redISub(c)).redMul(u), o = this.curve._mulC(c).redMul(i.redISub(n)), l = c.redMul(u);
  return this.curve.point(a, o, l);
};
Point.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point.prototype._extAdd = function(t) {
  var i = this.y.redSub(this.x).redMul(t.y.redSub(t.x)), n = this.y.redAdd(this.x).redMul(t.y.redAdd(t.x)), a = this.t.redMul(this.curve.dd).redMul(t.t), o = this.z.redMul(t.z.redAdd(t.z)), l = n.redSub(i), c = o.redSub(a), d = o.redAdd(a), u = n.redAdd(i), m = l.redMul(c), A = d.redMul(u), y = l.redMul(u), D = c.redMul(d);
  return this.curve.point(m, A, D, y);
};
Point.prototype._projAdd = function(t) {
  var i = this.z.redMul(t.z), n = i.redSqr(), a = this.x.redMul(t.x), o = this.y.redMul(t.y), l = this.curve.d.redMul(a).redMul(o), c = n.redSub(l), d = n.redAdd(l), u = this.x.redAdd(this.y).redMul(t.x.redAdd(t.y)).redISub(a).redISub(o), m = i.redMul(c).redMul(u), A, y;
  return this.curve.twisted ? (A = i.redMul(d).redMul(o.redSub(this.curve._mulA(a))), y = c.redMul(d)) : (A = i.redMul(d).redMul(o.redSub(a)), y = this.curve._mulC(c).redMul(d)), this.curve.point(m, A, y);
};
Point.prototype.add = function(t) {
  return this.isInfinity() ? t : t.isInfinity() ? this : this.curve.extended ? this._extAdd(t) : this._projAdd(t);
};
Point.prototype.mul = function(t) {
  return this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve._wnafMul(this, t);
};
Point.prototype.mulAdd = function(t, i, n) {
  return this.curve._wnafMulAdd(1, [this, i], [t, n], 2, !1);
};
Point.prototype.jmulAdd = function(t, i, n) {
  return this.curve._wnafMulAdd(1, [this, i], [t, n], 2, !0);
};
Point.prototype.normalize = function() {
  if (this.zOne)
    return this;
  var t = this.z.redInvm();
  return this.x = this.x.redMul(t), this.y = this.y.redMul(t), this.t && (this.t = this.t.redMul(t)), this.z = this.curve.one, this.zOne = !0, this;
};
Point.prototype.neg = function() {
  return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
Point.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
Point.prototype.getY = function() {
  return this.normalize(), this.y.fromRed();
};
Point.prototype.eq = function(t) {
  return this === t || this.getX().cmp(t.getX()) === 0 && this.getY().cmp(t.getY()) === 0;
};
Point.prototype.eqXToP = function(t) {
  var i = t.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(i) === 0)
    return !0;
  for (var n = t.clone(), a = this.curve.redN.redMul(this.z); ; ) {
    if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0)
      return !1;
    if (i.redIAdd(a), this.x.cmp(i) === 0)
      return !0;
  }
};
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;
(function(e) {
  var t = e;
  t.base = base, t.short = short, t.mont = mont, t.edwards = edwards;
})(curve);
var curves$2 = {}, secp256k1, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1 = { doubles: { step: 4, points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]] }, naf: { wnd: 7, points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]] } }), secp256k1;
}
(function(e) {
  var t = e, i = hash$2, n = curve, a = utils$c, o = a.assert;
  function l(u) {
    u.type === "short" ? this.curve = new n.short(u) : u.type === "edwards" ? this.curve = new n.edwards(u) : this.curve = new n.mont(u), this.g = this.curve.g, this.n = this.curve.n, this.hash = u.hash, o(this.g.validate(), "Invalid curve"), o(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  t.PresetCurve = l;
  function c(u, m) {
    Object.defineProperty(t, u, { configurable: !0, enumerable: !0, get: function() {
      var A = new l(m);
      return Object.defineProperty(t, u, { configurable: !0, enumerable: !0, value: A }), A;
    } });
  }
  c("p192", { type: "short", prime: "p192", p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff", a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc", b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1", n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831", hash: i.sha256, gRed: !1, g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"] }), c("p224", { type: "short", prime: "p224", p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001", a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe", b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4", n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d", hash: i.sha256, gRed: !1, g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"] }), c("p256", { type: "short", prime: null, p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff", a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc", b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b", n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551", hash: i.sha256, gRed: !1, g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"] }), c("p384", { type: "short", prime: null, p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff", a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc", b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef", n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973", hash: i.sha384, gRed: !1, g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"] }), c("p521", { type: "short", prime: null, p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff", a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc", b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00", n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409", hash: i.sha512, gRed: !1, g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"] }), c("curve25519", { type: "mont", prime: "p25519", p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed", a: "76d06", b: "1", n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed", hash: i.sha256, gRed: !1, g: ["9"] }), c("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: i.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var d;
  try {
    d = requireSecp256k1();
  } catch {
    d = void 0;
  }
  c("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: i.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [{ a: "3086d221a7d46bcde86c90e49284eb15", b: "-e4437ed6010e88286f547fa90abfe4c3" }, { a: "114ca50f7a8e2f3f657c1108d9d44cfd8", b: "3086d221a7d46bcde86c90e49284eb15" }],
    gRed: !1,
    g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", d]
  });
})(curves$2);
var hash$1 = hash$2, utils$6 = utils$b, assert$6 = minimalisticAssert;
function HmacDRBG$1(e) {
  if (!(this instanceof HmacDRBG$1))
    return new HmacDRBG$1(e);
  this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var t = utils$6.toArray(e.entropy, e.entropyEnc || "hex"), i = utils$6.toArray(e.nonce, e.nonceEnc || "hex"), n = utils$6.toArray(e.pers, e.persEnc || "hex");
  assert$6(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, i, n);
}
var hmacDrbg = HmacDRBG$1;
HmacDRBG$1.prototype._init = function(t, i, n) {
  var a = t.concat(i).concat(n);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var o = 0; o < this.V.length; o++)
    this.K[o] = 0, this.V[o] = 1;
  this._update(a), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG$1.prototype._hmac = function() {
  return new hash$1.hmac(this.hash, this.K);
};
HmacDRBG$1.prototype._update = function(t) {
  var i = this._hmac().update(this.V).update([0]);
  t && (i = i.update(t)), this.K = i.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([1]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG$1.prototype.reseed = function(t, i, n, a) {
  typeof i != "string" && (a = n, n = i, i = null), t = utils$6.toArray(t, i), n = utils$6.toArray(n, a), assert$6(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(t.concat(n || [])), this._reseed = 1;
};
HmacDRBG$1.prototype.generate = function(t, i, n, a) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof i != "string" && (a = n, n = i, i = null), n && (n = utils$6.toArray(n, a || "hex"), this._update(n));
  for (var o = []; o.length < t; )
    this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
  var l = o.slice(0, t);
  return this._update(n), this._reseed++, utils$6.encode(l, i);
};
var BN$3 = bnExports$1, utils$5 = utils$c, assert$5 = utils$5.assert;
function KeyPair$3(e, t) {
  this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
}
var key$1 = KeyPair$3;
KeyPair$3.fromPublic = function(t, i, n) {
  return i instanceof KeyPair$3 ? i : new KeyPair$3(t, { pub: i, pubEnc: n });
};
KeyPair$3.fromPrivate = function(t, i, n) {
  return i instanceof KeyPair$3 ? i : new KeyPair$3(t, { priv: i, privEnc: n });
};
KeyPair$3.prototype.validate = function() {
  var t = this.getPublic();
  return t.isInfinity() ? { result: !1, reason: "Invalid public key" } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$3.prototype.getPublic = function(t, i) {
  return typeof t == "string" && (i = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), i ? this.pub.encode(i, t) : this.pub;
};
KeyPair$3.prototype.getPrivate = function(t) {
  return t === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$3.prototype._importPrivate = function(t, i) {
  this.priv = new BN$3(t, i || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$3.prototype._importPublic = function(t, i) {
  if (t.x || t.y) {
    this.ec.curve.type === "mont" ? assert$5(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$5(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(t, i);
};
KeyPair$3.prototype.derive = function(t) {
  return t.validate() || assert$5(t.validate(), "public point not validated"), t.mul(this.priv).getX();
};
KeyPair$3.prototype.sign = function(t, i, n) {
  return this.ec.sign(t, this, i, n);
};
KeyPair$3.prototype.verify = function(t, i) {
  return this.ec.verify(t, i, this);
};
KeyPair$3.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$2 = bnExports$1, utils$4 = utils$c, assert$4 = utils$4.assert;
function Signature$4(e, t) {
  if (e instanceof Signature$4)
    return e;
  this._importDER(e, t) || (assert$4(e.r && e.s, "Signature without r or s"), this.r = new BN$2(e.r, 16), this.s = new BN$2(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var signature$1 = Signature$4;
function Position() {
  this.place = 0;
}
function getLength(e, t) {
  var i = e[t.place++];
  if (!(i & 128))
    return i;
  var n = i & 15;
  if (n === 0 || n > 4)
    return !1;
  for (var a = 0, o = 0, l = t.place; o < n; o++, l++)
    a <<= 8, a |= e[l], a >>>= 0;
  return a <= 127 ? !1 : (t.place = l, a);
}
function rmPadding(e) {
  for (var t = 0, i = e.length - 1; !e[t] && !(e[t + 1] & 128) && t < i; )
    t++;
  return t === 0 ? e : e.slice(t);
}
Signature$4.prototype._importDER = function(t, i) {
  t = utils$4.toArray(t, i);
  var n = new Position();
  if (t[n.place++] !== 48)
    return !1;
  var a = getLength(t, n);
  if (a === !1 || a + n.place !== t.length || t[n.place++] !== 2)
    return !1;
  var o = getLength(t, n);
  if (o === !1)
    return !1;
  var l = t.slice(n.place, o + n.place);
  if (n.place += o, t[n.place++] !== 2)
    return !1;
  var c = getLength(t, n);
  if (c === !1 || t.length !== c + n.place)
    return !1;
  var d = t.slice(n.place, c + n.place);
  if (l[0] === 0)
    if (l[1] & 128)
      l = l.slice(1);
    else
      return !1;
  if (d[0] === 0)
    if (d[1] & 128)
      d = d.slice(1);
    else
      return !1;
  return this.r = new BN$2(l), this.s = new BN$2(d), this.recoveryParam = null, !0;
};
function constructLength(e, t) {
  if (t < 128) {
    e.push(t);
    return;
  }
  var i = 1 + (Math.log(t) / Math.LN2 >>> 3);
  for (e.push(i | 128); --i; )
    e.push(t >>> (i << 3) & 255);
  e.push(t);
}
Signature$4.prototype.toDER = function(t) {
  var i = this.r.toArray(), n = this.s.toArray();
  for (i[0] & 128 && (i = [0].concat(i)), n[0] & 128 && (n = [0].concat(n)), i = rmPadding(i), n = rmPadding(n); !n[0] && !(n[1] & 128); )
    n = n.slice(1);
  var a = [2];
  constructLength(a, i.length), a = a.concat(i), a.push(2), constructLength(a, n.length);
  var o = a.concat(n), l = [48];
  return constructLength(l, o.length), l = l.concat(o), utils$4.encode(l, t);
};
var BN$1 = bnExports$1, HmacDRBG = hmacDrbg, utils$3 = utils$c, curves$1 = curves$2, rand = brorandExports, assert$3 = utils$3.assert, KeyPair$2 = key$1, Signature$3 = signature$1;
function EC(e) {
  if (!(this instanceof EC))
    return new EC(e);
  typeof e == "string" && (assert$3(Object.prototype.hasOwnProperty.call(curves$1, e), "Unknown curve " + e), e = curves$1[e]), e instanceof curves$1.PresetCurve && (e = { curve: e }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
}
var ec = EC;
EC.prototype.keyPair = function(t) {
  return new KeyPair$2(this, t);
};
EC.prototype.keyFromPrivate = function(t, i) {
  return KeyPair$2.fromPrivate(this, t, i);
};
EC.prototype.keyFromPublic = function(t, i) {
  return KeyPair$2.fromPublic(this, t, i);
};
EC.prototype.genKeyPair = function(t) {
  t || (t = {});
  for (var i = new HmacDRBG({ hash: this.hash, pers: t.pers, persEnc: t.persEnc || "utf8", entropy: t.entropy || rand(this.hash.hmacStrength), entropyEnc: t.entropy && t.entropyEnc || "utf8", nonce: this.n.toArray() }), n = this.n.byteLength(), a = this.n.sub(new BN$1(2)); ; ) {
    var o = new BN$1(i.generate(n));
    if (!(o.cmp(a) > 0))
      return o.iaddn(1), this.keyFromPrivate(o);
  }
};
EC.prototype._truncateToN = function(t, i) {
  var n = t.byteLength() * 8 - this.n.bitLength();
  return n > 0 && (t = t.ushrn(n)), !i && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
};
EC.prototype.sign = function(t, i, n, a) {
  typeof n == "object" && (a = n, n = null), a || (a = {}), i = this.keyFromPrivate(i, n), t = this._truncateToN(new BN$1(t, 16));
  for (var o = this.n.byteLength(), l = i.getPrivate().toArray("be", o), c = t.toArray("be", o), d = new HmacDRBG({ hash: this.hash, entropy: l, nonce: c, pers: a.pers, persEnc: a.persEnc || "utf8" }), u = this.n.sub(new BN$1(1)), m = 0; ; m++) {
    var A = a.k ? a.k(m) : new BN$1(d.generate(this.n.byteLength()));
    if (A = this._truncateToN(A, !0), !(A.cmpn(1) <= 0 || A.cmp(u) >= 0)) {
      var y = this.g.mul(A);
      if (!y.isInfinity()) {
        var D = y.getX(), C = D.umod(this.n);
        if (C.cmpn(0) !== 0) {
          var z = A.invm(this.n).mul(C.mul(i.getPrivate()).iadd(t));
          if (z = z.umod(this.n), z.cmpn(0) !== 0) {
            var R = (y.getY().isOdd() ? 1 : 0) | (D.cmp(C) !== 0 ? 2 : 0);
            return a.canonical && z.cmp(this.nh) > 0 && (z = this.n.sub(z), R ^= 1), new Signature$3({ r: C, s: z, recoveryParam: R });
          }
        }
      }
    }
  }
};
EC.prototype.verify = function(t, i, n, a) {
  t = this._truncateToN(new BN$1(t, 16)), n = this.keyFromPublic(n, a), i = new Signature$3(i, "hex");
  var o = i.r, l = i.s;
  if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0 || l.cmpn(1) < 0 || l.cmp(this.n) >= 0)
    return !1;
  var c = l.invm(this.n), d = c.mul(t).umod(this.n), u = c.mul(o).umod(this.n), m;
  return this.curve._maxwellTrick ? (m = this.g.jmulAdd(d, n.getPublic(), u), m.isInfinity() ? !1 : m.eqXToP(o)) : (m = this.g.mulAdd(d, n.getPublic(), u), m.isInfinity() ? !1 : m.getX().umod(this.n).cmp(o) === 0);
};
EC.prototype.recoverPubKey = function(e, t, i, n) {
  assert$3((3 & i) === i, "The recovery param is more than two bits"), t = new Signature$3(t, n);
  var a = this.n, o = new BN$1(e), l = t.r, c = t.s, d = i & 1, u = i >> 1;
  if (l.cmp(this.curve.p.umod(this.curve.n)) >= 0 && u)
    throw new Error("Unable to find sencond key candinate");
  u ? l = this.curve.pointFromX(l.add(this.curve.n), d) : l = this.curve.pointFromX(l, d);
  var m = t.r.invm(a), A = a.sub(o).mul(m).umod(a), y = c.mul(m).umod(a);
  return this.g.mulAdd(A, l, y);
};
EC.prototype.getKeyRecoveryParam = function(e, t, i, n) {
  if (t = new Signature$3(t, n), t.recoveryParam !== null)
    return t.recoveryParam;
  for (var a = 0; a < 4; a++) {
    var o;
    try {
      o = this.recoverPubKey(e, t, a);
    } catch {
      continue;
    }
    if (o.eq(i))
      return a;
  }
  throw new Error("Unable to find valid recovery factor");
};
var utils$2 = utils$c, assert$2 = utils$2.assert, parseBytes$2 = utils$2.parseBytes, cachedProperty$1 = utils$2.cachedProperty;
function KeyPair$1(e, t) {
  this.eddsa = e, this._secret = parseBytes$2(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = parseBytes$2(t.pub);
}
KeyPair$1.fromPublic = function(t, i) {
  return i instanceof KeyPair$1 ? i : new KeyPair$1(t, { pub: i });
};
KeyPair$1.fromSecret = function(t, i) {
  return i instanceof KeyPair$1 ? i : new KeyPair$1(t, { secret: i });
};
KeyPair$1.prototype.secret = function() {
  return this._secret;
};
cachedProperty$1(KeyPair$1, "pubBytes", function() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$1, "pub", function() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$1, "privBytes", function() {
  var t = this.eddsa, i = this.hash(), n = t.encodingLength - 1, a = i.slice(0, t.encodingLength);
  return a[0] &= 248, a[n] &= 127, a[n] |= 64, a;
});
cachedProperty$1(KeyPair$1, "priv", function() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$1, "hash", function() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$1, "messagePrefix", function() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$1.prototype.sign = function(t) {
  return assert$2(this._secret, "KeyPair can only verify"), this.eddsa.sign(t, this);
};
KeyPair$1.prototype.verify = function(t, i) {
  return this.eddsa.verify(t, i, this);
};
KeyPair$1.prototype.getSecret = function(t) {
  return assert$2(this._secret, "KeyPair is public only"), utils$2.encode(this.secret(), t);
};
KeyPair$1.prototype.getPublic = function(t) {
  return utils$2.encode(this.pubBytes(), t);
};
var key = KeyPair$1, BN = bnExports$1, utils$1 = utils$c, assert$1 = utils$1.assert, cachedProperty = utils$1.cachedProperty, parseBytes$1 = utils$1.parseBytes;
function Signature$2(e, t) {
  this.eddsa = e, typeof t != "object" && (t = parseBytes$1(t)), Array.isArray(t) && (t = { R: t.slice(0, e.encodingLength), S: t.slice(e.encodingLength) }), assert$1(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof BN && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
}
cachedProperty(Signature$2, "S", function() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$2, "R", function() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$2, "Rencoded", function() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$2, "Sencoded", function() {
  return this.eddsa.encodeInt(this.S());
});
Signature$2.prototype.toBytes = function() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$2.prototype.toHex = function() {
  return utils$1.encode(this.toBytes(), "hex").toUpperCase();
};
var signature = Signature$2, hash = hash$2, curves = curves$2, utils = utils$c, assert = utils.assert, parseBytes = utils.parseBytes, KeyPair = key, Signature$1 = signature;
function EDDSA(e) {
  if (assert(e === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(e);
  e = curves[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = hash.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function(t, i) {
  t = parseBytes(t);
  var n = this.keyFromSecret(i), a = this.hashInt(n.messagePrefix(), t), o = this.g.mul(a), l = this.encodePoint(o), c = this.hashInt(l, n.pubBytes(), t).mul(n.priv()), d = a.add(c).umod(this.curve.n);
  return this.makeSignature({ R: o, S: d, Rencoded: l });
};
EDDSA.prototype.verify = function(t, i, n) {
  t = parseBytes(t), i = this.makeSignature(i);
  var a = this.keyFromPublic(n), o = this.hashInt(i.Rencoded(), a.pubBytes(), t), l = this.g.mul(i.S()), c = i.R().add(a.pub().mul(o));
  return c.eq(l);
};
EDDSA.prototype.hashInt = function() {
  for (var t = this.hash(), i = 0; i < arguments.length; i++)
    t.update(arguments[i]);
  return utils.intFromLE(t.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function(t) {
  return KeyPair.fromPublic(this, t);
};
EDDSA.prototype.keyFromSecret = function(t) {
  return KeyPair.fromSecret(this, t);
};
EDDSA.prototype.makeSignature = function(t) {
  return t instanceof Signature$1 ? t : new Signature$1(this, t);
};
EDDSA.prototype.encodePoint = function(t) {
  var i = t.getY().toArray("le", this.encodingLength);
  return i[this.encodingLength - 1] |= t.getX().isOdd() ? 128 : 0, i;
};
EDDSA.prototype.decodePoint = function(t) {
  t = utils.parseBytes(t);
  var i = t.length - 1, n = t.slice(0, i).concat(t[i] & -129), a = (t[i] & 128) !== 0, o = utils.intFromLE(n);
  return this.curve.pointFromY(o, a);
};
EDDSA.prototype.encodeInt = function(t) {
  return t.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function(t) {
  return utils.intFromLE(t);
};
EDDSA.prototype.isPoint = function(t) {
  return t instanceof this.pointClass;
};
(function(e) {
  var t = e;
  t.version = require$$0$1.version, t.utils = utils$c, t.rand = brorandExports, t.curve = curve, t.curves = curves$2, t.ec = ec, t.eddsa = eddsa;
})(elliptic);
var eosjsKeyConversions = {}, PublicKey = {}, hasRequiredPublicKey;
function requirePublicKey() {
  if (hasRequiredPublicKey)
    return PublicKey;
  hasRequiredPublicKey = 1, Object.defineProperty(PublicKey, "__esModule", { value: !0 }), PublicKey.PublicKey = void 0;
  var e = eosjsNumeric, t = requireEosjsKeyConversions(), i = (
    /** @class */
    function() {
      function n(a, o) {
        this.key = a, this.ec = o;
      }
      return n.fromString = function(a, o) {
        var l = e.stringToPublicKey(a);
        return o || (o = t.constructElliptic(l.type)), new n(l, o);
      }, n.fromElliptic = function(a, o, l) {
        var c = a.getPublic().getX().toArray("be", 32), d = a.getPublic().getY().toArray("be", 32);
        return l || (l = t.constructElliptic(o)), new n({ type: o, data: new Uint8Array([d[31] & 1 ? 3 : 2].concat(c)) }, l);
      }, n.prototype.toString = function() {
        return e.publicKeyToString(this.key);
      }, n.prototype.toLegacyString = function() {
        return e.publicKeyToLegacyString(this.key);
      }, n.prototype.toElliptic = function() {
        return this.ec.keyPair({ pub: Buffer.from(this.key.data) });
      }, n.prototype.getType = function() {
        return this.key.type;
      }, n.prototype.isValid = function() {
        try {
          var a = this.toElliptic(), o = a.validate();
          return o.result;
        } catch {
          return !1;
        }
      }, n;
    }()
  );
  return PublicKey.PublicKey = i, PublicKey;
}
var PrivateKey = {}, hasRequiredPrivateKey;
function requirePrivateKey() {
  if (hasRequiredPrivateKey)
    return PrivateKey;
  hasRequiredPrivateKey = 1, Object.defineProperty(PrivateKey, "__esModule", { value: !0 }), PrivateKey.PrivateKey = void 0;
  var e = eosjsNumeric, t = requireEosjsKeyConversions(), i = (
    /** @class */
    function() {
      function n(a, o) {
        this.key = a, this.ec = o;
      }
      return n.fromElliptic = function(a, o, l) {
        return l || (l = t.constructElliptic(o)), new n({ type: o, data: a.getPrivate().toArrayLike(Buffer, "be", 32) }, l);
      }, n.fromString = function(a, o) {
        var l = e.stringToPrivateKey(a);
        return o || (o = t.constructElliptic(l.type)), new n(l, o);
      }, n.prototype.toElliptic = function() {
        return this.ec.keyFromPrivate(this.key.data);
      }, n.prototype.toLegacyString = function() {
        return e.privateKeyToLegacyString(this.key);
      }, n.prototype.toString = function() {
        return e.privateKeyToString(this.key);
      }, n.prototype.getType = function() {
        return this.key.type;
      }, n.prototype.getPublicKey = function() {
        var a = this.toElliptic();
        return t.PublicKey.fromElliptic(a, this.getType(), this.ec);
      }, n.prototype.sign = function(a, o, l) {
        var c = this;
        o === void 0 && (o = !0), l === void 0 && (l = "utf8"), o && (typeof a == "string" && (a = Buffer.from(a, l)), a = this.ec.hash().update(a).digest());
        var d = 0, u, m = function(y) {
          return !(y[1] & 128) && !(y[1] === 0 && !(y[2] & 128)) && !(y[33] & 128) && !(y[33] === 0 && !(y[34] & 128));
        }, A = function(y) {
          var D = c.toElliptic(), C = D.sign(a, y);
          return t.Signature.fromElliptic(C, c.getType(), c.ec);
        };
        if (this.key.type === e.KeyType.k1)
          do
            u = A({ canonical: !0, pers: [++d] });
          while (!m(u.toBinary()));
        else
          u = A({ canonical: !0 });
        return u;
      }, n.prototype.isValid = function() {
        try {
          var a = this.toElliptic(), o = a.validate();
          return o.result;
        } catch {
          return !1;
        }
      }, n;
    }()
  );
  return PrivateKey.PrivateKey = i, PrivateKey;
}
var Signature = {}, bnExports = {}, bn = { get exports() {
  return bnExports;
}, set exports(e) {
  bnExports = e;
} };
(function(e) {
  (function(t, i) {
    function n(T, g) {
      if (!T)
        throw new Error(g || "Assertion failed");
    }
    function a(T, g) {
      T.super_ = g;
      var b = function() {
      };
      b.prototype = g.prototype, T.prototype = new b(), T.prototype.constructor = T;
    }
    function o(T, g, b) {
      if (o.isBN(T))
        return T;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, T !== null && ((g === "le" || g === "be") && (b = g, g = 10), this._init(T || 0, g || 10, b || "be"));
    }
    typeof t == "object" ? t.exports = o : i.BN = o, o.BN = o, o.wordSize = 26;
    var l;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = require$$0.Buffer;
    } catch {
    }
    o.isBN = function(g) {
      return g instanceof o ? !0 : g !== null && typeof g == "object" && g.constructor.wordSize === o.wordSize && Array.isArray(g.words);
    }, o.max = function(g, b) {
      return g.cmp(b) > 0 ? g : b;
    }, o.min = function(g, b) {
      return g.cmp(b) < 0 ? g : b;
    }, o.prototype._init = function(g, b, x) {
      if (typeof g == "number")
        return this._initNumber(g, b, x);
      if (typeof g == "object")
        return this._initArray(g, b, x);
      b === "hex" && (b = 16), n(b === (b | 0) && b >= 2 && b <= 36), g = g.toString().replace(/\s+/g, "");
      var S = 0;
      g[0] === "-" && (S++, this.negative = 1), S < g.length && (b === 16 ? this._parseHex(g, S, x) : (this._parseBase(g, b, S), x === "le" && this._initArray(this.toArray(), b, x)));
    }, o.prototype._initNumber = function(g, b, x) {
      g < 0 && (this.negative = 1, g = -g), g < 67108864 ? (this.words = [g & 67108863], this.length = 1) : g < 4503599627370496 ? (this.words = [g & 67108863, g / 67108864 & 67108863], this.length = 2) : (n(g < 9007199254740992), this.words = [g & 67108863, g / 67108864 & 67108863, 1], this.length = 3), x === "le" && this._initArray(this.toArray(), b, x);
    }, o.prototype._initArray = function(g, b, x) {
      if (n(typeof g.length == "number"), g.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(g.length / 3), this.words = new Array(this.length);
      for (var S = 0; S < this.length; S++)
        this.words[S] = 0;
      var I, N, p = 0;
      if (x === "be")
        for (S = g.length - 1, I = 0; S >= 0; S -= 3)
          N = g[S] | g[S - 1] << 8 | g[S - 2] << 16, this.words[I] |= N << p & 67108863, this.words[I + 1] = N >>> 26 - p & 67108863, p += 24, p >= 26 && (p -= 26, I++);
      else if (x === "le")
        for (S = 0, I = 0; S < g.length; S += 3)
          N = g[S] | g[S + 1] << 8 | g[S + 2] << 16, this.words[I] |= N << p & 67108863, this.words[I + 1] = N >>> 26 - p & 67108863, p += 24, p >= 26 && (p -= 26, I++);
      return this._strip();
    };
    function c(T, g) {
      var b = T.charCodeAt(g);
      if (b >= 48 && b <= 57)
        return b - 48;
      if (b >= 65 && b <= 70)
        return b - 55;
      if (b >= 97 && b <= 102)
        return b - 87;
      n(!1, "Invalid character in " + T);
    }
    function d(T, g, b) {
      var x = c(T, b);
      return b - 1 >= g && (x |= c(T, b - 1) << 4), x;
    }
    o.prototype._parseHex = function(g, b, x) {
      this.length = Math.ceil((g.length - b) / 6), this.words = new Array(this.length);
      for (var S = 0; S < this.length; S++)
        this.words[S] = 0;
      var I = 0, N = 0, p;
      if (x === "be")
        for (S = g.length - 1; S >= b; S -= 2)
          p = d(g, b, S) << I, this.words[N] |= p & 67108863, I >= 18 ? (I -= 18, N += 1, this.words[N] |= p >>> 26) : I += 8;
      else {
        var M = g.length - b;
        for (S = M % 2 === 0 ? b + 1 : b; S < g.length; S += 2)
          p = d(g, b, S) << I, this.words[N] |= p & 67108863, I >= 18 ? (I -= 18, N += 1, this.words[N] |= p >>> 26) : I += 8;
      }
      this._strip();
    };
    function u(T, g, b, x) {
      for (var S = 0, I = 0, N = Math.min(T.length, b), p = g; p < N; p++) {
        var M = T.charCodeAt(p) - 48;
        S *= x, M >= 49 ? I = M - 49 + 10 : M >= 17 ? I = M - 17 + 10 : I = M, n(M >= 0 && I < x, "Invalid character"), S += I;
      }
      return S;
    }
    o.prototype._parseBase = function(g, b, x) {
      this.words = [0], this.length = 1;
      for (var S = 0, I = 1; I <= 67108863; I *= b)
        S++;
      S--, I = I / b | 0;
      for (var N = g.length - x, p = N % S, M = Math.min(N, N - p) + x, j = 0, U = x; U < M; U += S)
        j = u(g, U, U + S, b), this.imuln(I), this.words[0] + j < 67108864 ? this.words[0] += j : this._iaddn(j);
      if (p !== 0) {
        var H = 1;
        for (j = u(g, U, g.length, b), U = 0; U < p; U++)
          H *= b;
        this.imuln(H), this.words[0] + j < 67108864 ? this.words[0] += j : this._iaddn(j);
      }
      this._strip();
    }, o.prototype.copy = function(g) {
      g.words = new Array(this.length);
      for (var b = 0; b < this.length; b++)
        g.words[b] = this.words[b];
      g.length = this.length, g.negative = this.negative, g.red = this.red;
    };
    function m(T, g) {
      T.words = g.words, T.length = g.length, T.negative = g.negative, T.red = g.red;
    }
    if (o.prototype._move = function(g) {
      m(g, this);
    }, o.prototype.clone = function() {
      var g = new o(null);
      return this.copy(g), g;
    }, o.prototype._expand = function(g) {
      for (; this.length < g; )
        this.words[this.length++] = 0;
      return this;
    }, o.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, o.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        o.prototype[Symbol.for("nodejs.util.inspect.custom")] = A;
      } catch {
        o.prototype.inspect = A;
      }
    else
      o.prototype.inspect = A;
    function A() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var y = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"], D = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5], C = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
    o.prototype.toString = function(g, b) {
      g = g || 10, b = b | 0 || 1;
      var x;
      if (g === 16 || g === "hex") {
        x = "";
        for (var S = 0, I = 0, N = 0; N < this.length; N++) {
          var p = this.words[N], M = ((p << S | I) & 16777215).toString(16);
          I = p >>> 24 - S & 16777215, I !== 0 || N !== this.length - 1 ? x = y[6 - M.length] + M + x : x = M + x, S += 2, S >= 26 && (S -= 26, N--);
        }
        for (I !== 0 && (x = I.toString(16) + x); x.length % b !== 0; )
          x = "0" + x;
        return this.negative !== 0 && (x = "-" + x), x;
      }
      if (g === (g | 0) && g >= 2 && g <= 36) {
        var j = D[g], U = C[g];
        x = "";
        var H = this.clone();
        for (H.negative = 0; !H.isZero(); ) {
          var J = H.modrn(U).toString(g);
          H = H.idivn(U), H.isZero() ? x = J + x : x = y[j - J.length] + J + x;
        }
        for (this.isZero() && (x = "0" + x); x.length % b !== 0; )
          x = "0" + x;
        return this.negative !== 0 && (x = "-" + x), x;
      }
      n(!1, "Base should be between 2 and 36");
    }, o.prototype.toNumber = function() {
      var g = this.words[0];
      return this.length === 2 ? g += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? g += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -g : g;
    }, o.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, l && (o.prototype.toBuffer = function(g, b) {
      return this.toArrayLike(l, g, b);
    }), o.prototype.toArray = function(g, b) {
      return this.toArrayLike(Array, g, b);
    };
    var z = function(g, b) {
      return g.allocUnsafe ? g.allocUnsafe(b) : new g(b);
    };
    o.prototype.toArrayLike = function(g, b, x) {
      this._strip();
      var S = this.byteLength(), I = x || Math.max(1, S);
      n(S <= I, "byte array longer than desired length"), n(I > 0, "Requested array length <= 0");
      var N = z(g, I), p = b === "le" ? "LE" : "BE";
      return this["_toArrayLike" + p](N, S), N;
    }, o.prototype._toArrayLikeLE = function(g, b) {
      for (var x = 0, S = 0, I = 0, N = 0; I < this.length; I++) {
        var p = this.words[I] << N | S;
        g[x++] = p & 255, x < g.length && (g[x++] = p >> 8 & 255), x < g.length && (g[x++] = p >> 16 & 255), N === 6 ? (x < g.length && (g[x++] = p >> 24 & 255), S = 0, N = 0) : (S = p >>> 24, N += 2);
      }
      if (x < g.length)
        for (g[x++] = S; x < g.length; )
          g[x++] = 0;
    }, o.prototype._toArrayLikeBE = function(g, b) {
      for (var x = g.length - 1, S = 0, I = 0, N = 0; I < this.length; I++) {
        var p = this.words[I] << N | S;
        g[x--] = p & 255, x >= 0 && (g[x--] = p >> 8 & 255), x >= 0 && (g[x--] = p >> 16 & 255), N === 6 ? (x >= 0 && (g[x--] = p >> 24 & 255), S = 0, N = 0) : (S = p >>> 24, N += 2);
      }
      if (x >= 0)
        for (g[x--] = S; x >= 0; )
          g[x--] = 0;
    }, Math.clz32 ? o.prototype._countBits = function(g) {
      return 32 - Math.clz32(g);
    } : o.prototype._countBits = function(g) {
      var b = g, x = 0;
      return b >= 4096 && (x += 13, b >>>= 13), b >= 64 && (x += 7, b >>>= 7), b >= 8 && (x += 4, b >>>= 4), b >= 2 && (x += 2, b >>>= 2), x + b;
    }, o.prototype._zeroBits = function(g) {
      if (g === 0)
        return 26;
      var b = g, x = 0;
      return b & 8191 || (x += 13, b >>>= 13), b & 127 || (x += 7, b >>>= 7), b & 15 || (x += 4, b >>>= 4), b & 3 || (x += 2, b >>>= 2), b & 1 || x++, x;
    }, o.prototype.bitLength = function() {
      var g = this.words[this.length - 1], b = this._countBits(g);
      return (this.length - 1) * 26 + b;
    };
    function R(T) {
      for (var g = new Array(T.bitLength()), b = 0; b < g.length; b++) {
        var x = b / 26 | 0, S = b % 26;
        g[b] = T.words[x] >>> S & 1;
      }
      return g;
    }
    o.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var g = 0, b = 0; b < this.length; b++) {
        var x = this._zeroBits(this.words[b]);
        if (g += x, x !== 26)
          break;
      }
      return g;
    }, o.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, o.prototype.toTwos = function(g) {
      return this.negative !== 0 ? this.abs().inotn(g).iaddn(1) : this.clone();
    }, o.prototype.fromTwos = function(g) {
      return this.testn(g - 1) ? this.notn(g).iaddn(1).ineg() : this.clone();
    }, o.prototype.isNeg = function() {
      return this.negative !== 0;
    }, o.prototype.neg = function() {
      return this.clone().ineg();
    }, o.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, o.prototype.iuor = function(g) {
      for (; this.length < g.length; )
        this.words[this.length++] = 0;
      for (var b = 0; b < g.length; b++)
        this.words[b] = this.words[b] | g.words[b];
      return this._strip();
    }, o.prototype.ior = function(g) {
      return n((this.negative | g.negative) === 0), this.iuor(g);
    }, o.prototype.or = function(g) {
      return this.length > g.length ? this.clone().ior(g) : g.clone().ior(this);
    }, o.prototype.uor = function(g) {
      return this.length > g.length ? this.clone().iuor(g) : g.clone().iuor(this);
    }, o.prototype.iuand = function(g) {
      var b;
      this.length > g.length ? b = g : b = this;
      for (var x = 0; x < b.length; x++)
        this.words[x] = this.words[x] & g.words[x];
      return this.length = b.length, this._strip();
    }, o.prototype.iand = function(g) {
      return n((this.negative | g.negative) === 0), this.iuand(g);
    }, o.prototype.and = function(g) {
      return this.length > g.length ? this.clone().iand(g) : g.clone().iand(this);
    }, o.prototype.uand = function(g) {
      return this.length > g.length ? this.clone().iuand(g) : g.clone().iuand(this);
    }, o.prototype.iuxor = function(g) {
      var b, x;
      this.length > g.length ? (b = this, x = g) : (b = g, x = this);
      for (var S = 0; S < x.length; S++)
        this.words[S] = b.words[S] ^ x.words[S];
      if (this !== b)
        for (; S < b.length; S++)
          this.words[S] = b.words[S];
      return this.length = b.length, this._strip();
    }, o.prototype.ixor = function(g) {
      return n((this.negative | g.negative) === 0), this.iuxor(g);
    }, o.prototype.xor = function(g) {
      return this.length > g.length ? this.clone().ixor(g) : g.clone().ixor(this);
    }, o.prototype.uxor = function(g) {
      return this.length > g.length ? this.clone().iuxor(g) : g.clone().iuxor(this);
    }, o.prototype.inotn = function(g) {
      n(typeof g == "number" && g >= 0);
      var b = Math.ceil(g / 26) | 0, x = g % 26;
      this._expand(b), x > 0 && b--;
      for (var S = 0; S < b; S++)
        this.words[S] = ~this.words[S] & 67108863;
      return x > 0 && (this.words[S] = ~this.words[S] & 67108863 >> 26 - x), this._strip();
    }, o.prototype.notn = function(g) {
      return this.clone().inotn(g);
    }, o.prototype.setn = function(g, b) {
      n(typeof g == "number" && g >= 0);
      var x = g / 26 | 0, S = g % 26;
      return this._expand(x + 1), b ? this.words[x] = this.words[x] | 1 << S : this.words[x] = this.words[x] & ~(1 << S), this._strip();
    }, o.prototype.iadd = function(g) {
      var b;
      if (this.negative !== 0 && g.negative === 0)
        return this.negative = 0, b = this.isub(g), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && g.negative !== 0)
        return g.negative = 0, b = this.isub(g), g.negative = 1, b._normSign();
      var x, S;
      this.length > g.length ? (x = this, S = g) : (x = g, S = this);
      for (var I = 0, N = 0; N < S.length; N++)
        b = (x.words[N] | 0) + (S.words[N] | 0) + I, this.words[N] = b & 67108863, I = b >>> 26;
      for (; I !== 0 && N < x.length; N++)
        b = (x.words[N] | 0) + I, this.words[N] = b & 67108863, I = b >>> 26;
      if (this.length = x.length, I !== 0)
        this.words[this.length] = I, this.length++;
      else if (x !== this)
        for (; N < x.length; N++)
          this.words[N] = x.words[N];
      return this;
    }, o.prototype.add = function(g) {
      var b;
      return g.negative !== 0 && this.negative === 0 ? (g.negative = 0, b = this.sub(g), g.negative ^= 1, b) : g.negative === 0 && this.negative !== 0 ? (this.negative = 0, b = g.sub(this), this.negative = 1, b) : this.length > g.length ? this.clone().iadd(g) : g.clone().iadd(this);
    }, o.prototype.isub = function(g) {
      if (g.negative !== 0) {
        g.negative = 0;
        var b = this.iadd(g);
        return g.negative = 1, b._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(g), this.negative = 1, this._normSign();
      var x = this.cmp(g);
      if (x === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var S, I;
      x > 0 ? (S = this, I = g) : (S = g, I = this);
      for (var N = 0, p = 0; p < I.length; p++)
        b = (S.words[p] | 0) - (I.words[p] | 0) + N, N = b >> 26, this.words[p] = b & 67108863;
      for (; N !== 0 && p < S.length; p++)
        b = (S.words[p] | 0) + N, N = b >> 26, this.words[p] = b & 67108863;
      if (N === 0 && p < S.length && S !== this)
        for (; p < S.length; p++)
          this.words[p] = S.words[p];
      return this.length = Math.max(this.length, p), S !== this && (this.negative = 1), this._strip();
    }, o.prototype.sub = function(g) {
      return this.clone().isub(g);
    };
    function O(T, g, b) {
      b.negative = g.negative ^ T.negative;
      var x = T.length + g.length | 0;
      b.length = x, x = x - 1 | 0;
      var S = T.words[0] | 0, I = g.words[0] | 0, N = S * I, p = N & 67108863, M = N / 67108864 | 0;
      b.words[0] = p;
      for (var j = 1; j < x; j++) {
        for (var U = M >>> 26, H = M & 67108863, J = Math.min(j, g.length - 1), te = Math.max(0, j - T.length + 1); te <= J; te++) {
          var ae = j - te | 0;
          S = T.words[ae] | 0, I = g.words[te] | 0, N = S * I + H, U += N / 67108864 | 0, H = N & 67108863;
        }
        b.words[j] = H | 0, M = U | 0;
      }
      return M !== 0 ? b.words[j] = M | 0 : b.length--, b._strip();
    }
    var $ = function(g, b, x) {
      var S = g.words, I = b.words, N = x.words, p = 0, M, j, U, H = S[0] | 0, J = H & 8191, te = H >>> 13, ae = S[1] | 0, le = ae & 8191, ne = ae >>> 13, ue = S[2] | 0, ge = ue & 8191, re = ue >>> 13, fe = S[3] | 0, oe = fe & 8191, ve = fe >>> 13, Le = S[4] | 0, Be = Le & 8191, we = Le >>> 13, Ue = S[5] | 0, Oe = Ue & 8191, Te = Ue >>> 13, Ne = S[6] | 0, Ee = Ne & 8191, Se = Ne >>> 13, Re = S[7] | 0, W = Re & 8191, Y = Re >>> 13, Q = S[8] | 0, ee = Q & 8191, ie = Q >>> 13, se = S[9] | 0, pe = se & 8191, he = se >>> 13, Me = I[0] | 0, _e = Me & 8191, xe = Me >>> 13, Ye = I[1] | 0, Ve = Ye & 8191, Ce = Ye >>> 13, Qe = I[2] | 0, qe = Qe & 8191, Pe = Qe >>> 13, He = I[3] | 0, Ze = He & 8191, je = He >>> 13, We = I[4] | 0, Je = We & 8191, $e = We >>> 13, Xe = I[5] | 0, Ke = Xe & 8191, q = Xe >>> 13, ce = I[6] | 0, de = ce & 8191, me = ce >>> 13, De = I[7] | 0, Ie = De & 8191, ye = De >>> 13, Ae = I[8] | 0, Fe = Ae & 8191, be = Ae >>> 13, ke = I[9] | 0, ze = ke & 8191, Ge = ke >>> 13;
      x.negative = g.negative ^ b.negative, x.length = 19, M = Math.imul(J, _e), j = Math.imul(J, xe), j = j + Math.imul(te, _e) | 0, U = Math.imul(te, xe);
      var tt = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (tt >>> 26) | 0, tt &= 67108863, M = Math.imul(le, _e), j = Math.imul(le, xe), j = j + Math.imul(ne, _e) | 0, U = Math.imul(ne, xe), M = M + Math.imul(J, Ve) | 0, j = j + Math.imul(J, Ce) | 0, j = j + Math.imul(te, Ve) | 0, U = U + Math.imul(te, Ce) | 0;
      var et = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (et >>> 26) | 0, et &= 67108863, M = Math.imul(ge, _e), j = Math.imul(ge, xe), j = j + Math.imul(re, _e) | 0, U = Math.imul(re, xe), M = M + Math.imul(le, Ve) | 0, j = j + Math.imul(le, Ce) | 0, j = j + Math.imul(ne, Ve) | 0, U = U + Math.imul(ne, Ce) | 0, M = M + Math.imul(J, qe) | 0, j = j + Math.imul(J, Pe) | 0, j = j + Math.imul(te, qe) | 0, U = U + Math.imul(te, Pe) | 0;
      var rt = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (rt >>> 26) | 0, rt &= 67108863, M = Math.imul(oe, _e), j = Math.imul(oe, xe), j = j + Math.imul(ve, _e) | 0, U = Math.imul(ve, xe), M = M + Math.imul(ge, Ve) | 0, j = j + Math.imul(ge, Ce) | 0, j = j + Math.imul(re, Ve) | 0, U = U + Math.imul(re, Ce) | 0, M = M + Math.imul(le, qe) | 0, j = j + Math.imul(le, Pe) | 0, j = j + Math.imul(ne, qe) | 0, U = U + Math.imul(ne, Pe) | 0, M = M + Math.imul(J, Ze) | 0, j = j + Math.imul(J, je) | 0, j = j + Math.imul(te, Ze) | 0, U = U + Math.imul(te, je) | 0;
      var it = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (it >>> 26) | 0, it &= 67108863, M = Math.imul(Be, _e), j = Math.imul(Be, xe), j = j + Math.imul(we, _e) | 0, U = Math.imul(we, xe), M = M + Math.imul(oe, Ve) | 0, j = j + Math.imul(oe, Ce) | 0, j = j + Math.imul(ve, Ve) | 0, U = U + Math.imul(ve, Ce) | 0, M = M + Math.imul(ge, qe) | 0, j = j + Math.imul(ge, Pe) | 0, j = j + Math.imul(re, qe) | 0, U = U + Math.imul(re, Pe) | 0, M = M + Math.imul(le, Ze) | 0, j = j + Math.imul(le, je) | 0, j = j + Math.imul(ne, Ze) | 0, U = U + Math.imul(ne, je) | 0, M = M + Math.imul(J, Je) | 0, j = j + Math.imul(J, $e) | 0, j = j + Math.imul(te, Je) | 0, U = U + Math.imul(te, $e) | 0;
      var nt = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, M = Math.imul(Oe, _e), j = Math.imul(Oe, xe), j = j + Math.imul(Te, _e) | 0, U = Math.imul(Te, xe), M = M + Math.imul(Be, Ve) | 0, j = j + Math.imul(Be, Ce) | 0, j = j + Math.imul(we, Ve) | 0, U = U + Math.imul(we, Ce) | 0, M = M + Math.imul(oe, qe) | 0, j = j + Math.imul(oe, Pe) | 0, j = j + Math.imul(ve, qe) | 0, U = U + Math.imul(ve, Pe) | 0, M = M + Math.imul(ge, Ze) | 0, j = j + Math.imul(ge, je) | 0, j = j + Math.imul(re, Ze) | 0, U = U + Math.imul(re, je) | 0, M = M + Math.imul(le, Je) | 0, j = j + Math.imul(le, $e) | 0, j = j + Math.imul(ne, Je) | 0, U = U + Math.imul(ne, $e) | 0, M = M + Math.imul(J, Ke) | 0, j = j + Math.imul(J, q) | 0, j = j + Math.imul(te, Ke) | 0, U = U + Math.imul(te, q) | 0;
      var at = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, M = Math.imul(Ee, _e), j = Math.imul(Ee, xe), j = j + Math.imul(Se, _e) | 0, U = Math.imul(Se, xe), M = M + Math.imul(Oe, Ve) | 0, j = j + Math.imul(Oe, Ce) | 0, j = j + Math.imul(Te, Ve) | 0, U = U + Math.imul(Te, Ce) | 0, M = M + Math.imul(Be, qe) | 0, j = j + Math.imul(Be, Pe) | 0, j = j + Math.imul(we, qe) | 0, U = U + Math.imul(we, Pe) | 0, M = M + Math.imul(oe, Ze) | 0, j = j + Math.imul(oe, je) | 0, j = j + Math.imul(ve, Ze) | 0, U = U + Math.imul(ve, je) | 0, M = M + Math.imul(ge, Je) | 0, j = j + Math.imul(ge, $e) | 0, j = j + Math.imul(re, Je) | 0, U = U + Math.imul(re, $e) | 0, M = M + Math.imul(le, Ke) | 0, j = j + Math.imul(le, q) | 0, j = j + Math.imul(ne, Ke) | 0, U = U + Math.imul(ne, q) | 0, M = M + Math.imul(J, de) | 0, j = j + Math.imul(J, me) | 0, j = j + Math.imul(te, de) | 0, U = U + Math.imul(te, me) | 0;
      var st = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (st >>> 26) | 0, st &= 67108863, M = Math.imul(W, _e), j = Math.imul(W, xe), j = j + Math.imul(Y, _e) | 0, U = Math.imul(Y, xe), M = M + Math.imul(Ee, Ve) | 0, j = j + Math.imul(Ee, Ce) | 0, j = j + Math.imul(Se, Ve) | 0, U = U + Math.imul(Se, Ce) | 0, M = M + Math.imul(Oe, qe) | 0, j = j + Math.imul(Oe, Pe) | 0, j = j + Math.imul(Te, qe) | 0, U = U + Math.imul(Te, Pe) | 0, M = M + Math.imul(Be, Ze) | 0, j = j + Math.imul(Be, je) | 0, j = j + Math.imul(we, Ze) | 0, U = U + Math.imul(we, je) | 0, M = M + Math.imul(oe, Je) | 0, j = j + Math.imul(oe, $e) | 0, j = j + Math.imul(ve, Je) | 0, U = U + Math.imul(ve, $e) | 0, M = M + Math.imul(ge, Ke) | 0, j = j + Math.imul(ge, q) | 0, j = j + Math.imul(re, Ke) | 0, U = U + Math.imul(re, q) | 0, M = M + Math.imul(le, de) | 0, j = j + Math.imul(le, me) | 0, j = j + Math.imul(ne, de) | 0, U = U + Math.imul(ne, me) | 0, M = M + Math.imul(J, Ie) | 0, j = j + Math.imul(J, ye) | 0, j = j + Math.imul(te, Ie) | 0, U = U + Math.imul(te, ye) | 0;
      var ot = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (ot >>> 26) | 0, ot &= 67108863, M = Math.imul(ee, _e), j = Math.imul(ee, xe), j = j + Math.imul(ie, _e) | 0, U = Math.imul(ie, xe), M = M + Math.imul(W, Ve) | 0, j = j + Math.imul(W, Ce) | 0, j = j + Math.imul(Y, Ve) | 0, U = U + Math.imul(Y, Ce) | 0, M = M + Math.imul(Ee, qe) | 0, j = j + Math.imul(Ee, Pe) | 0, j = j + Math.imul(Se, qe) | 0, U = U + Math.imul(Se, Pe) | 0, M = M + Math.imul(Oe, Ze) | 0, j = j + Math.imul(Oe, je) | 0, j = j + Math.imul(Te, Ze) | 0, U = U + Math.imul(Te, je) | 0, M = M + Math.imul(Be, Je) | 0, j = j + Math.imul(Be, $e) | 0, j = j + Math.imul(we, Je) | 0, U = U + Math.imul(we, $e) | 0, M = M + Math.imul(oe, Ke) | 0, j = j + Math.imul(oe, q) | 0, j = j + Math.imul(ve, Ke) | 0, U = U + Math.imul(ve, q) | 0, M = M + Math.imul(ge, de) | 0, j = j + Math.imul(ge, me) | 0, j = j + Math.imul(re, de) | 0, U = U + Math.imul(re, me) | 0, M = M + Math.imul(le, Ie) | 0, j = j + Math.imul(le, ye) | 0, j = j + Math.imul(ne, Ie) | 0, U = U + Math.imul(ne, ye) | 0, M = M + Math.imul(J, Fe) | 0, j = j + Math.imul(J, be) | 0, j = j + Math.imul(te, Fe) | 0, U = U + Math.imul(te, be) | 0;
      var lt = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, M = Math.imul(pe, _e), j = Math.imul(pe, xe), j = j + Math.imul(he, _e) | 0, U = Math.imul(he, xe), M = M + Math.imul(ee, Ve) | 0, j = j + Math.imul(ee, Ce) | 0, j = j + Math.imul(ie, Ve) | 0, U = U + Math.imul(ie, Ce) | 0, M = M + Math.imul(W, qe) | 0, j = j + Math.imul(W, Pe) | 0, j = j + Math.imul(Y, qe) | 0, U = U + Math.imul(Y, Pe) | 0, M = M + Math.imul(Ee, Ze) | 0, j = j + Math.imul(Ee, je) | 0, j = j + Math.imul(Se, Ze) | 0, U = U + Math.imul(Se, je) | 0, M = M + Math.imul(Oe, Je) | 0, j = j + Math.imul(Oe, $e) | 0, j = j + Math.imul(Te, Je) | 0, U = U + Math.imul(Te, $e) | 0, M = M + Math.imul(Be, Ke) | 0, j = j + Math.imul(Be, q) | 0, j = j + Math.imul(we, Ke) | 0, U = U + Math.imul(we, q) | 0, M = M + Math.imul(oe, de) | 0, j = j + Math.imul(oe, me) | 0, j = j + Math.imul(ve, de) | 0, U = U + Math.imul(ve, me) | 0, M = M + Math.imul(ge, Ie) | 0, j = j + Math.imul(ge, ye) | 0, j = j + Math.imul(re, Ie) | 0, U = U + Math.imul(re, ye) | 0, M = M + Math.imul(le, Fe) | 0, j = j + Math.imul(le, be) | 0, j = j + Math.imul(ne, Fe) | 0, U = U + Math.imul(ne, be) | 0, M = M + Math.imul(J, ze) | 0, j = j + Math.imul(J, Ge) | 0, j = j + Math.imul(te, ze) | 0, U = U + Math.imul(te, Ge) | 0;
      var ft = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, M = Math.imul(pe, Ve), j = Math.imul(pe, Ce), j = j + Math.imul(he, Ve) | 0, U = Math.imul(he, Ce), M = M + Math.imul(ee, qe) | 0, j = j + Math.imul(ee, Pe) | 0, j = j + Math.imul(ie, qe) | 0, U = U + Math.imul(ie, Pe) | 0, M = M + Math.imul(W, Ze) | 0, j = j + Math.imul(W, je) | 0, j = j + Math.imul(Y, Ze) | 0, U = U + Math.imul(Y, je) | 0, M = M + Math.imul(Ee, Je) | 0, j = j + Math.imul(Ee, $e) | 0, j = j + Math.imul(Se, Je) | 0, U = U + Math.imul(Se, $e) | 0, M = M + Math.imul(Oe, Ke) | 0, j = j + Math.imul(Oe, q) | 0, j = j + Math.imul(Te, Ke) | 0, U = U + Math.imul(Te, q) | 0, M = M + Math.imul(Be, de) | 0, j = j + Math.imul(Be, me) | 0, j = j + Math.imul(we, de) | 0, U = U + Math.imul(we, me) | 0, M = M + Math.imul(oe, Ie) | 0, j = j + Math.imul(oe, ye) | 0, j = j + Math.imul(ve, Ie) | 0, U = U + Math.imul(ve, ye) | 0, M = M + Math.imul(ge, Fe) | 0, j = j + Math.imul(ge, be) | 0, j = j + Math.imul(re, Fe) | 0, U = U + Math.imul(re, be) | 0, M = M + Math.imul(le, ze) | 0, j = j + Math.imul(le, Ge) | 0, j = j + Math.imul(ne, ze) | 0, U = U + Math.imul(ne, Ge) | 0;
      var ct = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, M = Math.imul(pe, qe), j = Math.imul(pe, Pe), j = j + Math.imul(he, qe) | 0, U = Math.imul(he, Pe), M = M + Math.imul(ee, Ze) | 0, j = j + Math.imul(ee, je) | 0, j = j + Math.imul(ie, Ze) | 0, U = U + Math.imul(ie, je) | 0, M = M + Math.imul(W, Je) | 0, j = j + Math.imul(W, $e) | 0, j = j + Math.imul(Y, Je) | 0, U = U + Math.imul(Y, $e) | 0, M = M + Math.imul(Ee, Ke) | 0, j = j + Math.imul(Ee, q) | 0, j = j + Math.imul(Se, Ke) | 0, U = U + Math.imul(Se, q) | 0, M = M + Math.imul(Oe, de) | 0, j = j + Math.imul(Oe, me) | 0, j = j + Math.imul(Te, de) | 0, U = U + Math.imul(Te, me) | 0, M = M + Math.imul(Be, Ie) | 0, j = j + Math.imul(Be, ye) | 0, j = j + Math.imul(we, Ie) | 0, U = U + Math.imul(we, ye) | 0, M = M + Math.imul(oe, Fe) | 0, j = j + Math.imul(oe, be) | 0, j = j + Math.imul(ve, Fe) | 0, U = U + Math.imul(ve, be) | 0, M = M + Math.imul(ge, ze) | 0, j = j + Math.imul(ge, Ge) | 0, j = j + Math.imul(re, ze) | 0, U = U + Math.imul(re, Ge) | 0;
      var ut = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (ut >>> 26) | 0, ut &= 67108863, M = Math.imul(pe, Ze), j = Math.imul(pe, je), j = j + Math.imul(he, Ze) | 0, U = Math.imul(he, je), M = M + Math.imul(ee, Je) | 0, j = j + Math.imul(ee, $e) | 0, j = j + Math.imul(ie, Je) | 0, U = U + Math.imul(ie, $e) | 0, M = M + Math.imul(W, Ke) | 0, j = j + Math.imul(W, q) | 0, j = j + Math.imul(Y, Ke) | 0, U = U + Math.imul(Y, q) | 0, M = M + Math.imul(Ee, de) | 0, j = j + Math.imul(Ee, me) | 0, j = j + Math.imul(Se, de) | 0, U = U + Math.imul(Se, me) | 0, M = M + Math.imul(Oe, Ie) | 0, j = j + Math.imul(Oe, ye) | 0, j = j + Math.imul(Te, Ie) | 0, U = U + Math.imul(Te, ye) | 0, M = M + Math.imul(Be, Fe) | 0, j = j + Math.imul(Be, be) | 0, j = j + Math.imul(we, Fe) | 0, U = U + Math.imul(we, be) | 0, M = M + Math.imul(oe, ze) | 0, j = j + Math.imul(oe, Ge) | 0, j = j + Math.imul(ve, ze) | 0, U = U + Math.imul(ve, Ge) | 0;
      var ht = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, M = Math.imul(pe, Je), j = Math.imul(pe, $e), j = j + Math.imul(he, Je) | 0, U = Math.imul(he, $e), M = M + Math.imul(ee, Ke) | 0, j = j + Math.imul(ee, q) | 0, j = j + Math.imul(ie, Ke) | 0, U = U + Math.imul(ie, q) | 0, M = M + Math.imul(W, de) | 0, j = j + Math.imul(W, me) | 0, j = j + Math.imul(Y, de) | 0, U = U + Math.imul(Y, me) | 0, M = M + Math.imul(Ee, Ie) | 0, j = j + Math.imul(Ee, ye) | 0, j = j + Math.imul(Se, Ie) | 0, U = U + Math.imul(Se, ye) | 0, M = M + Math.imul(Oe, Fe) | 0, j = j + Math.imul(Oe, be) | 0, j = j + Math.imul(Te, Fe) | 0, U = U + Math.imul(Te, be) | 0, M = M + Math.imul(Be, ze) | 0, j = j + Math.imul(Be, Ge) | 0, j = j + Math.imul(we, ze) | 0, U = U + Math.imul(we, Ge) | 0;
      var dt = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, M = Math.imul(pe, Ke), j = Math.imul(pe, q), j = j + Math.imul(he, Ke) | 0, U = Math.imul(he, q), M = M + Math.imul(ee, de) | 0, j = j + Math.imul(ee, me) | 0, j = j + Math.imul(ie, de) | 0, U = U + Math.imul(ie, me) | 0, M = M + Math.imul(W, Ie) | 0, j = j + Math.imul(W, ye) | 0, j = j + Math.imul(Y, Ie) | 0, U = U + Math.imul(Y, ye) | 0, M = M + Math.imul(Ee, Fe) | 0, j = j + Math.imul(Ee, be) | 0, j = j + Math.imul(Se, Fe) | 0, U = U + Math.imul(Se, be) | 0, M = M + Math.imul(Oe, ze) | 0, j = j + Math.imul(Oe, Ge) | 0, j = j + Math.imul(Te, ze) | 0, U = U + Math.imul(Te, Ge) | 0;
      var pt = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, M = Math.imul(pe, de), j = Math.imul(pe, me), j = j + Math.imul(he, de) | 0, U = Math.imul(he, me), M = M + Math.imul(ee, Ie) | 0, j = j + Math.imul(ee, ye) | 0, j = j + Math.imul(ie, Ie) | 0, U = U + Math.imul(ie, ye) | 0, M = M + Math.imul(W, Fe) | 0, j = j + Math.imul(W, be) | 0, j = j + Math.imul(Y, Fe) | 0, U = U + Math.imul(Y, be) | 0, M = M + Math.imul(Ee, ze) | 0, j = j + Math.imul(Ee, Ge) | 0, j = j + Math.imul(Se, ze) | 0, U = U + Math.imul(Se, Ge) | 0;
      var mt = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, M = Math.imul(pe, Ie), j = Math.imul(pe, ye), j = j + Math.imul(he, Ie) | 0, U = Math.imul(he, ye), M = M + Math.imul(ee, Fe) | 0, j = j + Math.imul(ee, be) | 0, j = j + Math.imul(ie, Fe) | 0, U = U + Math.imul(ie, be) | 0, M = M + Math.imul(W, ze) | 0, j = j + Math.imul(W, Ge) | 0, j = j + Math.imul(Y, ze) | 0, U = U + Math.imul(Y, Ge) | 0;
      var gt = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, M = Math.imul(pe, Fe), j = Math.imul(pe, be), j = j + Math.imul(he, Fe) | 0, U = Math.imul(he, be), M = M + Math.imul(ee, ze) | 0, j = j + Math.imul(ee, Ge) | 0, j = j + Math.imul(ie, ze) | 0, U = U + Math.imul(ie, Ge) | 0;
      var yt = (p + M | 0) + ((j & 8191) << 13) | 0;
      p = (U + (j >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, M = Math.imul(pe, ze), j = Math.imul(pe, Ge), j = j + Math.imul(he, ze) | 0, U = Math.imul(he, Ge);
      var vt = (p + M | 0) + ((j & 8191) << 13) | 0;
      return p = (U + (j >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, N[0] = tt, N[1] = et, N[2] = rt, N[3] = it, N[4] = nt, N[5] = at, N[6] = st, N[7] = ot, N[8] = lt, N[9] = ft, N[10] = ct, N[11] = ut, N[12] = ht, N[13] = dt, N[14] = pt, N[15] = mt, N[16] = gt, N[17] = yt, N[18] = vt, p !== 0 && (N[19] = p, x.length++), x;
    };
    Math.imul || ($ = O);
    function k(T, g, b) {
      b.negative = g.negative ^ T.negative, b.length = T.length + g.length;
      for (var x = 0, S = 0, I = 0; I < b.length - 1; I++) {
        var N = S;
        S = 0;
        for (var p = x & 67108863, M = Math.min(I, g.length - 1), j = Math.max(0, I - T.length + 1); j <= M; j++) {
          var U = I - j, H = T.words[U] | 0, J = g.words[j] | 0, te = H * J, ae = te & 67108863;
          N = N + (te / 67108864 | 0) | 0, ae = ae + p | 0, p = ae & 67108863, N = N + (ae >>> 26) | 0, S += N >>> 26, N &= 67108863;
        }
        b.words[I] = p, x = N, N = S;
      }
      return x !== 0 ? b.words[I] = x : b.length--, b._strip();
    }
    function P(T, g, b) {
      return k(T, g, b);
    }
    o.prototype.mulTo = function(g, b) {
      var x, S = this.length + g.length;
      return this.length === 10 && g.length === 10 ? x = $(this, g, b) : S < 63 ? x = O(this, g, b) : S < 1024 ? x = k(this, g, b) : x = P(this, g, b), x;
    }, o.prototype.mul = function(g) {
      var b = new o(null);
      return b.words = new Array(this.length + g.length), this.mulTo(g, b);
    }, o.prototype.mulf = function(g) {
      var b = new o(null);
      return b.words = new Array(this.length + g.length), P(this, g, b);
    }, o.prototype.imul = function(g) {
      return this.clone().mulTo(g, this);
    }, o.prototype.imuln = function(g) {
      var b = g < 0;
      b && (g = -g), n(typeof g == "number"), n(g < 67108864);
      for (var x = 0, S = 0; S < this.length; S++) {
        var I = (this.words[S] | 0) * g, N = (I & 67108863) + (x & 67108863);
        x >>= 26, x += I / 67108864 | 0, x += N >>> 26, this.words[S] = N & 67108863;
      }
      return x !== 0 && (this.words[S] = x, this.length++), b ? this.ineg() : this;
    }, o.prototype.muln = function(g) {
      return this.clone().imuln(g);
    }, o.prototype.sqr = function() {
      return this.mul(this);
    }, o.prototype.isqr = function() {
      return this.imul(this.clone());
    }, o.prototype.pow = function(g) {
      var b = R(g);
      if (b.length === 0)
        return new o(1);
      for (var x = this, S = 0; S < b.length && b[S] === 0; S++, x = x.sqr())
        ;
      if (++S < b.length)
        for (var I = x.sqr(); S < b.length; S++, I = I.sqr())
          b[S] !== 0 && (x = x.mul(I));
      return x;
    }, o.prototype.iushln = function(g) {
      n(typeof g == "number" && g >= 0);
      var b = g % 26, x = (g - b) / 26, S = 67108863 >>> 26 - b << 26 - b, I;
      if (b !== 0) {
        var N = 0;
        for (I = 0; I < this.length; I++) {
          var p = this.words[I] & S, M = (this.words[I] | 0) - p << b;
          this.words[I] = M | N, N = p >>> 26 - b;
        }
        N && (this.words[I] = N, this.length++);
      }
      if (x !== 0) {
        for (I = this.length - 1; I >= 0; I--)
          this.words[I + x] = this.words[I];
        for (I = 0; I < x; I++)
          this.words[I] = 0;
        this.length += x;
      }
      return this._strip();
    }, o.prototype.ishln = function(g) {
      return n(this.negative === 0), this.iushln(g);
    }, o.prototype.iushrn = function(g, b, x) {
      n(typeof g == "number" && g >= 0);
      var S;
      b ? S = (b - b % 26) / 26 : S = 0;
      var I = g % 26, N = Math.min((g - I) / 26, this.length), p = 67108863 ^ 67108863 >>> I << I, M = x;
      if (S -= N, S = Math.max(0, S), M) {
        for (var j = 0; j < N; j++)
          M.words[j] = this.words[j];
        M.length = N;
      }
      if (N !== 0)
        if (this.length > N)
          for (this.length -= N, j = 0; j < this.length; j++)
            this.words[j] = this.words[j + N];
        else
          this.words[0] = 0, this.length = 1;
      var U = 0;
      for (j = this.length - 1; j >= 0 && (U !== 0 || j >= S); j--) {
        var H = this.words[j] | 0;
        this.words[j] = U << 26 - I | H >>> I, U = H & p;
      }
      return M && U !== 0 && (M.words[M.length++] = U), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, o.prototype.ishrn = function(g, b, x) {
      return n(this.negative === 0), this.iushrn(g, b, x);
    }, o.prototype.shln = function(g) {
      return this.clone().ishln(g);
    }, o.prototype.ushln = function(g) {
      return this.clone().iushln(g);
    }, o.prototype.shrn = function(g) {
      return this.clone().ishrn(g);
    }, o.prototype.ushrn = function(g) {
      return this.clone().iushrn(g);
    }, o.prototype.testn = function(g) {
      n(typeof g == "number" && g >= 0);
      var b = g % 26, x = (g - b) / 26, S = 1 << b;
      if (this.length <= x)
        return !1;
      var I = this.words[x];
      return !!(I & S);
    }, o.prototype.imaskn = function(g) {
      n(typeof g == "number" && g >= 0);
      var b = g % 26, x = (g - b) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= x)
        return this;
      if (b !== 0 && x++, this.length = Math.min(x, this.length), b !== 0) {
        var S = 67108863 ^ 67108863 >>> b << b;
        this.words[this.length - 1] &= S;
      }
      return this._strip();
    }, o.prototype.maskn = function(g) {
      return this.clone().imaskn(g);
    }, o.prototype.iaddn = function(g) {
      return n(typeof g == "number"), n(g < 67108864), g < 0 ? this.isubn(-g) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= g ? (this.words[0] = g - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(g), this.negative = 1, this) : this._iaddn(g);
    }, o.prototype._iaddn = function(g) {
      this.words[0] += g;
      for (var b = 0; b < this.length && this.words[b] >= 67108864; b++)
        this.words[b] -= 67108864, b === this.length - 1 ? this.words[b + 1] = 1 : this.words[b + 1]++;
      return this.length = Math.max(this.length, b + 1), this;
    }, o.prototype.isubn = function(g) {
      if (n(typeof g == "number"), n(g < 67108864), g < 0)
        return this.iaddn(-g);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(g), this.negative = 1, this;
      if (this.words[0] -= g, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var b = 0; b < this.length && this.words[b] < 0; b++)
          this.words[b] += 67108864, this.words[b + 1] -= 1;
      return this._strip();
    }, o.prototype.addn = function(g) {
      return this.clone().iaddn(g);
    }, o.prototype.subn = function(g) {
      return this.clone().isubn(g);
    }, o.prototype.iabs = function() {
      return this.negative = 0, this;
    }, o.prototype.abs = function() {
      return this.clone().iabs();
    }, o.prototype._ishlnsubmul = function(g, b, x) {
      var S = g.length + x, I;
      this._expand(S);
      var N, p = 0;
      for (I = 0; I < g.length; I++) {
        N = (this.words[I + x] | 0) + p;
        var M = (g.words[I] | 0) * b;
        N -= M & 67108863, p = (N >> 26) - (M / 67108864 | 0), this.words[I + x] = N & 67108863;
      }
      for (; I < this.length - x; I++)
        N = (this.words[I + x] | 0) + p, p = N >> 26, this.words[I + x] = N & 67108863;
      if (p === 0)
        return this._strip();
      for (n(p === -1), p = 0, I = 0; I < this.length; I++)
        N = -(this.words[I] | 0) + p, p = N >> 26, this.words[I] = N & 67108863;
      return this.negative = 1, this._strip();
    }, o.prototype._wordDiv = function(g, b) {
      var x = this.length - g.length, S = this.clone(), I = g, N = I.words[I.length - 1] | 0, p = this._countBits(N);
      x = 26 - p, x !== 0 && (I = I.ushln(x), S.iushln(x), N = I.words[I.length - 1] | 0);
      var M = S.length - I.length, j;
      if (b !== "mod") {
        j = new o(null), j.length = M + 1, j.words = new Array(j.length);
        for (var U = 0; U < j.length; U++)
          j.words[U] = 0;
      }
      var H = S.clone()._ishlnsubmul(I, 1, M);
      H.negative === 0 && (S = H, j && (j.words[M] = 1));
      for (var J = M - 1; J >= 0; J--) {
        var te = (S.words[I.length + J] | 0) * 67108864 + (S.words[I.length + J - 1] | 0);
        for (te = Math.min(te / N | 0, 67108863), S._ishlnsubmul(I, te, J); S.negative !== 0; )
          te--, S.negative = 0, S._ishlnsubmul(I, 1, J), S.isZero() || (S.negative ^= 1);
        j && (j.words[J] = te);
      }
      return j && j._strip(), S._strip(), b !== "div" && x !== 0 && S.iushrn(x), { div: j || null, mod: S };
    }, o.prototype.divmod = function(g, b, x) {
      if (n(!g.isZero()), this.isZero())
        return { div: new o(0), mod: new o(0) };
      var S, I, N;
      return this.negative !== 0 && g.negative === 0 ? (N = this.neg().divmod(g, b), b !== "mod" && (S = N.div.neg()), b !== "div" && (I = N.mod.neg(), x && I.negative !== 0 && I.iadd(g)), { div: S, mod: I }) : this.negative === 0 && g.negative !== 0 ? (N = this.divmod(g.neg(), b), b !== "mod" && (S = N.div.neg()), { div: S, mod: N.mod }) : this.negative & g.negative ? (N = this.neg().divmod(g.neg(), b), b !== "div" && (I = N.mod.neg(), x && I.negative !== 0 && I.isub(g)), { div: N.div, mod: I }) : g.length > this.length || this.cmp(g) < 0 ? { div: new o(0), mod: this } : g.length === 1 ? b === "div" ? { div: this.divn(g.words[0]), mod: null } : b === "mod" ? { div: null, mod: new o(this.modrn(g.words[0])) } : { div: this.divn(g.words[0]), mod: new o(this.modrn(g.words[0])) } : this._wordDiv(g, b);
    }, o.prototype.div = function(g) {
      return this.divmod(g, "div", !1).div;
    }, o.prototype.mod = function(g) {
      return this.divmod(g, "mod", !1).mod;
    }, o.prototype.umod = function(g) {
      return this.divmod(g, "mod", !0).mod;
    }, o.prototype.divRound = function(g) {
      var b = this.divmod(g);
      if (b.mod.isZero())
        return b.div;
      var x = b.div.negative !== 0 ? b.mod.isub(g) : b.mod, S = g.ushrn(1), I = g.andln(1), N = x.cmp(S);
      return N < 0 || I === 1 && N === 0 ? b.div : b.div.negative !== 0 ? b.div.isubn(1) : b.div.iaddn(1);
    }, o.prototype.modrn = function(g) {
      var b = g < 0;
      b && (g = -g), n(g <= 67108863);
      for (var x = (1 << 26) % g, S = 0, I = this.length - 1; I >= 0; I--)
        S = (x * S + (this.words[I] | 0)) % g;
      return b ? -S : S;
    }, o.prototype.modn = function(g) {
      return this.modrn(g);
    }, o.prototype.idivn = function(g) {
      var b = g < 0;
      b && (g = -g), n(g <= 67108863);
      for (var x = 0, S = this.length - 1; S >= 0; S--) {
        var I = (this.words[S] | 0) + x * 67108864;
        this.words[S] = I / g | 0, x = I % g;
      }
      return this._strip(), b ? this.ineg() : this;
    }, o.prototype.divn = function(g) {
      return this.clone().idivn(g);
    }, o.prototype.egcd = function(g) {
      n(g.negative === 0), n(!g.isZero());
      var b = this, x = g.clone();
      b.negative !== 0 ? b = b.umod(g) : b = b.clone();
      for (var S = new o(1), I = new o(0), N = new o(0), p = new o(1), M = 0; b.isEven() && x.isEven(); )
        b.iushrn(1), x.iushrn(1), ++M;
      for (var j = x.clone(), U = b.clone(); !b.isZero(); ) {
        for (var H = 0, J = 1; !(b.words[0] & J) && H < 26; ++H, J <<= 1)
          ;
        if (H > 0)
          for (b.iushrn(H); H-- > 0; )
            (S.isOdd() || I.isOdd()) && (S.iadd(j), I.isub(U)), S.iushrn(1), I.iushrn(1);
        for (var te = 0, ae = 1; !(x.words[0] & ae) && te < 26; ++te, ae <<= 1)
          ;
        if (te > 0)
          for (x.iushrn(te); te-- > 0; )
            (N.isOdd() || p.isOdd()) && (N.iadd(j), p.isub(U)), N.iushrn(1), p.iushrn(1);
        b.cmp(x) >= 0 ? (b.isub(x), S.isub(N), I.isub(p)) : (x.isub(b), N.isub(S), p.isub(I));
      }
      return { a: N, b: p, gcd: x.iushln(M) };
    }, o.prototype._invmp = function(g) {
      n(g.negative === 0), n(!g.isZero());
      var b = this, x = g.clone();
      b.negative !== 0 ? b = b.umod(g) : b = b.clone();
      for (var S = new o(1), I = new o(0), N = x.clone(); b.cmpn(1) > 0 && x.cmpn(1) > 0; ) {
        for (var p = 0, M = 1; !(b.words[0] & M) && p < 26; ++p, M <<= 1)
          ;
        if (p > 0)
          for (b.iushrn(p); p-- > 0; )
            S.isOdd() && S.iadd(N), S.iushrn(1);
        for (var j = 0, U = 1; !(x.words[0] & U) && j < 26; ++j, U <<= 1)
          ;
        if (j > 0)
          for (x.iushrn(j); j-- > 0; )
            I.isOdd() && I.iadd(N), I.iushrn(1);
        b.cmp(x) >= 0 ? (b.isub(x), S.isub(I)) : (x.isub(b), I.isub(S));
      }
      var H;
      return b.cmpn(1) === 0 ? H = S : H = I, H.cmpn(0) < 0 && H.iadd(g), H;
    }, o.prototype.gcd = function(g) {
      if (this.isZero())
        return g.abs();
      if (g.isZero())
        return this.abs();
      var b = this.clone(), x = g.clone();
      b.negative = 0, x.negative = 0;
      for (var S = 0; b.isEven() && x.isEven(); S++)
        b.iushrn(1), x.iushrn(1);
      do {
        for (; b.isEven(); )
          b.iushrn(1);
        for (; x.isEven(); )
          x.iushrn(1);
        var I = b.cmp(x);
        if (I < 0) {
          var N = b;
          b = x, x = N;
        } else if (I === 0 || x.cmpn(1) === 0)
          break;
        b.isub(x);
      } while (!0);
      return x.iushln(S);
    }, o.prototype.invm = function(g) {
      return this.egcd(g).a.umod(g);
    }, o.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, o.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, o.prototype.andln = function(g) {
      return this.words[0] & g;
    }, o.prototype.bincn = function(g) {
      n(typeof g == "number");
      var b = g % 26, x = (g - b) / 26, S = 1 << b;
      if (this.length <= x)
        return this._expand(x + 1), this.words[x] |= S, this;
      for (var I = S, N = x; I !== 0 && N < this.length; N++) {
        var p = this.words[N] | 0;
        p += I, I = p >>> 26, p &= 67108863, this.words[N] = p;
      }
      return I !== 0 && (this.words[N] = I, this.length++), this;
    }, o.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, o.prototype.cmpn = function(g) {
      var b = g < 0;
      if (this.negative !== 0 && !b)
        return -1;
      if (this.negative === 0 && b)
        return 1;
      this._strip();
      var x;
      if (this.length > 1)
        x = 1;
      else {
        b && (g = -g), n(g <= 67108863, "Number is too big");
        var S = this.words[0] | 0;
        x = S === g ? 0 : S < g ? -1 : 1;
      }
      return this.negative !== 0 ? -x | 0 : x;
    }, o.prototype.cmp = function(g) {
      if (this.negative !== 0 && g.negative === 0)
        return -1;
      if (this.negative === 0 && g.negative !== 0)
        return 1;
      var b = this.ucmp(g);
      return this.negative !== 0 ? -b | 0 : b;
    }, o.prototype.ucmp = function(g) {
      if (this.length > g.length)
        return 1;
      if (this.length < g.length)
        return -1;
      for (var b = 0, x = this.length - 1; x >= 0; x--) {
        var S = this.words[x] | 0, I = g.words[x] | 0;
        if (S !== I) {
          S < I ? b = -1 : S > I && (b = 1);
          break;
        }
      }
      return b;
    }, o.prototype.gtn = function(g) {
      return this.cmpn(g) === 1;
    }, o.prototype.gt = function(g) {
      return this.cmp(g) === 1;
    }, o.prototype.gten = function(g) {
      return this.cmpn(g) >= 0;
    }, o.prototype.gte = function(g) {
      return this.cmp(g) >= 0;
    }, o.prototype.ltn = function(g) {
      return this.cmpn(g) === -1;
    }, o.prototype.lt = function(g) {
      return this.cmp(g) === -1;
    }, o.prototype.lten = function(g) {
      return this.cmpn(g) <= 0;
    }, o.prototype.lte = function(g) {
      return this.cmp(g) <= 0;
    }, o.prototype.eqn = function(g) {
      return this.cmpn(g) === 0;
    }, o.prototype.eq = function(g) {
      return this.cmp(g) === 0;
    }, o.red = function(g) {
      return new V(g);
    }, o.prototype.toRed = function(g) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), g.convertTo(this)._forceRed(g);
    }, o.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, o.prototype._forceRed = function(g) {
      return this.red = g, this;
    }, o.prototype.forceRed = function(g) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(g);
    }, o.prototype.redAdd = function(g) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, g);
    }, o.prototype.redIAdd = function(g) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, g);
    }, o.prototype.redSub = function(g) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, g);
    }, o.prototype.redISub = function(g) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, g);
    }, o.prototype.redShl = function(g) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, g);
    }, o.prototype.redMul = function(g) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, g), this.red.mul(this, g);
    }, o.prototype.redIMul = function(g) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, g), this.red.imul(this, g);
    }, o.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, o.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, o.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, o.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, o.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, o.prototype.redPow = function(g) {
      return n(this.red && !g.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, g);
    };
    var L = { k256: null, p224: null, p192: null, p25519: null };
    function F(T, g) {
      this.name = T, this.p = new o(g, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    F.prototype._tmp = function() {
      var g = new o(null);
      return g.words = new Array(Math.ceil(this.n / 13)), g;
    }, F.prototype.ireduce = function(g) {
      var b = g, x;
      do
        this.split(b, this.tmp), b = this.imulK(b), b = b.iadd(this.tmp), x = b.bitLength();
      while (x > this.n);
      var S = x < this.n ? -1 : b.ucmp(this.p);
      return S === 0 ? (b.words[0] = 0, b.length = 1) : S > 0 ? b.isub(this.p) : b.strip !== void 0 ? b.strip() : b._strip(), b;
    }, F.prototype.split = function(g, b) {
      g.iushrn(this.n, 0, b);
    }, F.prototype.imulK = function(g) {
      return g.imul(this.k);
    };
    function B() {
      F.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    a(B, F), B.prototype.split = function(g, b) {
      for (var x = 4194303, S = Math.min(g.length, 9), I = 0; I < S; I++)
        b.words[I] = g.words[I];
      if (b.length = S, g.length <= 9) {
        g.words[0] = 0, g.length = 1;
        return;
      }
      var N = g.words[9];
      for (b.words[b.length++] = N & x, I = 10; I < g.length; I++) {
        var p = g.words[I] | 0;
        g.words[I - 10] = (p & x) << 4 | N >>> 22, N = p;
      }
      N >>>= 22, g.words[I - 10] = N, N === 0 && g.length > 10 ? g.length -= 10 : g.length -= 9;
    }, B.prototype.imulK = function(g) {
      g.words[g.length] = 0, g.words[g.length + 1] = 0, g.length += 2;
      for (var b = 0, x = 0; x < g.length; x++) {
        var S = g.words[x] | 0;
        b += S * 977, g.words[x] = b & 67108863, b = S * 64 + (b / 67108864 | 0);
      }
      return g.words[g.length - 1] === 0 && (g.length--, g.words[g.length - 1] === 0 && g.length--), g;
    };
    function G() {
      F.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    a(G, F);
    function Z() {
      F.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    a(Z, F);
    function X() {
      F.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    a(X, F), X.prototype.imulK = function(g) {
      for (var b = 0, x = 0; x < g.length; x++) {
        var S = (g.words[x] | 0) * 19 + b, I = S & 67108863;
        S >>>= 26, g.words[x] = I, b = S;
      }
      return b !== 0 && (g.words[g.length++] = b), g;
    }, o._prime = function(g) {
      if (L[g])
        return L[g];
      var b;
      if (g === "k256")
        b = new B();
      else if (g === "p224")
        b = new G();
      else if (g === "p192")
        b = new Z();
      else if (g === "p25519")
        b = new X();
      else
        throw new Error("Unknown prime " + g);
      return L[g] = b, b;
    };
    function V(T) {
      if (typeof T == "string") {
        var g = o._prime(T);
        this.m = g.p, this.prime = g;
      } else
        n(T.gtn(1), "modulus must be greater than 1"), this.m = T, this.prime = null;
    }
    V.prototype._verify1 = function(g) {
      n(g.negative === 0, "red works only with positives"), n(g.red, "red works only with red numbers");
    }, V.prototype._verify2 = function(g, b) {
      n((g.negative | b.negative) === 0, "red works only with positives"), n(g.red && g.red === b.red, "red works only with red numbers");
    }, V.prototype.imod = function(g) {
      return this.prime ? this.prime.ireduce(g)._forceRed(this) : (m(g, g.umod(this.m)._forceRed(this)), g);
    }, V.prototype.neg = function(g) {
      return g.isZero() ? g.clone() : this.m.sub(g)._forceRed(this);
    }, V.prototype.add = function(g, b) {
      this._verify2(g, b);
      var x = g.add(b);
      return x.cmp(this.m) >= 0 && x.isub(this.m), x._forceRed(this);
    }, V.prototype.iadd = function(g, b) {
      this._verify2(g, b);
      var x = g.iadd(b);
      return x.cmp(this.m) >= 0 && x.isub(this.m), x;
    }, V.prototype.sub = function(g, b) {
      this._verify2(g, b);
      var x = g.sub(b);
      return x.cmpn(0) < 0 && x.iadd(this.m), x._forceRed(this);
    }, V.prototype.isub = function(g, b) {
      this._verify2(g, b);
      var x = g.isub(b);
      return x.cmpn(0) < 0 && x.iadd(this.m), x;
    }, V.prototype.shl = function(g, b) {
      return this._verify1(g), this.imod(g.ushln(b));
    }, V.prototype.imul = function(g, b) {
      return this._verify2(g, b), this.imod(g.imul(b));
    }, V.prototype.mul = function(g, b) {
      return this._verify2(g, b), this.imod(g.mul(b));
    }, V.prototype.isqr = function(g) {
      return this.imul(g, g.clone());
    }, V.prototype.sqr = function(g) {
      return this.mul(g, g);
    }, V.prototype.sqrt = function(g) {
      if (g.isZero())
        return g.clone();
      var b = this.m.andln(3);
      if (n(b % 2 === 1), b === 3) {
        var x = this.m.add(new o(1)).iushrn(2);
        return this.pow(g, x);
      }
      for (var S = this.m.subn(1), I = 0; !S.isZero() && S.andln(1) === 0; )
        I++, S.iushrn(1);
      n(!S.isZero());
      var N = new o(1).toRed(this), p = N.redNeg(), M = this.m.subn(1).iushrn(1), j = this.m.bitLength();
      for (j = new o(2 * j * j).toRed(this); this.pow(j, M).cmp(p) !== 0; )
        j.redIAdd(p);
      for (var U = this.pow(j, S), H = this.pow(g, S.addn(1).iushrn(1)), J = this.pow(g, S), te = I; J.cmp(N) !== 0; ) {
        for (var ae = J, le = 0; ae.cmp(N) !== 0; le++)
          ae = ae.redSqr();
        n(le < te);
        var ne = this.pow(U, new o(1).iushln(te - le - 1));
        H = H.redMul(ne), U = ne.redSqr(), J = J.redMul(U), te = le;
      }
      return H;
    }, V.prototype.invm = function(g) {
      var b = g._invmp(this.m);
      return b.negative !== 0 ? (b.negative = 0, this.imod(b).redNeg()) : this.imod(b);
    }, V.prototype.pow = function(g, b) {
      if (b.isZero())
        return new o(1).toRed(this);
      if (b.cmpn(1) === 0)
        return g.clone();
      var x = 4, S = new Array(1 << x);
      S[0] = new o(1).toRed(this), S[1] = g;
      for (var I = 2; I < S.length; I++)
        S[I] = this.mul(S[I - 1], g);
      var N = S[0], p = 0, M = 0, j = b.bitLength() % 26;
      for (j === 0 && (j = 26), I = b.length - 1; I >= 0; I--) {
        for (var U = b.words[I], H = j - 1; H >= 0; H--) {
          var J = U >> H & 1;
          if (N !== S[0] && (N = this.sqr(N)), J === 0 && p === 0) {
            M = 0;
            continue;
          }
          p <<= 1, p |= J, M++, !(M !== x && (I !== 0 || H !== 0)) && (N = this.mul(N, S[p]), M = 0, p = 0);
        }
        j = 26;
      }
      return N;
    }, V.prototype.convertTo = function(g) {
      var b = g.umod(this.m);
      return b === g ? b.clone() : b;
    }, V.prototype.convertFrom = function(g) {
      var b = g.clone();
      return b.red = null, b;
    }, o.mont = function(g) {
      return new E(g);
    };
    function E(T) {
      V.call(this, T), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    a(E, V), E.prototype.convertTo = function(g) {
      return this.imod(g.ushln(this.shift));
    }, E.prototype.convertFrom = function(g) {
      var b = this.imod(g.mul(this.rinv));
      return b.red = null, b;
    }, E.prototype.imul = function(g, b) {
      if (g.isZero() || b.isZero())
        return g.words[0] = 0, g.length = 1, g;
      var x = g.imul(b), S = x.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), I = x.isub(S).iushrn(this.shift), N = I;
      return I.cmp(this.m) >= 0 ? N = I.isub(this.m) : I.cmpn(0) < 0 && (N = I.iadd(this.m)), N._forceRed(this);
    }, E.prototype.mul = function(g, b) {
      if (g.isZero() || b.isZero())
        return new o(0)._forceRed(this);
      var x = g.mul(b), S = x.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), I = x.isub(S).iushrn(this.shift), N = I;
      return I.cmp(this.m) >= 0 ? N = I.isub(this.m) : I.cmpn(0) < 0 && (N = I.iadd(this.m)), N._forceRed(this);
    }, E.prototype.invm = function(g) {
      var b = this.imod(g._invmp(this.m).mul(this.r2));
      return b._forceRed(this);
    };
  })(e, commonjsGlobal);
})(bn);
var hasRequiredSignature;
function requireSignature() {
  if (hasRequiredSignature)
    return Signature;
  hasRequiredSignature = 1, Object.defineProperty(Signature, "__esModule", { value: !0 }), Signature.Signature = void 0;
  var e = bnExports, t = eosjsNumeric, i = requireEosjsKeyConversions(), n = (
    /** @class */
    function() {
      function a(o, l) {
        this.signature = o, this.ec = l;
      }
      return a.fromString = function(o, l) {
        var c = t.stringToSignature(o);
        return l || (l = i.constructElliptic(c.type)), new a(c, l);
      }, a.fromElliptic = function(o, l, c) {
        var d = o.r.toArray("be", 32), u = o.s.toArray("be", 32), m;
        l === t.KeyType.k1 || l === t.KeyType.r1 ? (m = o.recoveryParam + 27, o.recoveryParam <= 3 && (m += 4)) : l === t.KeyType.wa && (m = o.recoveryParam);
        var A = new Uint8Array([m].concat(d, u));
        return c || (c = i.constructElliptic(l)), new a({ type: l, data: A }, c);
      }, a.prototype.toElliptic = function() {
        var o = 32, l = 32, c = new e(this.signature.data.slice(1, o + 1)), d = new e(this.signature.data.slice(o + 1, o + l + 1)), u;
        this.signature.type === t.KeyType.k1 || this.signature.type === t.KeyType.r1 ? (u = this.signature.data[0] - 27, u > 3 && (u -= 4)) : this.signature.type === t.KeyType.wa && (u = this.signature.data[0]);
        var m = u & 3;
        return { r: c, s: d, recoveryParam: m };
      }, a.prototype.toString = function() {
        return t.signatureToString(this.signature);
      }, a.prototype.toBinary = function() {
        return this.signature.data;
      }, a.prototype.getType = function() {
        return this.signature.type;
      }, a.prototype.verify = function(o, l, c, d) {
        c === void 0 && (c = !0), d === void 0 && (d = "utf8"), c && (typeof o == "string" && (o = Buffer.from(o, d)), o = this.ec.hash().update(o).digest());
        var u = this.toElliptic(), m = l.toElliptic();
        return this.ec.verify(o, u, m, d);
      }, a.prototype.recover = function(o, l, c) {
        l === void 0 && (l = !0), c === void 0 && (c = "utf8"), l && (typeof o == "string" && (o = Buffer.from(o, c)), o = this.ec.hash().update(o).digest());
        var d = this.toElliptic(), u = this.ec.recoverPubKey(o, d, d.recoveryParam, c), m = this.ec.keyFromPublic(u);
        return i.PublicKey.fromElliptic(m, this.getType(), this.ec);
      }, a;
    }()
  );
  return Signature.Signature = n, Signature;
}
var hasRequiredEosjsKeyConversions;
function requireEosjsKeyConversions() {
  return hasRequiredEosjsKeyConversions || (hasRequiredEosjsKeyConversions = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.sha256 = e.generateKeyPair = e.constructElliptic = e.Signature = e.PublicKey = e.PrivateKey = void 0;
    var t = elliptic, i = hash$2, n = eosjsNumeric, a = requirePublicKey(), o = requirePrivateKey(), l = requirePrivateKey();
    Object.defineProperty(e, "PrivateKey", { enumerable: !0, get: function() {
      return l.PrivateKey;
    } });
    var c = requirePublicKey();
    Object.defineProperty(e, "PublicKey", { enumerable: !0, get: function() {
      return c.PublicKey;
    } });
    var d = requireSignature();
    Object.defineProperty(e, "Signature", { enumerable: !0, get: function() {
      return d.Signature;
    } });
    var u = function(y) {
      return y === n.KeyType.k1 ? new t.ec("secp256k1") : new t.ec("p256");
    };
    e.constructElliptic = u;
    var m = function(y, D) {
      if (D === void 0 && (D = {}), !D.secureEnv)
        throw new Error("Key generation is completely INSECURE in production environments in the browser. If you are absolutely certain this does NOT describe your environment, set `secureEnv` in your options to `true`.  If this does describe your environment and you set `secureEnv` to `true`, YOU DO SO AT YOUR OWN RISK AND THE RISK OF YOUR USERS.");
      var C;
      y === n.KeyType.k1 ? C = new t.ec("secp256k1") : C = new t.ec("p256");
      var z = C.genKeyPair(D.ecOptions), R = a.PublicKey.fromElliptic(z, y, C), O = o.PrivateKey.fromElliptic(z, y, C);
      return { publicKey: R, privateKey: O };
    };
    e.generateKeyPair = m;
    var A = function(y) {
      return i.sha256().update(y).digest();
    };
    e.sha256 = A;
  }(eosjsKeyConversions)), eosjsKeyConversions;
}
(function(e) {
  var t = commonjsGlobal && commonjsGlobal.__awaiter || function(m, A, y, D) {
    function C(z) {
      return z instanceof y ? z : new y(function(R) {
        R(z);
      });
    }
    return new (y || (y = Promise))(function(z, R) {
      function O(P) {
        try {
          k(D.next(P));
        } catch (L) {
          R(L);
        }
      }
      function $(P) {
        try {
          k(D.throw(P));
        } catch (L) {
          R(L);
        }
      }
      function k(P) {
        P.done ? z(P.value) : C(P.value).then(O, $);
      }
      k((D = D.apply(m, A || [])).next());
    });
  }, i = commonjsGlobal && commonjsGlobal.__generator || function(m, A) {
    var y = { label: 0, sent: function() {
      if (z[0] & 1)
        throw z[1];
      return z[1];
    }, trys: [], ops: [] }, D, C, z, R;
    return R = { next: O(0), throw: O(1), return: O(2) }, typeof Symbol == "function" && (R[Symbol.iterator] = function() {
      return this;
    }), R;
    function O(k) {
      return function(P) {
        return $([k, P]);
      };
    }
    function $(k) {
      if (D)
        throw new TypeError("Generator is already executing.");
      for (; y; )
        try {
          if (D = 1, C && (z = k[0] & 2 ? C.return : k[0] ? C.throw || ((z = C.return) && z.call(C), 0) : C.next) && !(z = z.call(C, k[1])).done)
            return z;
          switch (C = 0, z && (k = [k[0] & 2, z.value]), k[0]) {
            case 0:
            case 1:
              z = k;
              break;
            case 4:
              return y.label++, { value: k[1], done: !1 };
            case 5:
              y.label++, C = k[1], k = [0];
              continue;
            case 7:
              k = y.ops.pop(), y.trys.pop();
              continue;
            default:
              if (z = y.trys, !(z = z.length > 0 && z[z.length - 1]) && (k[0] === 6 || k[0] === 2)) {
                y = 0;
                continue;
              }
              if (k[0] === 3 && (!z || k[1] > z[0] && k[1] < z[3])) {
                y.label = k[1];
                break;
              }
              if (k[0] === 6 && y.label < z[1]) {
                y.label = z[1], z = k;
                break;
              }
              if (z && y.label < z[2]) {
                y.label = z[2], y.ops.push(k);
                break;
              }
              z[2] && y.ops.pop(), y.trys.pop();
              continue;
          }
          k = A.call(m, y);
        } catch (P) {
          k = [6, P], C = 0;
        } finally {
          D = z = 0;
        }
      if (k[0] & 5)
        throw k[1];
      return { value: k[0] ? k[1] : void 0, done: !0 };
    }
  }, n = commonjsGlobal && commonjsGlobal.__values || function(m) {
    var A = typeof Symbol == "function" && Symbol.iterator, y = A && m[A], D = 0;
    if (y)
      return y.call(m);
    if (m && typeof m.length == "number")
      return { next: function() {
        return m && D >= m.length && (m = void 0), { value: m && m[D++], done: !m };
      } };
    throw new TypeError(A ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.JsSignatureProvider = e.digestFromSerializedData = e.Signature = e.PublicKey = e.PrivateKey = void 0;
  var a = elliptic, o = requireEosjsKeyConversions();
  Object.defineProperty(e, "PrivateKey", { enumerable: !0, get: function() {
    return o.PrivateKey;
  } }), Object.defineProperty(e, "PublicKey", { enumerable: !0, get: function() {
    return o.PublicKey;
  } }), Object.defineProperty(e, "Signature", { enumerable: !0, get: function() {
    return o.Signature;
  } });
  var l = eosjsNumeric, c = new a.ec("secp256k1"), d = function(m, A, y, D) {
    D === void 0 && (D = c);
    var C = Buffer.concat([Buffer.from(m, "hex"), Buffer.from(A), Buffer.from(y ? new Uint8Array(D.hash().update(y).digest()) : new Uint8Array(32))]);
    return D.hash().update(C).digest();
  };
  e.digestFromSerializedData = d;
  var u = (
    /** @class */
    function() {
      function m(A) {
        var y, D;
        this.keys = /* @__PURE__ */ new Map(), this.availableKeys = [];
        try {
          for (var C = n(A), z = C.next(); !z.done; z = C.next()) {
            var R = z.value, O = o.PrivateKey.fromString(R), $ = O.toElliptic(), k = O.getPublicKey().toString();
            this.keys.set(k, $), this.availableKeys.push(k);
          }
        } catch (P) {
          y = { error: P };
        } finally {
          try {
            z && !z.done && (D = C.return) && D.call(C);
          } finally {
            if (y)
              throw y.error;
          }
        }
      }
      return m.prototype.getAvailableKeys = function() {
        return t(this, void 0, void 0, function() {
          return i(this, function(A) {
            return [2, this.availableKeys];
          });
        });
      }, m.prototype.sign = function(A) {
        var y = A.chainId, D = A.requiredKeys, C = A.serializedTransaction, z = A.serializedContextFreeData;
        return t(this, void 0, void 0, function() {
          var R, O, $, k, P, L, F, B, G, Z, X;
          return i(this, function(V) {
            R = d(y, C, z, c), O = [];
            try {
              for ($ = n(D), k = $.next(); !k.done; k = $.next())
                P = k.value, L = o.PublicKey.fromString(P), F = this.keys.get(l.convertLegacyPublicKey(P)), B = o.PrivateKey.fromElliptic(F, L.getType()), G = B.sign(R, !1), O.push(G.toString());
            } catch (E) {
              Z = { error: E };
            } finally {
              try {
                k && !k.done && (X = $.return) && X.call($);
              } finally {
                if (Z)
                  throw Z.error;
              }
            }
            return [2, { signatures: O, serializedTransaction: C, serializedContextFreeData: z }];
          });
        });
      }, m;
    }()
  );
  e.JsSignatureProvider = u;
})(eosjsJssig);
Object.defineProperty(eosjsEccMigration, "__esModule", { value: !0 });
eosjsEccMigration.ecc = void 0;
var eosjs_jssig_1 = eosjsJssig, eosjs_key_conversions_1 = requireEosjsKeyConversions(), eosjs_numeric_1 = eosjsNumeric;
eosjsEccMigration.ecc = { initialize: function() {
  return console.error("Method deprecated");
}, unsafeRandomKey: function() {
  return console.error("Method deprecated");
}, randomKey: function(e, t) {
  t === void 0 && (t = {}), e !== void 0 && console.warn("Argument `cpuEntropyBits` is deprecated, use the options argument instead");
  var i = eosjs_key_conversions_1.generateKeyPair(eosjs_numeric_1.KeyType.k1, t).privateKey;
  return Promise.resolve(i.toLegacyString());
}, seedPrivate: function() {
  return console.error("Method deprecated");
}, privateToPublic: function(e, t) {
  t !== void 0 && console.warn("Argument `pubkey_prefix` is deprecated, keys prefixed with PUB_K1_/PUB_R1_/PUB_WA_ going forward");
  var i = eosjs_jssig_1.PrivateKey.fromString(e), n = i.getPublicKey();
  return n.toLegacyString();
}, isValidPublic: function(e, t) {
  t !== void 0 && console.warn("Argument `pubkey_prefix` is deprecated, keys prefixed with PUB_K1_/PUB_R1_/PUB_WA_ going forward");
  try {
    var i = eosjs_jssig_1.PublicKey.fromString(e);
    return i.isValid();
  } catch {
    return !1;
  }
}, isValidPrivate: function(e) {
  try {
    var t = eosjs_jssig_1.PrivateKey.fromString(e);
    return t.isValid();
  } catch {
    return !1;
  }
}, sign: function(e, t, i) {
  i === void 0 && (i = "utf8");
  var n = typeof t == "string" ? eosjs_jssig_1.PrivateKey.fromString(t) : t, a = n.sign(e, !0, i);
  return a.toString();
}, signHash: function(e, t, i) {
  i === void 0 && (i = "hex");
  var n = typeof t == "string" ? eosjs_jssig_1.PrivateKey.fromString(t) : t, a = n.sign(e, !1, i);
  return a.toString();
}, verify: function(e, t, i, n, a) {
  n === void 0 && (n = "utf8"), a === void 0 && (a = !0);
  var o = typeof i == "string" ? eosjs_jssig_1.PublicKey.fromString(i) : i, l = eosjs_jssig_1.Signature.fromString(e);
  return l.verify(t, o, a, n);
}, recover: function(e, t, i) {
  i === void 0 && (i = "utf8");
  var n = eosjs_jssig_1.Signature.fromString(e), a = n.recover(t, !0, i);
  return a.toLegacyString();
}, recoverHash: function(e, t, i) {
  i === void 0 && (i = "hex");
  var n = eosjs_jssig_1.Signature.fromString(e), a = n.recover(t, !1, i);
  return a.toLegacyString();
}, sha256: function(e, t, i) {
  return i !== void 0 && console.warn("Argument `encoding` is deprecated"), t !== void 0 && console.warn("Argument `resultEncoding` is deprecated"), requireEosjsKeyConversions().sha256(e);
} };
var WaxSigningApi$1 = {}, WaxEventSource$1 = {}, __awaiter$2 = commonjsGlobal && commonjsGlobal.__awaiter || function(e, t, i, n) {
  function a(o) {
    return o instanceof i ? o : new i(function(l) {
      l(o);
    });
  }
  return new (i || (i = Promise))(function(o, l) {
    function c(m) {
      try {
        u(n.next(m));
      } catch (A) {
        l(A);
      }
    }
    function d(m) {
      try {
        u(n.throw(m));
      } catch (A) {
        l(A);
      }
    }
    function u(m) {
      m.done ? o(m.value) : a(m.value).then(c, d);
    }
    u((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(WaxEventSource$1, "__esModule", { value: !0 });
WaxEventSource$1.WaxEventSource = void 0;
class WaxEventSource {
  constructor(t) {
    this.waxSigningURL = t, this.timeout = () => __awaiter$2(this, void 0, void 0, function* () {
      return new Promise((i, n) => setTimeout(() => n(new Error("Timeout")), 5e3));
    }), this.openEventSource = this.openEventSource.bind(this), this.onceEvent = this.onceEvent.bind(this);
  }
  openPopup(t) {
    return __awaiter$2(this, void 0, void 0, function* () {
      const i = yield window.open(t, "WaxPopup", "height=800,width=600");
      if (i)
        return i;
      throw new Error("Unable to open popup window");
    });
  }
  openEventSource(t, i, n) {
    return __awaiter$2(this, void 0, void 0, function* () {
      const a = n || (yield this.openPopup(t));
      if (!a)
        throw new Error("Unable to open a popup window");
      if (typeof i > "u")
        return a;
      const o = (c) => __awaiter$2(this, void 0, void 0, function* () {
        c.data.type === "READY" && a.postMessage(i, this.waxSigningURL);
      }), l = this.onceEvent(a, this.waxSigningURL, o, "READY");
      return yield Promise.race([l, this.timeout()]).catch((c) => {
        if (c.message !== "Timeout")
          throw c;
        a.postMessage(i, this.waxSigningURL);
      }), a;
    });
  }
  onceEvent(t, i, n, a) {
    return __awaiter$2(this, void 0, void 0, function* () {
      return new Promise((o, l) => {
        let c = !1;
        window.addEventListener("message", function u(m) {
          return __awaiter$2(this, void 0, void 0, function* () {
            if (m.origin === i && m.source === t && typeof m.data == "object" && !(a && (!m.data.type || m.data.type !== a))) {
              try {
                c = !0, o(yield n(m));
              } catch (A) {
                c = !0, l(A);
              }
              window.removeEventListener("message", u, !1);
            }
          });
        }, !1);
        const d = setInterval(() => {
          t.closed && !c && (clearInterval(d), l("user closed the window"));
        }, 1e3);
      });
    });
  }
}
WaxEventSource$1.WaxEventSource = WaxEventSource;
var __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || function(e, t, i, n) {
  function a(o) {
    return o instanceof i ? o : new i(function(l) {
      l(o);
    });
  }
  return new (i || (i = Promise))(function(o, l) {
    function c(m) {
      try {
        u(n.next(m));
      } catch (A) {
        l(A);
      }
    }
    function d(m) {
      try {
        u(n.throw(m));
      } catch (A) {
        l(A);
      }
    }
    function u(m) {
      m.done ? o(m.value) : a(m.value).then(c, d);
    }
    u((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(WaxSigningApi$1, "__esModule", { value: !0 });
WaxSigningApi$1.WaxSigningApi = void 0;
const WaxEventSource_1 = WaxEventSource$1;
function getCurrentTime() {
  return Math.floor((/* @__PURE__ */ new Date()).getTime());
}
class WaxSigningApi {
  constructor(t, i, n, a) {
    this.waxSigningURL = t, this.waxAutoSigningURL = i, this.metricURL = n, this.returnTempAccount = a, this.waxEventSource = new WaxEventSource_1.WaxEventSource(t), this.metricURL = n, this.returnTempAccount = a;
  }
  logout() {
    this.user = null;
  }
  login() {
    return __awaiter$1(this, void 0, void 0, function* () {
      if (this.user || (yield this.loginViaWindow()), this.user)
        return this.user;
      throw new Error("Login failed");
    });
  }
  tryAutologin() {
    return __awaiter$1(this, void 0, void 0, function* () {
      if (this.user)
        return !0;
      try {
        return yield this.loginViaEndpoint(), !0;
      } catch {
        return !1;
      }
    });
  }
  prepareTransaction(t) {
    return __awaiter$1(this, void 0, void 0, function* () {
      this.canAutoSign(t) || (this.signingWindow = yield this.waxEventSource.openPopup(`${this.waxSigningURL}/cloud-wallet/signing/`));
    });
  }
  metricLog(t) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return __awaiter$1(this, void 0, void 0, function* () {
      try {
        this.metricURL !== "" && (yield fetch(this.metricURL, { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify({ name: t, value: i, tags: n }) }));
      } catch (a) {
        console.debug(a);
      }
    });
  }
  signing(t, i) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
    return __awaiter$1(this, void 0, void 0, function* () {
      if (this.canAutoSign(t))
        try {
          const o = getCurrentTime(), l = yield this.signViaEndpoint(i, n, a);
          return yield this.metricLog("waxjs.metric.auto_signing", getCurrentTime() - o, []), l;
        } catch {
        }
      return yield this.signViaWindow(i, this.signingWindow, n, a);
    });
  }
  proofWindow(t, i, n) {
    return __awaiter$1(this, void 0, void 0, function* () {
      const a = `${this.waxSigningURL}/cloud-wallet/verify`, o = yield this.waxEventSource.openEventSource(a, { type: "VERIFY", nonce: t, proof_type: i, description: n });
      return this.waxEventSource.onceEvent(o, this.waxSigningURL, this.receiveVerfication.bind(this), void 0);
    });
  }
  loginViaWindow() {
    return __awaiter$1(this, void 0, void 0, function* () {
      const t = new URL(`${this.waxSigningURL}/cloud-wallet/login/`);
      this.returnTempAccount ? t.search = "returnTemp=true" : t.search = "";
      const i = yield this.waxEventSource.openEventSource(t.toString());
      return this.waxEventSource.onceEvent(i, this.waxSigningURL, this.receiveLogin.bind(this), void 0);
    });
  }
  loginViaEndpoint() {
    return __awaiter$1(this, void 0, void 0, function* () {
      const t = new URL(`${this.waxAutoSigningURL}login`);
      this.returnTempAccount ? t.search = "returnTemp=true" : t.search = "";
      const i = yield fetch(t.toString(), { credentials: "include", method: "get" });
      if (!i.ok)
        throw new Error(`Login Endpoint Error ${i.status} ${i.statusText}`);
      const n = yield i.json();
      if (n.processed && n.processed.except)
        throw new Error(n);
      return this.receiveLogin({ data: n });
    });
  }
  signViaEndpoint(t) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    return __awaiter$1(this, void 0, void 0, function* () {
      const a = new AbortController();
      setTimeout(() => a.abort(), 5e3);
      const o = yield fetch(`${this.waxAutoSigningURL}signing`, { body: JSON.stringify({ freeBandwidth: !i, feeFallback: n, transaction: Object.values(t) }), credentials: "include", headers: { "Content-Type": "application/json" }, method: "POST", signal: a.signal });
      if (!o.ok)
        throw this.whitelistedContracts = [], new Error(`Signing Endpoint Error ${o.status} ${o.statusText}`);
      const l = yield o.json();
      if (l.processed && l.processed.except)
        throw this.whitelistedContracts = [], new Error(`Error returned from signing endpoint: ${JSON.stringify(l)}`);
      return this.receiveSignatures({ data: l });
    });
  }
  receiveVerfication(t) {
    if (t.data.type === "DENY")
      throw new Error("User Denied Verification");
    return Object.assign({}, t.data);
  }
  signViaWindow(t, i) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
    return __awaiter$1(this, void 0, void 0, function* () {
      const o = getCurrentTime(), l = yield this.waxEventSource.openEventSource(`${this.waxSigningURL}/cloud-wallet/signing/`, { startTime: o, feeFallback: a, freeBandwidth: !n, transaction: t, type: "TRANSACTION" }, i);
      return this.waxEventSource.onceEvent(l, this.waxSigningURL, this.receiveSignatures.bind(this), "TX_SIGNED");
    });
  }
  receiveLogin(t) {
    return __awaiter$1(this, void 0, void 0, function* () {
      const { verified: i, userAccount: n, pubKeys: a, whitelistedContracts: o, isTemp: l, createData: c } = t.data;
      if (!i)
        throw new Error("User declined to share their user account");
      if (!n || !a)
        throw new Error("User does not have a blockchain account");
      return this.whitelistedContracts = o || [], this.user = { account: n, keys: a, isTemp: l, createData: c }, !0;
    });
  }
  receiveSignatures(t) {
    return __awaiter$1(this, void 0, void 0, function* () {
      if (t.data.type === "TX_SIGNED") {
        const { verified: i, signatures: n, whitelistedContracts: a, serializedTransaction: o, startTime: l } = t.data;
        if (!i || !n)
          throw new Error("User declined to sign the transaction");
        return this.whitelistedContracts = a || [], l && l > 0 && this.metricLog("waxjs.metric.manual_sign_transaction_time", getCurrentTime() - l, []), { serializedTransaction: o, signatures: n };
      }
      throw new Error(`Unexpected response received when attempting signing: ${JSON.stringify(t.data)}`);
    });
  }
  canAutoSign(t) {
    const i = navigator.userAgent.toLowerCase();
    return i.search("chrome") === -1 && i.search("safari") >= 0 ? !1 : !t.actions.find((n) => !this.isWhitelisted(n));
  }
  isWhitelisted(t) {
    return !!(this.whitelistedContracts && this.whitelistedContracts.find((i) => i.contract === t.account ? t.account === "eosio.token" && t.name === "transfer" ? i.recipients.includes(t.data.to) : !0 : !1));
  }
}
WaxSigningApi$1.WaxSigningApi = WaxSigningApi;
var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(e, t, i, n) {
  function a(o) {
    return o instanceof i ? o : new i(function(l) {
      l(o);
    });
  }
  return new (i || (i = Promise))(function(o, l) {
    function c(m) {
      try {
        u(n.next(m));
      } catch (A) {
        l(A);
      }
    }
    function d(m) {
      try {
        u(n.throw(m));
      } catch (A) {
        l(A);
      }
    }
    function u(m) {
      m.done ? o(m.value) : a(m.value).then(c, d);
    }
    u((n = n.apply(e, t || [])).next());
  });
};
Object.defineProperty(dist$1, "__esModule", { value: !0 });
dist$1.defaultTxVerifier = WaxJS_1 = dist$1.WaxJS = void 0;
const eosjs_1 = dist, eosjs_ecc_migration_1 = eosjsEccMigration, WaxSigningApi_1 = WaxSigningApi$1, PROOF_WAX = 1, PROOF_USER = 2;
class WaxJS {
  get userAccount() {
    return this.user && this.user.account;
  }
  get pubKeys() {
    return this.user && this.user.keys;
  }
  get isTemp() {
    return this.user && this.user.isTemp;
  }
  get createInfo() {
    return this.user && this.user.createData;
  }
  constructor(t) {
    let { rpcEndpoint: i, tryAutoLogin: n = !0, userAccount: a, pubKeys: o, apiSigner: l, waxSigningURL: c = "https://www.mycloudwallet.com", waxAutoSigningURL: d = "https://idm-api.mycloudwallet.com/v1/accounts/auto-accept/", eosApiArgs: u = {}, freeBandwidth: m = !0, feeFallback: A = !0, verifyTx: y = defaultTxVerifier, metricURL: D = "", returnTempAccounts: C = !1 } = t;
    this.signingApi = new WaxSigningApi_1.WaxSigningApi(c, d, D, C), this.rpc = new eosjs_1.JsonRpc(i), this.rpcUrl = i, this.waxSigningURL = c, this.waxAutoSigningURL = d, this.apiSigner = l, this.eosApiArgs = u, this.freeBandwidth = m, this.feeFallback = A, this.metricURL = D, this.proofWaxKey = "", this.verifyTx = y, this.returnTempAccounts = C, a && Array.isArray(o) ? this.receiveLogin({ account: a, keys: o }) : n && this.signingApi.tryAutologin().then((z) => __awaiter(this, void 0, void 0, function* () {
      z && this.receiveLogin(yield this.signingApi.login());
    }));
  }
  login() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.user || this.receiveLogin(yield this.signingApi.login()), this.user.account;
    });
  }
  isAutoLoginAvailable() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.user ? !0 : (yield this.signingApi.tryAutologin()) ? (this.receiveLogin(yield this.signingApi.login()), !0) : !1;
    });
  }
  logout() {
    return __awaiter(this, void 0, void 0, function* () {
      this.user = null, this.api = null, this.signingApi && this.signingApi.logout();
    });
  }
  userAccountProof(t, i) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.user)
        throw new Error("User is not logged in");
      const a = yield this.signingApi.proofWindow(t, PROOF_USER, i), o = t;
      if (!n)
        return Object.assign(Object.assign({}, a), { message: o });
      for (const l of this.pubKeys)
        if (yield eosjs_ecc_migration_1.ecc.verify(a.signature, o, l))
          return !0;
      return !1;
    });
  }
  waxProof(t) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.user)
        throw new Error("User is not logged in");
      this.proofWaxKey === "" && (yield this.getRequiredKeys());
      const n = yield this.signingApi.proofWindow(t, PROOF_WAX, null), a = `cloudwallet-verification-${n.referer}-${t}-${n.accountName}`;
      return i ? yield eosjs_ecc_migration_1.ecc.verify(n.signature, a, this.proofWaxKey) : Object.assign(Object.assign({}, n), { message: a });
    });
  }
  getRequiredKeys() {
    return __awaiter(this, void 0, void 0, function* () {
      const t = yield fetch(`${this.rpcUrl}/v1/chain/get_account`, { body: JSON.stringify({ account_name: "proof.wax" }), method: "POST" }).then((i) => i.json());
      if (t.permissions)
        for (const i of t.permissions)
          i.perm_name === "active" && (this.proofWaxKey = i.required_auth.keys[0].key);
    });
  }
  receiveLogin(t) {
    this.user = t;
    const i = { getAvailableKeys: () => __awaiter(this, void 0, void 0, function* () {
      return [...this.user.keys, ...this.apiSigner && (yield this.apiSigner.getAvailableKeys()) || []];
    }), sign: (a) => __awaiter(this, void 0, void 0, function* () {
      const o = yield this.api.deserializeTransactionWithActions(a.serializedTransaction), { serializedTransaction: l, signatures: c } = yield this.signingApi.signing(o, a.serializedTransaction, !this.freeBandwidth, this.feeFallback), d = yield this.api.deserializeTransactionWithActions(l);
      return this.verifyTx(this.user, o, d), a.serializedTransaction = l, { serializedTransaction: l, signatures: [...c, ...this.apiSigner && (yield this.apiSigner.sign(a)).signatures || []] };
    }) };
    this.api = new eosjs_1.Api(Object.assign(Object.assign({}, this.eosApiArgs), { rpc: this.rpc, signatureProvider: i }));
    const n = this.api.transact.bind(this.api);
    this.api.transact = (a, o) => __awaiter(this, void 0, void 0, function* () {
      return yield this.signingApi.prepareTransaction(a), yield n(a, o);
    });
  }
}
var WaxJS_1 = dist$1.WaxJS = WaxJS;
function defaultTxVerifier(e, t, i) {
  const { actions: n } = t, { actions: a } = i;
  if (JSON.stringify(n) !== JSON.stringify(a.slice(a.length - n.length)))
    throw new Error(`Augmented transaction actions has modified actions from the original.
Original: ${JSON.stringify(n, void 0, 2)}
Augmented: ${JSON.stringify(a, void 0, 2)}`);
  for (const o of a.slice(0, a.length - n.length))
    if (o.authorization.find((c) => c.actor === e.account)) {
      if (o.account === "eosio.token" && o.name === "transfer") {
        const c = a[0];
        if (o.data.to === "txfee.wax" && o.data.memo.startsWith("WAX fee for ") && JSON.stringify(c) === JSON.stringify({ account: "boost.wax", name: "noop", authorization: [{ actor: "boost.wax", permission: "paybw" }], data: {} }))
          continue;
      }
      if (o.account === "eosio" && o.name === "buyrambytes" && o.data.receiver === e.account)
        continue;
      throw new Error(`Augmented transaction actions has an extra action from the original authorizing the user.
Original: ${JSON.stringify(n, void 0, 2)}
Augmented: ${JSON.stringify(a, void 0, 2)}`);
    }
}
dist$1.defaultTxVerifier = defaultTxVerifier;
const defaultWaxWallet = { user: {}, wax: void 0 }, WaxCloudWalletContext = createContext({ ...defaultWaxWallet, activate: noop_1, deactivate: noop_1, activating: !1, waxUser: void 0, waxActivate: () => Promise.resolve(), waxDeactivate: () => {
}, waxActivating: !1, wax: void 0 }), useWaxCloudWalletProvider = (e) => {
  const t = e || "https://wax.greymass.com", [i, n] = useState(), [a, o] = useState(void 0), [l, c] = useState(!1), d = new WaxJS_1({ rpcEndpoint: t, tryAutoLogin: !1, feeFallback: !1, freeBandwidth: !1 });
  return { waxUser: i, waxActivate: async () => {
    c(!0), await d.login(), window.wax = d, o(d), c(!1), n(d.user);
  }, waxDeactivate: () => {
    c(!1), o(void 0), n(void 0), d.user = void 0, d.signingApi && (d.signingApi.user = void 0);
  }, waxActivating: l, wax: a };
}, WaxCloudWalletProvider = (e) => {
  let { waxRPC: t, children: i } = e;
  const n = useWaxCloudWalletProvider(t);
  return /* @__PURE__ */ jsx(WaxCloudWalletContext.Provider, { value: n, children: i });
}, useWaxCloudWalletContext = () => useContext(WaxCloudWalletContext);
WaxCloudWalletProvider.propTypes = { children: propTypesExports.node.isRequired };
const UnbindAddressButton = () => {
  const { walletAddress: e, onResetAuth: t } = useNavbarContext(), { account: i, connector: n } = useWeb3React(), { waxUser: a, waxDeactivate: o } = useWaxCloudWalletContext(), l = async () => {
    n && (await n.resetState(), localStorage.clear(), n.provider = void 0, n.eagerConnection = void 0), o(), t();
  }, u = ((m) => {
    if (a)
      return m;
    const A = m.substring(0, 6), y = m.substring(m.length - 4);
    return `${A}...${y}`;
  })((() => e || (a ? a.account : i))() || "");
  return /* @__PURE__ */ jsxs(StyledWalletAddressWrapper, { onClick: l, children: [/* @__PURE__ */ jsx(StyledMaskIcon, { src: unbindingIcon, width: "34px" }), /* @__PURE__ */ jsx(StyledWalletAddress, { children: u })] });
}, NetworkSwitchList = (e) => {
  let { isShow: t, isTestnet: i } = e;
  const { hideNetwork: n, onSwitchChainRedirect: a, switchNetworks: o } = useNavbarContext(), { chainId: l, connector: c } = useWeb3React(), d = (u) => async () => {
    var m;
    try {
      const { id: A } = u;
      await c.activate(A);
    } catch {
      const { chainName: y, id: D, url: C, nativeCurrency: z } = u, R = `0x${D.toString(16)}`;
      await ((m = c.provider) == null ? void 0 : m.request({ method: "wallet_addEthereumChain", params: [{ chainId: R, rpcUrls: [C], chainName: y, nativeCurrency: z }] }));
    } finally {
      a();
    }
  };
  return /* @__PURE__ */ jsxs(StyledWrapper$3, { isTestnet: i, isShow: t, children: [!n && /* @__PURE__ */ jsxs(StyledTitleWrapper, { children: [/* @__PURE__ */ jsx(StyledIconImg, { src: zondiconsNetworkIcon, width: "16px", marginRight: "12px" }), /* @__PURE__ */ jsx(StyledTitle, { children: "Choose Network" })] }), /* @__PURE__ */ jsxs(StyledList, { children: [!n && o.map((u) => {
    const m = u.id === l;
    return /* @__PURE__ */ jsx(StyledNetworkHover, { onClick: d(u), children: /* @__PURE__ */ jsxs(StyledNetwork, { children: [m && /* @__PURE__ */ jsx(StyledCheckMark, { src: checkMarkIcon, width: "16px" }), /* @__PURE__ */ jsx(StyledIconImg, { src: u.icon, width: "18px", marginRight: "8px" }), /* @__PURE__ */ jsx(StyledNetworkName, { isActive: m, children: u.chainName })] }) }, u.id);
  }), /* @__PURE__ */ jsx(StyledMobileRender, { children: /* @__PURE__ */ jsx(StyledTitleWrapper, { children: /* @__PURE__ */ jsx(UnbindAddressButton, {}) }) })] })] });
};
var supportsPassiveEvents;
function arePassiveEventsSupported() {
  if (supportsPassiveEvents !== void 0)
    return supportsPassiveEvents;
  var e = !1, t = {
    // @ts-ignore: this is a temporary object, it doesn't have to return anything
    get passive() {
      e = !0;
    }
  }, i = function() {
  };
  return window.addEventListener("t", i, t), window.removeEventListener("t", i, t), supportsPassiveEvents = e, e;
}
var index = useLayoutEffect, useLatest = function(t) {
  var i = React.useRef(t);
  return index(function() {
    i.current = t;
  }), i;
}, MOUSEDOWN = "mousedown", TOUCHSTART = "touchstart", events = [MOUSEDOWN, TOUCHSTART], getAddOptions = function(t) {
  if (t === TOUCHSTART && arePassiveEventsSupported())
    return { passive: !0 };
}, currentDocument = document;
function useOnClickOutside(e, t, i) {
  var n = i === void 0 ? {} : i, a = n.document, o = a === void 0 ? currentDocument : a, l = useLatest(t);
  useEffect(function() {
    if (t) {
      var c = function(u) {
        !e.current || !l.current || e.current.contains(u.target) || l.current(u);
      };
      return events.forEach(function(d) {
        o.addEventListener(d, c, getAddOptions(d));
      }), function() {
        events.forEach(function(d) {
          o.removeEventListener(d, c);
        });
      };
    }
  }, [!t]);
}
const NetworkWrapper = styled$3(Row)`
  margin-right: 48px;
  cursor: pointer;
  position: relative;
`, StyledNetworkText = styled$3.div`
  ${fontStyle("16px", "500")};
  color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};

  @media ${SM_AND_UP_QUERY} {
    ${fontStyle("14px", "500")};
  }
`;
var root$6 = _root, coreJsData$1 = root$6["__core-js_shared__"], _coreJsData = coreJsData$1, coreJsData = _coreJsData, maskSrcKey = function() {
  var e = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function isMasked$1(e) {
  return !!maskSrcKey && maskSrcKey in e;
}
var _isMasked = isMasked$1, funcProto$1 = Function.prototype, funcToString$1 = funcProto$1.toString;
function toSource$2(e) {
  if (e != null) {
    try {
      return funcToString$1.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var _toSource = toSource$2, isFunction = isFunction_1, isMasked = _isMasked, isObject$1 = isObject_1, toSource$1 = _toSource, reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto = Function.prototype, objectProto$5 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$4 = objectProto$5.hasOwnProperty, reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$4).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative$1(e) {
  if (!isObject$1(e) || isMasked(e))
    return !1;
  var t = isFunction(e) ? reIsNative : reIsHostCtor;
  return t.test(toSource$1(e));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(e, t) {
  return e == null ? void 0 : e[t];
}
var _getValue = getValue$1, baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(e, t) {
  var i = getValue(e, t);
  return baseIsNative(i) ? i : void 0;
}
var _getNative = getNative$7, getNative$6 = _getNative, defineProperty$1 = function() {
  try {
    var e = getNative$6(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), _defineProperty$1 = defineProperty$1, defineProperty = _defineProperty$1;
function baseAssignValue$2(e, t, i) {
  t == "__proto__" && defineProperty ? defineProperty(e, t, { configurable: !0, enumerable: !0, value: i, writable: !0 }) : e[t] = i;
}
var _baseAssignValue = baseAssignValue$2;
function arrayAggregator$1(e, t, i, n) {
  for (var a = -1, o = e == null ? 0 : e.length; ++a < o; ) {
    var l = e[a];
    t(n, l, i(l), e);
  }
  return n;
}
var _arrayAggregator = arrayAggregator$1;
function createBaseFor$1(e) {
  return function(t, i, n) {
    for (var a = -1, o = Object(t), l = n(t), c = l.length; c--; ) {
      var d = l[e ? c : ++a];
      if (i(o[d], d, o) === !1)
        break;
    }
    return t;
  };
}
var _createBaseFor = createBaseFor$1, createBaseFor = _createBaseFor, baseFor$1 = createBaseFor(), _baseFor = baseFor$1, baseFor = _baseFor, keys$2 = keys_1;
function baseForOwn$2(e, t) {
  return e && baseFor(e, t, keys$2);
}
var _baseForOwn = baseForOwn$2, isArrayLike = isArrayLike_1;
function createBaseEach$1(e, t) {
  return function(i, n) {
    if (i == null)
      return i;
    if (!isArrayLike(i))
      return e(i, n);
    for (var a = i.length, o = t ? a : -1, l = Object(i); (t ? o-- : ++o < a) && n(l[o], o, l) !== !1; )
      ;
    return i;
  };
}
var _createBaseEach = createBaseEach$1, baseForOwn$1 = _baseForOwn, createBaseEach = _createBaseEach, baseEach$1 = createBaseEach(baseForOwn$1), _baseEach = baseEach$1, baseEach = _baseEach;
function baseAggregator$1(e, t, i, n) {
  return baseEach(e, function(a, o, l) {
    t(n, a, i(a), l);
  }), n;
}
var _baseAggregator = baseAggregator$1;
function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$2(e, t) {
  return e === t || e !== e && t !== t;
}
var eq_1 = eq$2, eq$1 = eq_1;
function assocIndexOf$4(e, t) {
  for (var i = e.length; i--; )
    if (eq$1(e[i][0], t))
      return i;
  return -1;
}
var _assocIndexOf = assocIndexOf$4, assocIndexOf$3 = _assocIndexOf, arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete$1(e) {
  var t = this.__data__, i = assocIndexOf$3(t, e);
  if (i < 0)
    return !1;
  var n = t.length - 1;
  return i == n ? t.pop() : splice.call(t, i, 1), --this.size, !0;
}
var _listCacheDelete = listCacheDelete$1, assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(e) {
  var t = this.__data__, i = assocIndexOf$2(t, e);
  return i < 0 ? void 0 : t[i][1];
}
var _listCacheGet = listCacheGet$1, assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(e) {
  return assocIndexOf$1(this.__data__, e) > -1;
}
var _listCacheHas = listCacheHas$1, assocIndexOf = _assocIndexOf;
function listCacheSet$1(e, t) {
  var i = this.__data__, n = assocIndexOf(i, e);
  return n < 0 ? (++this.size, i.push([e, t])) : i[n][1] = t, this;
}
var _listCacheSet = listCacheSet$1, listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.clear(); ++t < i; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype.delete = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4, ListCache$3 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$3(), this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(e) {
  var t = this.__data__, i = t.delete(e);
  return this.size = t.size, i;
}
var _stackDelete = stackDelete$1;
function stackGet$1(e) {
  return this.__data__.get(e);
}
var _stackGet = stackGet$1;
function stackHas$1(e) {
  return this.__data__.has(e);
}
var _stackHas = stackHas$1, getNative$5 = _getNative, root$5 = _root, Map$4 = getNative$5(root$5, "Map"), _Map = Map$4, getNative$4 = _getNative, nativeCreate$4 = getNative$4(Object, "create"), _nativeCreate = nativeCreate$4, nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var _hashDelete = hashDelete$1, nativeCreate$2 = _nativeCreate, HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$4 = Object.prototype, hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function hashGet$1(e) {
  var t = this.__data__;
  if (nativeCreate$2) {
    var i = t[e];
    return i === HASH_UNDEFINED$2 ? void 0 : i;
  }
  return hasOwnProperty$3.call(t, e) ? t[e] : void 0;
}
var _hashGet = hashGet$1, nativeCreate$1 = _nativeCreate, objectProto$3 = Object.prototype, hasOwnProperty$2 = objectProto$3.hasOwnProperty;
function hashHas$1(e) {
  var t = this.__data__;
  return nativeCreate$1 ? t[e] !== void 0 : hasOwnProperty$2.call(t, e);
}
var _hashHas = hashHas$1, nativeCreate = _nativeCreate, HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(e, t) {
  var i = this.__data__;
  return this.size += this.has(e) ? 0 : 1, i[e] = nativeCreate && t === void 0 ? HASH_UNDEFINED$1 : t, this;
}
var _hashSet = hashSet$1, hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.clear(); ++t < i; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype.delete = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1, Hash = _Hash, ListCache$2 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0, this.__data__ = { hash: new Hash(), map: new (Map$3 || ListCache$2)(), string: new Hash() };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var _isKeyable = isKeyable$1, isKeyable = _isKeyable;
function getMapData$4(e, t) {
  var i = e.__data__;
  return isKeyable(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
}
var _getMapData = getMapData$4, getMapData$3 = _getMapData;
function mapCacheDelete$1(e) {
  var t = getMapData$3(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var _mapCacheDelete = mapCacheDelete$1, getMapData$2 = _getMapData;
function mapCacheGet$1(e) {
  return getMapData$2(this, e).get(e);
}
var _mapCacheGet = mapCacheGet$1, getMapData$1 = _getMapData;
function mapCacheHas$1(e) {
  return getMapData$1(this, e).has(e);
}
var _mapCacheHas = mapCacheHas$1, getMapData = _getMapData;
function mapCacheSet$1(e, t) {
  var i = getMapData(this, e), n = i.size;
  return i.set(e, t), this.size += i.size == n ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet$1, mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.clear(); ++t < i; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype.delete = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3, ListCache$1 = _ListCache, Map$2 = _Map, MapCache$2 = _MapCache, LARGE_ARRAY_SIZE = 200;
function stackSet$1(e, t) {
  var i = this.__data__;
  if (i instanceof ListCache$1) {
    var n = i.__data__;
    if (!Map$2 || n.length < LARGE_ARRAY_SIZE - 1)
      return n.push([e, t]), this.size = ++i.size, this;
    i = this.__data__ = new MapCache$2(n);
  }
  return i.set(e, t), this.size = i.size, this;
}
var _stackSet = stackSet$1, ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(e) {
  var t = this.__data__ = new ListCache(e);
  this.size = t.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype.delete = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2, HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(e) {
  return this.__data__.set(e, HASH_UNDEFINED), this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(e) {
  return this.__data__.has(e);
}
var _setCacheHas = setCacheHas$1, MapCache$1 = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.__data__ = new MapCache$1(); ++t < i; )
    this.add(e[t]);
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(e, t) {
  for (var i = -1, n = e == null ? 0 : e.length; ++i < n; )
    if (t(e[i], i, e))
      return !0;
  return !1;
}
var _arraySome = arraySome$1;
function cacheHas$1(e, t) {
  return e.has(t);
}
var _cacheHas = cacheHas$1, SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas, COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(e, t, i, n, a, o) {
  var l = i & COMPARE_PARTIAL_FLAG$5, c = e.length, d = t.length;
  if (c != d && !(l && d > c))
    return !1;
  var u = o.get(e), m = o.get(t);
  if (u && m)
    return u == t && m == e;
  var A = -1, y = !0, D = i & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (o.set(e, t), o.set(t, e); ++A < c; ) {
    var C = e[A], z = t[A];
    if (n)
      var R = l ? n(z, C, A, t, e, o) : n(C, z, A, e, t, o);
    if (R !== void 0) {
      if (R)
        continue;
      y = !1;
      break;
    }
    if (D) {
      if (!arraySome(t, function(O, $) {
        if (!cacheHas(D, $) && (C === O || a(C, O, i, n, o)))
          return D.push($);
      })) {
        y = !1;
        break;
      }
    } else if (!(C === z || a(C, z, i, n, o))) {
      y = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), y;
}
var _equalArrays = equalArrays$2, root$4 = _root, Uint8Array$2 = root$4.Uint8Array, _Uint8Array = Uint8Array$2;
function mapToArray$1(e) {
  var t = -1, i = Array(e.size);
  return e.forEach(function(n, a) {
    i[++t] = [a, n];
  }), i;
}
var _mapToArray = mapToArray$1;
function setToArray$1(e) {
  var t = -1, i = Array(e.size);
  return e.forEach(function(n) {
    i[++t] = n;
  }), i;
}
var _setToArray = setToArray$1, Symbol$2 = _Symbol, Uint8Array$1 = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray, COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag$1 = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function equalByTag$1(e, t, i, n, a, o, l) {
  switch (i) {
    case dataViewTag$1:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case arrayBufferTag:
      return !(e.byteLength != t.byteLength || !o(new Uint8Array$1(e), new Uint8Array$1(t)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+e, +t);
    case errorTag:
      return e.name == t.name && e.message == t.message;
    case regexpTag:
    case stringTag:
      return e == t + "";
    case mapTag$1:
      var c = mapToArray;
    case setTag$1:
      var d = n & COMPARE_PARTIAL_FLAG$4;
      if (c || (c = setToArray), e.size != t.size && !d)
        return !1;
      var u = l.get(e);
      if (u)
        return u == t;
      n |= COMPARE_UNORDERED_FLAG$2, l.set(e, t);
      var m = equalArrays$1(c(e), c(t), n, a, o, l);
      return l.delete(e), m;
    case symbolTag$1:
      if (symbolValueOf)
        return symbolValueOf.call(e) == symbolValueOf.call(t);
  }
  return !1;
}
var _equalByTag = equalByTag$1;
function arrayPush$1(e, t) {
  for (var i = -1, n = t.length, a = e.length; ++i < n; )
    e[a + i] = t[i];
  return e;
}
var _arrayPush = arrayPush$1, arrayPush = _arrayPush, isArray$7 = isArray_1;
function baseGetAllKeys$1(e, t, i) {
  var n = t(e);
  return isArray$7(e) ? n : arrayPush(n, i(e));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(e, t) {
  for (var i = -1, n = e == null ? 0 : e.length, a = 0, o = []; ++i < n; ) {
    var l = e[i];
    t(l, i, e) && (o[a++] = l);
  }
  return o;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1, arrayFilter = _arrayFilter, stubArray = stubArray_1, objectProto$2 = Object.prototype, propertyIsEnumerable = objectProto$2.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols$1 = nativeGetSymbols ? function(e) {
  return e == null ? [] : (e = Object(e), arrayFilter(nativeGetSymbols(e), function(t) {
    return propertyIsEnumerable.call(e, t);
  }));
} : stubArray, _getSymbols = getSymbols$1, baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$1 = keys_1;
function getAllKeys$1(e) {
  return baseGetAllKeys(e, keys$1, getSymbols);
}
var _getAllKeys = getAllKeys$1, getAllKeys = _getAllKeys, COMPARE_PARTIAL_FLAG$3 = 1, objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(e, t, i, n, a, o) {
  var l = i & COMPARE_PARTIAL_FLAG$3, c = getAllKeys(e), d = c.length, u = getAllKeys(t), m = u.length;
  if (d != m && !l)
    return !1;
  for (var A = d; A--; ) {
    var y = c[A];
    if (!(l ? y in t : hasOwnProperty$1.call(t, y)))
      return !1;
  }
  var D = o.get(e), C = o.get(t);
  if (D && C)
    return D == t && C == e;
  var z = !0;
  o.set(e, t), o.set(t, e);
  for (var R = l; ++A < d; ) {
    y = c[A];
    var O = e[y], $ = t[y];
    if (n)
      var k = l ? n($, O, y, t, e, o) : n(O, $, y, e, t, o);
    if (!(k === void 0 ? O === $ || a(O, $, i, n, o) : k)) {
      z = !1;
      break;
    }
    R || (R = y == "constructor");
  }
  if (z && !R) {
    var P = e.constructor, L = t.constructor;
    P != L && "constructor" in e && "constructor" in t && !(typeof P == "function" && P instanceof P && typeof L == "function" && L instanceof L) && (z = !1);
  }
  return o.delete(e), o.delete(t), z;
}
var _equalObjects = equalObjects$1, getNative$3 = _getNative, root$3 = _root, DataView$2 = getNative$3(root$3, "DataView"), _DataView = DataView$2, getNative$2 = _getNative, root$2 = _root, Promise$2 = getNative$2(root$2, "Promise"), _Promise = Promise$2, getNative$1 = _getNative, root$1 = _root, Set$2 = getNative$1(root$1, "Set"), _Set = Set$2, getNative = _getNative, root = _root, WeakMap$2 = getNative(root, "WeakMap"), _WeakMap = WeakMap$2, DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap$1 = _WeakMap, baseGetTag$1 = _baseGetTag, toSource = _toSource, mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag$1 = baseGetTag$1;
(DataView$1 && getTag$1(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) && (getTag$1 = function(e) {
  var t = baseGetTag$1(e), i = t == objectTag$1 ? e.constructor : void 0, n = i ? toSource(i) : "";
  if (n)
    switch (n) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return t;
});
var _getTag = getTag$1, Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$6 = isArray_1, isBuffer = isBufferExports, isTypedArray = isTypedArray_1, COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(e, t, i, n, a, o) {
  var l = isArray$6(e), c = isArray$6(t), d = l ? arrayTag : getTag(e), u = c ? arrayTag : getTag(t);
  d = d == argsTag ? objectTag : d, u = u == argsTag ? objectTag : u;
  var m = d == objectTag, A = u == objectTag, y = d == u;
  if (y && isBuffer(e)) {
    if (!isBuffer(t))
      return !1;
    l = !0, m = !1;
  }
  if (y && !m)
    return o || (o = new Stack$1()), l || isTypedArray(e) ? equalArrays(e, t, i, n, a, o) : equalByTag(e, t, d, i, n, a, o);
  if (!(i & COMPARE_PARTIAL_FLAG$2)) {
    var D = m && hasOwnProperty.call(e, "__wrapped__"), C = A && hasOwnProperty.call(t, "__wrapped__");
    if (D || C) {
      var z = D ? e.value() : e, R = C ? t.value() : t;
      return o || (o = new Stack$1()), a(z, R, i, n, o);
    }
  }
  return y ? (o || (o = new Stack$1()), equalObjects(e, t, i, n, a, o)) : !1;
}
var _baseIsEqualDeep = baseIsEqualDeep$1, baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$1 = isObjectLike_1;
function baseIsEqual$2(e, t, i, n, a) {
  return e === t ? !0 : e == null || t == null || !isObjectLike$1(e) && !isObjectLike$1(t) ? e !== e && t !== t : baseIsEqualDeep(e, t, i, n, baseIsEqual$2, a);
}
var _baseIsEqual = baseIsEqual$2, Stack = _Stack, baseIsEqual$1 = _baseIsEqual, COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(e, t, i, n) {
  var a = i.length, o = a, l = !n;
  if (e == null)
    return !o;
  for (e = Object(e); a--; ) {
    var c = i[a];
    if (l && c[2] ? c[1] !== e[c[0]] : !(c[0] in e))
      return !1;
  }
  for (; ++a < o; ) {
    c = i[a];
    var d = c[0], u = e[d], m = c[1];
    if (l && c[2]) {
      if (u === void 0 && !(d in e))
        return !1;
    } else {
      var A = new Stack();
      if (n)
        var y = n(u, m, d, e, t, A);
      if (!(y === void 0 ? baseIsEqual$1(m, u, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, n, A) : y))
        return !1;
    }
  }
  return !0;
}
var _baseIsMatch = baseIsMatch$1, isObject = isObject_1;
function isStrictComparable$2(e) {
  return e === e && !isObject(e);
}
var _isStrictComparable = isStrictComparable$2, isStrictComparable$1 = _isStrictComparable, keys = keys_1;
function getMatchData$1(e) {
  for (var t = keys(e), i = t.length; i--; ) {
    var n = t[i], a = e[n];
    t[i] = [n, a, isStrictComparable$1(a)];
  }
  return t;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(e, t) {
  return function(i) {
    return i == null ? !1 : i[e] === t && (t !== void 0 || e in Object(i));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2, baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(e) {
  var t = getMatchData(e);
  return t.length == 1 && t[0][2] ? matchesStrictComparable$1(t[0][0], t[0][1]) : function(i) {
    return i === e || baseIsMatch(i, e, t);
  };
}
var _baseMatches = baseMatches$1, baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1, symbolTag = "[object Symbol]";
function isSymbol$3(e) {
  return typeof e == "symbol" || isObjectLike(e) && baseGetTag(e) == symbolTag;
}
var isSymbol_1 = isSymbol$3, isArray$5 = isArray_1, isSymbol$2 = isSymbol_1, reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(e, t) {
  if (isArray$5(e))
    return !1;
  var i = typeof e;
  return i == "number" || i == "symbol" || i == "boolean" || e == null || isSymbol$2(e) ? !0 : reIsPlainProp.test(e) || !reIsDeepProp.test(e) || t != null && e in Object(t);
}
var _isKey = isKey$3, MapCache = _MapCache, FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  var i = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], o = i.cache;
    if (o.has(a))
      return o.get(a);
    var l = e.apply(this, n);
    return i.cache = o.set(a, l) || o, l;
  };
  return i.cache = new (memoize$1.Cache || MapCache)(), i;
}
memoize$1.Cache = MapCache;
var memoize_1 = memoize$1, memoize = memoize_1, MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(e) {
  var t = memoize(e, function(n) {
    return i.size === MAX_MEMOIZE_SIZE && i.clear(), n;
  }), i = t.cache;
  return t;
}
var _memoizeCapped = memoizeCapped$1, memoizeCapped = _memoizeCapped, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath$1 = memoizeCapped(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(rePropName, function(i, n, a, o) {
    t.push(a ? o.replace(reEscapeChar, "$1") : n || i);
  }), t;
}), _stringToPath = stringToPath$1;
function arrayMap$1(e, t) {
  for (var i = -1, n = e == null ? 0 : e.length, a = Array(n); ++i < n; )
    a[i] = t(e[i], i, e);
  return a;
}
var _arrayMap = arrayMap$1, Symbol$1 = _Symbol, arrayMap = _arrayMap, isArray$4 = isArray_1, isSymbol$1 = isSymbol_1, INFINITY$1 = 1 / 0, symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString$1(e) {
  if (typeof e == "string")
    return e;
  if (isArray$4(e))
    return arrayMap(e, baseToString$1) + "";
  if (isSymbol$1(e))
    return symbolToString ? symbolToString.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -INFINITY$1 ? "-0" : t;
}
var _baseToString = baseToString$1, baseToString = _baseToString;
function toString$1(e) {
  return e == null ? "" : baseToString(e);
}
var toString_1 = toString$1, isArray$3 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString = toString_1;
function castPath$2(e, t) {
  return isArray$3(e) ? e : isKey$2(e, t) ? [e] : stringToPath(toString(e));
}
var _castPath = castPath$2, isSymbol = isSymbol_1, INFINITY = 1 / 0;
function toKey$4(e) {
  if (typeof e == "string" || isSymbol(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -INFINITY ? "-0" : t;
}
var _toKey = toKey$4, castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$2(e, t) {
  t = castPath$1(t, e);
  for (var i = 0, n = t.length; e != null && i < n; )
    e = e[toKey$3(t[i++])];
  return i && i == n ? e : void 0;
}
var _baseGet = baseGet$2, baseGet$1 = _baseGet;
function get$1(e, t, i) {
  var n = e == null ? void 0 : baseGet$1(e, t);
  return n === void 0 ? i : n;
}
var get_1 = get$1;
function baseHasIn$1(e, t) {
  return e != null && t in Object(e);
}
var _baseHasIn = baseHasIn$1, castPath = _castPath, isArguments = isArguments_1, isArray$2 = isArray_1, isIndex = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$1(e, t, i) {
  t = castPath(t, e);
  for (var n = -1, a = t.length, o = !1; ++n < a; ) {
    var l = toKey$2(t[n]);
    if (!(o = e != null && i(e, l)))
      break;
    e = e[l];
  }
  return o || ++n != a ? o : (a = e == null ? 0 : e.length, !!a && isLength(a) && isIndex(l, a) && (isArray$2(e) || isArguments(e)));
}
var _hasPath = hasPath$1, baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(e, t) {
  return e != null && hasPath(e, t, baseHasIn);
}
var hasIn_1 = hasIn$1, baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey, COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(e, t) {
  return isKey$1(e) && isStrictComparable(t) ? matchesStrictComparable(toKey$1(e), t) : function(i) {
    var n = get(i, e);
    return n === void 0 && n === t ? hasIn(i, e) : baseIsEqual(t, n, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$1(e) {
  return e;
}
var identity_1 = identity$1;
function baseProperty$1(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var _baseProperty = baseProperty$1, baseGet = _baseGet;
function basePropertyDeep$1(e) {
  return function(t) {
    return baseGet(t, e);
  };
}
var _basePropertyDeep = basePropertyDeep$1, baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(e) {
  return isKey(e) ? baseProperty(toKey(e)) : basePropertyDeep(e);
}
var property_1 = property$1, baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity = identity_1, isArray$1 = isArray_1, property = property_1;
function baseIteratee$2(e) {
  return typeof e == "function" ? e : e == null ? identity : typeof e == "object" ? isArray$1(e) ? baseMatchesProperty(e[0], e[1]) : baseMatches(e) : property(e);
}
var _baseIteratee = baseIteratee$2, arrayAggregator = _arrayAggregator, baseAggregator = _baseAggregator, baseIteratee$1 = _baseIteratee, isArray = isArray_1;
function createAggregator$1(e, t) {
  return function(i, n) {
    var a = isArray(i) ? arrayAggregator : baseAggregator, o = t ? t() : {};
    return a(i, e, baseIteratee$1(n), o);
  };
}
var _createAggregator = createAggregator$1, baseAssignValue$1 = _baseAssignValue, createAggregator = _createAggregator, keyBy = createAggregator(function(e, t, i) {
  baseAssignValue$1(e, i, t);
}), keyBy_1 = keyBy, baseAssignValue = _baseAssignValue, baseForOwn = _baseForOwn, baseIteratee = _baseIteratee;
function mapValues(e, t) {
  var i = {};
  return t = baseIteratee(t), baseForOwn(e, function(n, a, o) {
    baseAssignValue(i, a, t(n, a, o));
  }), i;
}
var mapValues_1 = mapValues;
const chains = [{ id: 1, name: "eth", shortName: "ETH", rpc: "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161", metamaskDefaultRPC: "https://mainnet.infura.io/v3/", enabled: !0, network: "mainnet", display: "ETH", icon: EthereumIcon }, { id: 3, name: "eth", shortName: "ETH", rpc: "https://ropsten.infura.io/v3/d9044d96244b426fb3bbe68c46c848cb", metamaskDefaultRPC: "https://ropsten.infura.io/v3/", enabled: !1, network: "testnet", display: "Ethereum Testnet - Ropsten", icon: EthereumIcon }, { id: 4, name: "eth", shortName: "ETH", rpc: "https://rinkeby.infura.io/v3/d9044d96244b426fb3bbe68c46c848cb", metamaskDefaultRPC: "https://rinkeby.infura.io/v3/", enabled: !1, network: "testnet", display: "Ethereum Testnet - Rinkeby", icon: EthereumIcon }, { id: 5, name: "eth", shortName: "ETH", rpc: "https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161", metamaskDefaultRPC: "https://goerli.infura.io/v3/", enabled: !0, network: "testnet", display: "Ethereum Testnet - Goerli", nativeCurrency: { name: "Goerli ETH", symbol: "gorETH", decimals: 18 }, icon: EthereumIcon }, { id: 11155111, name: "eth", shortName: "ETH", rpc: "https://sepolia.infura.io/v3/ebec24a431234429a6f464da2e4f98c5", metamaskDefaultRPC: "https://sepolia.infura.io/v3/", enabled: !0, network: "testnet", display: "Ethereum Testnet - Sepolia", nativeCurrency: { name: "Sepolia ETH", symbol: "SepoliaETH", decimals: 18 }, icon: EthereumIcon }, { id: 18, name: "tt", shortName: "TT", rpc: "https://testnet-rpc.thundercore.com", enabled: !0, network: "testnet", display: "ThunderCore Testnet", nativeCurrency: { name: "Testnet TT", symbol: "TST", decimals: 18 }, icon: ThunderCoreIcon }, { id: 56, name: "bnb", shortName: "BNB", rpc: "https://bsc-dataseed1.binance.org", enabled: !0, network: "mainnet", display: "Binance Smart Chain Mainnet", nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 }, icon: BinanceIcon }, { id: 97, name: "bnb", shortName: "BNB", rpc: "https://data-seed-prebsc-1-s1.binance.org:8545", enabled: !0, network: "testnet", display: "Binance Smart Chain Testnet", nativeCurrency: { name: "Testnet BNB", symbol: "tBNB", decimals: 18 }, icon: BinanceIcon }, { id: 108, name: "tt", shortName: "TT", rpc: "https://mainnet-rpc.thundercore.com", enabled: !0, network: "mainnet", display: "ThunderCore Mainnet", nativeCurrency: { name: "TT", symbol: "TT", decimals: 18 }, icon: ThunderCoreIcon }, { id: 137, name: "polygon", shortName: "Polygon", rpc: "https://polygon-rpc.com", enabled: !0, network: "mainnet", display: "Polygon Mainnet", nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 }, icon: PolygonIcon }, { id: 80001, name: "polygon", shortName: "Polygon", rpc: "https://rpc-mumbai.maticvigil.com", enabled: !0, network: "testnet", display: "Polygon Testnet - Mumbai", nativeCurrency: { name: "Testnet MATIC", symbol: "MATIC", decimals: 18 }, icon: PolygonIcon }].filter((e) => e.enabled), chainMapping = keyBy_1(chains, "id");
mapValues_1(chainMapping, (e) => e.rpc);
const NetworkSelectButton = (e) => {
  var l;
  let { isTestnet: t } = e;
  const { chainId: i } = useWeb3React(), [n, a] = useState(!1), o = useRef(null);
  return useOnClickOutside(o, () => a(!1)), /* @__PURE__ */ jsxs(NetworkWrapper, { ref: o, children: [/* @__PURE__ */ jsxs(Row, { onClick: () => a(!n), children: [/* @__PURE__ */ jsx(StyledMaskIcon, { src: zondiconsNetworkPurpleIcon, width: "20px", mr: "12px" }), /* @__PURE__ */ jsx(StyledNetworkText, { children: ((l = chainMapping[i]) == null ? void 0 : l.shortName) || "" })] }), /* @__PURE__ */ jsx(NetworkSwitchList, { isShow: n, isTestnet: !!t })] });
}, Navbar = () => {
  const { hideNetwork: e, hideUnbindButton: t, logoImgUrl: i = "", isMainnet: n, onLogoClick: a } = useNavbarContext(), { account: o } = useWeb3React(), [l, c] = useState(!1), d = () => {
    typeof a == "function" && a();
  }, u = !n && o;
  return /* @__PURE__ */ jsxs(StyledHeader, { isTestnet: !!u, children: [/* @__PURE__ */ jsxs(StyledNav, { children: [u && /* @__PURE__ */ jsxs(StyledNoticeBanner, { justify: "center", children: [/* @__PURE__ */ jsx(StyledIconImg, { src: gridiconsNoticeIcon, width: "20px", marginRight: "8px" }), /* @__PURE__ */ jsx(StyledNoticeText, { children: "You are not on Mainnet now!" })] }), /* @__PURE__ */ jsxs(StyledContainer$2, { children: [/* @__PURE__ */ jsx(StyledImage$1, { onClick: d, alt: "redreamer logo", src: i || LogoImage }), /* @__PURE__ */ jsx(StyledDesktopRender, { children: /* @__PURE__ */ jsxs(Row, { children: [!e && /* @__PURE__ */ jsx(NetworkSelectButton, { isTestnet: !!u }), !t && /* @__PURE__ */ jsx(UnbindAddressButton, {})] }) }), /* @__PURE__ */ jsx(Hamburger, { isOpen: l, onClick: () => c((m) => !m) })] })] }), /* @__PURE__ */ jsx(NetworkSwitchList, { isShow: l, isTestnet: !!u })] });
}, NavbarContainer = (e) => /* @__PURE__ */ jsx(NavbarProvider, { ...e, children: /* @__PURE__ */ jsx(Navbar, {}) }), CustomMuiButton = styled$3(MButton)`
  &&& {
    width: 100%;
    padding: 8px 0;
    background: ${(e) => {
  let { theme: t } = e;
  return t.colors.darkDream;
}};
    border-radius: 4px;
    color: ${(e) => {
  let { theme: t } = e;
  return t.colors.redeemBtnText;
}};
    font-weight: 700;
    text-transform: none;
    margin-bottom: 18px;
    :hover {
      background: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
    },
  }
`, ConnectButton = (e) => {
  let { name: t = void 0, onClick: i = () => {
  }, ...n } = e;
  return /* @__PURE__ */ jsx(CustomMuiButton, { ...n, onClick: i, children: t });
}, StyledImage = styled$3.img`
  ${size("140px", "100%")};
  object-fit: ${(e) => {
  let { objectFit: t } = e;
  return t || "cover";
}};
  border-radius: 8px 0 0 8px;

  @media ${SM_AND_UP_QUERY} {
    ${size("100%", "200px")};
    border-radius: 8px 8px 0 0;
  }
`, StyledVideo = styled$3.video`
  width: 100%;
`, StyledWrapper$2 = styled$3(Row)`
  ${size("100%", "140px")};
  position: relative;
  border-radius: 8px;
  background: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
  border: 1px solid ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  justify-content: space-between;
  margin-bottom: 16px;

  @media ${SM_AND_UP_QUERY} {
    ${size("auto", "auto")};
    flex-direction: column;
    margin-bottom: 0px;
  }
`, StyledContent = styled$3.div`
  padding: 16px;
  width: 100%;
`, StyledNftTitle = styled$3.div`
  height: 34px;
  word-break: break-all;
  ${fontEllipsis(2)};
  ${fontStyle("14px", "700")};
  color: ${(e) => {
  let { theme: t } = e;
  return t.colors.darkDream;
}};

  @media ${SM_AND_UP_QUERY} {
    height: 38px;
    ${fontStyle("16px", "700")};
    color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
  }
`, StyledTokenId = styled$3.div`
  ${fontStyle("12px")};
  margin: 10px 0;

  @media ${SM_AND_UP_QUERY} {
    ${fontStyle("14px")};
    margin: 8px 0 23px 0;
  }
`, StyledRedeemButton = styled$3(MButton)`
  &&& {
    ${size("163px", "41px")};
    ${fontStyle("14px", "700")};
    padding: 12px 0;
    background-color: ${(e) => {
  let { theme: t, isRedeemable: i } = e;
  return i ? "rgba(0, 0, 0, 0.6)" : t.colors.darkDream;
}};
    border-radius: 4px;
    color: ${(e) => {
  let { theme: t, isRedeemable: i } = e;
  return i ? t.colors.white : t.colors.hope;
}};
    text-transform: none;
    box-shadow: 0px 1px 1px -2px rgba(0, 0, 0, 0.2);
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.14))
      drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.12));

    :hover {
      background-color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
    }

    @media ${SM_AND_UP_QUERY} {
      ${size("168px", "43px")};
      ${fontStyle("16px", "700")};
    }
  }
`, StyledInValidBackgroud = styled$3.div`
  background: rgba(255, 255, 255, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
`, CollectionCard = (e) => {
  let { nft: t, handleRedeem: i, defaultImg: n, imgUrlTransform: a, children: o } = e;
  const l = useRef(null), [c, d] = useState(), { image: u = "", video: m = "", isRedeemable: A = !1, name: y = "", tokenId: D = "" } = t || {}, C = () => {
    t && i(t);
  }, z = () => m ? /* @__PURE__ */ jsx(StyledVideo, { autoPlay: !0, loop: !0, muted: !0, children: /* @__PURE__ */ jsx("source", { src: m, type: "video/mp4" }) }) : /* @__PURE__ */ jsx(StyledImage, { height: c, ref: l, alt: "nft", objectFit: u ? "" : "contain", src: a || n });
  return useEffect(() => {
    if (l.current) {
      const { width: R } = l.current.getBoundingClientRect();
      d(R);
    }
  }, [l.current]), /* @__PURE__ */ jsxs(StyledWrapper$2, { children: [z(), o ? /* @__PURE__ */ jsx(StyledContent, { children: o }) : /* @__PURE__ */ jsxs(StyledContent, { children: [/* @__PURE__ */ jsx(StyledNftTitle, { children: y }), /* @__PURE__ */ jsx(StyledTokenId, { children: `#${D}` }), /* @__PURE__ */ jsx(StyledRedeemButton, { isRedeemable: A, onClick: C, children: A ? "Validated" : "Redeem" })] }), A && /* @__PURE__ */ jsx(StyledInValidBackgroud, {})] });
};
var lottieExports = {}, lottie$1 = { get exports() {
  return lottieExports;
}, set exports(e) {
  lottieExports = e;
} };
(function(module, exports) {
  typeof navigator < "u" && function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
      _useWebWorker = !!t;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(t) {
      locationHref = t;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(e) {
      return document.createElement(e);
    }
    function extendPrototype(e, t) {
      var i, n = e.length, a;
      for (i = 0; i < n; i += 1) {
        a = e[i].prototype;
        for (var o in a)
          Object.prototype.hasOwnProperty.call(a, o) && (t.prototype[o] = a[o]);
      }
    }
    function getDescriptor(e, t) {
      return Object.getOwnPropertyDescriptor(e, t);
    }
    function createProxyFunction(e) {
      function t() {
      }
      return t.prototype = e, t;
    }
    var audioControllerFactory = function() {
      function e(t) {
        this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
      }
      return e.prototype = { addAudio: function(i) {
        this.audios.push(i);
      }, pause: function() {
        var i, n = this.audios.length;
        for (i = 0; i < n; i += 1)
          this.audios[i].pause();
      }, resume: function() {
        var i, n = this.audios.length;
        for (i = 0; i < n; i += 1)
          this.audios[i].resume();
      }, setRate: function(i) {
        var n, a = this.audios.length;
        for (n = 0; n < a; n += 1)
          this.audios[n].setRate(i);
      }, createAudio: function(i) {
        return this.audioFactory ? this.audioFactory(i) : window.Howl ? new window.Howl({ src: [i] }) : { isPlaying: !1, play: function() {
          this.isPlaying = !0;
        }, seek: function() {
          this.isPlaying = !1;
        }, playing: function() {
        }, rate: function() {
        }, setVolume: function() {
        } };
      }, setAudioFactory: function(i) {
        this.audioFactory = i;
      }, setVolume: function(i) {
        this._volume = i, this._updateVolume();
      }, mute: function() {
        this._isMuted = !0, this._updateVolume();
      }, unmute: function() {
        this._isMuted = !1, this._updateVolume();
      }, getVolume: function() {
        return this._volume;
      }, _updateVolume: function() {
        var i, n = this.audios.length;
        for (i = 0; i < n; i += 1)
          this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
      } }, function() {
        return new e();
      };
    }(), createTypedArray = function() {
      function e(i, n) {
        var a = 0, o = [], l;
        switch (i) {
          case "int16":
          case "uint8c":
            l = 1;
            break;
          default:
            l = 1.1;
            break;
        }
        for (a = 0; a < n; a += 1)
          o.push(l);
        return o;
      }
      function t(i, n) {
        return i === "float32" ? new Float32Array(n) : i === "int16" ? new Int16Array(n) : i === "uint8c" ? new Uint8ClampedArray(n) : e(i, n);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? t : e;
    }();
    function createSizedArray(e) {
      return Array.apply(null, { length: e });
    }
    function _typeof$6(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(i) {
        return typeof i;
      } : _typeof$6 = function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, _typeof$6(e);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], t, i = e.length;
      for (t = 0; t < i; t += 1)
        BMMath[e[t]] = Math[e[t]];
    })(), BMMath.random = Math.random, BMMath.abs = function(e) {
      var t = _typeof$6(e);
      if (t === "object" && e.length) {
        var i = createSizedArray(e.length), n, a = e.length;
        for (n = 0; n < a; n += 1)
          i[n] = Math.abs(e[n]);
        return i;
      }
      return Math.abs(e);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(e) {
      e.style.position = "absolute", e.style.top = 0, e.style.left = 0, e.style.display = "block", e.style.transformOrigin = "0 0", e.style.webkitTransformOrigin = "0 0", e.style.backfaceVisibility = "visible", e.style.webkitBackfaceVisibility = "visible", e.style.transformStyle = "preserve-3d", e.style.webkitTransformStyle = "preserve-3d", e.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(e, t, i, n) {
      this.type = e, this.currentTime = t, this.totalTime = i, this.direction = n < 0 ? -1 : 1;
    }
    function BMCompleteEvent(e, t) {
      this.type = e, this.direction = t < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(e, t, i, n) {
      this.type = e, this.currentLoop = i, this.totalLoops = t, this.direction = n < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(e, t, i) {
      this.type = e, this.firstFrame = t, this.totalFrames = i;
    }
    function BMDestroyEvent(e, t) {
      this.type = e, this.target = t;
    }
    function BMRenderFrameErrorEvent(e, t) {
      this.type = "renderFrameError", this.nativeError = e, this.currentTime = t;
    }
    function BMConfigErrorEvent(e) {
      this.type = "configError", this.nativeError = e;
    }
    var createElementID = function() {
      var e = 0;
      return function() {
        return e += 1, idPrefix$1 + "__lottie_element_" + e;
      };
    }();
    function HSVtoRGB(e, t, i) {
      var n, a, o, l, c, d, u, m;
      switch (l = Math.floor(e * 6), c = e * 6 - l, d = i * (1 - t), u = i * (1 - c * t), m = i * (1 - (1 - c) * t), l % 6) {
        case 0:
          n = i, a = m, o = d;
          break;
        case 1:
          n = u, a = i, o = d;
          break;
        case 2:
          n = d, a = i, o = m;
          break;
        case 3:
          n = d, a = u, o = i;
          break;
        case 4:
          n = m, a = d, o = i;
          break;
        case 5:
          n = i, a = d, o = u;
          break;
      }
      return [n, a, o];
    }
    function RGBtoHSV(e, t, i) {
      var n = Math.max(e, t, i), a = Math.min(e, t, i), o = n - a, l, c = n === 0 ? 0 : o / n, d = n / 255;
      switch (n) {
        case a:
          l = 0;
          break;
        case e:
          l = t - i + o * (t < i ? 6 : 0), l /= 6 * o;
          break;
        case t:
          l = i - e + o * 2, l /= 6 * o;
          break;
        case i:
          l = e - t + o * 4, l /= 6 * o;
          break;
      }
      return [l, c, d];
    }
    function addSaturationToRGB(e, t) {
      var i = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return i[1] += t, i[1] > 1 ? i[1] = 1 : i[1] <= 0 && (i[1] = 0), HSVtoRGB(i[0], i[1], i[2]);
    }
    function addBrightnessToRGB(e, t) {
      var i = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return i[2] += t, i[2] > 1 ? i[2] = 1 : i[2] < 0 && (i[2] = 0), HSVtoRGB(i[0], i[1], i[2]);
    }
    function addHueToRGB(e, t) {
      var i = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return i[0] += t / 360, i[0] > 1 ? i[0] -= 1 : i[0] < 0 && (i[0] += 1), HSVtoRGB(i[0], i[1], i[2]);
    }
    var rgbToHex = function() {
      var e = [], t, i;
      for (t = 0; t < 256; t += 1)
        i = t.toString(16), e[t] = i.length === 1 ? "0" + i : i;
      return function(n, a, o) {
        return n < 0 && (n = 0), a < 0 && (a = 0), o < 0 && (o = 0), "#" + e[n] + e[a] + e[o];
      };
    }(), setSubframeEnabled = function(t) {
      subframeEnabled = !!t;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(t) {
      expressionsPlugin = t;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(t) {
      expressionsInterfaces = t;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(t) {
      defaultCurveSegments = t;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(t) {
      idPrefix$1 = t;
    };
    function createNS(e) {
      return document.createElementNS(svgNS, e);
    }
    function _typeof$5(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(i) {
        return typeof i;
      } : _typeof$5 = function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, _typeof$5(e);
    }
    var dataManager = function() {
      var e = 1, t = [], i, n, a = { onmessage: function() {
      }, postMessage: function(D) {
        i({ data: D });
      } }, o = { postMessage: function(D) {
        a.onmessage({ data: D });
      } };
      function l(y) {
        if (window.Worker && window.Blob && getWebWorker()) {
          var D = new Blob(["var _workerSelf = self; self.onmessage = ", y.toString()], { type: "text/javascript" }), C = URL.createObjectURL(D);
          return new Worker(C);
        }
        return i = y, a;
      }
      function c() {
        n || (n = l(function(D) {
          function C() {
            function R(b, x) {
              var S, I, N = b.length, p, M, j, U;
              for (I = 0; I < N; I += 1)
                if (S = b[I], "ks" in S && !S.completed) {
                  if (S.completed = !0, S.hasMask) {
                    var H = S.masksProperties;
                    for (M = H.length, p = 0; p < M; p += 1)
                      if (H[p].pt.k.i)
                        L(H[p].pt.k);
                      else
                        for (U = H[p].pt.k.length, j = 0; j < U; j += 1)
                          H[p].pt.k[j].s && L(H[p].pt.k[j].s[0]), H[p].pt.k[j].e && L(H[p].pt.k[j].e[0]);
                  }
                  S.ty === 0 ? (S.layers = k(S.refId, x), R(S.layers, x)) : S.ty === 4 ? P(S.shapes) : S.ty === 5 && T(S);
                }
            }
            function O(b, x) {
              if (b) {
                var S = 0, I = b.length;
                for (S = 0; S < I; S += 1)
                  b[S].t === 1 && (b[S].data.layers = k(b[S].data.refId, x), R(b[S].data.layers, x));
              }
            }
            function $(b, x) {
              for (var S = 0, I = x.length; S < I; ) {
                if (x[S].id === b)
                  return x[S];
                S += 1;
              }
              return null;
            }
            function k(b, x) {
              var S = $(b, x);
              return S ? S.layers.__used ? JSON.parse(JSON.stringify(S.layers)) : (S.layers.__used = !0, S.layers) : null;
            }
            function P(b) {
              var x, S = b.length, I, N;
              for (x = S - 1; x >= 0; x -= 1)
                if (b[x].ty === "sh")
                  if (b[x].ks.k.i)
                    L(b[x].ks.k);
                  else
                    for (N = b[x].ks.k.length, I = 0; I < N; I += 1)
                      b[x].ks.k[I].s && L(b[x].ks.k[I].s[0]), b[x].ks.k[I].e && L(b[x].ks.k[I].e[0]);
                else
                  b[x].ty === "gr" && P(b[x].it);
            }
            function L(b) {
              var x, S = b.i.length;
              for (x = 0; x < S; x += 1)
                b.i[x][0] += b.v[x][0], b.i[x][1] += b.v[x][1], b.o[x][0] += b.v[x][0], b.o[x][1] += b.v[x][1];
            }
            function F(b, x) {
              var S = x ? x.split(".") : [100, 100, 100];
              return b[0] > S[0] ? !0 : S[0] > b[0] ? !1 : b[1] > S[1] ? !0 : S[1] > b[1] ? !1 : b[2] > S[2] ? !0 : S[2] > b[2] ? !1 : null;
            }
            var B = function() {
              var b = [4, 4, 14];
              function x(I) {
                var N = I.t.d;
                I.t.d = { k: [{ s: N, t: 0 }] };
              }
              function S(I) {
                var N, p = I.length;
                for (N = 0; N < p; N += 1)
                  I[N].ty === 5 && x(I[N]);
              }
              return function(I) {
                if (F(b, I.v) && (S(I.layers), I.assets)) {
                  var N, p = I.assets.length;
                  for (N = 0; N < p; N += 1)
                    I.assets[N].layers && S(I.assets[N].layers);
                }
              };
            }(), G = function() {
              var b = [4, 7, 99];
              return function(x) {
                if (x.chars && !F(b, x.v)) {
                  var S, I = x.chars.length;
                  for (S = 0; S < I; S += 1) {
                    var N = x.chars[S];
                    N.data && N.data.shapes && (P(N.data.shapes), N.data.ip = 0, N.data.op = 99999, N.data.st = 0, N.data.sr = 1, N.data.ks = { p: { k: [0, 0], a: 0 }, s: { k: [100, 100], a: 0 }, a: { k: [0, 0], a: 0 }, r: { k: 0, a: 0 }, o: { k: 100, a: 0 } }, x.chars[S].t || (N.data.shapes.push({ ty: "no" }), N.data.shapes[0].it.push({ p: { k: [0, 0], a: 0 }, s: { k: [100, 100], a: 0 }, a: { k: [0, 0], a: 0 }, r: { k: 0, a: 0 }, o: { k: 100, a: 0 }, sk: { k: 0, a: 0 }, sa: { k: 0, a: 0 }, ty: "tr" })));
                  }
                }
              };
            }(), Z = function() {
              var b = [5, 7, 15];
              function x(I) {
                var N = I.t.p;
                typeof N.a == "number" && (N.a = { a: 0, k: N.a }), typeof N.p == "number" && (N.p = { a: 0, k: N.p }), typeof N.r == "number" && (N.r = { a: 0, k: N.r });
              }
              function S(I) {
                var N, p = I.length;
                for (N = 0; N < p; N += 1)
                  I[N].ty === 5 && x(I[N]);
              }
              return function(I) {
                if (F(b, I.v) && (S(I.layers), I.assets)) {
                  var N, p = I.assets.length;
                  for (N = 0; N < p; N += 1)
                    I.assets[N].layers && S(I.assets[N].layers);
                }
              };
            }(), X = function() {
              var b = [4, 1, 9];
              function x(I) {
                var N, p = I.length, M, j;
                for (N = 0; N < p; N += 1)
                  if (I[N].ty === "gr")
                    x(I[N].it);
                  else if (I[N].ty === "fl" || I[N].ty === "st")
                    if (I[N].c.k && I[N].c.k[0].i)
                      for (j = I[N].c.k.length, M = 0; M < j; M += 1)
                        I[N].c.k[M].s && (I[N].c.k[M].s[0] /= 255, I[N].c.k[M].s[1] /= 255, I[N].c.k[M].s[2] /= 255, I[N].c.k[M].s[3] /= 255), I[N].c.k[M].e && (I[N].c.k[M].e[0] /= 255, I[N].c.k[M].e[1] /= 255, I[N].c.k[M].e[2] /= 255, I[N].c.k[M].e[3] /= 255);
                    else
                      I[N].c.k[0] /= 255, I[N].c.k[1] /= 255, I[N].c.k[2] /= 255, I[N].c.k[3] /= 255;
              }
              function S(I) {
                var N, p = I.length;
                for (N = 0; N < p; N += 1)
                  I[N].ty === 4 && x(I[N].shapes);
              }
              return function(I) {
                if (F(b, I.v) && (S(I.layers), I.assets)) {
                  var N, p = I.assets.length;
                  for (N = 0; N < p; N += 1)
                    I.assets[N].layers && S(I.assets[N].layers);
                }
              };
            }(), V = function() {
              var b = [4, 4, 18];
              function x(I) {
                var N, p = I.length, M, j;
                for (N = p - 1; N >= 0; N -= 1)
                  if (I[N].ty === "sh")
                    if (I[N].ks.k.i)
                      I[N].ks.k.c = I[N].closed;
                    else
                      for (j = I[N].ks.k.length, M = 0; M < j; M += 1)
                        I[N].ks.k[M].s && (I[N].ks.k[M].s[0].c = I[N].closed), I[N].ks.k[M].e && (I[N].ks.k[M].e[0].c = I[N].closed);
                  else
                    I[N].ty === "gr" && x(I[N].it);
              }
              function S(I) {
                var N, p, M = I.length, j, U, H, J;
                for (p = 0; p < M; p += 1) {
                  if (N = I[p], N.hasMask) {
                    var te = N.masksProperties;
                    for (U = te.length, j = 0; j < U; j += 1)
                      if (te[j].pt.k.i)
                        te[j].pt.k.c = te[j].cl;
                      else
                        for (J = te[j].pt.k.length, H = 0; H < J; H += 1)
                          te[j].pt.k[H].s && (te[j].pt.k[H].s[0].c = te[j].cl), te[j].pt.k[H].e && (te[j].pt.k[H].e[0].c = te[j].cl);
                  }
                  N.ty === 4 && x(N.shapes);
                }
              }
              return function(I) {
                if (F(b, I.v) && (S(I.layers), I.assets)) {
                  var N, p = I.assets.length;
                  for (N = 0; N < p; N += 1)
                    I.assets[N].layers && S(I.assets[N].layers);
                }
              };
            }();
            function E(b) {
              b.__complete || (X(b), B(b), G(b), Z(b), V(b), R(b.layers, b.assets), O(b.chars, b.assets), b.__complete = !0);
            }
            function T(b) {
              b.t.a.length === 0 && "m" in b.t.p;
            }
            var g = {};
            return g.completeData = E, g.checkColors = X, g.checkChars = G, g.checkPathProperties = Z, g.checkShapes = V, g.completeLayers = R, g;
          }
          if (o.dataManager || (o.dataManager = C()), o.assetLoader || (o.assetLoader = function() {
            function R($) {
              var k = $.getResponseHeader("content-type");
              return k && $.responseType === "json" && k.indexOf("json") !== -1 || $.response && _typeof$5($.response) === "object" ? $.response : $.response && typeof $.response == "string" ? JSON.parse($.response) : $.responseText ? JSON.parse($.responseText) : null;
            }
            function O($, k, P, L) {
              var F, B = new XMLHttpRequest();
              try {
                B.responseType = "json";
              } catch {
              }
              B.onreadystatechange = function() {
                if (B.readyState === 4)
                  if (B.status === 200)
                    F = R(B), P(F);
                  else
                    try {
                      F = R(B), P(F);
                    } catch (G) {
                      L && L(G);
                    }
              };
              try {
                B.open(["G", "E", "T"].join(""), $, !0);
              } catch {
                B.open(["G", "E", "T"].join(""), k + "/" + $, !0);
              }
              B.send();
            }
            return { load: O };
          }()), D.data.type === "loadAnimation")
            o.assetLoader.load(D.data.path, D.data.fullPath, function(R) {
              o.dataManager.completeData(R), o.postMessage({ id: D.data.id, payload: R, status: "success" });
            }, function() {
              o.postMessage({ id: D.data.id, status: "error" });
            });
          else if (D.data.type === "complete") {
            var z = D.data.animation;
            o.dataManager.completeData(z), o.postMessage({ id: D.data.id, payload: z, status: "success" });
          } else
            D.data.type === "loadData" && o.assetLoader.load(D.data.path, D.data.fullPath, function(R) {
              o.postMessage({ id: D.data.id, payload: R, status: "success" });
            }, function() {
              o.postMessage({ id: D.data.id, status: "error" });
            });
        }), n.onmessage = function(y) {
          var D = y.data, C = D.id, z = t[C];
          t[C] = null, D.status === "success" ? z.onComplete(D.payload) : z.onError && z.onError();
        });
      }
      function d(y, D) {
        e += 1;
        var C = "processId_" + e;
        return t[C] = { onComplete: y, onError: D }, C;
      }
      function u(y, D, C) {
        c();
        var z = d(D, C);
        n.postMessage({ type: "loadAnimation", path: y, fullPath: window.location.origin + window.location.pathname, id: z });
      }
      function m(y, D, C) {
        c();
        var z = d(D, C);
        n.postMessage({ type: "loadData", path: y, fullPath: window.location.origin + window.location.pathname, id: z });
      }
      function A(y, D, C) {
        c();
        var z = d(D, C);
        n.postMessage({ type: "complete", animation: y, id: z });
      }
      return { loadAnimation: u, loadData: m, completeAnimation: A };
    }(), ImagePreloader = function() {
      var e = function() {
        var O = createTag("canvas");
        O.width = 1, O.height = 1;
        var $ = O.getContext("2d");
        return $.fillStyle = "rgba(0,0,0,0)", $.fillRect(0, 0, 1, 1), O;
      }();
      function t() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function i() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function n(O, $, k) {
        var P = "";
        if (O.e)
          P = O.p;
        else if ($) {
          var L = O.p;
          L.indexOf("images/") !== -1 && (L = L.split("/")[1]), P = $ + L;
        } else
          P = k, P += O.u ? O.u : "", P += O.p;
        return P;
      }
      function a(O) {
        var $ = 0, k = setInterval(function() {
          var P = O.getBBox();
          (P.width || $ > 500) && (this._imageLoaded(), clearInterval(k)), $ += 1;
        }.bind(this), 50);
      }
      function o(O) {
        var $ = n(O, this.assetsPath, this.path), k = createNS("image");
        isSafari ? this.testImageLoaded(k) : k.addEventListener("load", this._imageLoaded, !1), k.addEventListener("error", function() {
          P.img = e, this._imageLoaded();
        }.bind(this), !1), k.setAttributeNS("http://www.w3.org/1999/xlink", "href", $), this._elementHelper.append ? this._elementHelper.append(k) : this._elementHelper.appendChild(k);
        var P = { img: k, assetData: O };
        return P;
      }
      function l(O) {
        var $ = n(O, this.assetsPath, this.path), k = createTag("img");
        k.crossOrigin = "anonymous", k.addEventListener("load", this._imageLoaded, !1), k.addEventListener("error", function() {
          P.img = e, this._imageLoaded();
        }.bind(this), !1), k.src = $;
        var P = { img: k, assetData: O };
        return P;
      }
      function c(O) {
        var $ = { assetData: O }, k = n(O, this.assetsPath, this.path);
        return dataManager.loadData(k, function(P) {
          $.img = P, this._footageLoaded();
        }.bind(this), function() {
          $.img = {}, this._footageLoaded();
        }.bind(this)), $;
      }
      function d(O, $) {
        this.imagesLoadedCb = $;
        var k, P = O.length;
        for (k = 0; k < P; k += 1)
          O[k].layers || (!O[k].t || O[k].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(O[k]))) : O[k].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(O[k]))));
      }
      function u(O) {
        this.path = O || "";
      }
      function m(O) {
        this.assetsPath = O || "";
      }
      function A(O) {
        for (var $ = 0, k = this.images.length; $ < k; ) {
          if (this.images[$].assetData === O)
            return this.images[$].img;
          $ += 1;
        }
        return null;
      }
      function y() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function D() {
        return this.totalImages === this.loadedAssets;
      }
      function C() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function z(O, $) {
        O === "svg" ? (this._elementHelper = $, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function R() {
        this._imageLoaded = t.bind(this), this._footageLoaded = i.bind(this), this.testImageLoaded = a.bind(this), this.createFootageData = c.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return R.prototype = { loadAssets: d, setAssetsPath: m, setPath: u, loadedImages: D, loadedFootages: C, destroy: y, getAsset: A, createImgData: l, createImageData: o, imageLoaded: t, footageLoaded: i, setCacheType: z }, R;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = { triggerEvent: function(t, i) {
      if (this._cbs[t])
        for (var n = this._cbs[t], a = 0; a < n.length; a += 1)
          n[a](i);
    }, addEventListener: function(t, i) {
      return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(i), function() {
        this.removeEventListener(t, i);
      }.bind(this);
    }, removeEventListener: function(t, i) {
      if (!i)
        this._cbs[t] = null;
      else if (this._cbs[t]) {
        for (var n = 0, a = this._cbs[t].length; n < a; )
          this._cbs[t][n] === i && (this._cbs[t].splice(n, 1), n -= 1, a -= 1), n += 1;
        this._cbs[t].length || (this._cbs[t] = null);
      }
    } };
    var markerParser = function() {
      function e(t) {
        for (var i = t.split(`\r
`), n = {}, a, o = 0, l = 0; l < i.length; l += 1)
          a = i[l].split(":"), a.length === 2 && (n[a[0]] = a[1].trim(), o += 1);
        if (o === 0)
          throw new Error();
        return n;
      }
      return function(t) {
        for (var i = [], n = 0; n < t.length; n += 1) {
          var a = t[n], o = { time: a.tm, duration: a.dr };
          try {
            o.payload = JSON.parse(t[n].cm);
          } catch {
            try {
              o.payload = e(t[n].cm);
            } catch {
              o.payload = { name: t[n].cm };
            }
          }
          i.push(o);
        }
        return i;
      };
    }(), ProjectInterface = function() {
      function e(t) {
        this.compositions.push(t);
      }
      return function() {
        function t(i) {
          for (var n = 0, a = this.compositions.length; n < a; ) {
            if (this.compositions[n].data && this.compositions[n].data.nm === i)
              return this.compositions[n].prepareFrame && this.compositions[n].data.xt && this.compositions[n].prepareFrame(this.currentFrame), this.compositions[n].compInterface;
            n += 1;
          }
          return null;
        }
        return t.compositions = [], t.currentFrame = 0, t.registerComposition = e, t;
      };
    }(), renderers = {}, registerRenderer = function(t, i) {
      renderers[t] = i;
    };
    function getRenderer(e) {
      return renderers[e];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas)
        return "canvas";
      for (var e in renderers)
        if (renderers[e])
          return e;
      return "";
    }
    function _typeof$4(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(i) {
        return typeof i;
      } : _typeof$4 = function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, _typeof$4(e);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(e) {
      (e.wrapper || e.container) && (this.wrapper = e.wrapper || e.container);
      var t = "svg";
      e.animType ? t = e.animType : e.renderer && (t = e.renderer);
      var i = getRenderer(t);
      this.renderer = new i(this, e.rendererSettings), this.imagePreloader.setCacheType(t, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = t, e.loop === "" || e.loop === null || e.loop === void 0 || e.loop === !0 ? this.loop = !0 : e.loop === !1 ? this.loop = !1 : this.loop = parseInt(e.loop, 10), this.autoplay = "autoplay" in e ? e.autoplay : !0, this.name = e.name ? e.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(e, "autoloadSegments") ? e.autoloadSegments : !0, this.assetsPath = e.assetsPath, this.initialSegment = e.initialSegment, e.audioFactory && this.audioController.setAudioFactory(e.audioFactory), e.animationData ? this.setupAnimation(e.animationData) : e.path && (e.path.lastIndexOf("\\") !== -1 ? this.path = e.path.substr(0, e.path.lastIndexOf("\\") + 1) : this.path = e.path.substr(0, e.path.lastIndexOf("/") + 1), this.fileName = e.path.substr(e.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(e.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(e) {
      dataManager.completeAnimation(e, this.configAnimation);
    }, AnimationItem.prototype.setData = function(e, t) {
      t && _typeof$4(t) !== "object" && (t = JSON.parse(t));
      var i = { wrapper: e, animationData: t }, n = e.attributes;
      i.path = n.getNamedItem("data-animation-path") ? n.getNamedItem("data-animation-path").value : n.getNamedItem("data-bm-path") ? n.getNamedItem("data-bm-path").value : n.getNamedItem("bm-path") ? n.getNamedItem("bm-path").value : "", i.animType = n.getNamedItem("data-anim-type") ? n.getNamedItem("data-anim-type").value : n.getNamedItem("data-bm-type") ? n.getNamedItem("data-bm-type").value : n.getNamedItem("bm-type") ? n.getNamedItem("bm-type").value : n.getNamedItem("data-bm-renderer") ? n.getNamedItem("data-bm-renderer").value : n.getNamedItem("bm-renderer") ? n.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var a = n.getNamedItem("data-anim-loop") ? n.getNamedItem("data-anim-loop").value : n.getNamedItem("data-bm-loop") ? n.getNamedItem("data-bm-loop").value : n.getNamedItem("bm-loop") ? n.getNamedItem("bm-loop").value : "";
      a === "false" ? i.loop = !1 : a === "true" ? i.loop = !0 : a !== "" && (i.loop = parseInt(a, 10));
      var o = n.getNamedItem("data-anim-autoplay") ? n.getNamedItem("data-anim-autoplay").value : n.getNamedItem("data-bm-autoplay") ? n.getNamedItem("data-bm-autoplay").value : n.getNamedItem("bm-autoplay") ? n.getNamedItem("bm-autoplay").value : !0;
      i.autoplay = o !== "false", i.name = n.getNamedItem("data-name") ? n.getNamedItem("data-name").value : n.getNamedItem("data-bm-name") ? n.getNamedItem("data-bm-name").value : n.getNamedItem("bm-name") ? n.getNamedItem("bm-name").value : "";
      var l = n.getNamedItem("data-anim-prerender") ? n.getNamedItem("data-anim-prerender").value : n.getNamedItem("data-bm-prerender") ? n.getNamedItem("data-bm-prerender").value : n.getNamedItem("bm-prerender") ? n.getNamedItem("bm-prerender").value : "";
      l === "false" && (i.prerender = !1), i.path ? this.setParams(i) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(e) {
      e.op > this.animationData.op && (this.animationData.op = e.op, this.totalFrames = Math.floor(e.op - this.animationData.ip));
      var t = this.animationData.layers, i, n = t.length, a = e.layers, o, l = a.length;
      for (o = 0; o < l; o += 1)
        for (i = 0; i < n; ) {
          if (t[i].id === a[o].id) {
            t[i] = a[o];
            break;
          }
          i += 1;
        }
      if ((e.chars || e.fonts) && (this.renderer.globalData.fontManager.addChars(e.chars), this.renderer.globalData.fontManager.addFonts(e.fonts, this.renderer.globalData.defs)), e.assets)
        for (n = e.assets.length, i = 0; i < n; i += 1)
          this.animationData.assets.push(e.assets[i]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(e) {
      this.animationData = e;
      var t = getExpressionsPlugin();
      t && t.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var e = this.animationData.segments;
      if (!e || e.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var t = e.shift();
      this.timeCompleted = t.time * this.frameRate;
      var i = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(i, this.includeLayers.bind(this), function() {
        this.trigger("data_failed");
      }.bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      var e = this.animationData.segments;
      e || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(e) {
      if (this.renderer)
        try {
          this.animationData = e, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(e), e.assets || (e.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(e.assets), this.markers = markerParser(e.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (t) {
          this.triggerConfigError(t);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var e = getExpressionsPlugin();
        e && e.initExpressions(this), this.renderer.initItems(), setTimeout(function() {
          this.trigger("DOMLoaded");
        }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(e, t) {
      var i = typeof e == "number" ? e : void 0, n = typeof t == "number" ? t : void 0;
      this.renderer.updateContainerSize(i, n);
    }, AnimationItem.prototype.setSubframe = function(e) {
      this.isSubframeEnabled = !!e;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (e) {
          this.triggerRenderFrameError(e);
        }
    }, AnimationItem.prototype.play = function(e) {
      e && this.name !== e || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_pause"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(e) {
      e && this.name !== e || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_play"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(e) {
      e && this.name !== e || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(e) {
      e && this.name !== e || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(e) {
      for (var t, i = 0; i < this.markers.length; i += 1)
        if (t = this.markers[i], t.payload && t.payload.name === e)
          return t;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(e, t, i) {
      if (!(i && this.name !== i)) {
        var n = Number(e);
        if (isNaN(n)) {
          var a = this.getMarkerData(e);
          a && this.goToAndStop(a.time, !0);
        } else
          t ? this.setCurrentRawFrameValue(e) : this.setCurrentRawFrameValue(e * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(e, t, i) {
      if (!(i && this.name !== i)) {
        var n = Number(e);
        if (isNaN(n)) {
          var a = this.getMarkerData(e);
          a && (a.duration ? this.playSegments([a.time, a.time + a.duration], !0) : this.goToAndStop(a.time, !0));
        } else
          this.goToAndStop(n, t, i);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(e) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var t = this.currentRawFrame + e * this.frameModifier, i = !1;
        t >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(t > this.totalFrames ? t % this.totalFrames : 0) || (i = !0, t = this.totalFrames - 1) : t >= this.totalFrames ? (this.playCount += 1, this.checkSegments(t % this.totalFrames) || (this.setCurrentRawFrameValue(t % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(t) : t < 0 ? this.checkSegments(t % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + t % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (i = !0, t = 0)) : this.setCurrentRawFrameValue(t), i && (this.setCurrentRawFrameValue(t), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(e, t) {
      this.playCount = 0, e[1] < e[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = e[0] - e[1], this.timeCompleted = this.totalFrames, this.firstFrame = e[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - t)) : e[1] > e[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = e[1] - e[0], this.timeCompleted = this.totalFrames, this.firstFrame = e[0], this.setCurrentRawFrameValue(1e-3 + t)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(e, t) {
      var i = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < e ? i = e : this.currentRawFrame + this.firstFrame > t && (i = t - e)), this.firstFrame = e, this.totalFrames = t - e, this.timeCompleted = this.totalFrames, i !== -1 && this.goToAndStop(i, !0);
    }, AnimationItem.prototype.playSegments = function(e, t) {
      if (t && (this.segments.length = 0), _typeof$4(e[0]) === "object") {
        var i, n = e.length;
        for (i = 0; i < n; i += 1)
          this.segments.push(e[i]);
      } else
        this.segments.push(e);
      this.segments.length && t && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(e) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), e && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(e) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), e), !0) : !1;
    }, AnimationItem.prototype.destroy = function(e) {
      e && this.name !== e || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(e) {
      this.currentRawFrame = e, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(e) {
      this.playSpeed = e, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(e) {
      this.playDirection = e < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(e) {
      this.loop = e;
    }, AnimationItem.prototype.setVolume = function(e, t) {
      t && this.name !== t || this.audioController.setVolume(e);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(e) {
      e && this.name !== e || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(e) {
      e && this.name !== e || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(e) {
      var t = "";
      if (e.e)
        t = e.p;
      else if (this.assetsPath) {
        var i = e.p;
        i.indexOf("images/") !== -1 && (i = i.split("/")[1]), t = this.assetsPath + i;
      } else
        t = this.path, t += e.u ? e.u : "", t += e.p;
      return t;
    }, AnimationItem.prototype.getAssetData = function(e) {
      for (var t = 0, i = this.assets.length; t < i; ) {
        if (e === this.assets[t].id)
          return this.assets[t];
        t += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(e) {
      return e ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(e, t, i) {
      try {
        var n = this.renderer.getElementByPath(e);
        n.updateDocumentData(t, i);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(e) {
      if (this._cbs && this._cbs[e])
        switch (e) {
          case "enterFrame":
            this.triggerEvent(e, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(e, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(e, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(e, new BMCompleteEvent(e, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(e, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(e, new BMDestroyEvent(e, this));
            break;
          default:
            this.triggerEvent(e);
        }
      e === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameMult)), e === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult)), e === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(e, this.frameMult)), e === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames)), e === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(e, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(e) {
      var t = new BMRenderFrameErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    }, AnimationItem.prototype.triggerConfigError = function(e) {
      var t = new BMConfigErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    };
    var animationManager = function() {
      var e = {}, t = [], i = 0, n = 0, a = 0, o = !0, l = !1;
      function c(x) {
        for (var S = 0, I = x.target; S < n; )
          t[S].animation === I && (t.splice(S, 1), S -= 1, n -= 1, I.isPaused || A()), S += 1;
      }
      function d(x, S) {
        if (!x)
          return null;
        for (var I = 0; I < n; ) {
          if (t[I].elem === x && t[I].elem !== null)
            return t[I].animation;
          I += 1;
        }
        var N = new AnimationItem();
        return y(N, x), N.setData(x, S), N;
      }
      function u() {
        var x, S = t.length, I = [];
        for (x = 0; x < S; x += 1)
          I.push(t[x].animation);
        return I;
      }
      function m() {
        a += 1, X();
      }
      function A() {
        a -= 1;
      }
      function y(x, S) {
        x.addEventListener("destroy", c), x.addEventListener("_active", m), x.addEventListener("_idle", A), t.push({ elem: S, animation: x }), n += 1;
      }
      function D(x) {
        var S = new AnimationItem();
        return y(S, null), S.setParams(x), S;
      }
      function C(x, S) {
        var I;
        for (I = 0; I < n; I += 1)
          t[I].animation.setSpeed(x, S);
      }
      function z(x, S) {
        var I;
        for (I = 0; I < n; I += 1)
          t[I].animation.setDirection(x, S);
      }
      function R(x) {
        var S;
        for (S = 0; S < n; S += 1)
          t[S].animation.play(x);
      }
      function O(x) {
        var S = x - i, I;
        for (I = 0; I < n; I += 1)
          t[I].animation.advanceTime(S);
        i = x, a && !l ? window.requestAnimationFrame(O) : o = !0;
      }
      function $(x) {
        i = x, window.requestAnimationFrame(O);
      }
      function k(x) {
        var S;
        for (S = 0; S < n; S += 1)
          t[S].animation.pause(x);
      }
      function P(x, S, I) {
        var N;
        for (N = 0; N < n; N += 1)
          t[N].animation.goToAndStop(x, S, I);
      }
      function L(x) {
        var S;
        for (S = 0; S < n; S += 1)
          t[S].animation.stop(x);
      }
      function F(x) {
        var S;
        for (S = 0; S < n; S += 1)
          t[S].animation.togglePause(x);
      }
      function B(x) {
        var S;
        for (S = n - 1; S >= 0; S -= 1)
          t[S].animation.destroy(x);
      }
      function G(x, S, I) {
        var N = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), p, M = N.length;
        for (p = 0; p < M; p += 1)
          I && N[p].setAttribute("data-bm-type", I), d(N[p], x);
        if (S && M === 0) {
          I || (I = "svg");
          var j = document.getElementsByTagName("body")[0];
          j.innerText = "";
          var U = createTag("div");
          U.style.width = "100%", U.style.height = "100%", U.setAttribute("data-bm-type", I), j.appendChild(U), d(U, x);
        }
      }
      function Z() {
        var x;
        for (x = 0; x < n; x += 1)
          t[x].animation.resize();
      }
      function X() {
        !l && a && o && (window.requestAnimationFrame($), o = !1);
      }
      function V() {
        l = !0;
      }
      function E() {
        l = !1, X();
      }
      function T(x, S) {
        var I;
        for (I = 0; I < n; I += 1)
          t[I].animation.setVolume(x, S);
      }
      function g(x) {
        var S;
        for (S = 0; S < n; S += 1)
          t[S].animation.mute(x);
      }
      function b(x) {
        var S;
        for (S = 0; S < n; S += 1)
          t[S].animation.unmute(x);
      }
      return e.registerAnimation = d, e.loadAnimation = D, e.setSpeed = C, e.setDirection = z, e.play = R, e.pause = k, e.stop = L, e.togglePause = F, e.searchAnimations = G, e.resize = Z, e.goToAndStop = P, e.destroy = B, e.freeze = V, e.unfreeze = E, e.setVolume = T, e.mute = g, e.unmute = b, e.getRegisteredAnimations = u, e;
    }(), BezierFactory = function() {
      var e = {};
      e.getBezierEasing = i;
      var t = {};
      function i($, k, P, L, F) {
        var B = F || ("bez_" + $ + "_" + k + "_" + P + "_" + L).replace(/\./g, "p");
        if (t[B])
          return t[B];
        var G = new O([$, k, P, L]);
        return t[B] = G, G;
      }
      var n = 4, a = 1e-3, o = 1e-7, l = 10, c = 11, d = 1 / (c - 1), u = typeof Float32Array == "function";
      function m($, k) {
        return 1 - 3 * k + 3 * $;
      }
      function A($, k) {
        return 3 * k - 6 * $;
      }
      function y($) {
        return 3 * $;
      }
      function D($, k, P) {
        return ((m(k, P) * $ + A(k, P)) * $ + y(k)) * $;
      }
      function C($, k, P) {
        return 3 * m(k, P) * $ * $ + 2 * A(k, P) * $ + y(k);
      }
      function z($, k, P, L, F) {
        var B, G, Z = 0;
        do
          G = k + (P - k) / 2, B = D(G, L, F) - $, B > 0 ? P = G : k = G;
        while (Math.abs(B) > o && ++Z < l);
        return G;
      }
      function R($, k, P, L) {
        for (var F = 0; F < n; ++F) {
          var B = C(k, P, L);
          if (B === 0)
            return k;
          var G = D(k, P, L) - $;
          k -= G / B;
        }
        return k;
      }
      function O($) {
        this._p = $, this._mSampleValues = u ? new Float32Array(c) : new Array(c), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return O.prototype = {
        get: function(k) {
          var P = this._p[0], L = this._p[1], F = this._p[2], B = this._p[3];
          return this._precomputed || this._precompute(), P === L && F === B ? k : k === 0 ? 0 : k === 1 ? 1 : D(this._getTForX(k), L, B);
        },
        // Private part
        _precompute: function() {
          var k = this._p[0], P = this._p[1], L = this._p[2], F = this._p[3];
          this._precomputed = !0, (k !== P || L !== F) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var k = this._p[0], P = this._p[2], L = 0; L < c; ++L)
            this._mSampleValues[L] = D(L * d, k, P);
        },
        /**
        * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
        */
        _getTForX: function(k) {
          for (var P = this._p[0], L = this._p[2], F = this._mSampleValues, B = 0, G = 1, Z = c - 1; G !== Z && F[G] <= k; ++G)
            B += d;
          --G;
          var X = (k - F[G]) / (F[G + 1] - F[G]), V = B + X * d, E = C(V, P, L);
          return E >= a ? R(k, V, P, L) : E === 0 ? V : z(k, B, B + d, P, L);
        }
      }, e;
    }(), pooling = function() {
      function e(t) {
        return t.concat(createSizedArray(t.length));
      }
      return { double: e };
    }(), poolFactory = function() {
      return function(e, t, i) {
        var n = 0, a = e, o = createSizedArray(a), l = { newElement: c, release: d };
        function c() {
          var u;
          return n ? (n -= 1, u = o[n]) : u = t(), u;
        }
        function d(u) {
          n === a && (o = pooling.double(o), a *= 2), i && i(u), o[n] = u, n += 1;
        }
        return l;
      };
    }(), bezierLengthPool = function() {
      function e() {
        return { addedLength: 0, percents: createTypedArray("float32", getDefaultCurveSegments()), lengths: createTypedArray("float32", getDefaultCurveSegments()) };
      }
      return poolFactory(8, e);
    }(), segmentsLengthPool = function() {
      function e() {
        return { lengths: [], totalLength: 0 };
      }
      function t(i) {
        var n, a = i.lengths.length;
        for (n = 0; n < a; n += 1)
          bezierLengthPool.release(i.lengths[n]);
        i.lengths.length = 0;
      }
      return poolFactory(8, e, t);
    }();
    function bezFunction() {
      var e = Math;
      function t(y, D, C, z, R, O) {
        var $ = y * z + D * R + C * O - R * z - O * y - C * D;
        return $ > -1e-3 && $ < 1e-3;
      }
      function i(y, D, C, z, R, O, $, k, P) {
        if (C === 0 && O === 0 && P === 0)
          return t(y, D, z, R, $, k);
        var L = e.sqrt(e.pow(z - y, 2) + e.pow(R - D, 2) + e.pow(O - C, 2)), F = e.sqrt(e.pow($ - y, 2) + e.pow(k - D, 2) + e.pow(P - C, 2)), B = e.sqrt(e.pow($ - z, 2) + e.pow(k - R, 2) + e.pow(P - O, 2)), G;
        return L > F ? L > B ? G = L - F - B : G = B - F - L : B > F ? G = B - F - L : G = F - L - B, G > -1e-4 && G < 1e-4;
      }
      var n = function() {
        return function(y, D, C, z) {
          var R = getDefaultCurveSegments(), O, $, k, P, L, F = 0, B, G = [], Z = [], X = bezierLengthPool.newElement();
          for (k = C.length, O = 0; O < R; O += 1) {
            for (L = O / (R - 1), B = 0, $ = 0; $ < k; $ += 1)
              P = bmPow(1 - L, 3) * y[$] + 3 * bmPow(1 - L, 2) * L * C[$] + 3 * (1 - L) * bmPow(L, 2) * z[$] + bmPow(L, 3) * D[$], G[$] = P, Z[$] !== null && (B += bmPow(G[$] - Z[$], 2)), Z[$] = G[$];
            B && (B = bmSqrt(B), F += B), X.percents[O] = L, X.lengths[O] = F;
          }
          return X.addedLength = F, X;
        };
      }();
      function a(y) {
        var D = segmentsLengthPool.newElement(), C = y.c, z = y.v, R = y.o, O = y.i, $, k = y._length, P = D.lengths, L = 0;
        for ($ = 0; $ < k - 1; $ += 1)
          P[$] = n(z[$], z[$ + 1], R[$], O[$ + 1]), L += P[$].addedLength;
        return C && k && (P[$] = n(z[$], z[0], R[$], O[0]), L += P[$].addedLength), D.totalLength = L, D;
      }
      function o(y) {
        this.segmentLength = 0, this.points = new Array(y);
      }
      function l(y, D) {
        this.partialLength = y, this.point = D;
      }
      var c = function() {
        var y = {};
        return function(D, C, z, R) {
          var O = (D[0] + "_" + D[1] + "_" + C[0] + "_" + C[1] + "_" + z[0] + "_" + z[1] + "_" + R[0] + "_" + R[1]).replace(/\./g, "p");
          if (!y[O]) {
            var $ = getDefaultCurveSegments(), k, P, L, F, B, G = 0, Z, X, V = null;
            D.length === 2 && (D[0] !== C[0] || D[1] !== C[1]) && t(D[0], D[1], C[0], C[1], D[0] + z[0], D[1] + z[1]) && t(D[0], D[1], C[0], C[1], C[0] + R[0], C[1] + R[1]) && ($ = 2);
            var E = new o($);
            for (L = z.length, k = 0; k < $; k += 1) {
              for (X = createSizedArray(L), B = k / ($ - 1), Z = 0, P = 0; P < L; P += 1)
                F = bmPow(1 - B, 3) * D[P] + 3 * bmPow(1 - B, 2) * B * (D[P] + z[P]) + 3 * (1 - B) * bmPow(B, 2) * (C[P] + R[P]) + bmPow(B, 3) * C[P], X[P] = F, V !== null && (Z += bmPow(X[P] - V[P], 2));
              Z = bmSqrt(Z), G += Z, E.points[k] = new l(Z, X), V = X;
            }
            E.segmentLength = G, y[O] = E;
          }
          return y[O];
        };
      }();
      function d(y, D) {
        var C = D.percents, z = D.lengths, R = C.length, O = bmFloor((R - 1) * y), $ = y * D.addedLength, k = 0;
        if (O === R - 1 || O === 0 || $ === z[O])
          return C[O];
        for (var P = z[O] > $ ? -1 : 1, L = !0; L; )
          if (z[O] <= $ && z[O + 1] > $ ? (k = ($ - z[O]) / (z[O + 1] - z[O]), L = !1) : O += P, O < 0 || O >= R - 1) {
            if (O === R - 1)
              return C[O];
            L = !1;
          }
        return C[O] + (C[O + 1] - C[O]) * k;
      }
      function u(y, D, C, z, R, O) {
        var $ = d(R, O), k = 1 - $, P = e.round((k * k * k * y[0] + ($ * k * k + k * $ * k + k * k * $) * C[0] + ($ * $ * k + k * $ * $ + $ * k * $) * z[0] + $ * $ * $ * D[0]) * 1e3) / 1e3, L = e.round((k * k * k * y[1] + ($ * k * k + k * $ * k + k * k * $) * C[1] + ($ * $ * k + k * $ * $ + $ * k * $) * z[1] + $ * $ * $ * D[1]) * 1e3) / 1e3;
        return [P, L];
      }
      var m = createTypedArray("float32", 8);
      function A(y, D, C, z, R, O, $) {
        R < 0 ? R = 0 : R > 1 && (R = 1);
        var k = d(R, $);
        O = O > 1 ? 1 : O;
        var P = d(O, $), L, F = y.length, B = 1 - k, G = 1 - P, Z = B * B * B, X = k * B * B * 3, V = k * k * B * 3, E = k * k * k, T = B * B * G, g = k * B * G + B * k * G + B * B * P, b = k * k * G + B * k * P + k * B * P, x = k * k * P, S = B * G * G, I = k * G * G + B * P * G + B * G * P, N = k * P * G + B * P * P + k * G * P, p = k * P * P, M = G * G * G, j = P * G * G + G * P * G + G * G * P, U = P * P * G + G * P * P + P * G * P, H = P * P * P;
        for (L = 0; L < F; L += 1)
          m[L * 4] = e.round((Z * y[L] + X * C[L] + V * z[L] + E * D[L]) * 1e3) / 1e3, m[L * 4 + 1] = e.round((T * y[L] + g * C[L] + b * z[L] + x * D[L]) * 1e3) / 1e3, m[L * 4 + 2] = e.round((S * y[L] + I * C[L] + N * z[L] + p * D[L]) * 1e3) / 1e3, m[L * 4 + 3] = e.round((M * y[L] + j * C[L] + U * z[L] + H * D[L]) * 1e3) / 1e3;
        return m;
      }
      return { getSegmentsLength: a, getNewSegment: A, getPointInSegment: u, buildBezierData: c, pointOnLine2D: t, pointOnLine3D: i };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(e, t) {
      var i = this.offsetTime, n;
      this.propType === "multidimensional" && (n = createTypedArray("float32", this.pv.length));
      for (var a = t.lastIndex, o = a, l = this.keyframes.length - 1, c = !0, d, u, m; c; ) {
        if (d = this.keyframes[o], u = this.keyframes[o + 1], o === l - 1 && e >= u.t - i) {
          d.h && (d = u), a = 0;
          break;
        }
        if (u.t - i > e) {
          a = o;
          break;
        }
        o < l - 1 ? o += 1 : (a = 0, c = !1);
      }
      m = this.keyframesMetadata[o] || {};
      var A, y, D, C, z, R, O = u.t - i, $ = d.t - i, k;
      if (d.to) {
        m.bezierData || (m.bezierData = bez.buildBezierData(d.s, u.s || d.e, d.to, d.ti));
        var P = m.bezierData;
        if (e >= O || e < $) {
          var L = e >= O ? P.points.length - 1 : 0;
          for (y = P.points[L].point.length, A = 0; A < y; A += 1)
            n[A] = P.points[L].point[A];
        } else {
          m.__fnct ? R = m.__fnct : (R = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y, d.n).get, m.__fnct = R), D = R((e - $) / (O - $));
          var F = P.segmentLength * D, B, G = t.lastFrame < e && t._lastKeyframeIndex === o ? t._lastAddedLength : 0;
          for (z = t.lastFrame < e && t._lastKeyframeIndex === o ? t._lastPoint : 0, c = !0, C = P.points.length; c; ) {
            if (G += P.points[z].partialLength, F === 0 || D === 0 || z === P.points.length - 1) {
              for (y = P.points[z].point.length, A = 0; A < y; A += 1)
                n[A] = P.points[z].point[A];
              break;
            } else if (F >= G && F < G + P.points[z + 1].partialLength) {
              for (B = (F - G) / P.points[z + 1].partialLength, y = P.points[z].point.length, A = 0; A < y; A += 1)
                n[A] = P.points[z].point[A] + (P.points[z + 1].point[A] - P.points[z].point[A]) * B;
              break;
            }
            z < C - 1 ? z += 1 : c = !1;
          }
          t._lastPoint = z, t._lastAddedLength = G - P.points[z].partialLength, t._lastKeyframeIndex = o;
        }
      } else {
        var Z, X, V, E, T;
        if (l = d.s.length, k = u.s || d.e, this.sh && d.h !== 1)
          if (e >= O)
            n[0] = k[0], n[1] = k[1], n[2] = k[2];
          else if (e <= $)
            n[0] = d.s[0], n[1] = d.s[1], n[2] = d.s[2];
          else {
            var g = createQuaternion(d.s), b = createQuaternion(k), x = (e - $) / (O - $);
            quaternionToEuler(n, slerp(g, b, x));
          }
        else
          for (o = 0; o < l; o += 1)
            d.h !== 1 && (e >= O ? D = 1 : e < $ ? D = 0 : (d.o.x.constructor === Array ? (m.__fnct || (m.__fnct = []), m.__fnct[o] ? R = m.__fnct[o] : (Z = d.o.x[o] === void 0 ? d.o.x[0] : d.o.x[o], X = d.o.y[o] === void 0 ? d.o.y[0] : d.o.y[o], V = d.i.x[o] === void 0 ? d.i.x[0] : d.i.x[o], E = d.i.y[o] === void 0 ? d.i.y[0] : d.i.y[o], R = BezierFactory.getBezierEasing(Z, X, V, E).get, m.__fnct[o] = R)) : m.__fnct ? R = m.__fnct : (Z = d.o.x, X = d.o.y, V = d.i.x, E = d.i.y, R = BezierFactory.getBezierEasing(Z, X, V, E).get, d.keyframeMetadata = R), D = R((e - $) / (O - $)))), k = u.s || d.e, T = d.h === 1 ? d.s[o] : d.s[o] + (k[o] - d.s[o]) * D, this.propType === "multidimensional" ? n[o] = T : n = T;
      }
      return t.lastIndex = a, n;
    }
    function slerp(e, t, i) {
      var n = [], a = e[0], o = e[1], l = e[2], c = e[3], d = t[0], u = t[1], m = t[2], A = t[3], y, D, C, z, R;
      return D = a * d + o * u + l * m + c * A, D < 0 && (D = -D, d = -d, u = -u, m = -m, A = -A), 1 - D > 1e-6 ? (y = Math.acos(D), C = Math.sin(y), z = Math.sin((1 - i) * y) / C, R = Math.sin(i * y) / C) : (z = 1 - i, R = i), n[0] = z * a + R * d, n[1] = z * o + R * u, n[2] = z * l + R * m, n[3] = z * c + R * A, n;
    }
    function quaternionToEuler(e, t) {
      var i = t[0], n = t[1], a = t[2], o = t[3], l = Math.atan2(2 * n * o - 2 * i * a, 1 - 2 * n * n - 2 * a * a), c = Math.asin(2 * i * n + 2 * a * o), d = Math.atan2(2 * i * o - 2 * n * a, 1 - 2 * i * i - 2 * a * a);
      e[0] = l / degToRads, e[1] = c / degToRads, e[2] = d / degToRads;
    }
    function createQuaternion(e) {
      var t = e[0] * degToRads, i = e[1] * degToRads, n = e[2] * degToRads, a = Math.cos(t / 2), o = Math.cos(i / 2), l = Math.cos(n / 2), c = Math.sin(t / 2), d = Math.sin(i / 2), u = Math.sin(n / 2), m = a * o * l - c * d * u, A = c * d * l + a * o * u, y = c * o * l + a * d * u, D = a * d * l - c * o * u;
      return [A, y, D, m];
    }
    function getValueAtCurrentTime() {
      var e = this.comp.renderedFrame - this.offsetTime, t = this.keyframes[0].t - this.offsetTime, i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(e === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= i && e >= i || this._caching.lastFrame < t && e < t))) {
        this._caching.lastFrame >= e && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var n = this.interpolateValue(e, this._caching);
        this.pv = n;
      }
      return this._caching.lastFrame = e, this.pv;
    }
    function setVValue(e) {
      var t;
      if (this.propType === "unidimensional")
        t = e * this.mult, mathAbs(this.v - t) > 1e-5 && (this.v = t, this._mdf = !0);
      else
        for (var i = 0, n = this.v.length; i < n; )
          t = e[i] * this.mult, mathAbs(this.v[i] - t) > 1e-5 && (this.v[i] = t, this._mdf = !0), i += 1;
    }
    function processEffectsSequence() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var e, t = this.effectsSequence.length, i = this.kf ? this.pv : this.data.k;
        for (e = 0; e < t; e += 1)
          i = this.effectsSequence[e](i);
        this.setVValue(i), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(e) {
      this.effectsSequence.push(e), this.container.addDynamicProperty(this);
    }
    function ValueProperty(e, t, i, n) {
      this.propType = "unidimensional", this.mult = i || 1, this.data = t, this.v = i ? t.k * i : t.k, this.pv = t.k, this._mdf = !1, this.elem = e, this.container = n, this.comp = e.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(e, t, i, n) {
      this.propType = "multidimensional", this.mult = i || 1, this.data = t, this._mdf = !1, this.elem = e, this.container = n, this.comp = e.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var a, o = t.k.length;
      for (this.v = createTypedArray("float32", o), this.pv = createTypedArray("float32", o), this.vel = createTypedArray("float32", o), a = 0; a < o; a += 1)
        this.v[a] = t.k[a] * this.mult, this.pv[a] = t.k[a];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(e, t, i, n) {
      this.propType = "unidimensional", this.keyframes = t.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.frameId = -1, this._caching = { lastFrame: initFrame, lastIndex: 0, value: 0, _lastKeyframeIndex: -1 }, this.k = !0, this.kf = !0, this.data = t, this.mult = i || 1, this.elem = e, this.container = n, this.comp = e.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(e, t, i, n) {
      this.propType = "multidimensional";
      var a, o = t.k.length, l, c, d, u;
      for (a = 0; a < o - 1; a += 1)
        t.k[a].to && t.k[a].s && t.k[a + 1] && t.k[a + 1].s && (l = t.k[a].s, c = t.k[a + 1].s, d = t.k[a].to, u = t.k[a].ti, (l.length === 2 && !(l[0] === c[0] && l[1] === c[1]) && bez.pointOnLine2D(l[0], l[1], c[0], c[1], l[0] + d[0], l[1] + d[1]) && bez.pointOnLine2D(l[0], l[1], c[0], c[1], c[0] + u[0], c[1] + u[1]) || l.length === 3 && !(l[0] === c[0] && l[1] === c[1] && l[2] === c[2]) && bez.pointOnLine3D(l[0], l[1], l[2], c[0], c[1], c[2], l[0] + d[0], l[1] + d[1], l[2] + d[2]) && bez.pointOnLine3D(l[0], l[1], l[2], c[0], c[1], c[2], c[0] + u[0], c[1] + u[1], c[2] + u[2])) && (t.k[a].to = null, t.k[a].ti = null), l[0] === c[0] && l[1] === c[1] && d[0] === 0 && d[1] === 0 && u[0] === 0 && u[1] === 0 && (l.length === 2 || l[2] === c[2] && d[2] === 0 && u[2] === 0) && (t.k[a].to = null, t.k[a].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = t, this.keyframes = t.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = i || 1, this.elem = e, this.container = n, this.comp = e.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var m = t.k[0].s.length;
      for (this.v = createTypedArray("float32", m), this.pv = createTypedArray("float32", m), a = 0; a < m; a += 1)
        this.v[a] = initFrame, this.pv[a] = initFrame;
      this._caching = { lastFrame: initFrame, lastIndex: 0, value: createTypedArray("float32", m) }, this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
      function e(i, n, a, o, l) {
        n.sid && (n = i.globalData.slotManager.getProp(n));
        var c;
        if (!n.k.length)
          c = new ValueProperty(i, n, o, l);
        else if (typeof n.k[0] == "number")
          c = new MultiDimensionalProperty(i, n, o, l);
        else
          switch (a) {
            case 0:
              c = new KeyframedValueProperty(i, n, o, l);
              break;
            case 1:
              c = new KeyframedMultidimensionalProperty(i, n, o, l);
              break;
          }
        return c.effectsSequence.length && l.addDynamicProperty(c), c;
      }
      var t = { getProp: e };
      return t;
    }();
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = { addDynamicProperty: function(t) {
      this.dynamicProperties.indexOf(t) === -1 && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
    }, iterateDynamicProperties: function() {
      this._mdf = !1;
      var t, i = this.dynamicProperties.length;
      for (t = 0; t < i; t += 1)
        this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
    }, initDynamicPropertyContainer: function(t) {
      this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
    } };
    var pointPool = function() {
      function e() {
        return createTypedArray("float32", 2);
      }
      return poolFactory(8, e);
    }();
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(e, t) {
      this.c = e, this.setLength(t);
      for (var i = 0; i < t; )
        this.v[i] = pointPool.newElement(), this.o[i] = pointPool.newElement(), this.i[i] = pointPool.newElement(), i += 1;
    }, ShapePath.prototype.setLength = function(e) {
      for (; this._maxLength < e; )
        this.doubleArrayLength();
      this._length = e;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(e, t, i, n, a) {
      var o;
      switch (this._length = Math.max(this._length, n + 1), this._length >= this._maxLength && this.doubleArrayLength(), i) {
        case "v":
          o = this.v;
          break;
        case "i":
          o = this.i;
          break;
        case "o":
          o = this.o;
          break;
        default:
          o = [];
          break;
      }
      (!o[n] || o[n] && !a) && (o[n] = pointPool.newElement()), o[n][0] = e, o[n][1] = t;
    }, ShapePath.prototype.setTripleAt = function(e, t, i, n, a, o, l, c) {
      this.setXYAt(e, t, "v", l, c), this.setXYAt(i, n, "o", l, c), this.setXYAt(a, o, "i", l, c);
    }, ShapePath.prototype.reverse = function() {
      var e = new ShapePath();
      e.setPathData(this.c, this._length);
      var t = this.v, i = this.o, n = this.i, a = 0;
      this.c && (e.setTripleAt(t[0][0], t[0][1], n[0][0], n[0][1], i[0][0], i[0][1], 0, !1), a = 1);
      var o = this._length - 1, l = this._length, c;
      for (c = a; c < l; c += 1)
        e.setTripleAt(t[o][0], t[o][1], n[o][0], n[o][1], i[o][0], i[o][1], c, !1), o -= 1;
      return e;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = function() {
      function e() {
        return new ShapePath();
      }
      function t(a) {
        var o = a._length, l;
        for (l = 0; l < o; l += 1)
          pointPool.release(a.v[l]), pointPool.release(a.i[l]), pointPool.release(a.o[l]), a.v[l] = null, a.i[l] = null, a.o[l] = null;
        a._length = 0, a.c = !1;
      }
      function i(a) {
        var o = n.newElement(), l, c = a._length === void 0 ? a.v.length : a._length;
        for (o.setLength(c), o.c = a.c, l = 0; l < c; l += 1)
          o.setTripleAt(a.v[l][0], a.v[l][1], a.o[l][0], a.o[l][1], a.i[l][0], a.i[l][1], l);
        return o;
      }
      var n = poolFactory(4, e, t);
      return n.clone = i, n;
    }();
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(e) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = e, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var e;
      for (e = 0; e < this._length; e += 1)
        shapePool.release(this.shapes[e]);
      this._length = 0;
    };
    var shapeCollectionPool = function() {
      var e = { newShapeCollection: a, release: o }, t = 0, i = 4, n = createSizedArray(i);
      function a() {
        var l;
        return t ? (t -= 1, l = n[t]) : l = new ShapeCollection(), l;
      }
      function o(l) {
        var c, d = l._length;
        for (c = 0; c < d; c += 1)
          shapePool.release(l.shapes[c]);
        l._length = 0, t === i && (n = pooling.double(n), i *= 2), n[t] = l, t += 1;
      }
      return e;
    }(), ShapePropertyFactory = function() {
      var e = -999999;
      function t(O, $, k) {
        var P = k.lastIndex, L, F, B, G, Z, X, V, E, T, g = this.keyframes;
        if (O < g[0].t - this.offsetTime)
          L = g[0].s[0], B = !0, P = 0;
        else if (O >= g[g.length - 1].t - this.offsetTime)
          L = g[g.length - 1].s ? g[g.length - 1].s[0] : g[g.length - 2].e[0], B = !0;
        else {
          for (var b = P, x = g.length - 1, S = !0, I, N, p; S && (I = g[b], N = g[b + 1], !(N.t - this.offsetTime > O)); )
            b < x - 1 ? b += 1 : S = !1;
          if (p = this.keyframesMetadata[b] || {}, B = I.h === 1, P = b, !B) {
            if (O >= N.t - this.offsetTime)
              E = 1;
            else if (O < I.t - this.offsetTime)
              E = 0;
            else {
              var M;
              p.__fnct ? M = p.__fnct : (M = BezierFactory.getBezierEasing(I.o.x, I.o.y, I.i.x, I.i.y).get, p.__fnct = M), E = M((O - (I.t - this.offsetTime)) / (N.t - this.offsetTime - (I.t - this.offsetTime)));
            }
            F = N.s ? N.s[0] : I.e[0];
          }
          L = I.s[0];
        }
        for (X = $._length, V = L.i[0].length, k.lastIndex = P, G = 0; G < X; G += 1)
          for (Z = 0; Z < V; Z += 1)
            T = B ? L.i[G][Z] : L.i[G][Z] + (F.i[G][Z] - L.i[G][Z]) * E, $.i[G][Z] = T, T = B ? L.o[G][Z] : L.o[G][Z] + (F.o[G][Z] - L.o[G][Z]) * E, $.o[G][Z] = T, T = B ? L.v[G][Z] : L.v[G][Z] + (F.v[G][Z] - L.v[G][Z]) * E, $.v[G][Z] = T;
      }
      function i() {
        var O = this.comp.renderedFrame - this.offsetTime, $ = this.keyframes[0].t - this.offsetTime, k = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, P = this._caching.lastFrame;
        return P !== e && (P < $ && O < $ || P > k && O > k) || (this._caching.lastIndex = P < O ? this._caching.lastIndex : 0, this.interpolateShape(O, this.pv, this._caching)), this._caching.lastFrame = O, this.pv;
      }
      function n() {
        this.paths = this.localShapeCollection;
      }
      function a(O, $) {
        if (O._length !== $._length || O.c !== $.c)
          return !1;
        var k, P = O._length;
        for (k = 0; k < P; k += 1)
          if (O.v[k][0] !== $.v[k][0] || O.v[k][1] !== $.v[k][1] || O.o[k][0] !== $.o[k][0] || O.o[k][1] !== $.o[k][1] || O.i[k][0] !== $.i[k][0] || O.i[k][1] !== $.i[k][1])
            return !1;
        return !0;
      }
      function o(O) {
        a(this.v, O) || (this.v = shapePool.clone(O), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function l() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var O;
          this.kf ? O = this.pv : this.data.ks ? O = this.data.ks.k : O = this.data.pt.k;
          var $, k = this.effectsSequence.length;
          for ($ = 0; $ < k; $ += 1)
            O = this.effectsSequence[$](O);
          this.setVValue(O), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function c(O, $, k) {
        this.propType = "shape", this.comp = O.comp, this.container = O, this.elem = O, this.data = $, this.k = !1, this.kf = !1, this._mdf = !1;
        var P = k === 3 ? $.pt.k : $.ks.k;
        this.v = shapePool.clone(P), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = n, this.effectsSequence = [];
      }
      function d(O) {
        this.effectsSequence.push(O), this.container.addDynamicProperty(this);
      }
      c.prototype.interpolateShape = t, c.prototype.getValue = l, c.prototype.setVValue = o, c.prototype.addEffect = d;
      function u(O, $, k) {
        this.propType = "shape", this.comp = O.comp, this.elem = O, this.container = O, this.offsetTime = O.data.st, this.keyframes = k === 3 ? $.pt.k : $.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var P = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, P), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = e, this.reset = n, this._caching = { lastFrame: e, lastIndex: 0 }, this.effectsSequence = [i.bind(this)];
      }
      u.prototype.getValue = l, u.prototype.interpolateShape = t, u.prototype.setVValue = o, u.prototype.addEffect = d;
      var m = function() {
        var O = roundCorner;
        function $(k, P) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = P.d, this.elem = k, this.comp = k.comp, this.frameId = -1, this.initDynamicPropertyContainer(k), this.p = PropertyFactory.getProp(k, P.p, 1, 0, this), this.s = PropertyFactory.getProp(k, P.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return $.prototype = { reset: n, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
        }, convertEllToPath: function() {
          var P = this.p.v[0], L = this.p.v[1], F = this.s.v[0] / 2, B = this.s.v[1] / 2, G = this.d !== 3, Z = this.v;
          Z.v[0][0] = P, Z.v[0][1] = L - B, Z.v[1][0] = G ? P + F : P - F, Z.v[1][1] = L, Z.v[2][0] = P, Z.v[2][1] = L + B, Z.v[3][0] = G ? P - F : P + F, Z.v[3][1] = L, Z.i[0][0] = G ? P - F * O : P + F * O, Z.i[0][1] = L - B, Z.i[1][0] = G ? P + F : P - F, Z.i[1][1] = L - B * O, Z.i[2][0] = G ? P + F * O : P - F * O, Z.i[2][1] = L + B, Z.i[3][0] = G ? P - F : P + F, Z.i[3][1] = L + B * O, Z.o[0][0] = G ? P + F * O : P - F * O, Z.o[0][1] = L - B, Z.o[1][0] = G ? P + F : P - F, Z.o[1][1] = L + B * O, Z.o[2][0] = G ? P - F * O : P + F * O, Z.o[2][1] = L + B, Z.o[3][0] = G ? P - F : P + F, Z.o[3][1] = L - B * O;
        } }, extendPrototype([DynamicPropertyContainer], $), $;
      }(), A = function() {
        function O($, k) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = $, this.comp = $.comp, this.data = k, this.frameId = -1, this.d = k.d, this.initDynamicPropertyContainer($), k.sy === 1 ? (this.ir = PropertyFactory.getProp($, k.ir, 0, 0, this), this.is = PropertyFactory.getProp($, k.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp($, k.pt, 0, 0, this), this.p = PropertyFactory.getProp($, k.p, 1, 0, this), this.r = PropertyFactory.getProp($, k.r, 0, degToRads, this), this.or = PropertyFactory.getProp($, k.or, 0, 0, this), this.os = PropertyFactory.getProp($, k.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return O.prototype = { reset: n, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
        }, convertStarToPath: function() {
          var k = Math.floor(this.pt.v) * 2, P = Math.PI * 2 / k, L = !0, F = this.or.v, B = this.ir.v, G = this.os.v, Z = this.is.v, X = 2 * Math.PI * F / (k * 2), V = 2 * Math.PI * B / (k * 2), E, T, g, b, x = -Math.PI / 2;
          x += this.r.v;
          var S = this.data.d === 3 ? -1 : 1;
          for (this.v._length = 0, E = 0; E < k; E += 1) {
            T = L ? F : B, g = L ? G : Z, b = L ? X : V;
            var I = T * Math.cos(x), N = T * Math.sin(x), p = I === 0 && N === 0 ? 0 : N / Math.sqrt(I * I + N * N), M = I === 0 && N === 0 ? 0 : -I / Math.sqrt(I * I + N * N);
            I += +this.p.v[0], N += +this.p.v[1], this.v.setTripleAt(I, N, I - p * b * g * S, N - M * b * g * S, I + p * b * g * S, N + M * b * g * S, E, !0), L = !L, x += P * S;
          }
        }, convertPolygonToPath: function() {
          var k = Math.floor(this.pt.v), P = Math.PI * 2 / k, L = this.or.v, F = this.os.v, B = 2 * Math.PI * L / (k * 4), G, Z = -Math.PI * 0.5, X = this.data.d === 3 ? -1 : 1;
          for (Z += this.r.v, this.v._length = 0, G = 0; G < k; G += 1) {
            var V = L * Math.cos(Z), E = L * Math.sin(Z), T = V === 0 && E === 0 ? 0 : E / Math.sqrt(V * V + E * E), g = V === 0 && E === 0 ? 0 : -V / Math.sqrt(V * V + E * E);
            V += +this.p.v[0], E += +this.p.v[1], this.v.setTripleAt(V, E, V - T * B * F * X, E - g * B * F * X, V + T * B * F * X, E + g * B * F * X, G, !0), Z += P * X;
          }
          this.paths.length = 0, this.paths[0] = this.v;
        } }, extendPrototype([DynamicPropertyContainer], O), O;
      }(), y = function() {
        function O($, k) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = $, this.comp = $.comp, this.frameId = -1, this.d = k.d, this.initDynamicPropertyContainer($), this.p = PropertyFactory.getProp($, k.p, 1, 0, this), this.s = PropertyFactory.getProp($, k.s, 1, 0, this), this.r = PropertyFactory.getProp($, k.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return O.prototype = { convertRectToPath: function() {
          var k = this.p.v[0], P = this.p.v[1], L = this.s.v[0] / 2, F = this.s.v[1] / 2, B = bmMin(L, F, this.r.v), G = B * (1 - roundCorner);
          this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(k + L, P - F + B, k + L, P - F + B, k + L, P - F + G, 0, !0), this.v.setTripleAt(k + L, P + F - B, k + L, P + F - G, k + L, P + F - B, 1, !0), B !== 0 ? (this.v.setTripleAt(k + L - B, P + F, k + L - B, P + F, k + L - G, P + F, 2, !0), this.v.setTripleAt(k - L + B, P + F, k - L + G, P + F, k - L + B, P + F, 3, !0), this.v.setTripleAt(k - L, P + F - B, k - L, P + F - B, k - L, P + F - G, 4, !0), this.v.setTripleAt(k - L, P - F + B, k - L, P - F + G, k - L, P - F + B, 5, !0), this.v.setTripleAt(k - L + B, P - F, k - L + B, P - F, k - L + G, P - F, 6, !0), this.v.setTripleAt(k + L - B, P - F, k + L - G, P - F, k + L - B, P - F, 7, !0)) : (this.v.setTripleAt(k - L, P + F, k - L + G, P + F, k - L, P + F, 2), this.v.setTripleAt(k - L, P - F, k - L, P - F + G, k - L, P - F, 3))) : (this.v.setTripleAt(k + L, P - F + B, k + L, P - F + G, k + L, P - F + B, 0, !0), B !== 0 ? (this.v.setTripleAt(k + L - B, P - F, k + L - B, P - F, k + L - G, P - F, 1, !0), this.v.setTripleAt(k - L + B, P - F, k - L + G, P - F, k - L + B, P - F, 2, !0), this.v.setTripleAt(k - L, P - F + B, k - L, P - F + B, k - L, P - F + G, 3, !0), this.v.setTripleAt(k - L, P + F - B, k - L, P + F - G, k - L, P + F - B, 4, !0), this.v.setTripleAt(k - L + B, P + F, k - L + B, P + F, k - L + G, P + F, 5, !0), this.v.setTripleAt(k + L - B, P + F, k + L - G, P + F, k + L - B, P + F, 6, !0), this.v.setTripleAt(k + L, P + F - B, k + L, P + F - B, k + L, P + F - G, 7, !0)) : (this.v.setTripleAt(k - L, P - F, k - L + G, P - F, k - L, P - F, 1, !0), this.v.setTripleAt(k - L, P + F, k - L, P + F - G, k - L, P + F, 2, !0), this.v.setTripleAt(k + L, P + F, k + L - G, P + F, k + L, P + F, 3, !0)));
        }, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
        }, reset: n }, extendPrototype([DynamicPropertyContainer], O), O;
      }();
      function D(O, $, k) {
        var P;
        if (k === 3 || k === 4) {
          var L = k === 3 ? $.pt : $.ks, F = L.k;
          F.length ? P = new u(O, $, k) : P = new c(O, $, k);
        } else
          k === 5 ? P = new y(O, $) : k === 6 ? P = new m(O, $) : k === 7 && (P = new A(O, $));
        return P.k && O.addDynamicProperty(P), P;
      }
      function C() {
        return c;
      }
      function z() {
        return u;
      }
      var R = {};
      return R.getShapeProp = D, R.getConstructorFunction = C, R.getKeyframedConstructorFunction = z, R;
    }();
    /*!
    Transformation Matrix v2.0
    (c) Epistemex 2014-2015
    www.epistemex.com
    By Ken Fyrstenberg
    Contributions by leeoniya.
    License: MIT, header required.
    */
    var Matrix = function() {
      var e = Math.cos, t = Math.sin, i = Math.tan, n = Math.round;
      function a() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function o(S) {
        if (S === 0)
          return this;
        var I = e(S), N = t(S);
        return this._t(I, -N, 0, 0, N, I, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function l(S) {
        if (S === 0)
          return this;
        var I = e(S), N = t(S);
        return this._t(1, 0, 0, 0, 0, I, -N, 0, 0, N, I, 0, 0, 0, 0, 1);
      }
      function c(S) {
        if (S === 0)
          return this;
        var I = e(S), N = t(S);
        return this._t(I, 0, N, 0, 0, 1, 0, 0, -N, 0, I, 0, 0, 0, 0, 1);
      }
      function d(S) {
        if (S === 0)
          return this;
        var I = e(S), N = t(S);
        return this._t(I, -N, 0, 0, N, I, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function u(S, I) {
        return this._t(1, I, S, 1, 0, 0);
      }
      function m(S, I) {
        return this.shear(i(S), i(I));
      }
      function A(S, I) {
        var N = e(I), p = t(I);
        return this._t(N, p, 0, 0, -p, N, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, i(S), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(N, -p, 0, 0, p, N, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function y(S, I, N) {
        return !N && N !== 0 && (N = 1), S === 1 && I === 1 && N === 1 ? this : this._t(S, 0, 0, 0, 0, I, 0, 0, 0, 0, N, 0, 0, 0, 0, 1);
      }
      function D(S, I, N, p, M, j, U, H, J, te, ae, le, ne, ue, ge, re) {
        return this.props[0] = S, this.props[1] = I, this.props[2] = N, this.props[3] = p, this.props[4] = M, this.props[5] = j, this.props[6] = U, this.props[7] = H, this.props[8] = J, this.props[9] = te, this.props[10] = ae, this.props[11] = le, this.props[12] = ne, this.props[13] = ue, this.props[14] = ge, this.props[15] = re, this;
      }
      function C(S, I, N) {
        return N = N || 0, S !== 0 || I !== 0 || N !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, S, I, N, 1) : this;
      }
      function z(S, I, N, p, M, j, U, H, J, te, ae, le, ne, ue, ge, re) {
        var fe = this.props;
        if (S === 1 && I === 0 && N === 0 && p === 0 && M === 0 && j === 1 && U === 0 && H === 0 && J === 0 && te === 0 && ae === 1 && le === 0)
          return fe[12] = fe[12] * S + fe[15] * ne, fe[13] = fe[13] * j + fe[15] * ue, fe[14] = fe[14] * ae + fe[15] * ge, fe[15] *= re, this._identityCalculated = !1, this;
        var oe = fe[0], ve = fe[1], Le = fe[2], Be = fe[3], we = fe[4], Ue = fe[5], Oe = fe[6], Te = fe[7], Ne = fe[8], Ee = fe[9], Se = fe[10], Re = fe[11], W = fe[12], Y = fe[13], Q = fe[14], ee = fe[15];
        return fe[0] = oe * S + ve * M + Le * J + Be * ne, fe[1] = oe * I + ve * j + Le * te + Be * ue, fe[2] = oe * N + ve * U + Le * ae + Be * ge, fe[3] = oe * p + ve * H + Le * le + Be * re, fe[4] = we * S + Ue * M + Oe * J + Te * ne, fe[5] = we * I + Ue * j + Oe * te + Te * ue, fe[6] = we * N + Ue * U + Oe * ae + Te * ge, fe[7] = we * p + Ue * H + Oe * le + Te * re, fe[8] = Ne * S + Ee * M + Se * J + Re * ne, fe[9] = Ne * I + Ee * j + Se * te + Re * ue, fe[10] = Ne * N + Ee * U + Se * ae + Re * ge, fe[11] = Ne * p + Ee * H + Se * le + Re * re, fe[12] = W * S + Y * M + Q * J + ee * ne, fe[13] = W * I + Y * j + Q * te + ee * ue, fe[14] = W * N + Y * U + Q * ae + ee * ge, fe[15] = W * p + Y * H + Q * le + ee * re, this._identityCalculated = !1, this;
      }
      function R() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function O(S) {
        for (var I = 0; I < 16; ) {
          if (S.props[I] !== this.props[I])
            return !1;
          I += 1;
        }
        return !0;
      }
      function $(S) {
        var I;
        for (I = 0; I < 16; I += 1)
          S.props[I] = this.props[I];
        return S;
      }
      function k(S) {
        var I;
        for (I = 0; I < 16; I += 1)
          this.props[I] = S[I];
      }
      function P(S, I, N) {
        return { x: S * this.props[0] + I * this.props[4] + N * this.props[8] + this.props[12], y: S * this.props[1] + I * this.props[5] + N * this.props[9] + this.props[13], z: S * this.props[2] + I * this.props[6] + N * this.props[10] + this.props[14] };
      }
      function L(S, I, N) {
        return S * this.props[0] + I * this.props[4] + N * this.props[8] + this.props[12];
      }
      function F(S, I, N) {
        return S * this.props[1] + I * this.props[5] + N * this.props[9] + this.props[13];
      }
      function B(S, I, N) {
        return S * this.props[2] + I * this.props[6] + N * this.props[10] + this.props[14];
      }
      function G() {
        var S = this.props[0] * this.props[5] - this.props[1] * this.props[4], I = this.props[5] / S, N = -this.props[1] / S, p = -this.props[4] / S, M = this.props[0] / S, j = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / S, U = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / S, H = new Matrix();
        return H.props[0] = I, H.props[1] = N, H.props[4] = p, H.props[5] = M, H.props[12] = j, H.props[13] = U, H;
      }
      function Z(S) {
        var I = this.getInverseMatrix();
        return I.applyToPointArray(S[0], S[1], S[2] || 0);
      }
      function X(S) {
        var I, N = S.length, p = [];
        for (I = 0; I < N; I += 1)
          p[I] = Z(S[I]);
        return p;
      }
      function V(S, I, N) {
        var p = createTypedArray("float32", 6);
        if (this.isIdentity())
          p[0] = S[0], p[1] = S[1], p[2] = I[0], p[3] = I[1], p[4] = N[0], p[5] = N[1];
        else {
          var M = this.props[0], j = this.props[1], U = this.props[4], H = this.props[5], J = this.props[12], te = this.props[13];
          p[0] = S[0] * M + S[1] * U + J, p[1] = S[0] * j + S[1] * H + te, p[2] = I[0] * M + I[1] * U + J, p[3] = I[0] * j + I[1] * H + te, p[4] = N[0] * M + N[1] * U + J, p[5] = N[0] * j + N[1] * H + te;
        }
        return p;
      }
      function E(S, I, N) {
        var p;
        return this.isIdentity() ? p = [S, I, N] : p = [S * this.props[0] + I * this.props[4] + N * this.props[8] + this.props[12], S * this.props[1] + I * this.props[5] + N * this.props[9] + this.props[13], S * this.props[2] + I * this.props[6] + N * this.props[10] + this.props[14]], p;
      }
      function T(S, I) {
        if (this.isIdentity())
          return S + "," + I;
        var N = this.props;
        return Math.round((S * N[0] + I * N[4] + N[12]) * 100) / 100 + "," + Math.round((S * N[1] + I * N[5] + N[13]) * 100) / 100;
      }
      function g() {
        for (var S = 0, I = this.props, N = "matrix3d(", p = 1e4; S < 16; )
          N += n(I[S] * p) / p, N += S === 15 ? ")" : ",", S += 1;
        return N;
      }
      function b(S) {
        var I = 1e4;
        return S < 1e-6 && S > 0 || S > -1e-6 && S < 0 ? n(S * I) / I : S;
      }
      function x() {
        var S = this.props, I = b(S[0]), N = b(S[1]), p = b(S[4]), M = b(S[5]), j = b(S[12]), U = b(S[13]);
        return "matrix(" + I + "," + N + "," + p + "," + M + "," + j + "," + U + ")";
      }
      return function() {
        this.reset = a, this.rotate = o, this.rotateX = l, this.rotateY = c, this.rotateZ = d, this.skew = m, this.skewFromAxis = A, this.shear = u, this.scale = y, this.setTransform = D, this.translate = C, this.transform = z, this.applyToPoint = P, this.applyToX = L, this.applyToY = F, this.applyToZ = B, this.applyToPointArray = E, this.applyToTriplePoints = V, this.applyToPointStringified = T, this.toCSS = g, this.to2dCSS = x, this.clone = $, this.cloneFromProps = k, this.equals = O, this.inversePoints = X, this.inversePoint = Z, this.getInverseMatrix = G, this._t = this.transform, this.isIdentity = R, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(i) {
        return typeof i;
      } : _typeof$3 = function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, _typeof$3(e);
    }
    var lottie = {};
    function setLocation(e) {
      setLocationHref(e);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(e) {
      setSubframeEnabled(e);
    }
    function setPrefix(e) {
      setIdPrefix(e);
    }
    function loadAnimation(e) {
      return animationManager.loadAnimation(e);
    }
    function setQuality(e) {
      if (typeof e == "string")
        switch (e) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
            break;
        }
      else
        !isNaN(e) && e > 1 && setDefaultCurveSegments(e);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(e, t) {
      e === "expressions" && setExpressionsPlugin(t);
    }
    function getFactory(e) {
      switch (e) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.11.0";
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(e) {
      for (var t = queryString.split("&"), i = 0; i < t.length; i += 1) {
        var n = t[i].split("=");
        if (decodeURIComponent(n[0]) == e)
          return decodeURIComponent(n[1]);
      }
      return null;
    }
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || { src: "" };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (e) {
    }
    var ShapeModifiers = function() {
      var e = {}, t = {};
      e.registerModifier = i, e.getModifier = n;
      function i(a, o) {
        t[a] || (t[a] = o);
      }
      function n(a, o, l) {
        return new t[a](o, l);
      }
      return e;
    }();
    function ShapeModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(e) {
      if (!this.closed) {
        e.sh.container.addDynamicProperty(e.sh);
        var t = { shape: e.sh, data: e, localShapeCollection: shapeCollectionPool.newShapeCollection() };
        this.shapes.push(t), this.addShapeToModifier(t), this._isAnimated && e.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(e, t) {
      this.shapes = [], this.elem = e, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
    function TrimModifier() {
    }
    extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(e, t) {
      this.s = PropertyFactory.getProp(e, t.s, 0, 0.01, this), this.e = PropertyFactory.getProp(e, t.e, 0, 0.01, this), this.o = PropertyFactory.getProp(e, t.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = t.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(e) {
      e.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(e, t, i, n, a) {
      var o = [];
      t <= 1 ? o.push({ s: e, e: t }) : e >= 1 ? o.push({ s: e - 1, e: t - 1 }) : (o.push({ s: e, e: 1 }), o.push({ s: 0, e: t - 1 }));
      var l = [], c, d = o.length, u;
      for (c = 0; c < d; c += 1)
        if (u = o[c], !(u.e * a < n || u.s * a > n + i)) {
          var m, A;
          u.s * a <= n ? m = 0 : m = (u.s * a - n) / i, u.e * a >= n + i ? A = 1 : A = (u.e * a - n) / i, l.push([m, A]);
        }
      return l.length || l.push([0, 0]), l;
    }, TrimModifier.prototype.releasePathsData = function(e) {
      var t, i = e.length;
      for (t = 0; t < i; t += 1)
        segmentsLengthPool.release(e[t]);
      return e.length = 0, e;
    }, TrimModifier.prototype.processShapes = function(e) {
      var t, i;
      if (this._mdf || e) {
        var n = this.o.v % 360 / 360;
        if (n < 0 && (n += 1), this.s.v > 1 ? t = 1 + n : this.s.v < 0 ? t = 0 + n : t = this.s.v + n, this.e.v > 1 ? i = 1 + n : this.e.v < 0 ? i = 0 + n : i = this.e.v + n, t > i) {
          var a = t;
          t = i, i = a;
        }
        t = Math.round(t * 1e4) * 1e-4, i = Math.round(i * 1e4) * 1e-4, this.sValue = t, this.eValue = i;
      } else
        t = this.sValue, i = this.eValue;
      var o, l, c = this.shapes.length, d, u, m, A, y, D = 0;
      if (i === t)
        for (l = 0; l < c; l += 1)
          this.shapes[l].localShapeCollection.releaseShapes(), this.shapes[l].shape._mdf = !0, this.shapes[l].shape.paths = this.shapes[l].localShapeCollection, this._mdf && (this.shapes[l].pathsData.length = 0);
      else if (i === 1 && t === 0 || i === 0 && t === 1) {
        if (this._mdf)
          for (l = 0; l < c; l += 1)
            this.shapes[l].pathsData.length = 0, this.shapes[l].shape._mdf = !0;
      } else {
        var C = [], z, R;
        for (l = 0; l < c; l += 1)
          if (z = this.shapes[l], !z.shape._mdf && !this._mdf && !e && this.m !== 2)
            z.shape.paths = z.localShapeCollection;
          else {
            if (o = z.shape.paths, u = o._length, y = 0, !z.shape._mdf && z.pathsData.length)
              y = z.totalShapeLength;
            else {
              for (m = this.releasePathsData(z.pathsData), d = 0; d < u; d += 1)
                A = bez.getSegmentsLength(o.shapes[d]), m.push(A), y += A.totalLength;
              z.totalShapeLength = y, z.pathsData = m;
            }
            D += y, z.shape._mdf = !0;
          }
        var O = t, $ = i, k = 0, P;
        for (l = c - 1; l >= 0; l -= 1)
          if (z = this.shapes[l], z.shape._mdf) {
            for (R = z.localShapeCollection, R.releaseShapes(), this.m === 2 && c > 1 ? (P = this.calculateShapeEdges(t, i, z.totalShapeLength, k, D), k += z.totalShapeLength) : P = [[O, $]], u = P.length, d = 0; d < u; d += 1) {
              O = P[d][0], $ = P[d][1], C.length = 0, $ <= 1 ? C.push({ s: z.totalShapeLength * O, e: z.totalShapeLength * $ }) : O >= 1 ? C.push({ s: z.totalShapeLength * (O - 1), e: z.totalShapeLength * ($ - 1) }) : (C.push({ s: z.totalShapeLength * O, e: z.totalShapeLength }), C.push({ s: 0, e: z.totalShapeLength * ($ - 1) }));
              var L = this.addShapes(z, C[0]);
              if (C[0].s !== C[0].e) {
                if (C.length > 1) {
                  var F = z.shape.paths.shapes[z.shape.paths._length - 1];
                  if (F.c) {
                    var B = L.pop();
                    this.addPaths(L, R), L = this.addShapes(z, C[1], B);
                  } else
                    this.addPaths(L, R), L = this.addShapes(z, C[1]);
                }
                this.addPaths(L, R);
              }
            }
            z.shape.paths = R;
          }
      }
    }, TrimModifier.prototype.addPaths = function(e, t) {
      var i, n = e.length;
      for (i = 0; i < n; i += 1)
        t.addShape(e[i]);
    }, TrimModifier.prototype.addSegment = function(e, t, i, n, a, o, l) {
      a.setXYAt(t[0], t[1], "o", o), a.setXYAt(i[0], i[1], "i", o + 1), l && a.setXYAt(e[0], e[1], "v", o), a.setXYAt(n[0], n[1], "v", o + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(e, t, i, n) {
      t.setXYAt(e[1], e[5], "o", i), t.setXYAt(e[2], e[6], "i", i + 1), n && t.setXYAt(e[0], e[4], "v", i), t.setXYAt(e[3], e[7], "v", i + 1);
    }, TrimModifier.prototype.addShapes = function(e, t, i) {
      var n = e.pathsData, a = e.shape.paths.shapes, o, l = e.shape.paths._length, c, d, u = 0, m, A, y, D, C = [], z, R = !0;
      for (i ? (A = i._length, z = i._length) : (i = shapePool.newElement(), A = 0, z = 0), C.push(i), o = 0; o < l; o += 1) {
        for (y = n[o].lengths, i.c = a[o].c, d = a[o].c ? y.length : y.length + 1, c = 1; c < d; c += 1)
          if (m = y[c - 1], u + m.addedLength < t.s)
            u += m.addedLength, i.c = !1;
          else if (u > t.e) {
            i.c = !1;
            break;
          } else
            t.s <= u && t.e >= u + m.addedLength ? (this.addSegment(a[o].v[c - 1], a[o].o[c - 1], a[o].i[c], a[o].v[c], i, A, R), R = !1) : (D = bez.getNewSegment(a[o].v[c - 1], a[o].v[c], a[o].o[c - 1], a[o].i[c], (t.s - u) / m.addedLength, (t.e - u) / m.addedLength, y[c - 1]), this.addSegmentFromArray(D, i, A, R), R = !1, i.c = !1), u += m.addedLength, A += 1;
        if (a[o].c && y.length) {
          if (m = y[c - 1], u <= t.e) {
            var O = y[c - 1].addedLength;
            t.s <= u && t.e >= u + O ? (this.addSegment(a[o].v[c - 1], a[o].o[c - 1], a[o].i[0], a[o].v[0], i, A, R), R = !1) : (D = bez.getNewSegment(a[o].v[c - 1], a[o].v[0], a[o].o[c - 1], a[o].i[0], (t.s - u) / O, (t.e - u) / O, y[c - 1]), this.addSegmentFromArray(D, i, A, R), R = !1, i.c = !1);
          } else
            i.c = !1;
          u += m.addedLength, A += 1;
        }
        if (i._length && (i.setXYAt(i.v[z][0], i.v[z][1], "i", z), i.setXYAt(i.v[i._length - 1][0], i.v[i._length - 1][1], "o", i._length - 1)), u > t.e)
          break;
        o < l - 1 && (i = shapePool.newElement(), R = !0, C.push(i), A = 0);
      }
      return C;
    };
    function PuckerAndBloatModifier() {
    }
    extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(e, t) {
      var i = t / 100, n = [0, 0], a = e._length, o = 0;
      for (o = 0; o < a; o += 1)
        n[0] += e.v[o][0], n[1] += e.v[o][1];
      n[0] /= a, n[1] /= a;
      var l = shapePool.newElement();
      l.c = e.c;
      var c, d, u, m, A, y;
      for (o = 0; o < a; o += 1)
        c = e.v[o][0] + (n[0] - e.v[o][0]) * i, d = e.v[o][1] + (n[1] - e.v[o][1]) * i, u = e.o[o][0] + (n[0] - e.o[o][0]) * -i, m = e.o[o][1] + (n[1] - e.o[o][1]) * -i, A = e.i[o][0] + (n[0] - e.i[o][0]) * -i, y = e.i[o][1] + (n[1] - e.i[o][1]) * -i, l.setTripleAt(c, d, u, m, A, y, o);
      return l;
    }, PuckerAndBloatModifier.prototype.processShapes = function(e) {
      var t, i, n = this.shapes.length, a, o, l = this.amount.v;
      if (l !== 0) {
        var c, d;
        for (i = 0; i < n; i += 1) {
          if (c = this.shapes[i], d = c.localShapeCollection, !(!c.shape._mdf && !this._mdf && !e))
            for (d.releaseShapes(), c.shape._mdf = !0, t = c.shape.paths.shapes, o = c.shape.paths._length, a = 0; a < o; a += 1)
              d.addShape(this.processPath(t[a], l));
          c.shape.paths = c.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var e = [0, 0];
      function t(d) {
        var u = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || u, this.a && d.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && d.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && d.skewFromAxis(-this.sk.v, this.sa.v), this.r ? d.rotate(-this.r.v) : d.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? d.translate(this.px.v, this.py.v, -this.pz.v) : d.translate(this.px.v, this.py.v, 0) : d.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function i(d) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || d) {
            var u;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var m, A;
              if (u = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (m = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / u, 0), A = this.p.getValueAtTime(this.p.keyframes[0].t / u, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (m = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / u, 0), A = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / u, 0)) : (m = this.p.pv, A = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / u, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                m = [], A = [];
                var y = this.px, D = this.py;
                y._caching.lastFrame + y.offsetTime <= y.keyframes[0].t ? (m[0] = y.getValueAtTime((y.keyframes[0].t + 0.01) / u, 0), m[1] = D.getValueAtTime((D.keyframes[0].t + 0.01) / u, 0), A[0] = y.getValueAtTime(y.keyframes[0].t / u, 0), A[1] = D.getValueAtTime(D.keyframes[0].t / u, 0)) : y._caching.lastFrame + y.offsetTime >= y.keyframes[y.keyframes.length - 1].t ? (m[0] = y.getValueAtTime(y.keyframes[y.keyframes.length - 1].t / u, 0), m[1] = D.getValueAtTime(D.keyframes[D.keyframes.length - 1].t / u, 0), A[0] = y.getValueAtTime((y.keyframes[y.keyframes.length - 1].t - 0.01) / u, 0), A[1] = D.getValueAtTime((D.keyframes[D.keyframes.length - 1].t - 0.01) / u, 0)) : (m = [y.pv, D.pv], A[0] = y.getValueAtTime((y._caching.lastFrame + y.offsetTime - 0.01) / u, y.offsetTime), A[1] = D.getValueAtTime((D._caching.lastFrame + D.offsetTime - 0.01) / u, D.offsetTime));
              } else
                A = e, m = A;
              this.v.rotate(-Math.atan2(m[1] - A[1], m[0] - A[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function n() {
        if (!this.a.k)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function a() {
      }
      function o(d) {
        this._addDynamicProperty(d), this.elem.addDynamicProperty(d), this._isDirty = !0;
      }
      function l(d, u, m) {
        if (this.elem = d, this.frameId = -1, this.propType = "transform", this.data = u, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(m || d), u.p && u.p.s ? (this.px = PropertyFactory.getProp(d, u.p.x, 0, 0, this), this.py = PropertyFactory.getProp(d, u.p.y, 0, 0, this), u.p.z && (this.pz = PropertyFactory.getProp(d, u.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(d, u.p || { k: [0, 0, 0] }, 1, 0, this), u.rx) {
          if (this.rx = PropertyFactory.getProp(d, u.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(d, u.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(d, u.rz, 0, degToRads, this), u.or.k[0].ti) {
            var A, y = u.or.k.length;
            for (A = 0; A < y; A += 1)
              u.or.k[A].to = null, u.or.k[A].ti = null;
          }
          this.or = PropertyFactory.getProp(d, u.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(d, u.r || { k: 0 }, 0, degToRads, this);
        u.sk && (this.sk = PropertyFactory.getProp(d, u.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(d, u.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(d, u.a || { k: [0, 0, 0] }, 1, 0, this), this.s = PropertyFactory.getProp(d, u.s || { k: [100, 100, 100] }, 1, 0.01, this), u.o ? this.o = PropertyFactory.getProp(d, u.o, 0, 0.01, d) : this.o = { _mdf: !1, v: 1 }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      l.prototype = { applyToMatrix: t, getValue: i, precalculateMatrix: n, autoOrient: a }, extendPrototype([DynamicPropertyContainer], l), l.prototype.addDynamicProperty = o, l.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
      function c(d, u, m) {
        return new l(d, u, m);
      }
      return { getTransformProperty: c };
    }();
    function RepeaterModifier() {
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(e, t.c, 0, null, this), this.o = PropertyFactory.getProp(e, t.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(e, t.tr, this), this.so = PropertyFactory.getProp(e, t.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(e, t.tr.eo, 0, 0.01, this), this.data = t, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(e, t, i, n, a, o) {
      var l = o ? -1 : 1, c = n.s.v[0] + (1 - n.s.v[0]) * (1 - a), d = n.s.v[1] + (1 - n.s.v[1]) * (1 - a);
      e.translate(n.p.v[0] * l * a, n.p.v[1] * l * a, n.p.v[2]), t.translate(-n.a.v[0], -n.a.v[1], n.a.v[2]), t.rotate(-n.r.v * l * a), t.translate(n.a.v[0], n.a.v[1], n.a.v[2]), i.translate(-n.a.v[0], -n.a.v[1], n.a.v[2]), i.scale(o ? 1 / c : c, o ? 1 / d : d), i.translate(n.a.v[0], n.a.v[1], n.a.v[2]);
    }, RepeaterModifier.prototype.init = function(e, t, i, n) {
      for (this.elem = e, this.arr = t, this.pos = i, this.elemsData = n, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t[i]); i > 0; )
        i -= 1, this._elements.unshift(t[i]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(e) {
      var t, i = e.length;
      for (t = 0; t < i; t += 1)
        e[t]._processed = !1, e[t].ty === "gr" && this.resetElements(e[t].it);
    }, RepeaterModifier.prototype.cloneElements = function(e) {
      var t = JSON.parse(JSON.stringify(e));
      return this.resetElements(t), t;
    }, RepeaterModifier.prototype.changeGroupRender = function(e, t) {
      var i, n = e.length;
      for (i = 0; i < n; i += 1)
        e[i]._render = t, e[i].ty === "gr" && this.changeGroupRender(e[i].it, t);
    }, RepeaterModifier.prototype.processShapes = function(e) {
      var t, i, n, a, o, l = !1;
      if (this._mdf || e) {
        var c = Math.ceil(this.c.v);
        if (this._groups.length < c) {
          for (; this._groups.length < c; ) {
            var d = { it: this.cloneElements(this._elements), ty: "gr" };
            d.it.push({ a: { a: 0, ix: 1, k: [0, 0] }, nm: "Transform", o: { a: 0, ix: 7, k: 100 }, p: { a: 0, ix: 2, k: [0, 0] }, r: { a: 1, ix: 6, k: [{ s: 0, e: 0, t: 0 }, { s: 0, e: 0, t: 1 }] }, s: { a: 0, ix: 3, k: [100, 100] }, sa: { a: 0, ix: 5, k: 0 }, sk: { a: 0, ix: 4, k: 0 }, ty: "tr" }), this.arr.splice(0, 0, d), this._groups.splice(0, 0, d), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), l = !0;
        }
        o = 0;
        var u;
        for (n = 0; n <= this._groups.length - 1; n += 1) {
          if (u = o < c, this._groups[n]._render = u, this.changeGroupRender(this._groups[n].it, u), !u) {
            var m = this.elemsData[n].it, A = m[m.length - 1];
            A.transform.op.v !== 0 ? (A.transform.op._mdf = !0, A.transform.op.v = 0) : A.transform.op._mdf = !1;
          }
          o += 1;
        }
        this._currentCopies = c;
        var y = this.o.v, D = y % 1, C = y > 0 ? Math.floor(y) : Math.ceil(y), z = this.pMatrix.props, R = this.rMatrix.props, O = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var $ = 0;
        if (y > 0) {
          for (; $ < C; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), $ += 1;
          D && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, D, !1), $ += D);
        } else if (y < 0) {
          for (; $ > C; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), $ -= 1;
          D && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -D, !0), $ -= D);
        }
        n = this.data.m === 1 ? 0 : this._currentCopies - 1, a = this.data.m === 1 ? 1 : -1, o = this._currentCopies;
        for (var k, P; o; ) {
          if (t = this.elemsData[n].it, i = t[t.length - 1].transform.mProps.v.props, P = i.length, t[t.length - 1].transform.mProps._mdf = !0, t[t.length - 1].transform.op._mdf = !0, t[t.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (n / (this._currentCopies - 1)), $ !== 0) {
            for ((n !== 0 && a === 1 || n !== this._currentCopies - 1 && a === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(R[0], R[1], R[2], R[3], R[4], R[5], R[6], R[7], R[8], R[9], R[10], R[11], R[12], R[13], R[14], R[15]), this.matrix.transform(O[0], O[1], O[2], O[3], O[4], O[5], O[6], O[7], O[8], O[9], O[10], O[11], O[12], O[13], O[14], O[15]), this.matrix.transform(z[0], z[1], z[2], z[3], z[4], z[5], z[6], z[7], z[8], z[9], z[10], z[11], z[12], z[13], z[14], z[15]), k = 0; k < P; k += 1)
              i[k] = this.matrix.props[k];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), k = 0; k < P; k += 1)
              i[k] = this.matrix.props[k];
          $ += 1, o -= 1, n += a;
        }
      } else
        for (o = this._currentCopies, n = 0, a = 1; o; )
          t = this.elemsData[n].it, i = t[t.length - 1].transform.mProps.v.props, t[t.length - 1].transform.mProps._mdf = !1, t[t.length - 1].transform.op._mdf = !1, o -= 1, n += a;
      return l;
    }, RepeaterModifier.prototype.addShape = function() {
    };
    function RoundCornersModifier() {
    }
    extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(e, t.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(e, t) {
      var i = shapePool.newElement();
      i.c = e.c;
      var n, a = e._length, o, l, c, d, u, m, A = 0, y, D, C, z, R, O;
      for (n = 0; n < a; n += 1)
        o = e.v[n], c = e.o[n], l = e.i[n], o[0] === c[0] && o[1] === c[1] && o[0] === l[0] && o[1] === l[1] ? (n === 0 || n === a - 1) && !e.c ? (i.setTripleAt(o[0], o[1], c[0], c[1], l[0], l[1], A), A += 1) : (n === 0 ? d = e.v[a - 1] : d = e.v[n - 1], u = Math.sqrt(Math.pow(o[0] - d[0], 2) + Math.pow(o[1] - d[1], 2)), m = u ? Math.min(u / 2, t) / u : 0, R = o[0] + (d[0] - o[0]) * m, y = R, O = o[1] - (o[1] - d[1]) * m, D = O, C = y - (y - o[0]) * roundCorner, z = D - (D - o[1]) * roundCorner, i.setTripleAt(y, D, C, z, R, O, A), A += 1, n === a - 1 ? d = e.v[0] : d = e.v[n + 1], u = Math.sqrt(Math.pow(o[0] - d[0], 2) + Math.pow(o[1] - d[1], 2)), m = u ? Math.min(u / 2, t) / u : 0, C = o[0] + (d[0] - o[0]) * m, y = C, z = o[1] + (d[1] - o[1]) * m, D = z, R = y - (y - o[0]) * roundCorner, O = D - (D - o[1]) * roundCorner, i.setTripleAt(y, D, C, z, R, O, A), A += 1) : (i.setTripleAt(e.v[n][0], e.v[n][1], e.o[n][0], e.o[n][1], e.i[n][0], e.i[n][1], A), A += 1);
      return i;
    }, RoundCornersModifier.prototype.processShapes = function(e) {
      var t, i, n = this.shapes.length, a, o, l = this.rd.v;
      if (l !== 0) {
        var c, d;
        for (i = 0; i < n; i += 1) {
          if (c = this.shapes[i], d = c.localShapeCollection, !(!c.shape._mdf && !this._mdf && !e))
            for (d.releaseShapes(), c.shape._mdf = !0, t = c.shape.paths.shapes, o = c.shape.paths._length, a = 0; a < o; a += 1)
              d.addShape(this.processPath(t[a], l));
          c.shape.paths = c.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function floatEqual(e, t) {
      return Math.abs(e - t) * 1e5 <= Math.min(Math.abs(e), Math.abs(t));
    }
    function floatZero(e) {
      return Math.abs(e) <= 1e-5;
    }
    function lerp(e, t, i) {
      return e * (1 - i) + t * i;
    }
    function lerpPoint(e, t, i) {
      return [lerp(e[0], t[0], i), lerp(e[1], t[1], i)];
    }
    function quadRoots(e, t, i) {
      if (e === 0)
        return [];
      var n = t * t - 4 * e * i;
      if (n < 0)
        return [];
      var a = -t / (2 * e);
      if (n === 0)
        return [a];
      var o = Math.sqrt(n) / (2 * e);
      return [a - o, a + o];
    }
    function polynomialCoefficients(e, t, i, n) {
      return [-e + 3 * t - 3 * i + n, 3 * e - 6 * t + 3 * i, -3 * e + 3 * t, e];
    }
    function singlePoint(e) {
      return new PolynomialBezier(e, e, e, e, !1);
    }
    function PolynomialBezier(e, t, i, n, a) {
      a && pointEqual(e, t) && (t = lerpPoint(e, n, 1 / 3)), a && pointEqual(i, n) && (i = lerpPoint(e, n, 2 / 3));
      var o = polynomialCoefficients(e[0], t[0], i[0], n[0]), l = polynomialCoefficients(e[1], t[1], i[1], n[1]);
      this.a = [o[0], l[0]], this.b = [o[1], l[1]], this.c = [o[2], l[2]], this.d = [o[3], l[3]], this.points = [e, t, i, n];
    }
    PolynomialBezier.prototype.point = function(e) {
      return [((this.a[0] * e + this.b[0]) * e + this.c[0]) * e + this.d[0], ((this.a[1] * e + this.b[1]) * e + this.c[1]) * e + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(e) {
      return [(3 * e * this.a[0] + 2 * this.b[0]) * e + this.c[0], (3 * e * this.a[1] + 2 * this.b[1]) * e + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[1], t[0]);
    }, PolynomialBezier.prototype.normalAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[0], t[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var e = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(e))
        return [];
      var t = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / e, i = t * t - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / e;
      if (i < 0)
        return [];
      var n = Math.sqrt(i);
      return floatZero(n) ? n > 0 && n < 1 ? [t] : [] : [t - n, t + n].filter(function(a) {
        return a > 0 && a < 1;
      });
    }, PolynomialBezier.prototype.split = function(e) {
      if (e <= 0)
        return [singlePoint(this.points[0]), this];
      if (e >= 1)
        return [this, singlePoint(this.points[this.points.length - 1])];
      var t = lerpPoint(this.points[0], this.points[1], e), i = lerpPoint(this.points[1], this.points[2], e), n = lerpPoint(this.points[2], this.points[3], e), a = lerpPoint(t, i, e), o = lerpPoint(i, n, e), l = lerpPoint(a, o, e);
      return [new PolynomialBezier(this.points[0], t, a, l, !0), new PolynomialBezier(l, o, n, this.points[3], !0)];
    };
    function extrema(e, t) {
      var i = e.points[0][t], n = e.points[e.points.length - 1][t];
      if (i > n) {
        var a = n;
        n = i, i = a;
      }
      for (var o = quadRoots(3 * e.a[t], 2 * e.b[t], e.c[t]), l = 0; l < o.length; l += 1)
        if (o[l] > 0 && o[l] < 1) {
          var c = e.point(o[l])[t];
          c < i ? i = c : c > n && (n = c);
        }
      return { min: i, max: n };
    }
    PolynomialBezier.prototype.bounds = function() {
      return { x: extrema(this, 0), y: extrema(this, 1) };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var e = this.bounds();
      return { left: e.x.min, right: e.x.max, top: e.y.min, bottom: e.y.max, width: e.x.max - e.x.min, height: e.y.max - e.y.min, cx: (e.x.max + e.x.min) / 2, cy: (e.y.max + e.y.min) / 2 };
    };
    function intersectData(e, t, i) {
      var n = e.boundingBox();
      return { cx: n.cx, cy: n.cy, width: n.width, height: n.height, bez: e, t: (t + i) / 2, t1: t, t2: i };
    }
    function splitData(e) {
      var t = e.bez.split(0.5);
      return [intersectData(t[0], e.t1, e.t), intersectData(t[1], e.t, e.t2)];
    }
    function boxIntersect(e, t) {
      return Math.abs(e.cx - t.cx) * 2 < e.width + t.width && Math.abs(e.cy - t.cy) * 2 < e.height + t.height;
    }
    function intersectsImpl(e, t, i, n, a, o) {
      if (boxIntersect(e, t)) {
        if (i >= o || e.width <= n && e.height <= n && t.width <= n && t.height <= n) {
          a.push([e.t, t.t]);
          return;
        }
        var l = splitData(e), c = splitData(t);
        intersectsImpl(l[0], c[0], i + 1, n, a, o), intersectsImpl(l[0], c[1], i + 1, n, a, o), intersectsImpl(l[1], c[0], i + 1, n, a, o), intersectsImpl(l[1], c[1], i + 1, n, a, o);
      }
    }
    PolynomialBezier.prototype.intersections = function(e, t, i) {
      t === void 0 && (t = 2), i === void 0 && (i = 7);
      var n = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(e, 0, 1), 0, t, n, i), n;
    }, PolynomialBezier.shapeSegment = function(e, t) {
      var i = (t + 1) % e.length();
      return new PolynomialBezier(e.v[t], e.o[t], e.i[i], e.v[i], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(e, t) {
      var i = (t + 1) % e.length();
      return new PolynomialBezier(e.v[i], e.i[i], e.o[t], e.v[t], !0);
    };
    function crossProduct(e, t) {
      return [e[1] * t[2] - e[2] * t[1], e[2] * t[0] - e[0] * t[2], e[0] * t[1] - e[1] * t[0]];
    }
    function lineIntersection(e, t, i, n) {
      var a = [e[0], e[1], 1], o = [t[0], t[1], 1], l = [i[0], i[1], 1], c = [n[0], n[1], 1], d = crossProduct(crossProduct(a, o), crossProduct(l, c));
      return floatZero(d[2]) ? null : [d[0] / d[2], d[1] / d[2]];
    }
    function polarOffset(e, t, i) {
      return [e[0] + Math.cos(t) * i, e[1] - Math.sin(t) * i];
    }
    function pointDistance(e, t) {
      return Math.hypot(e[0] - t[0], e[1] - t[1]);
    }
    function pointEqual(e, t) {
      return floatEqual(e[0], t[0]) && floatEqual(e[1], t[1]);
    }
    function ZigZagModifier() {
    }
    extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(e, t.s, 0, null, this), this.frequency = PropertyFactory.getProp(e, t.r, 0, null, this), this.pointsType = PropertyFactory.getProp(e, t.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(e, t, i, n, a, o, l) {
      var c = i - Math.PI / 2, d = i + Math.PI / 2, u = t[0] + Math.cos(i) * n * a, m = t[1] - Math.sin(i) * n * a;
      e.setTripleAt(u, m, u + Math.cos(c) * o, m - Math.sin(c) * o, u + Math.cos(d) * l, m - Math.sin(d) * l, e.length());
    }
    function getPerpendicularVector(e, t) {
      var i = [t[0] - e[0], t[1] - e[1]], n = -Math.PI * 0.5, a = [Math.cos(n) * i[0] - Math.sin(n) * i[1], Math.sin(n) * i[0] + Math.cos(n) * i[1]];
      return a;
    }
    function getProjectingAngle(e, t) {
      var i = t === 0 ? e.length() - 1 : t - 1, n = (t + 1) % e.length(), a = e.v[i], o = e.v[n], l = getPerpendicularVector(a, o);
      return Math.atan2(0, 1) - Math.atan2(l[1], l[0]);
    }
    function zigZagCorner(e, t, i, n, a, o, l) {
      var c = getProjectingAngle(t, i), d = t.v[i % t._length], u = t.v[i === 0 ? t._length - 1 : i - 1], m = t.v[(i + 1) % t._length], A = o === 2 ? Math.sqrt(Math.pow(d[0] - u[0], 2) + Math.pow(d[1] - u[1], 2)) : 0, y = o === 2 ? Math.sqrt(Math.pow(d[0] - m[0], 2) + Math.pow(d[1] - m[1], 2)) : 0;
      setPoint(e, t.v[i % t._length], c, l, n, y / ((a + 1) * 2), A / ((a + 1) * 2));
    }
    function zigZagSegment(e, t, i, n, a, o) {
      for (var l = 0; l < n; l += 1) {
        var c = (l + 1) / (n + 1), d = a === 2 ? Math.sqrt(Math.pow(t.points[3][0] - t.points[0][0], 2) + Math.pow(t.points[3][1] - t.points[0][1], 2)) : 0, u = t.normalAngle(c), m = t.point(c);
        setPoint(e, m, u, o, i, d / ((n + 1) * 2), d / ((n + 1) * 2)), o = -o;
      }
      return o;
    }
    ZigZagModifier.prototype.processPath = function(e, t, i, n) {
      var a = e._length, o = shapePool.newElement();
      if (o.c = e.c, e.c || (a -= 1), a === 0)
        return o;
      var l = -1, c = PolynomialBezier.shapeSegment(e, 0);
      zigZagCorner(o, e, 0, t, i, n, l);
      for (var d = 0; d < a; d += 1)
        l = zigZagSegment(o, c, t, i, n, -l), d === a - 1 && !e.c ? c = null : c = PolynomialBezier.shapeSegment(e, (d + 1) % a), zigZagCorner(o, e, d + 1, t, i, n, l);
      return o;
    }, ZigZagModifier.prototype.processShapes = function(e) {
      var t, i, n = this.shapes.length, a, o, l = this.amplitude.v, c = Math.max(0, Math.round(this.frequency.v)), d = this.pointsType.v;
      if (l !== 0) {
        var u, m;
        for (i = 0; i < n; i += 1) {
          if (u = this.shapes[i], m = u.localShapeCollection, !(!u.shape._mdf && !this._mdf && !e))
            for (m.releaseShapes(), u.shape._mdf = !0, t = u.shape.paths.shapes, o = u.shape.paths._length, a = 0; a < o; a += 1)
              m.addShape(this.processPath(t[a], l, c, d));
          u.shape.paths = u.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function linearOffset(e, t, i) {
      var n = Math.atan2(t[0] - e[0], t[1] - e[1]);
      return [polarOffset(e, n, i), polarOffset(t, n, i)];
    }
    function offsetSegment(e, t) {
      var i, n, a, o, l, c, d;
      d = linearOffset(e.points[0], e.points[1], t), i = d[0], n = d[1], d = linearOffset(e.points[1], e.points[2], t), a = d[0], o = d[1], d = linearOffset(e.points[2], e.points[3], t), l = d[0], c = d[1];
      var u = lineIntersection(i, n, a, o);
      u === null && (u = n);
      var m = lineIntersection(l, c, a, o);
      return m === null && (m = l), new PolynomialBezier(i, u, m, c);
    }
    function joinLines(e, t, i, n, a) {
      var o = t.points[3], l = i.points[0];
      if (n === 3 || pointEqual(o, l))
        return o;
      if (n === 2) {
        var c = -t.tangentAngle(1), d = -i.tangentAngle(0) + Math.PI, u = lineIntersection(o, polarOffset(o, c + Math.PI / 2, 100), l, polarOffset(l, c + Math.PI / 2, 100)), m = u ? pointDistance(u, o) : pointDistance(o, l) / 2, A = polarOffset(o, c, 2 * m * roundCorner);
        return e.setXYAt(A[0], A[1], "o", e.length() - 1), A = polarOffset(l, d, 2 * m * roundCorner), e.setTripleAt(l[0], l[1], l[0], l[1], A[0], A[1], e.length()), l;
      }
      var y = pointEqual(o, t.points[2]) ? t.points[0] : t.points[2], D = pointEqual(l, i.points[1]) ? i.points[3] : i.points[1], C = lineIntersection(y, o, l, D);
      return C && pointDistance(C, o) < a ? (e.setTripleAt(C[0], C[1], C[0], C[1], C[0], C[1], e.length()), C) : o;
    }
    function getIntersection(e, t) {
      var i = e.intersections(t);
      return i.length && floatEqual(i[0][0], 1) && i.shift(), i.length ? i[0] : null;
    }
    function pruneSegmentIntersection(e, t) {
      var i = e.slice(), n = t.slice(), a = getIntersection(e[e.length - 1], t[0]);
      return a && (i[e.length - 1] = e[e.length - 1].split(a[0])[0], n[0] = t[0].split(a[1])[1]), e.length > 1 && t.length > 1 && (a = getIntersection(e[0], t[t.length - 1]), a) ? [[e[0].split(a[0])[0]], [t[t.length - 1].split(a[1])[1]]] : [i, n];
    }
    function pruneIntersections(e) {
      for (var t, i = 1; i < e.length; i += 1)
        t = pruneSegmentIntersection(e[i - 1], e[i]), e[i - 1] = t[0], e[i] = t[1];
      return e.length > 1 && (t = pruneSegmentIntersection(e[e.length - 1], e[0]), e[e.length - 1] = t[0], e[0] = t[1]), e;
    }
    function offsetSegmentSplit(e, t) {
      var i = e.inflectionPoints(), n, a, o, l;
      if (i.length === 0)
        return [offsetSegment(e, t)];
      if (i.length === 1 || floatEqual(i[1], 1))
        return o = e.split(i[0]), n = o[0], a = o[1], [offsetSegment(n, t), offsetSegment(a, t)];
      o = e.split(i[0]), n = o[0];
      var c = (i[1] - i[0]) / (1 - i[0]);
      return o = o[1].split(c), l = o[0], a = o[1], [offsetSegment(n, t), offsetSegment(l, t), offsetSegment(a, t)];
    }
    function OffsetPathModifier() {
    }
    extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(e, t.ml, 0, null, this), this.lineJoin = t.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(e, t, i, n) {
      var a = shapePool.newElement();
      a.c = e.c;
      var o = e.length();
      e.c || (o -= 1);
      var l, c, d, u = [];
      for (l = 0; l < o; l += 1)
        d = PolynomialBezier.shapeSegment(e, l), u.push(offsetSegmentSplit(d, t));
      if (!e.c)
        for (l = o - 1; l >= 0; l -= 1)
          d = PolynomialBezier.shapeSegmentInverted(e, l), u.push(offsetSegmentSplit(d, t));
      u = pruneIntersections(u);
      var m = null, A = null;
      for (l = 0; l < u.length; l += 1) {
        var y = u[l];
        for (A && (m = joinLines(a, A, y[0], i, n)), A = y[y.length - 1], c = 0; c < y.length; c += 1)
          d = y[c], m && pointEqual(d.points[0], m) ? a.setXYAt(d.points[1][0], d.points[1][1], "o", a.length() - 1) : a.setTripleAt(d.points[0][0], d.points[0][1], d.points[1][0], d.points[1][1], d.points[0][0], d.points[0][1], a.length()), a.setTripleAt(d.points[3][0], d.points[3][1], d.points[3][0], d.points[3][1], d.points[2][0], d.points[2][1], a.length()), m = d.points[3];
      }
      return u.length && joinLines(a, A, u[0][0], i, n), a;
    }, OffsetPathModifier.prototype.processShapes = function(e) {
      var t, i, n = this.shapes.length, a, o, l = this.amount.v, c = this.miterLimit.v, d = this.lineJoin;
      if (l !== 0) {
        var u, m;
        for (i = 0; i < n; i += 1) {
          if (u = this.shapes[i], m = u.localShapeCollection, !(!u.shape._mdf && !this._mdf && !e))
            for (m.releaseShapes(), u.shape._mdf = !0, t = u.shape.paths.shapes, o = u.shape.paths._length, a = 0; a < o; a += 1)
              m.addShape(this.processPath(t[a], l, d, c));
          u.shape.paths = u.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function getFontProperties(e) {
      for (var t = e.fStyle ? e.fStyle.split(" ") : [], i = "normal", n = "normal", a = t.length, o, l = 0; l < a; l += 1)
        switch (o = t[l].toLowerCase(), o) {
          case "italic":
            n = "italic";
            break;
          case "bold":
            i = "700";
            break;
          case "black":
            i = "900";
            break;
          case "medium":
            i = "500";
            break;
          case "regular":
          case "normal":
            i = "400";
            break;
          case "light":
          case "thin":
            i = "200";
            break;
        }
      return { style: n, weight: e.fWeight || i };
    }
    var FontManager = function() {
      var e = 5e3, t = { w: 0, size: 0, shapes: [], data: { shapes: [] } }, i = [];
      i = i.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var n = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"], a = [65039, 8205];
      function o(P) {
        var L = P.split(","), F, B = L.length, G = [];
        for (F = 0; F < B; F += 1)
          L[F] !== "sans-serif" && L[F] !== "monospace" && G.push(L[F]);
        return G.join(",");
      }
      function l(P, L) {
        var F = createTag("span");
        F.setAttribute("aria-hidden", !0), F.style.fontFamily = L;
        var B = createTag("span");
        B.innerText = "giItT1WQy@!-/#", F.style.position = "absolute", F.style.left = "-10000px", F.style.top = "-10000px", F.style.fontSize = "300px", F.style.fontVariant = "normal", F.style.fontStyle = "normal", F.style.fontWeight = "normal", F.style.letterSpacing = "0", F.appendChild(B), document.body.appendChild(F);
        var G = B.offsetWidth;
        return B.style.fontFamily = o(P) + ", " + L, { node: B, w: G, parent: F };
      }
      function c() {
        var P, L = this.fonts.length, F, B, G = L;
        for (P = 0; P < L; P += 1)
          this.fonts[P].loaded ? G -= 1 : this.fonts[P].fOrigin === "n" || this.fonts[P].origin === 0 ? this.fonts[P].loaded = !0 : (F = this.fonts[P].monoCase.node, B = this.fonts[P].monoCase.w, F.offsetWidth !== B ? (G -= 1, this.fonts[P].loaded = !0) : (F = this.fonts[P].sansCase.node, B = this.fonts[P].sansCase.w, F.offsetWidth !== B && (G -= 1, this.fonts[P].loaded = !0)), this.fonts[P].loaded && (this.fonts[P].sansCase.parent.parentNode.removeChild(this.fonts[P].sansCase.parent), this.fonts[P].monoCase.parent.parentNode.removeChild(this.fonts[P].monoCase.parent)));
        G !== 0 && Date.now() - this.initTime < e ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function d(P, L) {
        var F = document.body && L ? "svg" : "canvas", B, G = getFontProperties(P);
        if (F === "svg") {
          var Z = createNS("text");
          Z.style.fontSize = "100px", Z.setAttribute("font-family", P.fFamily), Z.setAttribute("font-style", G.style), Z.setAttribute("font-weight", G.weight), Z.textContent = "1", P.fClass ? (Z.style.fontFamily = "inherit", Z.setAttribute("class", P.fClass)) : Z.style.fontFamily = P.fFamily, L.appendChild(Z), B = Z;
        } else {
          var X = new OffscreenCanvas(500, 500).getContext("2d");
          X.font = G.style + " " + G.weight + " 100px " + P.fFamily, B = X;
        }
        function V(E) {
          return F === "svg" ? (B.textContent = E, B.getComputedTextLength()) : B.measureText(E).width;
        }
        return { measureText: V };
      }
      function u(P, L) {
        if (!P) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = P.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, P.list.forEach(function(x) {
            x.helper = d(x), x.cache = {};
          }), this.fonts = P.list;
          return;
        }
        var F = P.list, B, G = F.length, Z = G;
        for (B = 0; B < G; B += 1) {
          var X = !0, V, E;
          if (F[B].loaded = !1, F[B].monoCase = l(F[B].fFamily, "monospace"), F[B].sansCase = l(F[B].fFamily, "sans-serif"), !F[B].fPath)
            F[B].loaded = !0, Z -= 1;
          else if (F[B].fOrigin === "p" || F[B].origin === 3) {
            if (V = document.querySelectorAll('style[f-forigin="p"][f-family="' + F[B].fFamily + '"], style[f-origin="3"][f-family="' + F[B].fFamily + '"]'), V.length > 0 && (X = !1), X) {
              var T = createTag("style");
              T.setAttribute("f-forigin", F[B].fOrigin), T.setAttribute("f-origin", F[B].origin), T.setAttribute("f-family", F[B].fFamily), T.type = "text/css", T.innerText = "@font-face {font-family: " + F[B].fFamily + "; font-style: normal; src: url('" + F[B].fPath + "');}", L.appendChild(T);
            }
          } else if (F[B].fOrigin === "g" || F[B].origin === 1) {
            for (V = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), E = 0; E < V.length; E += 1)
              V[E].href.indexOf(F[B].fPath) !== -1 && (X = !1);
            if (X) {
              var g = createTag("link");
              g.setAttribute("f-forigin", F[B].fOrigin), g.setAttribute("f-origin", F[B].origin), g.type = "text/css", g.rel = "stylesheet", g.href = F[B].fPath, document.body.appendChild(g);
            }
          } else if (F[B].fOrigin === "t" || F[B].origin === 2) {
            for (V = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), E = 0; E < V.length; E += 1)
              F[B].fPath === V[E].src && (X = !1);
            if (X) {
              var b = createTag("link");
              b.setAttribute("f-forigin", F[B].fOrigin), b.setAttribute("f-origin", F[B].origin), b.setAttribute("rel", "stylesheet"), b.setAttribute("href", F[B].fPath), L.appendChild(b);
            }
          }
          F[B].helper = d(F[B], L), F[B].cache = {}, this.fonts.push(F[B]);
        }
        Z === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function m(P) {
        if (P) {
          this.chars || (this.chars = []);
          var L, F = P.length, B, G = this.chars.length, Z;
          for (L = 0; L < F; L += 1) {
            for (B = 0, Z = !1; B < G; )
              this.chars[B].style === P[L].style && this.chars[B].fFamily === P[L].fFamily && this.chars[B].ch === P[L].ch && (Z = !0), B += 1;
            Z || (this.chars.push(P[L]), G += 1);
          }
        }
      }
      function A(P, L, F) {
        for (var B = 0, G = this.chars.length; B < G; ) {
          if (this.chars[B].ch === P && this.chars[B].style === L && this.chars[B].fFamily === F)
            return this.chars[B];
          B += 1;
        }
        return (typeof P == "string" && P.charCodeAt(0) !== 13 || !P) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", P, L, F)), t;
      }
      function y(P, L, F) {
        var B = this.getFontByName(L), G = P.charCodeAt(0);
        if (!B.cache[G + 1]) {
          var Z = B.helper;
          if (P === " ") {
            var X = Z.measureText("|" + P + "|"), V = Z.measureText("||");
            B.cache[G + 1] = (X - V) / 100;
          } else
            B.cache[G + 1] = Z.measureText(P) / 100;
        }
        return B.cache[G + 1] * F;
      }
      function D(P) {
        for (var L = 0, F = this.fonts.length; L < F; ) {
          if (this.fonts[L].fName === P)
            return this.fonts[L];
          L += 1;
        }
        return this.fonts[0];
      }
      function C(P, L) {
        var F = P.toString(16) + L.toString(16);
        return n.indexOf(F) !== -1;
      }
      function z(P, L) {
        return L ? P === a[0] && L === a[1] : P === a[1];
      }
      function R(P) {
        return i.indexOf(P) !== -1;
      }
      function O() {
        this.isLoaded = !0;
      }
      var $ = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      $.isModifier = C, $.isZeroWidthJoiner = z, $.isCombinedCharacter = R;
      var k = { addChars: m, addFonts: u, getCharData: A, getFontByName: D, measureText: y, checkLoadedFonts: c, setIsLoaded: O };
      return $.prototype = k, $;
    }();
    function SlotManager(e) {
      this.animationData = e;
    }
    SlotManager.prototype.getProp = function(e) {
      return this.animationData.slots && this.animationData.slots[e.sid] ? Object.assign(e, this.animationData.slots[e.sid].p) : e;
    };
    function slotFactory(e) {
      return new SlotManager(e);
    }
    function RenderableElement() {
    }
    RenderableElement.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) === -1 && this.renderableComponents.push(t);
      },
      removeRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
      },
      prepareRenderableFrame: function(t) {
        this.checkLayerLimits(t);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
      * @function
      * Initializes frame related properties.
      *
      * @param {number} num
      * current frame number in Layer's time
      *
      */
      checkLayerLimits: function(t) {
        this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var t, i = this.renderableComponents.length;
        for (t = 0; t < i; t += 1)
          this.renderableComponents[t].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return { top: 0, left: 0, width: 100, height: 100 };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? { w: this.data.textData.width, h: this.data.textData.height } : { w: this.data.width, h: this.data.height };
      }
    };
    var getBlendMode = function() {
      var e = { 0: "source-over", 1: "multiply", 2: "screen", 3: "overlay", 4: "darken", 5: "lighten", 6: "color-dodge", 7: "color-burn", 8: "hard-light", 9: "soft-light", 10: "difference", 11: "exclusion", 12: "hue", 13: "saturation", 14: "color", 15: "luminosity" };
      return function(t) {
        return e[t] || "";
      };
    }();
    function SliderEffect(e, t, i) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, i);
    }
    function AngleEffect(e, t, i) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, i);
    }
    function ColorEffect(e, t, i) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, i);
    }
    function PointEffect(e, t, i) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, i);
    }
    function LayerIndexEffect(e, t, i) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, i);
    }
    function MaskIndexEffect(e, t, i) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, i);
    }
    function CheckboxEffect(e, t, i) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, i);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(e, t) {
      var i = e.ef || [];
      this.effectElements = [];
      var n, a = i.length, o;
      for (n = 0; n < a; n += 1)
        o = new GroupEffect(i[n], t), this.effectElements.push(o);
    }
    function GroupEffect(e, t) {
      this.init(e, t);
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(e, t) {
      this.data = e, this.effectElements = [], this.initDynamicPropertyContainer(t);
      var i, n = this.data.ef.length, a, o = this.data.ef;
      for (i = 0; i < n; i += 1) {
        switch (a = null, o[i].ty) {
          case 0:
            a = new SliderEffect(o[i], t, this);
            break;
          case 1:
            a = new AngleEffect(o[i], t, this);
            break;
          case 2:
            a = new ColorEffect(o[i], t, this);
            break;
          case 3:
            a = new PointEffect(o[i], t, this);
            break;
          case 4:
          case 7:
            a = new CheckboxEffect(o[i], t, this);
            break;
          case 10:
            a = new LayerIndexEffect(o[i], t, this);
            break;
          case 11:
            a = new MaskIndexEffect(o[i], t, this);
            break;
          case 5:
            a = new EffectsManager(o[i], t);
            break;
          default:
            a = new NoValueEffect(o[i]);
            break;
        }
        a && this.effectElements.push(a);
      }
    };
    function BaseElement() {
    }
    BaseElement.prototype = { checkMasks: function() {
      if (!this.data.hasMask)
        return !1;
      for (var t = 0, i = this.data.masksProperties.length; t < i; ) {
        if (this.data.masksProperties[t].mode !== "n" && this.data.masksProperties[t].cl !== !1)
          return !0;
        t += 1;
      }
      return !1;
    }, initExpressions: function() {
      var t = getExpressionInterfaces();
      if (t) {
        var i = t("layer"), n = t("effects"), a = t("shape"), o = t("text"), l = t("comp");
        this.layerInterface = i(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
        var c = n.createEffectsInterface(this, this.layerInterface);
        this.layerInterface.registerEffectsInterface(c), this.data.ty === 0 || this.data.xt ? this.compInterface = l(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = a(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = o(this), this.layerInterface.text = this.layerInterface.textInterface);
      }
    }, setBlendMode: function() {
      var t = getBlendMode(this.data.bm), i = this.baseElement || this.layerElement;
      i.style["mix-blend-mode"] = t;
    }, initBaseData: function(t, i, n) {
      this.globalData = i, this.comp = n, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
    }, getType: function() {
      return this.type;
    }, sourceRectAtTime: function() {
    } };
    function FrameElement() {
    }
    FrameElement.prototype = {
      /**
      * @function
      * Initializes frame related properties.
      *
      */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
      * @function
      * Calculates all dynamic values
      *
      * @param {number} num
      * current frame number in Layer's time
      * @param {boolean} isVisible
      * if layers is currently in range
      *
      */
      prepareProperties: function(t, i) {
        var n, a = this.dynamicProperties.length;
        for (n = 0; n < a; n += 1)
          (i || this._isParent && this.dynamicProperties[n].propType === "transform") && (this.dynamicProperties[n].getValue(), this.dynamicProperties[n]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && this.dynamicProperties.push(t);
      }
    };
    function FootageElement(e, t, i) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.footageData = t.imageLoader.getAsset(this.assetData), this.initBaseData(e, t, i);
    }
    FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var e = getExpressionInterfaces();
      if (e) {
        var t = e("footage");
        this.layerInterface = t(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    };
    function AudioElement(e, t, i) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.initBaseData(e, t, i), this._isPlaying = !1, this._canPlay = !1;
      var n = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(n), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : { _placeholder: !0 }, this.lv = PropertyFactory.getProp(this, e.au && e.au.lv ? e.au.lv : { k: [100] }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(e) {
      if (this.prepareRenderableFrame(e, !0), this.prepareProperties(e, !0), this.tm._placeholder)
        this._currentTime = e / this.data.sr;
      else {
        var t = this.tm.v;
        this._currentTime = t;
      }
      this._volume = this.lv.v[0];
      var i = this._volume * this._volumeMultiplier;
      this._previousVolume !== i && (this._previousVolume = i, this.audio.volume(i));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(e) {
      this.audio.rate(e);
    }, AudioElement.prototype.volume = function(e) {
      this._volumeMultiplier = e, this._previousVolume = e * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    };
    function BaseRenderer() {
    }
    BaseRenderer.prototype.checkLayers = function(e) {
      var t, i = this.layers.length, n;
      for (this.completeLayers = !0, t = i - 1; t >= 0; t -= 1)
        this.elements[t] || (n = this.layers[t], n.ip - n.st <= e - this.layers[t].st && n.op - n.st > e - this.layers[t].st && this.buildItem(t)), this.completeLayers = this.elements[t] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(e) {
      switch (e.ty) {
        case 2:
          return this.createImage(e);
        case 0:
          return this.createComp(e);
        case 1:
          return this.createSolid(e);
        case 3:
          return this.createNull(e);
        case 4:
          return this.createShape(e);
        case 5:
          return this.createText(e);
        case 6:
          return this.createAudio(e);
        case 13:
          return this.createCamera(e);
        case 15:
          return this.createFootage(e);
        default:
          return this.createNull(e);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(e) {
      return new AudioElement(e, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(e) {
      return new FootageElement(e, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.buildItem(e);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(e) {
      this.completeLayers = !1;
      var t, i = e.length, n, a = this.layers.length;
      for (t = 0; t < i; t += 1)
        for (n = 0; n < a; ) {
          if (this.layers[n].id === e[t].id) {
            this.layers[n] = e[t];
            break;
          }
          n += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(e) {
      this.globalData.projectInterface = e;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(e, t, i) {
      for (var n = this.elements, a = this.layers, o = 0, l = a.length; o < l; )
        a[o].ind == t && (!n[o] || n[o] === !0 ? (this.buildItem(o), this.addPendingElement(e)) : (i.push(n[o]), n[o].setAsParent(), a[o].parent !== void 0 ? this.buildElementParenting(e, a[o].parent, i) : e.setHierarchy(i))), o += 1;
    }, BaseRenderer.prototype.addPendingElement = function(e) {
      this.pendingElements.push(e);
    }, BaseRenderer.prototype.searchExtraCompositions = function(e) {
      var t, i = e.length;
      for (t = 0; t < i; t += 1)
        if (e[t].xt) {
          var n = this.createComp(e[t]);
          n.initExpressions(), this.globalData.projectInterface.registerComposition(n);
        }
    }, BaseRenderer.prototype.getElementById = function(e) {
      var t, i = this.elements.length;
      for (t = 0; t < i; t += 1)
        if (this.elements[t].data.ind === e)
          return this.elements[t];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(e) {
      var t = e.shift(), i;
      if (typeof t == "number")
        i = this.elements[t];
      else {
        var n, a = this.elements.length;
        for (n = 0; n < a; n += 1)
          if (this.elements[n].data.nm === t) {
            i = this.elements[n];
            break;
          }
      }
      return e.length === 0 ? i : i.getElementByPath(e);
    }, BaseRenderer.prototype.setupGlobalData = function(e, t) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(e), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, t), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = e.fr, this.globalData.nm = e.nm, this.globalData.compSize = { w: e.w, h: e.h };
    };
    function TransformElement() {
    }
    TransformElement.prototype = { initTransform: function() {
      this.finalTransform = { mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : { o: 0 }, _matMdf: !1, _opMdf: !1, mat: new Matrix() }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
    }, renderTransform: function() {
      if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
        var t, i = this.finalTransform.mat, n = 0, a = this.hierarchy.length;
        if (!this.finalTransform._matMdf)
          for (; n < a; ) {
            if (this.hierarchy[n].finalTransform.mProp._mdf) {
              this.finalTransform._matMdf = !0;
              break;
            }
            n += 1;
          }
        if (this.finalTransform._matMdf)
          for (t = this.finalTransform.mProp.v.props, i.cloneFromProps(t), n = 0; n < a; n += 1)
            t = this.hierarchy[n].finalTransform.mProp.v.props, i.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
      }
    }, globalToLocal: function(t) {
      var i = [];
      i.push(this.finalTransform);
      for (var n = !0, a = this.comp; n; )
        a.finalTransform ? (a.data.hasMask && i.splice(0, 0, a.finalTransform), a = a.comp) : n = !1;
      var o, l = i.length, c;
      for (o = 0; o < l; o += 1)
        c = i[o].mat.applyToPointArray(0, 0, 0), t = [t[0] - c[0], t[1] - c[1], 0];
      return t;
    }, mHelper: new Matrix() };
    function MaskElement(e, t, i) {
      this.data = e, this.element = t, this.globalData = i, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var n = this.globalData.defs, a, o = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(o), this.solidPath = "";
      var l, c = this.masksProperties, d = 0, u = [], m, A, y = createElementID(), D, C, z, R, O = "clipPath", $ = "clip-path";
      for (a = 0; a < o; a += 1)
        if ((c[a].mode !== "a" && c[a].mode !== "n" || c[a].inv || c[a].o.k !== 100 || c[a].o.x) && (O = "mask", $ = "mask"), (c[a].mode === "s" || c[a].mode === "i") && d === 0 ? (D = createNS("rect"), D.setAttribute("fill", "#ffffff"), D.setAttribute("width", this.element.comp.data.w || 0), D.setAttribute("height", this.element.comp.data.h || 0), u.push(D)) : D = null, l = createNS("path"), c[a].mode === "n")
          this.viewData[a] = { op: PropertyFactory.getProp(this.element, c[a].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, c[a], 3), elem: l, lastPath: "" }, n.appendChild(l);
        else {
          d += 1, l.setAttribute("fill", c[a].mode === "s" ? "#000000" : "#ffffff"), l.setAttribute("clip-rule", "nonzero");
          var k;
          if (c[a].x.k !== 0 ? (O = "mask", $ = "mask", R = PropertyFactory.getProp(this.element, c[a].x, 0, null, this.element), k = createElementID(), C = createNS("filter"), C.setAttribute("id", k), z = createNS("feMorphology"), z.setAttribute("operator", "erode"), z.setAttribute("in", "SourceGraphic"), z.setAttribute("radius", "0"), C.appendChild(z), n.appendChild(C), l.setAttribute("stroke", c[a].mode === "s" ? "#000000" : "#ffffff")) : (z = null, R = null), this.storedData[a] = { elem: l, x: R, expan: z, lastPath: "", lastOperator: "", filterId: k, lastRadius: 0 }, c[a].mode === "i") {
            A = u.length;
            var P = createNS("g");
            for (m = 0; m < A; m += 1)
              P.appendChild(u[m]);
            var L = createNS("mask");
            L.setAttribute("mask-type", "alpha"), L.setAttribute("id", y + "_" + d), L.appendChild(l), n.appendChild(L), P.setAttribute("mask", "url(" + getLocationHref() + "#" + y + "_" + d + ")"), u.length = 0, u.push(P);
          } else
            u.push(l);
          c[a].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[a] = { elem: l, lastPath: "", op: PropertyFactory.getProp(this.element, c[a].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, c[a], 3), invRect: D }, this.viewData[a].prop.k || this.drawPath(c[a], this.viewData[a].prop.v, this.viewData[a]);
        }
      for (this.maskElement = createNS(O), o = u.length, a = 0; a < o; a += 1)
        this.maskElement.appendChild(u[a]);
      d > 0 && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute($, "url(" + getLocationHref() + "#" + y + ")"), n.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(e) {
      return this.viewData[e].prop;
    }, MaskElement.prototype.renderFrame = function(e) {
      var t = this.element.finalTransform.mat, i, n = this.masksProperties.length;
      for (i = 0; i < n; i += 1)
        if ((this.viewData[i].prop._mdf || e) && this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]), (this.viewData[i].op._mdf || e) && this.viewData[i].elem.setAttribute("fill-opacity", this.viewData[i].op.v), this.masksProperties[i].mode !== "n" && (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || e) && this.viewData[i].invRect.setAttribute("transform", t.getInverseMatrix().to2dCSS()), this.storedData[i].x && (this.storedData[i].x._mdf || e))) {
          var a = this.storedData[i].expan;
          this.storedData[i].x.v < 0 ? (this.storedData[i].lastOperator !== "erode" && (this.storedData[i].lastOperator = "erode", this.storedData[i].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[i].filterId + ")")), a.setAttribute("radius", -this.storedData[i].x.v)) : (this.storedData[i].lastOperator !== "dilate" && (this.storedData[i].lastOperator = "dilate", this.storedData[i].elem.setAttribute("filter", null)), this.storedData[i].elem.setAttribute("stroke-width", this.storedData[i].x.v * 2));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var e = "M0,0 ";
      return e += " h" + this.globalData.compSize.w, e += " v" + this.globalData.compSize.h, e += " h-" + this.globalData.compSize.w, e += " v-" + this.globalData.compSize.h + " ", e;
    }, MaskElement.prototype.drawPath = function(e, t, i) {
      var n = " M" + t.v[0][0] + "," + t.v[0][1], a, o;
      for (o = t._length, a = 1; a < o; a += 1)
        n += " C" + t.o[a - 1][0] + "," + t.o[a - 1][1] + " " + t.i[a][0] + "," + t.i[a][1] + " " + t.v[a][0] + "," + t.v[a][1];
      if (t.c && o > 1 && (n += " C" + t.o[a - 1][0] + "," + t.o[a - 1][1] + " " + t.i[0][0] + "," + t.i[0][1] + " " + t.v[0][0] + "," + t.v[0][1]), i.lastPath !== n) {
        var l = "";
        i.elem && (t.c && (l = e.inv ? this.solidPath + n : n), i.elem.setAttribute("d", l)), i.lastPath = n;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var e = {};
      e.createFilter = t, e.createAlphaToLuminanceFilter = i;
      function t(n, a) {
        var o = createNS("filter");
        return o.setAttribute("id", n), a !== !0 && (o.setAttribute("filterUnits", "objectBoundingBox"), o.setAttribute("x", "0%"), o.setAttribute("y", "0%"), o.setAttribute("width", "100%"), o.setAttribute("height", "100%")), o;
      }
      function i() {
        var n = createNS("feColorMatrix");
        return n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), n;
      }
      return e;
    }(), featureSupport = function() {
      var e = { maskType: !0, svgLumaHidden: !0, offscreenCanvas: typeof OffscreenCanvas < "u" };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (e.maskType = !1), /firefox/i.test(navigator.userAgent) && (e.svgLumaHidden = !1), e;
    }(), registeredEffects = {}, idPrefix = "filter_result_";
    function SVGEffects(e) {
      var t, i = "SourceGraphic", n = e.data.ef ? e.data.ef.length : 0, a = createElementID(), o = filtersFactory.createFilter(a, !0), l = 0;
      this.filters = [];
      var c;
      for (t = 0; t < n; t += 1) {
        c = null;
        var d = e.data.ef[t].ty;
        if (registeredEffects[d]) {
          var u = registeredEffects[d].effect;
          c = new u(o, e.effectsManager.effectElements[t], e, idPrefix + l, i), i = idPrefix + l, registeredEffects[d].countsAsEffect && (l += 1);
        }
        c && this.filters.push(c);
      }
      l && (e.globalData.defs.appendChild(o), e.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + a + ")")), this.filters.length && e.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(e) {
      var t, i = this.filters.length;
      for (t = 0; t < i; t += 1)
        this.filters[t].renderFrame(e);
    };
    function registerEffect(e, t, i) {
      registeredEffects[e] = { effect: t, countsAsEffect: i };
    }
    function SVGBaseElement() {
    }
    SVGBaseElement.prototype = { initRendererElement: function() {
      this.layerElement = createNS("g");
    }, createContainerElements: function() {
      this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
      var t = null;
      if (this.data.td) {
        this.matteMasks = {};
        var i = createNS("g");
        i.setAttribute("id", this.layerId), i.appendChild(this.layerElement), t = i, this.globalData.defs.appendChild(i);
      } else
        this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
      if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
        var n = createNS("clipPath"), a = createNS("path");
        a.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
        var o = createElementID();
        if (n.setAttribute("id", o), n.appendChild(a), this.globalData.defs.appendChild(n), this.checkMasks()) {
          var l = createNS("g");
          l.setAttribute("clip-path", "url(" + getLocationHref() + "#" + o + ")"), l.appendChild(this.layerElement), this.transformedElement = l, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
        } else
          this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + o + ")");
      }
      this.data.bm !== 0 && this.setBlendMode();
    }, renderElement: function() {
      this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
    }, destroyBaseElement: function() {
      this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
    }, getBaseElement: function() {
      return this.data.hd ? null : this.baseElement;
    }, createRenderableComponents: function() {
      this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this);
    }, getMatte: function(t) {
      if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
        var i = this.layerId + "_" + t, n, a, o, l;
        if (t === 1 || t === 3) {
          var c = createNS("mask");
          c.setAttribute("id", i), c.setAttribute("mask-type", t === 3 ? "luminance" : "alpha"), o = createNS("use"), o.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), c.appendChild(o), this.globalData.defs.appendChild(c), !featureSupport.maskType && t === 1 && (c.setAttribute("mask-type", "luminance"), n = createElementID(), a = filtersFactory.createFilter(n), this.globalData.defs.appendChild(a), a.appendChild(filtersFactory.createAlphaToLuminanceFilter()), l = createNS("g"), l.appendChild(o), c.appendChild(l), l.setAttribute("filter", "url(" + getLocationHref() + "#" + n + ")"));
        } else if (t === 2) {
          var d = createNS("mask");
          d.setAttribute("id", i), d.setAttribute("mask-type", "alpha");
          var u = createNS("g");
          d.appendChild(u), n = createElementID(), a = filtersFactory.createFilter(n);
          var m = createNS("feComponentTransfer");
          m.setAttribute("in", "SourceGraphic"), a.appendChild(m);
          var A = createNS("feFuncA");
          A.setAttribute("type", "table"), A.setAttribute("tableValues", "1.0 0.0"), m.appendChild(A), this.globalData.defs.appendChild(a);
          var y = createNS("rect");
          y.setAttribute("width", this.comp.data.w), y.setAttribute("height", this.comp.data.h), y.setAttribute("x", "0"), y.setAttribute("y", "0"), y.setAttribute("fill", "#ffffff"), y.setAttribute("opacity", "0"), u.setAttribute("filter", "url(" + getLocationHref() + "#" + n + ")"), u.appendChild(y), o = createNS("use"), o.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), u.appendChild(o), featureSupport.maskType || (d.setAttribute("mask-type", "luminance"), a.appendChild(filtersFactory.createAlphaToLuminanceFilter()), l = createNS("g"), u.appendChild(y), l.appendChild(this.layerElement), u.appendChild(l)), this.globalData.defs.appendChild(d);
        }
        this.matteMasks[t] = i;
      }
      return this.matteMasks[t];
    }, setMatte: function(t) {
      this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
    } };
    function HierarchyElement() {
    }
    HierarchyElement.prototype = {
      /**
      * @function
      * Initializes hierarchy properties
      *
      */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
      * @function
      * Sets layer's hierarchy.
      * @param {array} hierarch
      * layer's parent list
      *
      */
      setHierarchy: function(t) {
        this.hierarchy = t;
      },
      /**
      * @function
      * Sets layer as parent.
      *
      */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
      * @function
      * Searches layer's parenting chain
      *
      */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function RenderableDOMElement() {
    }
    (function() {
      var e = { initElement: function(i, n, a) {
        this.initFrame(), this.initBaseData(i, n, a), this.initTransform(i, n, a), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
      }, hide: function() {
        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
          var i = this.baseElement || this.layerElement;
          i.style.display = "none", this.hidden = !0;
        }
      }, show: function() {
        if (this.isInRange && !this.isTransparent) {
          if (!this.data.hd) {
            var i = this.baseElement || this.layerElement;
            i.style.display = "block";
          }
          this.hidden = !1, this._isFirstFrame = !0;
        }
      }, renderFrame: function() {
        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
      }, renderInnerContent: function() {
      }, prepareFrame: function(i) {
        this._mdf = !1, this.prepareRenderableFrame(i), this.prepareProperties(i, this.isInRange), this.checkTransparency();
      }, destroy: function() {
        this.innerElem = null, this.destroyBaseElement();
      } };
      extendPrototype([RenderableElement, createProxyFunction(e)], RenderableDOMElement);
    })();
    function IImageElement(e, t, i) {
      this.assetData = t.getAssetData(e.refId), this.assetData && this.assetData.sid && (this.assetData = t.slotManager.getProp(this.assetData)), this.initElement(e, t, i), this.sourceRect = { top: 0, left: 0, width: this.assetData.w, height: this.assetData.h };
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function ProcessedElement(e, t) {
      this.elem = e, this.pos = t;
    }
    function IShapeElement() {
    }
    IShapeElement.prototype = { addShapeToModifiers: function(t) {
      var i, n = this.shapeModifiers.length;
      for (i = 0; i < n; i += 1)
        this.shapeModifiers[i].addShape(t);
    }, isShapeInAnimatedModifiers: function(t) {
      for (var i = 0, n = this.shapeModifiers.length; i < n; )
        if (this.shapeModifiers[i].isAnimatedWithShape(t))
          return !0;
      return !1;
    }, renderModifiers: function() {
      if (this.shapeModifiers.length) {
        var t, i = this.shapes.length;
        for (t = 0; t < i; t += 1)
          this.shapes[t].sh.reset();
        i = this.shapeModifiers.length;
        var n;
        for (t = i - 1; t >= 0 && (n = this.shapeModifiers[t].processShapes(this._isFirstFrame), !n); t -= 1)
          ;
      }
    }, searchProcessedElement: function(t) {
      for (var i = this.processedElements, n = 0, a = i.length; n < a; ) {
        if (i[n].elem === t)
          return i[n].pos;
        n += 1;
      }
      return 0;
    }, addProcessedElement: function(t, i) {
      for (var n = this.processedElements, a = n.length; a; )
        if (a -= 1, n[a].elem === t) {
          n[a].pos = i;
          return;
        }
      n.push(new ProcessedElement(t, i));
    }, prepareFrame: function(t) {
      this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
    } };
    var lineCapEnum = { 1: "butt", 2: "round", 3: "square" }, lineJoinEnum = { 1: "miter", 2: "round", 3: "bevel" };
    function SVGShapeData(e, t, i) {
      this.caches = [], this.styles = [], this.transformers = e, this.lStr = "", this.sh = i, this.lvl = t, this._isAnimated = !!i.k;
      for (var n = 0, a = e.length; n < a; ) {
        if (e[n].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        n += 1;
      }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function SVGStyleData(e, t) {
      this.data = e, this.type = e.ty, this.d = "", this.lvl = t, this._mdf = !1, this.closed = e.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function DashProperty(e, t, i, n) {
      this.elem = e, this.frameId = -1, this.dataProps = createSizedArray(t.length), this.renderer = i, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", t.length ? t.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(n);
      var a, o = t.length || 0, l;
      for (a = 0; a < o; a += 1)
        l = PropertyFactory.getProp(e, t[a].v, 0, 0, this), this.k = l.k || this.k, this.dataProps[a] = { n: t[a].n, p: l };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(e) {
      if (!(this.elem.globalData.frameId === this.frameId && !e) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || e, this._mdf)) {
        var t = 0, i = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), t = 0; t < i; t += 1)
          this.dataProps[t].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[t].p.v : this.dashArray[t] = this.dataProps[t].p.v : this.dashoffset[0] = this.dataProps[t].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty);
    function SVGStrokeStyleData(e, t, i) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = i, this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
    function SVGFillStyleData(e, t, i) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = i;
    }
    extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
    function SVGNoStyleData(e, t, i) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.style = i;
    }
    extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
    function GradientProperty(e, t, i) {
      this.data = t, this.c = createTypedArray("uint8c", t.p * 4);
      var n = t.k.k[0].s ? t.k.k[0].s.length - t.p * 4 : t.k.k.length - t.p * 4;
      this.o = createTypedArray("float32", n), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = n, this.initDynamicPropertyContainer(i), this.prop = PropertyFactory.getProp(e, t.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    GradientProperty.prototype.comparePoints = function(e, t) {
      for (var i = 0, n = this.o.length / 2, a; i < n; ) {
        if (a = Math.abs(e[i * 4] - e[t * 4 + i * 2]), a > 0.01)
          return !1;
        i += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var e = 0, t = this.data.k.k.length; e < t; ) {
          if (!this.comparePoints(this.data.k.k[e].s, this.data.p))
            return !1;
          e += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(e) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || e) {
        var t, i = this.data.p * 4, n, a;
        for (t = 0; t < i; t += 1)
          n = t % 4 === 0 ? 100 : 255, a = Math.round(this.prop.v[t] * n), this.c[t] !== a && (this.c[t] = a, this._cmdf = !e);
        if (this.o.length)
          for (i = this.prop.v.length, t = this.data.p * 4; t < i; t += 1)
            n = t % 2 === 0 ? 100 : 1, a = t % 2 === 0 ? Math.round(this.prop.v[t] * 100) : this.prop.v[t], this.o[t - this.data.p * 4] !== a && (this.o[t - this.data.p * 4] = a, this._omdf = !e);
        this._mdf = !e;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty);
    function SVGGradientFillStyleData(e, t, i) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.initGradientData(e, t, i);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(e, t, i) {
      this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.s = PropertyFactory.getProp(e, t.s, 1, null, this), this.e = PropertyFactory.getProp(e, t.e, 1, null, this), this.h = PropertyFactory.getProp(e, t.h || { k: 0 }, 0, 0.01, this), this.a = PropertyFactory.getProp(e, t.a || { k: 0 }, 0, degToRads, this), this.g = new GradientProperty(e, t.g, this), this.style = i, this.stops = [], this.setGradientData(i.pElem, t), this.setGradientOpacity(t, i), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(e, t) {
      var i = createElementID(), n = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
      n.setAttribute("id", i), n.setAttribute("spreadMethod", "pad"), n.setAttribute("gradientUnits", "userSpaceOnUse");
      var a = [], o, l, c;
      for (c = t.g.p * 4, l = 0; l < c; l += 4)
        o = createNS("stop"), n.appendChild(o), a.push(o);
      e.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + i + ")"), this.gf = n, this.cst = a;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(e, t) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var i, n, a, o = createNS("mask"), l = createNS("path");
        o.appendChild(l);
        var c = createElementID(), d = createElementID();
        o.setAttribute("id", d);
        var u = createNS(e.t === 1 ? "linearGradient" : "radialGradient");
        u.setAttribute("id", c), u.setAttribute("spreadMethod", "pad"), u.setAttribute("gradientUnits", "userSpaceOnUse"), a = e.g.k.k[0].s ? e.g.k.k[0].s.length : e.g.k.k.length;
        var m = this.stops;
        for (n = e.g.p * 4; n < a; n += 2)
          i = createNS("stop"), i.setAttribute("stop-color", "rgb(255,255,255)"), u.appendChild(i), m.push(i);
        l.setAttribute(e.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + c + ")"), e.ty === "gs" && (l.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), l.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), e.lj === 1 && l.setAttribute("stroke-miterlimit", e.ml)), this.of = u, this.ms = o, this.ost = m, this.maskId = d, t.msElem = l;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(e, t, i) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.initGradientData(e, t, i), this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(e, t, i) {
      this.transform = { mProps: e, op: t, container: i }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function(t, i, n, a) {
      if (i === 0)
        return "";
      var o = t.o, l = t.i, c = t.v, d, u = " M" + a.applyToPointStringified(c[0][0], c[0][1]);
      for (d = 1; d < i; d += 1)
        u += " C" + a.applyToPointStringified(o[d - 1][0], o[d - 1][1]) + " " + a.applyToPointStringified(l[d][0], l[d][1]) + " " + a.applyToPointStringified(c[d][0], c[d][1]);
      return n && i && (u += " C" + a.applyToPointStringified(o[d - 1][0], o[d - 1][1]) + " " + a.applyToPointStringified(l[0][0], l[0][1]) + " " + a.applyToPointStringified(c[0][0], c[0][1]), u += "z"), u;
    }, SVGElementsRenderer = function() {
      var e = new Matrix(), t = new Matrix(), i = { createRenderFunction: n };
      function n(A) {
        switch (A.ty) {
          case "fl":
            return c;
          case "gf":
            return u;
          case "gs":
            return d;
          case "st":
            return m;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return l;
          case "tr":
            return a;
          case "no":
            return o;
          default:
            return null;
        }
      }
      function a(A, y, D) {
        (D || y.transform.op._mdf) && y.transform.container.setAttribute("opacity", y.transform.op.v), (D || y.transform.mProps._mdf) && y.transform.container.setAttribute("transform", y.transform.mProps.v.to2dCSS());
      }
      function o() {
      }
      function l(A, y, D) {
        var C, z, R, O, $, k, P = y.styles.length, L = y.lvl, F, B, G, Z, X;
        for (k = 0; k < P; k += 1) {
          if (O = y.sh._mdf || D, y.styles[k].lvl < L) {
            for (B = t.reset(), Z = L - y.styles[k].lvl, X = y.transformers.length - 1; !O && Z > 0; )
              O = y.transformers[X].mProps._mdf || O, Z -= 1, X -= 1;
            if (O)
              for (Z = L - y.styles[k].lvl, X = y.transformers.length - 1; Z > 0; )
                G = y.transformers[X].mProps.v.props, B.transform(G[0], G[1], G[2], G[3], G[4], G[5], G[6], G[7], G[8], G[9], G[10], G[11], G[12], G[13], G[14], G[15]), Z -= 1, X -= 1;
          } else
            B = e;
          if (F = y.sh.paths, z = F._length, O) {
            for (R = "", C = 0; C < z; C += 1)
              $ = F.shapes[C], $ && $._length && (R += buildShapeString($, $._length, $.c, B));
            y.caches[k] = R;
          } else
            R = y.caches[k];
          y.styles[k].d += A.hd === !0 ? "" : R, y.styles[k]._mdf = O || y.styles[k]._mdf;
        }
      }
      function c(A, y, D) {
        var C = y.style;
        (y.c._mdf || D) && C.pElem.setAttribute("fill", "rgb(" + bmFloor(y.c.v[0]) + "," + bmFloor(y.c.v[1]) + "," + bmFloor(y.c.v[2]) + ")"), (y.o._mdf || D) && C.pElem.setAttribute("fill-opacity", y.o.v);
      }
      function d(A, y, D) {
        u(A, y, D), m(A, y, D);
      }
      function u(A, y, D) {
        var C = y.gf, z = y.g._hasOpacity, R = y.s.v, O = y.e.v;
        if (y.o._mdf || D) {
          var $ = A.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          y.style.pElem.setAttribute($, y.o.v);
        }
        if (y.s._mdf || D) {
          var k = A.t === 1 ? "x1" : "cx", P = k === "x1" ? "y1" : "cy";
          C.setAttribute(k, R[0]), C.setAttribute(P, R[1]), z && !y.g._collapsable && (y.of.setAttribute(k, R[0]), y.of.setAttribute(P, R[1]));
        }
        var L, F, B, G;
        if (y.g._cmdf || D) {
          L = y.cst;
          var Z = y.g.c;
          for (B = L.length, F = 0; F < B; F += 1)
            G = L[F], G.setAttribute("offset", Z[F * 4] + "%"), G.setAttribute("stop-color", "rgb(" + Z[F * 4 + 1] + "," + Z[F * 4 + 2] + "," + Z[F * 4 + 3] + ")");
        }
        if (z && (y.g._omdf || D)) {
          var X = y.g.o;
          for (y.g._collapsable ? L = y.cst : L = y.ost, B = L.length, F = 0; F < B; F += 1)
            G = L[F], y.g._collapsable || G.setAttribute("offset", X[F * 2] + "%"), G.setAttribute("stop-opacity", X[F * 2 + 1]);
        }
        if (A.t === 1)
          (y.e._mdf || D) && (C.setAttribute("x2", O[0]), C.setAttribute("y2", O[1]), z && !y.g._collapsable && (y.of.setAttribute("x2", O[0]), y.of.setAttribute("y2", O[1])));
        else {
          var V;
          if ((y.s._mdf || y.e._mdf || D) && (V = Math.sqrt(Math.pow(R[0] - O[0], 2) + Math.pow(R[1] - O[1], 2)), C.setAttribute("r", V), z && !y.g._collapsable && y.of.setAttribute("r", V)), y.e._mdf || y.h._mdf || y.a._mdf || D) {
            V || (V = Math.sqrt(Math.pow(R[0] - O[0], 2) + Math.pow(R[1] - O[1], 2)));
            var E = Math.atan2(O[1] - R[1], O[0] - R[0]), T = y.h.v;
            T >= 1 ? T = 0.99 : T <= -1 && (T = -0.99);
            var g = V * T, b = Math.cos(E + y.a.v) * g + R[0], x = Math.sin(E + y.a.v) * g + R[1];
            C.setAttribute("fx", b), C.setAttribute("fy", x), z && !y.g._collapsable && (y.of.setAttribute("fx", b), y.of.setAttribute("fy", x));
          }
        }
      }
      function m(A, y, D) {
        var C = y.style, z = y.d;
        z && (z._mdf || D) && z.dashStr && (C.pElem.setAttribute("stroke-dasharray", z.dashStr), C.pElem.setAttribute("stroke-dashoffset", z.dashoffset[0])), y.c && (y.c._mdf || D) && C.pElem.setAttribute("stroke", "rgb(" + bmFloor(y.c.v[0]) + "," + bmFloor(y.c.v[1]) + "," + bmFloor(y.c.v[2]) + ")"), (y.o._mdf || D) && C.pElem.setAttribute("stroke-opacity", y.o.v), (y.w._mdf || D) && (C.pElem.setAttribute("stroke-width", y.w.v), C.msElem && C.msElem.setAttribute("stroke-width", y.w.v));
      }
      return i;
    }();
    function SVGShapeElement(e, t, i) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(e, t, i), this.prevViewData = [];
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var e, t = this.shapes.length, i, n, a = this.stylesList.length, o, l = [], c = !1;
      for (n = 0; n < a; n += 1) {
        for (o = this.stylesList[n], c = !1, l.length = 0, e = 0; e < t; e += 1)
          i = this.shapes[e], i.styles.indexOf(o) !== -1 && (l.push(i), c = i._isAnimated || c);
        l.length > 1 && c && this.setShapesAsAnimated(l);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(e) {
      var t, i = e.length;
      for (t = 0; t < i; t += 1)
        e[t].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(e, t) {
      var i, n = new SVGStyleData(e, t), a = n.pElem;
      if (e.ty === "st")
        i = new SVGStrokeStyleData(this, e, n);
      else if (e.ty === "fl")
        i = new SVGFillStyleData(this, e, n);
      else if (e.ty === "gf" || e.ty === "gs") {
        var o = e.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
        i = new o(this, e, n), this.globalData.defs.appendChild(i.gf), i.maskId && (this.globalData.defs.appendChild(i.ms), this.globalData.defs.appendChild(i.of), a.setAttribute("mask", "url(" + getLocationHref() + "#" + i.maskId + ")"));
      } else
        e.ty === "no" && (i = new SVGNoStyleData(this, e, n));
      return (e.ty === "st" || e.ty === "gs") && (a.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), a.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), a.setAttribute("fill-opacity", "0"), e.lj === 1 && a.setAttribute("stroke-miterlimit", e.ml)), e.r === 2 && a.setAttribute("fill-rule", "evenodd"), e.ln && a.setAttribute("id", e.ln), e.cl && a.setAttribute("class", e.cl), e.bm && (a.style["mix-blend-mode"] = getBlendMode(e.bm)), this.stylesList.push(n), this.addToAnimatedContents(e, i), i;
    }, SVGShapeElement.prototype.createGroupElement = function(e) {
      var t = new ShapeGroupData();
      return e.ln && t.gr.setAttribute("id", e.ln), e.cl && t.gr.setAttribute("class", e.cl), e.bm && (t.gr.style["mix-blend-mode"] = getBlendMode(e.bm)), t;
    }, SVGShapeElement.prototype.createTransformElement = function(e, t) {
      var i = TransformPropertyFactory.getTransformProperty(this, e, this), n = new SVGTransformData(i, i.o, t);
      return this.addToAnimatedContents(e, n), n;
    }, SVGShapeElement.prototype.createShapeElement = function(e, t, i) {
      var n = 4;
      e.ty === "rc" ? n = 5 : e.ty === "el" ? n = 6 : e.ty === "sr" && (n = 7);
      var a = ShapePropertyFactory.getShapeProp(this, e, n, this), o = new SVGShapeData(t, i, a);
      return this.shapes.push(o), this.addShapeToModifiers(o), this.addToAnimatedContents(e, o), o;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(e, t) {
      for (var i = 0, n = this.animatedContents.length; i < n; ) {
        if (this.animatedContents[i].element === t)
          return;
        i += 1;
      }
      this.animatedContents.push({ fn: SVGElementsRenderer.createRenderFunction(e), element: t, data: e });
    }, SVGShapeElement.prototype.setElementStyles = function(e) {
      var t = e.styles, i, n = this.stylesList.length;
      for (i = 0; i < n; i += 1)
        this.stylesList[i].closed || t.push(this.stylesList[i]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(e, t, i, n, a, o, l) {
      var c = [].concat(o), d, u = e.length - 1, m, A, y = [], D = [], C, z, R;
      for (d = u; d >= 0; d -= 1) {
        if (R = this.searchProcessedElement(e[d]), R ? t[d] = i[R - 1] : e[d]._render = l, e[d].ty === "fl" || e[d].ty === "st" || e[d].ty === "gf" || e[d].ty === "gs" || e[d].ty === "no")
          R ? t[d].style.closed = !1 : t[d] = this.createStyleElement(e[d], a), e[d]._render && t[d].style.pElem.parentNode !== n && n.appendChild(t[d].style.pElem), y.push(t[d].style);
        else if (e[d].ty === "gr") {
          if (!R)
            t[d] = this.createGroupElement(e[d]);
          else
            for (A = t[d].it.length, m = 0; m < A; m += 1)
              t[d].prevViewData[m] = t[d].it[m];
          this.searchShapes(e[d].it, t[d].it, t[d].prevViewData, t[d].gr, a + 1, c, l), e[d]._render && t[d].gr.parentNode !== n && n.appendChild(t[d].gr);
        } else
          e[d].ty === "tr" ? (R || (t[d] = this.createTransformElement(e[d], n)), C = t[d].transform, c.push(C)) : e[d].ty === "sh" || e[d].ty === "rc" || e[d].ty === "el" || e[d].ty === "sr" ? (R || (t[d] = this.createShapeElement(e[d], c, a)), this.setElementStyles(t[d])) : e[d].ty === "tm" || e[d].ty === "rd" || e[d].ty === "ms" || e[d].ty === "pb" || e[d].ty === "zz" || e[d].ty === "op" ? (R ? (z = t[d], z.closed = !1) : (z = ShapeModifiers.getModifier(e[d].ty), z.init(this, e[d]), t[d] = z, this.shapeModifiers.push(z)), D.push(z)) : e[d].ty === "rp" && (R ? (z = t[d], z.closed = !0) : (z = ShapeModifiers.getModifier(e[d].ty), t[d] = z, z.init(this, e, d, t), this.shapeModifiers.push(z), l = !1), D.push(z));
        this.addProcessedElement(e[d], d + 1);
      }
      for (u = y.length, d = 0; d < u; d += 1)
        y[d].closed = !0;
      for (u = D.length, d = 0; d < u; d += 1)
        D[d].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].reset();
      for (this.renderShape(), e = 0; e < t; e += 1)
        (this.stylesList[e]._mdf || this._isFirstFrame) && (this.stylesList[e].msElem && (this.stylesList[e].msElem.setAttribute("d", this.stylesList[e].d), this.stylesList[e].d = "M0 0" + this.stylesList[e].d), this.stylesList[e].pElem.setAttribute("d", this.stylesList[e].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var e, t = this.animatedContents.length, i;
      for (e = 0; e < t; e += 1)
        i = this.animatedContents[e], (this._isFirstFrame || i.element._isAnimated) && i.data !== !0 && i.fn(i.data, i.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function LetterProps(e, t, i, n, a, o) {
      this.o = e, this.sw = t, this.sc = i, this.fc = n, this.m = a, this.p = o, this._mdf = { o: !0, sw: !!t, sc: !!i, fc: !!n, m: !0, p: !0 };
    }
    LetterProps.prototype.update = function(e, t, i, n, a, o) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var l = !1;
      return this.o !== e && (this.o = e, this._mdf.o = !0, l = !0), this.sw !== t && (this.sw = t, this._mdf.sw = !0, l = !0), this.sc !== i && (this.sc = i, this._mdf.sc = !0, l = !0), this.fc !== n && (this.fc = n, this._mdf.fc = !0, l = !0), this.m !== a && (this.m = a, this._mdf.m = !0, l = !0), o.length && (this.p[0] !== o[0] || this.p[1] !== o[1] || this.p[4] !== o[4] || this.p[5] !== o[5] || this.p[12] !== o[12] || this.p[13] !== o[13]) && (this.p = o, this._mdf.p = !0, l = !0), l;
    };
    function TextProperty(e, t) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, t.d && t.d.sid && (t.d = e.globalData.slotManager.getProp(t.d)), this.data = t, this.elem = e, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = { ascent: 0, boxWidth: this.defaultBoxWidth, f: "", fStyle: "", fWeight: "", fc: "", j: "", justifyOffset: "", l: [], lh: 0, lineWidths: [], ls: "", of: "", s: "", sc: "", sw: 0, t: 0, tr: 0, sz: 0, ps: null, fillColorAnim: !1, strokeColorAnim: !1, strokeWidthAnim: !1, yOffset: 0, finalSize: 0, finalText: [], finalLineHeight: 0, __complete: !1 }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(e, t) {
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      return e;
    }, TextProperty.prototype.setCurrentData = function(e) {
      e.__complete || this.completeTextData(e), this.currentData = e, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(e) {
      this.effectsSequence.push(e), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(e) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !e)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var t = this.currentData, i = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var n, a = this.effectsSequence.length, o = e || this.data.d.k[this.keysIndex].s;
        for (n = 0; n < a; n += 1)
          i !== this.keysIndex ? o = this.effectsSequence[n](o, o.t) : o = this.effectsSequence[n](this.currentData, o.t);
        t !== o && this.setCurrentData(o), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var e = this.data.d.k, t = this.elem.comp.renderedFrame, i = 0, n = e.length; i <= n - 1 && !(i === n - 1 || e[i + 1].t > t); )
        i += 1;
      return this.keysIndex !== i && (this.keysIndex = i), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(e) {
      for (var t = [], i = 0, n = e.length, a, o, l = !1; i < n; )
        a = e.charCodeAt(i), FontManager.isCombinedCharacter(a) ? t[t.length - 1] += e.charAt(i) : a >= 55296 && a <= 56319 ? (o = e.charCodeAt(i + 1), o >= 56320 && o <= 57343 ? (l || FontManager.isModifier(a, o) ? (t[t.length - 1] += e.substr(i, 2), l = !1) : t.push(e.substr(i, 2)), i += 1) : t.push(e.charAt(i))) : a > 56319 ? (o = e.charCodeAt(i + 1), FontManager.isZeroWidthJoiner(a, o) ? (l = !0, t[t.length - 1] += e.substr(i, 2), i += 1) : t.push(e.charAt(i))) : FontManager.isZeroWidthJoiner(a) ? (t[t.length - 1] += e.charAt(i), l = !0) : t.push(e.charAt(i)), i += 1;
      return t;
    }, TextProperty.prototype.completeTextData = function(e) {
      e.__complete = !0;
      var t = this.elem.globalData.fontManager, i = this.data, n = [], a, o, l, c = 0, d, u = i.m.g, m = 0, A = 0, y = 0, D = [], C = 0, z = 0, R, O, $ = t.getFontByName(e.f), k, P = 0, L = getFontProperties($);
      e.fWeight = L.weight, e.fStyle = L.style, e.finalSize = e.s, e.finalText = this.buildFinalText(e.t), o = e.finalText.length, e.finalLineHeight = e.lh;
      var F = e.tr / 1e3 * e.finalSize, B;
      if (e.sz)
        for (var G = !0, Z = e.sz[0], X = e.sz[1], V, E; G; ) {
          E = this.buildFinalText(e.t), V = 0, C = 0, o = E.length, F = e.tr / 1e3 * e.finalSize;
          var T = -1;
          for (a = 0; a < o; a += 1)
            B = E[a].charCodeAt(0), l = !1, E[a] === " " ? T = a : (B === 13 || B === 3) && (C = 0, l = !0, V += e.finalLineHeight || e.finalSize * 1.2), t.chars ? (k = t.getCharData(E[a], $.fStyle, $.fFamily), P = l ? 0 : k.w * e.finalSize / 100) : P = t.measureText(E[a], e.f, e.finalSize), C + P > Z && E[a] !== " " ? (T === -1 ? o += 1 : a = T, V += e.finalLineHeight || e.finalSize * 1.2, E.splice(a, T === a ? 1 : 0, "\r"), T = -1, C = 0) : (C += P, C += F);
          V += $.ascent * e.finalSize / 100, this.canResize && e.finalSize > this.minimumFontSize && X < V ? (e.finalSize -= 1, e.finalLineHeight = e.finalSize * e.lh / e.s) : (e.finalText = E, o = e.finalText.length, G = !1);
        }
      C = -F, P = 0;
      var g = 0, b;
      for (a = 0; a < o; a += 1)
        if (l = !1, b = e.finalText[a], B = b.charCodeAt(0), B === 13 || B === 3 ? (g = 0, D.push(C), z = C > z ? C : z, C = -2 * F, d = "", l = !0, y += 1) : d = b, t.chars ? (k = t.getCharData(b, $.fStyle, t.getFontByName(e.f).fFamily), P = l ? 0 : k.w * e.finalSize / 100) : P = t.measureText(d, e.f, e.finalSize), b === " " ? g += P + F : (C += P + F + g, g = 0), n.push({ l: P, an: P, add: m, n: l, anIndexes: [], val: d, line: y, animatorJustifyOffset: 0 }), u == 2) {
          if (m += P, d === "" || d === " " || a === o - 1) {
            for ((d === "" || d === " ") && (m -= P); A <= a; )
              n[A].an = m, n[A].ind = c, n[A].extra = P, A += 1;
            c += 1, m = 0;
          }
        } else if (u == 3) {
          if (m += P, d === "" || a === o - 1) {
            for (d === "" && (m -= P); A <= a; )
              n[A].an = m, n[A].ind = c, n[A].extra = P, A += 1;
            m = 0, c += 1;
          }
        } else
          n[c].ind = c, n[c].extra = 0, c += 1;
      if (e.l = n, z = C > z ? C : z, D.push(C), e.sz)
        e.boxWidth = e.sz[0], e.justifyOffset = 0;
      else
        switch (e.boxWidth = z, e.j) {
          case 1:
            e.justifyOffset = -e.boxWidth;
            break;
          case 2:
            e.justifyOffset = -e.boxWidth / 2;
            break;
          default:
            e.justifyOffset = 0;
        }
      e.lineWidths = D;
      var x = i.a, S, I;
      O = x.length;
      var N, p, M = [];
      for (R = 0; R < O; R += 1) {
        for (S = x[R], S.a.sc && (e.strokeColorAnim = !0), S.a.sw && (e.strokeWidthAnim = !0), (S.a.fc || S.a.fh || S.a.fs || S.a.fb) && (e.fillColorAnim = !0), p = 0, N = S.s.b, a = 0; a < o; a += 1)
          I = n[a], I.anIndexes[R] = p, (N == 1 && I.val !== "" || N == 2 && I.val !== "" && I.val !== " " || N == 3 && (I.n || I.val == " " || a == o - 1) || N == 4 && (I.n || a == o - 1)) && (S.s.rn === 1 && M.push(p), p += 1);
        i.a[R].s.totalChars = p;
        var j = -1, U;
        if (S.s.rn === 1)
          for (a = 0; a < o; a += 1)
            I = n[a], j != I.anIndexes[R] && (j = I.anIndexes[R], U = M.splice(Math.floor(Math.random() * M.length), 1)[0]), I.anIndexes[R] = U;
      }
      e.yOffset = e.finalLineHeight || e.finalSize * 1.2, e.ls = e.ls || 0, e.ascent = $.ascent * e.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(e, t) {
      t = t === void 0 ? this.keysIndex : t;
      var i = this.copyData({}, this.data.d.k[t].s);
      i = this.copyData(i, e), this.data.d.k[t].s = i, this.recalculate(t), this.setCurrentData(i), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(e) {
      var t = this.data.d.k[e].s;
      t.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(t);
    }, TextProperty.prototype.canResizeFont = function(e) {
      this.canResize = e, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(e) {
      this.minimumFontSize = Math.floor(e) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var e = Math.max, t = Math.min, i = Math.floor;
      function n(o, l) {
        this._currentTextLength = -1, this.k = !1, this.data = l, this.elem = o, this.comp = o.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(o), this.s = PropertyFactory.getProp(o, l.s || { k: 0 }, 0, 0, this), "e" in l ? this.e = PropertyFactory.getProp(o, l.e, 0, 0, this) : this.e = { v: 100 }, this.o = PropertyFactory.getProp(o, l.o || { k: 0 }, 0, 0, this), this.xe = PropertyFactory.getProp(o, l.xe || { k: 0 }, 0, 0, this), this.ne = PropertyFactory.getProp(o, l.ne || { k: 0 }, 0, 0, this), this.sm = PropertyFactory.getProp(o, l.sm || { k: 100 }, 0, 0, this), this.a = PropertyFactory.getProp(o, l.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      n.prototype = { getMult: function(l) {
        this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
        var c = 0, d = 0, u = 1, m = 1;
        this.ne.v > 0 ? c = this.ne.v / 100 : d = -this.ne.v / 100, this.xe.v > 0 ? u = 1 - this.xe.v / 100 : m = 1 + this.xe.v / 100;
        var A = BezierFactory.getBezierEasing(c, d, u, m).get, y = 0, D = this.finalS, C = this.finalE, z = this.data.sh;
        if (z === 2)
          C === D ? y = l >= C ? 1 : 0 : y = e(0, t(0.5 / (C - D) + (l - D) / (C - D), 1)), y = A(y);
        else if (z === 3)
          C === D ? y = l >= C ? 0 : 1 : y = 1 - e(0, t(0.5 / (C - D) + (l - D) / (C - D), 1)), y = A(y);
        else if (z === 4)
          C === D ? y = 0 : (y = e(0, t(0.5 / (C - D) + (l - D) / (C - D), 1)), y < 0.5 ? y *= 2 : y = 1 - 2 * (y - 0.5)), y = A(y);
        else if (z === 5) {
          if (C === D)
            y = 0;
          else {
            var R = C - D;
            l = t(e(0, l + 0.5 - D), C - D);
            var O = -R / 2 + l, $ = R / 2;
            y = Math.sqrt(1 - O * O / ($ * $));
          }
          y = A(y);
        } else
          z === 6 ? (C === D ? y = 0 : (l = t(e(0, l + 0.5 - D), C - D), y = (1 + Math.cos(Math.PI + Math.PI * 2 * l / (C - D))) / 2), y = A(y)) : (l >= i(D) && (l - D < 0 ? y = e(0, t(t(C, 1) - (D - l), 1)) : y = e(0, t(C - l, 1))), y = A(y));
        if (this.sm.v !== 100) {
          var k = this.sm.v * 0.01;
          k === 0 && (k = 1e-8);
          var P = 0.5 - k * 0.5;
          y < P ? y = 0 : (y = (y - P) / k, y > 1 && (y = 1));
        }
        return y * this.a.v;
      }, getValue: function(l) {
        this.iterateDynamicProperties(), this._mdf = l || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, l && this.data.r === 2 && (this.e.v = this._currentTextLength);
        var c = this.data.r === 2 ? 1 : 100 / this.data.totalChars, d = this.o.v / c, u = this.s.v / c + d, m = this.e.v / c + d;
        if (u > m) {
          var A = u;
          u = m, m = A;
        }
        this.finalS = u, this.finalE = m;
      } }, extendPrototype([DynamicPropertyContainer], n);
      function a(o, l, c) {
        return new n(o, l);
      }
      return { getTextSelectorProp: a };
    }();
    function TextAnimatorDataProperty(e, t, i) {
      var n = { propType: !1 }, a = PropertyFactory.getProp, o = t.a;
      this.a = { r: o.r ? a(e, o.r, 0, degToRads, i) : n, rx: o.rx ? a(e, o.rx, 0, degToRads, i) : n, ry: o.ry ? a(e, o.ry, 0, degToRads, i) : n, sk: o.sk ? a(e, o.sk, 0, degToRads, i) : n, sa: o.sa ? a(e, o.sa, 0, degToRads, i) : n, s: o.s ? a(e, o.s, 1, 0.01, i) : n, a: o.a ? a(e, o.a, 1, 0, i) : n, o: o.o ? a(e, o.o, 0, 0.01, i) : n, p: o.p ? a(e, o.p, 1, 0, i) : n, sw: o.sw ? a(e, o.sw, 0, 0, i) : n, sc: o.sc ? a(e, o.sc, 1, 0, i) : n, fc: o.fc ? a(e, o.fc, 1, 0, i) : n, fh: o.fh ? a(e, o.fh, 0, 0, i) : n, fs: o.fs ? a(e, o.fs, 0, 0.01, i) : n, fb: o.fb ? a(e, o.fb, 0, 0.01, i) : n, t: o.t ? a(e, o.t, 0, 0, i) : n }, this.s = TextSelectorProp.getTextSelectorProp(e, t.s, i), this.s.t = t.s.t;
    }
    function TextAnimatorProperty(e, t, i) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = e, this._renderType = t, this._elem = i, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = { alignment: {} }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(i);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var e, t = this._textData.a.length, i, n = PropertyFactory.getProp;
      for (e = 0; e < t; e += 1)
        i = this._textData.a[e], this._animatorsData[e] = new TextAnimatorDataProperty(this._elem, i, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = { a: n(this._elem, this._textData.p.a, 0, 0, this), f: n(this._elem, this._textData.p.f, 0, 0, this), l: n(this._elem, this._textData.p.l, 0, 0, this), r: n(this._elem, this._textData.p.r, 0, 0, this), p: n(this._elem, this._textData.p.p, 0, 0, this), m: this._elem.maskManager.getMaskProperty(this._textData.p.m) }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = n(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(e, t) {
      if (this.lettersChangedFlag = t, !(!this._mdf && !this._isFirstFrame && !t && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var i = this._moreOptions.alignment.v, n = this._animatorsData, a = this._textData, o = this.mHelper, l = this._renderType, c = this.renderedLetters.length, d, u, m, A, y = e.l, D, C, z, R, O, $, k, P, L, F, B, G, Z, X, V;
        if (this._hasMaskedPath) {
          if (V = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var E = V.v;
            this._pathData.r.v && (E = E.reverse()), D = { tLength: 0, segments: [] }, A = E._length - 1;
            var T;
            for (G = 0, m = 0; m < A; m += 1)
              T = bez.buildBezierData(E.v[m], E.v[m + 1], [E.o[m][0] - E.v[m][0], E.o[m][1] - E.v[m][1]], [E.i[m + 1][0] - E.v[m + 1][0], E.i[m + 1][1] - E.v[m + 1][1]]), D.tLength += T.segmentLength, D.segments.push(T), G += T.segmentLength;
            m = A, V.v.c && (T = bez.buildBezierData(E.v[m], E.v[0], [E.o[m][0] - E.v[m][0], E.o[m][1] - E.v[m][1]], [E.i[0][0] - E.v[0][0], E.i[0][1] - E.v[0][1]]), D.tLength += T.segmentLength, D.segments.push(T), G += T.segmentLength), this._pathData.pi = D;
          }
          if (D = this._pathData.pi, C = this._pathData.f.v, k = 0, $ = 1, R = 0, O = !0, F = D.segments, C < 0 && V.v.c)
            for (D.tLength < Math.abs(C) && (C = -Math.abs(C) % D.tLength), k = F.length - 1, L = F[k].points, $ = L.length - 1; C < 0; )
              C += L[$].partialLength, $ -= 1, $ < 0 && (k -= 1, L = F[k].points, $ = L.length - 1);
          L = F[k].points, P = L[$ - 1], z = L[$], B = z.partialLength;
        }
        A = y.length, d = 0, u = 0;
        var g = e.finalSize * 1.2 * 0.714, b = !0, x, S, I, N, p;
        N = n.length;
        var M, j = -1, U, H, J, te = C, ae = k, le = $, ne = -1, ue, ge, re, fe, oe, ve, Le, Be, we = "", Ue = this.defaultPropsArray, Oe;
        if (e.j === 2 || e.j === 1) {
          var Te = 0, Ne = 0, Ee = e.j === 2 ? -0.5 : -1, Se = 0, Re = !0;
          for (m = 0; m < A; m += 1)
            if (y[m].n) {
              for (Te && (Te += Ne); Se < m; )
                y[Se].animatorJustifyOffset = Te, Se += 1;
              Te = 0, Re = !0;
            } else {
              for (I = 0; I < N; I += 1)
                x = n[I].a, x.t.propType && (Re && e.j === 2 && (Ne += x.t.v * Ee), S = n[I].s, M = S.getMult(y[m].anIndexes[I], a.a[I].s.totalChars), M.length ? Te += x.t.v * M[0] * Ee : Te += x.t.v * M * Ee);
              Re = !1;
            }
          for (Te && (Te += Ne); Se < m; )
            y[Se].animatorJustifyOffset = Te, Se += 1;
        }
        for (m = 0; m < A; m += 1) {
          if (o.reset(), ue = 1, y[m].n)
            d = 0, u += e.yOffset, u += b ? 1 : 0, C = te, b = !1, this._hasMaskedPath && (k = ae, $ = le, L = F[k].points, P = L[$ - 1], z = L[$], B = z.partialLength, R = 0), we = "", Be = "", ve = "", Oe = "", Ue = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (ne !== y[m].line) {
                switch (e.j) {
                  case 1:
                    C += G - e.lineWidths[y[m].line];
                    break;
                  case 2:
                    C += (G - e.lineWidths[y[m].line]) / 2;
                    break;
                }
                ne = y[m].line;
              }
              j !== y[m].ind && (y[j] && (C += y[j].extra), C += y[m].an / 2, j = y[m].ind), C += i[0] * y[m].an * 5e-3;
              var W = 0;
              for (I = 0; I < N; I += 1)
                x = n[I].a, x.p.propType && (S = n[I].s, M = S.getMult(y[m].anIndexes[I], a.a[I].s.totalChars), M.length ? W += x.p.v[0] * M[0] : W += x.p.v[0] * M), x.a.propType && (S = n[I].s, M = S.getMult(y[m].anIndexes[I], a.a[I].s.totalChars), M.length ? W += x.a.v[0] * M[0] : W += x.a.v[0] * M);
              for (O = !0, this._pathData.a.v && (C = y[0].an * 0.5 + (G - this._pathData.f.v - y[0].an * 0.5 - y[y.length - 1].an * 0.5) * j / (A - 1), C += this._pathData.f.v); O; )
                R + B >= C + W || !L ? (Z = (C + W - R) / z.partialLength, H = P.point[0] + (z.point[0] - P.point[0]) * Z, J = P.point[1] + (z.point[1] - P.point[1]) * Z, o.translate(-i[0] * y[m].an * 5e-3, -(i[1] * g) * 0.01), O = !1) : L && (R += z.partialLength, $ += 1, $ >= L.length && ($ = 0, k += 1, F[k] ? L = F[k].points : V.v.c ? ($ = 0, k = 0, L = F[k].points) : (R -= z.partialLength, L = null)), L && (P = z, z = L[$], B = z.partialLength));
              U = y[m].an / 2 - y[m].add, o.translate(-U, 0, 0);
            } else
              U = y[m].an / 2 - y[m].add, o.translate(-U, 0, 0), o.translate(-i[0] * y[m].an * 5e-3, -i[1] * g * 0.01, 0);
            for (I = 0; I < N; I += 1)
              x = n[I].a, x.t.propType && (S = n[I].s, M = S.getMult(y[m].anIndexes[I], a.a[I].s.totalChars), (d !== 0 || e.j !== 0) && (this._hasMaskedPath ? M.length ? C += x.t.v * M[0] : C += x.t.v * M : M.length ? d += x.t.v * M[0] : d += x.t.v * M));
            for (e.strokeWidthAnim && (re = e.sw || 0), e.strokeColorAnim && (e.sc ? ge = [e.sc[0], e.sc[1], e.sc[2]] : ge = [0, 0, 0]), e.fillColorAnim && e.fc && (fe = [e.fc[0], e.fc[1], e.fc[2]]), I = 0; I < N; I += 1)
              x = n[I].a, x.a.propType && (S = n[I].s, M = S.getMult(y[m].anIndexes[I], a.a[I].s.totalChars), M.length ? o.translate(-x.a.v[0] * M[0], -x.a.v[1] * M[1], x.a.v[2] * M[2]) : o.translate(-x.a.v[0] * M, -x.a.v[1] * M, x.a.v[2] * M));
            for (I = 0; I < N; I += 1)
              x = n[I].a, x.s.propType && (S = n[I].s, M = S.getMult(y[m].anIndexes[I], a.a[I].s.totalChars), M.length ? o.scale(1 + (x.s.v[0] - 1) * M[0], 1 + (x.s.v[1] - 1) * M[1], 1) : o.scale(1 + (x.s.v[0] - 1) * M, 1 + (x.s.v[1] - 1) * M, 1));
            for (I = 0; I < N; I += 1) {
              if (x = n[I].a, S = n[I].s, M = S.getMult(y[m].anIndexes[I], a.a[I].s.totalChars), x.sk.propType && (M.length ? o.skewFromAxis(-x.sk.v * M[0], x.sa.v * M[1]) : o.skewFromAxis(-x.sk.v * M, x.sa.v * M)), x.r.propType && (M.length ? o.rotateZ(-x.r.v * M[2]) : o.rotateZ(-x.r.v * M)), x.ry.propType && (M.length ? o.rotateY(x.ry.v * M[1]) : o.rotateY(x.ry.v * M)), x.rx.propType && (M.length ? o.rotateX(x.rx.v * M[0]) : o.rotateX(x.rx.v * M)), x.o.propType && (M.length ? ue += (x.o.v * M[0] - ue) * M[0] : ue += (x.o.v * M - ue) * M), e.strokeWidthAnim && x.sw.propType && (M.length ? re += x.sw.v * M[0] : re += x.sw.v * M), e.strokeColorAnim && x.sc.propType)
                for (oe = 0; oe < 3; oe += 1)
                  M.length ? ge[oe] += (x.sc.v[oe] - ge[oe]) * M[0] : ge[oe] += (x.sc.v[oe] - ge[oe]) * M;
              if (e.fillColorAnim && e.fc) {
                if (x.fc.propType)
                  for (oe = 0; oe < 3; oe += 1)
                    M.length ? fe[oe] += (x.fc.v[oe] - fe[oe]) * M[0] : fe[oe] += (x.fc.v[oe] - fe[oe]) * M;
                x.fh.propType && (M.length ? fe = addHueToRGB(fe, x.fh.v * M[0]) : fe = addHueToRGB(fe, x.fh.v * M)), x.fs.propType && (M.length ? fe = addSaturationToRGB(fe, x.fs.v * M[0]) : fe = addSaturationToRGB(fe, x.fs.v * M)), x.fb.propType && (M.length ? fe = addBrightnessToRGB(fe, x.fb.v * M[0]) : fe = addBrightnessToRGB(fe, x.fb.v * M));
              }
            }
            for (I = 0; I < N; I += 1)
              x = n[I].a, x.p.propType && (S = n[I].s, M = S.getMult(y[m].anIndexes[I], a.a[I].s.totalChars), this._hasMaskedPath ? M.length ? o.translate(0, x.p.v[1] * M[0], -x.p.v[2] * M[1]) : o.translate(0, x.p.v[1] * M, -x.p.v[2] * M) : M.length ? o.translate(x.p.v[0] * M[0], x.p.v[1] * M[1], -x.p.v[2] * M[2]) : o.translate(x.p.v[0] * M, x.p.v[1] * M, -x.p.v[2] * M));
            if (e.strokeWidthAnim && (ve = re < 0 ? 0 : re), e.strokeColorAnim && (Le = "rgb(" + Math.round(ge[0] * 255) + "," + Math.round(ge[1] * 255) + "," + Math.round(ge[2] * 255) + ")"), e.fillColorAnim && e.fc && (Be = "rgb(" + Math.round(fe[0] * 255) + "," + Math.round(fe[1] * 255) + "," + Math.round(fe[2] * 255) + ")"), this._hasMaskedPath) {
              if (o.translate(0, -e.ls), o.translate(0, i[1] * g * 0.01 + u, 0), this._pathData.p.v) {
                X = (z.point[1] - P.point[1]) / (z.point[0] - P.point[0]);
                var Y = Math.atan(X) * 180 / Math.PI;
                z.point[0] < P.point[0] && (Y += 180), o.rotate(-Y * Math.PI / 180);
              }
              o.translate(H, J, 0), C -= i[0] * y[m].an * 5e-3, y[m + 1] && j !== y[m + 1].ind && (C += y[m].an / 2, C += e.tr * 1e-3 * e.finalSize);
            } else {
              switch (o.translate(d, u, 0), e.ps && o.translate(e.ps[0], e.ps[1] + e.ascent, 0), e.j) {
                case 1:
                  o.translate(y[m].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[y[m].line]), 0, 0);
                  break;
                case 2:
                  o.translate(y[m].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[y[m].line]) / 2, 0, 0);
                  break;
              }
              o.translate(0, -e.ls), o.translate(U, 0, 0), o.translate(i[0] * y[m].an * 5e-3, i[1] * g * 0.01, 0), d += y[m].l + e.tr * 1e-3 * e.finalSize;
            }
            l === "html" ? we = o.toCSS() : l === "svg" ? we = o.to2dCSS() : Ue = [o.props[0], o.props[1], o.props[2], o.props[3], o.props[4], o.props[5], o.props[6], o.props[7], o.props[8], o.props[9], o.props[10], o.props[11], o.props[12], o.props[13], o.props[14], o.props[15]], Oe = ue;
          }
          c <= m ? (p = new LetterProps(Oe, ve, Le, Be, we, Ue), this.renderedLetters.push(p), c += 1, this.lettersChangedFlag = !0) : (p = this.renderedLetters[m], this.lettersChangedFlag = p.update(Oe, ve, Le, Be, we, Ue) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
    function ITextElement() {
    }
    ITextElement.prototype.initElement = function(e, t, i) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(e, t, i), this.textProperty = new TextProperty(this, e.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(e.t, this.renderType, this), this.initTransform(e, t, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(e) {
      this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    }, ITextElement.prototype.createPathShape = function(e, t) {
      var i, n = t.length, a, o = "";
      for (i = 0; i < n; i += 1)
        t[i].ty === "sh" && (a = t[i].ks.k, o += buildShapeString(a, a.i.length, !0, e));
      return o;
    }, ITextElement.prototype.updateDocumentData = function(e, t) {
      this.textProperty.updateDocumentData(e, t);
    }, ITextElement.prototype.canResizeFont = function(e) {
      this.textProperty.canResizeFont(e);
    }, ITextElement.prototype.setMinimumFontSize = function(e) {
      this.textProperty.setMinimumFontSize(e);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(e, t, i, n, a) {
      switch (e.ps && t.translate(e.ps[0], e.ps[1] + e.ascent, 0), t.translate(0, -e.ls, 0), e.j) {
        case 1:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[i]), 0, 0);
          break;
        case 2:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[i]) / 2, 0, 0);
          break;
      }
      t.translate(n, a, 0);
    }, ITextElement.prototype.buildColor = function(e) {
      return "rgb(" + Math.round(e[0] * 255) + "," + Math.round(e[1] * 255) + "," + Math.round(e[2] * 255) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    };
    var emptyShapeData = { shapes: [] };
    function SVGTextLottieElement(e, t, i) {
      this.textSpans = [], this.renderType = "svg", this.initElement(e, t, i);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(e) {
      for (var t = 0, i = e.length, n = [], a = ""; t < i; )
        e[t] === String.fromCharCode(13) || e[t] === String.fromCharCode(3) ? (n.push(a), a = "") : a += e[t], t += 1;
      return n.push(a), n;
    }, SVGTextLottieElement.prototype.buildShapeData = function(e, t) {
      if (e.shapes && e.shapes.length) {
        var i = e.shapes[0];
        if (i.it) {
          var n = i.it[i.it.length - 1];
          n.s && (n.s.k[0] = t, n.s.k[1] = t);
        }
      }
      return e;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var e, t, i = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(i ? i.l.length : 0), i.fc ? this.layerElement.setAttribute("fill", this.buildColor(i.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), i.sc && (this.layerElement.setAttribute("stroke", this.buildColor(i.sc)), this.layerElement.setAttribute("stroke-width", i.sw)), this.layerElement.setAttribute("font-size", i.finalSize);
      var n = this.globalData.fontManager.getFontByName(i.f);
      if (n.fClass)
        this.layerElement.setAttribute("class", n.fClass);
      else {
        this.layerElement.setAttribute("font-family", n.fFamily);
        var a = i.fWeight, o = i.fStyle;
        this.layerElement.setAttribute("font-style", o), this.layerElement.setAttribute("font-weight", a);
      }
      this.layerElement.setAttribute("aria-label", i.t);
      var l = i.l || [], c = !!this.globalData.fontManager.chars;
      t = l.length;
      var d, u = this.mHelper, m = "", A = this.data.singleShape, y = 0, D = 0, C = !0, z = i.tr * 1e-3 * i.finalSize;
      if (A && !c && !i.sz) {
        var R = this.textContainer, O = "start";
        switch (i.j) {
          case 1:
            O = "end";
            break;
          case 2:
            O = "middle";
            break;
          default:
            O = "start";
            break;
        }
        R.setAttribute("text-anchor", O), R.setAttribute("letter-spacing", z);
        var $ = this.buildTextContents(i.finalText);
        for (t = $.length, D = i.ps ? i.ps[1] + i.ascent : 0, e = 0; e < t; e += 1)
          d = this.textSpans[e].span || createNS("tspan"), d.textContent = $[e], d.setAttribute("x", 0), d.setAttribute("y", D), d.style.display = "inherit", R.appendChild(d), this.textSpans[e] || (this.textSpans[e] = { span: null, glyph: null }), this.textSpans[e].span = d, D += i.finalLineHeight;
        this.layerElement.appendChild(R);
      } else {
        var k = this.textSpans.length, P;
        for (e = 0; e < t; e += 1) {
          if (this.textSpans[e] || (this.textSpans[e] = { span: null, childSpan: null, glyph: null }), !c || !A || e === 0) {
            if (d = k > e ? this.textSpans[e].span : createNS(c ? "g" : "text"), k <= e) {
              if (d.setAttribute("stroke-linecap", "butt"), d.setAttribute("stroke-linejoin", "round"), d.setAttribute("stroke-miterlimit", "4"), this.textSpans[e].span = d, c) {
                var L = createNS("g");
                d.appendChild(L), this.textSpans[e].childSpan = L;
              }
              this.textSpans[e].span = d, this.layerElement.appendChild(d);
            }
            d.style.display = "inherit";
          }
          if (u.reset(), A && (l[e].n && (y = -z, D += i.yOffset, D += C ? 1 : 0, C = !1), this.applyTextPropertiesToMatrix(i, u, l[e].line, y, D), y += l[e].l || 0, y += z), c) {
            P = this.globalData.fontManager.getCharData(i.finalText[e], n.fStyle, this.globalData.fontManager.getFontByName(i.f).fFamily);
            var F;
            if (P.t === 1)
              F = new SVGCompElement(P.data, this.globalData, this);
            else {
              var B = emptyShapeData;
              P.data && P.data.shapes && (B = this.buildShapeData(P.data, i.finalSize)), F = new SVGShapeElement(B, this.globalData, this);
            }
            if (this.textSpans[e].glyph) {
              var G = this.textSpans[e].glyph;
              this.textSpans[e].childSpan.removeChild(G.layerElement), G.destroy();
            }
            this.textSpans[e].glyph = F, F._debug = !0, F.prepareFrame(0), F.renderFrame(), this.textSpans[e].childSpan.appendChild(F.layerElement), P.t === 1 && this.textSpans[e].childSpan.setAttribute("transform", "scale(" + i.finalSize / 100 + "," + i.finalSize / 100 + ")");
          } else
            A && d.setAttribute("transform", "translate(" + u.props[12] + "," + u.props[13] + ")"), d.textContent = l[e].val, d.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        A && d && d.setAttribute("d", m);
      }
      for (; e < this.textSpans.length; )
        this.textSpans[e].span.style.display = "none", e += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var e = this.layerElement.getBBox();
        this.bbox = { top: e.y, left: e.x, width: e.width, height: e.height };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var e, t = this.textSpans.length, i;
      for (this.renderedFrame = this.comp.renderedFrame, e = 0; e < t; e += 1)
        i = this.textSpans[e].glyph, i && (i.prepareFrame(this.comp.renderedFrame - this.data.st), i._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var e, t, i = this.textAnimator.renderedLetters, n = this.textProperty.currentData.l;
        t = n.length;
        var a, o, l;
        for (e = 0; e < t; e += 1)
          n[e].n || (a = i[e], o = this.textSpans[e].span, l = this.textSpans[e].glyph, l && l.renderFrame(), a._mdf.m && o.setAttribute("transform", a.m), a._mdf.o && o.setAttribute("opacity", a.o), a._mdf.sw && o.setAttribute("stroke-width", a.sw), a._mdf.sc && o.setAttribute("stroke", a.sc), a._mdf.fc && o.setAttribute("fill", a.fc));
      }
    };
    function ISolidElement(e, t, i) {
      this.initElement(e, t, i);
    }
    extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var e = createNS("rect");
      e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.layerElement.appendChild(e);
    };
    function NullElement(e, t, i) {
      this.initFrame(), this.initBaseData(e, t, i), this.initFrame(), this.initTransform(e, t, i), this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
    function SVGRendererBase() {
    }
    extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(e) {
      return new NullElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(e) {
      return new SVGShapeElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(e) {
      return new SVGTextLottieElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(e) {
      return new IImageElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(e) {
      return new ISolidElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(e) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + e.w + " " + e.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", e.w), this.svgElement.setAttribute("height", e.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var t = this.globalData.defs;
      this.setupGlobalData(e, t), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = e;
      var i = createNS("clipPath"), n = createNS("rect");
      n.setAttribute("width", e.w), n.setAttribute("height", e.h), n.setAttribute("x", 0), n.setAttribute("y", 0);
      var a = createElementID();
      i.setAttribute("id", a), i.appendChild(n), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), t.appendChild(i), this.layers = e.layers, this.elements = createSizedArray(e.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(e) {
      var t = 0, i = this.layers.length;
      for (t = 0; t < i; t += 1)
        if (this.layers[t].ind === e)
          return t;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        t[e] = !0;
        var i = this.createItem(this.layers[e]);
        if (t[e] = i, getExpressionsPlugin() && (this.layers[e].ty === 0 && this.globalData.projectInterface.registerComposition(i), i.initExpressions()), this.appendElementInPos(i, e), this.layers[e].tt) {
          var n = "tp" in this.layers[e] ? this.findIndexByInd(this.layers[e].tp) : e - 1;
          if (n === -1)
            return;
          if (!this.elements[n] || this.elements[n] === !0)
            this.buildItem(n), this.addPendingElement(i);
          else {
            var a = t[n], o = a.getMatte(this.layers[e].tt);
            i.setMatte(o);
          }
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        if (e.checkParenting(), e.data.tt)
          for (var t = 0, i = this.elements.length; t < i; ) {
            if (this.elements[t] === e) {
              var n = "tp" in e.data ? this.findIndexByInd(e.data.tp) : t - 1, a = this.elements[n], o = a.getMatte(this.layers[t].tt);
              e.setMatte(o);
              break;
            }
            t += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(e) {
      if (!(this.renderedFrame === e || this.destroyed)) {
        e === null ? e = this.renderedFrame : this.renderedFrame = e, this.globalData.frameNum = e, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = e, this.globalData._mdf = !1;
        var t, i = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), t = i - 1; t >= 0; t -= 1)
          (this.completeLayers || this.elements[t]) && this.elements[t].prepareFrame(e - this.layers[t].st);
        if (this.globalData._mdf)
          for (t = 0; t < i; t += 1)
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(e, t) {
      var i = e.getBaseElement();
      if (i) {
        for (var n = 0, a; n < t; )
          this.elements[n] && this.elements[n] !== !0 && this.elements[n].getBaseElement() && (a = this.elements[n].getBaseElement()), n += 1;
        a ? this.layerElement.insertBefore(i, a) : this.layerElement.appendChild(i);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function ICompElement() {
    }
    extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(e, t, i) {
      this.initFrame(), this.initBaseData(e, t, i), this.initTransform(e, t, i), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !t.progressiveLoad) && this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(e) {
      if (this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = e / this.data.sr;
        else {
          var t = this.tm.v;
          t === this.data.op && (t = this.data.op - 1), this.renderedFrame = t;
        }
        var i, n = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), i = n - 1; i >= 0; i -= 1)
          (this.completeLayers || this.elements[i]) && (this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st), this.elements[i]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
    }, ICompElement.prototype.setElements = function(e) {
      this.elements = e;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function SVGCompElement(e, t, i) {
      this.layers = e.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, i), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : { _placeholder: !0 };
    }
    extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function SVGRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var i = "";
      if (t && t.title) {
        var n = createNS("title"), a = createElementID();
        n.setAttribute("id", a), n.textContent = t.title, this.svgElement.appendChild(n), i += a;
      }
      if (t && t.description) {
        var o = createNS("desc"), l = createElementID();
        o.setAttribute("id", l), o.textContent = t.description, this.svgElement.appendChild(o), i += " " + l;
      }
      i && this.svgElement.setAttribute("aria-labelledby", i);
      var c = createNS("defs");
      this.svgElement.appendChild(c);
      var d = createNS("g");
      this.svgElement.appendChild(d), this.layerElement = d, this.renderConfig = { preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet", imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice", contentVisibility: t && t.contentVisibility || "visible", progressiveLoad: t && t.progressiveLoad || !1, hideOnTransparent: !(t && t.hideOnTransparent === !1), viewBoxOnly: t && t.viewBoxOnly || !1, viewBoxSize: t && t.viewBoxSize || !1, className: t && t.className || "", id: t && t.id || "", focusable: t && t.focusable, filterSize: { width: t && t.filterSize && t.filterSize.width || "100%", height: t && t.filterSize && t.filterSize.height || "100%", x: t && t.filterSize && t.filterSize.x || "0%", y: t && t.filterSize && t.filterSize.y || "0%" }, width: t && t.width, height: t && t.height, runExpressions: !t || t.runExpressions === void 0 || t.runExpressions }, this.globalData = { _mdf: !1, frameNum: -1, defs: c, renderConfig: this.renderConfig }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function CVContextData() {
      this.saved = [], this.cArrPos = 0, this.cTr = new Matrix(), this.cO = 1;
      var e, t = 15;
      for (this.savedOp = createTypedArray("float32", t), e = 0; e < t; e += 1)
        this.saved[e] = createTypedArray("float32", 16);
      this._length = t;
    }
    CVContextData.prototype.duplicate = function() {
      var e = this._length * 2, t = this.savedOp;
      this.savedOp = createTypedArray("float32", e), this.savedOp.set(t);
      var i = 0;
      for (i = this._length; i < e; i += 1)
        this.saved[i] = createTypedArray("float32", 16);
      this._length = e;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.cO = 1;
    }, CVContextData.prototype.popTransform = function() {
      var e = this.saved[this.cArrPos], t, i = this.cTr.props;
      for (t = 0; t < 16; t += 1)
        i[t] = e[t];
      return e;
    }, CVContextData.prototype.popOpacity = function() {
      var e = this.savedOp[this.cArrPos];
      return this.cO = e, e;
    }, CVContextData.prototype.pop = function() {
      this.cArrPos -= 1;
      var e = this.popTransform(), t = this.popOpacity();
      return { transform: e, opacity: t };
    }, CVContextData.prototype.push = function() {
      var e = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var t, i = this.saved[this.cArrPos];
      for (t = 0; t < 16; t += 1)
        i[t] = e[t];
      this.savedOp[this.cArrPos] = this.cO, this.cArrPos += 1;
    }, CVContextData.prototype.getTransform = function() {
      return this.cTr;
    }, CVContextData.prototype.getOpacity = function() {
      return this.cO;
    }, CVContextData.prototype.setOpacity = function(e) {
      this.cO = e;
    };
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = { addTransformSequence: function(t) {
      var i, n = t.length, a = "_";
      for (i = 0; i < n; i += 1)
        a += t[i].transform.key + "_";
      var o = this.sequences[a];
      return o || (o = { transforms: [].concat(t), finalTransform: new Matrix(), _mdf: !1 }, this.sequences[a] = o, this.sequenceList.push(o)), o;
    }, processSequence: function(t, i) {
      for (var n = 0, a = t.transforms.length, o = i; n < a && !i; ) {
        if (t.transforms[n].transform.mProps._mdf) {
          o = !0;
          break;
        }
        n += 1;
      }
      if (o) {
        var l;
        for (t.finalTransform.reset(), n = a - 1; n >= 0; n -= 1)
          l = t.transforms[n].transform.mProps.v.props, t.finalTransform.transform(l[0], l[1], l[2], l[3], l[4], l[5], l[6], l[7], l[8], l[9], l[10], l[11], l[12], l[13], l[14], l[15]);
      }
      t._mdf = o;
    }, processSequences: function(t) {
      var i, n = this.sequenceList.length;
      for (i = 0; i < n; i += 1)
        this.processSequence(this.sequenceList[i], t);
    }, getNewKey: function() {
      return this.transform_key_count += 1, "_" + this.transform_key_count;
    } };
    var lumaLoader = function() {
      var t = "__lottie_element_luma_buffer", i = null, n = null, a = null;
      function o() {
        var d = createNS("svg"), u = createNS("filter"), m = createNS("feColorMatrix");
        return u.setAttribute("id", t), m.setAttribute("type", "matrix"), m.setAttribute("color-interpolation-filters", "sRGB"), m.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), u.appendChild(m), d.appendChild(u), d.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (d.style.display = "none"), d;
      }
      function l() {
        i || (a = o(), document.body.appendChild(a), i = createTag("canvas"), n = i.getContext("2d"), n.filter = "url(#" + t + ")", n.fillStyle = "rgba(0,0,0,0)", n.fillRect(0, 0, 1, 1));
      }
      function c(d) {
        return i || l(), i.width = d.width, i.height = d.height, n.filter = "url(#" + t + ")", i;
      }
      return { load: l, get: c };
    };
    function createCanvas(e, t) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(e, t);
      var i = createTag("canvas");
      return i.width = e, i.height = t, i;
    }
    var assetLoader = function() {
      return { loadLumaCanvas: lumaLoader.load, getLumaCanvas: lumaLoader.get, createCanvas };
    }();
    function CVEffects() {
    }
    CVEffects.prototype.renderFrame = function() {
    };
    function CVMaskElement(e, t) {
      this.data = e, this.element = t, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var i, n = this.masksProperties.length, a = !1;
      for (i = 0; i < n; i += 1)
        this.masksProperties[i].mode !== "n" && (a = !0), this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
      this.hasMasks = a, a && this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var e = this.element.finalTransform.mat, t = this.element.canvasContext, i, n = this.masksProperties.length, a, o, l;
        for (t.beginPath(), i = 0; i < n; i += 1)
          if (this.masksProperties[i].mode !== "n") {
            this.masksProperties[i].inv && (t.moveTo(0, 0), t.lineTo(this.element.globalData.compSize.w, 0), t.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), t.lineTo(0, this.element.globalData.compSize.h), t.lineTo(0, 0)), l = this.viewData[i].v, a = e.applyToPointArray(l.v[0][0], l.v[0][1], 0), t.moveTo(a[0], a[1]);
            var c, d = l._length;
            for (c = 1; c < d; c += 1)
              o = e.applyToTriplePoints(l.o[c - 1], l.i[c], l.v[c]), t.bezierCurveTo(o[0], o[1], o[2], o[3], o[4], o[5]);
            o = e.applyToTriplePoints(l.o[c - 1], l.i[0], l.v[0]), t.bezierCurveTo(o[0], o[1], o[2], o[3], o[4], o[5]);
          }
        this.element.globalData.renderer.save(!0), t.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    function CVBaseElement() {
    }
    var operationsMap = { 1: "source-in", 2: "source-out", 3: "source-in", 4: "source-out" };
    CVBaseElement.prototype = { createElements: function() {
    }, initRendererElement: function() {
    }, createContainerElements: function() {
      if (this.data.tt >= 1) {
        this.buffers = [];
        var t = this.globalData.canvasContext, i = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
        this.buffers.push(i);
        var n = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
        this.buffers.push(n), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
      }
      this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects();
    }, createContent: function() {
    }, setBlendMode: function() {
      var t = this.globalData;
      if (t.blendMode !== this.data.bm) {
        t.blendMode = this.data.bm;
        var i = getBlendMode(this.data.bm);
        t.canvasContext.globalCompositeOperation = i;
      }
    }, createRenderableComponents: function() {
      this.maskManager = new CVMaskElement(this.data, this);
    }, hideElement: function() {
      !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
    }, showElement: function() {
      this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
    }, clearCanvas: function(t) {
      t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
    }, prepareLayer: function() {
      if (this.data.tt >= 1) {
        var t = this.buffers[0], i = t.getContext("2d");
        this.clearCanvas(i), i.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
      }
    }, exitLayer: function() {
      if (this.data.tt >= 1) {
        var t = this.buffers[1], i = t.getContext("2d");
        this.clearCanvas(i), i.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
        var n = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
        if (n.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
          var a = assetLoader.getLumaCanvas(this.canvasContext.canvas), o = a.getContext("2d");
          o.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(a, 0, 0);
        }
        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
      }
    }, renderFrame: function(t) {
      if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !t)) {
        this.renderTransform(), this.renderRenderable(), this.setBlendMode();
        var i = this.data.ty === 0;
        this.prepareLayer(), this.globalData.renderer.save(i), this.globalData.renderer.ctxTransform(this.finalTransform.mat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v), this.renderInnerContent(), this.globalData.renderer.restore(i), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
      }
    }, destroy: function() {
      this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
    }, mHelper: new Matrix() }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(e, t, i, n) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var a = 4;
      t.ty === "rc" ? a = 5 : t.ty === "el" ? a = 6 : t.ty === "sr" && (a = 7), this.sh = ShapePropertyFactory.getShapeProp(e, t, a, e);
      var o, l = i.length, c;
      for (o = 0; o < l; o += 1)
        i[o].closed || (c = { transforms: n.addTransformSequence(i[o].transforms), trNodes: [] }, this.styledShapes.push(c), i[o].elements.push(c));
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(e, t, i) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(e, t, i);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: !1 }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(e, t) {
      var i = { data: e, type: e.ty, preTransforms: this.transformsManager.addTransformSequence(t), transforms: [], elements: [], closed: e.hd === !0 }, n = {};
      if (e.ty === "fl" || e.ty === "st" ? (n.c = PropertyFactory.getProp(this, e.c, 1, 255, this), n.c.k || (i.co = "rgb(" + bmFloor(n.c.v[0]) + "," + bmFloor(n.c.v[1]) + "," + bmFloor(n.c.v[2]) + ")")) : (e.ty === "gf" || e.ty === "gs") && (n.s = PropertyFactory.getProp(this, e.s, 1, null, this), n.e = PropertyFactory.getProp(this, e.e, 1, null, this), n.h = PropertyFactory.getProp(this, e.h || { k: 0 }, 0, 0.01, this), n.a = PropertyFactory.getProp(this, e.a || { k: 0 }, 0, degToRads, this), n.g = new GradientProperty(this, e.g, this)), n.o = PropertyFactory.getProp(this, e.o, 0, 0.01, this), e.ty === "st" || e.ty === "gs") {
        if (i.lc = lineCapEnum[e.lc || 2], i.lj = lineJoinEnum[e.lj || 2], e.lj == 1 && (i.ml = e.ml), n.w = PropertyFactory.getProp(this, e.w, 0, null, this), n.w.k || (i.wi = n.w.v), e.d) {
          var a = new DashProperty(this, e.d, "canvas", this);
          n.d = a, n.d.k || (i.da = n.d.dashArray, i.do = n.d.dashoffset[0]);
        }
      } else
        i.r = e.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(i), n.style = i, n;
    }, CVShapeElement.prototype.createGroupElement = function() {
      var e = { it: [], prevViewData: [] };
      return e;
    }, CVShapeElement.prototype.createTransformElement = function(e) {
      var t = { transform: { opacity: 1, _opMdf: !1, key: this.transformsManager.getNewKey(), op: PropertyFactory.getProp(this, e.o, 0, 0.01, this), mProps: TransformPropertyFactory.getTransformProperty(this, e, this) } };
      return t;
    }, CVShapeElement.prototype.createShapeElement = function(e) {
      var t = new CVShapeData(this, e, this.stylesList, this.transformsManager);
      return this.shapes.push(t), this.addShapeToModifiers(t), t;
    }, CVShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(e) {
      var t, i = this.stylesList.length;
      for (t = 0; t < i; t += 1)
        this.stylesList[t].closed || this.stylesList[t].transforms.push(e);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].closed || this.stylesList[e].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(e) {
      var t, i = e.length;
      for (t = 0; t < i; t += 1)
        e[t].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(e, t, i, n, a) {
      var o, l = e.length - 1, c, d, u = [], m = [], A, y, D, C = [].concat(a);
      for (o = l; o >= 0; o -= 1) {
        if (A = this.searchProcessedElement(e[o]), A ? t[o] = i[A - 1] : e[o]._shouldRender = n, e[o].ty === "fl" || e[o].ty === "st" || e[o].ty === "gf" || e[o].ty === "gs")
          A ? t[o].style.closed = !1 : t[o] = this.createStyleElement(e[o], C), u.push(t[o].style);
        else if (e[o].ty === "gr") {
          if (!A)
            t[o] = this.createGroupElement(e[o]);
          else
            for (d = t[o].it.length, c = 0; c < d; c += 1)
              t[o].prevViewData[c] = t[o].it[c];
          this.searchShapes(e[o].it, t[o].it, t[o].prevViewData, n, C);
        } else
          e[o].ty === "tr" ? (A || (D = this.createTransformElement(e[o]), t[o] = D), C.push(t[o]), this.addTransformToStyleList(t[o])) : e[o].ty === "sh" || e[o].ty === "rc" || e[o].ty === "el" || e[o].ty === "sr" ? A || (t[o] = this.createShapeElement(e[o])) : e[o].ty === "tm" || e[o].ty === "rd" || e[o].ty === "pb" || e[o].ty === "zz" || e[o].ty === "op" ? (A ? (y = t[o], y.closed = !1) : (y = ShapeModifiers.getModifier(e[o].ty), y.init(this, e[o]), t[o] = y, this.shapeModifiers.push(y)), m.push(y)) : e[o].ty === "rp" && (A ? (y = t[o], y.closed = !0) : (y = ShapeModifiers.getModifier(e[o].ty), t[o] = y, y.init(this, e, o, t), this.shapeModifiers.push(y), n = !1), m.push(y));
        this.addProcessedElement(e[o], o + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(u), l = m.length, o = 0; o < l; o += 1)
        m[o].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(e, t) {
      (e._opMdf || t.op._mdf || this._isFirstFrame) && (t.opacity = e.opacity, t.opacity *= t.op.v, t._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var e, t = this.stylesList.length, i, n, a, o, l, c, d = this.globalData.renderer, u = this.globalData.canvasContext, m, A;
      for (e = 0; e < t; e += 1)
        if (A = this.stylesList[e], m = A.type, !((m === "st" || m === "gs") && A.wi === 0 || !A.data._shouldRender || A.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
          for (d.save(), l = A.elements, m === "st" || m === "gs" ? (u.strokeStyle = m === "st" ? A.co : A.grd, u.lineWidth = A.wi, u.lineCap = A.lc, u.lineJoin = A.lj, u.miterLimit = A.ml || 0) : u.fillStyle = m === "fl" ? A.co : A.grd, d.ctxOpacity(A.coOp), m !== "st" && m !== "gs" && u.beginPath(), d.ctxTransform(A.preTransforms.finalTransform.props), n = l.length, i = 0; i < n; i += 1) {
            for ((m === "st" || m === "gs") && (u.beginPath(), A.da && (u.setLineDash(A.da), u.lineDashOffset = A.do)), c = l[i].trNodes, o = c.length, a = 0; a < o; a += 1)
              c[a].t === "m" ? u.moveTo(c[a].p[0], c[a].p[1]) : c[a].t === "c" ? u.bezierCurveTo(c[a].pts[0], c[a].pts[1], c[a].pts[2], c[a].pts[3], c[a].pts[4], c[a].pts[5]) : u.closePath();
            (m === "st" || m === "gs") && (u.stroke(), A.da && u.setLineDash(this.dashResetter));
          }
          m !== "st" && m !== "gs" && u.fill(A.r), d.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(e, t, i, n) {
      var a, o = t.length - 1, l;
      for (l = e, a = o; a >= 0; a -= 1)
        t[a].ty === "tr" ? (l = i[a].transform, this.renderShapeTransform(e, l)) : t[a].ty === "sh" || t[a].ty === "el" || t[a].ty === "rc" || t[a].ty === "sr" ? this.renderPath(t[a], i[a]) : t[a].ty === "fl" ? this.renderFill(t[a], i[a], l) : t[a].ty === "st" ? this.renderStroke(t[a], i[a], l) : t[a].ty === "gf" || t[a].ty === "gs" ? this.renderGradientFill(t[a], i[a], l) : t[a].ty === "gr" ? this.renderShape(l, t[a].it, i[a].it) : t[a].ty;
      n && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(e, t) {
      if (this._isFirstFrame || t._mdf || e.transforms._mdf) {
        var i = e.trNodes, n = t.paths, a, o, l, c = n._length;
        i.length = 0;
        var d = e.transforms.finalTransform;
        for (l = 0; l < c; l += 1) {
          var u = n.shapes[l];
          if (u && u.v) {
            for (o = u._length, a = 1; a < o; a += 1)
              a === 1 && i.push({ t: "m", p: d.applyToPointArray(u.v[0][0], u.v[0][1], 0) }), i.push({ t: "c", pts: d.applyToTriplePoints(u.o[a - 1], u.i[a], u.v[a]) });
            o === 1 && i.push({ t: "m", p: d.applyToPointArray(u.v[0][0], u.v[0][1], 0) }), u.c && o && (i.push({ t: "c", pts: d.applyToTriplePoints(u.o[a - 1], u.i[0], u.v[0]) }), i.push({ t: "z" }));
          }
        }
        e.trNodes = i;
      }
    }, CVShapeElement.prototype.renderPath = function(e, t) {
      if (e.hd !== !0 && e._shouldRender) {
        var i, n = t.styledShapes.length;
        for (i = 0; i < n; i += 1)
          this.renderStyledShape(t.styledShapes[i], t.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(e, t, i) {
      var n = t.style;
      (t.c._mdf || this._isFirstFrame) && (n.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || i._opMdf || this._isFirstFrame) && (n.coOp = t.o.v * i.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(e, t, i) {
      var n = t.style, a;
      if (!n.grd || t.g._mdf || t.s._mdf || t.e._mdf || e.t !== 1 && (t.h._mdf || t.a._mdf)) {
        var o = this.globalData.canvasContext, l = t.s.v, c = t.e.v;
        if (e.t === 1)
          a = o.createLinearGradient(l[0], l[1], c[0], c[1]);
        else {
          var d = Math.sqrt(Math.pow(l[0] - c[0], 2) + Math.pow(l[1] - c[1], 2)), u = Math.atan2(c[1] - l[1], c[0] - l[0]), m = t.h.v;
          m >= 1 ? m = 0.99 : m <= -1 && (m = -0.99);
          var A = d * m, y = Math.cos(u + t.a.v) * A + l[0], D = Math.sin(u + t.a.v) * A + l[1];
          a = o.createRadialGradient(y, D, 0, l[0], l[1], d);
        }
        var C, z = e.g.p, R = t.g.c, O = 1;
        for (C = 0; C < z; C += 1)
          t.g._hasOpacity && t.g._collapsable && (O = t.g.o[C * 2 + 1]), a.addColorStop(R[C * 4] / 100, "rgba(" + R[C * 4 + 1] + "," + R[C * 4 + 2] + "," + R[C * 4 + 3] + "," + O + ")");
        n.grd = a;
      }
      n.coOp = t.o.v * i.opacity;
    }, CVShapeElement.prototype.renderStroke = function(e, t, i) {
      var n = t.style, a = t.d;
      a && (a._mdf || this._isFirstFrame) && (n.da = a.dashArray, n.do = a.dashoffset[0]), (t.c._mdf || this._isFirstFrame) && (n.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || i._opMdf || this._isFirstFrame) && (n.coOp = t.o.v * i.opacity), (t.w._mdf || this._isFirstFrame) && (n.wi = t.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    };
    function CVTextElement(e, t, i) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = { fill: "rgba(0,0,0,0)", stroke: "rgba(0,0,0,0)", sWidth: 0, fValue: "" }, this.initElement(e, t, i);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = !1;
      e.fc ? (t = !0, this.values.fill = this.buildColor(e.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = t;
      var i = !1;
      e.sc && (i = !0, this.values.stroke = this.buildColor(e.sc), this.values.sWidth = e.sw);
      var n = this.globalData.fontManager.getFontByName(e.f), a, o, l = e.l, c = this.mHelper;
      this.stroke = i, this.values.fValue = e.finalSize + "px " + this.globalData.fontManager.getFontByName(e.f).fFamily, o = e.finalText.length;
      var d, u, m, A, y, D, C, z, R, O, $ = this.data.singleShape, k = e.tr * 1e-3 * e.finalSize, P = 0, L = 0, F = !0, B = 0;
      for (a = 0; a < o; a += 1) {
        d = this.globalData.fontManager.getCharData(e.finalText[a], n.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), u = d && d.data || {}, c.reset(), $ && l[a].n && (P = -k, L += e.yOffset, L += F ? 1 : 0, F = !1), y = u.shapes ? u.shapes[0].it : [], C = y.length, c.scale(e.finalSize / 100, e.finalSize / 100), $ && this.applyTextPropertiesToMatrix(e, c, l[a].line, P, L), R = createSizedArray(C - 1);
        var G = 0;
        for (D = 0; D < C; D += 1)
          if (y[D].ty === "sh") {
            for (A = y[D].ks.k.i.length, z = y[D].ks.k, O = [], m = 1; m < A; m += 1)
              m === 1 && O.push(c.applyToX(z.v[0][0], z.v[0][1], 0), c.applyToY(z.v[0][0], z.v[0][1], 0)), O.push(c.applyToX(z.o[m - 1][0], z.o[m - 1][1], 0), c.applyToY(z.o[m - 1][0], z.o[m - 1][1], 0), c.applyToX(z.i[m][0], z.i[m][1], 0), c.applyToY(z.i[m][0], z.i[m][1], 0), c.applyToX(z.v[m][0], z.v[m][1], 0), c.applyToY(z.v[m][0], z.v[m][1], 0));
            O.push(c.applyToX(z.o[m - 1][0], z.o[m - 1][1], 0), c.applyToY(z.o[m - 1][0], z.o[m - 1][1], 0), c.applyToX(z.i[0][0], z.i[0][1], 0), c.applyToY(z.i[0][0], z.i[0][1], 0), c.applyToX(z.v[0][0], z.v[0][1], 0), c.applyToY(z.v[0][0], z.v[0][1], 0)), R[G] = O, G += 1;
          }
        $ && (P += l[a].l, P += k), this.textSpans[B] ? this.textSpans[B].elem = R : this.textSpans[B] = { elem: R }, B += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      var e = this.canvasContext;
      e.font = this.values.fValue, e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4, this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var t, i, n, a, o, l, c = this.textAnimator.renderedLetters, d = this.textProperty.currentData.l;
      i = d.length;
      var u, m = null, A = null, y = null, D, C;
      for (t = 0; t < i; t += 1)
        if (!d[t].n) {
          if (u = c[t], u && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(u.p), this.globalData.renderer.ctxOpacity(u.o)), this.fill) {
            for (u && u.fc ? m !== u.fc && (m = u.fc, e.fillStyle = u.fc) : m !== this.values.fill && (m = this.values.fill, e.fillStyle = this.values.fill), D = this.textSpans[t].elem, a = D.length, this.globalData.canvasContext.beginPath(), n = 0; n < a; n += 1)
              for (C = D[n], l = C.length, this.globalData.canvasContext.moveTo(C[0], C[1]), o = 2; o < l; o += 6)
                this.globalData.canvasContext.bezierCurveTo(C[o], C[o + 1], C[o + 2], C[o + 3], C[o + 4], C[o + 5]);
            this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
          }
          if (this.stroke) {
            for (u && u.sw ? y !== u.sw && (y = u.sw, e.lineWidth = u.sw) : y !== this.values.sWidth && (y = this.values.sWidth, e.lineWidth = this.values.sWidth), u && u.sc ? A !== u.sc && (A = u.sc, e.strokeStyle = u.sc) : A !== this.values.stroke && (A = this.values.stroke, e.strokeStyle = this.values.stroke), D = this.textSpans[t].elem, a = D.length, this.globalData.canvasContext.beginPath(), n = 0; n < a; n += 1)
              for (C = D[n], l = C.length, this.globalData.canvasContext.moveTo(C[0], C[1]), o = 2; o < l; o += 6)
                this.globalData.canvasContext.bezierCurveTo(C[o], C[o + 1], C[o + 2], C[o + 3], C[o + 4], C[o + 5]);
            this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
          }
          u && this.globalData.renderer.restore();
        }
    };
    function CVImageElement(e, t, i) {
      this.assetData = t.getAssetData(e.refId), this.img = t.imageLoader.getAsset(this.assetData), this.initElement(e, t, i);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var e = createTag("canvas");
        e.width = this.assetData.w, e.height = this.assetData.h;
        var t = e.getContext("2d"), i = this.img.width, n = this.img.height, a = i / n, o = this.assetData.w / this.assetData.h, l, c, d = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        a > o && d === "xMidYMid slice" || a < o && d !== "xMidYMid slice" ? (c = n, l = c * o) : (l = i, c = l / o), t.drawImage(this.img, (i - l) / 2, (n - c) / 2, l, c, 0, 0, this.assetData.w, this.assetData.h), this.img = e;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    };
    function CVSolidElement(e, t, i) {
      this.initElement(e, t, i);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      var e = this.canvasContext;
      e.fillStyle = this.data.sc, e.fillRect(0, 0, this.data.sw, this.data.sh);
    };
    function CanvasRendererBase(e, t) {
      this.animationItem = e, this.renderConfig = { clearCanvas: t && t.clearCanvas !== void 0 ? t.clearCanvas : !0, context: t && t.context || null, progressiveLoad: t && t.progressiveLoad || !1, preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet", imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice", contentVisibility: t && t.contentVisibility || "visible", className: t && t.className || "", id: t && t.id || "" }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = { frameNum: -1, _mdf: !1, renderConfig: this.renderConfig, currentGlobalAlpha: -1 }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas";
    }
    extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(e) {
      return new CVShapeElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(e) {
      return new CVTextElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(e) {
      return new CVImageElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(e) {
      return new CVSolidElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(e) {
      if (!(e[0] === 1 && e[1] === 0 && e[4] === 0 && e[5] === 1 && e[12] === 0 && e[13] === 0)) {
        if (!this.renderConfig.clearCanvas) {
          this.canvasContext.transform(e[0], e[1], e[4], e[5], e[12], e[13]);
          return;
        }
        this.transformMat.cloneFromProps(e);
        var t = this.contextData.getTransform(), i = t.props;
        this.transformMat.transform(i[0], i[1], i[2], i[3], i[4], i[5], i[6], i[7], i[8], i[9], i[10], i[11], i[12], i[13], i[14], i[15]), t.cloneFromProps(this.transformMat.props);
        var n = t.props;
        this.canvasContext.setTransform(n[0], n[1], n[4], n[5], n[12], n[13]);
      }
    }, CanvasRendererBase.prototype.ctxOpacity = function(e) {
      var t = this.contextData.getOpacity();
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.globalAlpha *= e < 0 ? 0 : e, this.globalData.currentGlobalAlpha = t;
        return;
      }
      t *= e < 0 ? 0 : e, this.contextData.setOpacity(t), this.globalData.currentGlobalAlpha !== t && (this.canvasContext.globalAlpha = t, this.globalData.currentGlobalAlpha = t);
    }, CanvasRendererBase.prototype.reset = function() {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      this.contextData.reset();
    }, CanvasRendererBase.prototype.save = function(e) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.save();
        return;
      }
      e && this.canvasContext.save(), this.contextData.push();
    }, CanvasRendererBase.prototype.restore = function(e) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      e && (this.canvasContext.restore(), this.globalData.blendMode = "source-over");
      var t = this.contextData.pop(), i = t.transform, n = t.opacity;
      this.canvasContext.setTransform(i[0], i[1], i[4], i[5], i[12], i[13]), this.globalData.currentGlobalAlpha !== n && (this.canvasContext.globalAlpha = n, this.globalData.currentGlobalAlpha = n);
    }, CanvasRendererBase.prototype.configAnimation = function(e) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var t = this.animationItem.container.style;
        t.width = "100%", t.height = "100%";
        var i = "0px 0px 0px";
        t.transformOrigin = i, t.mozTransformOrigin = i, t.webkitTransformOrigin = i, t["-webkit-transform"] = i, t.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.data = e, this.layers = e.layers, this.transformCanvas = { w: e.w, h: e.h, sx: 0, sy: 0, tx: 0, ty: 0 }, this.setupGlobalData(e, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(e.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(e, t) {
      this.reset();
      var i, n;
      e ? (i = e, n = t, this.canvasContext.canvas.width = i, this.canvasContext.canvas.height = n) : (this.animationItem.wrapper && this.animationItem.container ? (i = this.animationItem.wrapper.offsetWidth, n = this.animationItem.wrapper.offsetHeight) : (i = this.canvasContext.canvas.width, n = this.canvasContext.canvas.height), this.canvasContext.canvas.width = i * this.renderConfig.dpr, this.canvasContext.canvas.height = n * this.renderConfig.dpr);
      var a, o;
      if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var l = this.renderConfig.preserveAspectRatio.split(" "), c = l[1] || "meet", d = l[0] || "xMidYMid", u = d.substr(0, 4), m = d.substr(4);
        a = i / n, o = this.transformCanvas.w / this.transformCanvas.h, o > a && c === "meet" || o < a && c === "slice" ? (this.transformCanvas.sx = i / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = n / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = n / (this.transformCanvas.h / this.renderConfig.dpr)), u === "xMid" && (o < a && c === "meet" || o > a && c === "slice") ? this.transformCanvas.tx = (i - this.transformCanvas.w * (n / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : u === "xMax" && (o < a && c === "meet" || o > a && c === "slice") ? this.transformCanvas.tx = (i - this.transformCanvas.w * (n / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, m === "YMid" && (o > a && c === "meet" || o < a && c === "slice") ? this.transformCanvas.ty = (n - this.transformCanvas.h * (i / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : m === "YMax" && (o > a && c === "meet" || o < a && c === "slice") ? this.transformCanvas.ty = (n - this.transformCanvas.h * (i / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
      } else
        this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = i / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = n / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
      var e, t = this.layers ? this.layers.length : 0;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(e, t) {
      if (!(this.renderedFrame === e && this.renderConfig.clearCanvas === !0 && !t || this.destroyed || e === -1)) {
        this.renderedFrame = e, this.globalData.frameNum = e - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || t, this.globalData.projectInterface.currentFrame = e;
        var i, n = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), i = 0; i < n; i += 1)
          (this.completeLayers || this.elements[i]) && this.elements[i].prepareFrame(e - this.layers[i].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), i = n - 1; i >= 0; i -= 1)
            (this.completeLayers || this.elements[i]) && this.elements[i].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        var i = this.createItem(this.layers[e], this, this.globalData);
        t[e] = i, i.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    };
    function CVCompElement(e, t, i) {
      this.completeLayers = !1, this.layers = e.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(e, t, i), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : { _placeholder: !0 };
    }
    extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var e = this.canvasContext;
      e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip();
      var t, i = this.layers.length;
      for (t = i - 1; t >= 0; t -= 1)
        (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var e, t = this.layers.length;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function CanvasRenderer(e, t) {
      this.animationItem = e, this.renderConfig = { clearCanvas: t && t.clearCanvas !== void 0 ? t.clearCanvas : !0, context: t && t.context || null, progressiveLoad: t && t.progressiveLoad || !1, preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet", imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice", contentVisibility: t && t.contentVisibility || "visible", className: t && t.className || "", id: t && t.id || "", runExpressions: !t || t.runExpressions === void 0 || t.runExpressions }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = { frameNum: -1, _mdf: !1, renderConfig: this.renderConfig, currentGlobalAlpha: -1 }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas";
    }
    extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function HBaseElement() {
    }
    HBaseElement.prototype = { checkBlendMode: function() {
    }, initRendererElement: function() {
      this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
    }, createContainerElements: function() {
      this.renderableEffectsManager = new CVEffects(), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
    }, renderElement: function() {
      var t = this.transformedElement ? this.transformedElement.style : {};
      if (this.finalTransform._matMdf) {
        var i = this.finalTransform.mat.toCSS();
        t.transform = i, t.webkitTransform = i;
      }
      this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
    }, renderFrame: function() {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    }, destroy: function() {
      this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
    }, createRenderableComponents: function() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
    }, addEffects: function() {
    }, setMatte: function() {
    } }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(e, t, i) {
      this.initElement(e, t, i);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var e;
      this.data.hasMask ? (e = createNS("rect"), e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (e = createTag("div"), e.style.width = this.data.sw + "px", e.style.height = this.data.sh + "px", e.style.backgroundColor = this.data.sc), this.layerElement.appendChild(e);
    };
    function HShapeElement(e, t, i) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(e, t, i), this.prevViewData = [], this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 };
    }
    extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var e;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), e = this.svgElement;
      else {
        e = createNS("svg");
        var t = this.comp.data ? this.comp.data : this.globalData.compSize;
        e.setAttribute("width", t.w), e.setAttribute("height", t.h), e.appendChild(this.shapesContainer), this.layerElement.appendChild(e);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = e;
    }, HShapeElement.prototype.getTransformedPoint = function(e, t) {
      var i, n = e.length;
      for (i = 0; i < n; i += 1)
        t = e[i].mProps.v.applyToPointArray(t[0], t[1], 0);
      return t;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(e, t) {
      var i = e.sh.v, n = e.transformers, a, o = i._length, l, c, d, u;
      if (!(o <= 1)) {
        for (a = 0; a < o - 1; a += 1)
          l = this.getTransformedPoint(n, i.v[a]), c = this.getTransformedPoint(n, i.o[a]), d = this.getTransformedPoint(n, i.i[a + 1]), u = this.getTransformedPoint(n, i.v[a + 1]), this.checkBounds(l, c, d, u, t);
        i.c && (l = this.getTransformedPoint(n, i.v[a]), c = this.getTransformedPoint(n, i.o[a]), d = this.getTransformedPoint(n, i.i[0]), u = this.getTransformedPoint(n, i.v[0]), this.checkBounds(l, c, d, u, t));
      }
    }, HShapeElement.prototype.checkBounds = function(e, t, i, n, a) {
      this.getBoundsOfCurve(e, t, i, n);
      var o = this.shapeBoundingBox;
      a.x = bmMin(o.left, a.x), a.xMax = bmMax(o.right, a.xMax), a.y = bmMin(o.top, a.y), a.yMax = bmMax(o.bottom, a.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = { left: 0, right: 0, top: 0, bottom: 0 }, HShapeElement.prototype.tempBoundingBox = { x: 0, xMax: 0, y: 0, yMax: 0, width: 0, height: 0 }, HShapeElement.prototype.getBoundsOfCurve = function(e, t, i, n) {
      for (var a = [[e[0], n[0]], [e[1], n[1]]], o, l, c, d, u, m, A, y = 0; y < 2; ++y)
        l = 6 * e[y] - 12 * t[y] + 6 * i[y], o = -3 * e[y] + 9 * t[y] - 9 * i[y] + 3 * n[y], c = 3 * t[y] - 3 * e[y], l |= 0, o |= 0, c |= 0, o === 0 && l === 0 || (o === 0 ? (d = -c / l, d > 0 && d < 1 && a[y].push(this.calculateF(d, e, t, i, n, y))) : (u = l * l - 4 * c * o, u >= 0 && (m = (-l + bmSqrt(u)) / (2 * o), m > 0 && m < 1 && a[y].push(this.calculateF(m, e, t, i, n, y)), A = (-l - bmSqrt(u)) / (2 * o), A > 0 && A < 1 && a[y].push(this.calculateF(A, e, t, i, n, y)))));
      this.shapeBoundingBox.left = bmMin.apply(null, a[0]), this.shapeBoundingBox.top = bmMin.apply(null, a[1]), this.shapeBoundingBox.right = bmMax.apply(null, a[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, a[1]);
    }, HShapeElement.prototype.calculateF = function(e, t, i, n, a, o) {
      return bmPow(1 - e, 3) * t[o] + 3 * bmPow(1 - e, 2) * e * i[o] + 3 * (1 - e) * bmPow(e, 2) * n[o] + bmPow(e, 3) * a[o];
    }, HShapeElement.prototype.calculateBoundingBox = function(e, t) {
      var i, n = e.length;
      for (i = 0; i < n; i += 1)
        e[i] && e[i].sh ? this.calculateShapeBoundingBox(e[i], t) : e[i] && e[i].it ? this.calculateBoundingBox(e[i].it, t) : e[i] && e[i].style && e[i].w && this.expandStrokeBoundingBox(e[i].w, t);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(e, t) {
      var i = 0;
      if (e.keyframes) {
        for (var n = 0; n < e.keyframes.length; n += 1) {
          var a = e.keyframes[n].s;
          a > i && (i = a);
        }
        i *= e.mult;
      } else
        i = e.v * e.mult;
      t.x -= i, t.xMax += i, t.y -= i, t.yMax += i;
    }, HShapeElement.prototype.currentBoxContains = function(e) {
      return this.currentBBox.x <= e.x && this.currentBBox.y <= e.y && this.currentBBox.width + this.currentBBox.x >= e.x + e.width && this.currentBBox.height + this.currentBBox.y >= e.y + e.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var e = this.tempBoundingBox, t = 999999;
        if (e.x = t, e.xMax = -t, e.y = t, e.yMax = -t, this.calculateBoundingBox(this.itemsData, e), e.width = e.xMax < e.x ? 0 : e.xMax - e.x, e.height = e.yMax < e.y ? 0 : e.yMax - e.y, this.currentBoxContains(e))
          return;
        var i = !1;
        if (this.currentBBox.w !== e.width && (this.currentBBox.w = e.width, this.shapeCont.setAttribute("width", e.width), i = !0), this.currentBBox.h !== e.height && (this.currentBBox.h = e.height, this.shapeCont.setAttribute("height", e.height), i = !0), i || this.currentBBox.x !== e.x || this.currentBBox.y !== e.y) {
          this.currentBBox.w = e.width, this.currentBBox.h = e.height, this.currentBBox.x = e.x, this.currentBBox.y = e.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var n = this.shapeCont.style, a = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          n.transform = a, n.webkitTransform = a;
        }
      }
    };
    function HTextElement(e, t, i) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }, this.renderType = "svg", this.isMasked = !1, this.initElement(e, t, i);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var e = createNS("g");
        this.maskedElement.appendChild(e), this.innerElem = e;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = this.innerElem.style, i = e.fc ? this.buildColor(e.fc) : "rgba(0,0,0,0)";
      t.fill = i, t.color = i, e.sc && (t.stroke = this.buildColor(e.sc), t.strokeWidth = e.sw + "px");
      var n = this.globalData.fontManager.getFontByName(e.f);
      if (!this.globalData.fontManager.chars)
        if (t.fontSize = e.finalSize + "px", t.lineHeight = e.finalSize + "px", n.fClass)
          this.innerElem.className = n.fClass;
        else {
          t.fontFamily = n.fFamily;
          var a = e.fWeight, o = e.fStyle;
          t.fontStyle = o, t.fontWeight = a;
        }
      var l, c, d = e.l;
      c = d.length;
      var u, m, A, y = this.mHelper, D, C = "", z = 0;
      for (l = 0; l < c; l += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[z] ? u = this.textPaths[z] : (u = createNS("path"), u.setAttribute("stroke-linecap", lineCapEnum[1]), u.setAttribute("stroke-linejoin", lineJoinEnum[2]), u.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[z] ? (m = this.textSpans[z], A = m.children[0]) : (m = createTag("div"), m.style.lineHeight = 0, A = createNS("svg"), A.appendChild(u), styleDiv(m)))) : this.isMasked ? u = this.textPaths[z] ? this.textPaths[z] : createNS("text") : this.textSpans[z] ? (m = this.textSpans[z], u = this.textPaths[z]) : (m = createTag("span"), styleDiv(m), u = createTag("span"), styleDiv(u), m.appendChild(u)), this.globalData.fontManager.chars) {
          var R = this.globalData.fontManager.getCharData(e.finalText[l], n.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), O;
          if (R ? O = R.data : O = null, y.reset(), O && O.shapes && O.shapes.length && (D = O.shapes[0].it, y.scale(e.finalSize / 100, e.finalSize / 100), C = this.createPathShape(y, D), u.setAttribute("d", C)), this.isMasked)
            this.innerElem.appendChild(u);
          else {
            if (this.innerElem.appendChild(m), O && O.shapes) {
              document.body.appendChild(A);
              var $ = A.getBBox();
              A.setAttribute("width", $.width + 2), A.setAttribute("height", $.height + 2), A.setAttribute("viewBox", $.x - 1 + " " + ($.y - 1) + " " + ($.width + 2) + " " + ($.height + 2));
              var k = A.style, P = "translate(" + ($.x - 1) + "px," + ($.y - 1) + "px)";
              k.transform = P, k.webkitTransform = P, d[l].yOffset = $.y - 1;
            } else
              A.setAttribute("width", 1), A.setAttribute("height", 1);
            m.appendChild(A);
          }
        } else if (u.textContent = d[l].val, u.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(u);
        else {
          this.innerElem.appendChild(m);
          var L = u.style, F = "translate3d(0," + -e.finalSize / 1.2 + "px,0)";
          L.transform = F, L.webkitTransform = F;
        }
        this.isMasked ? this.textSpans[z] = u : this.textSpans[z] = m, this.textSpans[z].style.display = "block", this.textPaths[z] = u, z += 1;
      }
      for (; z < this.textSpans.length; )
        this.textSpans[z].style.display = "none", z += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      var e;
      if (this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), e = this.svgElement.style;
          var t = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          e.transform = t, e.webkitTransform = t;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
        var i, n, a = 0, o = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
        n = l.length;
        var c, d, u;
        for (i = 0; i < n; i += 1)
          l[i].n ? a += 1 : (d = this.textSpans[i], u = this.textPaths[i], c = o[a], a += 1, c._mdf.m && (this.isMasked ? d.setAttribute("transform", c.m) : (d.style.webkitTransform = c.m, d.style.transform = c.m)), d.style.opacity = c.o, c.sw && c._mdf.sw && u.setAttribute("stroke-width", c.sw), c.sc && c._mdf.sc && u.setAttribute("stroke", c.sc), c.fc && c._mdf.fc && (u.setAttribute("fill", c.fc), u.style.color = c.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var m = this.innerElem.getBBox();
          this.currentBBox.w !== m.width && (this.currentBBox.w = m.width, this.svgElement.setAttribute("width", m.width)), this.currentBBox.h !== m.height && (this.currentBBox.h = m.height, this.svgElement.setAttribute("height", m.height));
          var A = 1;
          if (this.currentBBox.w !== m.width + A * 2 || this.currentBBox.h !== m.height + A * 2 || this.currentBBox.x !== m.x - A || this.currentBBox.y !== m.y - A) {
            this.currentBBox.w = m.width + A * 2, this.currentBBox.h = m.height + A * 2, this.currentBBox.x = m.x - A, this.currentBBox.y = m.y - A, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), e = this.svgElement.style;
            var y = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            e.transform = y, e.webkitTransform = y;
          }
        }
      }
    };
    function HCameraElement(e, t, i) {
      this.initFrame(), this.initBaseData(e, t, i), this.initHierarchy();
      var n = PropertyFactory.getProp;
      if (this.pe = n(this, e.pe, 0, 0, this), e.ks.p.s ? (this.px = n(this, e.ks.p.x, 1, 0, this), this.py = n(this, e.ks.p.y, 1, 0, this), this.pz = n(this, e.ks.p.z, 1, 0, this)) : this.p = n(this, e.ks.p, 1, 0, this), e.ks.a && (this.a = n(this, e.ks.a, 1, 0, this)), e.ks.or.k.length && e.ks.or.k[0].to) {
        var a, o = e.ks.or.k.length;
        for (a = 0; a < o; a += 1)
          e.ks.or.k[a].to = null, e.ks.or.k[a].ti = null;
      }
      this.or = n(this, e.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = n(this, e.ks.rx, 0, degToRads, this), this.ry = n(this, e.ks.ry, 0, degToRads, this), this.rz = n(this, e.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = { mProp: this };
    }
    extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var e, t = this.comp.threeDElements.length, i, n, a;
      for (e = 0; e < t; e += 1)
        if (i = this.comp.threeDElements[e], i.type === "3d") {
          n = i.perspectiveElem.style, a = i.container.style;
          var o = this.pe.v + "px", l = "0px 0px 0px", c = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          n.perspective = o, n.webkitPerspective = o, a.transformOrigin = l, a.mozTransformOrigin = l, a.webkitTransformOrigin = l, n.transform = c, n.webkitTransform = c;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var e = this._isFirstFrame, t, i;
      if (this.hierarchy)
        for (i = this.hierarchy.length, t = 0; t < i; t += 1)
          e = this.hierarchy[t].finalTransform.mProp._mdf || e;
      if (e || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (i = this.hierarchy.length - 1, t = i; t >= 0; t -= 1) {
            var n = this.hierarchy[t].finalTransform.mProp;
            this.mat.translate(-n.p.v[0], -n.p.v[1], n.p.v[2]), this.mat.rotateX(-n.or.v[0]).rotateY(-n.or.v[1]).rotateZ(n.or.v[2]), this.mat.rotateX(-n.rx.v).rotateY(-n.ry.v).rotateZ(n.rz.v), this.mat.scale(1 / n.s.v[0], 1 / n.s.v[1], 1 / n.s.v[2]), this.mat.translate(n.a.v[0], n.a.v[1], n.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var a;
          this.p ? a = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : a = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var o = Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2)), l = [a[0] / o, a[1] / o, a[2] / o], c = Math.sqrt(l[2] * l[2] + l[0] * l[0]), d = Math.atan2(l[1], c), u = Math.atan2(l[0], -l[2]);
          this.mat.rotateY(u).rotateX(-d);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var m = !this._prevMat.equals(this.mat);
        if ((m || this.pe._mdf) && this.comp.threeDElements) {
          i = this.comp.threeDElements.length;
          var A, y, D;
          for (t = 0; t < i; t += 1)
            if (A = this.comp.threeDElements[t], A.type === "3d") {
              if (m) {
                var C = this.mat.toCSS();
                D = A.container.style, D.transform = C, D.webkitTransform = C;
              }
              this.pe._mdf && (y = A.perspectiveElem.style, y.perspective = this.pe.v + "px", y.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    };
    function HImageElement(e, t, i) {
      this.assetData = t.getAssetData(e.refId), this.initElement(e, t, i);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData), t = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(t), t.crossOrigin = "anonymous", t.src = e, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = { className: t && t.className || "", imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice", hideOnTransparent: !(t && t.hideOnTransparent === !1), filterSize: { width: t && t.filterSize && t.filterSize.width || "400%", height: t && t.filterSize && t.filterSize.height || "400%", x: t && t.filterSize && t.filterSize.x || "-100%", y: t && t.filterSize && t.filterSize.y || "-100%" } }, this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, HybridRendererBase.prototype.appendElementInPos = function(e, t) {
      var i = e.getBaseElement();
      if (i) {
        var n = this.layers[t];
        if (!n.ddd || !this.supports3d)
          if (this.threeDElements)
            this.addTo3dContainer(i, t);
          else {
            for (var a = 0, o, l, c; a < t; )
              this.elements[a] && this.elements[a] !== !0 && this.elements[a].getBaseElement && (l = this.elements[a], c = this.layers[a].ddd ? this.getThreeDContainerByPos(a) : l.getBaseElement(), o = c || o), a += 1;
            o ? (!n.ddd || !this.supports3d) && this.layerElement.insertBefore(i, o) : (!n.ddd || !this.supports3d) && this.layerElement.appendChild(i);
          }
        else
          this.addTo3dContainer(i, t);
      }
    }, HybridRendererBase.prototype.createShape = function(e) {
      return this.supports3d ? new HShapeElement(e, this.globalData, this) : new SVGShapeElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(e) {
      return this.supports3d ? new HTextElement(e, this.globalData, this) : new SVGTextLottieElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(e) {
      return this.camera = new HCameraElement(e, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(e) {
      return this.supports3d ? new HImageElement(e, this.globalData, this) : new IImageElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(e) {
      return this.supports3d ? new HSolidElement(e, this.globalData, this) : new ISolidElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(e) {
      for (var t = 0, i = this.threeDElements.length; t < i; ) {
        if (this.threeDElements[t].startPos <= e && this.threeDElements[t].endPos >= e)
          return this.threeDElements[t].perspectiveElem;
        t += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(e, t) {
      var i = createTag("div"), n, a;
      styleDiv(i);
      var o = createTag("div");
      if (styleDiv(o), t === "3d") {
        n = i.style, n.width = this.globalData.compSize.w + "px", n.height = this.globalData.compSize.h + "px";
        var l = "50% 50%";
        n.webkitTransformOrigin = l, n.mozTransformOrigin = l, n.transformOrigin = l, a = o.style;
        var c = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        a.transform = c, a.webkitTransform = c;
      }
      i.appendChild(o);
      var d = { container: o, perspectiveElem: i, startPos: e, endPos: e, type: t };
      return this.threeDElements.push(d), d;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var e, t = this.layers.length, i, n = "";
      for (e = 0; e < t; e += 1)
        this.layers[e].ddd && this.layers[e].ty !== 3 ? (n !== "3d" && (n = "3d", i = this.createThreeDContainer(e, "3d")), i.endPos = Math.max(i.endPos, e)) : (n !== "2d" && (n = "2d", i = this.createThreeDContainer(e, "2d")), i.endPos = Math.max(i.endPos, e));
      for (t = this.threeDElements.length, e = t - 1; e >= 0; e -= 1)
        this.resizerElem.appendChild(this.threeDElements[e].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(e, t) {
      for (var i = 0, n = this.threeDElements.length; i < n; ) {
        if (t <= this.threeDElements[i].endPos) {
          for (var a = this.threeDElements[i].startPos, o; a < t; )
            this.elements[a] && this.elements[a].getBaseElement && (o = this.elements[a].getBaseElement()), a += 1;
          o ? this.threeDElements[i].container.insertBefore(e, o) : this.threeDElements[i].container.appendChild(e);
          break;
        }
        i += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(e) {
      var t = createTag("div"), i = this.animationItem.wrapper, n = t.style;
      n.width = e.w + "px", n.height = e.h + "px", this.resizerElem = t, styleDiv(t), n.transformStyle = "flat", n.mozTransformStyle = "flat", n.webkitTransformStyle = "flat", this.renderConfig.className && t.setAttribute("class", this.renderConfig.className), i.appendChild(t), n.overflow = "hidden";
      var a = createNS("svg");
      a.setAttribute("width", "1"), a.setAttribute("height", "1"), styleDiv(a), this.resizerElem.appendChild(a);
      var o = createNS("defs");
      a.appendChild(o), this.data = e, this.setupGlobalData(e, a), this.globalData.defs = o, this.layers = e.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var e = this.animationItem.wrapper.offsetWidth, t = this.animationItem.wrapper.offsetHeight, i = e / t, n = this.globalData.compSize.w / this.globalData.compSize.h, a, o, l, c;
      n > i ? (a = e / this.globalData.compSize.w, o = e / this.globalData.compSize.w, l = 0, c = (t - this.globalData.compSize.h * (e / this.globalData.compSize.w)) / 2) : (a = t / this.globalData.compSize.h, o = t / this.globalData.compSize.h, l = (e - this.globalData.compSize.w * (t / this.globalData.compSize.h)) / 2, c = 0);
      var d = this.resizerElem.style;
      d.webkitTransform = "matrix3d(" + a + ",0,0,0,0," + o + ",0,0,0,0,1,0," + l + "," + c + ",0,1)", d.transform = d.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var e = this.globalData.compSize.w, t = this.globalData.compSize.h, i, n = this.threeDElements.length;
        for (i = 0; i < n; i += 1) {
          var a = this.threeDElements[i].perspectiveElem.style;
          a.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2)) + "px", a.perspective = a.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(e) {
      var t, i = e.length, n = createTag("div");
      for (t = 0; t < i; t += 1)
        if (e[t].xt) {
          var a = this.createComp(e[t], n, this.globalData.comp, null);
          a.initExpressions(), this.globalData.projectInterface.registerComposition(a);
        }
    };
    function HCompElement(e, t, i) {
      this.layers = e.layers, this.supports3d = !e.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, i), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : { _placeholder: !0 };
    }
    extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(e, t) {
      for (var i = 0, n; i < t; )
        this.elements[i] && this.elements[i].getBaseElement && (n = this.elements[i].getBaseElement()), i += 1;
      n ? this.layerElement.insertBefore(e, n) : this.layerElement.appendChild(e);
    }, HCompElement.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    function HybridRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = { className: t && t.className || "", imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice", hideOnTransparent: !(t && t.hideOnTransparent === !1), filterSize: { width: t && t.filterSize && t.filterSize.width || "400%", height: t && t.filterSize && t.filterSize.height || "400%", x: t && t.filterSize && t.filterSize.x || "-100%", y: t && t.filterSize && t.filterSize.y || "-100%" }, runExpressions: !t || t.runExpressions === void 0 || t.runExpressions }, this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    var CompExpressionInterface = function() {
      return function(e) {
        function t(i) {
          for (var n = 0, a = e.layers.length; n < a; ) {
            if (e.layers[n].nm === i || e.layers[n].ind === i)
              return e.elements[n].layerInterface;
            n += 1;
          }
          return null;
        }
        return Object.defineProperty(t, "_name", { value: e.data.nm }), t.layer = t, t.pixelAspect = 1, t.height = e.data.h || e.globalData.compSize.h, t.width = e.data.w || e.globalData.compSize.w, t.pixelAspect = 1, t.frameDuration = 1 / e.globalData.frameRate, t.displayStartTime = 0, t.numLayers = e.layers.length, t;
      };
    }(), Expressions = function() {
      var e = {};
      e.initExpressions = t;
      function t(i) {
        var n = 0, a = [];
        function o() {
          n += 1;
        }
        function l() {
          n -= 1, n === 0 && d();
        }
        function c(u) {
          a.indexOf(u) === -1 && a.push(u);
        }
        function d() {
          var u, m = a.length;
          for (u = 0; u < m; u += 1)
            a[u].release();
          a.length = 0;
        }
        i.renderer.compInterface = CompExpressionInterface(i.renderer), i.renderer.globalData.projectInterface.registerComposition(i.renderer), i.renderer.globalData.pushExpression = o, i.renderer.globalData.popExpression = l, i.renderer.globalData.registerExpressionProperty = c;
      }
      return e;
    }(), MaskManagerInterface = function() {
      function e(i, n) {
        this._mask = i, this._data = n;
      }
      Object.defineProperty(e.prototype, "maskPath", { get: function() {
        return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
      } }), Object.defineProperty(e.prototype, "maskOpacity", { get: function() {
        return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
      } });
      var t = function(n) {
        var a = createSizedArray(n.viewData.length), o, l = n.viewData.length;
        for (o = 0; o < l; o += 1)
          a[o] = new e(n.viewData[o], n.masksProperties[o]);
        var c = function(u) {
          for (o = 0; o < l; ) {
            if (n.masksProperties[o].nm === u)
              return a[o];
            o += 1;
          }
          return null;
        };
        return c;
      };
      return t;
    }(), ExpressionPropertyInterface = function() {
      var e = { pv: 0, v: 0, mult: 1 }, t = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
      function i(l, c, d) {
        Object.defineProperty(l, "velocity", { get: function() {
          return c.getVelocityAtTime(c.comp.currentFrame);
        } }), l.numKeys = c.keyframes ? c.keyframes.length : 0, l.key = function(u) {
          if (!l.numKeys)
            return 0;
          var m = "";
          "s" in c.keyframes[u - 1] ? m = c.keyframes[u - 1].s : "e" in c.keyframes[u - 2] ? m = c.keyframes[u - 2].e : m = c.keyframes[u - 2].s;
          var A = d === "unidimensional" ? new Number(m) : Object.assign({}, m);
          return A.time = c.keyframes[u - 1].t / c.elem.comp.globalData.frameRate, A.value = d === "unidimensional" ? m[0] : m, A;
        }, l.valueAtTime = c.getValueAtTime, l.speedAtTime = c.getSpeedAtTime, l.velocityAtTime = c.getVelocityAtTime, l.propertyGroup = c.propertyGroup;
      }
      function n(l) {
        (!l || !("pv" in l)) && (l = e);
        var c = 1 / l.mult, d = l.pv * c, u = new Number(d);
        return u.value = d, i(u, l, "unidimensional"), function() {
          return l.k && l.getValue(), d = l.v * c, u.value !== d && (u = new Number(d), u.value = d, i(u, l, "unidimensional")), u;
        };
      }
      function a(l) {
        (!l || !("pv" in l)) && (l = t);
        var c = 1 / l.mult, d = l.data && l.data.l || l.pv.length, u = createTypedArray("float32", d), m = createTypedArray("float32", d);
        return u.value = m, i(u, l, "multidimensional"), function() {
          l.k && l.getValue();
          for (var A = 0; A < d; A += 1)
            m[A] = l.v[A] * c, u[A] = m[A];
          return u;
        };
      }
      function o() {
        return e;
      }
      return function(l) {
        return l ? l.propType === "unidimensional" ? n(l) : a(l) : o;
      };
    }(), TransformExpressionInterface = function() {
      return function(e) {
        function t(l) {
          switch (l) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return t.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return t.rotation;
            case "ADBE Rotate X":
              return t.xRotation;
            case "ADBE Rotate Y":
              return t.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return t.position;
            case "ADBE Position_0":
              return t.xPosition;
            case "ADBE Position_1":
              return t.yPosition;
            case "ADBE Position_2":
              return t.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return t.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return t.opacity;
            default:
              return null;
          }
        }
        Object.defineProperty(t, "rotation", { get: ExpressionPropertyInterface(e.r || e.rz) }), Object.defineProperty(t, "zRotation", { get: ExpressionPropertyInterface(e.rz || e.r) }), Object.defineProperty(t, "xRotation", { get: ExpressionPropertyInterface(e.rx) }), Object.defineProperty(t, "yRotation", { get: ExpressionPropertyInterface(e.ry) }), Object.defineProperty(t, "scale", { get: ExpressionPropertyInterface(e.s) });
        var i, n, a, o;
        return e.p ? o = ExpressionPropertyInterface(e.p) : (i = ExpressionPropertyInterface(e.px), n = ExpressionPropertyInterface(e.py), e.pz && (a = ExpressionPropertyInterface(e.pz))), Object.defineProperty(t, "position", { get: function() {
          return e.p ? o() : [i(), n(), a ? a() : 0];
        } }), Object.defineProperty(t, "xPosition", { get: ExpressionPropertyInterface(e.px) }), Object.defineProperty(t, "yPosition", { get: ExpressionPropertyInterface(e.py) }), Object.defineProperty(t, "zPosition", { get: ExpressionPropertyInterface(e.pz) }), Object.defineProperty(t, "anchorPoint", { get: ExpressionPropertyInterface(e.a) }), Object.defineProperty(t, "opacity", { get: ExpressionPropertyInterface(e.o) }), Object.defineProperty(t, "skew", { get: ExpressionPropertyInterface(e.sk) }), Object.defineProperty(t, "skewAxis", { get: ExpressionPropertyInterface(e.sa) }), Object.defineProperty(t, "orientation", { get: ExpressionPropertyInterface(e.or) }), t;
      };
    }(), LayerExpressionInterface = function() {
      function e(u) {
        var m = new Matrix();
        if (u !== void 0) {
          var A = this._elem.finalTransform.mProp.getValueAtTime(u);
          A.clone(m);
        } else {
          var y = this._elem.finalTransform.mProp;
          y.applyToMatrix(m);
        }
        return m;
      }
      function t(u, m) {
        var A = this.getMatrix(m);
        return A.props[12] = 0, A.props[13] = 0, A.props[14] = 0, this.applyPoint(A, u);
      }
      function i(u, m) {
        var A = this.getMatrix(m);
        return this.applyPoint(A, u);
      }
      function n(u, m) {
        var A = this.getMatrix(m);
        return A.props[12] = 0, A.props[13] = 0, A.props[14] = 0, this.invertPoint(A, u);
      }
      function a(u, m) {
        var A = this.getMatrix(m);
        return this.invertPoint(A, u);
      }
      function o(u, m) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var A, y = this._elem.hierarchy.length;
          for (A = 0; A < y; A += 1)
            this._elem.hierarchy[A].finalTransform.mProp.applyToMatrix(u);
        }
        return u.applyToPointArray(m[0], m[1], m[2] || 0);
      }
      function l(u, m) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var A, y = this._elem.hierarchy.length;
          for (A = 0; A < y; A += 1)
            this._elem.hierarchy[A].finalTransform.mProp.applyToMatrix(u);
        }
        return u.inversePoint(m);
      }
      function c(u) {
        var m = new Matrix();
        if (m.reset(), this._elem.finalTransform.mProp.applyToMatrix(m), this._elem.hierarchy && this._elem.hierarchy.length) {
          var A, y = this._elem.hierarchy.length;
          for (A = 0; A < y; A += 1)
            this._elem.hierarchy[A].finalTransform.mProp.applyToMatrix(m);
          return m.inversePoint(u);
        }
        return m.inversePoint(u);
      }
      function d() {
        return [1, 1, 1, 1];
      }
      return function(u) {
        var m;
        function A(z) {
          D.mask = new MaskManagerInterface(z, u);
        }
        function y(z) {
          D.effect = z;
        }
        function D(z) {
          switch (z) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return D.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return m;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return D.effect;
            case "ADBE Text Properties":
              return D.textInterface;
            default:
              return null;
          }
        }
        D.getMatrix = e, D.invertPoint = l, D.applyPoint = o, D.toWorld = i, D.toWorldVec = t, D.fromWorld = a, D.fromWorldVec = n, D.toComp = i, D.fromComp = c, D.sampleImage = d, D.sourceRectAtTime = u.sourceRectAtTime.bind(u), D._elem = u, m = TransformExpressionInterface(u.finalTransform.mProp);
        var C = getDescriptor(m, "anchorPoint");
        return Object.defineProperties(D, { hasParent: { get: function() {
          return u.hierarchy.length;
        } }, parent: { get: function() {
          return u.hierarchy[0].layerInterface;
        } }, rotation: getDescriptor(m, "rotation"), scale: getDescriptor(m, "scale"), position: getDescriptor(m, "position"), opacity: getDescriptor(m, "opacity"), anchorPoint: C, anchor_point: C, transform: { get: function() {
          return m;
        } }, active: { get: function() {
          return u.isInRange;
        } } }), D.startTime = u.data.st, D.index = u.data.ind, D.source = u.data.refId, D.height = u.data.ty === 0 ? u.data.h : 100, D.width = u.data.ty === 0 ? u.data.w : 100, D.inPoint = u.data.ip / u.comp.globalData.frameRate, D.outPoint = u.data.op / u.comp.globalData.frameRate, D._name = u.data.nm, D.registerMaskInterface = A, D.registerEffectsInterface = y, D;
      };
    }(), propertyGroupFactory = function() {
      return function(e, t) {
        return function(i) {
          return i = i === void 0 ? 1 : i, i <= 0 ? e : t(i - 1);
        };
      };
    }(), PropertyInterface = function() {
      return function(e, t) {
        var i = { _name: e };
        function n(a) {
          return a = a === void 0 ? 1 : a, a <= 0 ? i : t(a - 1);
        }
        return n;
      };
    }(), EffectsExpressionInterface = function() {
      var e = { createEffectsInterface: t };
      function t(a, o) {
        if (a.effectsManager) {
          var l = [], c = a.data.ef, d, u = a.effectsManager.effectElements.length;
          for (d = 0; d < u; d += 1)
            l.push(i(c[d], a.effectsManager.effectElements[d], o, a));
          var m = a.data.ef || [], A = function(D) {
            for (d = 0, u = m.length; d < u; ) {
              if (D === m[d].nm || D === m[d].mn || D === m[d].ix)
                return l[d];
              d += 1;
            }
            return null;
          };
          return Object.defineProperty(A, "numProperties", { get: function() {
            return m.length;
          } }), A;
        }
        return null;
      }
      function i(a, o, l, c) {
        function d(D) {
          for (var C = a.ef, z = 0, R = C.length; z < R; ) {
            if (D === C[z].nm || D === C[z].mn || D === C[z].ix)
              return C[z].ty === 5 ? m[z] : m[z]();
            z += 1;
          }
          throw new Error();
        }
        var u = propertyGroupFactory(d, l), m = [], A, y = a.ef.length;
        for (A = 0; A < y; A += 1)
          a.ef[A].ty === 5 ? m.push(i(a.ef[A], o.effectElements[A], o.effectElements[A].propertyGroup, c)) : m.push(n(o.effectElements[A], a.ef[A].ty, c, u));
        return a.mn === "ADBE Color Control" && Object.defineProperty(d, "color", { get: function() {
          return m[0]();
        } }), Object.defineProperties(d, { numProperties: { get: function() {
          return a.np;
        } }, _name: { value: a.nm }, propertyGroup: { value: u } }), d.enabled = a.en !== 0, d.active = d.enabled, d;
      }
      function n(a, o, l, c) {
        var d = ExpressionPropertyInterface(a.p);
        function u() {
          return o === 10 ? l.comp.compInterface(a.p.v) : d();
        }
        return a.p.setGroupProperty && a.p.setGroupProperty(PropertyInterface("", c)), u;
      }
      return e;
    }(), ShapePathInterface = function() {
      return function(t, i, n) {
        var a = i.sh;
        function o(c) {
          return c === "Shape" || c === "shape" || c === "Path" || c === "path" || c === "ADBE Vector Shape" || c === 2 ? o.path : null;
        }
        var l = propertyGroupFactory(o, n);
        return a.setGroupProperty(PropertyInterface("Path", l)), Object.defineProperties(o, { path: { get: function() {
          return a.k && a.getValue(), a;
        } }, shape: { get: function() {
          return a.k && a.getValue(), a;
        } }, _name: { value: t.nm }, ix: { value: t.ix }, propertyIndex: { value: t.ix }, mn: { value: t.mn }, propertyGroup: { value: n } }), o;
      };
    }(), ShapeExpressionInterface = function() {
      function e(C, z, R) {
        var O = [], $, k = C ? C.length : 0;
        for ($ = 0; $ < k; $ += 1)
          C[$].ty === "gr" ? O.push(i(C[$], z[$], R)) : C[$].ty === "fl" ? O.push(n(C[$], z[$], R)) : C[$].ty === "st" ? O.push(l(C[$], z[$], R)) : C[$].ty === "tm" ? O.push(c(C[$], z[$], R)) : C[$].ty === "tr" || (C[$].ty === "el" ? O.push(u(C[$], z[$], R)) : C[$].ty === "sr" ? O.push(m(C[$], z[$], R)) : C[$].ty === "sh" ? O.push(ShapePathInterface(C[$], z[$], R)) : C[$].ty === "rc" ? O.push(A(C[$], z[$], R)) : C[$].ty === "rd" ? O.push(y(C[$], z[$], R)) : C[$].ty === "rp" ? O.push(D(C[$], z[$], R)) : C[$].ty === "gf" ? O.push(a(C[$], z[$], R)) : O.push(o(C[$], z[$])));
        return O;
      }
      function t(C, z, R) {
        var O, $ = function(L) {
          for (var F = 0, B = O.length; F < B; ) {
            if (O[F]._name === L || O[F].mn === L || O[F].propertyIndex === L || O[F].ix === L || O[F].ind === L)
              return O[F];
            F += 1;
          }
          return typeof L == "number" ? O[L - 1] : null;
        };
        $.propertyGroup = propertyGroupFactory($, R), O = e(C.it, z.it, $.propertyGroup), $.numProperties = O.length;
        var k = d(C.it[C.it.length - 1], z.it[z.it.length - 1], $.propertyGroup);
        return $.transform = k, $.propertyIndex = C.cix, $._name = C.nm, $;
      }
      function i(C, z, R) {
        var O = function(L) {
          switch (L) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return O.content;
            default:
              return O.transform;
          }
        };
        O.propertyGroup = propertyGroupFactory(O, R);
        var $ = t(C, z, O.propertyGroup), k = d(C.it[C.it.length - 1], z.it[z.it.length - 1], O.propertyGroup);
        return O.content = $, O.transform = k, Object.defineProperty(O, "_name", { get: function() {
          return C.nm;
        } }), O.numProperties = C.np, O.propertyIndex = C.ix, O.nm = C.nm, O.mn = C.mn, O;
      }
      function n(C, z, R) {
        function O($) {
          return $ === "Color" || $ === "color" ? O.color : $ === "Opacity" || $ === "opacity" ? O.opacity : null;
        }
        return Object.defineProperties(O, { color: { get: ExpressionPropertyInterface(z.c) }, opacity: { get: ExpressionPropertyInterface(z.o) }, _name: { value: C.nm }, mn: { value: C.mn } }), z.c.setGroupProperty(PropertyInterface("Color", R)), z.o.setGroupProperty(PropertyInterface("Opacity", R)), O;
      }
      function a(C, z, R) {
        function O($) {
          return $ === "Start Point" || $ === "start point" ? O.startPoint : $ === "End Point" || $ === "end point" ? O.endPoint : $ === "Opacity" || $ === "opacity" ? O.opacity : null;
        }
        return Object.defineProperties(O, { startPoint: { get: ExpressionPropertyInterface(z.s) }, endPoint: { get: ExpressionPropertyInterface(z.e) }, opacity: { get: ExpressionPropertyInterface(z.o) }, type: { get: function() {
          return "a";
        } }, _name: { value: C.nm }, mn: { value: C.mn } }), z.s.setGroupProperty(PropertyInterface("Start Point", R)), z.e.setGroupProperty(PropertyInterface("End Point", R)), z.o.setGroupProperty(PropertyInterface("Opacity", R)), O;
      }
      function o() {
        function C() {
          return null;
        }
        return C;
      }
      function l(C, z, R) {
        var O = propertyGroupFactory(B, R), $ = propertyGroupFactory(F, O);
        function k(G) {
          Object.defineProperty(F, C.d[G].nm, { get: ExpressionPropertyInterface(z.d.dataProps[G].p) });
        }
        var P, L = C.d ? C.d.length : 0, F = {};
        for (P = 0; P < L; P += 1)
          k(P), z.d.dataProps[P].p.setGroupProperty($);
        function B(G) {
          return G === "Color" || G === "color" ? B.color : G === "Opacity" || G === "opacity" ? B.opacity : G === "Stroke Width" || G === "stroke width" ? B.strokeWidth : null;
        }
        return Object.defineProperties(B, { color: { get: ExpressionPropertyInterface(z.c) }, opacity: { get: ExpressionPropertyInterface(z.o) }, strokeWidth: { get: ExpressionPropertyInterface(z.w) }, dash: { get: function() {
          return F;
        } }, _name: { value: C.nm }, mn: { value: C.mn } }), z.c.setGroupProperty(PropertyInterface("Color", O)), z.o.setGroupProperty(PropertyInterface("Opacity", O)), z.w.setGroupProperty(PropertyInterface("Stroke Width", O)), B;
      }
      function c(C, z, R) {
        function O(k) {
          return k === C.e.ix || k === "End" || k === "end" ? O.end : k === C.s.ix ? O.start : k === C.o.ix ? O.offset : null;
        }
        var $ = propertyGroupFactory(O, R);
        return O.propertyIndex = C.ix, z.s.setGroupProperty(PropertyInterface("Start", $)), z.e.setGroupProperty(PropertyInterface("End", $)), z.o.setGroupProperty(PropertyInterface("Offset", $)), O.propertyIndex = C.ix, O.propertyGroup = R, Object.defineProperties(O, { start: { get: ExpressionPropertyInterface(z.s) }, end: { get: ExpressionPropertyInterface(z.e) }, offset: { get: ExpressionPropertyInterface(z.o) }, _name: { value: C.nm } }), O.mn = C.mn, O;
      }
      function d(C, z, R) {
        function O(k) {
          return C.a.ix === k || k === "Anchor Point" ? O.anchorPoint : C.o.ix === k || k === "Opacity" ? O.opacity : C.p.ix === k || k === "Position" ? O.position : C.r.ix === k || k === "Rotation" || k === "ADBE Vector Rotation" ? O.rotation : C.s.ix === k || k === "Scale" ? O.scale : C.sk && C.sk.ix === k || k === "Skew" ? O.skew : C.sa && C.sa.ix === k || k === "Skew Axis" ? O.skewAxis : null;
        }
        var $ = propertyGroupFactory(O, R);
        return z.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", $)), z.transform.mProps.p.setGroupProperty(PropertyInterface("Position", $)), z.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", $)), z.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", $)), z.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", $)), z.transform.mProps.sk && (z.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", $)), z.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", $))), z.transform.op.setGroupProperty(PropertyInterface("Opacity", $)), Object.defineProperties(O, { opacity: { get: ExpressionPropertyInterface(z.transform.mProps.o) }, position: { get: ExpressionPropertyInterface(z.transform.mProps.p) }, anchorPoint: { get: ExpressionPropertyInterface(z.transform.mProps.a) }, scale: { get: ExpressionPropertyInterface(z.transform.mProps.s) }, rotation: { get: ExpressionPropertyInterface(z.transform.mProps.r) }, skew: { get: ExpressionPropertyInterface(z.transform.mProps.sk) }, skewAxis: { get: ExpressionPropertyInterface(z.transform.mProps.sa) }, _name: { value: C.nm } }), O.ty = "tr", O.mn = C.mn, O.propertyGroup = R, O;
      }
      function u(C, z, R) {
        function O(P) {
          return C.p.ix === P ? O.position : C.s.ix === P ? O.size : null;
        }
        var $ = propertyGroupFactory(O, R);
        O.propertyIndex = C.ix;
        var k = z.sh.ty === "tm" ? z.sh.prop : z.sh;
        return k.s.setGroupProperty(PropertyInterface("Size", $)), k.p.setGroupProperty(PropertyInterface("Position", $)), Object.defineProperties(O, { size: { get: ExpressionPropertyInterface(k.s) }, position: { get: ExpressionPropertyInterface(k.p) }, _name: { value: C.nm } }), O.mn = C.mn, O;
      }
      function m(C, z, R) {
        function O(P) {
          return C.p.ix === P ? O.position : C.r.ix === P ? O.rotation : C.pt.ix === P ? O.points : C.or.ix === P || P === "ADBE Vector Star Outer Radius" ? O.outerRadius : C.os.ix === P ? O.outerRoundness : C.ir && (C.ir.ix === P || P === "ADBE Vector Star Inner Radius") ? O.innerRadius : C.is && C.is.ix === P ? O.innerRoundness : null;
        }
        var $ = propertyGroupFactory(O, R), k = z.sh.ty === "tm" ? z.sh.prop : z.sh;
        return O.propertyIndex = C.ix, k.or.setGroupProperty(PropertyInterface("Outer Radius", $)), k.os.setGroupProperty(PropertyInterface("Outer Roundness", $)), k.pt.setGroupProperty(PropertyInterface("Points", $)), k.p.setGroupProperty(PropertyInterface("Position", $)), k.r.setGroupProperty(PropertyInterface("Rotation", $)), C.ir && (k.ir.setGroupProperty(PropertyInterface("Inner Radius", $)), k.is.setGroupProperty(PropertyInterface("Inner Roundness", $))), Object.defineProperties(O, { position: { get: ExpressionPropertyInterface(k.p) }, rotation: { get: ExpressionPropertyInterface(k.r) }, points: { get: ExpressionPropertyInterface(k.pt) }, outerRadius: { get: ExpressionPropertyInterface(k.or) }, outerRoundness: { get: ExpressionPropertyInterface(k.os) }, innerRadius: { get: ExpressionPropertyInterface(k.ir) }, innerRoundness: { get: ExpressionPropertyInterface(k.is) }, _name: { value: C.nm } }), O.mn = C.mn, O;
      }
      function A(C, z, R) {
        function O(P) {
          return C.p.ix === P ? O.position : C.r.ix === P ? O.roundness : C.s.ix === P || P === "Size" || P === "ADBE Vector Rect Size" ? O.size : null;
        }
        var $ = propertyGroupFactory(O, R), k = z.sh.ty === "tm" ? z.sh.prop : z.sh;
        return O.propertyIndex = C.ix, k.p.setGroupProperty(PropertyInterface("Position", $)), k.s.setGroupProperty(PropertyInterface("Size", $)), k.r.setGroupProperty(PropertyInterface("Rotation", $)), Object.defineProperties(O, { position: { get: ExpressionPropertyInterface(k.p) }, roundness: { get: ExpressionPropertyInterface(k.r) }, size: { get: ExpressionPropertyInterface(k.s) }, _name: { value: C.nm } }), O.mn = C.mn, O;
      }
      function y(C, z, R) {
        function O(P) {
          return C.r.ix === P || P === "Round Corners 1" ? O.radius : null;
        }
        var $ = propertyGroupFactory(O, R), k = z;
        return O.propertyIndex = C.ix, k.rd.setGroupProperty(PropertyInterface("Radius", $)), Object.defineProperties(O, { radius: { get: ExpressionPropertyInterface(k.rd) }, _name: { value: C.nm } }), O.mn = C.mn, O;
      }
      function D(C, z, R) {
        function O(P) {
          return C.c.ix === P || P === "Copies" ? O.copies : C.o.ix === P || P === "Offset" ? O.offset : null;
        }
        var $ = propertyGroupFactory(O, R), k = z;
        return O.propertyIndex = C.ix, k.c.setGroupProperty(PropertyInterface("Copies", $)), k.o.setGroupProperty(PropertyInterface("Offset", $)), Object.defineProperties(O, { copies: { get: ExpressionPropertyInterface(k.c) }, offset: { get: ExpressionPropertyInterface(k.o) }, _name: { value: C.nm } }), O.mn = C.mn, O;
      }
      return function(C, z, R) {
        var O;
        function $(P) {
          if (typeof P == "number")
            return P = P === void 0 ? 1 : P, P === 0 ? R : O[P - 1];
          for (var L = 0, F = O.length; L < F; ) {
            if (O[L]._name === P)
              return O[L];
            L += 1;
          }
          return null;
        }
        function k() {
          return R;
        }
        return $.propertyGroup = propertyGroupFactory($, k), O = e(C, z, $.propertyGroup), $.numProperties = O.length, $._name = "Contents", $;
      };
    }(), TextExpressionInterface = function() {
      return function(e) {
        var t;
        function i(n) {
          switch (n) {
            case "ADBE Text Document":
              return i.sourceText;
            default:
              return null;
          }
        }
        return Object.defineProperty(i, "sourceText", { get: function() {
          e.textProperty.getValue();
          var a = e.textProperty.currentData.t;
          return (!t || a !== t.value) && (t = new String(a), t.value = a || new String(a), Object.defineProperty(t, "style", { get: function() {
            return { fillColor: e.textProperty.currentData.fc };
          } })), t;
        } }), i;
      };
    }();
    function _typeof$2(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(i) {
        return typeof i;
      } : _typeof$2 = function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, _typeof$2(e);
    }
    var FootageInterface = function() {
      var e = function(n) {
        var a = "", o = n.getFootageData();
        function l() {
          return a = "", o = n.getFootageData(), c;
        }
        function c(d) {
          if (o[d])
            return a = d, o = o[d], _typeof$2(o) === "object" ? c : o;
          var u = d.indexOf(a);
          if (u !== -1) {
            var m = parseInt(d.substr(u + a.length), 10);
            return o = o[m], _typeof$2(o) === "object" ? c : o;
          }
          return "";
        }
        return l;
      }, t = function(n) {
        function a(o) {
          return o === "Outline" ? a.outlineInterface() : null;
        }
        return a._name = "Outline", a.outlineInterface = e(n), a;
      };
      return function(i) {
        function n(a) {
          return a === "Data" ? n.dataInterface : null;
        }
        return n._name = "Data", n.dataInterface = t(i), n;
      };
    }(), interfaces = { layer: LayerExpressionInterface, effects: EffectsExpressionInterface, comp: CompExpressionInterface, shape: ShapeExpressionInterface, text: TextExpressionInterface, footage: FootageInterface };
    function getInterface(e) {
      return interfaces[e] || null;
    }
    function _typeof$1(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(i) {
        return typeof i;
      } : _typeof$1 = function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, _typeof$1(e);
    }
    function seedRandom(e, t) {
      var i = this, n = 256, a = 6, o = 52, l = "random", c = t.pow(n, a), d = t.pow(2, o), u = d * 2, m = n - 1, A;
      function y(k, P, L) {
        var F = [];
        P = P === !0 ? { entropy: !0 } : P || {};
        var B = R(z(P.entropy ? [k, $(e)] : k === null ? O() : k, 3), F), G = new D(F), Z = function() {
          for (var V = G.g(a), E = c, T = 0; V < d; )
            V = (V + T) * n, E *= n, T = G.g(1);
          for (; V >= u; )
            V /= 2, E /= 2, T >>>= 1;
          return (V + T) / E;
        };
        return Z.int32 = function() {
          return G.g(4) | 0;
        }, Z.quick = function() {
          return G.g(4) / 4294967296;
        }, Z.double = Z, R($(G.S), e), (P.pass || L || function(X, V, E, T) {
          return T && (T.S && C(T, G), X.state = function() {
            return C(G, {});
          }), E ? (t[l] = X, V) : X;
        })(Z, B, "global" in P ? P.global : this == t, P.state);
      }
      t["seed" + l] = y;
      function D(k) {
        var P, L = k.length, F = this, B = 0, G = F.i = F.j = 0, Z = F.S = [];
        for (L || (k = [L++]); B < n; )
          Z[B] = B++;
        for (B = 0; B < n; B++)
          Z[B] = Z[G = m & G + k[B % L] + (P = Z[B])], Z[G] = P;
        F.g = function(X) {
          for (var V, E = 0, T = F.i, g = F.j, b = F.S; X--; )
            V = b[T = m & T + 1], E = E * n + b[m & (b[T] = b[g = m & g + V]) + (b[g] = V)];
          return F.i = T, F.j = g, E;
        };
      }
      function C(k, P) {
        return P.i = k.i, P.j = k.j, P.S = k.S.slice(), P;
      }
      function z(k, P) {
        var L = [], F = _typeof$1(k), B;
        if (P && F == "object")
          for (B in k)
            try {
              L.push(z(k[B], P - 1));
            } catch {
            }
        return L.length ? L : F == "string" ? k : k + "\0";
      }
      function R(k, P) {
        for (var L = k + "", F, B = 0; B < L.length; )
          P[m & B] = m & (F ^= P[m & B] * 19) + L.charCodeAt(B++);
        return $(P);
      }
      function O() {
        try {
          var k = new Uint8Array(n);
          return (i.crypto || i.msCrypto).getRandomValues(k), $(k);
        } catch {
          var P = i.navigator, L = P && P.plugins;
          return [+/* @__PURE__ */ new Date(), i, L, i.screen, $(e)];
        }
      }
      function $(k) {
        return String.fromCharCode.apply(0, k);
      }
      R(t.random(), e);
    }
    function initialize$2(e) {
      seedRandom([], e);
    }
    var propTypes = { SHAPE: "shape" };
    function _typeof(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(i) {
        return typeof i;
      } : _typeof = function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, _typeof(e);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null;
      initialize$2(BMMath);
      function $bm_isInstanceOfArray(e) {
        return e.constructor === Array || e.constructor === Float32Array;
      }
      function isNumerable(e, t) {
        return e === "number" || e === "boolean" || e === "string" || t instanceof Number;
      }
      function $bm_neg(e) {
        var t = _typeof(e);
        if (t === "number" || t === "boolean" || e instanceof Number)
          return -e;
        if ($bm_isInstanceOfArray(e)) {
          var i, n = e.length, a = [];
          for (i = 0; i < n; i += 1)
            a[i] = -e[i];
          return a;
        }
        return e.propType ? e.v : -e;
      }
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(e, t) {
        var i = _typeof(e), n = _typeof(t);
        if (i === "string" || n === "string" || isNumerable(i, e) && isNumerable(n, t))
          return e + t;
        if ($bm_isInstanceOfArray(e) && isNumerable(n, t))
          return e = e.slice(0), e[0] += t, e;
        if (isNumerable(i, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e + t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var a = 0, o = e.length, l = t.length, c = []; a < o || a < l; )
            (typeof e[a] == "number" || e[a] instanceof Number) && (typeof t[a] == "number" || t[a] instanceof Number) ? c[a] = e[a] + t[a] : c[a] = t[a] === void 0 ? e[a] : e[a] || t[a], a += 1;
          return c;
        }
        return 0;
      }
      var add = sum;
      function sub(e, t) {
        var i = _typeof(e), n = _typeof(t);
        if (isNumerable(i, e) && isNumerable(n, t))
          return i === "string" && (e = parseInt(e, 10)), n === "string" && (t = parseInt(t, 10)), e - t;
        if ($bm_isInstanceOfArray(e) && isNumerable(n, t))
          return e = e.slice(0), e[0] -= t, e;
        if (isNumerable(i, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e - t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var a = 0, o = e.length, l = t.length, c = []; a < o || a < l; )
            (typeof e[a] == "number" || e[a] instanceof Number) && (typeof t[a] == "number" || t[a] instanceof Number) ? c[a] = e[a] - t[a] : c[a] = t[a] === void 0 ? e[a] : e[a] || t[a], a += 1;
          return c;
        }
        return 0;
      }
      function mul(e, t) {
        var i = _typeof(e), n = _typeof(t), a;
        if (isNumerable(i, e) && isNumerable(n, t))
          return e * t;
        var o, l;
        if ($bm_isInstanceOfArray(e) && isNumerable(n, t)) {
          for (l = e.length, a = createTypedArray("float32", l), o = 0; o < l; o += 1)
            a[o] = e[o] * t;
          return a;
        }
        if (isNumerable(i, e) && $bm_isInstanceOfArray(t)) {
          for (l = t.length, a = createTypedArray("float32", l), o = 0; o < l; o += 1)
            a[o] = e * t[o];
          return a;
        }
        return 0;
      }
      function div(e, t) {
        var i = _typeof(e), n = _typeof(t), a;
        if (isNumerable(i, e) && isNumerable(n, t))
          return e / t;
        var o, l;
        if ($bm_isInstanceOfArray(e) && isNumerable(n, t)) {
          for (l = e.length, a = createTypedArray("float32", l), o = 0; o < l; o += 1)
            a[o] = e[o] / t;
          return a;
        }
        if (isNumerable(i, e) && $bm_isInstanceOfArray(t)) {
          for (l = t.length, a = createTypedArray("float32", l), o = 0; o < l; o += 1)
            a[o] = e / t[o];
          return a;
        }
        return 0;
      }
      function mod(e, t) {
        return typeof e == "string" && (e = parseInt(e, 10)), typeof t == "string" && (t = parseInt(t, 10)), e % t;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(e, t, i) {
        if (t > i) {
          var n = i;
          i = t, t = n;
        }
        return Math.min(Math.max(e, t), i);
      }
      function radiansToDegrees(e) {
        return e / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(e) {
        return e * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(e, t) {
        if (typeof e == "number" || e instanceof Number)
          return t = t || 0, Math.abs(e - t);
        t || (t = helperLengthArray);
        var i, n = Math.min(e.length, t.length), a = 0;
        for (i = 0; i < n; i += 1)
          a += Math.pow(t[i] - e[i], 2);
        return Math.sqrt(a);
      }
      function normalize(e) {
        return div(e, length(e));
      }
      function rgbToHsl(e) {
        var t = e[0], i = e[1], n = e[2], a = Math.max(t, i, n), o = Math.min(t, i, n), l, c, d = (a + o) / 2;
        if (a === o)
          l = 0, c = 0;
        else {
          var u = a - o;
          switch (c = d > 0.5 ? u / (2 - a - o) : u / (a + o), a) {
            case t:
              l = (i - n) / u + (i < n ? 6 : 0);
              break;
            case i:
              l = (n - t) / u + 2;
              break;
            case n:
              l = (t - i) / u + 4;
              break;
          }
          l /= 6;
        }
        return [l, c, d, e[3]];
      }
      function hue2rgb(e, t, i) {
        return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? e + (t - e) * 6 * i : i < 1 / 2 ? t : i < 2 / 3 ? e + (t - e) * (2 / 3 - i) * 6 : e;
      }
      function hslToRgb(e) {
        var t = e[0], i = e[1], n = e[2], a, o, l;
        if (i === 0)
          a = n, l = n, o = n;
        else {
          var c = n < 0.5 ? n * (1 + i) : n + i - n * i, d = 2 * n - c;
          a = hue2rgb(d, c, t + 1 / 3), o = hue2rgb(d, c, t), l = hue2rgb(d, c, t - 1 / 3);
        }
        return [a, o, l, e[3]];
      }
      function linear(e, t, i, n, a) {
        if ((n === void 0 || a === void 0) && (n = t, a = i, t = 0, i = 1), i < t) {
          var o = i;
          i = t, t = o;
        }
        if (e <= t)
          return n;
        if (e >= i)
          return a;
        var l = i === t ? 0 : (e - t) / (i - t);
        if (!n.length)
          return n + (a - n) * l;
        var c, d = n.length, u = createTypedArray("float32", d);
        for (c = 0; c < d; c += 1)
          u[c] = n[c] + (a[c] - n[c]) * l;
        return u;
      }
      function random(e, t) {
        if (t === void 0 && (e === void 0 ? (e = 0, t = 1) : (t = e, e = void 0)), t.length) {
          var i, n = t.length;
          e || (e = createTypedArray("float32", n));
          var a = createTypedArray("float32", n), o = BMMath.random();
          for (i = 0; i < n; i += 1)
            a[i] = e[i] + o * (t[i] - e[i]);
          return a;
        }
        e === void 0 && (e = 0);
        var l = BMMath.random();
        return e + l * (t - e);
      }
      function createPath(e, t, i, n) {
        var a, o = e.length, l = shapePool.newElement();
        l.setPathData(!!n, o);
        var c = [0, 0], d, u;
        for (a = 0; a < o; a += 1)
          d = t && t[a] ? t[a] : c, u = i && i[a] ? i[a] : c, l.setTripleAt(e[a][0], e[a][1], u[0] + e[a][0], u[1] + e[a][1], d[0] + e[a][0], d[1] + e[a][1], a, !0);
        return l;
      }
      function initiateExpression(elem, data, property) {
        function noOp(e) {
          return e;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", { get: function() {
          return thisProperty.v;
        } }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = function e(t, i) {
          var n, a, o = this.pv.length ? this.pv.length : 1, l = createTypedArray("float32", o);
          t = 5;
          var c = Math.floor(time * t);
          for (n = 0, a = 0; n < c; ) {
            for (a = 0; a < o; a += 1)
              l[a] += -i + i * 2 * BMMath.random();
            n += 1;
          }
          var d = time * t, u = d - Math.floor(d), m = createTypedArray("float32", o);
          if (o > 1) {
            for (a = 0; a < o; a += 1)
              m[a] = this.pv[a] + l[a] + (-i + i * 2 * BMMath.random()) * u;
            return m;
          }
          return this.pv + l[0] + (-i + i * 2 * BMMath.random()) * u;
        }.bind(this);
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
        function loopInDuration(e, t) {
          return loopIn(e, t, !0);
        }
        function loopOutDuration(e, t) {
          return loopOut(e, t, !0);
        }
        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
        function lookAt(e, t) {
          var i = [t[0] - e[0], t[1] - e[1], t[2] - e[2]], n = Math.atan2(i[0], Math.sqrt(i[1] * i[1] + i[2] * i[2])) / degToRads, a = -Math.atan2(i[1], i[2]) / degToRads;
          return [a, n, 0];
        }
        function easeOut(e, t, i, n, a) {
          return applyEase(easeOutBez, e, t, i, n, a);
        }
        function easeIn(e, t, i, n, a) {
          return applyEase(easeInBez, e, t, i, n, a);
        }
        function ease(e, t, i, n, a) {
          return applyEase(easeInOutBez, e, t, i, n, a);
        }
        function applyEase(e, t, i, n, a, o) {
          a === void 0 ? (a = i, o = n) : t = (t - i) / (n - i), t > 1 ? t = 1 : t < 0 && (t = 0);
          var l = e(t);
          if ($bm_isInstanceOfArray(a)) {
            var c, d = a.length, u = createTypedArray("float32", d);
            for (c = 0; c < d; c += 1)
              u[c] = (o[c] - a[c]) * l + a[c];
            return u;
          }
          return (o - a) * l + a;
        }
        function nearestKey(e) {
          var t, i = data.k.length, n, a;
          if (!data.k.length || typeof data.k[0] == "number")
            n = 0, a = 0;
          else if (n = -1, e *= elem.comp.globalData.frameRate, e < data.k[0].t)
            n = 1, a = data.k[0].t;
          else {
            for (t = 0; t < i - 1; t += 1)
              if (e === data.k[t].t) {
                n = t + 1, a = data.k[t].t;
                break;
              } else if (e > data.k[t].t && e < data.k[t + 1].t) {
                e - data.k[t].t > data.k[t + 1].t - e ? (n = t + 2, a = data.k[t + 1].t) : (n = t + 1, a = data.k[t].t);
                break;
              }
            n === -1 && (n = t + 1, a = data.k[t].t);
          }
          var o = {};
          return o.index = n, o.time = a / elem.comp.globalData.frameRate, o;
        }
        function key(e) {
          var t, i, n;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + e);
          e -= 1, t = { time: data.k[e].t / elem.comp.globalData.frameRate, value: [] };
          var a = Object.prototype.hasOwnProperty.call(data.k[e], "s") ? data.k[e].s : data.k[e - 1].e;
          for (n = a.length, i = 0; i < n; i += 1)
            t[i] = a[i], t.value[i] = a[i];
          return t;
        }
        function framesToTime(e, t) {
          return t || (t = elem.comp.globalData.frameRate), e / t;
        }
        function timeToFrames(e, t) {
          return !e && e !== 0 && (e = time), t || (t = elem.comp.globalData.frameRate), e * t;
        }
        function seedRandom(e) {
          BMMath.seedrandom(randSeed + e);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substring(e) : value.substring(e, t) : "";
        }
        function substr(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substr(e) : value.substr(e, t) : "";
        }
        function posterizeTime(e) {
          time = e === 0 ? 0 : Math.floor(time * e) / e, value = valueAtTime(time);
        }
        var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
        function executeExpression(e) {
          return value = e, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath], ob;
    }(), expressionHelpers = function() {
      function e(l, c, d) {
        c.x && (d.k = !0, d.x = !0, d.initiateExpression = ExpressionManager.initiateExpression, d.effectsSequence.push(d.initiateExpression(l, c, d).bind(d)));
      }
      function t(l) {
        return l *= this.elem.globalData.frameRate, l -= this.offsetTime, l !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < l ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(l, this._cachingAtTime), this._cachingAtTime.lastFrame = l), this._cachingAtTime.value;
      }
      function i(l) {
        var c = -0.01, d = this.getValueAtTime(l), u = this.getValueAtTime(l + c), m = 0;
        if (d.length) {
          var A;
          for (A = 0; A < d.length; A += 1)
            m += Math.pow(u[A] - d[A], 2);
          m = Math.sqrt(m) * 100;
        } else
          m = 0;
        return m;
      }
      function n(l) {
        if (this.vel !== void 0)
          return this.vel;
        var c = -1e-3, d = this.getValueAtTime(l), u = this.getValueAtTime(l + c), m;
        if (d.length) {
          m = createTypedArray("float32", d.length);
          var A;
          for (A = 0; A < d.length; A += 1)
            m[A] = (u[A] - d[A]) / c;
        } else
          m = (u - d) / c;
        return m;
      }
      function a() {
        return this.pv;
      }
      function o(l) {
        this.propertyGroup = l;
      }
      return { searchExpressions: e, getSpeedAtTime: i, getVelocityAtTime: n, getValueAtTime: t, getStaticValueAtTime: a, setGroupProperty: o };
    }();
    function addPropertyDecorator() {
      function e(y, D, C) {
        if (!this.k || !this.keyframes)
          return this.pv;
        y = y ? y.toLowerCase() : "";
        var z = this.comp.renderedFrame, R = this.keyframes, O = R[R.length - 1].t;
        if (z <= O)
          return this.pv;
        var $, k;
        C ? (D ? $ = Math.abs(O - this.elem.comp.globalData.frameRate * D) : $ = Math.max(0, O - this.elem.data.ip), k = O - $) : ((!D || D > R.length - 1) && (D = R.length - 1), k = R[R.length - 1 - D].t, $ = O - k);
        var P, L, F;
        if (y === "pingpong") {
          var B = Math.floor((z - k) / $);
          if (B % 2 !== 0)
            return this.getValueAtTime(($ - (z - k) % $ + k) / this.comp.globalData.frameRate, 0);
        } else if (y === "offset") {
          var G = this.getValueAtTime(k / this.comp.globalData.frameRate, 0), Z = this.getValueAtTime(O / this.comp.globalData.frameRate, 0), X = this.getValueAtTime(((z - k) % $ + k) / this.comp.globalData.frameRate, 0), V = Math.floor((z - k) / $);
          if (this.pv.length) {
            for (F = new Array(G.length), L = F.length, P = 0; P < L; P += 1)
              F[P] = (Z[P] - G[P]) * V + X[P];
            return F;
          }
          return (Z - G) * V + X;
        } else if (y === "continue") {
          var E = this.getValueAtTime(O / this.comp.globalData.frameRate, 0), T = this.getValueAtTime((O - 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (F = new Array(E.length), L = F.length, P = 0; P < L; P += 1)
              F[P] = E[P] + (E[P] - T[P]) * ((z - O) / this.comp.globalData.frameRate) / 5e-4;
            return F;
          }
          return E + (E - T) * ((z - O) / 1e-3);
        }
        return this.getValueAtTime(((z - k) % $ + k) / this.comp.globalData.frameRate, 0);
      }
      function t(y, D, C) {
        if (!this.k)
          return this.pv;
        y = y ? y.toLowerCase() : "";
        var z = this.comp.renderedFrame, R = this.keyframes, O = R[0].t;
        if (z >= O)
          return this.pv;
        var $, k;
        C ? (D ? $ = Math.abs(this.elem.comp.globalData.frameRate * D) : $ = Math.max(0, this.elem.data.op - O), k = O + $) : ((!D || D > R.length - 1) && (D = R.length - 1), k = R[D].t, $ = k - O);
        var P, L, F;
        if (y === "pingpong") {
          var B = Math.floor((O - z) / $);
          if (B % 2 === 0)
            return this.getValueAtTime(((O - z) % $ + O) / this.comp.globalData.frameRate, 0);
        } else if (y === "offset") {
          var G = this.getValueAtTime(O / this.comp.globalData.frameRate, 0), Z = this.getValueAtTime(k / this.comp.globalData.frameRate, 0), X = this.getValueAtTime(($ - (O - z) % $ + O) / this.comp.globalData.frameRate, 0), V = Math.floor((O - z) / $) + 1;
          if (this.pv.length) {
            for (F = new Array(G.length), L = F.length, P = 0; P < L; P += 1)
              F[P] = X[P] - (Z[P] - G[P]) * V;
            return F;
          }
          return X - (Z - G) * V;
        } else if (y === "continue") {
          var E = this.getValueAtTime(O / this.comp.globalData.frameRate, 0), T = this.getValueAtTime((O + 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (F = new Array(E.length), L = F.length, P = 0; P < L; P += 1)
              F[P] = E[P] + (E[P] - T[P]) * (O - z) / 1e-3;
            return F;
          }
          return E + (E - T) * (O - z) / 1e-3;
        }
        return this.getValueAtTime(($ - ((O - z) % $ + O)) / this.comp.globalData.frameRate, 0);
      }
      function i(y, D) {
        if (!this.k)
          return this.pv;
        if (y = (y || 0.4) * 0.5, D = Math.floor(D || 5), D <= 1)
          return this.pv;
        var C = this.comp.renderedFrame / this.comp.globalData.frameRate, z = C - y, R = C + y, O = D > 1 ? (R - z) / (D - 1) : 1, $ = 0, k = 0, P;
        this.pv.length ? P = createTypedArray("float32", this.pv.length) : P = 0;
        for (var L; $ < D; ) {
          if (L = this.getValueAtTime(z + $ * O), this.pv.length)
            for (k = 0; k < this.pv.length; k += 1)
              P[k] += L[k];
          else
            P += L;
          $ += 1;
        }
        if (this.pv.length)
          for (k = 0; k < this.pv.length; k += 1)
            P[k] /= D;
        else
          P /= D;
        return P;
      }
      function n(y) {
        this._transformCachingAtTime || (this._transformCachingAtTime = { v: new Matrix() });
        var D = this._transformCachingAtTime.v;
        if (D.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var C = this.a.getValueAtTime(y);
          D.translate(-C[0] * this.a.mult, -C[1] * this.a.mult, C[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var z = this.s.getValueAtTime(y);
          D.scale(z[0] * this.s.mult, z[1] * this.s.mult, z[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var R = this.sk.getValueAtTime(y), O = this.sa.getValueAtTime(y);
          D.skewFromAxis(-R * this.sk.mult, O * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var $ = this.r.getValueAtTime(y);
          D.rotate(-$ * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var k = this.rz.getValueAtTime(y), P = this.ry.getValueAtTime(y), L = this.rx.getValueAtTime(y), F = this.or.getValueAtTime(y);
          D.rotateZ(-k * this.rz.mult).rotateY(P * this.ry.mult).rotateX(L * this.rx.mult).rotateZ(-F[2] * this.or.mult).rotateY(F[1] * this.or.mult).rotateX(F[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var B = this.px.getValueAtTime(y), G = this.py.getValueAtTime(y);
          if (this.data.p.z) {
            var Z = this.pz.getValueAtTime(y);
            D.translate(B * this.px.mult, G * this.py.mult, -Z * this.pz.mult);
          } else
            D.translate(B * this.px.mult, G * this.py.mult, 0);
        } else {
          var X = this.p.getValueAtTime(y);
          D.translate(X[0] * this.p.mult, X[1] * this.p.mult, -X[2] * this.p.mult);
        }
        return D;
      }
      function a() {
        return this.v.clone(new Matrix());
      }
      var o = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(y, D, C) {
        var z = o(y, D, C);
        return z.dynamicProperties.length ? z.getValueAtTime = n.bind(z) : z.getValueAtTime = a.bind(z), z.setGroupProperty = expressionHelpers.setGroupProperty, z;
      };
      var l = PropertyFactory.getProp;
      PropertyFactory.getProp = function(y, D, C, z, R) {
        var O = l(y, D, C, z, R);
        O.kf ? O.getValueAtTime = expressionHelpers.getValueAtTime.bind(O) : O.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(O), O.setGroupProperty = expressionHelpers.setGroupProperty, O.loopOut = e, O.loopIn = t, O.smooth = i, O.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(O), O.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(O), O.numKeys = D.a === 1 ? D.k.length : 0, O.propertyIndex = D.ix;
        var $ = 0;
        return C !== 0 && ($ = createTypedArray("float32", D.a === 1 ? D.k[0].s.length : D.k.length)), O._cachingAtTime = { lastFrame: initialDefaultFrame, lastIndex: 0, value: $ }, expressionHelpers.searchExpressions(y, D, O), O.k && R.addDynamicProperty(O), O;
      };
      function c(y) {
        return this._cachingAtTime || (this._cachingAtTime = { shapeValue: shapePool.clone(this.pv), lastIndex: 0, lastTime: initialDefaultFrame }), y *= this.elem.globalData.frameRate, y -= this.offsetTime, y !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < y ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = y, this.interpolateShape(y, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }
      var d = ShapePropertyFactory.getConstructorFunction(), u = ShapePropertyFactory.getKeyframedConstructorFunction();
      function m() {
      }
      m.prototype = { vertices: function(D, C) {
        this.k && this.getValue();
        var z = this.v;
        C !== void 0 && (z = this.getValueAtTime(C, 0));
        var R, O = z._length, $ = z[D], k = z.v, P = createSizedArray(O);
        for (R = 0; R < O; R += 1)
          D === "i" || D === "o" ? P[R] = [$[R][0] - k[R][0], $[R][1] - k[R][1]] : P[R] = [$[R][0], $[R][1]];
        return P;
      }, points: function(D) {
        return this.vertices("v", D);
      }, inTangents: function(D) {
        return this.vertices("i", D);
      }, outTangents: function(D) {
        return this.vertices("o", D);
      }, isClosed: function() {
        return this.v.c;
      }, pointOnPath: function(D, C) {
        var z = this.v;
        C !== void 0 && (z = this.getValueAtTime(C, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(z));
        for (var R = this._segmentsLength, O = R.lengths, $ = R.totalLength * D, k = 0, P = O.length, L = 0, F; k < P; ) {
          if (L + O[k].addedLength > $) {
            var B = k, G = z.c && k === P - 1 ? 0 : k + 1, Z = ($ - L) / O[k].addedLength;
            F = bez.getPointInSegment(z.v[B], z.v[G], z.o[B], z.i[G], Z, O[k]);
            break;
          } else
            L += O[k].addedLength;
          k += 1;
        }
        return F || (F = z.c ? [z.v[0][0], z.v[0][1]] : [z.v[z._length - 1][0], z.v[z._length - 1][1]]), F;
      }, vectorOnPath: function(D, C, z) {
        D == 1 ? D = this.v.c : D == 0 && (D = 0.999);
        var R = this.pointOnPath(D, C), O = this.pointOnPath(D + 1e-3, C), $ = O[0] - R[0], k = O[1] - R[1], P = Math.sqrt(Math.pow($, 2) + Math.pow(k, 2));
        if (P === 0)
          return [0, 0];
        var L = z === "tangent" ? [$ / P, k / P] : [-k / P, $ / P];
        return L;
      }, tangentOnPath: function(D, C) {
        return this.vectorOnPath(D, C, "tangent");
      }, normalOnPath: function(D, C) {
        return this.vectorOnPath(D, C, "normal");
      }, setGroupProperty: expressionHelpers.setGroupProperty, getValueAtTime: expressionHelpers.getStaticValueAtTime }, extendPrototype([m], d), extendPrototype([m], u), u.prototype.getValueAtTime = c, u.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var A = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(y, D, C, z, R) {
        var O = A(y, D, C, z, R);
        return O.propertyIndex = D.ix, O.lock = !1, C === 3 ? expressionHelpers.searchExpressions(y, D.pt, O) : C === 4 && expressionHelpers.searchExpressions(y, D.ks, O), O.k && y.addDynamicProperty(O), O;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      function e() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      }
      TextProperty.prototype.getExpressionValue = function(t, i) {
        var n = this.calculateExpression(i);
        if (t.t !== n) {
          var a = {};
          return this.copyData(a, t), a.t = n.toString(), a.__complete = !1, a;
        }
        return t;
      }, TextProperty.prototype.searchProperty = function() {
        var t = this.searchKeyframes(), i = this.searchExpressions();
        return this.kf = t || i, this.kf;
      }, TextProperty.prototype.searchExpressions = e;
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = { createMergeNode: function e(t, i) {
      var n = createNS("feMerge");
      n.setAttribute("result", t);
      var a, o;
      for (o = 0; o < i.length; o += 1)
        a = createNS("feMergeNode"), a.setAttribute("in", i[o]), n.appendChild(a), n.appendChild(a);
      return n;
    } };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(e, t, i, n, a) {
      this.filterManager = t;
      var o = createNS("feColorMatrix");
      o.setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "linearRGB"), o.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = o, o.setAttribute("result", n + "_tint_1"), e.appendChild(o), o = createNS("feColorMatrix"), o.setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), o.setAttribute("result", n + "_tint_2"), e.appendChild(o), this.matrixFilter = o;
      var l = this.createMergeNode(n, [a, n + "_tint_1", n + "_tint_2"]);
      e.appendChild(l);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, i = this.filterManager.effectElements[1].p.v, n = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + n + " 0"), this.matrixFilter.setAttribute("values", i[0] - t[0] + " 0 0 0 " + t[0] + " " + (i[1] - t[1]) + " 0 0 0 " + t[1] + " " + (i[2] - t[2]) + " 0 0 0 " + t[2] + " 0 0 0 1 0");
      }
    };
    function SVGFillFilter(e, t, i, n) {
      this.filterManager = t;
      var a = createNS("feColorMatrix");
      a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", n), e.appendChild(a), this.matrixFilter = a;
    }
    SVGFillFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[2].p.v, i = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + t[0] + " 0 0 0 0 " + t[1] + " 0 0 0 0 " + t[2] + " 0 0 0 " + i + " 0");
      }
    };
    function SVGStrokeEffect(e, t, i) {
      this.initialized = !1, this.filterManager = t, this.elem = i, this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
      var e = this.elem.layerElement.children || this.elem.layerElement.childNodes, t, i, n, a;
      for (this.filterManager.effectElements[1].p.v === 1 ? (a = this.elem.maskManager.masksProperties.length, n = 0) : (n = this.filterManager.effectElements[0].p.v - 1, a = n + 1), i = createNS("g"), i.setAttribute("fill", "none"), i.setAttribute("stroke-linecap", "round"), i.setAttribute("stroke-dashoffset", 1), n; n < a; n += 1)
        t = createNS("path"), i.appendChild(t), this.paths.push({ p: t, m: n });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var o = createNS("mask"), l = createElementID();
        o.setAttribute("id", l), o.setAttribute("mask-type", "alpha"), o.appendChild(i), this.elem.globalData.defs.appendChild(o);
        var c = createNS("g");
        for (c.setAttribute("mask", "url(" + getLocationHref() + "#" + l + ")"); e[0]; )
          c.appendChild(e[0]);
        this.elem.layerElement.appendChild(c), this.masker = o, i.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (e = this.elem.layerElement.children || this.elem.layerElement.childNodes; e.length; )
            this.elem.layerElement.removeChild(e[0]);
        this.elem.layerElement.appendChild(i), this.elem.layerElement.removeAttribute("mask"), i.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = i;
    }, SVGStrokeEffect.prototype.renderFrame = function(e) {
      this.initialized || this.initialize();
      var t, i = this.paths.length, n, a;
      for (t = 0; t < i; t += 1)
        if (this.paths[t].m !== -1 && (n = this.elem.maskManager.viewData[this.paths[t].m], a = this.paths[t].p, (e || this.filterManager._mdf || n.prop._mdf) && a.setAttribute("d", n.lastPath), e || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || n.prop._mdf)) {
          var o;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var l = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, c = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, d = a.getTotalLength();
            o = "0 0 0 " + d * l + " ";
            var u = d * (c - l), m = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, A = Math.floor(u / m), y;
            for (y = 0; y < A; y += 1)
              o += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            o += "0 " + d * 10 + " 0 0";
          } else
            o = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          a.setAttribute("stroke-dasharray", o);
        }
      if ((e || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (e || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (e || this.filterManager.effectElements[3].p._mdf)) {
        var D = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(D[0] * 255) + "," + bmFloor(D[1] * 255) + "," + bmFloor(D[2] * 255) + ")");
      }
    };
    function SVGTritoneFilter(e, t, i, n) {
      this.filterManager = t;
      var a = createNS("feColorMatrix");
      a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), e.appendChild(a);
      var o = createNS("feComponentTransfer");
      o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("result", n), this.matrixFilter = o;
      var l = createNS("feFuncR");
      l.setAttribute("type", "table"), o.appendChild(l), this.feFuncR = l;
      var c = createNS("feFuncG");
      c.setAttribute("type", "table"), o.appendChild(c), this.feFuncG = c;
      var d = createNS("feFuncB");
      d.setAttribute("type", "table"), o.appendChild(d), this.feFuncB = d, e.appendChild(o);
    }
    SVGTritoneFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, i = this.filterManager.effectElements[1].p.v, n = this.filterManager.effectElements[2].p.v, a = n[0] + " " + i[0] + " " + t[0], o = n[1] + " " + i[1] + " " + t[1], l = n[2] + " " + i[2] + " " + t[2];
        this.feFuncR.setAttribute("tableValues", a), this.feFuncG.setAttribute("tableValues", o), this.feFuncB.setAttribute("tableValues", l);
      }
    };
    function SVGProLevelsFilter(e, t, i, n) {
      this.filterManager = t;
      var a = this.filterManager.effectElements, o = createNS("feComponentTransfer");
      (a[10].p.k || a[10].p.v !== 0 || a[11].p.k || a[11].p.v !== 1 || a[12].p.k || a[12].p.v !== 1 || a[13].p.k || a[13].p.v !== 0 || a[14].p.k || a[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", o)), (a[17].p.k || a[17].p.v !== 0 || a[18].p.k || a[18].p.v !== 1 || a[19].p.k || a[19].p.v !== 1 || a[20].p.k || a[20].p.v !== 0 || a[21].p.k || a[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", o)), (a[24].p.k || a[24].p.v !== 0 || a[25].p.k || a[25].p.v !== 1 || a[26].p.k || a[26].p.v !== 1 || a[27].p.k || a[27].p.v !== 0 || a[28].p.k || a[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", o)), (a[31].p.k || a[31].p.v !== 0 || a[32].p.k || a[32].p.v !== 1 || a[33].p.k || a[33].p.v !== 1 || a[34].p.k || a[34].p.v !== 0 || a[35].p.k || a[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", o)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (o.setAttribute("color-interpolation-filters", "sRGB"), e.appendChild(o)), (a[3].p.k || a[3].p.v !== 0 || a[4].p.k || a[4].p.v !== 1 || a[5].p.k || a[5].p.v !== 1 || a[6].p.k || a[6].p.v !== 0 || a[7].p.k || a[7].p.v !== 1) && (o = createNS("feComponentTransfer"), o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("result", n), e.appendChild(o), this.feFuncRComposed = this.createFeFunc("feFuncR", o), this.feFuncGComposed = this.createFeFunc("feFuncG", o), this.feFuncBComposed = this.createFeFunc("feFuncB", o));
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(e, t) {
      var i = createNS(e);
      return i.setAttribute("type", "table"), t.appendChild(i), i;
    }, SVGProLevelsFilter.prototype.getTableValue = function(e, t, i, n, a) {
      for (var o = 0, l = 256, c, d = Math.min(e, t), u = Math.max(e, t), m = Array.call(null, { length: l }), A, y = 0, D = a - n, C = t - e; o <= 256; )
        c = o / 256, c <= d ? A = C < 0 ? a : n : c >= u ? A = C < 0 ? n : a : A = n + D * Math.pow((c - e) / C, 1 / i), m[y] = A, y += 1, o += 256 / (l - 1);
      return m.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t, i = this.filterManager.effectElements;
        this.feFuncRComposed && (e || i[3].p._mdf || i[4].p._mdf || i[5].p._mdf || i[6].p._mdf || i[7].p._mdf) && (t = this.getTableValue(i[3].p.v, i[4].p.v, i[5].p.v, i[6].p.v, i[7].p.v), this.feFuncRComposed.setAttribute("tableValues", t), this.feFuncGComposed.setAttribute("tableValues", t), this.feFuncBComposed.setAttribute("tableValues", t)), this.feFuncR && (e || i[10].p._mdf || i[11].p._mdf || i[12].p._mdf || i[13].p._mdf || i[14].p._mdf) && (t = this.getTableValue(i[10].p.v, i[11].p.v, i[12].p.v, i[13].p.v, i[14].p.v), this.feFuncR.setAttribute("tableValues", t)), this.feFuncG && (e || i[17].p._mdf || i[18].p._mdf || i[19].p._mdf || i[20].p._mdf || i[21].p._mdf) && (t = this.getTableValue(i[17].p.v, i[18].p.v, i[19].p.v, i[20].p.v, i[21].p.v), this.feFuncG.setAttribute("tableValues", t)), this.feFuncB && (e || i[24].p._mdf || i[25].p._mdf || i[26].p._mdf || i[27].p._mdf || i[28].p._mdf) && (t = this.getTableValue(i[24].p.v, i[25].p.v, i[26].p.v, i[27].p.v, i[28].p.v), this.feFuncB.setAttribute("tableValues", t)), this.feFuncA && (e || i[31].p._mdf || i[32].p._mdf || i[33].p._mdf || i[34].p._mdf || i[35].p._mdf) && (t = this.getTableValue(i[31].p.v, i[32].p.v, i[33].p.v, i[34].p.v, i[35].p.v), this.feFuncA.setAttribute("tableValues", t));
      }
    };
    function SVGDropShadowEffect(e, t, i, n, a) {
      var o = t.container.globalData.renderConfig.filterSize, l = t.data.fs || o;
      e.setAttribute("x", l.x || o.x), e.setAttribute("y", l.y || o.y), e.setAttribute("width", l.width || o.width), e.setAttribute("height", l.height || o.height), this.filterManager = t;
      var c = createNS("feGaussianBlur");
      c.setAttribute("in", "SourceAlpha"), c.setAttribute("result", n + "_drop_shadow_1"), c.setAttribute("stdDeviation", "0"), this.feGaussianBlur = c, e.appendChild(c);
      var d = createNS("feOffset");
      d.setAttribute("dx", "25"), d.setAttribute("dy", "0"), d.setAttribute("in", n + "_drop_shadow_1"), d.setAttribute("result", n + "_drop_shadow_2"), this.feOffset = d, e.appendChild(d);
      var u = createNS("feFlood");
      u.setAttribute("flood-color", "#00ff00"), u.setAttribute("flood-opacity", "1"), u.setAttribute("result", n + "_drop_shadow_3"), this.feFlood = u, e.appendChild(u);
      var m = createNS("feComposite");
      m.setAttribute("in", n + "_drop_shadow_3"), m.setAttribute("in2", n + "_drop_shadow_2"), m.setAttribute("operator", "in"), m.setAttribute("result", n + "_drop_shadow_4"), e.appendChild(m);
      var A = this.createMergeNode(n, [n + "_drop_shadow_4", a]);
      e.appendChild(A);
    }
    extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        if ((e || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), e || this.filterManager.effectElements[0].p._mdf) {
          var t = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(t[0] * 255), Math.round(t[1] * 255), Math.round(t[2] * 255)));
        }
        if ((e || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), e || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var i = this.filterManager.effectElements[3].p.v, n = (this.filterManager.effectElements[2].p.v - 90) * degToRads, a = i * Math.cos(n), o = i * Math.sin(n);
          this.feOffset.setAttribute("dx", a), this.feOffset.setAttribute("dy", o);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(e, t, i) {
      this.initialized = !1, this.filterManager = t, this.filterElem = e, this.elem = i, i.matteElement = createNS("g"), i.matteElement.appendChild(i.layerElement), i.matteElement.appendChild(i.transformedElement), i.baseElement = i.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(e) {
      for (var t = 0, i = _svgMatteSymbols.length; t < i; ) {
        if (_svgMatteSymbols[t] === e)
          return _svgMatteSymbols[t];
        t += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(e, t) {
      var i = e.layerElement.parentNode;
      if (i) {
        for (var n = i.children, a = 0, o = n.length; a < o && n[a] !== e.layerElement; )
          a += 1;
        var l;
        a <= o - 2 && (l = n[a + 1]);
        var c = createNS("use");
        c.setAttribute("href", "#" + t), l ? i.insertBefore(c, l) : i.appendChild(c);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(e, t) {
      if (!this.findSymbol(t)) {
        var i = createElementID(), n = createNS("mask");
        n.setAttribute("id", t.layerId), n.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(t);
        var a = e.globalData.defs;
        a.appendChild(n);
        var o = createNS("symbol");
        o.setAttribute("id", i), this.replaceInParent(t, i), o.appendChild(t.layerElement), a.appendChild(o);
        var l = createNS("use");
        l.setAttribute("href", "#" + i), n.appendChild(l), t.data.hd = !1, t.show();
      }
      e.setMatte(t.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var e = this.filterManager.effectElements[0].p.v, t = this.elem.comp.elements, i = 0, n = t.length; i < n; )
        t[i] && t[i].data.ind === e && this.setElementAsMask(this.elem, t[i]), i += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    };
    function SVGGaussianBlurEffect(e, t, i, n) {
      e.setAttribute("x", "-100%"), e.setAttribute("y", "-100%"), e.setAttribute("width", "300%"), e.setAttribute("height", "300%"), this.filterManager = t;
      var a = createNS("feGaussianBlur");
      a.setAttribute("result", n), e.appendChild(a), this.feGaussianBlur = a;
    }
    return SVGGaussianBlurEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = 0.3, i = this.filterManager.effectElements[0].p.v * t, n = this.filterManager.effectElements[1].p.v, a = n == 3 ? 0 : i, o = n == 2 ? 0 : i;
        this.feGaussianBlur.setAttribute("stdDeviation", a + " " + o);
        var l = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", l);
      }
    }, registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect(20, SVGTintFilter, !0), registerEffect(21, SVGFillFilter, !0), registerEffect(22, SVGStrokeEffect, !1), registerEffect(23, SVGTritoneFilter, !0), registerEffect(24, SVGProLevelsFilter, !0), registerEffect(25, SVGDropShadowEffect, !0), registerEffect(28, SVGMatte3Effect, !1), registerEffect(29, SVGGaussianBlurEffect, !0), lottie;
  });
})(lottie$1, lottieExports);
const lottie = lottieExports;
function _iterableToArrayLimit(e, t) {
  var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (i != null) {
    var n, a, o, l, c = [], d = !0, u = !1;
    try {
      if (o = (i = i.call(e)).next, t === 0) {
        if (Object(i) !== i)
          return;
        d = !1;
      } else
        for (; !(d = (n = o.call(i)).done) && (c.push(n.value), c.length !== t); d = !0)
          ;
    } catch (m) {
      u = !0, a = m;
    } finally {
      try {
        if (!d && i.return != null && (l = i.return(), Object(l) !== l))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return c;
  }
}
function ownKeys(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function _objectSpread2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys(Object(i), !0).forEach(function(n) {
      _defineProperty(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ownKeys(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function _defineProperty(e, t, i) {
  return t = _toPropertyKey(t), t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
function _objectWithoutPropertiesLoose(e, t) {
  if (e == null)
    return {};
  var i = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(t.indexOf(a) >= 0) && (i[a] = e[a]);
  return i;
}
function _objectWithoutProperties(e, t) {
  if (e == null)
    return {};
  var i = _objectWithoutPropertiesLoose(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _arrayWithHoles(e) {
  if (Array.isArray(e))
    return e;
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if (typeof e == "string")
      return _arrayLikeToArray(e, t);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set")
      return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
      return _arrayLikeToArray(e, t);
  }
}
function _arrayLikeToArray(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var i = 0, n = new Array(t); i < t; i++)
    n[i] = e[i];
  return n;
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toPrimitive(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var n = i.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _toPropertyKey(e) {
  var t = _toPrimitive(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var _excluded$1 = ["animationData", "loop", "autoplay", "initialSegment", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart", "onConfigReady", "onDataReady", "onDataFailed", "onLoadedImages", "onDOMLoaded", "onDestroy", "lottieRef", "renderer", "name", "assetsPath", "rendererSettings"], useLottie = function e(t, i) {
  var n = t.animationData, a = t.loop, o = t.autoplay, l = t.initialSegment, c = t.onComplete, d = t.onLoopComplete, u = t.onEnterFrame, m = t.onSegmentStart, A = t.onConfigReady, y = t.onDataReady, D = t.onDataFailed, C = t.onLoadedImages, z = t.onDOMLoaded, R = t.onDestroy;
  t.lottieRef, t.renderer, t.name, t.assetsPath, t.rendererSettings;
  var O = _objectWithoutProperties(t, _excluded$1), $ = useState(!1), k = _slicedToArray($, 2), P = k[0], L = k[1], F = useRef(), B = useRef(null), G = function() {
    var j;
    (j = F.current) === null || j === void 0 || j.play();
  }, Z = function() {
    var j;
    (j = F.current) === null || j === void 0 || j.stop();
  }, X = function() {
    var j;
    (j = F.current) === null || j === void 0 || j.pause();
  }, V = function(j) {
    var U;
    (U = F.current) === null || U === void 0 || U.setSpeed(j);
  }, E = function(j, U) {
    var H;
    (H = F.current) === null || H === void 0 || H.goToAndPlay(j, U);
  }, T = function(j, U) {
    var H;
    (H = F.current) === null || H === void 0 || H.goToAndStop(j, U);
  }, g = function(j) {
    var U;
    (U = F.current) === null || U === void 0 || U.setDirection(j);
  }, b = function(j, U) {
    var H;
    (H = F.current) === null || H === void 0 || H.playSegments(j, U);
  }, x = function(j) {
    var U;
    (U = F.current) === null || U === void 0 || U.setSubframe(j);
  }, S = function(j) {
    var U;
    return (U = F.current) === null || U === void 0 ? void 0 : U.getDuration(j);
  }, I = function() {
    var j;
    (j = F.current) === null || j === void 0 || j.destroy(), F.current = void 0;
  }, N = function() {
    var j = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, U;
    if (B.current) {
      (U = F.current) === null || U === void 0 || U.destroy();
      var H = _objectSpread2(_objectSpread2(_objectSpread2({}, t), j), {}, { container: B.current });
      return F.current = lottie.loadAnimation(H), L(!!F.current), function() {
        var J;
        (J = F.current) === null || J === void 0 || J.destroy(), F.current = void 0;
      };
    }
  };
  useEffect(function() {
    var M = N();
    return function() {
      return M == null ? void 0 : M();
    };
  }, [n, a]), useEffect(function() {
    F.current && (F.current.autoplay = !!o);
  }, [o]), useEffect(function() {
    if (F.current) {
      if (!l) {
        F.current.resetSegments(!0);
        return;
      }
      !Array.isArray(l) || !l.length || ((F.current.currentRawFrame < l[0] || F.current.currentRawFrame > l[1]) && (F.current.currentRawFrame = l[0]), F.current.setSegment(l[0], l[1]));
    }
  }, [l]), useEffect(function() {
    var M = [{ name: "complete", handler: c }, { name: "loopComplete", handler: d }, { name: "enterFrame", handler: u }, { name: "segmentStart", handler: m }, { name: "config_ready", handler: A }, { name: "data_ready", handler: y }, { name: "data_failed", handler: D }, { name: "loaded_images", handler: C }, { name: "DOMLoaded", handler: z }, { name: "destroy", handler: R }], j = M.filter(function(H) {
      return H.handler != null;
    });
    if (j.length) {
      var U = j.map(
        /**
        * Handle the process of adding an event listener
        * @param {Listener} listener
        * @return {Function} Function that deregister the listener
        */
        function(H) {
          var J;
          return (J = F.current) === null || J === void 0 || J.addEventListener(H.name, H.handler), function() {
            var te;
            (te = F.current) === null || te === void 0 || te.removeEventListener(H.name, H.handler);
          };
        }
      );
      return function() {
        U.forEach(function(H) {
          return H();
        });
      };
    }
  }, [c, d, u, m, A, y, D, C, z, R]);
  var p = /* @__PURE__ */ React__default.createElement("div", _objectSpread2({ style: i, ref: B }, O));
  return { View: p, play: G, stop: Z, pause: X, setSpeed: V, goToAndStop: T, goToAndPlay: E, setDirection: g, playSegments: b, setSubframe: x, getDuration: S, destroy: I, animationContainerRef: B, animationLoaded: P, animationItem: F.current };
};
function getContainerVisibility(e) {
  var t = e.getBoundingClientRect(), i = t.top, n = t.height, a = window.innerHeight - i, o = window.innerHeight + n;
  return a / o;
}
function getContainerCursorPosition(e, t, i) {
  var n = e.getBoundingClientRect(), a = n.top, o = n.left, l = n.width, c = n.height, d = (t - o) / l, u = (i - a) / c;
  return { x: d, y: u };
}
var useInitInteractivity = function e(t) {
  var i = t.wrapperRef, n = t.animationItem, a = t.mode, o = t.actions;
  useEffect(function() {
    var l = i.current;
    if (!(!l || !n || !o.length)) {
      n.stop();
      var c = function() {
        var m = null, A = function() {
          var D = getContainerVisibility(l), C = o.find(function(R) {
            var O = R.visibility;
            return O && D >= O[0] && D <= O[1];
          });
          if (C) {
            if (C.type === "seek" && C.visibility && C.frames.length === 2) {
              var z = C.frames[0] + Math.ceil((D - C.visibility[0]) / (C.visibility[1] - C.visibility[0]) * C.frames[1]);
              //! goToAndStop must be relative to the start of the current segment
              n.goToAndStop(z - n.firstFrame - 1, !0);
            }
            C.type === "loop" && (m === null || m !== C.frames || n.isPaused) && (n.playSegments(C.frames, !0), m = C.frames), C.type === "play" && n.isPaused && (n.resetSegments(!0), n.play()), C.type === "stop" && n.goToAndStop(C.frames[0] - n.firstFrame - 1, !0);
          }
        };
        return document.addEventListener("scroll", A), function() {
          document.removeEventListener("scroll", A);
        };
      }, d = function() {
        var m = function(C, z) {
          var R = C, O = z;
          if (R !== -1 && O !== -1) {
            var $ = getContainerCursorPosition(l, R, O);
            R = $.x, O = $.y;
          }
          var k = o.find(function(F) {
            var B = F.position;
            return B && Array.isArray(B.x) && Array.isArray(B.y) ? R >= B.x[0] && R <= B.x[1] && O >= B.y[0] && O <= B.y[1] : B && !Number.isNaN(B.x) && !Number.isNaN(B.y) ? R === B.x && O === B.y : !1;
          });
          if (k) {
            if (k.type === "seek" && k.position && Array.isArray(k.position.x) && Array.isArray(k.position.y) && k.frames.length === 2) {
              var P = (R - k.position.x[0]) / (k.position.x[1] - k.position.x[0]), L = (O - k.position.y[0]) / (k.position.y[1] - k.position.y[0]);
              n.playSegments(k.frames, !0), n.goToAndStop(Math.ceil((P + L) / 2 * (k.frames[1] - k.frames[0])), !0);
            }
            k.type === "loop" && n.playSegments(k.frames, !0), k.type === "play" && (n.isPaused && n.resetSegments(!1), n.playSegments(k.frames)), k.type === "stop" && n.goToAndStop(k.frames[0], !0);
          }
        }, A = function(C) {
          m(C.clientX, C.clientY);
        }, y = function() {
          m(-1, -1);
        };
        return l.addEventListener("mousemove", A), l.addEventListener("mouseout", y), function() {
          l.removeEventListener("mousemove", A), l.removeEventListener("mouseout", y);
        };
      };
      switch (a) {
        case "scroll":
          return c();
        case "cursor":
          return d();
      }
    }
  }, [a, n]);
}, useLottieInteractivity = function e(t) {
  var i = t.actions, n = t.mode, a = t.lottieObj, o = a.animationItem, l = a.View, c = a.animationContainerRef;
  return useInitInteractivity({ actions: i, animationItem: o, mode: n, wrapperRef: c }), l;
}, _excluded = ["style", "interactivity"], Lottie = function e(t) {
  var i, n, a, o = t.style, l = t.interactivity, c = _objectWithoutProperties(t, _excluded), d = useLottie(c, o), u = d.View, m = d.play, A = d.stop, y = d.pause, D = d.setSpeed, C = d.goToAndStop, z = d.goToAndPlay, R = d.setDirection, O = d.playSegments, $ = d.setSubframe, k = d.getDuration, P = d.destroy, L = d.animationContainerRef, F = d.animationLoaded, B = d.animationItem;
  return useEffect(function() {
    t.lottieRef && (t.lottieRef.current = { play: m, stop: A, pause: y, setSpeed: D, goToAndPlay: z, goToAndStop: C, setDirection: R, playSegments: O, setSubframe: $, getDuration: k, destroy: P, animationContainerRef: L, animationLoaded: F, animationItem: B });
  }, [(i = t.lottieRef) === null || i === void 0 ? void 0 : i.current]), useLottieInteractivity({ lottieObj: { View: u, play: m, stop: A, pause: y, setSpeed: D, goToAndStop: C, goToAndPlay: z, setDirection: R, playSegments: O, setSubframe: $, getDuration: k, destroy: P, animationContainerRef: L, animationLoaded: F, animationItem: B }, actions: (n = l == null ? void 0 : l.actions) !== null && n !== void 0 ? n : [], mode: (a = l == null ? void 0 : l.mode) !== null && a !== void 0 ? a : "scroll" });
};
const v = "4.8.0", meta = { g: "LottieFiles AE 3.0.2", a: "", k: "", d: "", tc: "" }, fr = 29.9700012207031, ip = 0, op = 60.0000024438501, w = 500, h = 500, nm = "load", ddd = 0, assets = [{ id: "image_0", w: 176, h: 162, u: "", p: "data:image/png;base64,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", e: 1 }, { id: "comp_0", layers: [{ ddd: 0, ind: 1, ty: 2, nm: "REDREAMER GHOST.ai", cl: "ai", refId: "image_0", sr: 1, ks: { o: { a: 1, k: [{ i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] }, { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 14, s: [60] }, { t: 29.0000011811942, s: [100] }], ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 1, k: [{ i: { x: 0.833, y: 0.833 }, o: { x: 0.167, y: 0.167 }, t: 0, s: [29, 55, 0], to: [0, -0.833, 0], ti: [0, 0, 0] }, { i: { x: 0.833, y: 0.833 }, o: { x: 0.167, y: 0.167 }, t: 16, s: [29, 50, 0], to: [0, 0, 0], ti: [0, -0.833, 0] }, { t: 29.0000011811942, s: [29, 55, 0] }], ix: 2 }, a: { a: 0, k: [88, 81, 0], ix: 1 }, s: { a: 0, k: [33.432, 33.432, 100], ix: 6 } }, ao: 0, ip: 0, op: 30.0000012219251, st: 0, bm: 0 }] }, { id: "comp_1", layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 1", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [384.236, 403.264, 0], ix: 2 }, a: { a: 0, k: [0, 0, 0], ix: 1 }, s: { a: 0, k: [112.803, 129.885, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ind: 0, ty: "sh", ix: 1, ks: { a: 0, k: { i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[-151, -174], [-52, -173], [-52, -92], [-82, -62], [-186, -62], [-186, -139]], c: !0 }, ix: 2 }, nm: "Path 1", mn: "ADBE Vector Shape - Group", hd: !1 }, { ty: "st", c: { a: 0, k: [0.694117647059, 0.262745098039, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 8, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: !1 }, { ty: "tr", p: { a: 0, k: [0, 0], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Shape 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] }, { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 21, s: [0] }, { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 25, s: [0] }, { t: 50.0000020365418, s: [100] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] }, { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 21, s: [100] }, { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 25, s: [100] }, { t: 50.0000020365418, s: [100] }], ix: 2 }, o: { a: 0, k: 82, ix: 3 }, m: 1, ix: 2, nm: "Trim Paths 1", mn: "ADBE Vector Filter - Trim", hd: !1 }], ip: 0, op: 60.0000024438501, st: 0, bm: 0 }] }], layers = [{ ddd: 0, ind: 1, ty: 0, nm: "鬼鬼", refId: "comp_0", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [250, 248, 0], ix: 2 }, a: { a: 0, k: [29.5, 50, 0], ix: 1 }, s: { a: 0, k: [140.678, 140.678, 100], ix: 6 } }, ao: 0, w: 59, h: 100, ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 0, nm: "鬼鬼", refId: "comp_0", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [250, 248, 0], ix: 2 }, a: { a: 0, k: [29.5, 50, 0], ix: 1 }, s: { a: 0, k: [140.678, 140.678, 100], ix: 6 } }, ao: 0, w: 59, h: 100, ip: 30.0000012219251, op: 60.0000024438501, st: 30.0000012219251, bm: 0 }, { ddd: 0, ind: 3, ty: 0, nm: "line", refId: "comp_1", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [250, 250, 0], ix: 2 }, a: { a: 0, k: [250, 250, 0], ix: 1 }, s: { a: 0, k: [113.6, 113.6, 100], ix: 6 } }, ao: 0, w: 500, h: 500, ip: 0, op: 60.0000024438501, st: 0, bm: 0 }, { ddd: 0, ind: 4, ty: 4, nm: "Shape Layer 1", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [249.236, 256.264, 0], ix: 2 }, a: { a: 0, k: [-119.677, -113.177, 0], ix: 1 }, s: { a: 0, k: [133.155, 151.259, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ind: 0, ty: "sh", ix: 1, ks: { a: 0, k: { i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], v: [[-151, -174], [-52, -173], [-52, -92], [-82, -62], [-186, -62], [-186, -139]], c: !0 }, ix: 2 }, nm: "Path 1", mn: "ADBE Vector Shape - Group", hd: !1 }, { ty: "fl", c: { a: 0, k: [1, 0.925490196078, 0, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: !1 }, { ty: "tr", p: { a: 0, k: [-118.721, -110.188], ix: 2 }, a: { a: 0, k: [-118.721, -110.188], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Shape 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }], ip: 0, op: 60.0000024438501, st: 0, bm: 0 }], markers = [], defaultEffect = { v, meta, fr, ip, op, w, h, nm, ddd, assets, layers, markers }, StyledContainer = styled$3(Row)`
  display: ${(e) => {
  let { isLoading: t } = e;
  return t ? "flex" : "none";
}};
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
`, Loading = (e) => {
  let { effect: t, style: i, isLoading: n } = e;
  return /* @__PURE__ */ jsx(StyledContainer, { justify: "center", isLoading: n, children: /* @__PURE__ */ jsx(Lottie, { animationData: t || defaultEffect, loop: !0, style: i || { width: 103, height: 103 } }) });
};
var ButtonType = /* @__PURE__ */ ((e) => (e.CUSTOM = "CUSTOM", e.OUTLINE = "OUTLINE", e.GENERAL = "GENERAL", e.DELETE = "DELETE", e))(ButtonType || {});
const StyledButton = styled$3(MButton)`
  &&& {
    font-family: 'Poppins', sans-serif;
    border-radius: 4px;
    font-weight: 500;
    text-transform: none;
    ${(e) => {
  let { width: t, height: i } = e;
  return size(t, i || "50px");
}};
    font-size: ${(e) => {
  let { fontsize: t } = e;
  return t || "20px";
}};
    margin-right: ${(e) => {
  let { mr: t } = e;
  return t;
}};
    margin-left: ${(e) => {
  let { ml: t } = e;
  return t;
}};
    margin-bottom: ${(e) => {
  let { mb: t } = e;
  return t;
}};
    margin-top: ${(e) => {
  let { mt: t } = e;
  return t;
}};
    border: solid 1px
      ${(e) => {
  let { theme: t, buttonType: i, borderColor: n } = e;
  switch (i) {
    case "CUSTOM":
      return n;
    case "DELETE":
      return t.colors.rose;
    case "OUTLINE":
      return t.colors.brightDream;
    case "GENERAL":
    default:
      return "transparent";
  }
}};
    color: ${(e) => {
  let { theme: t, buttonType: i, btnColor: n } = e;
  switch (i) {
    case "CUSTOM":
      return n;
    case "DELETE":
      return t.colors.rose;
    case "OUTLINE":
      return t.colors.brightDream;
    case "GENERAL":
    default:
      return t.colors.hope;
  }
}};
    background: ${(e) => {
  let { theme: t, buttonType: i, background: n } = e;
  switch (i) {
    case "CUSTOM":
      return n;
    case "DELETE":
    case "OUTLINE":
      return t.colors.white;
    case "GENERAL":
    default:
      return t.colors.darkDream;
  }
}};

    :hover {
      background: ${(e) => {
  let { theme: t, buttonType: i, hoverBackground: n } = e;
  switch (i) {
    case "CUSTOM":
      return n;
    case "DELETE":
      return "rgba(255, 44, 130, 0.05)";
    case "OUTLINE":
      return "rgba(177, 67, 255, 0.05)";
    case "GENERAL":
    default:
      return t.colors.brightDream;
  }
}};
      color: ${(e) => {
  let { theme: t, buttonType: i, hoverBtnColor: n } = e;
  switch (i) {
    case "CUSTOM":
    default:
      return n;
  }
}};
    }
  }
`, Button = (e) => {
  let { children: t, ref: i, type: n, onClick: a, ...o } = e;
  return /* @__PURE__ */ jsx(StyledButton, { ref: i, type: n, ...o, onClick: a, children: t });
}, StyledWrapper$1 = styled$3.div`
  background: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
  padding: 20px;
  min-width: 320px;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px,
    rgba(0, 0, 0, 0.12) 0px 3px 14px 2px;
`, StyledDateContainer$1 = styled$3.div`
  & > div:first-child {
    margin-bottom: 20px;
  }
`, StyledGrid$1 = styled$3.div`
  display: grid;
  grid-template-columns: repeat(7, 40px);
  justify-items: center;
`, StyledMonth$1 = styled$3.div`
  color: #e2e2e2;
  font-size: 12px;
`, StyledDate$1 = styled$3(Row)`
  ${size("100%", "40px")};
  font-size: 0.75rem;
  visibility: ${(e) => {
  let { disabled: t } = e;
  return t ? "hidden" : "visible";
}};
  opacity: ${(e) => {
  let { disabled: t } = e;
  return t ? "0" : "1";
}};
  align-items: center;
  justify-content: center;
  cursor: ${(e) => {
  let { disabledDate: t } = e;
  return t ? "not-allowed" : "pointer";
}};
  border-radius: ${(e) => {
  let { isActive: t, isRangeActive: i, rangeStart: n, rangeEnd: a } = e;
  return !t && i ? "0" : n ? "50% 0 0 50%" : a ? "0 50% 50% 0" : "50%";
}};
  color: ${(e) => {
  let { theme: t, isActive: i, isRangeActive: n, disabledDate: a } = e;
  return n || i ? t.colors.white : a ? "#e2e2e2" : t.colors.black;
}};
  background: ${(e) => {
  let { theme: t, isActive: i, isRangeActive: n } = e;
  return n || i ? t.colors.brightDream : t.colors.white;
}};

  &:hover {
    color: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
    background: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
  }
`, StyledMonthRow$1 = styled$3(Row)`
  margin-bottom: 16px;

  & > div {
    color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
  }
`, StyledSelect = styled$3(Row)`
  padding: 8px 16px;
  background: #e2e2e2;
  width: 200px;
  position: relative;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
`, StyledPicker = styled$3.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px,
    rgba(0, 0, 0, 0.12) 0px 3px 14px 2px;
  border-radius: 4px;

  & > div:not(:last-child) {
    border-right: solid 1px #e2e2e2;
  }
`, StyledColumn = styled$3.div`
  height: 200px;
  overflow-y: auto;
`, StyledTime = styled$3.div`
  background: ${(e) => {
  let { isSelect: t, theme: i } = e;
  return t ? i.colors.brightDream : i.colors.white;
}};
  color: ${(e) => {
  let { isSelect: t, theme: i } = e;
  return t ? i.colors.white : i.colors.black;
}};
  text-align: center;
  padding: 8px 0;
  font-weight: normal;

  &:hover {
    background: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
    color: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
  }
`, StyledRightContent = styled$3.div`
  margin-left: 16px;
`;
var dayjs_minExports = {}, dayjs_min = { get exports() {
  return dayjs_minExports;
}, set exports(e) {
  dayjs_minExports = e;
} };
(function(e, t) {
  (function(i, n) {
    e.exports = n();
  })(commonjsGlobal, function() {
    var i = 1e3, n = 6e4, a = 36e5, o = "millisecond", l = "second", c = "minute", d = "hour", u = "day", m = "week", A = "month", y = "quarter", D = "year", C = "date", z = "Invalid Date", R = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, O = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, $ = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(T) {
      var g = ["th", "st", "nd", "rd"], b = T % 100;
      return "[" + T + (g[(b - 20) % 10] || g[b] || g[0]) + "]";
    } }, k = function(T, g, b) {
      var x = String(T);
      return !x || x.length >= g ? T : "" + Array(g + 1 - x.length).join(b) + T;
    }, P = { s: k, z: function(T) {
      var g = -T.utcOffset(), b = Math.abs(g), x = Math.floor(b / 60), S = b % 60;
      return (g <= 0 ? "+" : "-") + k(x, 2, "0") + ":" + k(S, 2, "0");
    }, m: function T(g, b) {
      if (g.date() < b.date())
        return -T(b, g);
      var x = 12 * (b.year() - g.year()) + (b.month() - g.month()), S = g.clone().add(x, A), I = b - S < 0, N = g.clone().add(x + (I ? -1 : 1), A);
      return +(-(x + (b - S) / (I ? S - N : N - S)) || 0);
    }, a: function(T) {
      return T < 0 ? Math.ceil(T) || 0 : Math.floor(T);
    }, p: function(T) {
      return { M: A, y: D, w: m, d: u, D: C, h: d, m: c, s: l, ms: o, Q: y }[T] || String(T || "").toLowerCase().replace(/s$/, "");
    }, u: function(T) {
      return T === void 0;
    } }, L = "en", F = {};
    F[L] = $;
    var B = function(T) {
      return T instanceof V;
    }, G = function T(g, b, x) {
      var S;
      if (!g)
        return L;
      if (typeof g == "string") {
        var I = g.toLowerCase();
        F[I] && (S = I), b && (F[I] = b, S = I);
        var N = g.split("-");
        if (!S && N.length > 1)
          return T(N[0]);
      } else {
        var p = g.name;
        F[p] = g, S = p;
      }
      return !x && S && (L = S), S || !x && L;
    }, Z = function(T, g) {
      if (B(T))
        return T.clone();
      var b = typeof g == "object" ? g : {};
      return b.date = T, b.args = arguments, new V(b);
    }, X = P;
    X.l = G, X.i = B, X.w = function(T, g) {
      return Z(T, { locale: g.$L, utc: g.$u, x: g.$x, $offset: g.$offset });
    };
    var V = function() {
      function T(b) {
        this.$L = G(b.locale, null, !0), this.parse(b);
      }
      var g = T.prototype;
      return g.parse = function(b) {
        this.$d = function(x) {
          var S = x.date, I = x.utc;
          if (S === null)
            return /* @__PURE__ */ new Date(NaN);
          if (X.u(S))
            return /* @__PURE__ */ new Date();
          if (S instanceof Date)
            return new Date(S);
          if (typeof S == "string" && !/Z$/i.test(S)) {
            var N = S.match(R);
            if (N) {
              var p = N[2] - 1 || 0, M = (N[7] || "0").substring(0, 3);
              return I ? new Date(Date.UTC(N[1], p, N[3] || 1, N[4] || 0, N[5] || 0, N[6] || 0, M)) : new Date(N[1], p, N[3] || 1, N[4] || 0, N[5] || 0, N[6] || 0, M);
            }
          }
          return new Date(S);
        }(b), this.$x = b.x || {}, this.init();
      }, g.init = function() {
        var b = this.$d;
        this.$y = b.getFullYear(), this.$M = b.getMonth(), this.$D = b.getDate(), this.$W = b.getDay(), this.$H = b.getHours(), this.$m = b.getMinutes(), this.$s = b.getSeconds(), this.$ms = b.getMilliseconds();
      }, g.$utils = function() {
        return X;
      }, g.isValid = function() {
        return this.$d.toString() !== z;
      }, g.isSame = function(b, x) {
        var S = Z(b);
        return this.startOf(x) <= S && S <= this.endOf(x);
      }, g.isAfter = function(b, x) {
        return Z(b) < this.startOf(x);
      }, g.isBefore = function(b, x) {
        return this.endOf(x) < Z(b);
      }, g.$g = function(b, x, S) {
        return X.u(b) ? this[x] : this.set(S, b);
      }, g.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, g.valueOf = function() {
        return this.$d.getTime();
      }, g.startOf = function(b, x) {
        var S = this, I = !!X.u(x) || x, N = X.p(b), p = function(le, ne) {
          var ue = X.w(S.$u ? Date.UTC(S.$y, ne, le) : new Date(S.$y, ne, le), S);
          return I ? ue : ue.endOf(u);
        }, M = function(le, ne) {
          return X.w(S.toDate()[le].apply(S.toDate("s"), (I ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ne)), S);
        }, j = this.$W, U = this.$M, H = this.$D, J = "set" + (this.$u ? "UTC" : "");
        switch (N) {
          case D:
            return I ? p(1, 0) : p(31, 11);
          case A:
            return I ? p(1, U) : p(0, U + 1);
          case m:
            var te = this.$locale().weekStart || 0, ae = (j < te ? j + 7 : j) - te;
            return p(I ? H - ae : H + (6 - ae), U);
          case u:
          case C:
            return M(J + "Hours", 0);
          case d:
            return M(J + "Minutes", 1);
          case c:
            return M(J + "Seconds", 2);
          case l:
            return M(J + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, g.endOf = function(b) {
        return this.startOf(b, !1);
      }, g.$set = function(b, x) {
        var S, I = X.p(b), N = "set" + (this.$u ? "UTC" : ""), p = (S = {}, S[u] = N + "Date", S[C] = N + "Date", S[A] = N + "Month", S[D] = N + "FullYear", S[d] = N + "Hours", S[c] = N + "Minutes", S[l] = N + "Seconds", S[o] = N + "Milliseconds", S)[I], M = I === u ? this.$D + (x - this.$W) : x;
        if (I === A || I === D) {
          var j = this.clone().set(C, 1);
          j.$d[p](M), j.init(), this.$d = j.set(C, Math.min(this.$D, j.daysInMonth())).$d;
        } else
          p && this.$d[p](M);
        return this.init(), this;
      }, g.set = function(b, x) {
        return this.clone().$set(b, x);
      }, g.get = function(b) {
        return this[X.p(b)]();
      }, g.add = function(b, x) {
        var S, I = this;
        b = Number(b);
        var N = X.p(x), p = function(U) {
          var H = Z(I);
          return X.w(H.date(H.date() + Math.round(U * b)), I);
        };
        if (N === A)
          return this.set(A, this.$M + b);
        if (N === D)
          return this.set(D, this.$y + b);
        if (N === u)
          return p(1);
        if (N === m)
          return p(7);
        var M = (S = {}, S[c] = n, S[d] = a, S[l] = i, S)[N] || 1, j = this.$d.getTime() + b * M;
        return X.w(j, this);
      }, g.subtract = function(b, x) {
        return this.add(-1 * b, x);
      }, g.format = function(b) {
        var x = this, S = this.$locale();
        if (!this.isValid())
          return S.invalidDate || z;
        var I = b || "YYYY-MM-DDTHH:mm:ssZ", N = X.z(this), p = this.$H, M = this.$m, j = this.$M, U = S.weekdays, H = S.months, J = function(ne, ue, ge, re) {
          return ne && (ne[ue] || ne(x, I)) || ge[ue].slice(0, re);
        }, te = function(ne) {
          return X.s(p % 12 || 12, ne, "0");
        }, ae = S.meridiem || function(ne, ue, ge) {
          var re = ne < 12 ? "AM" : "PM";
          return ge ? re.toLowerCase() : re;
        }, le = { YY: String(this.$y).slice(-2), YYYY: X.s(this.$y, 4, "0"), M: j + 1, MM: X.s(j + 1, 2, "0"), MMM: J(S.monthsShort, j, H, 3), MMMM: J(H, j), D: this.$D, DD: X.s(this.$D, 2, "0"), d: String(this.$W), dd: J(S.weekdaysMin, this.$W, U, 2), ddd: J(S.weekdaysShort, this.$W, U, 3), dddd: U[this.$W], H: String(p), HH: X.s(p, 2, "0"), h: te(1), hh: te(2), a: ae(p, M, !0), A: ae(p, M, !1), m: String(M), mm: X.s(M, 2, "0"), s: String(this.$s), ss: X.s(this.$s, 2, "0"), SSS: X.s(this.$ms, 3, "0"), Z: N };
        return I.replace(O, function(ne, ue) {
          return ue || le[ne] || N.replace(":", "");
        });
      }, g.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, g.diff = function(b, x, S) {
        var I, N = X.p(x), p = Z(b), M = (p.utcOffset() - this.utcOffset()) * n, j = this - p, U = X.m(this, p);
        return U = (I = {}, I[D] = U / 12, I[A] = U, I[y] = U / 3, I[m] = (j - M) / 6048e5, I[u] = (j - M) / 864e5, I[d] = j / a, I[c] = j / n, I[l] = j / i, I)[N] || j, S ? U : X.a(U);
      }, g.daysInMonth = function() {
        return this.endOf(A).$D;
      }, g.$locale = function() {
        return F[this.$L];
      }, g.locale = function(b, x) {
        if (!b)
          return this.$L;
        var S = this.clone(), I = G(b, x, !0);
        return I && (S.$L = I), S;
      }, g.clone = function() {
        return X.w(this.$d, this);
      }, g.toDate = function() {
        return new Date(this.valueOf());
      }, g.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, g.toISOString = function() {
        return this.$d.toISOString();
      }, g.toString = function() {
        return this.$d.toUTCString();
      }, T;
    }(), E = V.prototype;
    return Z.prototype = E, [["$ms", o], ["$s", l], ["$m", c], ["$H", d], ["$W", u], ["$M", A], ["$y", D], ["$D", C]].forEach(function(T) {
      E[T[1]] = function(g) {
        return this.$g(g, T[0], T[1]);
      };
    }), Z.extend = function(T, g) {
      return T.$i || (T(g, V, Z), T.$i = !0), Z;
    }, Z.locale = G, Z.isDayjs = B, Z.unix = function(T) {
      return Z(1e3 * T);
    }, Z.en = F[L], Z.Ls = F, Z.p = {}, Z;
  });
})(dayjs_min);
const dayjs = dayjs_minExports, currentYear$1 = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getFullYear(), currentMonth$1 = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getMonth(), daysMap$1 = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], monthMap$1 = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], DatePicker = (e) => {
  let { themeColor: t, value: i, footer: n, disabledDates: a, useTimePicker: o, onSelectDate: l, ...c } = e;
  const [d, u] = useState([]), [m, A] = useState(currentYear$1), [y, D] = useState(currentMonth$1), [C, z] = useState(i || dayjs()), [R, O] = useState(!1), [$, k] = useState({ hour: "00", minute: "00", second: "00" }), [P, L] = useState(!1), F = useRef(null), B = useRef(null), G = useRef(null), Z = useRef(null), X = (N, p) => 40 - new Date(N, p, 40).getDate(), V = (N) => {
    let { index: p, monthDays: M, firstDayOfMonth: j, year: U, month: H } = N, J = p - j, te = p % 7, ae = H - 1, le = U;
    ae < 0 && (ae = 11, le--);
    let ne = X(le, ae), ue = (J < 0 ? ne + J : J % M) + 1, ge = J < 0 ? -1 : J >= M ? 1 : 0, re = new Date(U, H, ue).getTime();
    const fe = H + 1;
    return { day: te, timestamp: re, year: U, date: ue, month: fe, monthOffset: ge, dayString: daysMap$1[te], dateString: dayjs(`${U}-${fe}-${ue}`) };
  }, E = (N, p) => {
    let M = new Date(N, p).getDay(), j = X(N, p), U = [], H = 7, J = 6, te = null, ae = 0;
    for (let le = 0; le < H; le++)
      for (let ne = 0; ne < J && (te = V({ index: ae, monthDays: j, firstDayOfMonth: M, year: N, month: p }), !(te.monthOffset > 0)); ne++)
        U.push(te), ae++;
    return U;
  }, T = (N) => {
    if (a != null && a.from && !(a != null && a.to))
      return N.dateString.isAfter(a.from);
    if (a != null && a.to && !(a != null && a.from))
      return N.dateString.isBefore(a.to);
    if (a != null && a.from && (a != null && a.to))
      return N.dateString.isAfter(a.from) && N.dateString.isBefore(a.to);
  }, g = () => /* @__PURE__ */ jsxs(StyledDateContainer$1, { children: [/* @__PURE__ */ jsx(StyledGrid$1, { children: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((N, p) => /* @__PURE__ */ jsx(StyledMonth$1, { children: N }, p)) }), /* @__PURE__ */ jsx(StyledGrid$1, { children: d.map((N, p) => /* @__PURE__ */ jsx(StyledDate$1, { disabled: N.monthOffset !== 0, isActive: C.isSame(N.dateString, "day"), disabledDate: T(N), onClick: x(N), children: N.monthOffset === 0 ? N.date : "" }, p)) })] }), b = (N) => {
    let p = m, M = y + N;
    M === -1 ? (M = 11, p--) : M === 12 && (M = 0, p++), A(p), D(M), u(E(p, M));
  }, x = (N) => () => {
    if (T(N))
      return;
    const p = N.dateString.format("YYYY-MM-DD"), M = dayjs(`${p}T${$.hour}:${$.minute}:${$.second}`);
    z(M);
  }, S = (N, p, M) => {
    N.stopPropagation(), k({ ...$, [p]: M });
  }, I = (N) => monthMap$1[Math.max(Math.min(11, N), 0)] || "Month";
  return useEffect(() => {
    P ? (() => {
      if (typeof l != "function")
        return "";
      const p = C.format("YYYY-MM-DD"), M = dayjs(`${p}T${$.hour}:${$.minute}:${$.second}`);
      l(M);
    })() : L(!0);
  }, [C, $]), useEffect(() => {
    u(E(currentYear$1, currentMonth$1));
  }, []), useEffect(() => {
    R && (B != null && B.current) && B.current.children[Number($.hour)].scrollIntoView({ block: "nearest", inline: "start" });
  }, [R, $.hour]), useEffect(() => {
    R && (G != null && G.current) && G.current.children[Number($.minute)].scrollIntoView({ block: "nearest", inline: "start" });
  }, [R, $.minute]), useEffect(() => {
    R && (Z != null && Z.current) && Z.current.children[Number($.second)].scrollIntoView({ block: "nearest", inline: "start" });
  }, [R, $.second]), useOnClickOutside(F, () => O(!1)), /* @__PURE__ */ jsx(StyledWrapper$1, { ...c, children: /* @__PURE__ */ jsxs(Row, { align: "flex-start", children: [/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsxs(StyledMonthRow$1, { justify: "space-between", children: [/* @__PURE__ */ jsx(StyledMaskIcon, { width: "20px", src: arrowLeftIcon, onClick: () => b(-1), pointer: !0, color: t || "#b143ff" }), /* @__PURE__ */ jsxs("div", { children: [I(y), " ", m] }), /* @__PURE__ */ jsx(StyledMaskIcon, { width: "20px", src: arrowRightIcon, onClick: () => b(1), pointer: !0, color: t || "#b143ff" })] }), g(), !o && n] }), o && /* @__PURE__ */ jsxs(StyledRightContent, { children: [/* @__PURE__ */ jsxs(StyledSelect, { justify: "space-between", ref: F, onClick: () => O(!R), children: [`${$.hour}:${$.minute}:${$.second}`, R && /* @__PURE__ */ jsxs(StyledPicker, { children: [/* @__PURE__ */ jsx(StyledColumn, { ref: B, children: Array.from({ length: 24 }, (N, p) => `${p}`.padStart(2, "0")).map((N) => /* @__PURE__ */ jsx(StyledTime, { isSelect: N === $.hour, onClick: (p) => S(p, "hour", N), children: N })) }), /* @__PURE__ */ jsx(StyledColumn, { ref: G, children: Array.from({ length: 60 }, (N, p) => `${p}`.padStart(2, "0")).map((N) => /* @__PURE__ */ jsx(StyledTime, { isSelect: N === $.minute, onClick: (p) => S(p, "minute", N), children: N })) }), /* @__PURE__ */ jsx(StyledColumn, { ref: Z, children: Array.from({ length: 60 }, (N, p) => `${p}`.padStart(2, "0")).map((N) => /* @__PURE__ */ jsx(StyledTime, { isSelect: N === $.second, onClick: (p) => S(p, "second", N), children: N })) })] }), /* @__PURE__ */ jsx(StyledMaskIcon, { width: "20px", src: downArrowIcon, pointer: !0, color: "#000000" })] }), o && n] })] }) });
}, StyledWrapper = styled$3.div`
  background: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
  padding: 20px;
  width: 320px;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px,
    rgba(0, 0, 0, 0.12) 0px 3px 14px 2px;
`, StyledDateContainer = styled$3.div`
  & > div:first-child {
    margin-bottom: 20px;
  }
`, StyledGrid = styled$3.div`
  display: grid;
  grid-template-columns: repeat(7, 40px);
  justify-items: center;
`, StyledMonth = styled$3.div`
  color: #e2e2e2;
  font-size: 12px;
`, StyledDate = styled$3(Row)`
  ${size("100%", "40px")};
  font-size: 0.75rem;
  visibility: ${(e) => {
  let { disabled: t } = e;
  return t ? "hidden" : "visible";
}};
  opacity: ${(e) => {
  let { disabled: t } = e;
  return t ? "0" : "1";
}};
  align-items: center;
  justify-content: center;
  cursor: ${(e) => {
  let { disabledDate: t } = e;
  return t ? "not-allowed" : "pointer";
}};
  border-radius: ${(e) => {
  let { isActive: t, isRangeActive: i, rangeStart: n, rangeEnd: a } = e;
  return !t && i ? "0" : n ? "50% 0 0 50%" : a ? "0 50% 50% 0" : "50%";
}};
  color: ${(e) => {
  let { theme: t, isActive: i, isRangeActive: n, disabledDate: a } = e;
  return n || i ? t.colors.white : a ? "#e2e2e2" : t.colors.black;
}};
  background: ${(e) => {
  let { theme: t, isActive: i, isRangeActive: n } = e;
  return n || i ? t.colors.brightDream : t.colors.white;
}};

  &:hover {
    color: ${(e) => {
  let { theme: t } = e;
  return t.colors.white;
}};
    background: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
  }
`, StyledMonthRow = styled$3(Row)`
  margin-bottom: 16px;

  & > div {
    color: ${(e) => {
  let { theme: t } = e;
  return t.colors.brightDream;
}};
  }
`;
var minMaxExports = {}, minMax$1 = { get exports() {
  return minMaxExports;
}, set exports(e) {
  minMaxExports = e;
} };
(function(e, t) {
  (function(i, n) {
    e.exports = n();
  })(commonjsGlobal, function() {
    return function(i, n, a) {
      var o = function(l, c) {
        if (!c || !c.length || !c[0] || c.length === 1 && !c[0].length)
          return null;
        var d;
        c.length === 1 && c[0].length > 0 && (c = c[0]), d = c[0];
        for (var u = 1; u < c.length; u += 1)
          c[u].isValid() && !c[u][l](d) || (d = c[u]);
        return d;
      };
      a.max = function() {
        var l = [].slice.call(arguments, 0);
        return o("isAfter", l);
      }, a.min = function() {
        var l = [].slice.call(arguments, 0);
        return o("isBefore", l);
      };
    };
  });
})(minMax$1);
const minMax = minMaxExports;
dayjs.extend(minMax);
const currentYear = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getFullYear(), currentMonth = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getMonth(), daysMap = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], monthMap = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], RangePicker = (e) => {
  let { themeColor: t, value: i, footer: n, disabledDates: a, onSelectDates: o, ...l } = e;
  const [c, d] = useState([]), [u, m] = useState(currentYear), [A, y] = useState(currentMonth), [D, C] = useState(i || [dayjs()]), z = (B, G) => 40 - new Date(B, G, 40).getDate(), R = (B) => {
    let { index: G, monthDays: Z, firstDayOfMonth: X, year: V, month: E } = B, T = G - X, g = G % 7, b = E - 1, x = V;
    b < 0 && (b = 11, x--);
    let S = z(x, b), I = (T < 0 ? S + T : T % Z) + 1, N = T < 0 ? -1 : T >= Z ? 1 : 0, p = new Date(V, E, I).getTime();
    const M = E + 1;
    return { day: g, timestamp: p, year: V, date: I, month: M, monthOffset: N, dayString: daysMap[g], dateString: dayjs(`${V}-${M}-${I}`) };
  }, O = (B, G) => {
    let Z = new Date(B, G).getDay(), X = z(B, G), V = [], E = 7, T = 6, g = null, b = 0;
    for (let x = 0; x < E; x++)
      for (let S = 0; S < T && (g = R({ index: b, monthDays: X, firstDayOfMonth: Z, year: B, month: G }), !(g.monthOffset > 0)); S++)
        V.push(g), b++;
    return V;
  }, $ = (B) => {
    if (a != null && a.from && !(a != null && a.to))
      return B.dateString.isAfter(a.from);
    if (a != null && a.to && !(a != null && a.from))
      return B.dateString.isBefore(a.to);
    if (a != null && a.from && (a != null && a.to))
      return B.dateString.isAfter(a.from) && B.dateString.isBefore(a.to);
  }, k = () => /* @__PURE__ */ jsxs(StyledDateContainer, { children: [/* @__PURE__ */ jsx(StyledGrid, { children: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((B, G) => /* @__PURE__ */ jsx(StyledMonth, { children: B }, G)) }), /* @__PURE__ */ jsx(StyledGrid, { children: c.map((B, G) => {
    var E, T;
    let Z, X;
    const V = D.length === 2;
    return V && (Z = dayjs.min(D[0], D[1]), X = dayjs.max(D[0], D[1])), /* @__PURE__ */ jsx(StyledDate, { disabled: B.monthOffset !== 0, isActive: ((E = D[0]) == null ? void 0 : E.isSame(B.dateString, "day")) || ((T = D[1]) == null ? void 0 : T.isSame(B.dateString, "day")), isRangeActive: V && B.dateString.isAfter(Z) && B.dateString.isBefore(X), rangeStart: V && B.dateString.isSame(Z, "day"), rangeEnd: V && B.dateString.isSame(X, "day"), disabledDate: $(B), onClick: L(B), children: B.monthOffset === 0 ? B.date : "" }, G);
  }) })] }), P = (B) => {
    let G = u, Z = A + B;
    Z === -1 ? (Z = 11, G--) : Z === 12 && (Z = 0, G++), m(G), y(Z), d(O(G, Z));
  }, L = (B) => () => {
    if ($(B))
      return;
    if (D.length === 2) {
      C([]);
      return;
    }
    const G = dayjs(B.dateString), Z = [...D, G];
    if (C(Z), typeof o == "function" && Z.length === 2) {
      const X = dayjs.min(Z[0], Z[1]), V = dayjs.max(Z[0], Z[1]);
      o([X, V]);
    }
  }, F = (B) => monthMap[Math.max(Math.min(11, B), 0)] || "Month";
  return useEffect(() => {
    d(O(currentYear, currentMonth));
  }, []), /* @__PURE__ */ jsxs(StyledWrapper, { ...l, children: [/* @__PURE__ */ jsxs(StyledMonthRow, { justify: "space-between", children: [/* @__PURE__ */ jsx(StyledMaskIcon, { width: "20px", src: arrowLeftIcon, onClick: () => P(-1), pointer: !0, color: t || "#b143ff" }), /* @__PURE__ */ jsxs("div", { children: [F(A), " ", u] }), /* @__PURE__ */ jsx(StyledMaskIcon, { width: "20px", src: arrowRightIcon, onClick: () => P(1), pointer: !0, color: t || "#b143ff" })] }), k(), n] });
}, WalletContext = createContext({}), Provider = (e) => {
  let { waxRPC: t, connectors: i, children: n } = e;
  const a = {};
  return /* @__PURE__ */ jsx(Web3ReactProvider, { connectors: i, children: /* @__PURE__ */ jsx(WaxCloudWalletProvider, { waxRPC: t, children: /* @__PURE__ */ jsx(WalletContext.Provider, { value: a, children: n }) }) });
}, WalletProvider = Provider;
export {
  Button,
  ButtonType,
  CampaignCard,
  CollectionCard,
  ConnectButton,
  DatePicker,
  Footer,
  Hamburger,
  Loading,
  Modal,
  ModalMode,
  Mode,
  NavbarContainer as Navbar,
  NetworkSelectButton,
  NetworkSwitchList,
  RangePicker,
  RefreshButton,
  wt as ThemeProvider,
  TradeMark,
  UnbindAddressButton,
  WalletProvider,
  WaxCloudWalletProvider,
  useWaxCloudWalletContext
};
